(function() {
  'use strict';

  angular.module('portal.despesa', []);
  angular.module('portal.receita', []);
  angular.module('portal.patrimonio', []);
  angular.module('portal.convenio', []);
  angular.module('portal.licitacao-contrato', []);
  angular.module('portal.prestando-contas', []);

  angular.module('fsm', []);

  angular.module('portal', [
    'portal.config',
    'portal.despesa',
    'portal.receita',
    'portal.patrimonio',
    'portal.convenio',
    'portal.licitacao-contrato',
    'portal.prestando-contas',
    'portal.acessibilidade',
    'portal.pagina-inicial',
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ngRoute',
    'ui.router',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'ngPlaceholders',
    'ngTable',
    'angular-loading-bar',
    'angulartics',
    'angulartics.google.analytics',
    'ui.select',
    'gridshore.c3js.chart',
    'monospaced.elastic',     // resizable textarea
    'jcs-autoValidate',
    'ngFileUpload',
    'textAngular',
    'fsm',                    // sticky header
    'smoothScroll',
    'LocalStorageModule', // Remover
    'ngStorage',
    'underscore',
    'infinite-scroll',
    'ngFileSaver',
    'checklist-model',
    'vAccordion',
    '720kb.socialshare',
    'ui.mask',
    'ngMask',
    'ui.bootstrap.datetimepicker',
    'ui.dateTimeInput',
    'portal.breadcrumb',
    //'angularjs-gauge',
  ]);

  angular.module('portal').config([
    "$httpProvider",
    function ($httpProvider) {
        $httpProvider.defaults.headers.common = {};
        $httpProvider.defaults.headers.post = {};
        $httpProvider.defaults.headers.put = {};
        $httpProvider.defaults.headers.patch = {};
        $httpProvider.interceptors.push('tokenInterceptor');

    }
]);

})();

(function() {
  'use strict';

  var resizableElements = 'h1, h2, h3, h4, h5, p, li, table, td, tr, th, ol, ul, a, tspan, label, button, legend, dt, span, pre';

  angular.module('portal.acessibilidade', ['toggle-switch', 'angularCSS'])
    .value('resizableElements', resizableElements);
})();

(function(){
  'use strict';

  angular.module('portal.breadcrumb', ['crumble']).run(run);

  /** @ngInject */
  function run(crumble, Breadcrumb){

    // Extending crumble getCrumb method to check if it is a linkable route
    crumble.getCrumb = Breadcrumb.getCrumb;

    // Extending crumble by creating a clean method
    crumble.clean = Breadcrumb.clean;
  }
})();
(function(){
    'use strict';

    angular.module('portal.pagina-inicial', ['portal.pagina-inicial.ptVideoCarousel']).run(run);

    /** @ngInject */
    function run(PtVideoCarousel){
        configureVideos(PtVideoCarousel);
    }

    function configureVideos(PtVideoCarousel){
        // Videos to play on carousel
        PtVideoCarousel.addVideo('assets/videos/clipe1.webm');
        PtVideoCarousel.addVideo('assets/videos/clipe2.webm');
        PtVideoCarousel.addVideo('assets/videos/clipe3.webm');
        PtVideoCarousel.addVideo('assets/videos/clipe4.webm');
        PtVideoCarousel.addVideo('assets/videos/clipe5.webm');
        PtVideoCarousel.setVideosFormat('video/webm');
    }
})();
(function(){
    'use strict';

    angular.module('portal.pagina-inicial.ptVideoCarousel', []);
})();
/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').run(ThemeChange);

  function ThemeChange($rootScope, $analytics) {
    $rootScope.$on('theme:change', function(event, msg) {
      $analytics.eventTrack(msg, {  category: 'Themepicker' });
    });
  }

})();

/*eslint-disable */
'use strict';

var theme_colors = {
  "brand-primary": "blue",
  "brand-success": "green",
  "brand-info":    "purple",
  "brand-warning": "orange",
  "brand-danger":  "red",
  "theme": "pink",
  "theme-secondary": "blue"



};

var global_colors = {
  "red": {
    "lighten-5":  "#FFEBEE",
    "lighten-4":  "#FFCDD2",
    "lighten-3":  "#EF9A9A",
    "lighten-2":  "#E57373",
    "lighten-1":  "#EF5350",
    "base":       "#F44336",
    "darken-1":   "#E53935",
    "darken-2":   "#D32F2F",
    "darken-3":   "#C62828",
    "darken-4":   "#B71C1C",
    "accent-1":    "#FF8A80",
    "accent-2":    "#FF5252",
    "accent-3":    "#FF1744",
    "accent-4":    "#D50000"
  },
  "pink": {
    "lighten-5":  "#fce4ec",
    "lighten-4":  "#f8bbd0",
    "lighten-3":  "#f48fb1",
    "lighten-2":  "#f06292",
    "lighten-1":  "#ec407a",
    "base":       "#e91e63",
    "darken-1":   "#d81b60",
    "darken-2":   "#c2185b",
    "darken-3":   "#ad1457",
    "darken-4":   "#880e4f",
    "accent-1":    "#ff80ab",
    "accent-2":    "#ff4081",
    "accent-3":    "#f50057",
    "accent-4":    "#c51162"
  },
  "purple": {
    "lighten-5":  "#f3e5f5",
    "lighten-4":  "#e1bee7",
    "lighten-3":  "#ce93d8",
    "lighten-2":  "#ba68c8",
    "lighten-1":  "#ab47bc",
    "base":       "#9c27b0",
    "darken-1":   "#8e24aa",
    "darken-2":   "#7b1fa2",
    "darken-3":   "#6a1b9a",
    "darken-4":   "#4a148c",
    "accent-1":    "#ea80fc",
    "accent-2":    "#e040fb",
    "accent-3":    "#d500f9",
    "accent-4":    "#aa00ff"
  },
  "deep-purple": {
    "lighten-5":  "#ede7f6",
    "lighten-4":  "#d1c4e9",
    "lighten-3":  "#b39ddb",
    "lighten-2":  "#9575cd",
    "lighten-1":  "#7e57c2",
    "base":       "#673ab7",
    "darken-1":   "#5e35b1",
    "darken-2":   "#512da8",
    "darken-3":   "#4527a0",
    "darken-4":   "#311b92",
    "accent-1":    "#b388ff",
    "accent-2":    "#7c4dff",
    "accent-3":    "#651fff",
    "accent-4":    "#6200ea"
  },
  "indigo": {
    "lighten-5":  "#e8eaf6",
    "lighten-4":  "#c5cae9",
    "lighten-3":  "#9fa8da",
    "lighten-2":  "#7986cb",
    "lighten-1":  "#5c6bc0",
    "base":       "#3f51b5",
    "darken-1":   "#3949ab",
    "darken-2":   "#303f9f",
    "darken-3":   "#283593",
    "darken-4":   "#1a237e",
    "accent-1":    "#8c9eff",
    "accent-2":    "#536dfe",
    "accent-3":    "#3d5afe",
    "accent-4":    "#304ffe"
  },
  "blue": {
    "lighten-5":  "#E3F2FD",
    "lighten-4":  "#BBDEFB",
    "lighten-3":  "#90CAF9",
    "lighten-2":  "#64B5F6",
    "lighten-1":  "#42A5F5",
    "base":       "#2196F3",
    "darken-1":   "#1E88E5",
    "darken-2":   "#1976D2",
    "darken-3":   "#1565C0",
    "darken-4":   "#0D47A1",
    "accent-1":    "#82B1FF",
    "accent-2":    "#448AFF",
    "accent-3":    "#2979FF",
    "accent-4":    "#2962FF"
  },

  /*"light-blue": {
    "lighten-5":  "#e1f5fe",
    "lighten-4":  "#b3e5fc",
    "lighten-3":  "#81d4fa",
    "lighten-2":  "#4fc3f7",
    "lighten-1":  "#29b6f6",
    "base":       "#03a9f4",
    "darken-1":   "#039be5",
    "darken-2":   "#0288d1",
    "darken-3":   "#0277bd",
    "darken-4":   "#01579b",
    "accent-1":    "#80d8ff",
    "accent-2":    "#40c4ff",
    "accent-3":    "#00b0ff",
    "accent-4":    "#0091ea"
  },*/

  "light-blue": {
    "lighten-5":  "#e1f5fe",
    "lighten-4":  "#b3e5fc",
    "lighten-3":  "#81d4fa",
    "lighten-2":  "#4fc3f7",
    "lighten-1":  "#29b6f6",
    "base":       "#03a9f4",
    "darken-1":   "#039be5",
    "darken-2":   "#0288d1",
    "darken-3":   "#0277bd",
    "darken-4":   "#01579b",
    "accent-1":    "#80d8ff",
    "accent-2":    "#40c4ff",
    "accent-3":    "#00b0ff",
    "accent-4":    "#0091ea"
  },

  "cyan": {
    "lighten-5":  "#e0f7fa",
    "lighten-4":  "#b2ebf2",
    "lighten-3":  "#80deea",
    "lighten-2":  "#4dd0e1",
    "lighten-1":  "#26c6da",
    "base":       "#00bcd4",
    "darken-1":   "#00acc1",
    "darken-2":   "#0097a7",
    "darken-3":   "#00838f",
    "darken-4":   "#006064",
    "accent-1":    "#84ffff",
    "accent-2":    "#18ffff",
    "accent-3":    "#00e5ff",
    "accent-4":    "#00b8d4"
  },
  "teal": {
    "lighten-5":  "#e0f2f1",
    "lighten-4":  "#b2dfdb",
    "lighten-3":  "#80cbc4",
    "lighten-2":  "#4db6ac",
    "lighten-1":  "#26a69a",
    "base":       "#009688",
    "darken-1":   "#00897b",
    "darken-2":   "#00796b",
    "darken-3":   "#00695c",
    "darken-4":   "#004d40",
    "accent-1":    "#a7ffeb",
    "accent-2":    "#64ffda",
    "accent-3":    "#1de9b6",
    "accent-4":    "#00bfa5"
  },
  "green": {
    "lighten-5":  "#E8F5E9",
    "lighten-4":  "#C8E6C9",
    "lighten-3":  "#A5D6A7",
    "lighten-2":  "#81C784",
    "lighten-1":  "#66BB6A",
    "base":       "#4CAF50",
    "darken-1":   "#43A047",
    "darken-2":   "#388E3C",
    "darken-3":   "#2E7D32",
    "darken-4":   "#1B5E20",
    "accent-1":    "#B9F6CA",
    "accent-2":    "#69F0AE",
    "accent-3":    "#00E676",
    "accent-4":    "#00C853"
  },
  "light-green": {
    "lighten-5":  "#f1f8e9",
    "lighten-4":  "#dcedc8",
    "lighten-3":  "#c5e1a5",
    "lighten-2":  "#aed581",
    "lighten-1":  "#9ccc65",
    "base":       "#8bc34a",
    "darken-1":   "#7cb342",
    "darken-2":   "#689f38",
    "darken-3":   "#558b2f",
    "darken-4":   "#33691e",
    "accent-1":    "#ccff90",
    "accent-2":    "#b2ff59",
    "accent-3":    "#76ff03",
    "accent-4":    "#64dd17"
  },
  "lime": {
    "lighten-5":  "#f9fbe7",
    "lighten-4":  "#f0f4c3",
    "lighten-3":  "#e6ee9c",
    "lighten-2":  "#dce775",
    "lighten-1":  "#d4e157",
    "base":       "#cddc39",
    "darken-1":   "#c0ca33",
    "darken-2":   "#afb42b",
    "darken-3":   "#9e9d24",
    "darken-4":   "#827717",
    "accent-1":    "#f4ff81",
    "accent-2":    "#eeff41",
    "accent-3":    "#c6ff00",
    "accent-4":    "#aeea00"
  },
  "yellow": {
    "lighten-5":  "#fffde7",
    "lighten-4":  "#fff9c4",
    "lighten-3":  "#fff59d",
    "lighten-2":  "#fff176",
    "lighten-1":  "#ffee58",
    "base":       "#ffeb3b",
    "darken-1":   "#fdd835",
    "darken-2":   "#fbc02d",
    "darken-3":   "#f9a825",
    "darken-4":   "#f57f17",
    "accent-1":    "#ffff8d",
    "accent-2":    "#ffff00",
    "accent-3":    "#ffea00",
    "accent-4":    "#ffd600"
  },
  "amber": {
    "lighten-5":  "#fff8e1",
    "lighten-4":  "#ffecb3",
    "lighten-3":  "#ffe082",
    "lighten-2":  "#ffd54f",
    "lighten-1":  "#ffca28",
    "base":       "#ffc107",
    "darken-1":   "#ffb300",
    "darken-2":   "#ffa000",
    "darken-3":   "#ff8f00",
    "darken-4":   "#ff6f00",
    "accent-1":    "#ffe57f",
    "accent-2":    "#ffd740",
    "accent-3":    "#ffc400",
    "accent-4":    "#ffab00"
  },
  "orange": {
    "lighten-5":  "#fff3e0",
    "lighten-4":  "#ffe0b2",
    "lighten-3":  "#ffcc80",
    "lighten-2":  "#ffb74d",
    "lighten-1":  "#ffa726",
    "base":       "#ff9800",
    "darken-1":   "#fb8c00",
    "darken-2":   "#f57c00",
    "darken-3":   "#ef6c00",
    "darken-4":   "#e65100",
    "accent-1":    "#ffd180",
    "accent-2":    "#ffab40",
    "accent-3":    "#ff9100",
    "accent-4":    "#ff6d00"
  },
  "deep-orange": {
    "lighten-5":  "#fbe9e7",
    "lighten-4":  "#ffccbc",
    "lighten-3":  "#ffab91",
    "lighten-2":  "#ff8a65",
    "lighten-1":  "#ff7043",
    "base":       "#ff5722",
    "darken-1":   "#f4511e",
    "darken-2":   "#e64a19",
    "darken-3":   "#d84315",
    "darken-4":   "#bf360c",
    "accent-1":    "#ff9e80",
    "accent-2":    "#ff6e40",
    "accent-3":    "#ff3d00",
    "accent-4":    "#dd2c00"
  },
  "brown": {
    "lighten-5":  "#efebe9",
    "lighten-4":  "#d7ccc8",
    "lighten-3":  "#bcaaa4",
    "lighten-2":  "#a1887f",
    "lighten-1":  "#8d6e63",
    "base":       "#795548",
    "darken-1":   "#6d4c41",
    "darken-2":   "#5d4037",
    "darken-3":   "#4e342e",
    "darken-4":   "#3e2723"
  },
  "blue-grey": {
    "lighten-5":  "#eceff1",
    "lighten-4":  "#cfd8dc",
    "lighten-3":  "#b0bec5",
    "lighten-2":  "#90a4ae",
    "lighten-1":  "#78909c",
    "base":       "#607d8b",
    "darken-1":   "#546e7a",
    "darken-2":   "#455a64",
    "darken-3":   "#37474f",
    "darken-4":   "#263238"
  },
  "grey": {
    "lighten-5":  "#fafafa",
    "lighten-4":  "#f5f5f5",
    "lighten-3":  "#eeeeee",
    "lighten-2":  "#e0e0e0",
    "lighten-1":  "#bdbdbd",
    "base":       "#9e9e9e",
    "darken-1":   "#757575",
    "darken-2":   "#616161",
    "darken-3":   "#424242",
    "darken-4":   "#212121"
  },
  "shades": {
    "black":      "#000000",
    "white":      "#FFFFFF"
  }
};

angular.module("portal.config", [])
.constant("api", {"url":"/api"})
.constant("apisuperbusca", {"url":"/api-super-busca"})
.constant("apiGerenciador", {"url":"https://www.transparencia.df.gov.br"})
.constant("caminhoImagens", {"url":"/arquivos/portal-imagens/"})
.constant("caminhoArquivos", {"url":"/arquivos/portal-arquivos/"})
.constant("caminhoDadosAbertos", {"url":"/arquivos/portal-dados-abertos/"});

(function(){
  'use strict';

  angular.module('portal').service('DataAtualizacaoService', DataAtualizacaoService);

  /** @ngInject */
  function DataAtualizacaoService($http, api) {

    return {
      buscarDataAtualizacao: buscarDataAtualizacao
    };

    function buscarDataAtualizacao(param){
      var serviceConfig = { cache: true };
      return $http.get(api.url + '/dataAtualizacao/' + param, serviceConfig);
    }
  }

})();
(function() {
  'use strict';

  angular.module('portal').config(config);

  /** @ngInject */
  function config($logProvider, cfpLoadingBarProvider,
                  $datepickerProvider, $timepickerProvider,
                  $animateProvider, $alertProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // loading bar settings
    cfpLoadingBarProvider.includeSpinner = true;
    cfpLoadingBarProvider.latencyThreshold = 300;

    // defaults for date picker
    angular.extend($datepickerProvider.defaults, {
      dateFormat: 'dd/MM/yyyy',
      iconLeft: 'md md-chevron-left',
      iconRight: 'md md-chevron-right',
      autoclose: true
    });

    // defaults for date picker
    angular.extend($timepickerProvider.defaults, {
      timeFormat: 'HH:mm',
      iconUp: 'md md-expand-less',
      iconDown: 'md md-expand-more',
      hourStep: 1,
      minuteStep: 1,
      arrowBehavior: 'picker',
      modelTimeFormat: 'HH:mm'
    });

    // disable nganimate with adding class
    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

    angular.extend($alertProvider.defaults, {
      placement: 'top-right',
      container: '.alert-container-top-right',
      animation: 'mat-grow-top-right',
      templateUrl: 'app/template/partials/alert.html',
      duration: 7,
      dismissable: true
    });

    //set constants
    //$rootScope.APP = APP;
  }

  angular.module('jcs-autoValidate').run([
      'defaultErrorMessageResolver',
      function (defaultErrorMessageResolver) {
        defaultErrorMessageResolver.setI18nFileRootPath('assets');
        defaultErrorMessageResolver.setCulture('pt-br');
      }
  ]);

  angular.module('mgcrea.ngStrap')
    .config(function($modalProvider) {
      angular.extend($modalProvider.defaults, {
        html: true
      });
    });

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('portal')
    .constant('moment', moment)
    .constant('APP', { version: '1.0' });

})();

(function () {
  "use strict";

  angular.module("portal").config(RouterConfig).config(NoLinkRoutes);

  /** @ngInject */
  function NoLinkRoutes($routeProvider) {
    var noLinkRoute = {
      redirectTo: "/",
      noLink: true,
    };

    noLinkRoute.label = "Receitas";
    $routeProvider.when("/receitas", noLinkRoute);

    noLinkRoute.label = "Despesas";
    $routeProvider.when("/despesas", noLinkRoute);

    noLinkRoute.label = "Servidores";
    $routeProvider.when("/servidores", noLinkRoute);

    noLinkRoute.label = "Licitações e Contratos";
    $routeProvider.when("/licitacoes-contratos", noLinkRoute);

    noLinkRoute.label = "Convênios";
    $routeProvider.when("/convenio", noLinkRoute);

    noLinkRoute.label = "Prestando Contas";
    $routeProvider.when("/prestando-contas", noLinkRoute);

    noLinkRoute.label = "Orçamento";
    $routeProvider.when("/orcamento", noLinkRoute);

    noLinkRoute.label = "Patrimônio";
    $routeProvider.when("/patrimonio", noLinkRoute);

    noLinkRoute.label = "Beneficiário";
    $routeProvider.when("/prestando-contas/beneficiario", noLinkRoute);

    noLinkRoute.label = "Programa Social";
    $routeProvider.when(
      "/prestando-contas/beneficiario/programa-social",
      noLinkRoute
    );

    noLinkRoute.label = "Cartão";
    $routeProvider.when("/prestando-contas/beneficiario/cartao", noLinkRoute);
  }

  /** @ngInject */
  function RouterConfig($routeProvider) {
    var templatesUrl = "app/components";

    var ANO_ATUAL = 2019;

    $routeProvider
      .when("/", {
        templateUrl: "app/template/home.html",
        controller: "HomeController",
        controllerAs: "vm",
        label: "Início",
      })

      .when("/old", {
        templateUrl: "app/template/dashboard.html",
        controller: "DashboardController",
        controllerAs: "vm",
        label: "Início",
        resolve: {
          receitasXDespesas: function (DespesasService) {
            return DespesasService.graficoEvolucaoDespesasReceitas();
          },
          evolucaoImposto: function (ReceitasService) {
            return ReceitasService.graficoEvolucaoImposto("IPVA");
          },
          situacaoAtivo: function (ServidoresService) {
            return ServidoresService.listarDadosServidoresAtivos();
          },
          situacaoAposentado: function (ServidoresService) {
            return ServidoresService.listarDadosServidoresAposentados();
          },
          situacaoTotalServidores: function (ServidoresService) {
            return ServidoresService.recuperarTotalServidores();
          },
          dadosNivelSatisfacao: function (ServidoresService) {
            return ServidoresService.listarDadosPesquisaNivelSatisfacao();
          },
          dadosFaixaEtaria: function (ServidoresService) {
            return ServidoresService.listarDadosPesquisaFaixaEtaria();
          },
          dadosOcupacao: function (ServidoresService) {
            return ServidoresService.listarDadosPesquisaOcupacao();
          },
          graficoTreemap: function (DespesasService) {
            return DespesasService.recuperarDespesasAtuais();
          },
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicioServidoresOrgao();
          },
          admregionais: function (DespesasService) {
            return DespesasService.recuperarDadosAdm();
          },
          admregionaisliquidado: function (DespesasService) {
            return DespesasService.recuperarDadosLiquidado();
          },
        },
      })

      // Servidores
      .when("/servidores/dashboard", {
        templateUrl: templatesUrl + "/servidores/dashboard.html",
        controller: "ServidoresDashboardController",
        controllerAs: "vm",
        label: "Painel",
        resolve: {
          anos: function (ServidoresService) {
            return ServidoresService.listarAnoRemuneracao();
          },
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicio();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "painel-servidores"
            );
          },
        },
      })

      .when("/servidores/ressarcimento-requisitado/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/servidores/ressarcimento-requisitado/ressarcimento-requisitado-saibamais.html",
        controller: "RessarcimentoRequisitadosSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "programas-sociais"
            );
          },
        },
      })

      .when("/servidores/ressarcimento-requisitado", {
        templateUrl:
          templatesUrl +
          "/servidores/ressarcimento-requisitado/ressarcimento-requisitado.html",
        controller: "RessarcimentoRequisitadoController",
        controllerAs: "vm",
        label: "Ressarcimento Requisitados",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          gestoes: function (DespesasService) {
            return DespesasService.listarGestao();
          },
          anos: function (DespesasService) {
            return DespesasService.listarAno();
          },
          fonte: function (DespesasService) {
            return DespesasService.listarFontesQdd();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "despesas-consulta-dinamica"
            );
          },
        },
      })

      .when("/servidores/remuneracao", {
        templateUrl: templatesUrl + "/servidores/remuneracao.html",
        controller: "RemuneracaoController",
        controllerAs: "vm",
        label: "Remuneração dos Servidores",
        resolve: {
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicio();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "remuneracao-servidores"
            );
          },
        },
      })

      .when("/servidores/orgao", {
        templateUrl: templatesUrl + "/servidores/servidores-por-orgao.html",
        controller: "ServidoresController",
        controllerAs: "vm",
        label: "Servidores por órgão",
        resolve: {
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicioServidoresOrgao();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "servidores-por-orgao"
            );
          },
        },
      })

      .when("/servidores/perfil", {
        templateUrl: templatesUrl + "/servidores/servidores-por-perfil.html",
        controller: "ServidoresPerfilController",
        controllerAs: "vm",
        label: "Perfil dos Servidores",
        resolve: {
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicio();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "servidores-por-orgao"
            );
          },
        },
      })

      .when("/servidores/expulsoes", {
        templateUrl: templatesUrl + "/servidores/cadastro-expulsoes.html",
        controller: "CadastroExpulsoesController",
        controllerAs: "vm",
        label: "Cadastro de Expulsões",
        resolve: {
          listaAno: function (Expulsao) {
            return Expulsao.listaAno().get();
          },
          orgaos: function (CadastroExpulsaoService) {
            return CadastroExpulsaoService.listarOrgao();
          },
          punicoes: function (CadastroExpulsaoService) {
            return CadastroExpulsaoService.listarPunicao();
          },
          cargos: function (CadastroExpulsaoService) {
            return CadastroExpulsaoService.listarCargo();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "expulsoes-servidores"
            );
          },
        },
      })

      .when("/servidores/quadro", {
        templateUrl: templatesUrl + "/servidores/quadro-servidores.html",
        controller: "ServidorQuadroController",
        controllerAs: "servidoresCtrl",
        label: "Quadro de Servidores",
        resolve: {
          formTemplate: function () {
            return "app/components/servidores/quadro-servidores-filtro.html";
          },
          categoria: function (ServidoresService) {
            return ServidoresService.listarCategoriaRelatorio();
          },
          datasReferencias: function (ServidoresService) {
            return ServidoresService.listarDataReferenciaPorGdf();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "quadro-servidores"
            );
          },
          anosQuadro: function (ServidoresService) {
            return ServidoresService.listarAnosQuadro();
          },
        },
      })

      /*.when('/servidores/tabela', {
              templateUrl: templatesUrl + '/servidores/tabela-remuneracao.html',
              controller: 'ServidoresTabelaController',
              controllerAs: 'vm',
              label: 'Tabela de Remuneração',
              resolve:{
                formTemplate: function() {
                  return 'app/components/servidores/tabela-servidores-form.html';
                },
                categoria: function(ServidoresService) {
                  return ServidoresService.listarCategoriaRelatorio();
                },
                datasReferencias : function(ServidoresService) {
                  return ServidoresService.listarDataReferenciaPorRemuneracao();
                },
                dataAtualizacao: function(DataAtualizacaoService) {
                  return DataAtualizacaoService.buscarDataAtualizacao('tabela-remuneracao');
                },
                anosTabela: function(ServidoresService) {
                  return ServidoresService.listarAnosTabela();
                }
              }
            })*/

      .when("/servidores/status", {
        templateUrl: templatesUrl + "/servidores/status-servidores.html",
        controller: "StatusServidoresController",
        controllerAs: "vm",
        label: "Servidores por Status",
        resolve: {
          orgaos: function (ServidoresService) {
            return ServidoresService.listarOrgao();
          },
          carreiras: function (ServidoresService) {
            return ServidoresService.listarCarreira();
          },
          cargos: function (ServidoresService) {
            return ServidoresService.listarCargos();
          },
        },
      })

      .when("/servidores/cargo-comissionado", {
        templateUrl: templatesUrl + "/servidores/cargo.pesquisa.html",
        controller: "CargoComissionadoController",
        controllerAs: "vm",
        label: "Cargos Comissionados",
        resolve: {
          simbolos: function (ServidoresService) {
            return ServidoresService.listarSimbolos();
          },

          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "cargo-comissionado"
            );
          },
          funcao: function (ServidoresService) {
            return ServidoresService.listarFuncoes();
          },
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicioCargosComissionado();
          },
        },
      })

      .when("/servidores/cargo-efetivo", {
        templateUrl: templatesUrl + "/servidores/cargo.pesquisa.html",
        controller: "CargoEfetivoController",
        controllerAs: "vm",
        label: "Cargos Efetivos",
        resolve: {
          carreira: function (ServidoresService) {
            return ServidoresService.listarCarreiraCargoEfetivo();
          },
          cargo: function (ServidoresService) {
            return ServidoresService.listarDescricaoCargoEfetivo();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "cargo-efetivo"
            );
          },
          ultimoExercicio: function (ServidoresService) {
            return ServidoresService.recuperarUltimoExercicioCargosEfetivo();
          },
        },
      })

      .when("/prestando-contas/pads", {
        templateUrl: templatesUrl + "/prestando-contas/pads/pads.html",
        controller: "PADsController",
        controllerAs: "vm",
        label: "Processos Administrativos Disciplinares",
        resolve: {
          dataAtualizacao: function (PADsService) {
            return PADsService.buscarDataAtualizacao();
          },
        },
      })

      .when("/prestando-contas/pips", {
        templateUrl: templatesUrl + "/prestando-contas/pips/pips.html",
        controller: "PIPsController",
        controllerAs: "vm",
        label: "Processos de Investigação Preliminar",
        resolve: {
          dataAtualizacao: function (PIPsService) {
            return PIPsService.buscarDataAtualizacao();
          },
        },
      })

      // Despesas
      .when("/despesas/dashboard", {
        templateUrl: templatesUrl + "/despesas/dashboard.html",
        controller: "DespesasDashboardController",
        controllerAs: "vm",
        label: "Painel",
        resolve: {},
      })

      .when("/despesas/pagamentos-por-credor-detalhamento", {
        templateUrl:
          templatesUrl +
          "/despesas/pagamentos-por-credor/pagamentos-por-credor-detalhamento.html",
        controller: "PagamentosPorCredorDetalhamentoCtrl",
        controllerAs: "vm",
        label: "Pagamentos - Detalhamento",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "painel-despesas"
            );
          },
        },
      })

      //PPA
      .when("/orcamento/ppa", {
        templateUrl: templatesUrl + "/orcamento/ppa.html",
        controller: "PpaController",
        controllerAs: "vm",
        label: "Plano Plurianual - PPA",
        resolve: {
          listaDataReferencias: function (ServidoresService, $route) {
            return ServidoresService.listarDataReferenciaPorTipo("ppa");
          },
          dataAtualizacao: function (DataAtualizacaoService, $route) {
            return DataAtualizacaoService.buscarDataAtualizacao("ppa");
          },
          anos: function (OrcamentoService, $route) {
            return OrcamentoService.listarAnosRelatoriosGerenciais();
          },
        },
      })

      // OrÃ§amento - RelatÃ³rio gerencial
      .when("/orcamento/:tipo", {
        templateUrl: templatesUrl + "/orcamento/orcamento.pesquisa.html",
        controller: "OrcamentoController",
        controllerAs: "orcamentoCtrl",
        label: "{{tipo}}",
        resolve: {
          tipo: function ($route) {
            return $route.current.params.tipo;
          },
          categorias: function (OrcamentoService, $route) {
            if (
              $route.current.params.tipo === "relatorios-gerenciais" ||
              $route.current.params.tipo === "responsabilidade-fiscal"
            ) {
              return OrcamentoService.getCategorias($route.current.params.tipo);
            } else {
              return [];
            }
          },
          listaAssuntosLRF: function (OrcamentoService, $route) {
            if ($route.current.params.tipo === "responsabilidade-fiscal") {
              return OrcamentoService.listarAssuntosLRF();
            } else {
              return [];
            }
          },
          listaAssuntosRelatoriosGerenciais: function (
            OrcamentoService,
            $route
          ) {
            return OrcamentoService.listaAssuntosRelatoriosGerenciais();
          },
          listaDataReferencias: function (OrcamentoService, $route) {
            if (
              $route.current.params.tipo === "relatorios-gerenciais" ||
              $route.current.params.tipo === "responsabilidade-fiscal"
            ) {
              return OrcamentoService.listaDataReferencias();
            } else {
              return null;
            }
          },
          dataAtualizacao: function (DataAtualizacaoService, $route) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              $route.current.params.tipo
            );
          },
          anos: function (OrcamentoService, $route) {
            if ($route.current.params.tipo === "responsabilidade-fiscal") {
              return OrcamentoService.listarAnosLrf();
            }
            if ($route.current.params.tipo === "ldo") {
              return OrcamentoService.listarAnosLdo();
            }
            if ($route.current.params.tipo === "loa") {
              return OrcamentoService.listarAnosLoa();
            }
            if ($route.current.params.tipo === "relatorios-gerenciais") {
              return OrcamentoService.listarAnosRelatoriosGerenciais();
            }
          },
        },
      })

      .when("/despesas/pagamentos-por-credor", {
        templateUrl:
          "app/components/despesas/pagamentos-por-credor/pagamentos-por-credor.html",
        controller: "PagamentosPorCredorCtrl",
        controllerAs: "vm",
        label: "Pagamentos",
        resolve: {
          anos: function (DespesasService, $route) {
            return DespesasService.listarAnosPagamentosPorCredor();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "painel-despesas"
            );
          },
        },
      })

      .when("/despesas/consulta-dinamica", {
        templateUrl:
          templatesUrl + "/despesas/consulta-dinamica/consulta-dinamica.html",
        controller: "DespesaConsultaDinamicaController",
        controllerAs: "vm",
        label: "Consulta Dinâmica de Despesas",
        resolve: {
          ano: function (DespesasService) {
            return DespesasService.listarAno();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "despesas-consulta-dinamica"
            );
          },
        },
      })

      .when("/despesas/por-funcao", {
        templateUrl: templatesUrl + "/despesas/por-funcao.html",
        controller: "PorFuncaoDespesaController",
        controllerAs: "vm",
        label: "Gráfico por Função",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "despesas-consulta-dinamica"
            );
          },
        },
      })

      /*.when('/despesas/restos-a-pagar', {
              templateUrl: templatesUrl + '/despesas/restosAPagar/restos-a-pagar.html',
              controller: 'RestosAPagarController',
              controllerAs: 'vm',
              label: 'Restos a Pagar',
              resolve: {
                unidadeGestora: function(DespesasService) {
                  return DespesasService.listarUnidadeGestora();
                },
                gestao: function(DespesasService) {
                  return DespesasService.listarGestao();
                },
                ano: function(DespesasService) {
                  return DespesasService.listarRestosAPagarAnos();
                },
                fonte: function (DespesasService) {
                  return DespesasService.listarFontesQdd();
                },
                dataAtualizacao: function(DataAtualizacaoService) {
                  return DataAtualizacaoService.buscarDataAtualizacao('restos-a-pagar');
                }
              }
            })*/

      .when("/despesas/detalhamento", {
        templateUrl: templatesUrl + "/despesas/detalhamento-despesa.html",
        controller: "DetalhamentoDespesaCtrl",
        controllerAs: "vm",
        label: "Detalhamento da Despesa",
        resolve: {
          ano: function (DespesasService) {
            return DespesasService.listarDetalhamentoDespesaAno();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("detalhamento");
          },
        },
      })

      .when("/despesas/detalhamentos/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/despesas/despesas-por-agrupador/despesas-detalhamentos-saibamais.html",
        controller: "DespesasDetalhamentosSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "detalhamentos/saiba-mais"
            );
          },
        },
      })

      /*.when('/despesas/execucao-emendas', {
              templateUrl: templatesUrl + '/despesas/execucao-emendas.html',
              controller: 'ExecucaoEmendasController',
              controllerAs: 'vm',
              label: 'Execução de Emendas',
              resolve: {
                unidadeGestora: function(DespesasService) {
                  return DespesasService.listarDetalhamentoDespesaUnidadeGestora();
                },
                gestao: function(DespesasService) {
                  return DespesasService.listarDetalhamentoDespesaGestao();
                },
                ano: function(DespesasService) {
                  return DespesasService.listarAnosEmendasParlamentares();
                },
                dataAtualizacao: function(DataAtualizacaoService) {
                  return DataAtualizacaoService.buscarDataAtualizacao('execucao-emendas');
                }
              }
            })*/

      .when("/despesas/execucao-oca", {
        templateUrl: templatesUrl + "/despesas/execucao-oca.html",
        controller: "ExecucaoOcaController",
        controllerAs: "vm",
        label: "Execução OCA",
        resolve: {
          ano: function (DespesasService) {
            return DespesasService.listarAnosOca();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("execucao-oca");
          },
        },
      })

      .when("/despesas/emendas-parlamentares", {
        templateUrl: templatesUrl + "/despesas/emendas-parlamentares.html",
        controller: "EmendasParlamentaresController",
        controllerAs: "vm",
        label: "Emendas Parlamentares",
        resolve: {
          anos: function (DespesasService) {
            return DespesasService.listarAnosEmendasParlamentares();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "emendas-parlamentares"
            );
          },
        },
      })

      .when("/despesas/emenda-parlamentar-federal", {
        templateUrl: templatesUrl + "/despesas/emendas-parlamentares-federais/emendas-parlamentares-federais.html",
        controller: "EmendasParlamentaresFederaisController",
        controllerAs: "vm",
        label: "Emendas Parlamentares Federais",
        resolve: {
          anos: function (DespesasService) {
            return DespesasService.listarAnosEmendasParlamentares();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "emendas-parlamentares"
            );
          },
        },
      })

      .when("/despesas/nota-empenho/emendas-parlamentares", {
        templateUrl:
          templatesUrl + "/despesas/nota-empenho-emendas-parlamentares.html",
        controller: "NotaEmpenhoEmendasParlamentaresController",
        controllerAs: "vm",
        label: "Emendas Parlamentares",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("nota-empenho");
          },
        },
      })

      .when("/despesas/nota-lancamento/emendas-parlamentares", {
        templateUrl:
          templatesUrl + "/despesas/nota-lancamento-emendas-parlamentares.html",
        controller: "NotaLancamentoEmendasParlamentaresController",
        controllerAs: "vm",
        label: "Emendas Parlamentares",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "nota-lancamento"
            );
          },
        },
      })

      .when("/despesas/ordem-bancaria/emendas-parlamentares", {
        templateUrl:
          templatesUrl + "/despesas/ordem-bancaria-emendas-parlamentares.html",
        controller: "OrdemBancariaEmendasParlamentaresController",
        controllerAs: "vm",
        label: "Emendas Parlamentares",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "ordem-bancaria"
            );
          },
        },
      })

      .when("/despesas/diarias-passagens-locomocao", {
        templateUrl:
          templatesUrl + "/despesas/diarias-passagens/diarias-passagens.html",
        controller: "DiariasPassagensController",
        controllerAs: "vm",
        label: "Despesas com Locomoção",
        resolve: {
          anos: function (DespesasService) {
            return DespesasService.listarAnosDiariasPassagens();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "diarias-passagens"
            );
          },
        },
      })

      .when("/despesa/diarias-passagens/nota-empenho", {
        templateUrl:
          templatesUrl + "/despesas/despesas-por-agrupador/nota-empenho.html",
        controller: "NotaEmpenhoDiariasPassagensController",
        controllerAs: "vm",
        label: "Nota de Empenho",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("nota-empenho");
          },
        },
      })

      .when("/despesa/diarias-passagens/nota-lancamento", {
        templateUrl:
          templatesUrl +
          "/despesas/despesas-por-agrupador/nota-lancamento.html",
        controller: "NotaLancamentoDiariasPassagensController",
        controllerAs: "vm",
        label: "Nota de Lançamento",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "nota-lancamento"
            );
          },
        },
      })

      .when("/despesa/diarias-passagens/ordem-bancaria", {
        templateUrl:
          templatesUrl + "/despesas/despesas-por-agrupador/ordem-bancaria.html",
        controller: "OrdemBancariaDiariasPassagensController",
        controllerAs: "vm",
        label: "Pagamentos - Ordem Bancária",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          gestaoNl: function (DespesasService) {
            return DespesasService.listarOrdemBancariaGestaoNl();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "ordem-bancaria"
            );
          },
        },
      })

      .when("/despesas/nota-empenho", {
        templateUrl:
          templatesUrl + "/despesas/despesas-por-agrupador/nota-empenho.html",
        controller: "NotaEmpenhoController",
        controllerAs: "vm",
        label: "Nota de Empenho",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("nota-empenho");
          },
        },
      })

      .when("/despesas/nota-lancamento", {
        templateUrl:
          templatesUrl +
          "/despesas/despesas-por-agrupador/nota-lancamento.html",
        controller: "NotaLancamentoController",
        controllerAs: "vm",
        label: "Nota de Lançamento",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "nota-lancamento"
            );
          },
        },
      })

      .when("/despesas/ordem-bancaria", {
        templateUrl:
          templatesUrl + "/despesas/despesas-por-agrupador/ordem-bancaria.html",
        controller: "OrdemBancariaController",
        controllerAs: "vm",
        label: "Pagamentos - Ordem Bancária",
        resolve: {
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          gestaoNl: function (DespesasService) {
            return DespesasService.listarOrdemBancariaGestaoNl();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "ordem-bancaria"
            );
          },
        },
      })

      /*.when('/despesas/acao', {
             templateUrl: templatesUrl + '/despesas/despesas-por-agrupador/despesas-por-acao.html',
             controller: 'DespesaPorAcaoController',
             controllerAs: 'vm'
             })*/

      .when("/despesas/despesas-covid19-por-item", {
        templateUrl:
          templatesUrl + "/despesas/despesas-covid19/despesas-covid19.html",
        controller: "DespesasCovid19PorItemController",
        controllerAs: "vm",
        resolve: {
          anos: function (DespesasService) {
            return [2020, 2021];
            //return DespesasService.listarAnosEmendasParlamentares();
          },
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "despesas-consulta-dinamica"
            );
          },
        },
      })

      .when("/despesas/saiba-mais", {
        templateUrl: templatesUrl + "/despesas/saiba-mais/saiba-mais.html",
        controller: "DespesasSaibaMaisController",
        controllerAs: "vm",
        label: "Despesas - Saiba Mais",
      })

      .when("/despesas/saiba-mais-obras", {
        templateUrl: templatesUrl + "/despesas/saiba-mais/saiba-mais.html",
        controller: "DespesasSaibaMaisController",
        controllerAs: "vm",
        label: "Despesas - Saiba Mais",
      })

      .when("/despesas/:tipo", {
        templateUrl:
          templatesUrl +
          "/despesas/despesas-por-agrupador/agrupador-valores.html",
        controller: "DespesasPorAgrupadorController",
        controllerAs: "vm",
        label: "{{tipo}}",
        resolve: {
          tipo: function ($route) {
            return $route.current.params.tipo;
          },
          initialParams: function ($q, DespesasService, $route) {
            return $q(function (resolve, reject) {
              var listaAnos;

              DespesasService.listarAno()
                .then(function (resp) {
                  if (
                    $route.current.params.tipo == "covidorgao" ||
                    $route.current.params.tipo == "covidAuxilioUniao"
                  ) {
                    listaAnos = resp.data.filter(function (ano) {
                      return ano >= 2020;
                    });
                    if (listaAnos.length == 0) {
                      listaAnos = [2020];
                    }
                  } else {
                    listaAnos = resp.data;
                  }
                  return DespesasService.listarModalidadeLicitacao(
                    listaAnos[0]
                  );
                })
                .then(
                  function (modalidades) {
                    resolve({
                      anos: listaAnos,
                      modalidadesLicitacaoUltimoAno: modalidades.data,
                    });
                  },
                  function (err) {
                    reject(err);
                  }
                );
            });
          },
          categoriaEconomica: function (DespesasService) {
            return DespesasService.listarCategoriaEconomica();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "despesas-consulta-dinamica"
            );
          },
        },
      })

      .when("/despesas/:tipo/:categoria/:codigo", {
        templateUrl: function (attr) {
          return (
            templatesUrl +
            "/despesas/por-" +
            attr.tipo +
            "-" +
            attr.categoria +
            ".html"
          );
        },
        controller: "DespesaValoresController",
        controllerAs: "despesaCtrl",
        resolve: {
          tipo: function ($route) {
            return $route.current.params.tipo;
          },
          categoria: function ($route) {
            return $route.current.params.categoria;
          },
        },
      })

      // Legislacao
      .when("/legislacao/:nome", {
        templateUrl: function (attr) {
          return templatesUrl + "/legislacao/" + attr.nome + ".html";
        },
        resolve: {
          tipo: function ($route) {
            return $route.current.params.tipo;
          },
          categoria: function ($route) {
            return $route.current.params.categoria;
          },
        },
        label: "Legislação",
      })

      .when("/prestando-contas/relatorio-contas", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/relatorio-contas/relatorio-contas.html",
        controller: "RelatorioContasController",
        controllerAs: "vm",
        label: "Prestação de Contas Anual",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosPrestacaoContasAnual();
          },
        },
      })

      //EMPRESA INTEGRIDADE

      .when("/prestando-contas/empresa-punida", {
        templateUrl: templatesUrl + "/prestando-contas/empresa-punida.html",
        controller: "EmpresaPunidaCtrl",
        controllerAs: "vm",
        label: "Empresas Punidas",
        resolve: {
          orgaosSancionadores: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaos();
          },
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnos();
          },
          sancao: function (PrestandoContasService) {
            return PrestandoContasService.listarTipoSancao();
          },
          tipoPessoa: function (PrestandoContasService) {
            return PrestandoContasService.listarTipoPessoa();
          },
          uf: function (PrestandoContasService) {
            return PrestandoContasService.listarUf();
          },
          origemInformacoes: function (PrestandoContasService) {
            return PrestandoContasService.listarOrigemInformacoes();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "empresas-punidas"
            );
          },
          horaAtualizacao: function (PrestandoContasService) {
            return PrestandoContasService.buscarHoraAtualizacao();
          },
        },
      })

      .when("/receitas/dashboard", {
        templateUrl: templatesUrl + "/receitas/dashboard.html",
        controller: "ReceitaDashboardController",
        controllerAs: "vm",
        label: "Painel",
        resolve: {
          // texto: function (TextoConsultaService) {
          //   return TextoConsultaService.buscarTextoConsulta('RECEITAS', 'GRÁFICOS');
          // }
        },
      })

      .when("/receitas/impostos", {
        templateUrl: templatesUrl + "/receitas/impostos.html",
        controller: "ImpostosController",
        controllerAs: "vm",
        resolve: {
          impostoPreSelecionado: function () {
            return "IPVA";
          },
          // texto: function (TextoConsultaService) {
          //   return TextoConsultaService.buscarTextoConsulta('RECEITAS', 'IMPOSTOS');
          // }
        },
      })

      .when("/receitas/consulta-dinamica", {
        templateUrl:
          templatesUrl + "/receitas/consulta-dinamica/consulta-dinamica.html",
        controller: "ReceitaConsultaDinamicaController",
        controllerAs: "vm",
        label: "Consulta Dinâmica",
        resolve: {
          ano: function (ReceitasService) {
            return ReceitasService.listarAnos();
          },
          unidadeGestora: function (ReceitasService) {
            return ReceitasService.listarUnidadeGestora();
          },
          gestao: function (ReceitasService) {
            return ReceitasService.listarGestao();
          },
          categoria: function (ReceitasService) {
            return ReceitasService.listarCategoria();
          },
          fonte: function (ReceitasService) {
            return ReceitasService.listarFonte();
          },
          subfonte: function (ReceitasService) {
            return ReceitasService.listarSubFonte();
          },
          rubrica: function (ReceitasService) {
            return ReceitasService.listarRubrica();
          },
          alinea: function (ReceitasService) {
            return ReceitasService.listarAlinea();
          },
          subalinea: function (ReceitasService) {
            return ReceitasService.listarSubAlinea();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "receitas-consulta-dinamica"
            );
          },
          // texto: function (TextoConsultaService) {
          //   return TextoConsultaService.buscarTextoConsulta('RECEITAS', 'CONSULTA DINÂMICA');
          // }
        },
      })

      .when("/receitas/multas-transito", {
        templateUrl: templatesUrl + "/receitas/multas-transito.html",
        controller: "MultasTransitoController",
        controllerAs: "vm",
        label: "Multas de trânsito",
        resolve: {
          anos: function (ReceitasService) {
            return ReceitasService.listarAnosMultasTransito();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "multas-transito"
            );
          },
        },
      })

      .when("/receitas/por-orgao", {
        templateUrl: templatesUrl + "/receitas/receita-por-orgao.html",
        controller: "ReceitaController",
        controllerAs: "vm",
        label: "Receitas por Órgão",
        resolve: {
          anos: function (ReceitasService) {
            return ReceitasService.listarAnos();
          },
          unidadesGestoras: function (ReceitasService) {
            return ReceitasService.listarUnidadeGestora();
          },
          fontes: function (ReceitasService) {
            return ReceitasService.listarFonte();
          },
          subfontes: function (ReceitasService) {
            return ReceitasService.listarSubFonte();
          },
          rubricas: function (ReceitasService) {
            return ReceitasService.listarRubrica();
          },
          alineas: function (ReceitasService) {
            return ReceitasService.listarAlinea();
          },
          subalineas: function (ReceitasService) {
            return ReceitasService.listarSubAlinea();
          },
          categoria: function (ReceitasService) {
            return ReceitasService.listarCategoria();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "receitas-por-orgao"
            );
          },
        },
      })

      .when("/receitas/receita-covid19-auxilio-uniao", {
        templateUrl:
          templatesUrl + "/receitas/receitas-covid19/auxilio-uniao.html",
        controller: "ReceitaAuxilioUniaoController",
        controllerAs: "vm",
        label: "Receita - Auxílio União",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "receitas-consulta-dinamica"
            );
          },
          exercicioReferencia: function (ReceitasService) {
            return ReceitasService.listarReceitaAuxilioUniaoExercicio();
          },
          FonteRecursoFiltro: function (ReceitasService) {
            return ReceitasService.listarFonteRecurso();
          },
        },
      })

      .when("/receita-uniao/transferencia", {
        templateUrl:
          templatesUrl + "/receitas/transferencia-uniao/receita-uniao.html",
        controller: "ReceitaControllerUniao",
        controllerAs: "vm",
        label: "Receitas Transferência da União",
        resolve: {
          anos: function (ReceitasService) {
            return ReceitasService.listarAnos();
          },
          unidadesGestoras: function (ReceitasService) {
            return ReceitasService.listarUnidadeGestora();
          },
          fontes: function (ReceitasService) {
            return ReceitasService.listarFonte();
          },
          subfontes: function (ReceitasService) {
            return ReceitasService.listarSubFonte();
          },
          rubricas: function (ReceitasService) {
            return ReceitasService.listarRubrica();
          },
          alineas: function (ReceitasService) {
            return ReceitasService.listarAlinea();
          },
          subalineas: function (ReceitasService) {
            return ReceitasService.listarSubAlinea();
          },
          categoria: function (ReceitasService) {
            return ReceitasService.listarCategoria();
          },
          origem: function (ReceitasService) {
            return ReceitasService.listarOrigem();
          },

          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "receitas-transferencia-uniao"
            );
          },
        },
      })

      .when("/prestando-contas/gastos-publicidade", {
        templateUrl:
          templatesUrl + "/prestando-contas/gastos-com-publicidade.html",
        controller: "GastosPublicidadeCtrl",
        controllerAs: "vm",
        label: "Gastos com Publicidade",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listaAnosGastosComPublicidade();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "gastos-publicidade"
            );
          },
        },
      })
      .when("/prestando-contas/outros-relatorios", {
        templateUrl: templatesUrl + "/prestando-contas/outros-relatorios.html",
        controller: "OutrosRelatoriosController",
        controllerAs: "vm",
        label: "Outros Relatórios",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosOutrosRelatorios();
          },
          formTemplate: function () {
            return "app/components/prestando-contas/outros-relatorios-filter.html";
          },
          categorias: function (PrestandoContasService) {
            return PrestandoContasService.listarCategorias();
          },
          listaDatasReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarDataReferenciaPorCategoria();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "outros-relatorios"
            );
          },
        },
      })

      .when("/servidores/remuneracao/saiba-mais", {
        templateUrl: templatesUrl + "/servidores/remuneracao-saibamais.html",
        controller: "ServidoresRemuneracaoSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "programas-sociais"
            );
          },
        },
      })

      .when("/prestando-contas/beneficiarios-acoes-emergenciais/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-acoes-emergenciais-saiba-mais/beneficiarios-acoes-emergenciais-saiba-mais.html",
        controller: "BeneficiariosAcoesEmergenciaisSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
      })

      .when("/prestando-contas/orgaos-deliberativos/saiba-mais", {
        templateUrl:
          templatesUrl + "/prestando-contas/saibamaisorgaosdeliberativos.html",
        controller: "OrgaosDeliberativosSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "orgaos-deliberativos"
            );
          },
        },
      })

      .when("/despesas/diarias-passagens/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/despesas/diarias-passagens/diarias-passagens-saibamais.html",
        controller: "DiariasPassagensSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "programas-sociais"
            );
          },
        },
      })

      .when("/prestando-contas/beneficiario/programa-social/legislacao", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-programas-sociais/beneficiarios-programas-sociais-legislacao.html",
        controller: "BeneficiarioProSocLegislacaoController",
        controllerAs: "vm",
        label: "Legislação",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "programas-sociais"
            );
          },
        },
      })

      .when("/prestando-contas/beneficiario/cartao/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/cartao-material-escolar/beneficiarios-cartao-material-escolar-saiba-mais.html",
        controller: "BeneficiarioCartaoMatEscSaibaMaisController",
        controllerAs: "vm",
        label: "Saiba Mais",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "materialescolar-saibamais"
            );
          },
        },
      })

      .when("/prestando-contas/beneficiario/programas-sociais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-programas-sociais/beneficiarios-programas-sociais.html",
        controller: "BeneficiarioProSocController",
        controllerAs: "vm",
        label: "Programas Sociais",
        resolve: {
          ultimoAnoMes: function (PrestandoContasService) {
            return PrestandoContasService.ultimoAnoMesBeneficiarioProgramaSocial();
          },
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosBeneficiarioProgramaSocial();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "programas-sociais"
            );
          },
          listarProgramas: function (PrestandoContasService) {
            return PrestandoContasService.listarProgramasSociais();
          },
        },
      })

      .when("/prestando-contas/beneficiario/renda-emergencial", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-renda-emergencial/beneficiarios-renda-emergencial.html",
        controller: "BeneficiarioRendaEmergController",
        controllerAs: "vm",
        label: "Renda Emergencial",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "beneficiarios-auxilio-emergencial"
            );
          },
          mesesReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarMesesReferenciaBeneficiarioAuxilioEmergencial();
          },
        },
      })

      .when("/prestando-contas/beneficiario/renda-emergencial/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-renda-emergencial/beneficiarios-renda-emergencial-saiba-mais.html",
        controller: "RendaEmergencialSaibaMaisController",
        controllerAs: "vm",
        label: "Renda Emergencial - Saiba Mais",
        resolve: {},
      })

      .when("/prestando-contas/beneficiario/prato-cheio", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-prato-cheio/beneficiarios-prato-cheio.html",
        controller: "BeneficiarioPratoCheioController",
        controllerAs: "vm",
        label: "Prato Cheio",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "beneficiarios-prato-cheio"
            );
          },
          anosReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosReferenciaBeneficiarioPratoCheio();
          },
          mesesReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarMesesReferenciaBeneficiarioPratoCheio();
          },
        },
      })

      .when("/prestando-contas/beneficiario/prato-cheio/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-prato-cheio/beneficiarios-prato-cheio-saiba-mais.html",
        controller: "PratoCheioSaibaMaisController",
        controllerAs: "vm",
        label: "Prato Cheio - Saiba Mais",
        resolve: {},
      })

      .when("/prestando-contas/beneficiario/cartao-material-escolar", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/cartao-material-escolar/beneficiarios-cartao-material-escolar.html",
        controller: "BeneficiarioCartaoMatEscController",
        controllerAs: "vm",
        label: "Cartão Material Escolar",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosCartaoMaterialEscolar();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "material-escolar"
            );
          },
        },
      })

      .when("/prestando-contas/beneficiario/artistico-cultural", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-artistico-cultural/beneficiarios-artistico-cultural.html",
        controller: "BeneficiarioArtisticoCulturalController",
        controllerAs: "vm",
        label: "Beneficiários Artístico e Cultural",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "beneficiarios-artistico-cultural"
            );
          },
          anoReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosReferenciaBeneficiarioArtisticoCultural();
          },
        },
      })
      .when("/prestando-contas/beneficiario/artistico-cultural/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-artistico-cultural/beneficiarios-artistico-cultural-saiba-mais.html",
        controller: "BeneficiariosArtisticoCulturalSaibaMaisController",
        label: "Beneficiários Artístico e Cultural ",
        controllerAs: "vm",
        label: "Saiba mais",
      })

      .when("/prestando-contas/beneficiario/mobilidade-cidada", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-mobilidade-cidada/beneficiarios-mobilidade-cidada.html",
        controller: "BeneficiarioMobilidadeCidadaController",
        controllerAs: "vm",
        label: "Beneficiários Mobilidade Cidadã",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "beneficiarios-mobilidade-cidada"
            );
          },
          concessoes: function (PrestandoContasService) {
            return PrestandoContasService.listarConcessoesBeneficiarioMobilidadeCidada();
          },
          exercicios: function (PrestandoContasService) {
            return PrestandoContasService.listarExerciciosBeneficiarioMobilidadeCidada();
          },
        },
      })
      .when("/prestando-contas/beneficiarios-mobilidade-cidada/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/beneficiarios-mobilidade-cidada/beneficiarios-mobilidade-cidada-saiba-mais.html",
        controller: "BeneficiariosMobilidadeCidadaSaibaMaisController",
        label: "Beneficiários Mobilidade Cidadã",
        controllerAs: "vm",
        label: "Saiba mais",
      })

      .when("/prestando-contas/mobilidade-por-bicicleta", {
        templateUrl:
          templatesUrl + "/prestando-contas/mobilidade-por-bicicleta.html",
        label: "Mobilidade por Bicicleta",
      })

      .when("/prestando-contas/mobilidade-por-bicicleta/saiba-mais", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/mobilidade-por-bicicleta-saiba-mais.html",
        label: "Saiba mais",
      })

      .when("/prestando-contas/conselhos", {
        templateUrl: templatesUrl + "/prestando-contas/orgao-deliberativo.html",
        controller: "OrgaoDeliberativoController",
        controllerAs: "vm",
        label: "Conselhos",
        resolve: {
          orgaosDeliberativos: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaosDeliberativos();
          },
          grau: function (PrestandoContasService) {
            return PrestandoContasService.listarGrauOrgaosDeliberativos();
          },
          tipos: function (PrestandoContasService) {
            return PrestandoContasService.listarTipos();
          },
          orgaosVinculados: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaosVinculados();
          },
          titularidades: function (PrestandoContasService) {
            return PrestandoContasService.listarTitularidades();
          },
          representacoes: function (PrestandoContasService) {
            return PrestandoContasService.listarRepresentacoes();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "orgaos-deliberativos"
            );
          },
        },
      })

      .when("/prestando-contas/shows-eventos", {
        templateUrl:
          templatesUrl + "/prestando-contas/shows-eventos/shows-eventos.html",
        controller: "ShowsEventosController",
        controllerAs: "vm",
        label: "Shows e Eventos",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listaAnosShowEvento();
          },
          valorTotal: function (PrestandoContasService) {
            return PrestandoContasService.recuperarValorTotal();
          },
          orgaos: function (PrestandoContasService) {
            return PrestandoContasService.listaOrgaosShowsEventos();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "shows-eventos"
            );
          },
        },
      })

      .when("/prestando-contas/conselheiros", {
        templateUrl: templatesUrl + "/prestando-contas/conselheiro.html",
        controller: "ConselheiroController",
        controllerAs: "vm",
        label: "Conselheiros",
        resolve: {
          orgaosDeliberativos: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaosDeliberativos();
          },
          grau: function (PrestandoContasService) {
            return PrestandoContasService.listarGrauOrgaosDeliberativos();
          },
          tipos: function (PrestandoContasService) {
            return PrestandoContasService.listarTipos();
          },
          orgaosVinculados: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaosVinculados();
          },
          titularidades: function (PrestandoContasService) {
            return PrestandoContasService.listarTitularidades();
          },
          representacoes: function (PrestandoContasService) {
            return PrestandoContasService.listarRepresentacoes();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "orgaos-deliberativos"
            );
          },
        },
      })

      .when("/prestando-contas/organizacoes-sociais-saude", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/organizacoes-sociais/organizacoes-sociais-saude.html",
        controller: "OrganizacoesSociaisSaudeController",
        controllerAs: "vm",
        label: "Organizações Sociais - Saúde",
        resolve: {
          anos: function (PrestandoContasService) {
            return PrestandoContasService.listarAnosOrganizacoesSociaisSaude();
          },
          listaDatasReferencia: function (PrestandoContasService) {
            return PrestandoContasService.listarDataReferenciaPorCategoria(48);
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "organizacoes-sociais-saude"
            );
          },
          nomes: function (PrestandoContasService) {
            return PrestandoContasService.listarNomeOrganizacoesSociaisSaude();
          },
          relatorios: function (PrestandoContasService) {
            return PrestandoContasService.listarRelatoriosOrganizacoesSociaisSaude();
          },
          formTemplate: function () {
            return "app/components/prestando-contas/organizacoes-sociais/organizacoes-sociais-saude-filtro.html";
          },
        },
      })

      .when("/prestando-contas/empresas-programa-integridade", {
        templateUrl:
          templatesUrl +
          "/prestando-contas/empresas-programa-integridade/empresa-programa-integridade.html",
        controller: "EmpresaProgramaIntegridadeController",
        controllerAs: "vm",
        label: "Empresa Programa Integridade",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "empresa-programa-integridade"
            );
          },
          situacoes: function (PrestandoContasService) {
            return PrestandoContasService.listarSituacoesEmpresaProgramaIntegridade();
          },
          orgaoContratante: function (PrestandoContasService) {
            return PrestandoContasService.listarOrgaoContratanteEmpresaProgramaIntegridade();
          },
          anoDataApresentacao: function (PrestandoContasService) {
            return PrestandoContasService.listarAnoDataApresentacao();
          },
          mesDataApresentacao: function (PrestandoContasService) {
            return PrestandoContasService.listarMesDataApresentacao();
          },
          anoDataAvaliacao: function (PrestandoContasService) {
            return PrestandoContasService.listarAnoDataAvaliacao();
          },
          mesDataAvaliacao: function (PrestandoContasService) {
            return PrestandoContasService.listarMesDataAvaliacao();
          },
        },
      })

      .when("/prestando-contas/prospera-df", {
        templateUrl:
          templatesUrl + "/prestando-contas/prospera-df/prospera-df.html",
        controller: "ProsperaDfController",
        controllerAs: "vm",
        label: "Prospera-DF",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("prospera-df");
          },
          exercicio: function (PrestandoContasService) {
            return PrestandoContasService.listarExercicio();
          },
          personalidade: function (PrestandoContasService) {
            return PrestandoContasService.listarPersonalidade();
          },
          regiao: function (PrestandoContasService) {
            return PrestandoContasService.listarRegiaoAdministrativa();
          },
          carteira: function (PrestandoContasService) {
            return PrestandoContasService.listarCarteira();
          },
          comite: function (PrestandoContasService) {
            return PrestandoContasService.listarComite();
          },
          porte: function (PrestandoContasService) {
            return PrestandoContasService.listarPorte();
          },
          novoRenovacao: function (PrestandoContasService) {
            return PrestandoContasService.listarContrato();
          },
          modalidade: function (PrestandoContasService) {
            return PrestandoContasService.listarModalidade();
          },
          atividade: function (PrestandoContasService) {
            return PrestandoContasService.listarAtividadde();
          },
          subatividade: function (PrestandoContasService) {
            return PrestandoContasService.listarSubatividade();
          },
        },
      })

      .when("/servidores/militares-cedidos", {
        templateUrl:
          templatesUrl + "/servidores/militares-cedidos/militares-cedidos.html",
        controller: "MilitaresCedidosController",
        controllerAs: "vm",
        label: "Militares Cedidos",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "militares-cedidos"
            );
          },
          referencias: function (ServidoresService) {
            return ServidoresService.listarReferenciaMilitaresCedidos();
          },
          nomeCedente: function (ServidoresService) {
            return ServidoresService.listarNomeCedenteMilitaresCedidos();
          },
        },
      })

      /*.when('/prestando-contas/beneficiarios-bolsa-alimentacao', {
            templateUrl: templatesUrl + '/prestando-contas/beneficiarios-bolsa-alimentacao/beneficiarios-bolsa-alimentacao.html',
            controller: 'BeneficiariosBolsaAlimentacaoController',
            controllerAs: 'vm',
            label: 'Beneficiarios Bolsa Alimentação',
            resolve: {
                dataAtualizacao: function (DataAtualizacaoService){
                  return DataAtualizacaoService.buscarDataAtualizacao('beneficiarios-bolsa-alimentacao')
                },
                referencias: function(PrestandoContasService){
                  return PrestandoContasService.listarReferenciaBeneficiariosBolsaAlimentacao();
                },
                nomeEscola: function(PrestandoContasService){
                  return PrestandoContasService.listarNomeEscolaBeneficiariosBolsaAlimentacao();
                },
                regime: function(PrestandoContasService){
                  return PrestandoContasService.listarRegimeBeneficiariosBolsaAlimentacao();
                },
            }  -
          })AGUARDANDO CARGA ETL*/

      .when("/patrimonio/bens-moveis", {
        templateUrl: templatesUrl + "/patrimonio/bens-moveis/bens-moveis.html",
        controller: "BensMoveisController",
        controllerAs: "vm",
        label: "Bens móveis",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService, $route) {
            return DataAtualizacaoService.buscarDataAtualizacao("bens-moveis");
          },
        },
      })

      .when("/patrimonio/bens-imoveis", {
        templateUrl:
          templatesUrl + "/patrimonio/bens-imoveis/bens-imoveis.html",
        controller: "PatrimonioBensImoveisController",
        controllerAs: "vm",
        label: "Bens imóveis",
        resolve: {
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("bens-imoveis");
          },
        },
      })

      .when("/patrimonio/localizacao", {
        templateUrl: templatesUrl + "/patrimonio/patrimonio-por-orgao.html",
        controller: "PatrimonioPorOrgaoController",
        controllerAs: "vm",
        label: "Por Órgão e Localização",
        resolve: {
          orgao: function (PatrimonioService) {
            return PatrimonioService.listarOrgaosLocalizacao();
          },
          dataAtualizacao: function (DataAtualizacaoService, $route) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "patrimonio-por-orgao"
            );
          },
        },
      })
      .when("/patrimonio/relatorio", {
        templateUrl: templatesUrl + "/patrimonio/relatorio-patrimonio.html",
        controller: "PatrimonioRelatorioController",
        controllerAs: "patrimonioRelatorioController",
        label: "Demonstrativos",
        resolve: {
          anos: function (PatrimonioService) {
            return PatrimonioService.listarAnosDemonstrativo();
          },
          formTemplate: function () {
            return "app/components/patrimonio/patrimonio-relatorio-form.html";
          },
          categoria: function (ServidoresService) {
            return ServidoresService.listarCategoriaRelatorio();
          },
          datasReferencias: function (PatrimonioService) {
            return PatrimonioService.listarDataReferenciaPorPatrimonio();
          },
          dataAtualizacao: function (DataAtualizacaoService, $route) {
            return DataAtualizacaoService.buscarDataAtualizacao("relatorios");
          },
        },
      })

      .when("/convenio/receita", {
        templateUrl: templatesUrl + "/convenio/convenio-receita.html",
        controller: "ConvenioReceitaController",
        controllerAs: "vm",
        label: "Convênios de Receita",
        resolve: {
          anos: function (ConvenioService) {
            return ConvenioService.listarAnosReceita();
          },
          concedente: function (ConvenioService) {
            return ConvenioService.listarReceitaConcedente();
          },
          especie: function (ConvenioService) {
            return ConvenioService.listarReceitaEspecie();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "convenio-receita"
            );
          },
        },
      })

      .when("/convenio/despesa", {
        templateUrl: templatesUrl + "/convenio/convenio-despesa.html",
        controller: "ConvenioDespesaController",
        controllerAs: "vm",
        label: "Convênios de Despesa",
        resolve: {
          anos: function (ConvenioService) {
            return ConvenioService.listarAnosDespesa();
          },
          concedente: function (ConvenioService) {
            return ConvenioService.listarDespesaConcedente();
          },
          especie: function (ConvenioService) {
            return ConvenioService.listarDespesaEspecie();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "convenio-despesa"
            );
          },
        },
      })

      .when("/convenio/entidades-beneficiadas", {
        templateUrl:
          templatesUrl + "/convenio/convenio-entidades-beneficiadas.html",
        controller: "ConvenioEntidadesBeneficiadasController",
        controllerAs: "vm",
        label: "Entidades Beneficiadas",
        resolve: {
          anos: function (ConvenioService) {
            return ConvenioService.listarAnosEntidadesBeneficiadas();
          },
          concedente: function (ConvenioService) {
            return ConvenioService.listarEntidadeBeneficiadaConcedente();
          },
          especie: function (ConvenioService) {
            return ConvenioService.listarReceitaEspecie();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("nota-empenho");
          },
        },
      })

      .when("/convenio/relatorio", {
        templateUrl: templatesUrl + "/convenio/convenio-relatorios.html",
        controller: "ConvenioRelatorioController",
        controllerAs: "convenioRelatorioController",
        label: "Relatórios",
        resolve: {
          formTemplate: function () {
            return "app/components/convenio/convenio-relatorio-form.html";
          },
          categoria: function (ServidoresService) {
            return ServidoresService.listarCategoriaRelatorio();
          },
          datasReferencias: function (ServidoresService) {
            return ServidoresService.listarDataReferenciaPorConvenio();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "relatorio-convenio"
            );
          },
        },
      })

      .when("/convenio/entidades-beneficiadas/valor-pago", {
        templateUrl:
          templatesUrl + "/despesas/despesas-por-agrupador/ordem-bancaria.html",
        controller: "OrdemBancariaController",
        controllerAs: "vm",
        label: "Pagamentos - Entidade Beneficiada",
        resolve: {
          gestaoNl: function (DespesasService) {
            return DespesasService.listarOrdemBancariaGestaoNl();
          },
          prioridades: function (DespesasService) {
            return DespesasService.listarPrioridades();
          },
          unidadesGestoras: function (DespesasService) {
            return DespesasService.listarUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "ordem-bancaria"
            );
          },
        },
      })

      .when("/licitacoes-contratos/dashboard", {
        templateUrl:
          templatesUrl +
          "/licitacoes-contratos/licitacoes-contratos-dashboard.html",
        controller: "LicitacoesContratosDashboardController",
        controllerAs: "vm",
        label: "Painel",
        resolve: {
          anos: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarAnos();
          },
          evolucaoModalidade: function (LicitacoesContratosService) {
            return LicitacoesContratosService.graficoEvolucaoModalidade();
          },
          objeto: function (LicitacoesContratosService) {
            return LicitacoesContratosService.graficoObjeto();
          },
          situacao: function (LicitacoesContratosService) {
            return LicitacoesContratosService.graficoSituacao();
          },
          especie: function (LicitacoesContratosService) {
            return LicitacoesContratosService.graficoEspecie();
          },
          orgaos: function (LicitacoesContratosService) {
            return LicitacoesContratosService.graficoMaioresOrgaosContratantes();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao(
              "painel-licitacao-contratos"
            );
          },
        },
      })

      .when("/licitacoes-contratos/contratos", {
        templateUrl:
          templatesUrl + "/licitacoes-contratos/contratos/contratos.html",
        controller: "ContratosController",
        controllerAs: "vm",
        label: "Contratos",
        resolve: {
          anos: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarAnosContratos();
          },
          fonteRecurso: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarContratoFonteRecurso();
          },
          funcao: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarContratoFuncao();
          },
          gestao: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarContratoGestao();
          },
          tipoLicitacao: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarContratoTipoLicitacao();
          },
          unidadeGestora: function (LicitacoesContratosService) {
            return LicitacoesContratosService.listarContratoUnidadeGestora();
          },
          dataAtualizacao: function (DataAtualizacaoService) {
            return DataAtualizacaoService.buscarDataAtualizacao("contratos");
          },
        },
      })

      .when("/licitacoes-contratos/licitacoes", {
        templateUrl:
          templatesUrl + "/licitacoes-contratos/licitacoes/licitacoes.html",
        controller: "LicitacoesController",
        controllerAs: "vm",
        label: "Licitações",
        resolve: {
          anos: function (LicitacoesService) {
            return LicitacoesService.listarExercicios();
          },
        },
      })

      .when("/licitacoes-contratos/licitacoes/fornecedores", {
        templateUrl:
          templatesUrl +
          "/licitacoes-contratos/licitacoes/fornecedores/fornecedores.html",
        controller: "FornecedoresController",
        controllerAs: "vm",
        label: "Fornecedores",
        resolve: {},
      })

      /*.when('/licitacoes-contratos/licitacoes', {
              templateUrl: templatesUrl + '/licitacoes-contratos/licitacoes/licitacoes.html',
              controller: 'LicitacoesController',
              controllerAs: 'vm',
              label: 'Licitações',
              resolve: {
                anos: function (LicitacoesContratosService) {
                  return LicitacoesContratosService.listarAnos();
                },
                situacoes: function (LicitacoesContratosService) {
                  return LicitacoesContratosService.listarLicitacaoSituacao();
                },
                modalidades: function (LicitacoesContratosService) {
                  return LicitacoesContratosService.listarLicitacaoModalidade();
                },
                dataAtualizacao: function (DataAtualizacaoService) {
                  return DataAtualizacaoService.buscarDataAtualizacao('licitacao');
                }
              }
            })*/

            .when('/licitacoes-contratos/itens-licitados', {
                templateUrl: templatesUrl + '/licitacoes-contratos/itens-licitados/itens-licitados.html',
                controller: 'ItensLicitadosController',
                controllerAs: 'vm',
                label: 'Itens Licitados',
                resolve: {
                    anos: function (LicitacoesContratosService) {
                        return LicitacoesContratosService.listarAnosItensLicitados();
                    },
                    dataAtualizacao: function (DataAtualizacaoService) {
                        return DataAtualizacaoService.buscarDataAtualizacao('itens-licitados');
                    }
                }
            })

            .when('/url-arquivo', {
                templateUrl: templatesUrl + '/compartilhado/carregando-arquivo.html',
                controller: 'ArquivoUrlController',
                controllerAs: 'vm'
            })

            .when('/sobre', {
                templateUrl: templatesUrl + '/compartilhado/sobre.html',
                label: 'Sobre o portal'
            })

            .when('/glossario', {
                templateUrl: templatesUrl + '/compartilhado/glossario.html',
                controller: 'GlossarioController',
                controllerAs: 'vm',
                label: 'Glossário'
            })

            .when('/faq', {
                templateUrl: templatesUrl + '/compartilhado/faq.html',
                label: 'FAQ'
            })


            .when('/downloads', {
                templateUrl: templatesUrl + '/compartilhado/downloads.html',
                controller: 'DownloadsController',
                controllerAs: 'vm',
                label: 'Downloads'
            })

            .when('/linksuteis', {
                templateUrl: templatesUrl + '/compartilhado/linksuteis.html',
                label: 'Links úteis'
            })

            .when('/busca', {
                templateUrl: templatesUrl + '/super-busca/super-busca.html',
                controller: 'SuperBuscaController',
                controllerAs: 'vm',
                label: 'Busca',
                reloadOnSearch: false
            })

            .when('/temas', {
                templateUrl: templatesUrl + '/quadros-tematicos/quadros-tematicos.html',
                controller: 'QuadrosTematicosController',
                controllerAs: 'vm',
                label: 'Temas',
                reloadOnSearch: false
            })

            .when('/acesso-informacao', {
                templateUrl: templatesUrl + '/acesso-informacao/acesso-informacao.html',
                controller: 'AcessoInformacaoController',
                controllerAs: 'vm',
                label: 'Acesso à informação'
            })

             // **************  temporário *****************
            .when('/informacao', {
              templateUrl: templatesUrl + '/compartilhado/informacao.html'

            })
            // ********************************************

            .otherwise({ redirectTo: '/' });
    }

})();

(function() {
  'use strict';

  angular
    .module('portal')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, Breadcrumb) {
    $rootScope.$on('$routeChangeSuccess', function(){
      Breadcrumb.update();
    });
  }

})();

(function() {
    'use strict';

    var CLIENT_ID_HEADER = 'x-client-id';
    var clientId = generateClientId();

    window.PortalTransparenciaClient = window.PortalTransparenciaClient || {};
    window.PortalTransparenciaClient.getClientId = getClientId;
    window.PortalTransparenciaClient.getHeaders = getHeaders;
    window.PortalTransparenciaClient.CLIENT_ID_HEADER = CLIENT_ID_HEADER;

    function generateClientId() {
        if (window.crypto && window.crypto.randomUUID) {
            return window.crypto.randomUUID();
        }

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
            var random = Math.random() * 16 | 0;
            var value = character === 'x' ? random : (random & 0x3 | 0x8);
            return value.toString(16);
        });
    }

    function getClientId() {
        if (!clientId) {
            clientId = generateClientId();
        }

        return clientId;
    }

    function getHeaders() {
        var headers = {};
        headers[CLIENT_ID_HEADER] = getClientId();
        return headers;
    }

    angular.module('portal').factory('tokenInterceptor', ['$q', 'api', function ($q, api) {
        function isPortalApiRequest(url) {
            return url && api.url && url.indexOf(api.url) === 0;
        }

        return {
            request: function (config) {
                config.headers = config.headers || {};

                if (isPortalApiRequest(config.url)) {
                    config.headers[CLIENT_ID_HEADER] = getClientId();
                }
     
                return config;
            },
            responseError: function (error) {
                return $q.reject(error);
            },
        }
    }])

})();

(function() {
    'use strict';

    angular.module('portal').controller('AcessoInformacaoController', AcessoInformacaoController);

    /**
     * Controlador da página de acesso a informação.
     */
    /** @ngInject */
    function AcessoInformacaoController(AcessoInformacaoService, $timeout) {
        var vm = this;
        vm.menus = MENUS;

        /*AcessoInformacaoService.obterOrgaos().then(function(response) {
            vm.entidades = response.data;
        });*/

        vm.entidades = AcessoInformacaoService.obterOrgaos();
    }

    var MENUS = [
        {
            label: 'Cartilha',
            link: 'https://lai.cg.df.gov.br/wp-content/uploads/2026/06/Cartilha-LAI-brasao_compressed.pdf',
            newtab: true
        },{
            label: 'Relatório',
            link: 'https://bit.ly/paineldetransparenciadf',
            newtab: true
        },{
            label: 'Legislação',
            link: 'https://www.df.gov.br/legislacao-2/',
            newtab: true
        },{
            label: 'Saiba mais',
            link: 'http://www.df.gov.br/category/acesso-a-informacao/',
            newtab: true
        }
    ];

})();

(function () {
    'use strict';
  
    angular.module('portal').service('AcessoInformacaoService', AcessoInformacaoService);

    /**
     * Fornece serviços para a funcionalidade de quadros temáticos.
     */
    function AcessoInformacaoService($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.obterOrgaos = obterOrgaos;
        _scope.api = api;
  
        return _scope;
    }

    /**
     * Obtem o conjunto de orgãos que fornecem acesso a informação.
     */

    function obterOrgaos() {
        return this.$http({
            url: this.api.url + '/v2/orgaos-lai',
            method: 'GET'
        });
    };
    
})();

(function(){
  'use strict';

  angular.module('portal.breadcrumb').factory('Breadcrumb', Breadcrumb);

  /** @ngInject */
  function Breadcrumb(crumble, $interpolate, $location){

    return {
      update: updateCrumble,
      getCrumb: getCrumb,
      clean: crumbleClean
    };

    function updateCrumble() {
      var currentRoute = crumble.getRoute($location.path());
      if(angular.isDefined(currentRoute.label)){
        var currentRouteParent = crumble.getParent($location.path());
        var parentRoute = crumble.getRoute(currentRouteParent);
        if(parentRoute){
          crumble.update();
        }else{
          crumble.clean();
        }
      }else{ 
        // Cleans the crumble trail if the route has no label attribute to show
        crumble.clean();
      }
    }

    function getCrumb(path) {
      var route = crumble.getRoute(path);
      if(route){
        var noLink = angular.isDefined(route.noLink) ? route.noLink : false;
        return {
          path: $interpolate(path)(crumble.context),
          label: $interpolate(route.label)(crumble.context),
          noLink: noLink
        };
      }else{ 
        var ERR_NO_ROUTE = 'Could not find matching route definition for path ';
        throw new Error(ERR_NO_ROUTE + JSON.stringify(path));
      }
    }

    function crumbleClean(){
      crumble.trail = [];
      crumble.context = {};
    }
  }
})();
(function () {
    'use strict';

    angular.module('portal.convenio').controller('ConvenioDespesaController', Controller);

    /** @ngInject */
    function Controller($location, $scope, $aside, $alert, $modal, anos, concedente, especie,
        PagingService, RelatorioService, ConvenioService, dataAtualizacao) {

        var vm = this, currentModal;

        vm.anos = anos.data;
        vm.concedente = concedente.data;
        vm.especie = especie.data;
        vm.dataAtualizacao = dataAtualizacao;

        var colunas = {
            anoExercicio: { nome: "Exercício", visible: true, termo: "Ano da celebração do convênio" },
            numeroTransferenciaDespesa: { nome: "Nº Transferência", visible: true, termo: "Nº do registro do convênio no SIGGO", center: true },
            //numeroDocumentoDespesa:{ nome:"Numero do Processo", visible:false },
            dataInicioVigenciaDespesa: { nome: "Início Vigência", visible: false, center: true, termo: "Data do ínicío da validade do convênio" },
            dataFimVigenciaDespesa: { nome: "Fim Vigência", visible: false, center: true, termo: "Data do término da validade do convênio" },
            dataCelebracaoDespesa: { nome: "Celebração", visible: true, center: true, termo: "Data da assinatura do convênio" },
            dataPublicacaoDespesa: { nome: "Publicação", visible: false, center: true, termo: "Data da publicação do extrato do convênio no Diário Oficial do DF" },
            dataRescisaoDespesa: { nome: "Rescisão", visible: false, center: true, termo: "Data de cancelamento do convênio" },
            dataConclusaoDespesa: { nome: "Conclusão", visible: false, center: true, termo: "Data de término da execução do objeto" },
            concedenteDespesa: { nome: "Concedente", visible: true, termo: "Responsável pela concessão ou repasse de recursos" },
            beneficiarioDespesa: { nome: "Convenente", visible: true, termo: "Recebedor de recursos e executor do objeto do convênio" },
            justificativaDespesa: { nome: "Justificativa", visible: true, termo: "Razões para a celebração do convênio" },
            especieDespesa: { nome: "Espécie", visible: false, termo: "Tipo de instrumento utilizado" },
            gestorDespesa: { nome: "Gestor", visible: false, termo: "Responsável no órgão pelo acompanhamento do convênio" },
            codigoBeneficiarioDespesaMascarado: { nome: "CPF/CNPJ Convenente", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica do recebedor dos recursos e executor do objeto do convênio" },
            gestaoDespesa: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            objetoResumidoDespesa: { nome: "Objeto Resumido", visible: false, termo: "Produto do convênio" },
            situacaoDespesa: { nome: "Situação", visible: false, termo: "Situação do convênio quanto à prestação de contas" },
            valorPactuadoDespesa: { nome: "Valor Pactuado", visible: true, currency: true, termo: "Valor total do convênio" },
            //valorLancamentoDespesa:{ nome:"Valor Pactuado", visible:true, currency:true },
            valorTransferenciaDespesa: { nome: "Valor Transferência", visible: false, currency: true, termo: "Valor a ser concedido ou repassado pelo concedente" },
            valorContrapartidaDespesa: { nome: "Valor Contrapartida", visible: false, currency: true, termo: "Valor a ser desembolsado pelo convenente" },

        };

        $scope.colunas = colunas;

        // settings
        vm.settings = {
            singular: 'Convênios de Despesa',
            plural: '',
            busy: true,
            cmd: '',
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            anoExercicio: vm.anos[0],
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        var data = {
            url: '/convenio/despesa',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/convenio/convenio-despesa-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/convenio/convenio-despesa-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        vm.cancelar = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
        };

        vm.exibirFormPesquisa = function () {
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            $scope.showForm();
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                $scope.showFormDetalhamento();
            }
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.tipo = $scope.dados.form.tipo;
                vm.item.colunas = vm.settings.colunas;
                RelatorioService.exportar('/convenio/relatorio/despesa', vm.item);
            }
        };

        vm.init = function () {
            vm.item.anoExercicio = vm.anos[0];

            vm.assignInitParams($location.search());

            vm.search();
        };

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         */
        vm.assignInitParams = function (params) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return compareProp ? elem[compareProp].trim() == param : elem == param; })[0];

                    if (element != null) {
                        if (valueProp != undefined) {
                            element = element[valueProp];
                        }

                        modelObj[modelProp] = isMultiple ? [element] : element;
                    }
                }
            };

            assignProps([{ from: 'convenente', to: 'beneficiario', type: String }], params, vm.item);
            assignProps([{ from: 'justificativa', to: 'justificativa', type: String }], params, vm.item);
            assignProps([{ from: 'exercicio', to: 'anoExercicio', type: String }], params, vm.item);
            assignSelect(vm.concedente, vm.item, 'listaCodigoConcedente', params['concedente'], 'nome', 'codigo', true);
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.item.anoExercicio;
            $scope.filter = angular.copy(vm.item);
            $scope.hideForm();
        };

        $scope.showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.showFormDetalhamento = function () {
            angular.element('.tooltip').remove();
            formTplDetalhamento.show();
            currentModal = formTplDetalhamento;
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        vm.voltar = function () {
            if (currentModal) {
                currentModal.show();
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

        vm.exibirModalExecucao = function (item) {

            var reqObj = {
                anoExercicio: item.anoExercicio,
                numeroTransferenciaDespesa: item.numeroTransferenciaDespesa
            };

            ConvenioService.listExecucaoDespesa(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não foram encontrados resultados.',
                            type: 'info'
                        });
                        return;
                    }

                    vm.execucao = response.data;
                    vm.execucaoTotal = _.reduce(vm.execucao, function (memo, obj) {
                        return memo + obj.valorLancamentoDespesa
                    }, 0);

                    if (currentModal) {
                        currentModal.hide();
                    }

                    $aside({
                        scope: $scope,
                        template: 'app/components/convenio/convenio-execucao-despesa-modal.html',
                        show: true,
                        placement: 'left',
                        backdrop: true,
                        animation: 'am-slide-left'
                    });
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar dados.',
                        type: 'info'
                    });
                }
            );
        };

        vm.exibirModalExtratoConvenio = function (item) {

            var reqObj = {
                anoExercicio: item.anoExercicio,
                numeroTransferenciaDespesa: item.numeroTransferenciaDespesa
            };

            ConvenioService.listExtratoConvenioDespesa(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não foram encontrados resultados.',
                            type: 'info'
                        });
                        return;
                    }

                    vm.extratoDoConvenio = response.data;

                    var modal = modalTemplate(
                        'Extrato do Convênio',
                        'app/components/convenio/convenio-extrato-convenio-despesa-modal.html'
                    );
                    modal.$promise.then(modal.show);
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar dados.',
                        type: 'info'
                    });
                }
            );
        };

        var modalTemplate = function (titulo, template) {
            return $modal({
                scope: $scope,
                title: titulo,
                template: template,
                show: false
            });
        };

    }

})();

(function(){
  'use strict';

  angular.module('portal.convenio').controller('ConvenioEntidadesBeneficiadasController', Controller);

  /** @ngInject */
  function Controller($scope, $aside, $alert, $modal, $location, anos, concedente, especie,
                      PagingService, ScopeService, RelatorioService, ConvenioService,
                      dataAtualizacao) {

    var vm = this;

    vm.anos = anos.data;
    vm.concedente = concedente.data;
    vm.especie = especie.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      codigoCredorMascarado:{ nome:"CNPJ Entidade", visible:true, termo:"CNPJ da entidade beneficiada" },
      nomeCredor:{ nome:"Entidade", visible:true, termo:"Nome da entidade beneficiada" },
      endereco:{ nome:"Endereço", visible:false, termo:"Endereço da sede da entidade beneficiada" },
      nomeUnidadeGestora:{ nome:"Orgão Transferidor", visible:true, termo:"Responsável pela concessão ou repasse de recurso" },
      valorPago:{ nome:"Valor Pago", visible:true, currency:true, termo:"Valor repassado à entidade beneficiada" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Entidades Beneficiadas',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };
    vm.item = {
      tipo: 'pdf',
      page: 0,
      anoOrdemBancaria: vm.anos[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/convenio/entidades-beneficiadas',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;


    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/convenio/convenio-entidades-beneficiadas-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      $scope.showForm();
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        $scope.showForm();
      }
    };

    vm.exportarDetalhamento = function(item) {
      if(item.codigoCredor)
        item.tipo = 'pdf';
      RelatorioService.exportar('/convenio/relatorio/entidades-beneficiadas/detalhamento-entidade/' + item.anoOrdemBancaria + '/' + vm.codigoCredor + '/' + vm.codigoUnidadeGestora, item);
    };

    $scope.exportar = function() {
      if(vm.item)
      vm.item.colunas = vm.settings.colunas;
      vm.item.tipo = $scope.dados.form.tipo;
      RelatorioService.exportar('/convenio/relatorio//entidades-beneficiadas', vm.item);
    };

    vm.init = function() {
      vm.item.anoExercicio = vm.anos[0];

      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function(params) {
      var assignProps = function(propsArray, fromObj, toObj) {
        propsArray.forEach(function(prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignProps([{from:'codCredor', to:'codigoCredor', type:String}], params, vm.item);
      assignProps([{from:'nomeCredor', to:'nomeCredor', type:String}], params, vm.item);
      assignProps([{from:'exercicio', to:'anoOrdemBancaria', type:String}], params, vm.item);
      assignSelect(vm.concedente, vm.item, 'listaCodigoUnidadeGestora', params['orgao'], 'nome', 'codigo', true);
    };

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.anoOrdemBancaria;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    $scope.showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

  vm.showModal = function(item) {
    ConvenioService.listDetalhamentoConvenioEntidadeBeneficiada(item).then(
        function(response) {
          vm.DetalhamentoConselho = response.data;
          vm.codigoCredor = item.codigoCredor;
          vm.nomeCredor = item.nomeCredor;
          vm.codigoUnidadeGestora = item.codigoUnidadeGestora;
          vm.anoOrdemBancaria = item.anoOrdemBancaria;
          vm.linha = item;

          $aside({
            scope: $scope,
            template: 'app/components/convenio/convenio-entidades-beneficiadas-detalhamento.html',
            show: true,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
          });

        },
        function(erro) {
          $alert({
            title:'Erro',
            content: 'Erro ao recuperar dados para o detalhamento',
            placement: 'top-right',
            type: 'erro',
            container: '.alert-container-top-right',
            animation: 'mat-grow-top-right',
            duration: 5
          });
        }
    );
  };

  vm.visualizarPago = function (row, tipoValorPago) {
    vm.item.colunas = $scope.colunas;

    var obj = {
      filtroOrigem: vm.item,
      colunas: $scope.colunas
    };

    obj.url = '/convenio/entidades-beneficiadas';
    ScopeService.store(obj);
    $location.path('/convenio/entidades-beneficiadas/valor-pago').search({
      ano: vm.item.anoOrdemBancaria,
      codigoCredorCodificado: btoa(row.codigoCredor),
      codigoUnidadeGestora: row.codigoUnidadeGestora,
      nomeCredor: row.nomeCredor,
      tipoValorPago: tipoValorPago
    });
  };

  }

})();

(function () {
    'use strict';

    angular.module('portal.convenio').controller('ConvenioReceitaController', Controller);

    /** @ngInject */
    function Controller($location, $scope, $aside, $alert, $modal, anos, concedente, especie,
        PagingService, RelatorioService, ConvenioService, dataAtualizacao) {

        var vm = this, currentModal;
        vm.anos = anos.data;
        vm.concedente = concedente.data;
        vm.especie = especie.data;
        vm.dataAtualizacao = dataAtualizacao;

        vm.concedente.forEach(function (c) {
            c.nome = c.nome ? c.nome.trim() : c.nome;
        });

        var colunas = {
            anoExercicio: { nome: "Exercício", visible: true, termo: "Ano da celebração do convênio" },
            numeroTransferencia: { nome: "Nº Transferência", visible: true, termo: "Nº do registro do convênio no SIGGO", center: true },
            //numeroDocumento:{ nome:"Numero do Processo", visible:false },
            dataInicioVigencia: { nome: "Início Vigência", visible: true, center: true, termo: "Data do ínicío da validade do convênio" },
            dataFimVigencia: { nome: "Fim Vigência", visible: false, center: true, termo: "Data do término da validade do convênio" },
            dataCelebracao: { nome: "Celebração", visible: false, center: true, termo: "Data da assinatura do convênio" },
            dataPublicacao: { nome: "Publicação", visible: false, center: true, termo: "Data da publicação do extrato do convênio no Diário Oficial do DF" },
            dataRescisao: { nome: "Rescisão", visible: false, center: true, termo: "Data de cancelamento do convênio" },
            dataConclusao: { nome: "Conclusão", visible: false, center: true, termo: "Data de término da execução do objeto" },
            concedente: { nome: "Concedente", visible: true, termo: "Responsável pela concessão ou repasse de recursos" },
            beneficiario: { nome: "Convenente", visible: true, termo: "Recebedor de recursos e executor do objeto do convênio" },
            justificativa: { nome: "Justificativa", visible: true, termo: "Razões para a celebração do convênio" },
            especie: { nome: "Espécie", visible: false, termo: "Tipo de instrumento utilizado" },
            gestor: { nome: "Gestor", visible: false, termo: "Responsável no órgão pelo acompanhamento do convênio" },
            codigoBeneficiarioMascarado: { nome: "CPF/CNPJ Convenente", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica do recebedor dos recursos e executor do objeto do convênio" },
            gestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            objetoResumido: { nome: "Objeto Resumido", visible: false, termo: "Produto do convênio" },
            situacaoReceita: { nome: "Situação", visible: false, termo: "Situação do convênio quanto à prestação de contas" },
            valorPactuado: { nome: "Valor Pactuado", visible: true, currency: true, termo: "Valor total do convênio" },
            //valorLancamento:{ nome:"Valor Pactuado", visible:true, currency:true },
            valorTransferencia: { nome: "Valor Transferência", visible: false, currency: true, termo: "Valor a ser concedido ou repassado pelo concedente" },
            valorContrapartida: { nome: "Valor Contrapartida", visible: false, currency: true, termo: "Valor a ser desembolsado pelo convenente" },

        };

        $scope.colunas = colunas;
        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };
        // settings
        vm.settings = {
            singular: 'Convênios de Receita',
            plural: '',
            busy: true,
            cmd: '',
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            anoExercicio: vm.anos[0],
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        var data = {
            url: '/convenio/receita',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/convenio/convenio-receita-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/convenio/convenio-receita-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
        };

        vm.exibirFormPesquisa = function () {
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            $scope.showForm();
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                $scope.showFormDetalhamento();
            }
        };

        $scope.exportar = function () {
            if (vm.item)
                vm.item.colunas = vm.settings.colunas;
            vm.item.tipo = $scope.dados.form.tipo;
            RelatorioService.exportar('/convenio/relatorio/receita', vm.item);
        };


        vm.init = function () {
            vm.item.anoExercicio = vm.anos[0];

            vm.assignInitParams($location.search());

            vm.search();
        };

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         */
        vm.assignInitParams = function (params) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

                    if (element != null) {
                        if (valueProp != undefined) {
                            element = element[valueProp];
                        }

                        modelObj[modelProp] = isMultiple ? [element] : element;
                    }
                }
            };

            assignProps([{ from: 'convenente', to: 'beneficiario', type: String }], params, vm.item);
            assignProps([{ from: 'justificativa', to: 'justificativa', type: String }], params, vm.item);
            assignProps([{ from: 'exercicio', to: 'anoExercicio', type: String }], params, vm.item);
            assignSelect(vm.concedente, vm.item, 'listaCodigoConcedente', params['concedente'], 'nome', 'codigo', true);
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.item.anoExercicio;
            $scope.filter = angular.copy(vm.item);
            $scope.hideForm();
        };

        $scope.showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.showFormDetalhamento = function () {
            angular.element('.tooltip').remove();
            formTplDetalhamento.show();
            currentModal = formTplDetalhamento;
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        vm.voltar = function () {
            if (currentModal) {
                currentModal.show();
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

        vm.exibirModalExecucao = function (item) {

            var reqObj = {
                anoExercicio: item.anoExercicio,
                numeroTransferencia: item.numeroTransferencia
            };

            ConvenioService.listExecucaoReceita(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não foram encontrados resultados.',
                            type: 'info'
                        });
                        return;
                    }

                    vm.execucao = response.data;
                    vm.execucaoTotal = _.reduce(vm.execucao, function (memo, obj) {
                        return memo + obj.valorLancamento
                    }, 0);

                    if (currentModal) {
                        currentModal.hide();
                    }

                    $aside({
                        scope: $scope,
                        template: 'app/components/convenio/convenio-execucao-receita-modal.html',
                        show: true,
                        placement: 'left',
                        backdrop: true,
                        animation: 'am-slide-left'
                    });
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar dados.',
                        type: 'info'
                    });
                }
            );
        };

    }

})();

(function(){
  'use strict';

  angular.module('portal.convenio').service('ConvenioService', Service);

  function Service($http, api) {

    var service = {};
    var serviceConfig = { cache: true };

    service.listarAnosReceita = function() {
      return $http.get(api.url + '/convenio/receita/anos', serviceConfig);
    };

    service.listarAnosDespesa = function() {
      return $http.get(api.url + '/convenio/despesa/anos', serviceConfig);
    };

    service.listarAnosEntidadesBeneficiadas = function() {
      return $http.get(api.url + '/convenio/entidades-beneficiadas/anos', serviceConfig);
    };

    service.listarReceitaConcedente = function() {
      return $http.get(api.url + '/convenio/receita/concedente', serviceConfig);
    };

    service.listarDespesaConcedente = function() {
      return $http.get(api.url + '/convenio/despesa/concedente', serviceConfig);
    };
    service.listarReceitaEspecie = function() {
      return $http.get(api.url + '/convenio/receita/especie', serviceConfig);
    };
    service.listarDespesaEspecie = function() {
      return $http.get(api.url + '/convenio/despesa/especie', serviceConfig);
    };

    service.listarEntidadeBeneficiadaConcedente = function() {
      return $http.get(api.url + '/convenio/entidade-beneficiada/concedente', serviceConfig);
    }


    service.listExecucaoReceita = function(obj) {
      return $http({
        url: api.url + '/convenio/receita/execucao',
        method: 'GET',
        params: obj
      });
    };

    service.listExecucaoDespesa = function(obj) {
      return $http({
        url: api.url + '/convenio/despesa/execucao',
        method: 'GET',
        params: obj
      });
    };

    service.listExtratoConvenioDespesa = function(obj) {
      return $http({
        url: api.url + '/convenio/despesa/extrato-convenio',
        method: 'GET',
        params: obj
      });
    };

    service.listDetalhamentoConvenioEntidadeBeneficiada = function(obj) {
      return $http({
        url: api.url + '/convenio/entidades-beneficiadas/detalhamento-entidades/' + obj.anoOrdemBancaria + '/' + obj.codigoCredor + '/' + obj.codigoUnidadeGestora,
        method: 'GET',
      });
    };

    service.listDetalhamentoValorPagoEntidadeBeneficiada = function(obj) {
      return $http({
        url: api.url + '/convenio/entidade-beneficiada/valor-pago',
        method: 'GET',
        params: obj
      });
    }

    return service;

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('ConvenioRelatorioController', ConvenioRelatorioController);

  /** @ngInject */
  function ConvenioRelatorioController($scope, $log, $aside,  formTemplate, categoria,datasReferencias, dataAtualizacao) {

    var vm = this;
    vm.contador = 0;
    $scope.vm = vm;
    vm.datasReferencias = datasReferencias.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nome:{ nome: "Nome", visible:true },
      ano:{ nome:"Exercício", visible:true },
      dataReferencia:{ nome:"Data referência", visible:true,date:true },
      descricao:{nome:"Observação", visible:true},
      fonte:{nome:"Fonte",visible:true}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Relatório',
      plural: 'Relatórios',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      editing: true,
      page: 0,
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/convenio/relatorio',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: formTemplate,
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    //vm.visualizarItem = function(linha){
    //  if(linha){
    //    vm.item.editing = false;
    //    vm.linha = linha;
    //    vm.settings.cmd = 'Visualizar';
    //    showForm();
    //  }
    //};

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.search();
    };

    $scope.init = vm.init;

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };


    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      formTpl.hide();
    });

  }

})();

/*eslint-disable */
(function(){
    'use strict';
  
    angular.module('portal').controller('DashBoardExecucaoDespesaController', DashBoardExecucaoDespesaController);
  
    /** @ngInject */
    function DashBoardExecucaoDespesaController($scope) {
  
    };
  
  })();
  
  
(function(){
  'use strict';

  angular.module('portal').controller('DespesaValoresController', DespesaValoresController);

  /** @ngInject */
  function DespesaValoresController($scope, $aside, $modal, $routeParams, $location, tipo, categoria,
                                 DespesasService, PagingService, RelatorioService) {

    var chave = function() {
      if (tipo == 'acao') return 'codigoProjeto';
      if (tipo == 'credor') return 'codigoCredor';
      if (tipo == 'orgao') return 'codigoUnidadeGestora';
    }

    // settings
    $scope.settings = {
      singular: 'Nota Empenho',
      plural: 'Despesas',
      busy: true,
      cmd: ''
    };

    $scope.item = {
      colunas : [],
      editing: true,
      tipo: 'pdf',
      page: -1
    };

    $scope.item[chave] = $routeParams.codigo;

    var data = {
      content: [],
      totalElements: 0,
      last: true
    };

    $scope.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/nota-empenho-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    $scope.visualizarItem = function(linha){
      if(linha){
        $scope.item.editing = false;
        $scope.linha = linha;
        $scope.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function(){
      formTpl.hide();
    };

    $scope.voltar = function() {
      $location.path('/despesas/' + tipo);
    }

    $scope.nextPage = function() {
      if ($scope.settings.busy) return;
      $scope.settings.busy = true;
      $scope.item.page += 1;
      pesquisa();
    };

    var pesquisa = function() {
      if(categoria != 'empenhado') return;
      PagingService.pesquisar('/despesa/' + tipo + '/empenhado/' + $routeParams.codigo,
          $scope.item, $scope.data, $scope.settings).then(
        function(response) {

        },
        function(error) {

        }
      );
    };

    $scope.pesquisa = pesquisa();

    var myModal = $modal(
      {
        scope: $scope,
        title: '',
        template: 'app/components/despesas/extrato-ne-modal.html',
        show: false
      });

    $scope.showModal = function(item) {
      DespesasService.listarExtratoNe(
        item.codigoUnidadeGestora, item.codigoGestao,
        item.anoNotaEmpenho, item.numeroNotaEmpenho)
        .then(
          function(response) {
            $scope.extrato = response.data;
            myModal.$promise.then(myModal.show);
          },
          function(erro) {

          }
      );
    };

    $scope.hideModal = function() {
      myModal.$promise.then(myModal.hide)
    };

    $scope.exportar = function() {
      RelatorioService.exportar('/despesa/relatorio/empenhado', $scope.item);
    }
  }

})();

(function() {
    'use strict';

    angular.module('portal').controller('DespesasDashboardController', Controller);

    /**
     * Controlador corresponde a tela que apresenta o dashboard de despesas.
     */
    /** @ngInject */
    function Controller($q, $timeout, $scope, $location, DespesasService, DataAtualizacaoService) {
        
        var vm = this;
        vm.$q = $q;
        vm.$timeout = $timeout;
        vm.$location = $location;
        vm.$scope = $scope;
        vm.DespesasService = DespesasService;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.obterDataDeAtualizacao = obterDataDeAtualizacao;
        vm.beforeLoadPanel = beforeLoadPanel;
        vm.buildPromiseSupplier = buildPromiseSupplier;
        vm.obterAnosDespesa = obterAnosDespesa;
        vm.onClickAnoLink = onClickAnoLink;
        vm.isAnoSelecionavel = isAnoSelecionavel;
        vm.getCurrentPanel = getCurrentPanel;
        vm.onDataSelectedEvoAnual = onDataSelectedEvoAnual;
        vm.onDataSelectedMaioresTipos = onDataSelectedMaioresTipos;
        vm.onDataSelectedMaioresGrupos = onDataSelectedMaioresGrupos;
        vm.onDataSelectedCategoriaEconomica = onDataSelectedCategoriaEconomica;
        vm.anosDespesaLoadPromise = vm.obterAnosDespesa().then(function(anos) {
            vm.anosDespesa = anos;

            if (vm.anoSelecionado == undefined) {
                vm.anoSelecionado = vm.anosDespesa[0];
            }
        });

        vm.obterDataDeAtualizacao().then(function(date) {
            vm.updateDate = date;
        });

        vm.panels = [
            ['panelEvoAnual', DespesasService, 'graficoEvolucao', onDataSelectedEvoAnual],
            ['panelEvoGrupo', DespesasService, 'buscarEvolucaoGrupoDespesas'],
            ['panelMaioresTipos', DespesasService, 'graficoTipoDespesa', onDataSelectedMaioresTipos],
            ['panelMaioresGrupos', DespesasService, 'graficoGrupo', onDataSelectedMaioresGrupos],
            ['panelCategoriaEconomica', DespesasService, 'graficoDespesasCategoriaEconomica', onDataSelectedCategoriaEconomica]
        ].map(function(panelIdAndData) {
            var panel = findPanelById(panelIdAndData[0], PANELS);
      
            panel.chartDataPromise = vm.buildPromiseSupplier(panel, panelIdAndData[1], panelIdAndData[2]);

            if (panelIdAndData[3] != undefined) {
                panel.onDataSelected = function() {
                    panelIdAndData[3].apply(vm, arguments);
                };
            }
      
            return panel;
        });
    }

    /**
     * Retorna uma promise para tarefas que precisão ser executadas antes de carregar um painel.
     * @param {*} panel Painel
     * @returns Promise.
     */
    function beforeLoadPanel(panel) {
        var delayPromise = this.$timeout(300);

        if (panel.isAnoSelecionavel) {
            return delayPromise.then(this.anosDespesaLoadPromise);
        }

        return delayPromise;
    }

    /**
     * Constrói um supplier para a promise de carregamento de um painel.
     * @param {*} panel Painel.
     * @param {*} service Serviço que fornece os dados do painel.
     * @param {*} method Método do serviço que fornece os dados.
     */
    function buildPromiseSupplier(panel, service, method) {
        var self = this;

        return function() {
            return self.beforeLoadPanel(panel).then(function() {
                return service[method](panel.isAnoSelecionavel ? self.anoSelecionado : undefined)
                    .then(function(resp) {
                        return {
                            data: {
                                anoSelecionado: self.anoSelecionado,
                                data: resp.data
                            }
                        };
                    });
            });
        };
    }

    /**
     * Obtem os anos em que dados de despesa foram contabilizados.
     * @returns Promise para a data.
     */
    function obterAnosDespesa() {
        return this.DespesasService.listarAno().then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Responde ao evento de seleção de um ano.
     * @param {*} ano Ano selecionado.
     */
    function onClickAnoLink(ano) {
        this.anoSelecionado = ano;

        var currentPanel = this.getCurrentPanel();

        if (currentPanel.isAnoSelecionavel) {
            currentPanel.reload();
        }

        this.panels.filter(function(panel) {
            return panel != currentPanel && panel.isAnoSelecionavel;
        }).forEach(function(panel) {
            panel.invalidadeLoad();
        });
    }

    /**
     * Diz se o ano é selecionável de acordo com o painel em exibição.
     * @returns true, ano pode ser selecionado; false, caso contrário.
     */
    function isAnoSelecionavel() {
        var panel = this.getCurrentPanel();

        if (panel) {
            return panel.isAnoSelecionavel;
        }

        return false;
    }

    /**
     * Obtem a data de atualização dos dados.
     * @returns Promise para a data.
     */
    function obterDataDeAtualizacao() {
        return this.DataAtualizacaoService.buscarDataAtualizacao('painel-despesas').then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de evolução anual.
     * @param {*} ano Ano da categoria.
     */
    function onDataSelectedEvoAnual(ano) {
        this.$location.path('/despesas/consulta-dinamica').search({
            anoExercicio: ano,
            colunas: ['nomeUnidadeGestora', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
        });
        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de maiores tipos de despesas.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedMaioresTipos(categoria) {
        this.$location.path('/despesas/consulta-dinamica').search({
            anoExercicio: this.anoSelecionado,
            nomeTipoLicitacao: categoria.dataLabel,
            colunas: ['nomeTipoLicitacao', 'nomeUnidadeGestora', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
        });
        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de maiores grupos de despesas.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedMaioresGrupos(categoria) {
        this.$location.path('/despesas/consulta-dinamica').search({
            anoExercicio: this.anoSelecionado,
            nomeGrupoNatureza: categoria,
            colunas: ['nomeGrupoNatureza', 'nomeElemento', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
        });
        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de categoria econômica.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedCategoriaEconomica(categoria) {
        this.$location.path('/despesas/consulta-dinamica').search({
            anoExercicio: this.anoSelecionado,
            listaCodigoCategoriaEconomica: categoria,
            colunas: ['nomeUnidadeGestora', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
        });
        this.$scope.$apply();
    }

    /**
     * Obtem o corrente painel em exibição.
     */
    function getCurrentPanel() {
        if (this.panels && this.panels.length > 0) {
            return this.panels.filter(function(panel) {
                return panel.current == true;
            })[0];
        }

        return undefined;
    }

    /**
     * Obtem o painel correspondente a um ID.
     * @param {*} panelId ID.
     * @param {*} panels Paineis.
     * @returns Panel correspondente; undefined, caso o mesmo não seja encontrado.
     */
    function findPanelById(panelId, panels) {
        return panels.filter(function(panel) {
            return panel.id == panelId;
        })[0];
    }

    var PANELS = [
        {
            id: 'panelEvoAnual',
            chartType: 'evolution-chart',
            isAnoSelecionavel: false,
            current: true,
            initial: true,
            title: 'Evolução Anual da Despesa',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function() {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function(serviceData) {
                var chartColors = ['#84878c', '#265bf7', '#FFD200', '#50597B', '#229396', '#65A0CE', '#0E7ECA', '#1ED6D6', '#4CAF50'];
                var panel = this;

                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartEvoAnual',
                    chartHeight: 300,
                    minScaleValue: 0,
                    useBySideTooltipPosition: true,
                    fnTickSequenceBy: function() { return 5; },
                    fnFormatData: function(v) { return 'R$ ' + parseInt(v) + ' bilhões'; },
                    fnFormatTooltip: function(v) { return 'R$ ' + v.toFixed(1) + ' bilhões'; },
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnDataClickListener: function(v, d) { panel.onDataSelected(v, d); },
                    dimentions: Object.keys(data).filter(function(key) {
                        return key != 'categoria';
                    }).map(function(key) {
                        return data[key];
                    }).map(function(dimentionData, index) {
                        return {
                            type: 'area',
                            label: dimentionData[0],
                            color: chartColors[index % chartColors.length],
                            data: data.categoria.map(function(ano, index) {
                                return [ano, dimentionData[index + 1] / 1000000000];
                            })
                        };
                    })
                };
            }
        },{
            id: 'panelEvoGrupo',
            chartType: 'evolution-chart',
            isAnoSelecionavel: false,
            current: false,
            initial: false,
            title: 'Evolução do Grupo de Despesa - Pessoal e Encargos Sociais *',
            bottomNote: '* - Nas despesas com pessoal e encargos sociais não estão inseridos os valores referentes à Segurança Pública, pagos pela União com recurso do Fundo Constitucional.',
            chartDataPromise: undefined,
            onDataSelected: function() {},
            destroy: function() {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function(serviceData) {
                var chartColors = ['#1ED6D6'];
                var panel = this;

                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartEvoGrupo',
                    chartHeight: 300,
                    minScaleValue: 0,
                    fnTickSequenceBy: function() { return 3; },
                    fnFormatData: function(v) { return 'R$ ' + parseInt(v) + ' bilhões'; },
                    fnFormatTooltip: function(v) { return 'R$ ' + v.toFixed(1) + ' bilhões'; },
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnDataClickListener: function(v, d) { panel.onDataSelected(v, d); },
                    dimentions: [
                        {
                            label: 'despesas',
                            color: chartColors[0 % chartColors.length],
                            data: data.categoria.map(function(ano, index) {
                                return [ano, data.colunas[0][index + 1] / 1000000000];
                            })
                        }
                    ]
                };
            }
        },{
            id: 'panelMaioresTipos',
            chartType: 'bar-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: '5 Maiores Tipos de Despesa',
            panelTitle: '5 Maiores Tipos de Despesa',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function() {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function(serviceData) {
                var chartColors = ['#1ED6D6', '#0E7ECA', '#65A0CE', '#229396', '#50597B'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;
                var data = serviceData.data;
      
                this.chartModel = {
                    chartId: 'chartMaioresTipos',
                    chartHeight: 300,
                    fnFormatData: formatData,
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnDataClickListener: function(v) { panel.onDataSelected(v); },
                    dimentions: data.categorias.map(function(cat, index) {
                        return {
                            dataLabel: cat,
                            color: chartColors[index % chartColors.length],
                            data: data.colunas[index + 1]
                        };
                    })
                };
            }
        },{
            id: 'panelMaioresGrupos',
            chartType: 'area-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: '5 Maiores Grupos',
            panelTitle: '5 Maiores Grupos',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            loadHideContent: true,
            destroy: function() {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function(serviceData) {
                var chartColors = ['#1ED6D6', '#1F7DC0', '#65A0CE', '#229396', '#50597B', '#FFD200', '#D14C39', '#E64C65'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;
                var data = serviceData.data;
        
                this.chartModel = {
                    chartId: 'chartMaioresGrupos',
                    chartHeight: 340,
                    fnFormatData: function(ratio) { return (ratio * 100).toFixed(1).toString().replace('.', ','); },
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnChartShow: function() { panel.onShow(); },
                    fnDataClickListener: function(v) { panel.onDataSelected(v); },
                    dimentions: data.map(function(d, index) {
                        return {
                            dataLabel: d[0].toLowerCase(),
                            data: d[1],
                            color: chartColors[index % chartColors.length]
                        };
                    })
                };
            }
        },{
            id: 'panelCategoriaEconomica',
            chartType: 'multi-gauge-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: 'Categoria Econômica',
            panelTitle: 'Categoria Econômica',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function() {
                if (this.chartModel) {
                    if (this.chartModel.charts) {
                        this.chartModel.charts.forEach(function(c) {
                            c.chart.destroy();
                        });
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.charts) {
                    this.chartModel.charts.forEach(function(c) {
                        c.chart.flush();
                    });
                }
            },
            buildModel: function(serviceData) {
                var chartColors = ['#1ED6D6'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;

                this.chartModel = {
                    charts: [{
                        chartId: 'chartCategoriaCorrentes',
                        legend: 'despesas correntes',
                        dataLabel: 'Despesas correntes',
                        data: serviceData.data.corrente,
                        categoria: 3
                    },{
                        chartId: 'chartCategoriaCapital',
                        legend: 'despesas de capital',
                        dataLabel: 'Despesas de capital',
                        data: serviceData.data.capital,
                        categoria: 4
                    }].map(function(props) {
                        return {
                            chartId: props.chartId,
                            chartHeight: 170,
                            chartWidth: 250,
                            legend: props.legend,
                            fnChartBuild: function(chart) { this.chart = chart; },
                            fnDataClickListener: function(v) { panel.onDataSelected(props.categoria); },
                            dimentions: [{
                                dataLabel: props.dataLabel,
                                color: chartColors[0],
                                data: props.data
                            }]
                        };
                    })
                };
            }
        }
    ];

    /**
     * Formata um valor a ser exibido no gráfico de um painel.
     * @param {*} v Valor.
     * @param {*} containerWidth Largura do container de conteúdo do painel.
     * @returns String referente ao valor a ser exibido.
     */
    function formatData(v, containerWidth) {
        if (v == 0) {
            return '0';
        }

        var mask = 'coinSimbol value desc';

        if (containerWidth) {
            if (containerWidth <= 500) {
                mask = 'value descShort';
            } else if (containerWidth <= 600) {
                mask = 'coinSimbol value descShort';
            }
        }

        var numberDesc = [
            {
                desc: 'bilhões',
                descSingle: 'bilhão',
                descShort: 'bi',
                value: 1000000000,
                divisor: 1000000000
            },{
                desc: 'milhões',
                descSingle: 'milhão',
                descShort: 'mi',
                value: 1,
                divisor: 1000000
            }
        ];

        var desc = numberDesc.filter(function(desc) {
            return v >= desc.value;
        })[0];
        v = v / desc.divisor;

        var coinSimbol = 'R$';
        var value = String(v % parseInt(v) == 0 ? v : v.toFixed(1));
        var numberDescrition = v >= 2 ? desc.desc : desc.descSingle;
        var numberDescritionShort = desc.descShort;

        return mask.replace('coinSimbol', coinSimbol)
            .replace('value', value)
            .replace('descShort', numberDescritionShort)
            .replace('desc', numberDescrition);
    }

})();
(function () {
  'use strict';

  angular.module('portal').service('DespesasService', DespesasService);

  /** @ngInject */
  function DespesasService($http, api) {
    var service = {};
    var serviceConfig = { cache: true };
    var storedData;

    service.recuperarDadosAdm = function () {
      return $http({
        url: api.url + '/despesa/adm-regionais',
        method: 'GET'
      });
    };

    service.recuperarDadosLiquidado = function () {
      return $http({
        url: api.url + '/despesa/liquidado-adm',
        method: 'GET'
      });
    };

    service.buscarEvolucaoGrupoDespesas = function () {
      return $http({
        url: api.url + '/despesa/grafico/grupo-despesa/',
        method: 'GET',
        cache: true
      });
    };

    service.listarAnosPagamentosPorCredor = function () {
      return $http.get(api.url + '/despesa/pagamentos-por-credor/anos', serviceConfig);
    };

    service.pesquisarPorAcaoEmpenhado = function (despesa) {
      return $http({
        url: api.url + '/despesa/porAcao/empenhado/' + despesa.codigoProjeto,
        method: 'GET',
        params: {}
      });
    };

    service.recuperarDespesasAtuais = function (ano) {
      if (ano == undefined) {
        ano = new Date().getFullYear();
      }

      return $http({
        url: api.url + '/despesa/grafico/treemap/' + ano,
        method: 'GET',
        cache: true
      });
    };

    service.graficoTreemapSubfuncao = function (funcao, ano) {
      if (ano == undefined) {
        ano = new Date().getFullYear();
      }

      return $http({
        url: api.url + '/despesa/grafico/treemap/subfuncao/',
        method: 'GET',
        params: { ano: ano, funcao: funcao },
        cache: true
      });
    };

    service.listarExtratoNotaEmpenho = function (obj) {
      return $http({
        url: api.url + '/despesa/nota-empenho/extrato',
        method: 'GET',
        params: obj
      });
    };

    service.listarSubitemDespesa = function (obj) {
      return $http({
        url: api.url + '/despesa/nota-empenho/subitem',
        method: 'GET',
        params: obj
      });
    };

    service.listarDetalhamentoPorProjeto = function (obj) {
      return $http({
        url: api.url + '/despesa/detalhamento/' + obj.anoExercicio + '/' + obj.codigoUnidadeGestora,
        method: 'GET',
        params: obj
      });
    };

    service.listarDetalhamentoPorProjetoSubitem = function (obj) {
      return $http({
        url: api.url + '/despesa/detalhamento/subitem',
        method: 'GET',
        params: obj
      });
    };

    service.listarExecucaoEmendasPorSubtitulo = function (obj) {
      return $http({
        url: api.url + '/despesa/execucao-emendas/' + obj.anoExercicio + '/' + obj.codigoUnidadeGestora,
        method: 'GET',
        params: obj
      });
    };

    service.listarExecucaoOcaPorSubtitulo = function (obj) {
      return $http({
        url: api.url + '/despesa/oca/' + obj.anoExercicio + '/' + obj.codigoUnidadeGestora,
        method: 'GET',
        params: obj
      });
    };

    service.listarAnosOca = function () {
      return $http({
        url: api.url + '/despesa/oca/anos',
        method: 'GET'
      });
    };

    service.listarNotasLancamentoPorNeOriginal = function (obj) {
      return $http({
        url: api.url + '/despesa/nota-empenho/notas-lancamento',
        method: 'GET',
        params: obj
      });
    };

    service.listarOrdemBancariaPorNeOriginal = function (obj) {
      return $http({
        url: api.url + '/despesa/nota-empenho/ordem-bancaria',
        method: 'GET',
        params: obj
      });
    };

    service.store = function (data) {
      storedData = data;
    };

    service.getStored = function () {
      var data = storedData;
      storedData = null;
      return data;
    };

    service.listarFiltros = function (exercicio) {
      return $http({
        url: api.url + '/despesa/filtros',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarFiltrosCovid = function (exercicio) {
      return $http({
        url: api.url + '/despesa/filtrosCovid',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarFiltrosCovidAuxUni = function (exercicio) {
      return $http({
        url: api.url + '/despesa/filtrosCovidAuxUni',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarFiltrosEmendasParlamentares = function (exercicio) {
      return $http({
        url: api.url + '/despesa/emendas-parlamentares/filtros',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarUnidadeGestora = function (exercicio) {
      return $http({
        url: api.url + '/despesa/unidadeGestora',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarGestao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/gestao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarEsfera = function (exercicio) {
      return $http({
        url: api.url + '/despesa/esfera',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarFuncao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/funcao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarSubFuncao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/subfuncao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarPrograma = function (exercicio) {
      return $http({
        url: api.url + '/despesa/programa',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarModalidadeLicitacao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/modalidadeLicitacao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarCategoriaEconomica = function () {
      return $http.get(api.url + '/despesa/categoria-economica', serviceConfig);
    };

    service.listarGrupoNatureza = function (exercicio) {
      return $http({
        url: api.url + '/despesa/grupo-natureza',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarModalidadeAplicacao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/modalidade-aplicacao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarElemento = function (exercicio) {
      return $http({
        url: api.url + '/despesa/elemento',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarAno = function () {
      return $http.get(api.url + '/despesa/anos', serviceConfig);
    };

    service.listarAutores = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/autor', serviceConfig)
    }

    service.listarDetalhamentoDespesaUnidadeGestora = function (exercicio) {
      return $http({
        url: api.url + '/despesa/detalhamento/unidade-gestora',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarDetalhamentoDespesaGestao = function (exercicio) {
      return $http({
        url: api.url + '/despesa/detalhamento/gestao',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarExecucaoOcaUnidadesGestoras = function (exercicio, mesReferencia) {
      return $http({
        url: api.url + '/despesa/oca/unidades-gestoras',
        method: 'GET',
        params: {
          exercicio: exercicio,
          mesReferencia: mesReferencia
        }
      })
    };

    service.listarExecucaoOcaGestao = function (exercicio, mesReferencia) {
      return $http({
        url: api.url + '/despesa/oca/gestoes',
        method: 'GET',
        params: {
          exercicio: exercicio,
          mesReferencia: mesReferencia
        }
      })
    };

    service.listarCategoriasQdd = function (exercicio) {
      return $http({
        url: api.url + '/despesa/emendas-parlamentares/categoria',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };

    service.listarDetalhamentoDespesaAno = function () {
      return $http.get(api.url + '/despesa/detalhamento/ano', serviceConfig);
    };

    service.listarAnosEmendasParlamentares = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/anos', serviceConfig);
    };

    service.listarElementoQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/elemento', serviceConfig);
    };

    service.listarFontesQdd = function (exercicio) {
      return $http({
        url: api.url + '/despesa/emendas-parlamentares/fonte',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    };


    service.listarFontesEmendas = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/fonteEmendas', serviceConfig);
    };


    service.listarFuncoesQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/funcao', serviceConfig);
    };

    service.listarSubfuncoesQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/subfuncao', serviceConfig);
    };

    service.listarGruposQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/grupo', serviceConfig);
    };

    service.listarModalidadeAplicacaoQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/modalidade-aplicacao', serviceConfig);
    };

    service.listarProgramasQdd = function () {
      return $http.get(api.url + '/despesa/emendas-parlamentares/programa', serviceConfig);
    };

    service.listarAnosDiariasPassagens = function () {
      return $http.get(api.url + '/despesa/diarias-passagens/anos', serviceConfig);
    };

    service.listarUnidadesGestorasDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/unidades-gestoras',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarElementosDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/elementos',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarSubElementosDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/sub-elementos',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarGestoesDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/gestoes',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarEsferasDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/esferas',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarTiposDespesaDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/tipos-despesa',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarFuncoesDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/funcoes',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarSubFuncoesDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/subfuncoes',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarProgramasDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/programas',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarCategoriasEconomicasDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/categorias-economicas',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarGruposDespesaDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/grupos-despesa',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarModalidadesAplicacoesDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/modalidades-aplicacoes',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarFontesRecursoDiariasPassagens = function (exercicio) {
      return $http({
        url: api.url + '/despesa/diarias-passagens/fontes-recurso',
        method: 'GET',
        params: {
          exercicio: exercicio
        }
      })
    }

    service.listarSubitemPorElemento = function (listaSubitem) {
      var list = listaSubitem.join(", ")
      return $http.post(api.url + '/despesa/diarias-passagens/subitemPorElemento', list, serviceConfig);
    };

    service.listarRestosAPagarAnos = function () {
      return $http.get(api.url + '/despesa/restos-a-pagar/anos', serviceConfig);
    };

    service.graficoEvolucao = function () {
      return $http.get(api.url + '/despesa/grafico/evolucao', serviceConfig);
    };

    service.graficoFuncao = function (ano) {
      if (!ano) ano = new Date().getFullYear();
      return $http.get(api.url + '/despesa/grafico/funcao/' + ano, serviceConfig);
    };

    service.graficoGrupo = function (ano) {
      if (!ano) ano = new Date().getFullYear();
      return $http.get(api.url + '/despesa/grafico/grupo/' + ano, serviceConfig);
    };

    service.graficoTipoDespesa = function (ano) {
      if (!ano) ano = new Date().getFullYear();
      return $http.get(api.url + '/despesa/grafico/tipodespesa/' + ano, serviceConfig);
    };

    service.graficoEvolucaoDespesasReceitas = function () {
      return $http.get(api.url + '/despesa/grafico/receitas-despesas', serviceConfig);
    };

    service.graficoEvolucaoFuncao = function () {
      return $http.get(api.url + '/despesa/grafico/evolucao-funcao', serviceConfig);
    };

    service.listarNotasEmpenhoPorOrdemBancaria = function (params) {
      return $http({
        url: api.url + '/despesa/nota-empenho/por-ordem-bancaria',
        method: 'GET',
        params: params
      });
    };

    service.listarNotasLancamentoPorOrdemBancaria = function (params) {
      return $http({
        url: api.url + '/despesa/nota-lancamento/por-ordem-bancaria',
        method: 'GET',
        params: params
      });
    };

    service.listarNotasEmpenhoPorNotaLancamento = function (params) {
      return $http({
        url: api.url + '/despesa/nota-empenho/por-nota-lancamento',
        method: 'GET',
        params: params
      });
    };

    service.listarNotasEmpenhoPorNotaLancamentoDetalheNL = function (params) {
      return $http({
        url: api.url + '/despesa/nota-empenho/por-nota-lancamento-detalhe-nl',
        method: 'GET',
        params: params
      });
    };

    service.listarDescricaoNotaEmpenho = function (params) {
      return $http({
        url: api.url + '/despesa/descricao',
        method: 'GET',
        params: params
      });
    };

    service.listarNotaFiscalNotaEmpenho = function (params) {
      return $http({
      url: api.url + '/despesa/nota-fiscal',
      method: 'GET',
      params: params
      });
    };

    service.recuperarNotaEmpenho = function (params) {
      return $http({
        url: api.url + '/despesa/nota-empenho/'
          + params.anoNotaEmpenho + '/'
          + params.codigoGestao + '/'
          + params.codigoUnidadeGestora + '/'
          + params.numeroNotaEmpenho,
        method: 'GET'
      });
    };

    service.recuperarNotaLancamento = function (params) {
      return $http({
        url: api.url + '/despesa/nota-lancamento/'
          + params.ano + '/'
          + params.codigoGestao + '/'
          + params.codigoUnidadeGestora + '/'
          + params.notaLancamento + '/'
          + params.numeroNotaEmpenho,
        method: 'GET'
      });
    };

    service.recuperarNotaLancamentoOB = function (params) {
      return $http({
        url: api.url + '/despesa/nota-lancamento-ob/'
          + params.ano + '/'
          + params.codigoGestao + '/'
          + params.codigoUnidadeGestora + '/'
          + params.notaLancamento,
        method: 'GET'
      });
    };

    service.recuperarOrdemBancaria = function (params) {
      return $http({
        url: api.url + '/despesa/ordem-bancaria/'
          + params.ano + '/'
          + params.codigoGestao + '/'
          + params.codigoUnidadeGestora + '/'
          + params.ordemBancaria,
        method: 'GET'
      });
    };

    service.listarOrdemBancariaGestaoNl = function () {
      return $http({
        url: api.url + '/despesa/ordem-bancaria/gestoes-nl',
        method: 'GET'
      })
    }

    service.graficoDespesasCategoriaEconomica = function (exercicio) {
      if (!exercicio) exercicio = new Date().getFullYear();
      return $http({
        url: api.url + '/despesa/grafico/percentual/categoria-economica',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.listarEventosNotaLancamento = function (obj) {
      return $http({
        url: api.url + '/despesa/nota-lancamento/eventos',
        method: 'GET',
        params: obj
      });

    };
    service.listarOrdemCancelamentoPorOB = function (obj) {
      return $http({
        url: api.url + '/despesa/ordens-cancelamento',
        method: 'POST',
        params: obj
      });
    }

    service.listarPrioridades = function () {
      return $http({
        method: 'GET',
        url: api.url + '/despesa/prioridades'
      });
    }

    service.listarParlamentaresFederais = function () {
      return $http.get(api.url + '/despesa/emenda-parlamentar-federal/parlamentares', {
        params: { size: 10000 },
        cache: true
      });
    };

    service.listarOrgaosExecutoresFederais = function () {
      return $http.get(api.url + '/despesa/emenda-parlamentar-federal/orgaos-executores', {
        params: { size: 10000 },
        cache: true
      });
    };

    return service;
  }


})();

(function () {
  'use strict';

  angular.module('portal').controller('DetalhamentoDespesaCtrl', DetalhamentoDespesaCtrl);

  /** @ngInject */
  function DetalhamentoDespesaCtrl($location, $scope, ano,
                                   $aside, DespesasService, PagingService, RelatorioService, dataAtualizacao) {

    var vm = this;
    vm.ano = ano.data;
    vm.exibirTabelaAgrupadora = true;
    vm.listaSubitem = [];
    var codigoUnidadeGestoraSelecionado = {};
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nomeUnidadeGestora: {nome: "Unid. Gestora", visible: true, termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos"},
      valorLei: {nome: "Aprovado", visible: true, currency: true, termo:"Valor do orçamento inicial fixado pela Lei Orçamentária Anual"},
      valorAlteracao: {nome: "Alteração", visible: true, currency: true, termo:"Acréscimo e ou dedução realizada"},
      valorMovimentacao: {nome: "Movimentação", visible: true, currency: true, termo:"Valor realocado para outro programa de trabalho"},
      valorBloqueado: {nome: "Bloqueado", visible: true, currency: true, termo:"Indisponibilidade de uma dotação para movimentação e empenho"},
      valorDespesaAutorizada: {nome: "Autorizado", visible: true, currency: true, termo:"Valores disponíveis para a execução da despesa"},
      valorEmpenhado: {nome: "Empenhado", visible: true, currency: true, termo:"Valor reservado para pagamento de um produto ou serviço"},
      valorLiquidado: {nome: "Liquidado", visible: true, currency: true, termo:"Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado"},
    };

    vm.unidadeGestora = [];
    vm.gestao = [];

    vm.carregarFiltros = carregarFiltros;

    function carregarFiltros(exercicio) {
        DespesasService.listarDetalhamentoDespesaUnidadeGestora(exercicio)
            .then(function(response){
                vm.unidadeGestora = response.data;
            });

        DespesasService.listarDetalhamentoDespesaGestao(exercicio)
            .then(function(response){
                vm.gestao = response.data;
            });
    }

    $scope.colunas = colunas;
    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // settings
    vm.settings = {
      singular: 'Detalhamento da Despesa',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo: 'csv',
      anoExercicio: vm.ano[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/despesa/detalhamento',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/detalhamento-despesa-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = true;
      vm.item.anoExercicio = vm.ano[0];
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);

      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function(params) {
      var assignProps = function(propsArray, fromObj, toObj) {
        propsArray.forEach(function(prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return elem[compareProp] == param; })[0];

          if (element != null) {
            modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
          }
        }
      };

      assignProps([{from:'exercicio', to:'anoExercicio', type:String}], params, vm.item);
      assignSelect(vm.unidadeGestora, vm.item, 'codigosUg', params['orgao'], 'nome', 'codigo', true);
    };

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        linha.anoExercicio = vm.data.form.anoExercicio;
        DespesasService.listarDetalhamentoPorProjeto(linha).then(
          function (response) {
            //$scope.dadosDetalhamento = removeDuplicated(response.data);
            $scope.dadosDetalhamento = response.data;
            vm.unidadeGestoraSelecionada = linha.nomeUnidadeGestora;
            codigoUnidadeGestoraSelecionado = linha.codigoUnidadeGestora;
            vm.exibirTabelaAgrupadora = false;
          }
        );
      }
    };

    var removeDuplicated = function (collection) {
      var unremovedItens = [];
      var index = 1;
      unremovedItens[0] = collection[0];
      for (var i = 1; i < collection.length; i++) {
        if (collection[i].nomePrograma != collection[i - 1].nomePrograma) {
          unremovedItens[index++] = collection[i];
        }
      }
      return unremovedItens;
    };


    vm.voltar = function () {
      delete $scope.dadosDetalhamento;
      vm.exibirTabelaAgrupadora = true;
      search();
    }

    vm.exibirFormPesquisa = function () {
      carregarFiltros(vm.item.anoExercicio);
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    var search = function () {
      if (!vm.exibirTabelaAgrupadora) {
        vm.voltar();
      }
      vm.data.content = [];
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      hideForm();
    };

    vm.search = search;

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.nomeUnidadeGestora = vm.unidadeGestoraSelecionada;
        vm.item.colunas = colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/detalhamento', vm.item);
      }
    };

    $scope.exportarSub = function () {
      if (codigoUnidadeGestoraSelecionado) {
        vm.item.nomeUnidadeGestora = vm.unidadeGestoraSelecionada;
        vm.item.codigoUnidadeGestora = codigoUnidadeGestoraSelecionado;
        vm.item.colunas = {
          nomePrograma: {nome: "Unidade Gestora", visible: true},
          nomeSubtitulo: {nome: "Programa de Trabalho", visible: true},
          nomeEsfera: {nome: "Esfera", visible: true},
          nomeNatureza: {nome: "Natureza", visible: true},
          nomeFonte: {nome: "Fonte", visible: true},
          valorLei: {nome: "Lei", visible: true, currency: true},
          valorAlteracao: {nome: "Alteração", visible: true, currency: true},
          valorMovimentacao: {nome: "Movimentação", visible: true, currency: true},
          valorBloqueado: {nome: "Bloqueado", visible: true, currency: true},
          valorDespesaAutorizada: {nome: "Despesa Autorizada", visible: true, currency: true},
          valorEmpenhado: {nome: "Empenhado", visible: true, currency: true},
          valorLiquidado: {nome: "Liquidado", visible: true, currency: true}
        }

        RelatorioService.exportar('/despesa/relatorio/detalhe-detalhamento', vm.item);
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function () {
      formTpl.hide();
    };

    vm.expandCallback = function (index) {

      var valorLinha = $scope.dadosDetalhamento[index];

      var obj = {
        codigoUnidadeGestora: codigoUnidadeGestoraSelecionado,
        anoExercicio: vm.item.anoExercicio,
        nomePrograma: valorLinha.nomeSubtitulo
      };

      DespesasService.listarDetalhamentoPorProjetoSubitem(obj).then(
        function (response) {
          vm.listaSubitem = response.data;
          vm.subtotalValorLei = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorLei
          }, 0);
          vm.subtotalValorAlteracao = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorAlteracao
          }, 0);
          vm.subtotalValorMovimentacao = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorMovimentacao
          }, 0);
          vm.subtotalValorBloqueado = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorBloqueado
          }, 0);
          vm.subtotalValorDespesaAutorizada = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorDespesaAutorizada
          }, 0);
          vm.subtotalValorEmpenhado = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorEmpenhado
          }, 0);
          vm.subtotalValorLiquidado = _.reduce(vm.listaSubitem, function (memo, obj) {
            return memo + obj.valorLiquidado
          }, 0);
        }
      );
    };

    $scope.$on('$destroy', function () {
      hideForm();
    });
  }
})();

(function () {
    'use strict';
  
    angular.module('portal.despesa').controller('NotaEmpenhoEmendasParlamentaresController', NotaEmpenhoEmendasParlamentaresController);
  
    /** @ngInject */
    function NotaEmpenhoEmendasParlamentaresController($scope, $modal, $aside, $location, $alert, unidadesGestoras,
                                   DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {
  
      var vm = this;

      var currentModal, backModal;
  
      var storedObj;
      var filtroOrigem;
      vm.dataAtualizacao = dataAtualizacao;
  
      var colunas = {
        numeroNotaEmpenho: {nome: "Nota Empenho", visible: true, disabled: true, termo: "Nº do documento utilizado para formalizar o comprometimento da despesa"},
        dataEmissao: {nome: "Emissão", visible: true, date: true, termo: "Data em que o comprometimento da despesa foi registrado"},
        nomeUnidadeGestora: {nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos"},
        nomeGestao: {nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos"},
        nomeEsfera: {nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais"},
        processo: {nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa"},
        nomeModalidadeLicitacao: {nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa"},
        nomeProgramaTrabalho: {nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo"},
        nomeFuncao: {nome: "Função", visible: false, termo: "Área de atuação da Administração Pública"},
        nomeSubfuncao: {nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação "},
        nomePrograma: {nome: "Programa", visible: false, termo: "Instrumento de atuação governamental, formado por um conjunto de ações "},
        nomeProjeto: {nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa"},
        nomeSubtitulo: {nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária"},
        nomeCategoriaEconomica: {nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico"},
        nomeNaturezaDespesa: {nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto"},
        nomeModalidadeAplicacao: {nome: "Modalidade de Aplicação", visible: false, termo: "Forma de aplicação dos recursos: diretamente ou por transferência a outras entidades "},
        nomeElementoDespesa: {nome: "Elemento", visible: false, termo: "Indica os objetos de gastos"},
        nomeFonteRecurso: {nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas"},
        codigoCredor: {nome: "CNPJ/CPF", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública"},
        nomeCredor: {nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública"},
        valorNeFinal: {nome: "Valor Final", visible: true, currency: true, termo: "Valor reservado para pagamento pela prestação ou entrega do serviço após os reforços e anulações"}
      };
  
      $scope.colunas = colunas;
  
      // settings
      vm.settings = {
        singular: 'Nota de Empenho',
        plural: 'Notas de Empenho'
      };
  
      vm.item = {
        busy: true,
        editing: true,
        colunas: $scope.colunas,
        dataAtualizacao: new Date(vm.dataAtualizacao.data)
      };
  
      vm.unidadesGestoras = unidadesGestoras.data;
  
      $scope.dados = {
        form: {
          tipo: 'pdf'
        }
      };

      var data = {
        url: '/despesa/emendas-parlamentares/nota-empenho',
        form: vm.item,
        settings: vm.settings,
        content: [],
        totalElements: 0,
        last: true
      };

      vm.data = data;
  
      var formTpl = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-filtro.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });

      var formDetalhamento = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-detalhamento.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });

      var extratoNeTemplate = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-modal.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });

      var subitemNeTemplate = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/subitem-ne-modal.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });

      var execucaoNeTemplate = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/execucao-ne-modal.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });

      var descricaoNeTemplate = $aside({
        scope: $scope,
        template: 'app/components/despesas/despesas-por-agrupador/descricao-ne-modal.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
      });
  
      vm.cancelar = function () {
        vm.item = storedObj;
        vm.item.editing = true;
        vm.item.busy = false;
      };
  
      vm.exibirFormPesquisa = function () {
        vm.item.editing = true;
        vm.settings.cmd = 'Pesquisar';
        showForm();
      };
  
      vm.visualizarItem = function (linha) {
        DespesasService.recuperarNotaEmpenho(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormDetalhamento();
          }
        );
      };

      var hideCurrentModal = function() {
        if(currentModal) {
            currentModal.hide();
            backModal = currentModal;
        }
      };

      vm.backCurrentModal = function() {
          if(backModal) {
            backModal.show();
            backModal = undefined;
          }
      }
  
      vm.exibirModalExtratoNotaEmpenho = function (item) {
  
        var reqObj = {
          anoNotaEmpenho: item.anoNotaEmpenho,
          codigoUnidadeGestora: item.codigoUnidadeGestora,
          codigoGestao: item.codigoGestao,
          numeroNotaEmpenho: item.numeroNotaEmpenho
        };
  
        DespesasService.listarExtratoNotaEmpenho(reqObj).then(
          function (response) {
            if (response.data.length == 0) {
              $alert({
                content: 'Não há notas de empenho vinculadas',
                type: 'info'
              });
              return;
            }
  
            vm.extratoAnual = response.data;
            vm.extratoTotal = _.reduce(vm.extratoAnual, function (memo, obj) {
              return memo + obj.valorNe
            }, 0);

            hideCurrentModal();
            extratoNeTemplate.show();
          },
          function () {
            $alert({
              content: 'Erro ao recuperar dados para o extrato',
              type: 'info'
            });
          }
        );
      };
  
      vm.exibirModalSubitemNotaEmpenho = function (item) {
  
        var reqObj = {
          anoNotaEmpenho: item.anoNotaEmpenho,
          codigoUnidadeGestora: item.codigoUnidadeGestora,
          codigoGestao: item.codigoGestao,
          numeroNotaEmpenho: item.numeroNotaEmpenho
        };
  
        DespesasService.listarSubitemDespesa(reqObj).then(
          function (response) {
            if (response.data.length == 0) {
              $alert({
                content: 'Não há subitens para essa nota de empenho',
                type: 'info'
              });
              return;
            }
  
            vm.subitemsDespesa = response.data;
            vm.subitemsDespesaTotal = _.reduce(vm.subitemsDespesa, function (memo, obj) {
              return memo + obj.valor
            }, 0);

            hideCurrentModal();
            subitemNeTemplate.show();
          },
          function () {
            $alert({
              content: 'Erro ao recuperar subitens',
              type: 'info'
            });
          }
        );
      };
  
      vm.exibirModalExecucaoNotaEmpenho = function (item) {
  
        var reqObj = {
          anoNotaEmpenho: item.anoNotaEmpenho,
          codigoUnidadeGestora: item.codigoUnidadeGestora,
          codigoGestao: item.codigoGestao,
          numeroNotaEmpenho: item.numeroNotaEmpenho
        };
  
        DespesasService.listarNotasLancamentoPorNeOriginal(reqObj).then(
          function (response) {
            vm.notasLancamento = response.data;
            vm.notasLancamentoTotal = _.reduce(vm.notasLancamento, function (memo, obj) {
              return memo + obj.valorFinal
            }, 0);
            
            hideCurrentModal();
            execucaoNeTemplate.show();
          },
          function () {
            $alert({
              content: 'Erro ao recuperar as notas de lançamento na execução da nota de empenho',
              type: 'info'
            });
          }
        );
  
        DespesasService.listarOrdemBancariaPorNeOriginal(reqObj).then(
          function (response) {
            vm.ordensBancarias = response.data;
            vm.ordensBancariasTotal = _.reduce(vm.ordensBancarias, function (memo, obj) {
              return memo + obj.valorFinal
            }, 0);
          },
          function () {
            $alert({
              content: 'Erro ao recuperar as ordens bancárias na execução da nota de empenho',
              type: 'info'
            });
          }
        );
  
      };
  
      vm.exibirModalDescricaoNotaEmpenho = function (item) {
        var reqObj = {
          numeroNotaEmpenho: item.numeroNotaEmpenho,
          codigoUnidadeGestora: item.codigoUnidadeGestora,
          anoNotaEmpenho: item.anoNotaEmpenho,
          codigoGestao: item.codigoGestao
        };
  
        DespesasService.listarDescricaoNotaEmpenho(reqObj).then(
          function (response) {
            if (response.data.length == 0) {
              $alert({
                content: 'Não há descrições vinculadas',
                type: 'info'
              });
              return;
            }
  
            vm.listaDescricao = response.data;
            vm.listaDescricaoTotal = _.reduce(vm.listaDescricao, function (memo, obj) {
              return memo + obj.valorTotal
            }, 0);
  
            hideCurrentModal();
            descricaoNeTemplate.show();
          },
          function () {
            $alert({
              content: 'Erro ao recuperar as descrições da nota de empenho',
              type: 'info'
            });
          }
        );
      };
  
      vm.init = function () {
        //vm.data.content = [];
        
        vm.item.page = 0;
        vm.item.padrao = false;

        storedObj = ScopeService.getStored();

        var obj = $location.search();
        if (obj.anoNotaEmpenho) {
          vm.item = obj;
          filtroOrigem = storedObj.filtroOrigem;
          filtroOrigem.url = storedObj.url;
          vm.applyFilters();      
          vm.search();
        }
      };
  
      vm.applyFilters = function () {
        var fn = function (item, dados) {
          if (item) {
            var codigo = '';
            if (Array.isArray(dados)) {
              dados.forEach(function (dado) {
                if (dado.nome == item || dado.codigo == item) {
                  codigo = [dado.codigo];
                }
              });
            } else {
              codigo = [item];
            }
            return codigo;
            
          }
        }
        vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
      };
  
      var extend = function (obj, src) {
        for (var key in src) {
          if (src.hasOwnProperty(key)) obj[key] = src[key];
        }
        return obj;
      };
  
      vm.voltar = function () {
        $rootScope.filter = filtroOrigem;
        $location.path(filtroOrigem.url).search(filtroOrigem);
      };
  
      vm.search = function () {
        //vm.data.content = [];
        vm.item.page = 0;
        vm.item.padrao = false;
        vm.data.form = vm.item;
        $scope.filter = angular.copy(vm.item);
        $scope.hideForm();
      };
  
      var showForm = function () {
        angular.element('.tooltip').remove();
        formTpl.show();
        currentModal = formTpl;
      };
      
      var showFormDetalhamento = function () {
        angular.element('.tooltip').remove();
        formDetalhamento.show();
        currentModal = formDetalhamento;
      };
  
      $scope.hideForm = function () {
        formTpl.hide();
        if(formDetalhamento) {
            formDetalhamento.hide();
        }
      };
  
      $scope.exportar = function () {
        if (vm.item) {
          vm.item.colunas = $scope.colunas;
          vm.item.tipo = $scope.dados.form.tipo;
          RelatorioService.exportar('/despesa/relatorio/nota-empenho', vm.item);
        }
      };
  
      $scope.$on('$destroy', function () {
        $scope.hideForm();
      });
  
    }
  })();
  
(function () {
  'use strict';

  angular.module('portal.despesa').controller('NotaLancamentoEmendasParlamentaresController', NotaLancamentoEmendasParlamentaresController);

  /** @ngInject */
  function NotaLancamentoEmendasParlamentaresController($scope, $modal, $aside, $alert, $location, $window, PagingService,
    unidadesGestoras, prioridades, DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;

    var currentModal, backModal;

    vm.prioridades = prioridades.data;

    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    var storedObj;
    var filtroOrigem;

    var colunas = {
      notaLancamento: { nome: "Nota Lançamento", visible: true, disabled: true, termo: "Nº do documento que registra a conferência da entrega do produto ou da prestação do serviço" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, disabled: true, termo: "Data em que a conferência da entrega do produto ou prestação do serviço foi registrada" },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      codigoCredor: { nome: "CNPJ/CPF", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, disabled: true, termo: "Valor que deve ser pago pela entrega de produto ou prestação de serviço" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Lançamento',
      plural: 'Notas de Lançamento'
    };

    vm.item = {
      busy: true,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    vm.unidadesGestoras = unidadesGestoras.data;

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoNePorObTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoEventosTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.busy = false;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.visualizarItem = function (linha) {
      DespesasService.recuperarNotaLancamento(linha).then(
        function (response) {
          vm.item.editing = false;
          vm.settings.cmd = 'Visualizar';
          vm.linha = response.data;
          showFormDetalhamento();
        }
      );
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    }

    vm.init = function () {
      storedObj = ScopeService.getStored();
      var obj = $location.search();
      if (obj.ano) {
        vm.item = extend(vm.item, obj);
        vm.item.busy = false;
        filtroOrigem = storedObj.filtroOrigem;
        filtroOrigem.anoExercicio = obj.ano;
        filtroOrigem.colunas = storedObj.colunas;
        filtroOrigem.url = storedObj ? storedObj.url : '';
        vm.applyFilters();
        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
      currentModal = formTpl;
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
      currentModal = formDetalhamentoTpl;
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/nota-lancamento-emendas', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          vm.totalNotasEmpenho = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          extratoNePorObTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          extratoEventosTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

  }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('OrdemBancariaEmendasParlamentaresController', OrdemBancariaEmendasParlamentaresController);

  /** @ngInject */
  function OrdemBancariaEmendasParlamentaresController($scope, $modal, $aside, $location, $alert, $window, PagingService,
    unidadesGestoras, prioridades, DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;

    var currentModal, backModal;

    vm.prioridades = prioridades.data;

    var storedObj;
    var filtroOrigem;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      ordemBancaria: { nome: "Pagamentos", visible: true, disabled: true, termo: "Nº do documento relativo ao valor pago pelo produto entregue ou serviço prestado" },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, termo: "Data de registro do pagamento pelo produto entregue ou serviço prestado" },
      hora: { nome: "Hora", visible: true, termo: "Hora" },
      numeroNotaLancamentoReferencia: { nome: "NL Referência", visible: true, termo: "NL Referência" },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      unidadeGestoraLiquidante: { nome: "Unidade Liquidante", visible: true, termo: "Unidade responsável pela liquidação da despesa" },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      codigoCredor: { nome: "CNPJ/CPF", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, termo: "Valor pago pelo produto entregue ou serviço realizado" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Empenho',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'pdf',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/despesa/ordem-bancaria',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.checarDataInvalida = function (data) {
      // Datas abaixo de 2009 e acima da data atual são inválidas
      var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
      var dataFutura = data >= moment().valueOf();
      return anteriorA2009 || dataFutura;
    };


    vm.unidadesGestoras = unidadesGestoras.data;
    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoOBTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoNEPorOBTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-aside.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoEventosTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoCancelamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ordem-cancelamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var notaLancamentoFormTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.page = 0;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.visualizarItem = function (linha) {
      if (linha.ordemBancaria.indexOf('NL') > -1) {
        linha.notaLancamento = linha.ordemBancaria;
        DespesasService.recuperarNotaLancamentoOB(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormDetalhamentoNL();
          }
        );
      } else if (linha.ordemBancaria.indexOf('OB') > -1) {
        DespesasService.recuperarOrdemBancaria(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormDetalhamentoOB();
          }
        );
      }
    };

    vm.exibirModalNELiquidacao = function (item) {
      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasEmpenhoLiquidacao = response.data;
            vm.notasEmpenhoLiquidacaoTotalPago = _.reduce(vm.listaNotasEmpenhoLiquidacao, function (memo, obj) {
              return memo + obj.valorNeFinal
            }, 0);
            var modal = modalTemplate('Notas de Empenho', 'app/components/despesas/despesas-por-agrupador/empenho-liquidacao-modal.html');
            modal.$promise.then(modal.show);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de empenho', type: 'info' }); }
      );
      DespesasService.listarNotasLancamentoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasLancamentoLiquidacao = response.data;
            vm.notasLancamentoLiquidacaoTotalPago = _.reduce(vm.listaNotasLancamentoLiquidacao, function (memo, obj) {
              return memo + obj.valorFinal
            }, 0);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de lancamento', type: 'info' }); }
      );
    };

    vm.exibirModalNEporOB = function (item) {

      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;

          var somaValores = 0;
          for (var i = 0; i < vm.listaNotasEmpenho.length; i++) {
            somaValores += vm.listaNotasEmpenho[i].valorNeFinal;
          }
          vm.totalNotasEmpenho = somaValores;

          hideCurrentModal();
          extratoNEPorOBTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    vm.init = function () {
      vm.data.content = [];

      storedObj = ScopeService.getStored();

      if (localStorage.getItem('URL_PREVIOUS_PAGE')) {
        localStorage.removeItem('URL_PREVIOUS_PAGE');
      }

      vm.item.ano = storedObj.filtroOrigem.anoExercicio;
      var obj = $location.search();
      if (storedObj && obj.ano) {
        vm.item = obj;
        vm.item.dataFim = null;
        vm.item.dataInicio = null;
        filtroOrigem = storedObj.filtroOrigem;
        filtroOrigem.colunas = storedObj.colunas;
        filtroOrigem.anoExercicio = obj.ano;
        filtroOrigem.url = storedObj.url;

        vm.titulo = "Pagamentos";
        var tipoValorPago = vm.item.tipoValorPago;
        switch (tipoValorPago) {
          case 'pago-exercicio':
            vm.titulo = vm.titulo + " no exercício";
            break;
          case 'pago-rpp':
            vm.titulo = vm.titulo + " de restos a pagar processados (RPP)";
            break;
          case 'pago-rpnp':
            vm.titulo = vm.titulo + " de restos a pagar não processados (RPNP)";
            break;
          case 'pago-ret':
            vm.titulo = vm.titulo + " das retenções (RET) ";
            break;
        }

        vm.applyFilters();

        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
      currentModal = formTpl;
    };

    var showFormDetalhamentoOB = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoOBTpl.show();
      currentModal = formDetalhamentoOBTpl;
    };

    var showFormDetalhamentoNL = function () {
      angular.element('.tooltip').remove();
      notaLancamentoFormTpl.show();
      currentModal = notaLancamentoFormTpl;
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/ordem-bancaria-emendas', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    }

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          vm.listaNotasEmpenhoTotal = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          extratoNEPorOBTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          extratoEventosTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

    vm.exibirOrdensDeCancelamento = function (item) {
      var reqObj = {
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroOrdemBancaria: item.ordemBancaria
      };

      DespesasService.listarOrdemCancelamentoPorOB(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há ordens de cancelamento vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaOrdensCancelamento = response.data;


          /*
          vm.listaEventosTotal = _.reduce( vm.listaEventos, function(memo, obj) {
            return memo + obj.valorLancamento
          }, 0 );*/

          hideCurrentModal();
          extratoCancelamentoTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar ordens de cancelamento',
            type: 'danger'
          });
        }
      );
    }

  }

})();

(function() {
  'use strict';

  angular.module('portal.despesa').controller('EmendasParlamentaresController', Controller);

  /** @ngInject */
  function Controller($scope, $aside, PagingService, RelatorioService,
                      anos, dataAtualizacao, ScopeService, $location, DespesasService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nomeAutor:{nome: "Autor", visible:true, termo:"Nome dos autores da Emenda Parlamentar"},
      nomeTipoEmenda:{ nome: "Tipo de Emenda", visible:false, termo:"Indica o tipo de emenda parlamentar"  },
      nomeProgramaTrabalho:{ nome:"Emenda", visible:true, termo:"Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
      nomeUnidadeGestora:{ nome:"Órgão", visible:true, termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      nomeGestao:{ nome:"Gestão", visible:false, termo:"Unidade responsável pela administração dos recursos públicos" },
      nomeModalidade:{ nome:"Modalidade de Aplicação", visible:false, termo:"Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas"},
      nomeFuncao:{ nome:"Função", visible:false, termo:"Área de atuação da Administração Pública" },
      nomeSubfuncao:{ nome:"Subfunção", visible:false, termo:"Identifica a natureza básica das ações de uma determinada área de atuação" },
      nomePrograma:{ nome:"Programa", visible:false, termo:"Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
      nomeAcao:{ nome:"Ação", visible:false, termo:"Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
      nomeSubtitulo:{ nome:"Subtítulo", visible:false, termo:"Identifica a localização física ou geográfica da ação orçamentária" },
      nomeCategoria:{ nome:"Categoria Econômica", visible:false, termo:"Classificação das receitas e despesas para uma avaliação do efeito econômico" },
      nomeGrupo:{ nome:"Grupo de Natureza da Despesa", visible:false, termo:"Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
      nomeElemento:{ nome:"Elemento de Despesa", visible:false, termo:"Indica os objetos de gastos" },
      //nomeSubElemento:{ nome:"Subelemento de Despesa", visible:false },
      nomeFonte:{ nome:"Fonte de Recurso", visible:false, termo:"Indica a origem dos recursos para realizar as despesas" },
      dotacaoInicial:{ nome:"Aprovado", visible:true, currency:true, termo:"Valor do orçamento inicial fixado pela Lei Orçamentária Anual" },
      alteracao:{ nome:"Alteração", visible:true, currency:true, termo:"Acréscimo ou dedução realizada" },
      movimentacao:{ nome:"Movimentação", visible:true, currency:true, termo:"Valor realocado para outro programa de trabalho" },
      bloqueado:{ nome:"Bloqueado", visible:true, currency:true, termo:"Indisponibilidade de uma dotação para movimentação e empenho" },
      valorDespesaAutorizadaEmendas:{ nome:"Autorizado", visible:true ,currency:true, termo:"Valores disponíveis para a execução da despesa" },
      valorEmpenhadoEmendas:{ nome:"Empenhado", visible:true, currency:true, termo:"Valor reservado para pagamento de um produto ou serviço", detalhado: true },
      valorLiquidadoEmendas:{ nome:"Liquidado", visible:true, currency:true, termo:"Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado", detalhado: true },
      valorEmpenhoPago:{ nome:"Pago", visible:true, currency:true, termo:"Valor pago pelo produto entregue ou serviço realizado", detalhado: true }

    };

    //Modelos do Filtro
    vm.ano = anos.data;
    vm.autor = [];
    vm.unidadeGestora = [];
    vm.gestao = [];
    vm.funcao = [];
    vm.subfuncao = [];
    vm.programa = [];
    vm.categoria = [];
    vm.grupos = [];
    vm.modalidadeAplicacao = [];
    vm.elemento = [];
    vm.fonteEmendas = [];

    vm.carregarFiltros = carregarFiltros;

    function carregarFiltros(exercicio) {
        vm.loadingFilter = true;
        DespesasService.listarFiltrosEmendasParlamentares(exercicio)
            .then(function(response){
                vm.autor = response.data.autores;
                vm.unidadeGestora = response.data.unidadesGestoras;
                vm.gestao = response.data.gestoes;
                vm.funcao = response.data.funcoes;
                vm.subfuncao = response.data.subfuncoes;
                vm.programa = response.data.programas;
                vm.categoria = response.data.categoriasEconomicas;
                vm.grupos = response.data.grupoNatureza;
                vm.modalidadeAplicacao = response.data.modalidadeAplicacoes;
                vm.elemento = response.data.elementos;
                vm.fonteEmendas = response.data.fontesRecurso;
                vm.loadingFilter = false;
            });
    }

    $scope.colunas = colunas;
    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // settings
    vm.settings = {
      singular: 'Emendas Parlamentares',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      busy: false,
      anoExercicio: vm.ano[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/despesa/emendas-parlamentares',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/emendas-parlamentares-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/emendas-parlamentares-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      carregarFiltros(vm.item.anoExercicio);
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFormFiltro();
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.linha = linha;
        showFormDetalhamento();
      }
    };

    vm.init = function() {
      var params = $location.search();
      if(params.colunas != null) {
        $scope.colunas = obj.colunas;
      }

      if (params.anoExercicio) {
        vm.item = extend(vm.item, params);
      } else {
        vm.item.anoExercicio = anos.data[0];
      }

      vm.assignInitParams(params, vm.item);

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function(params, modelObject) {
      var assignProps = function(propsArray, fromObj, toObj) {
        propsArray.forEach(function(prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return elem[compareProp] == param; })[0];

          if (element != null) {
            modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
          }
        }
      };

      assignProps([{from:'programa', to:'nomeProgramaTrabalho', type:String}], params, vm.item);
      assignProps([{from:'exercicio', to:'anoExercicio', type:String}], params, vm.item);
      assignSelect(vm.unidadeGestora, modelObject, 'codigosUg', params['orgao'], 'nome', 'codigo', true);
      assignSelect(vm.autor, modelObject, 'nomeAutor', params['autor'], 'nome', 'nome', false);
    };

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      formFiltroTpl.hide();
    };

    var showFormFiltro = function(){
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
    };

    var showFormDetalhamento = function(){
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
    };

    $scope.exportar = function() {
      if(vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/emendas-parlamentares', vm.item);
      }
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

    vm.visualizarEmpenhado = function (row) {
      var obj = {
        filtroOrigem: vm.item
      };

      obj.url = '/despesas/emendas-parlamentares';

      ScopeService.store(obj);

      $location.path('/despesas/nota-empenho/emendas-parlamentares').search({
        codigoFuncao: row.codigoFuncao,
        codigoSubfuncao: row.codigoSubfuncao,
        codigoPrograma: row.codigoPrograma,
        codigoProjeto: row.codigoProjeto,
        codigoSubtitulo: row.codigoSubtitulo,
        codigoNatureza: row.codigoGrupoNatureza,
        codigoFonteRecurso: row.codigoFonte,
        codigoEsfera: row.codigoEsfera,
        codigoUnidadeOrcamentaria: row.codigoUnidadeOrcamentaria,
        codigoUnidadeGestora: row.codigoUnidadeGestora,
        codigoGestao: row.codigoGestao,
        anoNotaEmpenho: row.anoExercicio
      });
    };

    vm.visualizarLiquidado = function (row) {
      vm.item.colunas = $scope.colunas;
      var obj = {
        filtroOrigem: vm.item,
      };
      obj.url = '/despesas/emendas-parlamentares';

      ScopeService.store(obj);
      $location.path('/despesas/nota-lancamento/emendas-parlamentares').search({
        codigoFuncao: row.codigoFuncao,
        codigoSubfuncao: row.codigoSubfuncao,
        codigoPrograma: row.codigoPrograma,
        codigoProjeto: row.codigoProjeto,
        codigoSubtitulo: row.codigoSubtitulo,
        codigoNatureza: row.codigoGrupoNatureza,
        codigoFonteRecurso: row.codigoFonte,
        codigoEsfera: row.codigoEsfera,
        codigoUnidadeOrcamentaria: row.codigoUnidadeOrcamentaria,
        codigoUnidadeGestora: row.codigoUnidadeGestora,
        codigoGestao: row.codigoGestao,
        ano: row.anoExercicio
      });
    };

    vm.visualizarPago = function (row, tipoValorPago) {
      vm.item.colunas = $scope.colunas;
      var obj = {
        filtroOrigem: vm.item,
        colunas: $scope.colunas
      };
      obj.url = '/despesas/emendas-parlamentares';
      ScopeService.store(obj);
      $location.path('/despesas/ordem-bancaria/emendas-parlamentares').search({
        codigoFuncao: row.codigoFuncao,
        codigoSubfuncao: row.codigoSubfuncao,
        codigoPrograma: row.codigoPrograma,
        codigoProjeto: row.codigoProjeto,
        codigoSubtitulo: row.codigoSubtitulo,
        ano: row.anoExercicio,
        tipoValorPago: tipoValorPago,
        codigoNatureza: row.codigoGrupoNatureza,
        codigoFonteRecurso: row.codigoFonte,
        codigoEsfera: row.codigoEsfera,
        codigoUnidadeOrcamentaria: row.codigoUnidadeOrcamentaria,
        codigoUnidadeGestora: row.codigoUnidadeGestora,
        codigoGestao: row.codigoGestao,
      });
    };

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    }

  }

})();

(function(){
  'use strict';
var app = angular.module('portal.despesa');
  app.filter('subtotalValorLei', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorLei;
      });
      return total;
    }
  });
  app.filter('subtotalValorAlteracao', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorAlteracao;
      });
      return total;
    }
  });
  app.filter('subtotalValorMovimentacao', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorMovimentacao;
      });
      return total;
    }
  });
  app.filter('subtotalValorBloqueado', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorBloqueado;
      });
      return total;
    }
  });
  app.filter('subtotalValorDespesaAutorizada', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorDespesaAutorizada;
      });
      return total;
    }
  });
  app.filter('subtotalValorEmpenhado', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorEmpenhado;
      });
      return total;
    }

  });
  app.filter('subtotalValorLiquidado', function() {
    return function(lista) {
      var total = null;
      _.forEach(lista, function (obj, k1) {
        total += obj.valorLiquidado;
      });
      return total;
    }
  });
  app.controller('ExecucaoEmendasController', Controller);

  /** @ngInject */
  function Controller($scope, unidadeGestora, gestao, ano,
                      $aside, DespesasService, PagingService, RelatorioService, dataAtualizacao) {

    var vm = this;
    vm.unidadeGestora = unidadeGestora.data;
    vm.gestao = gestao.data;
    vm.ano = ano.data;
    vm.exibirTabelaAgrupadora = true;
    var codigoUnidadeGestoraSelecionado = {};
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nomeUnidadeGestora:{ nome: "Unidade Gestora", visible:true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos"  },
      nomeGestao:{ nome: "Gestão", visible:true, termo: "Unidade responsável pela administração dos recursos públicos"  },
      nomeSubtitulo:{ nome: "Tipo de Emenda", visible:true, termo: "Indica o tipo de emenda parlamentar"  },
      valorLei:{ nome: "Orçamento Aprovado", visible:true, currency:true, termo: "Valor do orçamento inicial fixado pela Lei Orçamentária Anual"  },
      valorAlteracao:{ nome: "Alteração", visible:true, currency:true, termo: "Acréscimo e ou dedução realizada "  },
      valorMovimentacao:{ nome: "Movimentação", visible:true, currency:true, termo: "Valor realocado para outro programa de trabalho"  },
      valorBloqueado:{ nome: "Bloqueado", visible:true, currency:true, termo: "Indisponibilidade de uma dotação para movimentação e empenho"  },
      valorDespesaAutorizada:{ nome: "Despesa Autorizada", visible:true, currency:true, termo: "Valores disponíveis para a execução da despesa"  },
      valorEmpenhado:{ nome: "Empenhado", visible:true, currency:true, termo: "Valor reservado para pagamento de um produto ou serviço"  },
      valorLiquidado:{ nome: "Liquidado", visible:true, currency:true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado"  }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Execução de Emendas',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo:'csv',
      anoExercicio: vm.ano[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // adding demo data
    var data = {
      url: '/despesa/execucao-emendas',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/execucao-emendas-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.item.anoExercicio = vm.ano[0];
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){
      if(linha){
        linha.anoExercicio = vm.data.form.anoExercicio;
        linha.nomeTipoEmenda = vm.item.nomeTipoEmenda;
        DespesasService.listarExecucaoEmendasPorSubtitulo(linha).then(
          function(response) {
            $scope.dadosDetalhamento = response.data;
            vm.unidadeGestoraSelecionada = linha.nomeUnidadeGestora;
            codigoUnidadeGestoraSelecionado = linha.codigoUnidadeGestora;
            vm.exibirTabelaAgrupadora = false;
          }
        );
      }
    };

    vm.voltar = function() {
      delete $scope.dadosDetalhamento;
      vm.exibirTabelaAgrupadora = true;
      vm.search();
    }

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    var search = function() {
      if (!vm.exibirTabelaAgrupadora) {
        vm.voltar();
      }
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.search = search;

    $scope.exportar = function() {
      if(vm.item){
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/execucao-emendas', vm.item);
      }
    };

    $scope.exportarSub = function(){
      if (codigoUnidadeGestoraSelecionado) {
        vm.item.nomeUnidadeGestora = vm.unidadeGestoraSelecionada;
        vm.item.codigoUnidadeGestora = codigoUnidadeGestoraSelecionado;
        vm.item.colunas = {
          nomePrograma: {nome: "Unidade Gestora", visible: true},
          nomeSubtitulo: {nome: "Programa de Trabalho", visible: true},
          nomeEsfera: {nome: "Esfera", visible: true},
          nomeNatureza: {nome: "Natureza", visible: true},
          nomeFonte: {nome: "Fonte", visible: true},
          valorLei: {nome: "Lei", visible: true, currency: true},
          valorAlteracao: {nome: "Alteração", visible: true, currency: true},
          valorMovimentacao: {nome: "Movimentação", visible: true, currency: true},
          valorBloqueado: {nome: "Bloqueado", visible: true, currency: true},
          valorDespesaAutorizada: {nome: "Despesa Autorizada", visible: true, currency: true},
          valorEmpenhado: {nome: "Empenhado", visible: true, currency: true},
          valorLiquidado: {nome: "Liquidado", visible: true, currency: true}
        }

        RelatorioService.exportar('/despesa/relatorio/execucao-emendas-detalhe', vm.item);
      }
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      hideForm();
    });

    vm.expandCallback = function (index, id) {
      vm.idSelecionado = id;
      var obj = {
        codigoUnidadeGestora: codigoUnidadeGestoraSelecionado,
        anoExercicio: vm.item.anoExercicio,
        codigoProjeto: id
      };

      DespesasService.listarExecucaoEmendasPorSubtitulo(obj).then(
        function (response) {
          vm.listaSubitem = response.data;

          for (var i = 0; i < vm.listaSubitem.length; i++) {
            if (vm.listaSubitem[i].codigoProjeto == vm.idSelecionado) {
              vm.subtotalValorLei += vm.listaSubitem[i].valorLei;
              vm.subtotalValorAlteracao += vm.listaSubitem[i].valorAlteracao;
              vm.subtotalValorMovimentacao += vm.listaSubitem[i].valorMovimentacao;
              vm.subtotalValorBloqueado += vm.listaSubitem[i].valorBloqueado;
              vm.subtotalValorDespesaAutorizada += vm.listaSubitem[i].valorDespesaAutorizada;
              vm.subtotalValorEmpenhado += vm.listaSubitem[i].valorEmpenhado;
              vm.subtotalValorLiquidado += vm.listaSubitem[i].valorLiquidado;
            }
          }
        }
      );
    };

  }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('ExecucaoOcaController', Controller);

  /** @ngInject */
  function Controller($scope, $aside, DespesasService, PagingService, RelatorioService, ano, dataAtualizacao) {

    var vm = this;    
    vm.exibirTabelaAgrupadora = true;
    var codigoUnidadeGestoraSelecionado = {};
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nomeUnidadeGestora: {nome: "Unid. Gestora", visible: true, termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos"},
      valorLei: {nome: "Aprovado", visible: true, currency: true, termo:"Valor do orçamento inicial fixado pela Lei Orçamentária Anual"},
      valorAlteracao: {nome: "Alteração", visible: true, currency: true, termo:"Acréscimo e ou dedução realizada "},
      valorMovimentacao: {nome: "Movimentação", visible: true, currency: true, termo:"Valor realocado para outro programa de trabalho"},
      valorBloqueado: {nome: "Bloqueado", visible: true, currency: true, termo:"Indisponibilidade de uma dotação para movimentação e empenho"},
      valorDespesaAutorizada: {nome: "Autorizado", visible: true, currency: true, termo:"Valores disponíveis para a execução da despesa"},
      valorEmpenhado: {nome: "Empenhado", visible: true, currency: true, termo:"Valor reservado para pagamento de um produto ou serviço"},
      valorLiquidado: {nome: "Liquidado", visible: true, currency: true, termo:"Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado"},
    };

    vm.carregarFiltros = carregarFiltros;

    //Objetos do filtros
    vm.unidadeGestora = [];
    vm.gestao = [];
    vm.ano = ano.data;

    function carregarFiltros(exercicio, mesReferencia) {
        DespesasService.listarExecucaoOcaUnidadesGestoras(exercicio, mesReferencia)
            .then(function(response) {
                vm.unidadeGestora = response.data;
            });

        DespesasService.listarExecucaoOcaGestao(exercicio, mesReferencia)
            .then(function(response) {
                vm.gestao = response.data;
            });
    }

    $scope.colunas = colunas;

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // settings
    vm.settings = {
      singular: 'Execução OCA',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo: 'csv',
      busy: false,
      anoExercicio: vm.ano[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/despesa/oca',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/execucao-oca-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.item.anoExercicio = vm.ano[0];
      vm.tituloFiltro = vm.item.anoExercicio;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.cancelar = function () {
      vm.data.form = {};
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        linha.anoExercicio = vm.data.form.anoExercicio;
        DespesasService.listarExecucaoOcaPorSubtitulo(linha).then(
          function (response) {
            $scope.dadosDetalhamento = response.data;
            codigoUnidadeGestoraSelecionado = linha.codigoUnidadeGestora;
            vm.unidadeGestoraSelecionada = linha.nomeUnidadeGestora;
            vm.exibirTabelaAgrupadora = false;
          }
        );
      }
    };

    vm.voltar = function () {
      delete $scope.dadosDetalhamento;
      vm.exibirTabelaAgrupadora = true;
      vm.init();
    }

    vm.exibirFormPesquisa = function () {
      carregarFiltros(vm.item.anoExercicio, vm.item.mesReferencia);
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.search = function () {
      if (!vm.exibirTabelaAgrupadora) {
        vm.voltar();
      }
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      if(vm.item.mesReferencia && vm.item.mesReferencia > 0){
        vm.tituloFiltro = monthArray[vm.item.mesReferencia-1] + "/" + vm.item.anoExercicio;
      }else{
        vm.tituloFiltro = vm.item.anoExercicio;
      }
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/execucao-oca', vm.item);
      }
    };

    $scope.exportarSub = function(){
        if (codigoUnidadeGestoraSelecionado) {
          vm.item.nomeUnidadeGestora = vm.unidadeGestoraSelecionada;
          vm.item.codigoUnidadeGestora = codigoUnidadeGestoraSelecionado;
          vm.item.colunas = {
            nomePrograma: {nome: "Unidade Gestora", visible: true},
            nomeSubtitulo: {nome: "Programa de Trabalho", visible: true},
            nomeEsfera: {nome: "Esfera", visible: true},
            nomeNatureza: {nome: "Natureza", visible: true},
            nomeFonte: {nome: "Fonte", visible: true},
            valorLei: {nome: "Lei", visible: true, currency: true},
            valorAlteracao: {nome: "Alteração", visible: true, currency: true},
            valorMovimentacao: {nome: "Movimentação", visible: true, currency: true},
            valorBloqueado: {nome: "Bloqueado", visible: true, currency: true},
            valorDespesaAutorizada: {nome: "Despesa Autorizada", visible: true, currency: true},
            valorEmpenhado: {nome: "Empenhado", visible: true, currency: true},
            valorLiquidado: {nome: "Liquidado", visible: true, currency: true}
          }

          RelatorioService.exportar('/despesa/relatorio/execucao-oca-detalhe', vm.item);
        }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    vm.expandCallback = function (index, id) {
      vm.idSelecionado = id;
      var obj = {
        codigoUnidadeGestora: codigoUnidadeGestoraSelecionado,
        anoExercicio: vm.item.anoExercicio,
        codigoProjeto: id
      };

      DespesasService.listarExecucaoOcaPorSubtitulo(obj).then(
        function (response) {
          vm.listaSubitem = response.data;

          vm.subtotalValorLei = 0.0;
          vm.subtotalValorAlteracao = 0.0;
          vm.subtotalValorMovimentacao = 0.0;
          vm.subtotalValorBloqueado = 0.0;
          vm.subtotalValorDespesaAutorizada = 0.0;
          vm.subtotalValorEmpenhado = 0.0;
          vm.subtotalValorLiquidado = 0.0;
          for (var i = 0; i < vm.listaSubitem.length; i++) {
            if (vm.listaSubitem[i].codigoProjeto == vm.idSelecionado) {
              vm.subtotalValorLei += vm.listaSubitem[i].valorLei;
              vm.subtotalValorAlteracao += vm.listaSubitem[i].valorAlteracao;
              vm.subtotalValorMovimentacao += vm.listaSubitem[i].valorMovimentacao;
              vm.subtotalValorBloqueado += vm.listaSubitem[i].valorBloqueado;
              vm.subtotalValorDespesaAutorizada += vm.listaSubitem[i].valorDespesaAutorizada;
              vm.subtotalValorEmpenhado += vm.listaSubitem[i].valorEmpenhado;
              vm.subtotalValorLiquidado += vm.listaSubitem[i].valorLiquidado;
            }
          }
        }
      );
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var monthArray = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

  }

})();

(function () {
    'use strict';

    angular.module('portal.despesa').controller('PorFuncaoDespesaControllerNew', PorFuncaoDespesaController);

    /**
     * Controlador da página que apresenta despesas por função.
     */
    /** @ngInject */
    function PorFuncaoDespesaController($scope, $q, $location, ultimoExercicio, DespesasService) {
        var vm = this;
        vm.$q = $q;
        vm.DespesasService = DespesasService;
        vm.onDataSelected = onDataSelected;
        vm.parseAnosDespesa = parseAnosDespesa;
        vm.obterDespesasAno = obterDespesasAno;
        vm.obterUltimoAno = obterUltimoAno;
        vm.obterListaAnos = obterListaAnos;
        vm.buildPanelModel = buildPanelModel;

        var panels = [
            vm.buildPanelModel({
                title: '' + new Date().getFullYear(),
                promise: function() {
                    return vm.obterUltimoAno().then(function(ano) {
                        return ano.fetchDespesas().then(function(desp) { return { data: desp }; });
                    });
                }
            }, true)
        ];

        vm.panels = panels;

        vm.obterListaAnos().then(function(anos) {
            vm.panels = vm.panels.concat(anos.slice(1).map(function(ano) {
                return vm.buildPanelModel({
                    title: ano.ano,
                    promise: function() { return ano.fetchDespesas().then(function(desp) { return { data: desp }; }); }
                }, false);
            }));
        });

        window['VM'] = vm;
    }

    function buildPanelModel(ano, current) {
        var self = this;
        return {
            ano: ano,
            id: 'panel' + ano.title,
            chartType: 'bar-chart',
            current: current ? true : false,
            initial: current ? true : false,
            title: '' + ano.title,
            chartDataPromise: ano.promise(),
            destroy: function() {
                if (this.chartModel && this.chartModel.chart) {
                    this.chartModel.chart = this.chartModel.chart.destroy();
                    this.chartModel = undefined;
                }
            },
            onDataSelected: function(c) {
                self.onDataSelected(this, c);
            },
            onShow: function() {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function(data) {
                var chartColors = ['#1ED6D6','#0E7ECA','#65A0CE','#229396','#50597B','#FFD200','#D14C39','#E64C65','#229396','#50597B','#50597B','#1ED6D6','#0E7ECA','#65A0CE','#229396'];
                var panel = this;
      
                this.chartModel = {
                    chartId: 'chart' + ano.title,
                    chartHeight: 340,
                    fnFormatData: function(v) { return v + '%'; },
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnDataClickListener: function(v) { panel.onDataSelected(v); },
                    dimentions: data.map(function(d, index) {
                        return {
                            dataLabel: d.label,
                            data: d.percentual,
                            despesa: d.despesa,
                            color: chartColors[index % chartColors.length]
                        };
                    })
                };
            }
        }
    }

    /**
     * Obtem a lista de anos de despesa.
     */
    function obterListaAnos() {
        var self = this;

        if (this._cachedListaAnos == undefined) {
            this._cachedListaAnos = buildCachablePromiseFn(function() {
                return self.DespesasService.listarAno().then(function(resp) {
                    return self.parseAnosDespesa(resp.data);
                });
            }, this.$q);
        }

        return this._cachedListaAnos();
    }

    /**
     * Obtem o último ano de despesa.
     */
    function obterUltimoAno() {
        return this.obterListaAnos().then(function(lista) {
            return lista[0];
        });
    }

    /**
     * Obtem as despesas refentes a um ano.
     * @param {*} ano Objeto Ano.
     */
    function obterDespesasAno(ano) {
        return this.DespesasService.recuperarDespesasAtuais(ano.ano).then(function(resp) {
            return parseCategoriasDespesa(resp.data);
        });
    }

    function obterSubDespesas(ano, funcao) {
        DespesasService.graficoTreemapSubfuncao(funcao, ano);
    } 

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento.
     * @param {*} panel Painel.
     * @param {*} categoria Categoria.
     */
    function onDataSelected(panel, categoria) {
        
    }

    /**
     * Realiza o parse do conjunto de dados refentes as categorias de despesa.
     * @param {*} data Dados.
     */
    function parseCategoriasDespesa(data) {
        var categorias = [];

        for (var i = 0; i < data.length - 1; i += 2) {
            var label = data[i];
            var valor = data[i + 1];

            var labelSplit = label.split(' - ');
            var percent = labelSplit[1].replace(',', '.').match(/-?\d+(\.\d+)?/g);

            label = labelSplit[0];
            percent = Number(percent[0]);

            categorias.push({
                label: label,
                percentual: percent,
                despesa: valor
            });
        }

        return categorias.filter(function(cat) {
            return CATEGORIAS_SELECIONADAS.indexOf(cat.label) >= 0;
        }).sort(function(c1, c2) {
            return CATEGORIAS_SELECIONADAS.indexOf(c1.label) - CATEGORIAS_SELECIONADAS.indexOf(c2.label);
        });
    }

    /**
     * Realiza o parse do conjunto de anos de despesa.
     * @param {*} data Lista de anos de despesa.
     */
    function parseAnosDespesa(data) {
        var self = this;
        return data.sort().reverse().map(function(ano) {
            return {
                ano: ano,
                fetchDespesas: buildCachablePromiseFn(function(caller) {
                    return self.obterDespesasAno(caller);
                }, self.$q)
            };
        });
    }

    /**
     * Constroí uma função que retorna uma promise com cache.
     * @param {*} promise Promise.
     * @param {*} $q Primise service.
     */
    function buildCachablePromiseFn(promiseSupplier, $q) {
        var store = {};

        return function() {
            var caller = this;

            return $q(function(resolve, reject) {
                if (store.resp == undefined) {
                    promiseSupplier(caller).then(function(resp) {
                        store.resp = resp;
                        resolve(store.resp);
                    }, function(err) {
                        reject(err);
                    });
                } else {
                    resolve(store.resp);
                }
            });
        };
    }

    var CATEGORIAS_SELECIONADAS = [
        'EDUCAÇÃO',
        'SAÚDE',
        'TRANSPORTE',
        'URBANISMO',
        'SEGURANÇA PÚBLICA',
        'CULTURA',
        'ASSISTÊNCIA SOCIAL',
        'AGRICULTURA',
        'GESTÃO AMBIENTAL',
        'PREVIDÊNCIA SOCIAL',
        'ADMINISTRAÇÃO',
        'ENCARGOS ESPECIAIS',
        'DIREITOS DA CIDADANIA',
        'ESSENCIAL À JUSTIÇA',
        'LEGISLATIVA'
    ];

})();
(function () {
    'use strict';

    angular.module('portal.despesa').controller('PorFuncaoDespesaController', PorFuncaoDespesaController);

    /**
     * Controlador referente a página que apresenta despesas por função.
     */
    /** @ngInject */
    function PorFuncaoDespesaController($scope, $location, $filter, $timeout, DespesasService, dataAtualizacao) {
        var vm = this;
        vm.$scope = $scope;
        vm.$filter = $filter;
        vm.$timeout = $timeout;
        vm.$location = $location;
        vm.DespesasService = DespesasService;
        vm.obterAnosDespesa = obterAnosDespesa;
        vm.onAnoSelecionado = onAnoSelecionado;
        vm.beforeLoadPanel = beforeLoadPanel;
        vm.buildChartPromiseSupplier = buildChartPromiseSupplier;
        vm.formatCategoriaTooltip = formatCategoriaTooltip;
        vm.buildPanelModel = buildPanelModel;
        vm.onFuncaoSelecionada = onFuncaoSelecionada;
        vm.onSubFuncaoSelecionada = onSubFuncaoSelecionada;
        vm.configurePanelFuncao = configurePanelFuncao;
        vm.configurePanelSubfuncao = configurePanelSubfuncao;
        vm.isAnyFuncaoSelecionada = isAnyFuncaoSelecionada;
        vm.onClickBtnVoltar = onClickBtnVoltar;
        vm.anosDespesaLoadPromise = vm.obterAnosDespesa().then(function(anos) {
            vm.anos = anos;

            if (vm.anoSelecionado == undefined) {
                vm.anoSelecionado = vm.anos[0];
            }
        });

        vm.dataAtualizacao = dataAtualizacao.data;

        vm.panel = vm.buildPanelModel();
        vm.configurePanelFuncao();
        vm.panels = [vm.panel];
    }

    /**
     * Configura o painel para a apresentação de funções.
     */
    function configurePanelFuncao() {
        var self = this;
        this.funcaoSelecionada = undefined;
        this.panel.title = 'Funções - Despesas Liquidadas';
        this.panel.onDataSelected = function(f) { self.onFuncaoSelecionada(f); };
        this.panel.chartDataPromise = this.buildChartPromiseSupplier(function() {
            return self.DespesasService.recuperarDespesasAtuais(self.anoSelecionado);
        });
    }

    /**
     * Configura o painel para a apresentação das subfunções de uma função.
     * @param {*} funcao Função.
     */
    function configurePanelSubfuncao(funcao) {
        var self = this;
        this.panel.title = funcao + ' - Despesas Liquidadas';
        this.panel.onDataSelected = function(f) { self.onSubFuncaoSelecionada(f); };
        this.panel.chartDataPromise = this.buildChartPromiseSupplier(function() {
            return self.DespesasService.graficoTreemapSubfuncao(funcao, self.anoSelecionado)
                .then(function(resp) {
                    return {
                        data: resp.data.slice(1)
                    };
                });
        });
    }

    /**
     * Vertifica se algum função se encontra selecionada.
     * @returns true, existe uma função selecionada; false, caso contrário.
     */
    function isAnyFuncaoSelecionada() {
        return this.funcaoSelecionada != undefined;
    }

    /**
     * Constrói o supplier que fornecerá os dados para o gráfico.
     * @param {*} promiseSuplier Função que retorna a promise dos dados.
     */
    function buildChartPromiseSupplier(promiseSuplier) {
        var self = this;
        return function() {
            return self.beforeLoadPanel().then(function() {
                return promiseSuplier();
            });
        };
    }

    /**
     * Retorna uma promise para tarefas que precisão ser executadas antes de carregar um painel.
     * @returns Promise.
     */
    function beforeLoadPanel() {
        return this.$timeout(100).then(this.anosDespesaLoadPromise);
    }

    /**
     * Obtem os anos de despesa.
     * @returns Promise.
     */
    function obterAnosDespesa() {
        return this.DespesasService.listarAno().then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Responde ao evento de seleção de uma função.
     * @param {*} funcao Nome da função selecionada.
     */
    function onFuncaoSelecionada(funcao) {
        this.funcaoSelecionada = funcao.name.split(' - ')[0];

        this.configurePanelSubfuncao(this.funcaoSelecionada);

        this.panel.destroy();
        this.panel.reload();

        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma função.
     * @param {*} subfuncao Subfunção selecionada.
     */
    function onSubFuncaoSelecionada(subfuncao) {
        this.$location.path('/despesas/consulta-dinamica').search({
            anoExercicio: this.anoSelecionado,
            nomeFuncao: this.funcaoSelecionada,
            nomeSubfuncao: subfuncao.name.split(' - ')[0],
            colunas: ['nomeUnidadeGestora', 'nomeFuncao', 'nomeSubfuncao', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
        });

        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de um ano.
     * @param {*} ano Ano selecionado.
     */
    function onAnoSelecionado(ano) {
        this.anoSelecionado = ano;

        this.panel.destroy();
        this.panel.reload();
    }

    /**
     * Responde ao evento de click no botão voltar.
     */
    function onClickBtnVoltar() {
        this.configurePanelFuncao();

        this.panel.destroy();
        this.panel.reload();
    }

    /**
     * Formata o texto a ser exibido na tooltip de uma categoria.
     * @param {*} cat Categoria.
     */
    function formatCategoriaTooltip(cat) {
        var power = 0;

        for (var i = 1; i <= 10; i++) {
            if (cat.value >= Math.pow(10, i * 3)) {
                power = i * 3;
            }
        }

        var scaleNumber = Math.pow(10, power);

        var title = '<b>' + cat.name + '</b><br/>';
        var valor = 'R$ ' + (cat.value / scaleNumber).toFixed(2) + ' ' + this.$filter('classeNumericaDesc')(cat.value);

        return title + valor;
    }

    /**
     * Realiza o parse dos dados para um conjunto de categorias.
     * @param {*} data Dados
     */
    function parseCategorias(data) {
        var pairs = [];
        
        for (var i = 0; i + 1 < data.length; i += 2) {
            pairs.push({
                name: data[i].trim(),
                value: data[i + 1]
            });
        }

        return pairs;
    }

    /**
     * Constrói o modelo do painel.
     * @returns Panel model.
     */
    function buildPanelModel() {
        var self = this;
        return {
            id: 'panelId',
            chartType: 'treemap-chart',
            current: true,
            initial: true,
            title: 'Funções',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            onShow: function() {},
            destroy: function() {
                if (this.chartModel && this.chartModel.chart) {
                    this.chartModel.chart.destroy();
                    this.chartModel = undefined;
                }
            },
            buildModel: function(data) {
                var panel = this;
                var chartColors = ['#30C4C4', '#0E7ECA', '#65A0CE', '#50597B', '#229396', '#1ED6D6', '#5A86AB', '#0E7ECA', '#229396', '#1ED6D6', '#50597B', '#229396', '#50597B', '#65A0CE', '#0E7ECA'];
                var maxData = 15;

                //chartColors = ['#1565C0', '#1A6AC3', '#2070C7', '#2576CB', '#2B7BCF', '#3181D3', '#3687D7', '#3C8DDB', '#4292DE', '#4798E2', '#4D9EE6', '#53A3EA', '#58A9EE', '#5EAFF2', '#64B5F6'];
        
                var pairs = parseCategorias(data);
      
                this.chartModel = {
                    chartId: 'chartId',
                    chartTitle: '',
                    fnChartBuild: function(chart) { this.chart = chart; },
                    fnDataClickListener: function(cat) { panel.onDataSelected(cat); },
                    fnFormatTooltip: function(dim) { return self.formatCategoriaTooltip(dim); },
                    dimentions: pairs.slice(0, pairs.length > maxData ? maxData : pairs.length).map(function(pair, index) {
                        return {
                            label: pair.name,
                            data: pair.value,
                            color: chartColors[index % chartColors.length]
                        };
                    })
                };
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('portal').controller('LicitacoesContratosDashboardController', Controller);

  /** @ngInject */
  function Controller($scope, $filter, $location, evolucaoModalidade, orgaos, anos,
                      objeto, situacao, especie, LicitacoesContratosService, dataAtualizacao) {

    var vm = this;
    $scope.exerciciosDashboard = anos.data;
    $scope.exercicioDashboard = anos.data[0];
    vm.anoSelecionado = anos.data[0];
    vm.dataAtualizacao =  $filter('date')(new Date(dataAtualizacao.data), 'dd/MM/yyyy');

    $scope.alterarExercicio = function (exercicio) {
      vm.anoSelecionado = exercicio;

      LicitacoesContratosService.graficoObjeto(exercicio).then(
        function(response) { chartObjetoLicitacao.load({ columns: response.data, unload: chartObjetoLicitacao.columns  }); }
      );

      LicitacoesContratosService.graficoSituacao(exercicio).then(
        function (response) { chartSituacaoLicitacao.load({ columns: getColunasSituacao(response.data),
          categories: getCategoriasSituacao(response.data), unload: chartSituacaoLicitacao.columns }); }
      );

      LicitacoesContratosService.graficoEspecie(exercicio).then(
        function (response) { chartEspecieContrato.load({ columns: response.data, unload: chartEspecieContrato.columns }); }
      );

      LicitacoesContratosService.graficoMaioresOrgaosContratantes(exercicio).then(
        function(response) { chartOrgaos.load({ columns: response.data, unload: chartOrgaos.columns });
        }
      );
    };


    var graficoEvolucaoModalidadeColunas = evolucaoModalidade.data.colunas;
    var graficoEvolucaoModalidadeCategorias = evolucaoModalidade.data.categoria;
    vm.graficoEvolucaoModalidadeCategorias = graficoEvolucaoModalidadeCategorias;

    //var colors = ['#FFC87A', '#FFDF7A', '#DECD04', '#FFF151', '#FFCC29', '#FFA629', '#AE6600'];
    var colors = ['#95D1AA', '#6DB0E1', '#2D5181', '#90CEDB', '#76A8D7', '#2F8E43', '#6CAA6C', '#5DA199'];

    var chartEvolucaoModalidade = c3.generate({
      bindto: '#grafico-evolucao-modalidade',
      data: {
        columns: graficoEvolucaoModalidadeColunas,
        type: 'line',
        onclick: function (d, i) {

          var data = {
            modalidade: d.name,
            ano: vm.graficoEvolucaoModalidadeCategorias[d.x]
          };
          LicitacoesContratosService.store(data);
          $location.path('/licitacoes-contratos/licitacoes');
          $scope.$apply();
        }
      },
      axis: {
        x: {
          type: 'category',
          categories: graficoEvolucaoModalidadeCategorias
        },
        y: {
          tick: {
            format: function (d) {
              return $filter('number')(d);
            }
          }
        }
      },
      size: {
        height: 200
      },
      color: {
        pattern: colors
      },
      tooltip: {
        grouped: false
      }
    });

    var chartObjetoLicitacao = c3.generate({
      bindto: '#grafico-objeto-licitacao',
      data: {
        columns: objeto.data,
        type: 'donut',
        onclick: function (d, i) {
          var data = {
            objeto: d.name,
            ano: vm.anoSelecionado
          };
          LicitacoesContratosService.store(data);
          $location.path('/licitacoes-contratos/licitacoes');
          $scope.$apply();
        }
      },
      donut: {
        title: 'Objeto',
        width: 45
      },
      legend: {
        position: 'right'
      },
      size: {
        height: 200
      },
      color: {
        pattern: colors
      }
    });

    var getColunasSituacao = function(data){
      var colunas = [];
      colunas.push("Licitações");
      data.forEach(function(item){
        colunas.push(item[1]);
      });
      return [colunas];
    };

    var getCategoriasSituacao = function(data){
      var categorias = [];
      data.forEach(function(item){
        categorias.push(item[0]);
      });
      return categorias;
    }

    var chartSituacaoLicitacao = c3.generate({
      bindto: '#grafico-situacao-licitacao',
      data: {
        columns: getColunasSituacao(situacao.data),
        type: 'bar',
        onclick: function (d, i) {
          var data = {situacao: situacao.data[d.x][0],
            ano: vm.anoSelecionado};
          LicitacoesContratosService.store(data);
          $location.path('/licitacoes-contratos/licitacoes');
          $scope.$apply();
        },
        color: function (color, d) {
          return colors[d.index];
        }
      },
      axis: {
        x: {
          type: 'category',
          categories: getCategoriasSituacao(situacao.data)
        },
        y: {
          tick: {
            format: function (d) {
              return $filter('number')(d);
            }
          }
        }
      },
      size: {
        height: 200
      },
      color: {
        pattern: colors
      },
      legend:{
        show:false
      }
    });

    var chartEspecieContrato = c3.generate({
      bindto: '#grafico-especie-contrato',
      data: {
        columns: especie.data,
        type: 'donut',
        onclick: function (d, i) {
          var data = {
            especie: d.name,
            ano: vm.anoSelecionado
          };
          LicitacoesContratosService.store(data);
          $location.path('/licitacoes-contratos/contratos');
          $scope.$apply();
        }
      },
      donut: {
        title: 'Espécie',
        width: 45
      },
      legend: {
        position: 'right'
      },
      size: {
        height: 200
      },
      color: {
        pattern: colors
      }
    });

    var chartOrgaos = c3.generate({
      bindto: '#grafico-orgaos-contratos',
      data: {
        columns: orgaos.data,
        type: 'donut',
        onclick: function (d, i) {
          var data = {
            unidadeGestora: d.name,
            ano: vm.anoSelecionado
          };
          LicitacoesContratosService.store(data);
          $location.path('/licitacoes-contratos/contratos');
          $scope.$apply();
        }
      },
      donut: {
        width: 45
      },
      legend: {
        position: 'right'
      },
      size: {
        height: 200
      },
      color: {
        pattern: colors
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal').service('LicitacoesContratosService', Service);

  function Service($http, api) {

    var dataStored;
    var service = {};
    var serviceConfig = {cache: true};

    service.store = function (data) {
      dataStored = data;
    }

    service.getStored = function () {
      var data = dataStored;
      dataStored = null;
      return data;
    }

    service.listarContratoFonteRecurso = function () {
      return $http.get(api.url + '/licitacoes-contratos/contrato/fonte-recurso', serviceConfig);
    };

    service.listarContratoFuncao = function () {
      return $http.get(api.url + '/licitacoes-contratos/funcao', serviceConfig);
    };

    service.listarContratoGestao = function () {
      return $http.get(api.url + '/licitacoes-contratos/gestao', serviceConfig);
    };

    service.listarContratoTipoLicitacao = function () {
      return $http.get(api.url + '/licitacoes-contratos/modalidade-licitacao', serviceConfig);
    };

    service.listarContratoUnidadeGestora = function () {
      return $http.get(api.url + '/licitacoes-contratos/unidade-gestora', serviceConfig);
    };

    service.listarLicitacaoOrgao = function () {
      return $http.get(api.url + '/licitacoes-contratos/licitacao/orgao', serviceConfig);
    };

    service.listarLicitacaoSituacao = function () {
      return $http.get(api.url + '/licitacoes-contratos/licitacao/situacao', serviceConfig);
    };

    service.listarLicitacaoModalidade = function () {
      return $http.get(api.url + '/licitacoes-contratos/licitacao/modalidade', serviceConfig);
    };

    service.listarLicitacaoPropostas = function (obj) {
      return $http({
        url: api.url + '/licitacoes-contratos/licitacao/propostas',
        method: 'GET',
        params: obj
      });
    };

    service.listarLicitacaoProcessoOrgao = function (obj) {
      return $http({
        url: api.url + '/licitacoes-contratos/licitacao/processo-orgao',
        method: 'GET',
        params: obj
      });
    };

    service.listarLicitacaoVencedores = function (obj) {
      return $http({
        url: api.url + '/licitacoes-contratos/licitacao/vencedores',
        method: 'GET',
        params: obj
      });
    };

    service.listarExtratoNotaEmpenho = function(obj) {
      return $http({
        url: api.url + '/licitacoes-contratos/nota-empenho/extrato',
        method: 'GET',
        params: {
          numeroContrato : obj
        }
      });
    };

    service.listarContratoAditivos = function (obj) {
      return $http({
        url: api.url + '/licitacoes-contratos/contrato/aditivos',
        method: 'GET',
        params: obj
      });
    };

    service.graficoEvolucaoModalidade = function () {
      return $http.get(api.url + '/licitacoes-contratos/grafico/evolucao-modalidade', serviceConfig);
    };

    service.graficoEspecie = function (ano) {
      return $http({
        url: api.url + '/licitacoes-contratos/grafico/especie',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.graficoObjeto = function (ano) {
      return $http({
        url: api.url + '/licitacoes-contratos/grafico/objeto',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.graficoSituacao = function (ano) {
      return $http({
        url: api.url + '/licitacoes-contratos/grafico/situacao',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.graficoMaioresOrgaosContratantes = function (ano) {
      return $http({
        url: api.url + '/licitacoes-contratos/grafico/orgaos-contratos',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarAnos = function(){
        return $http.get(api.url + '/licitacoes-contratos/anos', serviceConfig);
    };

    service.listarAnosContratos = function(){
      return $http.get(api.url + '/licitacoes-contratos/contrato/anos', serviceConfig);
    };

    service.listarItensLicitados = function (obj) {
        return $http({
          url: api.url + '/v2/itens-licitados',
          method: 'GET',
          params: obj
        });
    };

    service.detalharItemLicitado = function(idItemCompra) {
        return $http({
            url: api.url + '/v2/itens-licitados/' + idItemCompra,
            method: 'GET'
          });
    }

    service.listarAnosItensLicitados = function(){
        return $http.get(api.url + '/v2/itens-licitados/anos', serviceConfig);
    };

    service.listarOrgaos = function() {
        return $http.get(api.url + '/v2/itens-licitados/orgaos', serviceConfig);
    }

    service.listarUfs = function() {
        return $http.get(api.url + '/v2/itens-licitados/ufs', serviceConfig);
    }

    service.listarModalidades = function() {
        return $http.get(api.url + '/v2/itens-licitados/modalidades', serviceConfig);
    }

    return service;

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('OrcamentoController', OrcamentoController);

  /** @ngInject */
  function OrcamentoController($scope, $aside, OrcamentoService, PagingService, tipo, ServidoresService, categorias, listaDataReferencias, dataAtualizacao, anos, listaAssuntosLRF,
    listaAssuntosRelatoriosGerenciais, $routeParams, crumble,ArquivoUrlService) {

    var vm = this;

    //vm.datasReferencias = listaDataReferencias.data;
    vm.anos = anos.data;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    vm.assuntosLRF = listaAssuntosLRF.data;
    vm.assuntosRelatoriosGerenciais = listaAssuntosRelatoriosGerenciais.data;
    $scope.vm = vm;
    vm.tipo = tipo;
    vm.categorias = categorias.data;
    vm.dataAtualizacao = dataAtualizacao;
    $scope.listarDataReferenciaPorAssunto = function(assunto){
        OrcamentoService.listarDataReferenciaPorAssunto(assunto)
        .success(function(data){
        vm.datasReferencias = data;
        });

      };

    vm.titulos = {
      'ldo': 'Lei de Diretrizes Orçamentárias - LDO',
      'loa': 'Lei Orçamentária Anual - LOA',
      'responsabilidade-fiscal': 'Lei de Responsabilidade Fiscal',
      'relatorios-gerenciais': 'Relatórios Gerenciais'
    };

    vm.titulo = vm.titulos[tipo];

    vm.urls = {
      'ldo': '/orcamento/ldo',
      'loa': '/orcamento/loa',
      'responsabilidade-fiscal': '/orcamento/responsabilidade-fiscal',
      'relatorios-gerenciais': '/orcamento/relatorios-gerenciais'
    };

    vm.url = vm.urls[tipo];

    vm.textos = {
      'ldo': 'Veja aqui as Leis de Diretrizes Orçamentárias (LDO), por exercício. A LDO dispõe sobre o equilíbrio entre receita e despesa, apresentando metas e prioridades da administração pública, listando os programas, objetivos e ações, com os valores correspondentes. Fonte: SEEC',
      'loa': 'Veja aqui as Leis Orçamentárias Anuais (LOA). A LOA estima a receita e fixa a despesa do governo, ou seja, é nesta lei que a administração pública define a origem, o montante e o destino dos recursos a serem gastos. Fonte: SEEC',
      'responsabilidade-fiscal': 'A Lei de Responsabilidade Fiscal (LRF) é o código de conduta dos administradores públicos, exigindo metas para controlar receitas e despesas, fixando limites para o endividamento e estabelecendo a prestação de contas, por meio de dois instrumentos: Relatório da Gestão Fiscal (RGF) e Relatório Resumido da Execução Orçamentária (RREO). Fonte: SEEC',
      'relatorios-gerenciais': 'Aqui você encontra diversos relatórios sobre a aplicação dos gastos governamentais, em destaque a Prestação de Contas Anual e o Balanço Geral do Governo. Fonte: Diversas'
    };

    vm.texto = vm.textos[tipo];

    var colunas = null;

    if(tipo== 'responsabilidade-fiscal'){
      colunas = {
        //nomeCategoria:{ nome: "Assunto", visible:true },
        nome:{ nome: "Nome", visible:true, termo:"Descrição dos relatórios relacionados aos instrumentos (Relatórios da Gestão Fiscal / Relatório Resumido da Execução Orçamentária)" },
        ano:{ nome:"Exercício", visible:true, termo:"Ano de referência da Lei de Responsabilidade Fiscal", center: true },
        dataReferencia:{ nome:"Referência", visible:true,date:true, termo:"Período correspondente aos relatórios da Lei de Responsabilidade Fiscal (Bimestral/Quadrimestral)", center: true },
        descricao:{nome:"Observação", visible:true, termo:"Informações adicionais referentes aos relatórios da Lei de Responsabilidade Fiscal"},
        fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
       };
    }
    if(tipo== 'relatorios-gerenciais'){
      colunas = {
        nome:{ nome: "Nome", visible:true, termo:"Descrição dos relatórios gerenciais correspondentes aos assuntos" },
        ano:{ nome:"Exercício", visible:true, termo:"Ano de referência do relatório", center: true },
        dataReferencia:{ nome:"Referência", visible:true, termo:"Período correspondente à cada assunto do relatório gerencial", center: true },
        descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes aos relatórios gereciais"},
        fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
      };
    }
    if(tipo=='ldo'){
      colunas = {
        nome:{ nome: "Nome", visible:true, termo:"Informações correspondentes aos relatórios da LDO(Lei que orienta a elaboração do orçamento do ano seguinte)" },
        ano:{ nome:"Exercício", visible:true, termo:"Ano de referência da Lei de Diretrizes Orçamentárias", center: true },
        dataReferencia:{ nome:"Referência", visible:true, termo:"Período referente à Lei (LDO)", center: true},
        descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes ao período da Lei de Diretrizes Orçamentárias"},
        fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
      };
    }
    if(tipo=='loa'){
      colunas = {
        nome:{ nome: "Nome", visible:true, termo:"Informações correspondentes aos relatórios da LOA (Lei que estima as receitas e estabelece as despesas a serem realizadas no ano seguinte)" },
        ano:{ nome:"Exercício", visible:true, termo:"Ano de referência da Lei Orçamentária Anual", center: true },
        dataReferencia:{ nome:"Referência", visible:true, termo:"Período correspondente à cada assunto do relatório gerencial", center: true},
        descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes ao período da Lei Orçamentária Anual"},
        fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
      };
    }

    $scope.colunas = colunas;

    vm.settings = {
      singular: vm.titulo,
      plural: '',
      busy: true,
      cmd: 'Pesquisar'//,
      //colunas: {
      //  nome:{ nome: "Nome", visible:true  },
      //  ano:{ nome: "Ano", visible:true }
      //}
    };

    vm.item = {
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/orcamento/'+vm.tipo,
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var tipo = vm.data.settings.singular;
    crumble.update({tipo: tipo});
    crumble.context = {tipo: tipo};
    crumble.update();

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/orcamento/filtro-form.html',
      show: vm.tipo === "relatorios-gerenciais" || vm.tipo === "responsabilidade-fiscal" ? true : false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = {
        editing: true,
        page: 0
      };

      vm.item = {
        page: 0
      };
    };

      vm.exibirFormPesquisa = function(){
        vm.data.form.icon = 'md-search';
        vm.data.form.editing = true;
        vm.settings.cmd = 'Pesquisar';
        showForm();
      };


      vm.init = function() {
        vm.tituloFiltro = vm.anos[0];
        if (vm.tipo === "relatorios-gerenciais" || vm.tipo === "responsabilidade-fiscal") return;
        var data = OrcamentoService.pesquisar(2016, null, vm.tipo);

        if(data) {
          vm.data.form = data;

          search();
        }
        ServidoresService.listarDataReferenciaPorTipo(tipo).then(function(retorno){
          vm.datasReferencias = retorno.data;
        });

      };
      var search = function() {
        vm.data.content = [];
        vm.item.page = 0;
        vm.item.padrao = false;
        vm.data.form = vm.item;
        vm.tituloFiltro = vm.item.ano;
        $scope.filter = angular.copy(vm.item);
        formTpl.hide();
      };

      vm.search = search;

      var showForm = function(){
        angular.element('.tooltip').remove();
        formTpl.show();
      };

      var hideForm = function(){
        formTpl.hide();
      };

      $scope.$on('$destroy', function() {
        hideForm();
      });

    $scope.$watch('vm.item.codigoCategoria', function(){
      if (vm.item.codigoCategoria) {
        vm.item.dataReferencia = [];
        listaDataReferencias(vm.item.codigoCategoria).success(function(response){
          vm.datasReferencias = response;
        });
      }else{
        vm.item.dataReferencia = [];
      }
    });
  }

})();

(function(){
  'use strict';

  angular.module('portal').service('OrcamentoService', OrcamentoService);

  /** @ngInject */
  function OrcamentoService($http, api) {
    var service = {};
    var serviceConfig = { cache: true };

    service.listarAnosRelatoriosGerenciais = function() {
      return $http.get(api.url + '/orcamento/relatorios-gerenciais/anos', serviceConfig);
    };

    service.listarAnosLdo = function() {
      return $http.get(api.url + '/orcamento/ldo/anos', serviceConfig);
    };

    service.listarAnosLoa = function() {
      return $http.get(api.url + '/orcamento/loa/anos', serviceConfig);
    };

    service.listarAnosLrf = function() {
      return $http.get(api.url + '/orcamento/lrf/anos', serviceConfig);
    };
    // tipos esperados 'loa', 'ldo' e 'relatorios-gerenciais'
    service.pesquisar = function(ano, nome, tipo) {
      return $http({
        url: api.url + '/orcamento/'+tipo,
        method: 'GET',
        params: {
          'ano': ano,
          'nome': nome
        }
      });
    };

    service.LDO = 'Lei de Diretrizes Orçamentárias',
    service.LOA = 'Lei Orçamentária Anual',
    service.REL_GERENCIAL = 'Relatórios Gerenciais'

    service.getCategorias = function (tipo){
      return $http.post(api.url + '/orcamento/categorias', tipo);
    }

    service.listaDataReferencias = function (codigoCategoria){
      return $http.post(api.url + '/orcamento/data-referencias', codigoCategoria);
    }

     service.listarDataReferenciaPorAssunto = function(assunto) {
      return $http({
        url: api.url + '/orcamento/listarDataReferenciaPorAssunto',
        method: 'GET',
        params: {
          assunto: assunto
        }
      });
    }

    service.listarAssuntosLRF = function (){
      return $http.get(api.url + '/orcamento/assuntosLRF', serviceConfig);
    }

    service.listaAssuntosRelatoriosGerenciais = function (){
      return $http.get(api.url + '/orcamento/assuntosRelatoriosGerenciais', serviceConfig);
    }

    return service;
  }

})();

(function () {
	'use strict';

	angular.module('portal').controller('PpaController', PpaController);


	/** @ngInject */
	function PpaController($scope, $aside, OrcamentoService, listaDataReferencias, anos, dataAtualizacao, ServidoresService,ArquivoUrlService) {

		var vm = this;

		vm.anos = anos.data;
		vm.dataAtualizacao = dataAtualizacao;
		vm.datasReferencias = listaDataReferencias.data;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

		vm.titulo = 'Plano Plurianual - PPA';
		vm.url = '/orcamento/ppa'


		var colunas = null;

		colunas = {
			nome: { nome: "Nome", visible: true, termo: "Informações correspondentes aos relatórios do PPA (Lei que estabelece quais serão seus objetivos e metas para os próximos 04 anos)" },
			ano: { nome: "Exercício", visible: false, termo: "", center: true },
			dataReferencia: { nome: "Referência", visible: true, date: true, termo: "Intervalo correspondente ao período de 4 anos do plano plurianual", center: true },
			descricao: { nome: "Observação", visible: true, termo: "Informações adicionais correspondentes ao período do plano plurianual" },
			fonte: { nome: "Fonte", visible: true, termo: "Órgão responsável pela gestão da informação" }
		};

		$scope.colunas = colunas;

		vm.settings = {
			singular: vm.titulo,
			plural: '',
			busy: true,
			cmd: 'Pesquisar'//,
		};

		vm.item = {
			page: 0,
			ano: vm.anos[0],
			dataAtualizacao: new Date(vm.dataAtualizacao.data),
			dataReferencia: vm.datasReferencias[0].nome
		};

		var data = {
			url: '/orcamento/ppa',
      ArquivoUrlService: vm.urlArquivos,
			form: vm.item,
			settings: vm.settings,
			content: [],
			//dataReferencia: vm.datasReferencias[0],
			totalElements: 0,
			last: true
		};

		vm.data = data;
		var formTpl = $aside({
			scope: $scope,
			template: 'app/components/orcamento/ppa-form.html',
			placement: 'left',
			backdrop: true,
			animation: 'am-slide-left'
		});

		vm.cancelar = function () {
			vm.data.form = {
				editing: true,
				page: 0
			};

			vm.item = {
				page: 0
			};
		};

		vm.exibirFormPesquisa = function () {
			vm.data.form.icon = 'md-search';
			vm.data.form.editing = true;
			vm.settings.cmd = 'Pesquisar';
			showForm();
		};

		vm.init = function () {
			vm.item.dataReferencia = vm.datasReferencias[0].nome;
			if (data) {
				data.form.dataReferencia = vm.item.dataReferencia;
				vm.data.form = data;
				search();
			}
		}

		var search = function () {
			vm.data.content = [];
			vm.item.page = 0;
			vm.item.padrao = false;
			vm.data.form = vm.item;
			//vm.tituloFiltro = vm.item.ano;
			$scope.filter = angular.copy(vm.item);
			formTpl.hide();
		};

		vm.search = search;

		var showForm = function () {
			angular.element('.tooltip').remove();
			formTpl.show();
		};

		var hideForm = function () {
			formTpl.hide();
		};

		$scope.$on('$destroy', function () {
			hideForm();
		});

		$scope.$watch('vm.item.codigoCategoria', function () {
			if (vm.item.codigoCategoria) {
				vm.item.dataReferencia = [];
				listaDataReferencias(vm.item.codigoCategoria).success(function (response) {
					vm.datasReferencias = response;
				});
			} else {
      	vm.item.dataReferencia = [];
			}
		});

	}

})();

(function(){
  'use strict';

  angular.module('portal.patrimonio').controller('PatrimonioBensMoveisController', Controller);

  /** @ngInject */
  function Controller($location, $scope, $aside, anos, ultimoAno, unidadeGestora, gestao,
                      PagingService, RelatorioService, gestaoPorUnidadeGestora, unidadeGestoraPorAno, dataAtualizacao) {

    var vm = this;

    vm.anos = anos.data;
    vm.unidadeGestora = unidadeGestora.data;
    vm.gestao = gestao.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      item: {nome: "Item", visible: true, termo:"Descrição referente às aquisições dos bens móveis da administração pública"},
      nomeUnidadeGestora: {nome: "Unidade Gestora", visible: false, termo:"Órgãos e entidades encarregados de gerir os recursos públicos"},
      nomeGestao: {nome: "Gestão", visible: false, termo:"Unidade responsável pela administração dos recursos públicos"},
      saldoInicial: {nome: "Saldo Inicial", visible: true, currency: true, termo:"Representa o valor dos bens móveis e semoventes registrados no Cadastro Geral de Bens Patrimoniais do Distrito Federal, na data inicial do exercício ou período indicado no Demonstrativo dos Bens Patrimoniais do Distrito Federal"},
      saldoAnterior: {nome: "Ajuste Exercício Anterior", visible: true, currency: true, termo:"Representa a origem extra-orçamentária da aquisição de bens móveis e semoventes registrados no Cadastro Geral de Bens Patrimoniais do Distrito Federal provenientes de exercícios já encerrados "},
      orcamentario: {nome: "Orçamentária", visible: true, currency: true, termo:"Representa a aquisição de bens móveis e  semoventes registrados no Cadastro Geral de Bens Patrimoniais do Distrito Federal"},
      extraOrcamentario: {nome: "Extra Orçamentária", visible: true, currency: true, termo:"Representa a origem da aquisição de bens móveis e semoventes registrados no Cadastro Geral de Bens Patrimoniais do DFl, quais sejam: Restos a pagar; Doação; Reposição; Produção, Nascimento e Captura; Apreensão; Órgão Extinto; Fundo Constitucional do DF; Ação Judicial; Desmembramento; Convênio e Congêneres; etc"},
      saida: {nome: "Saída", visible: true, currency: true, termo:"Representa o valor de baixa e/ou transferência de bens móveis e semoventes entre órgãos da Administração registrados no Cadastro Geral de Bens Patrimoniais do Distrito Federal "},
      saldoAtual: {nome: "Saldo Atual", visible: true, currency: true, termo:"Representa os valores decorrentes da incorporação, transferência e baixa de bens móveis e semoventes registrados no Cadastro Geral de Bens Patrimoniais do DF, na data final do exercício ou período indicado no Demonstrativo dos Bens Patrimoniais do Distrito Federal"}
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Bens Móveis',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      listaAnoExercicio: [vm.anos[0]],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/patrimonio/bens-moveis',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/patrimonio/patrimonio-bens-moveis-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    $scope.exportar = function() {
      if(vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/patrimonio/relatorio/bens-moveis', vm.item);
      }
    };

    vm.init = function() {
      vm.item.listaAnoExercicio = [vm.anos[0]];

      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function(params) {
      var assignProps = function(propsArray, fromObj, toObj) {
        propsArray.forEach(function(prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignProps([{from:'item', to:'item', type:String}], params, vm.item);
      assignSelect(vm.anos, vm.item, 'listaAnoExercicio', params['exercicio'], undefined, undefined, true);
    };

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.colunas = vm.settings.colunas;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.listaAnoExercicio.join(", ");
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

    $scope.$watch('vm.item.listaCodigoUnidadeGestora', function(){
      $scope.atualizarListaDeGestao();
    });

    $scope.atualizarListaDeGestao = function(){
      if (vm.item.listaCodigoUnidadeGestora) {
        vm.item.listaCodigoGestao = [ ];
        gestaoPorUnidadeGestora(vm.item.listaCodigoUnidadeGestora).success(function(response){
          vm.gestao = response;
        });
      }else{
        vm.gestao = [ ];
      }
    };

    $scope.$watch('vm.item.listaAnoExercicio', function(){
      if (vm.item.listaAnoExercicio) {
        vm.item.listaCodigoUnidadeGestora = [ ];
        unidadeGestoraPorAno(vm.item.listaAnoExercicio).success(function(response){
          vm.unidadeGestora = response;
          $scope.atualizarListaDeGestao();
        });
      }else{
        vm.unidadeGestora = [ ];
      }
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal.patrimonio').controller('PatrimonioPorOrgaoController', Controller);

  /** @ngInject */
  function Controller($location, $scope, $aside, orgao, PagingService, RelatorioService, dataAtualizacao) {

    var vm = this;

    vm.orgao = orgao.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      tipoBem: { nome: "Tipo do Bem", visible: true, termo: "Subitem de classificação orçamentária do bem móvel " },
      descricao: { nome: "Descrição do Bem", visible: true, termo: "Especificação do bem móvel" },
      nomeOrgao: { nome: "Órgão", visible: true, termo: "Unidade Administrativa usuária do bem móvel" },
      localizacao: { nome: "Unidade", visible: true, termo: "Denominação da Unidade Administrativa usuária do bem móvel " },
      dataIncorporacao: { nome: "Incorporação", visible: true, termo: "Data de registro de incorporação do bem móvel", center: true },
      estado: { nome: "Estado", visible: true, termo: "Estado de conservação do bem móvel", center: true }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Por Orgão',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/patrimonio/localizacao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/patrimonio/patrimonio-por-orgao-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/patrimonio/relatorio/localizacao', vm.item);
      }
    };

    vm.init = function () {
      var inicio = new Date();
      inicio.setMonth(0);
      inicio.setDate(1);
      var fim = new Date();
      vm.item.dataInicio = inicio;
      vm.item.dataFim = fim;

      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function (params) {
      if (params.descricao || params.orgao) {
        vm.item = {
          tipo: 'csv',
          page: 0,
          dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };
      }
      var assignProps = function (propsArray, fromObj, toObj) {
        propsArray.forEach(function (prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function (elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignProps([{ from: 'descricao', to: 'descricao', type: String }], params, vm.item);
      assignSelect(vm.orgao, vm.item, 'listaCodigoOrgao', params['orgao'], 'nome', 'codigo', true);

      if (params['ano'] && params['mes']) {
        var dateBegin = new Date(params['ano'], Number(params['mes']) - 1, 1);
        var dateEnd = new Date(dateBegin.getTime());

        if (dateEnd.getMonth() == 11) {
          dateEnd.setFullYear(dateEnd.getFullYear() + 1);
          dateEnd.setMonth(0);
        } else {
          dateEnd.setMonth(dateEnd.getMonth() + 1);
        }
        dateEnd.setMilliseconds(-1);

        vm.item.dataInicio = dateBegin;
        vm.item.dataFim = dateEnd;
      }
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      if (vm.item.dataInicio != null && vm.item.dataFim != null) {
        vm.tituloFiltro = monthArray[vm.item.dataInicio.getMonth()] + "/" + vm.item.dataInicio.getFullYear() + " - "
          + monthArray[vm.item.dataFim.getMonth()] + "/" + vm.item.dataFim.getFullYear();
      } else {
        vm.tituloFiltro = "";
      }
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var monthArray = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

  }

})();

(function(){
  'use strict';

  angular.module('portal.patrimonio').service('PatrimonioService', Service);

  function Service($http, api) {

    var service = {};
    var serviceConfig = { cache: true };

    service.listarDataReferenciaPorPatrimonio = function() {
      return $http.get(api.url + '/patrimonio/demonstrativos/datas-referencia', serviceConfig);
    };

    service.listarAnosDemonstrativo = function() {
      return $http.get(api.url + '/patrimonio/demonstrativos/anos', serviceConfig);
    };

    service.listarOrgaosLocalizacao = function() {
      return $http.get(api.url + '/patrimonio/localizacao/orgaos', serviceConfig);
    };

    service.listarAnosBensMoveis = function() {
      return $http.get(api.url + '/patrimonio/bens-moveis/anos', serviceConfig);
    };

    service.ultimoAnoBensMoveis = function() {
      return $http.get(api.url + '/patrimonio/bens-moveis/ultimo-ano', serviceConfig);
    };

    service.listarUnidadeGestoraBensMoveis = function() {
      return $http.get(api.url + '/patrimonio/bens-moveis/unidades-gestoras', serviceConfig);
    };

    service.listarGestaoBensMoveis = function() {
      return $http.get(api.url + '/patrimonio/bens-moveis/gestoes', serviceConfig);
    };

    service.listarGestaoBensMoveisPorUnidadeGestora = function(listaCodigoUnidadeGestora) {
      var list = listaCodigoUnidadeGestora.join(", ")
      return $http.post(api.url + '/patrimonio/bens-moveis/gestoes', list, serviceConfig);
    };

    service.listarUnidadeGestoraPorAno = function(listaAno) {
      var list = listaAno.join(", ")
      return $http.post(api.url + '/patrimonio/bens-moveis/unidades-gestoras', list, serviceConfig);
    };

    return service;

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('PatrimonioRelatorioController', PatrimonioRelatorioController);

  /** @ngInject */
  function PatrimonioRelatorioController($scope, $log, $aside,  formTemplate, categoria, datasReferencias, dataAtualizacao, anos) {

    var vm = this;
    
    vm.contador = 0;
    vm.anos = anos.data;
    $scope.vm = vm;
    vm.datasReferencias =   datasReferencias.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nome:{ nome: "Nome", visible:true, termo:"Descrição referente aos demonstrativos dos bens patrimoniais" },
      ano:{ nome:"Exercício", visible:true, termo:"Ano de referência das informações" },
      dataReferencia:{ nome:"Data referência", visible:true,date:true, termo:"Mês de referência do demonstrativo" },
      descricao:{nome:"Observação", visible:true, termo:"Período cumulativo correspondente ao demonstrativo"},
      fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Relatório',
      plural: 'Relatórios',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      editing: true,
      page: 0,
      busy: false,
      ano: vm.anos[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/convenio/relatorio',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;
    var formTpl = $aside({
      scope: $scope,
      template: formTemplate,
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    //vm.visualizarItem = function(linha){
    //  if(linha){
    //    vm.item.editing = false;
    //    vm.linha = linha;
    //    vm.settings.cmd = 'Visualizar';
    //    showForm();
    //  }
    //};

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.anos[0];
      vm.search();
    };

    $scope.init = vm.init;

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.ano;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };


    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      formTpl.hide();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('ConselheiroController', Controller);

  /** @ngInject */
  function Controller($location, $scope, $aside, $window, grau, orgaosDeliberativos, tipos, orgaosVinculados, titularidades, representacoes, PagingService, RelatorioService, PrestandoContasService, dataAtualizacao, $modal, $alert) {

    var vm = this;


    vm.opcoesGrau = grau.data;
    vm.opcoesRemuneracao = ["TODOS", "NÃO REMUNERADO", "REMUNERADO"];
    vm.opcoesEsfera = ["ADMINISTRAÇÃO DIRETA", "ADMINISTRAÇÃO INDIRETA"];
    vm.orgaosDeliberativos = orgaosDeliberativos.data;
    vm.tiposOrgao = tipos.data;
    vm.orgaosVinculados = orgaosVinculados.data;
    vm.titularidades = titularidades.data;
    vm.representacoes = representacoes.data;
    vm.dataAtualizacao = dataAtualizacao;
    vm.especies = ["POLÍTICAS PÚBLICAS", "TUTELARES", "COMUNITÁRIOS", "TODOS"];
    vm.observacao = ["REMUNERADO", "NÃO REMUNERADO"];

    var colunas = {
      nomeConselheiro: { nome: "Conselheiro", visible: true, disabled: true, termo: "Nome do conselheiro" },
      representacao: { nome: "Representação", visible: true, termo: "Órgão/tipo de respresentação do conselheiro" },
      titularidade: { nome: "Titularidade", visible: true, termo: "Função do conselheiro (titular/suplente)" },
      conselho: { nome: "Conselho", visible: true, termo: "Nome do conselho" },
      nomeOrgaoVinculado: { nome: "Órgão Vinculado", visible: true, termo: "Órgão a qual o conselho está vinculado" },
      administracao: { nome: "Administração", visible: false, termo: "Tipo de administração do conselho" },
      tipoOrgao: { nome: "Tipo", visible: false, termo: "Classificação de acordo com a natureza do conselho" },
      observacao: { nome: "Observação", visible: false, termo: "Informa se o membro é remunerado ou não pela participação no conselho" },
      dataDesignacao: { nome: "Designação", visible: true, termo: "Data da publicação da designação no DODF " },
      dataInicioMandato: { nome: "Início Mandato", visible: false, termo: "Data de início do mandato" },
      dataFinalMandato: { nome: "Final Mandato", visible: false, termo: "Data de término do mandato" },
      valor: { nome: "Valor", visible: true, currency: true, termo: "Valor definido em legislação para a participação no conselho" }
    };

    vm.settings = {
      singular: 'Conselheiro',
      plural: 'Conselheiros',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    $scope.colunas = colunas;

    vm.item = {
      tipo: 'csv',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var data = {
      url: '/prestando-contas/conselheiros',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/conselheiro-filter.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formTplDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/conselheiro-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.init = function () {
      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function (params) {
      var assignProps = function (propsArray, fromObj, toObj) {
        propsArray.forEach(function (prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function (elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignProps([{ from: 'nome', to: 'nomeConselheiro', type: String }], params, vm.item);
      assignProps([{ from: 'representacao', to: 'representacao', type: String }], params, vm.item);
      assignSelect(vm.orgaosDeliberativos, vm.item, 'conselho', params['conselho'], undefined, undefined, false);
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      hideForm();
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formTplDetalhamento.show();
    };

    var hideForm = function () {
      formTpl.hide();
    };

    $scope.$on('$destroy', function () {
      hideForm();
    });

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showFormDetalhamento();
      }
    };

    $scope.exportar = function () {
      if (vm.item)
        vm.item.colunas = vm.settings.colunas;
      vm.item.tipo = $scope.dados.form.tipo;
      RelatorioService.exportar('/prestando-contas/relatorio/conselheiros', vm.item);
    };

    var modalDetalhamentoConselho = $modal(
      {
        scope: $scope,
        title: 'teste',
        template: 'app/components/prestando-contas/detalhamento-conselheiros.html',
        show: false
      });

    var colunasParaExportacao = {
      nomeConselheiro: { nome: "Conselheiro", visible: true, disabled: true, termo: "Nome do conselheiro" },
      representacao: { nome: "Representação", visible: true, termo: "Órgão/tipo de respresentação do conselheiro" },
      titularidade: { nome: "Titularidade", visible: true, termo: "Função do conselheiro (titular/suplente)" },
      conselho: { nome: "Conselho", visible: true, termo: "Nome do conselho" },
      nomeOrgaoVinculado: { nome: "Órgão Vinculado", visible: true, termo: "Órgão a qual o conselho está vinculado" },
      administracao: { nome: "Administração", visible: false, termo: "Tipo de administração do conselho" },
      tipoOrgao: { nome: "Tipo", visible: false, termo: "Classificação de acordo com a natureza do conselho" },
      observacao: { nome: "Observação", visible: false, termo: "Informa se o membro é remunerado ou não pela participação no conselho" },
      dataDesignacao: { nome: "Data Designação", date: true, visible: true, termo: "Data da publicação da designação no DODF " },
      dataInicioMandato: { nome: "Data Inicio Mandato", date: true, visible: false, termo: "Data de início do mandato" },
      dataFinalMandato: { nome: "Data Final Mandato", date: true, visible: false, termo: "Data de término do mandato" },
      valor: { nome: "Valor", visible: true, currency: true, termo: "Valor definido em legislação para a participação no conselho" }
    };

    vm.colunasParaExportacao = colunasParaExportacao;

    vm.settings.cmd = 'Pesquisar';

    /*
    var formTpl2 = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/filtro-conselhos-form.html',
      show:true,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left',
      controller: 'OrgaoDeliberativoController'
    });
    */

  }
})();

(function(){
  'use strict';

  angular.module('portal').controller('EmpresaPunidaCtrl', EmpresaPunida);

  /** @ngInject */
  function EmpresaPunida($scope, $aside, $alert, 
                         orgaosSancionadores, sancao, tipoPessoa, uf, anos, origemInformacoes, 
                         PagingService, RelatorioService, PrestandoContasService, dataAtualizacao, horaAtualizacao) {

    var vm = this;

    vm.anos = anos.data;
    vm.uf = uf.data;
    vm.tipoPessoa = tipoPessoa.data;
    vm.origem = origemInformacoes.data;
    vm.orgaos = orgaosSancionadores.data;
    vm.sancoes = sancao.data;
    vm.dataAtualizacao = dataAtualizacao;
    vm.horaAtualizacao = horaAtualizacao.data[0];

    var colunas = {
      numeroCpfCnpj: {nome: "CNPJ/CPF Sancionado", visible: true, termo:"Nº do cadastro de pessoa física ou jurídica de quem recebeu a sanção"},
      nomeInformadoOrgaoSancionador: {nome: "Nome Sancionado", visible: true, termo: "Nome da empresa/pessoa que recebeu a sanção"},
      nomeFantasia: {nome:"Nome Fantasia", visible: false, termo: "Expressão usada para diferenciar e identificar a empresa sancionada (uso não obrigatório)"},
      tipoPessoa: {nome:"Tipo de Pessoa", visible: false, termo: "Pessoa física ou jurídica"},
      tipoSancao: {nome:"Tipo de Sanção", visible: true, termo: "Nome da sanção aplicada"},
      dataPublicacao: {nome:"Data Publicação", visible: false, termo: "Data em que a sanção foi publicada"},
      dataInicioSancao: {nome:"Data Início Sanção", visible: false, termo: "Data do início da sanção"},
      dataFimSancao: {nome:"Data Fim Sanção", visible: true, termo: "Data do término da sanção"},
      numeroProcesso: {nome:"Nº Processo", visible: false, termo: "Nº do processo referente à sanção"},
      nomeOrgaoSancionador: {nome:"Órgão Sancionador", visible: true, termo: "Órgão que aplicou a sanção"},
      nomeOrgaoOrigemInformacao: {nome:"Origem Informações", visible: true, termo: "Unidade responsável pelas informações"},
      exercicio: {nome: "Exercício", visible: true, termo: "Exercício considerado pela data de publicação"},
      siglaUfOrgaoSancionador: {nome:"UF", visible: true, termo: "Unidade da Federação em que se encontra o órgão sancionador"}
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Empresa Punida',
      plural: 'Empresas Punidas',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/empresa-punida',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/empresa-punida-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      vm.showForm();
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        vm.showForm();
      }
    };

    vm.init = function() {
      vm.search();
    };

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.item.colunas = vm.settings.colunas;
      vm.tituloFiltro = vm.item.exercicio;
      $scope.filter = angular.copy(vm.item);
      PrestandoContasService.listarEmpresaPunida(vm.item).then(
        function (response) {
          if(response.data.content.length == 0){
            var date = new Date();
            var dataCorrente = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
            if (vm.item.numeroCpfCnpj) {
              vm.mensagem = 'Não foram encontrados registros inerentes ao CPF/CNPJ Nº ' +  
              vm.item.numeroCpfCnpj + ' em ' + vm.recuperarDataAtual() + ' às ' + vm.recuperarHoraAtual() + '.';
            }
            if (vm.item.nomeInformadoOrgaoSancionador) {
              vm.mensagem = 'Não foram encontrados registros inerentes à Razão Social ' +  
              vm.item.nomeInformadoOrgaoSancionador + ' em ' + vm.recuperarDataAtual() + ' às ' + vm.recuperarHoraAtual() + '.';
            }
            if(vm.item.numeroCpfCnpj && vm.item.nomeInformadoOrgaoSancionador) {
              vm.mensagem = 'Não foram encontrados registros inerentes à Razão Social ' + 
              vm.item.nomeInformadoOrgaoSancionador + ' e CPF/CNPJ Nº ' + vm.item.numeroCpfCnpj + ' em ' + 
              vm.recuperarDataAtual() + ' às ' + vm.recuperarHoraAtual() + '.';
            }
          }
        });
      vm.mensagem = '';
      $scope.hideForm();
    };

    vm.showForm = function(){
      vm.dataAtual = vm.recuperarDataAtual();
      vm.horaAtual = vm.recuperarHoraAtual();
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.exportar = function() {
      if(vm.item)
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/prestando-contas/relatorio/empresa-punida', vm.item);
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

    vm.exportarDetalhamento = function(item) {
      item.tipo = 'pdf';
      RelatorioService.exportar('/prestando-contas/relatorio/empresa-punida/detalhamento', item);
    };

    vm.recuperarDataAtual = function() {
      var dataAtual = new Date();
      var diaFormatado = '';
      var mesFormatado = '';
      var dia = dataAtual.getDate();
      var mes = dataAtual.getMonth() + 1;
      var ano = dataAtual.getFullYear();

      if(dia < 10) {
        diaFormatado = '0' + dia.toString();
      } else {
        diaFormatado = dia.toString();
      }

      if(mes < 10) {
        mesFormatado = '0' + mes.toString();
      } else {
        mesFormatado = mes.toString();
      }

      var dataFormatada = diaFormatado + '/' + mesFormatado + '/' + ano;

      return dataFormatada;
    };

    vm.recuperarHoraAtual = function() {
      var horaAtual = new Date();
      var minutosFormatado = '';
      var segundosFormatado = '';
      var hora = horaAtual.getHours();
      var minutos = horaAtual.getMinutes();
      var segundos = horaAtual.getSeconds();

      if(minutos < 10) {
        minutosFormatado = '0' + minutos.toString();
      } else {
        minutosFormatado = minutos.toString();
      }

      if(segundos < 10) {
        segundosFormatado = '0' + segundos.toString();
      } else {
        segundosFormatado = segundos.toString();
      }

      var horaFormatada = hora + ':' + minutosFormatado + ':' + segundosFormatado;

      return horaFormatada;
    };

    vm.imprimir = function() {
      window.print();
    };

    vm.horaAtualizacaoFormatada = new Date(vm.dataAtualizacao.data);
    vm.horaAtualizacaoFormatada = vm.horaAtualizacaoFormatada.setHours(vm.horaAtualizacaoFormatada.getHours() - 1);
    vm.horaAtualizacaoFormatada = new Date(vm.horaAtualizacaoFormatada).toLocaleTimeString();

    vm.textoAtualizacao = 'Atualizado em ' + new Date(vm.dataAtualizacao.data).toLocaleDateString() + ' às '  + vm.horaAtualizacaoFormatada ;

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('GastosPublicidadeCtrl', GastosPublicidade);

  /** @ngInject */
  function GastosPublicidade($scope, $aside, anos,ServidoresService, dataAtualizacao, ArquivoUrlService) {

    var vm = this;
    vm.anos = anos.data;
    vm.dataAtualizacao = dataAtualizacao;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    var colunas = {
      nome:{ nome: "Nome", visible:true, termo:"Especificação do relatório" },
      ano:{
        nome:"Exercício", visible:true,
        termo:"Ano correspondente à publicação dos gastos efetivos com publicidade de utilidade pública e de interesse institucional",
        center: true
      },
      dataReferencia:{ nome:"Referência", visible:true,date:true, termo:"Período de publicação no DODF" },
      descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes à cada assunto"},
      fonte:{nome:"Fonte", visible:true, termo:"Órgão responsável pela gestão da informação"}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Gastos com Publicidade',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
        page: 0,
        tipo:'pdf',
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/prestando-contas/gastos-publicidade',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    ServidoresService.listarDataReferenciaPorTipo('gasto-publicidade').then(function(retorno){
      vm.datasReferencias = retorno.data;
    });

    var formTpl = $aside({
        scope: $scope,
        template: 'app/components/prestando-contas/gastos-com-publicidade-form.html',
        show: false,
        placement: 'left',
        backdrop: true,
        animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.init = function() {
      vm.data.form.ano = vm.anos[0];
      vm.search();
    }

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.data.form.ano;
      if (vm.data.form.trimestre){
        vm.tituloFiltro += "/" + vm.data.form.trimestre;
      }
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('OrgaoDeliberativoController', Controller);

  /** @ngInject */
  function Controller($location, $scope, $aside, $window, grau, orgaosDeliberativos, tipos, orgaosVinculados, titularidades, representacoes, PagingService, RelatorioService, PrestandoContasService, dataAtualizacao, $modal, $alert) {

    var vm = this;

    vm.opcoesGrau = grau.data;
    vm.opcoesRemuneracao = ["TODOS", "NÃO REMUNERADO", "REMUNERADO"];
    vm.opcoesEsfera = ["ADMINISTRAÇÃO DIRETA", "ADMINISTRAÇÃO INDIRETA"];
    vm.orgaosDeliberativos = orgaosDeliberativos.data;
    vm.tipos = tipos.data;
    vm.orgaosVinculados = orgaosVinculados.data;
    vm.titularidades = titularidades.data;
    vm.representacoes = representacoes.data;
    vm.dataAtualizacao = dataAtualizacao;
    vm.especies = ["POLÍTICAS PÚBLICAS", "TUTELARES", "COMUNITÁRIOS", "TODOS"];

    var colunas = {
      nomeOrgaoDeliberativo: { nome: "Nome do Conselho", visible: true, disabled:true, termo: "Nome do conselho" },
      nomeOrgaoVinculado: { nome: "Órgão Vinculado", visible: true, termo: "Órgão a qual o conselho está vinculado" },
      nomeLeiAtribuicao: {nome: "Atribuição", visible: true, termo: "Normativo que define a atribuição do conselho", linkAtribuicao: true},
      nomeAtoCriacao: {nome: "Ato criação", visible: true, termo: "Normativo que cria o conselho", linkCriacao: true},
      grau: {nome: "Grau", visible: false, termo: ""},
      esfera: { nome: "Administração", visible: false, termo: "Tipo de Administração do conselho (direta/indireta/comunitário)"},
      tipoOrgao: { nome: "Tipo", visible: false, termo: "Classificação de acordo com a natureza do conselho"},
      email: {nome: "Email", visible: true, termo: "Endereço eletrônico do conselho"},
      telefone: {nome: "Telefone", visible: true, termo: "Nº de contato do conselho"},
      valorRemuneracao: {nome: "Valor", visible: true, currency: true, termo: "Valor total recebido pelos membros remunerados em cada conselho. (OBS: valor definido em legislação)"}
    };

    vm.settings = {
      singular: 'Conselho',
      plural: 'Conselhos',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    $scope.colunas = colunas;

    vm.item = {
      tipo: 'csv',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var data = {
      url: '/prestando-contas/orgao-deliberativo',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/orgao-deliberativo-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });



    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      vm.showForm();
    };

    vm.init = function() {
      vm.assignInitParams($location.search(), vm.item);
      vm.search();
      formTpl.show();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function(params) {
      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignSelect(vm.orgaosDeliberativos, vm.item, 'nomeOrgaoDeliberativo', params['nome'], undefined, undefined, false);
      assignSelect(vm.orgaosVinculados, vm.item, 'nomeOrgaoVinculado', params['orgao'], undefined, undefined, false);
    };


    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      hideForm();
    };

    vm.showForm = function(){

      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function(){
      formTpl.hide();
      formTpl2.hide();
    };

    $scope.$on('$destroy', function() {
      hideForm();
    });

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        vm.showModal(linha);
      }
    };

    $scope.exportar = function() {
      if(vm.item)
        vm.item.colunas = vm.colunasParaExportacao
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/prestando-contas/relatorio/orgaos-deliberativos', vm.item);
    };



    vm.showModal = function(item) {
      PrestandoContasService.listarDetalhamentoConselho(item).then(
          function(response) {
            response.data.numberOfElements = response.data.totalElements;
            vm.detalhamentoConselho = response.data.content;
            vm.totalizador = response.data.totalizador.valor;
            vm.nomeDoConselho = response.data.content[0].nomeOrgaoDeliberativo;
            vm.nomeOrgaoVinculado = response.data.content[0].nomeOrgaoVinculado;

            $aside({
              scope: $scope,
              template: 'app/components/prestando-contas/detalhamento-conselheiros.html',
              show: true,
              placement: 'left',
              backdrop: true,
              animation: 'am-slide-left'
            });

          },
          function(erro) {
            $alert({
              title:'Erro',
              content: 'Erro ao recuperar dados dos conselheiros',
              placement: 'top-right',
              type: 'erro',
              container: '.alert-container-top-right',
              animation: 'mat-grow-top-right',
              duration: 5
            });
          }
      );
    };

    var colunasParaExportacao = {
      nomeOrgaoDeliberativo: { nome: "Nome do Conselho", visible: true, disabled:true, termo: "Nome do conselho" },
      nomeOrgaoVinculado: { nome: "Órgão Vinculado", visible: true, termo: "Órgão a qual o conselho está vinculado" },
      nomeLeiAtribuicao: {nome: "Atribuição", visible: true, termo: "Normativo que define a atribuição do conselho"},
      nomeAtoCriacao: {nome: "Ato criação", visible: true, termo: "Normativo que cria o conselho"},
      grau: {nome: "Grau", visible: true, termo: ""},
      nomeConselheiro: { nome: "Conselheiro", visible: true, termo: "Nome do membro" },
      dataDesignacao: {nome: "Data Designação", visible: true, termo: "Data da publicação no DODF"},
      titularidade: {nome: "Titularidade", visible: true, termo: "Função do membro (titular/suplente)"},
      representacaoPublicaCivil: { nome: "Representação", visible: true, termo: "Tipo de representação: Poder Público/Sociedade Civil/Entidades" },
      dataInicioMandato: {nome: "Início Mandato", visible: true, termo: "Data de início do mandato"},
      dataFimMandato: {nome: "Final Mandato", visible: true, termo: "Data de término do mandato"},
      esfera: { nome: "Administração", visible: true, termo: "Tipo de Administração do conselho (direta/indireta/comunitário)"},
      tipoOrgao: { nome: "Tipo", visible: true, termo: "Classificação de acordo com a natureza do conselho"},
      email: {nome: "Email", visible: true, termo: "Endereço eletrônico do conselho"},
      telefone: {nome: "Telefone", visible: true, termo: "Nº de contato do conselho"},
      observacao: {nome: "Remuneração", visible: true, termo: "Informa se o membro é remunerado ou não pela participação no conselho"},
      valorRemuneracao: {nome: "Valor", visible: true, currency: true, termo: "Valor total recebido pelos membros remunerados em cada conselho. (OBS: valor definido em legislação)"}
    };

    vm.colunasParaExportacao = colunasParaExportacao;

    vm.settings.cmd = 'Pesquisar';

    var formTpl2 = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/filtro-conselhos-form.html',
      show:false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left',
      controller: 'OrgaoDeliberativoController'
    });

  }
})();

(function () {
  'use strict';

  angular.module('portal').controller('OrgaosDeliberativosSaibaMaisController', OrgaosDeliberativosSaibaMaisController);

  /** @ngInject */
  function OrgaosDeliberativosSaibaMaisController($scope, $window, dataAtualizacao, ArquivoUrlService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao.data;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    var colunas = {
      nome:{ nome: "Nome", visible:true },
      ano:{ nome:"Exercício", visible:true },
      dataReferencia:{ nome:"Data referência", visible:false}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Órgãos Deliberativos - Saiba Mais​',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
      page: 0,
      busy: false
    };

    var data = {
      url: '/prestando-contas/orgaos-deliberativos/saiba-mais',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    vm.init = function () {
      vm.search();
    }

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.voltar = function(){
      $window.location.href = '#/prestando-contas/conselhos';
    };
  }
})();

(function(){
    'use strict';

    angular.module('portal').controller("OutrosRelatoriosController",["$scope","formTemplate","categorias","$aside","listaDatasReferencia", "dataAtualizacao","anos","ArquivoUrlService" ,"PrestandoContasService",
    function ($scope,formTemplate,categorias,$aside, listaDatasReferencia, dataAtualizacao, anos, ArquivoUrlService, PrestandoContasService) {

        var vm = this;

        vm.anos = anos.data;
        vm.categorias = categorias.data;
        vm.dataAtualizacao = dataAtualizacao;

        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        //vm.anos = [];
        /*for (var i = new Date().getFullYear(); i >= 2007; i--) {
            vm.anos.push(i);
        }*/

        var colunas = {
            //nomeCategoria:{nome:"Assunto",visible:true},
            nome:{ nome: "Nome", visible:true, termo:"Especificação do relatório correspondente à cada assunto" },
            ano:{ nome:"Exercício", visible:true, termo:"Ano de referência do relatório", center: true },
            dataReferencia:{ nome:"Referência", visible:true, termo:"Período de referência do relatório", center: true },
            descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes à cada assunto "},
            fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"}
        };

        $scope.colunas = colunas;

        $scope.settings = {
            singular: 'Relatório',
            plural: 'Relatórios',
            busy: true,
            cmd: 'Pesquisar',
            colunas: colunas
        };

        vm.item = {
            editing: true,
            page: 0,
            busy: false,
            anos: angular.copy(vm.anos[0]),
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };
        var formTpl = $aside({
            scope: $scope,
            template: formTemplate,
            show: true,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var data = {
            url: '/prestando-contas/outros-relatorios',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        $scope.cancelar = function() {
            vm.data.form = null;
            vm.item = {
              editing: true,
              page: 0,
              busy: false,
              anos: angular.copy(vm.anos[0]),
              dataAtualizacao: new Date(vm.dataAtualizacao.data)
            }

            vm.carregarFiltroExercicio(null);
          vm.carregarCategoriaRelatorio(null);
        };

        vm.exibirFormPesquisa = function(){
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            $scope.settings.cmd = 'Pesquisar';
            showForm();
        };

        vm.init = function() {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.anos[0].nome;
        };

        vm.carregarFiltroExercicio = function(categoriaRelatorio) {
            PrestandoContasService.listarAnosOutrosRelatorios(categoriaRelatorio)
                .then(function(anos) {
                    vm.anos = anos.data;
                });
        }

        vm.carregarCategoriaRelatorio = function(anoExercicio) {
            vm.item.ano = anoExercicio
            PrestandoContasService.listarCategorias(anoExercicio)
                .then(function(categorias) {
                    vm.categorias = categorias.data;
                });
        }

        var showForm = function(){
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.search = function() {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.item.anos.nome;
            $scope.filter = angular.copy(vm.item);
            formTpl.hide();
        };

        $scope.$watch('vm.item.codigoCategoria', function(){
            if (vm.item.codigoCategoria) {
                vm.item.dataReferencia = [];
                listaDatasReferencia(vm.item.codigoCategoria).success(function(response){
                    vm.datasReferencias = response;
                });
            }else{
                vm.item.dataReferencia = [];
            }
        });

        var hideForm = function(){
            formTpl.hide();
        };

        $scope.$on('$destroy', function() {
            hideForm();
        });

    }])

})();

(function () {
  "use strict";

  angular
    .module("portal")
    .service("PrestandoContasService", PrestandoContasService);

  function PrestandoContasService($http, api) {
    var service = {};
    var serviceConfig = { cache: true };

    service.listarEmpresaPunida = function (EmpresaPunida) {
      return $http({
        url: api.url + "/empresa-punida",
        method: "GET",
        params: EmpresaPunida,
      });
    };

    service.recuperarValorTotal = function () {
      return $http({
        url: api.url + "/prestando-contas/valor-total",
        method: "GET",
        cache: true,
      });
    };

    service.buscarHoraAtualizacao = function () {
      return $http.get(
        api.url + "/dataAtualizacao/hora/empresas-punidas",
        serviceConfig
      );
    };

    service.listarGrauOrgaosDeliberativos = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-grau",
        serviceConfig
      );
    };

    service.listarUf = function () {
      return $http.get(api.url + "/empresa-punida/uf", serviceConfig);
    };

    service.listarOrigemInformacoes = function () {
      return $http.get(
        api.url + "/empresa-punida/origem-informacoes",
        serviceConfig
      );
    };

    service.listarTipoPessoa = function () {
      return $http.get(api.url + "/empresa-punida/tipo-pessoa", serviceConfig);
    };

    service.listarOrgaosDeliberativos = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-detalhe",
        serviceConfig
      );
    };

    service.listarTipos = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-tipo",
        serviceConfig
      );
    };

    service.listarOrgaosVinculados = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-vinculacao",
        serviceConfig
      );
    };

    service.listarTitularidades = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-titularidade",
        serviceConfig
      );
    };

    service.listarRepresentacoes = function () {
      return $http.get(
        api.url + "/prestando-contas/orgao-deliberativo-representacoes",
        serviceConfig
      );
    };

    service.listarTipoSancao = function () {
      return $http.get(api.url + "/empresa-punida/sancao", serviceConfig);
    };

    service.listarOrgaos = function () {
      return $http.get(api.url + "/empresa-punida/orgao", serviceConfig);
    };

    service.listarAnos = function () {
      return $http.get(api.url + "/empresa-punida/anos", serviceConfig);
    };

    service.textoExplicativoBeneficiarioProgramaSocial = function () {
      return $http.get(
        api.url + "/texto-explicativo/beneficiario/programa-social",
        serviceConfig
      );
    };

    service.ultimoAnoMesBeneficiarioProgramaSocial = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiario/programa-social/ultimo-mes-ano",
        serviceConfig
      );
    };

    service.listarAnosBeneficiarioProgramaSocial = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiario/programa-social/anos",
        serviceConfig
      );
    };

    service.listarProgramasSociais = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiario/programa-social/programas",
        serviceConfig
      );
    };

    service.listarAnosCartaoMaterialEscolar = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiario/cartao/anos",
        serviceConfig
      );
    };


    service.listarLoteCartaoMaterialEscolar = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiario/cartao/lotes",
        serviceConfig
      );
    };

    service.listaOrgaosShowsEventos = function () {
      return $http.get(
        api.url + "/prestando-contas/shows-eventos/orgao",
        serviceConfig
      );
    };

    service.listaAnosShowEvento = function () {
      return $http.get(
        api.url + "/prestando-contas/shows-eventos/anos",
        serviceConfig
      );
    };

    service.listaAnosGastosComPublicidade = function () {
      return $http.get(
        api.url + "/prestando-contas/gastos-publicidade/anos",
        serviceConfig
      );
    };

    service.listarCategorias = function (anoExercicio) {
      var url = "/prestando-contas/outros-relatorios/categorias";
      if (anoExercicio) {
        url += "?anoExercicio=" + anoExercicio;
      }
      return $http.get(api.url + url, serviceConfig);
    };

    service.listarDataReferenciaPorCategoria = function (codigoCategoria) {
      return $http.post(
        api.url + "/prestando-contas/data-referencias",
        codigoCategoria
      );
    };

    service.listarAnosOutrosRelatorios = function (categoriaRelatorio) {
      var url = "/prestando-contas/outros-relatorios/anos";
      if (categoriaRelatorio) {
        url += "?categoriaRelatorio=" + categoriaRelatorio;
      }
      return $http.get(api.url + url, serviceConfig);
    };

    service.listarAnosOrganizacoesSociaisSaude = function () {
      return $http.get(
        api.url + "/prestando-contas/organizacoes-sociais-saude/anos",
        serviceConfig
      );
    };

    service.listarNomeOrganizacoesSociaisSaude = function () {
      return $http.get(
        api.url + "/prestando-contas/organizacoes-sociais-saude/nomes",
        serviceConfig
      );
    };

    service.listarRelatoriosOrganizacoesSociaisSaude = function () {
      return $http.get(
        api.url + "/prestando-contas/organizacoes-sociais-saude/relatorios",
        serviceConfig
      );
    };

    service.listarDetalhamentoConselho = function (item) {
      return $http({
        url: api.url + "/prestando-contas/detalhamento-conselho",
        method: "GET",
        params: { nomeOrgaoDeliberativo: item.nomeOrgaoDeliberativo },
        cache: true,
      });
    };

    service.listarDetalhamentoConselheiro = function (item) {
      return $http({
        url: api.url + "/prestando-contas/detalhamento-conselheiro",
        method: "GET",
        params: { nomeOrgaoDeliberativo: item.nomeOrgaoDeliberativo },
        cache: true,
      });
    };

    service.listarAnosPrestacaoContasAnual = function () {
      return $http.get(
        api.url + "/prestando-contas/prestacao-contas-anual/anos",
        serviceConfig
      );
    };

    service.listarMesesReferenciaBeneficiarioAuxilioEmergencial = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-auxilio-emergencial/meses-referencia",
        serviceConfig
      );
    };

    service.listarAnosReferenciaBeneficiarioPratoCheio = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiarios-prato-cheio/anos-referencia",
        serviceConfig
      );
    };

    service.listarMesesReferenciaBeneficiarioPratoCheio = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-prato-cheio/meses-referencia",
        serviceConfig
      );
    };

    service.listarAnosReferenciaBeneficiarioArtisticoCultural = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-artistico-cultural/anos-referencia",
        serviceConfig
      );
    };
    service.listarConcessoesBeneficiarioMobilidadeCidada = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-mobilidade-cidada/concessoes",
        serviceConfig
      );
    };

    service.listarExerciciosBeneficiarioMobilidadeCidada = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-mobilidade-cidada/exercicios",
        serviceConfig
      );
    };

    service.listarSituacoesEmpresaProgramaIntegridade = function () {
      return $http.get(
        api.url + "/prestando-contas/empresas-programa-integridade/situacoes",
        serviceConfig
      );
    };
    service.listarOrgaoContratanteEmpresaProgramaIntegridade = function () {
      return $http.get(
        api.url +
          "/prestando-contas/empresas-programa-integridade/orgao-contratante",
        serviceConfig
      );
    };
    service.listarAnoDataApresentacao = function () {
      return $http.get(
        api.url +
          "/prestando-contas/empresas-programa-integridade/ano-data-apresentacao",
        serviceConfig
      );
    };
    service.listarMesDataApresentacao = function () {
      return $http.get(
        api.url +
          "/prestando-contas/empresas-programa-integridade/mes-data-apresentacao",
        serviceConfig
      );
    };
    service.listarAnoDataAvaliacao = function () {
      return $http.get(
        api.url +
          "/prestando-contas/empresas-programa-integridade/ano-data-avaliacao",
        serviceConfig
      );
    };
    service.listarMesDataAvaliacao = function () {
      return $http.get(
        api.url +
          "/prestando-contas/empresas-programa-integridade/mes-data-avaliacao",
        serviceConfig
      );
    };
    service.listarAnosBeneficiariosBolsaAlimentacao = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiarios-bolsa-alimentacao/ano",
        serviceConfig
      );
    };
    service.listarMesBeneficiariosBolsaAlimentacao = function (exercicio) {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-bolsa-alimentacao/mes?exercicio=" +
          exercicio,
        serviceConfig
      );
    };

    service.listarExercicio = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/ano",
        serviceConfig
      );
    };
    service.listarPersonalidade = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/personalidade",
         serviceConfig
      );
    };
    service.listarRegiaoAdministrativa = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/regiao",
         serviceConfig
      );
    };
    service.listarCarteira = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/carteira",
         serviceConfig
      );
    };
    service.listarComite = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/comite",
         serviceConfig
      );
    };
    service.listarPorte = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/porte",
          serviceConfig
      );
    };
    service.listarContrato = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/contrato",
          serviceConfig
      );
    };
    service.listarModalidade = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/modalidade",
          serviceConfig
      );
    };
    service.listarAtividadde = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/atividade",
          serviceConfig
      );
    };
    service.listarSubatividade = function (){
      return $http.get(
        api.url +
          "/prestando-contas/prospera-df/subatividade",
          serviceConfig
      );
    };



    service.listarReferenciaBeneficiariosBolsaAlimentacao = function () {
      var referencias = {};
      var self = this;
      return this.listarAnosBeneficiariosBolsaAlimentacao().then(function (
        exercicios
      ) {
        referencias.exercicios = exercicios.data;
        return self
          .listarMesBeneficiariosBolsaAlimentacao(referencias.exercicios[0])
          .then(function (meses) {
            referencias.meses = meses.data;

            return referencias;
          });
      });
    };

    service.listarRegimeBeneficiariosBolsaAlimentacao = function () {
      return $http.get(
        api.url + "/prestando-contas/beneficiarios-bolsa-alimentacao/regime",
        serviceConfig
      );
    };
    service.listarNomeEscolaBeneficiariosBolsaAlimentacao = function () {
      return $http.get(
        api.url +
          "/prestando-contas/beneficiarios-bolsa-alimentacao/nome-escola",
        serviceConfig
      );
    };

    return service;
  }
})();

(function() {
    'use strict';

    angular.module('portal').controller('QuadrosTematicosController', QuadrosTematicosController);

    /**
     * Controlador da página de apresentação dos quadros temáticos.
     * @param {*} $scope Escopo injetado.
     */
    /** @ngInject */
    function QuadrosTematicosController($location, $scope, $timeout, QuadrosTematicosService, apiGerenciador, ArquivoUrlService) {
        var vm = this;
        vm.anoAtual = null;
        vm.$scope = $scope;
        vm.$location = $location;
        vm.$timeout = $timeout;
        vm.onClickIndicator = onClickIndicator;
        vm.setCurrentQuadro = setCurrentQuadro;
        vm.onQuadroShow = onQuadroShow;
        vm.changeSelectedQuadro = changeSelectedQuadro;
        vm.onSwipeListener = onSwipeListener;
        vm.QuadrosTematicosService = QuadrosTematicosService;
        vm.obterDadosTema = obterDadosTema;
        vm.obterQuadrosTematicos = obterQuadrosTematicos;
        vm.loadQuadros = loadQuadros;
        vm.getSelectedPreviously = getSelectedPreviously;
        vm.buildQuadroPromise = buildQuadroPromise;
        vm.apiGerenciador = apiGerenciador;
        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;
        vm.urlImagens = ArquivoUrlService.IMAGENS;

        vm.loadQuadros();
    }

    /**
     * Obtem o quadro previamente selecionado.
     * @returns Quadro.
     */
    function getSelectedPreviously() {
        var params = this.$location.search();
        var param = Object.keys(params)[0];

        var quadro = this.quadros.filter(function(quadro) {
            return quadro.quadroId == param;
        })[0];

        return quadro ? quadro : this.quadros[0];
    }

    /**
     * Altera o indicativo do quadro atualmente selecionado.
     * @param {*} quadro Quadro.
     */
    function changeSelectedQuadro(quadro) {
        var currUrl = Object.keys(this.$location.search())[0];

        if (currUrl) {
            this.$location.search(String(this.quadros.indexOf(quadro) + 1));
        }
    }

    /**
     * Carrega os quadros.
     */
    function loadQuadros() {
        var self = this;

        self.loading = true;
        self.error = false;
        this.obterQuadrosTematicos().then(function(data) {
            self.anoAtual = data.anos[0];
            self.quadros = data.quadros;
            self.$timeout(function() {
                self.setCurrentQuadro(self.getSelectedPreviously());
            });
        }, function(err) {
            self.error = true;
        }).finally(function() {
            self.loading = false;
        });
    }

    /**
     * Obtem os quadros temáticos.
     */
    function obterQuadrosTematicos() {
        var self = this;

        return this.QuadrosTematicosService.obterTemas().then(function(data) {
            return {
                quadros: data.temas.map(function(tema, i) {
                    return {
                        quadroId: tema.codigoFuncao,
                        imgId: 'img_' + tema.codigoFuncao,
                        title: tema.nomeFuncao,
                        imgSrc: self.urlImagens + tema.caminhoImagemBackground,
                        iconSrc: tema.icon ? tema.icon.icon : 'assets/img/temas/icons/faqs.svg',
                        pngIcon: tema.icon.pngIcon ? true : false,
                        page: 1
                    };
                }),
                anos: data.anos
            };
        });
    }

    /**
     * Obtem os dados referentes a um quadro temático.
     * @param {*} quadro Quadro temático.
     */
    function obterDadosTema(quadro, page) {
        return this.QuadrosTematicosService.obterDados(quadro, page, this.anoAtual).then(function(dados) {
            return {
                total: dados.data.total,
                projetos: dados.data.funcoes.map(function(funcao) {
                    return {
                        nome: funcao.nomeProjeto,
                        valor: funcao.valorLiquidado
                    };
                })
            };

        });
    }

    /**
     * Constrói uma função que obtem os dados de um quadro.
     * @param {*} quadro Quadro.
     */
    function buildQuadroPromise(quadro) {
        var self = this;
        return function(page) {
            quadro.loading = true;
            return self.$timeout(1000).then(function() {
                return self.obterDadosTema(quadro, page);
            }).then(function(dados) {
                return dados;
            }).finally(function() {
                quadro.loading = false;
            });
        };
    }

    /**
     * Responde ao evento de swipe sobre o painel de quadros.
     * @param {*} direction Constante que identifica a direção do gesto.
     */
    function onSwipeListener(direction) {
        var currentIndex = this.quadros.indexOf(this.currentQuadro);
        var quadro = null;

        if (direction == 'l') {
            quadro = next(this.quadros, currentIndex);
        } else if (direction == 'r') {
            quadro = prev(this.quadros, currentIndex);
        }

        if (quadro) {
            this.setCurrentQuadro(quadro);
        }

        this.$scope.$apply();
    }

    /**
     * Responde ao evento em que um quadro é apresentado.
     * @param {*} quadro Quadro.
     */
    function onQuadroShow(quadro) {
        this.changeSelectedQuadro(quadro);

        if (quadro.promise == undefined) {
            quadro.promise = this.buildQuadroPromise(quadro);
        }
    }

    /**
     * Responde ao evento de click em um indicator.
     * @param {*} quadro Quando referente ao indicator.
     */
    function onClickIndicator(quadro) {
        this.setCurrentQuadro(quadro);
    }

    /**
     * Configura um quadro como o corrente.
     * @param {*} quadro Quadro.
     */
    function setCurrentQuadro(quadro) {
        if (this.currentQuadro != undefined && this.quadros.length > 1) {
            var quadros = this.quadros.map(function(q) {
                return q.quadroId;
            });

            slide(this.currentQuadro.quadroId, quadro.quadroId, quadros);

            this.currentQuadro.current = false;
        } else if (this.currentQuadro == undefined) {
            $('#' + quadro.quadroId).fadeIn();
        }

        switchImage(this.currentQuadro ? this.currentQuadro.imgId : null, quadro.imgId);

        this.currentQuadro = quadro;
        quadro.current = true;

        this.onQuadroShow(quadro);
    }

    /**
     * Alterna a exibição dentre duas imagens.
     * @param {*} current Imagem em corrente apresentação.
     * @param {*} next Próxima imagem a ser exibida.
     */
    function switchImage(current, next) {
        $('#' + current).fadeOut();
        $('#' + next).fadeIn();
    }

    /**
     * Obtem o próximo elemento de um array.
     */
    function next(elements, currentIndex) {
        if (elements.length > 1) {
            var nextIndex = 0;

            if (currentIndex < elements.length - 1) {
                nextIndex = currentIndex + 1;
            }

            return elements[nextIndex];
        }

        return null;
    }

    /**
     * Obtem o elemento anterior de um array.
     */
    function prev(elements, currentIndex) {
        if (elements.length > 1) {
            var nextIndex = elements.length - 1;

            if (currentIndex > 0) {
                nextIndex = currentIndex - 1;
            }

            return elements[nextIndex];
        }

        return null;
    }

    /**
     * Realiza o slide entre elementos.
     * @param {*} current Elemento corrente.
     * @param {*} next Próximo elemento.
     * @param {*} elements Elementos.
     */
    function slide(current, next, elements) {
        function animateSlide(current, next, slideType) {
            var speed = 300;
            if (slideType == 'right-to-left') {
                $('#' + current).toggle('slide', {direction: 'left'}, speed);
                $('#' + next).toggle('slide', {direction: 'right'}, speed);
            } else {
                $('#' + current).toggle('slide', {direction: 'right'}, speed);
                $('#' + next).toggle('slide', {direction: 'left'}, speed);
            }
        }

        var nextIndex = elements.indexOf(next);
        var currentIndex = elements.indexOf(current);

        if (next && current && currentIndex != nextIndex) {
            if (nextIndex == 0 && currentIndex == elements.length - 1 && elements.length > 2) {
                animateSlide(current, next, 'right-to-left');
            } else if (currentIndex == 0 && nextIndex == elements.length - 1 && elements.length > 2) {
                animateSlide(current, next, 'left-to-right');
            } else if (nextIndex < currentIndex) {
                animateSlide(current, next, 'left-to-right');
            } else if (nextIndex > currentIndex) {
                animateSlide(current, next, 'right-to-left');
            }
        }
    }

})();

(function () {
    'use strict';
  
    angular.module('portal').service('QuadrosTematicosService', QuadrosTematicosService);

    /**
     * Fornece serviços para a funcionalidade que quadros temáticos.
     */
    function QuadrosTematicosService($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.obterTemas = obterTemas;
        _scope.obterDados = obterDados;
        _scope.api = api;
  
        return _scope;
    }

    /**
     * Obtem o conjunto de temas.
     */
    function obterTemas() {
        
        return this.$http({
            url: this.api.url + '/v2/paineis-despesa/temas-anos',
            method: 'GET'
        }).then(function(resp) {
            return {
                temas: resp.data.temas.map(function(tema, i) {
                    tema.icon = ICON_MAP.find(function(element) {
                        return element.id == tema.codigoFuncao; 
                    });
                    return tema;
                }),
                anos: resp.data.anos
            };
        });
    }

    var ICON_MAP = [
        {
            id: 10,
            icon: 'assets/img/temas/icons/health.svg'
        },{
            id: 26,
            icon: 'assets/img/temas/icons/transport.svg'
        },{
            id: 6, 
            icon: 'assets/img/temas/icons/security.svg'
        },{
            id: 12,
            icon: 'assets/img/temas/icons/education.svg'
        },{
            id: 4,
            icon: 'assets/img/temas/icons/administration.svg'
        },{
            id: 15,
            icon: 'assets/img/temas/icons/urban.svg'
        },{
            id: 14,
            icon: 'assets/img/temas/icons/citizenship.png',
            pngIcon: true
        },{
            id: 8,
            icon: 'assets/img/temas/icons/handshake.svg'
        }

    ];
        
    /**
     * Obtem o conjunto de dados associados a um tema.
     * @param {*} tema Quando temático.
     * @param {*} page Página em exibição.
     * @param {*} ano Exercício de referência.
     */
    function obterDados(tema, page, ano) {

        if (page == null || page == undefined) {
            page = 1;
        }
        return this.$http({
            url: this.api.url + '/v2/paineis-despesa',
            method: 'GET',
            params: {
                codigoFuncao: tema.quadroId,
                numeroPagina: page -1,
                exercicio: ano  
            }})
    }      
    /*
    function obterDados(tema, page) {
        if (page == null || page == undefined) {
            page = 1;
        }


        return this.$q.resolve({
            total: Math.floor(Math.random() * 9999999999) + 1,
            funcoes: PROJETOS.giveMe(4).map(function(desc) {
                return {
                    descricao: desc,
                    valor: Math.floor(Math.random() * 9999999999) + 1
                };
            })
        });
    }

    */
    /* 
    var PROJETOS = {
        giveMe: function(howMuch) {
            if (howMuch >= this.humanStuff.length) {
                return this.humanStuff.slice(0);
            }

            var collectedStuff = [];

            Array.apply(null, {length: howMuch}).reduce(function(stuff) {
                var elem = stuff[Math.floor(Math.random() * stuff.length)];
                var index = stuff.indexOf(elem);

                collectedStuff.push(elem);
                stuff.splice(index, index);

                return stuff;
            }, this.humanStuff.slice(0));

            return collectedStuff;
        },
        humanStuff: [
            'AQUISIÇÃO DE SERES HUMANOS',
            'ADMINISTRAÇÃO GERAL',
            'ASSISTÊNCIA HOSPITALAR E AMBULATORIAL',
            'VIGILÂNCIA SANITÁRIA',
            'ATENÇÃO BÁSICA',
            'ENSINO FUNDAMENTAL',
            'ENSINO MÉDIO',
            'EDUCAÇÃO INFANTIL',
            'SEGURANÇA PÚBLICA',
            'POLICIAMENTO',
            'CUSTÓDIA E REINTEGRAÇÃO SOCIAL',
            'CONCESSÃO DO PASSE LIVRE',
            'MANUTENÇÃO DA RODOVIÁRIA DO PLANO',
            'MANUTENÇÃO DO EQUILÍBRIO FINANCEIRO',
            'COMUNICAÇÃO SOCIAL',
            'ADMINISTRAÇÃO PESSOAL',
            'AQUISIÇÃO DE MEDICAMENTOS',
            'MANUTENÇÃO DE EQUIPAMENTOS',
            'CULTURA',
            'DIFUSÃO CULTURAL',
            'ASSISTÊNCIA COMUNITÁRIA',
            'ASSISTÊNCIA À CRIANÇA E AO ADOLESCENTE',
            'ALIMENTAÇÃO E NUTRIÇÃO'
        ]
    };

    */
})();
(function () {
    'use strict';

    angular.module('portal.receita').controller('ImpostosController', ImpostosController);

    /**
     * Controlador corresponde a tela que apresenta a receita decorrente dos principais impostos.
     * @param {*} $scope
     * @param {*} ReceitasService
     * @param {*} impostoPreSelecionado
     */
    /** @ngInject */
    function ImpostosController($scope, ReceitasService, DataAtualizacaoService, impostoPreSelecionado) {
        var vm = this;
        vm.$scope = $scope;
        vm.$scope.currentPanel = undefined;
        vm.buildPanelModel = buildPanelModel;
        vm.onDataSelected = onDataSelected;
        vm.ReceitasService = ReceitasService;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.obterDadosImposto = obterDadosImposto;
        vm.obterDataDeAtualizacao = obterDataDeAtualizacao;
        vm.impostos = ['ISS', 'ICMS', 'IPTU', 'ITBI', 'ITCD', 'IR', 'IPVA'];
        vm._onClickPanelLink = _onClickPanelLink;
        vm.buildPanelImposto = buildPanelImposto;
        //vm.texto = texto.data.texto;
        vm.onClickPanelLink = function (p) { vm._onClickPanelLink(p); };

        vm.panels = [
            vm.buildPanelImposto(impostoPreSelecionado, true)
        ].concat(
            vm.impostos.filter(function (i) {
                return i != impostoPreSelecionado;
            }).map(function (imposto) {
                return vm.buildPanelImposto(imposto, false);
            })
        );

        vm.obterDataDeAtualizacao().then(function (date) {
            vm.updateDate = date;
        });
    }

    /**
     * Obtem a data de atualização dos dados.
     * @returns Promise para a data.
     */
    function obterDataDeAtualizacao() {
        return this.DataAtualizacaoService.buscarDataAtualizacao('painel-receitas').then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento.
     * @param {*} panel Painel.
     * @param {*} categoria Categoria.
     */
    function onDataSelected(panel, categoria) {
        var ano = Number(categoria.dataLabel);
        var siglaImposto = panel.props.imposto;

        openDetalheImpostoAno(siglaImposto, ano);
    }

    /**
     * Responde ao evento de click no link correspondente a um painel.
     * @param {*} panel Painel.
     */
    function _onClickPanelLink(panel) {
        this.$scope.currentPanel = panel;
    }

    /**
     * Constrói o modelo do painel corresponde a um imposto.
     * @param {*} imposto Imposto.
     * @param {*} current Indicativo de que o painel é o corrente em exibição.
     */
    function buildPanelImposto(imposto, current) {
        var self = this;
        return this.buildPanelModel({
            imposto: imposto,
            title: imposto,
            promise: function () { return self.obterDadosImposto(imposto); }
        }, current);
    }

    /**
     * Constrói o modelo corresponde a um painel.
     * @param {*} props Propriedades do painel
     * @param {*} current Indicador para o estado de corrente do painel.
     * @returns Objeto que representa o modelo do painel.
     */
    function buildPanelModel(props, current) {
        var self = this;
        return {
            props: props,
            id: 'panel' + props.title,
            chartType: 'bar-chart',
            current: current ? true : false,
            initial: current ? true : false,
            title: '' + props.title,
            chartDataPromise: props.promise,
            destroy: function () {
                if (this.chartModel && this.chartModel.chart) {
                    this.chartModel.chart = this.chartModel.chart.destroy();
                    this.chartModel = undefined;
                }
            },
            onDataSelected: function (c) {
                self.onDataSelected(this, c);
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function (data) {
                var chartColors = ['#1ED6D6'];
                var panel = this;

                this.chartModel = {
                    chartId: 'chart' + props.title,
                    chartHeight: 340,
                    fnFormatData: formatData,
                    fnChartBuild: function (chart) { this.chart = chart; },
                    fnDataClickListener: function (v) { panel.onDataSelected(v); },
                    dimentions: data.map(function (d, index) {
                        return {
                            dataLabel: d.ano,
                            data: d.valor,
                            color: chartColors[index % chartColors.length]
                        };
                    })
                };
            }
        }
    }

    /**
     * Formata um valor a ser exibido no gráfico de um painel.
     * @param {*} v Valor.
     * @param {*} containerWidth Largura do container de conteúdo do painel.
     * @returns String referente ao valor a ser exibido.
     */
    function formatData(v, containerWidth) {
        if (v == 0) {
            return '0';
        }

        var mask = 'coinSimbol value desc';

        if (containerWidth) {
            if (containerWidth <= 500) {
                mask = 'value descShort';
            } else if (containerWidth <= 600) {
                mask = 'coinSimbol value descShort';
            }
        }

        var numberDesc = [
            {
                desc: 'bilhões',
                descSingle: 'bilhão',
                descShort: 'bi',
                value: 1000000000,
                divisor: 1000000000
            }, {
                desc: 'milhões',
                descSingle: 'milhão',
                descShort: 'mi',
                value: 1,
                divisor: 1000000
            }
        ];

        var desc = numberDesc.filter(function (desc) {
            return v >= desc.value;
        })[0];
        v = v / desc.divisor;

        var coinSimbol = 'R$';
        var value = String(v % parseInt(v) == 0 ? v : v.toFixed(1));
        var numberDescrition = v >= 2 ? desc.desc : desc.descSingle;
        var numberDescritionShort = desc.descShort;

        return mask.replace('coinSimbol', coinSimbol)
            .replace('value', value)
            .replace('descShort', numberDescritionShort)
            .replace('desc', numberDescrition);
    }

    /**
     * Obtem os dados correspondentes a arrecadação de um imposto.
     * @param {*} imposto Imposto.
     * @returns Promise para os dados.
     */
    function obterDadosImposto(imposto) {
        return this.ReceitasService.graficoEvolucaoImposto(imposto)
            .then(function (response) {
                return { data: parseImpostoData(response.data) };
            });
    }

    /**
     * Realiza o parse dos dados da arrecadação de um imposto.
     * @param {*} data Dados.
     */
    function parseImpostoData(data) {
        var keys = data.categoria;
        var values = data.colunas[0].slice(1);

        return keys.map(function (k, i) {
            return {
                ano: k,
                valor: values[i]
            };
        });
    }

    /**
     * Abre uma página de detalhamento de um imposto.
     * @param {*} siglaImposto Sigla do imposto
     * @param {*} anoExercicio ano.
     */
    function openDetalheImpostoAno(siglaImposto, anoExercicio) {
        var cols = "";

        ['nomeAlinea', 'nomeSubalinea', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual'].forEach(function (item) {
            cols += 'colunas=' + item + '&';
        });

        var url = "";
        if(anoExercicio <= 2018) {
            var codigoImpostoAlinea = getAlinea(siglaImposto);
            url = "#/receitas/consulta-dinamica?exercicio=" + anoExercicio + "&listaCodigoAlinea=" + codigoImpostoAlinea + "&" + cols;
        } else {
            var codigoNaturezaReceita = getAlineaMaior2019(siglaImposto);
            url = "#/receitas/consulta-dinamica?exercicio=" + anoExercicio + "&listaCodigoNaturezaReceita=" + codigoNaturezaReceita + "&" + cols;
        }

        window.open(url, '_blank');
    }

    /**
     * Obtem o código corresponde a um imposto.
     * @param {*} siglaImposto Sigla do imposto
     */
    function getAlinea(siglaImposto) {
        switch (siglaImposto) {
            case "ITBI":
                return "111208";
            case "ICMS":
                return "111302";
            case "IPVA":
                return "111205";
            case "IR":
                return "111204";
            case "ITCD":
                return "111207";
            case "IPTU":
                return "111202";
            case "ISS":
                return "111305";
            default:
                return null;
        }
    }

    /**
     * Obtem o código corresponde a um imposto cujo ano é igual ou superior a 2019.
     * Caso ocorre alterações do código incluir.
     * @param {*} siglaImposto Sigla do imposto
     */
    function getAlineaMaior2019(sigla) {
        switch (sigla) {
            case "ITBI":
                return "1118014, 7118014, 1112530,7112530";
            case "ICMS":
                return "1118021, 7118021, 1118022, 7118022, 1114501, 7114501,1114502,7114502  ";
            case "IPVA":
                return "1118012, 7118012, 1112510, 7112510";
            case "IR":
                return "1113, 7113";
            case "ITCD":
                return "1118013, 7118013, 1112520,7112520 ";
            case "IPTU":
                return "1118011, 7118011, 1112500, 7112500 ";
            case "ISS":
                return "1118023, 7118023, 1118024, 7118024, 1114511, 7114511, 1114512, 7114512";
            default:
                return null;
        }
    }

})();

(function () {
    'use strict';

    angular.module('portal.receita').controller('MultasTransitoController', RemuneracaoController);

    /** @ngInject */
    function RemuneracaoController($scope, $aside, ReceitasService, RelatorioService, anos, dataAtualizacao) {

        var vm = this;

        vm.anos = anos.data;
        vm.data = [];
        vm.contador = 0;
        vm.dataAtualizacao = dataAtualizacao;

        var colunas = {
            natureza: { nome: "Origem", visible: true },
            orgaoEmissor: { nome: "Orgão Emissor", visible: true },
            valorRealizadoMultas: { nome: "Receita Realizada", visible: true, currency: true },
        };

        $scope.colunas = colunas;

        // settings
        vm.settings = {
            singular: 'Multa de Trânsito',
            plural: 'Multas de Trânsito'
        };

        vm.item = {
            ano: anos.data[0],
            busy: false,
            editing: true,
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/receitas/multas-transito-form.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.item = {
                busy: false,
                editing: true
            };
        };

        vm.exibirFormPesquisa = function () {
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showForm();
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                showForm();
            }
        };

        vm.init = function () {
            vm.search();
        };

        vm.search = function () {
            $scope.filter = angular.copy(vm.item);
        };

        var showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = colunas;
                vm.item.tipo = $scope.dados.form.tipo;
                RelatorioService.exportar('/receita/relatorio/multas', vm.item);
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

    }

})();

(function () {
    'use strict';

    angular.module('portal.receita').controller('ReceitaDashboardController', Controller);

    /**
     * Controlador corresponde a tela que apresenta o dashboard de receitas.
     */
    /** @ngInject */
    function Controller($scope, $location, $q, $timeout, DataAtualizacaoService, ReceitasService) {
        var vm = this;
        vm.$q = $q;
        vm.$timeout = $timeout;
        vm.ReceitasService = ReceitasService;
        vm.$location = $location;
        vm.$scope = $scope;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.obterDataDeAtualizacao = obterDataDeAtualizacao;
        vm.getCurrentPanel = getCurrentPanel;
        vm.isAnoSelecionavel = isAnoSelecionavel;
        vm.obterAnosReceita = obterAnosReceita;
        vm.beforeLoadPanel = beforeLoadPanel;
        vm.buildPromiseSupplier = buildPromiseSupplier;
        vm.onClickAnoLink = onClickAnoLink;
        vm.anoSelecionado = undefined;
        vm.anosReceita = [];
        //vm.texto = texto.data.texto;
        vm.anosReceitaLoadPromise = vm.obterAnosReceita().then(function (anos) {
            vm.anosReceita = anos;

            if (vm.anoSelecionado == undefined) {
                vm.anoSelecionado = vm.anosReceita[0];
            }
        });

        vm.obterDataDeAtualizacao().then(function (date) {
            vm.updateDate = date;
        });

        vm.panels = [
            ['panelEvoAnual', onDataSelectedEvoAnual, function (ano) {
                return ReceitasService.graficoEvolucaoReceita(ano);
            }],
            ['panelReceitaCategoria', onDataSelectedReceitaCategoria, function (ano) {
                return ReceitasService.graficoReceitaCategoria(ano);
            }],
            ['panelReceitaCorrente', onDataSelectedReceitaCorrente, function (ano) {
                return ReceitasService.graficoReceitasCorrentes(ano);
            }],
            ['panelReceitaImpostos', onDataSelectedReceitaImpostos, function (ano) {
                return ReceitasService.graficoImpostos(ano);
            }],
            ['panelReceitaTributaria', onDataSelectedReceitaTributaria, function (ano) {
                return $q.all([ReceitasService.graficoPercentualImpostos(ano), ReceitasService.graficoPercentualTaxas(ano)]).then(function (resps) {
                    return resps.map(function (resp) {
                        return resp.data;
                    });
                });
            }]
        ].map(function (panelIdAndData) {
            var panel = findPanelById(panelIdAndData[0], PANELS);

            panel.chartDataPromise = vm.buildPromiseSupplier(panel, panelIdAndData[2]);
            panel.onDataSelected = function () {
                panelIdAndData[1].apply(vm, arguments);
            };

            return panel;
        });
    }

    /**
     * Retorna uma promise para tarefas que precisão ser executadas antes de carregar um painel.
     * @param {*} panel Painel
     * @returns Promise.
     */
    function beforeLoadPanel(panel) {
        var delayPromise = this.$timeout(300);

        if (panel.isAnoSelecionavel) {
            return delayPromise.then(this.anosReceitaLoadPromise);
        }

        return delayPromise;
    }

    /**
     * Constrói um supplier para a promise de carregamento de um painel.
     * @param {*} panel Painel.
     * @param {*} service Serviço que fornece os dados do painel.
     * @param {*} method Método do serviço que fornece os dados.
     */
    function buildPromiseSupplier(panel, dataPromiseSupplier) {
        var self = this;

        return function () {
            return self.beforeLoadPanel(panel).then(function () {
                return dataPromiseSupplier(panel.isAnoSelecionavel ? self.anoSelecionado : undefined)
                    .then(function (resp) {
                        return {
                            data: {
                                anoSelecionado: self.anoSelecionado,
                                data: resp.data != undefined ? resp.data : resp
                            }
                        };
                    });
            });
        };
    }

    /**
     * Responde ao evento de seleção de um ano.
     * @param {*} ano Ano selecionado.
     */
    function onClickAnoLink(ano) {
        this.anoSelecionado = ano;

        var currentPanel = this.getCurrentPanel();

        if (currentPanel.isAnoSelecionavel) {
            currentPanel.reload();
        }

        this.panels.filter(function (panel) {
            return panel != currentPanel && panel.isAnoSelecionavel;
        }).forEach(function (panel) {
            panel.invalidadeLoad();
        });
    }

    /**
     * Diz se o ano é selecionável de acordo com o painel em exibição.
     * @returns true, ano pode ser selecionado; false, caso contrário.
     */
    function isAnoSelecionavel() {
        var panel = this.getCurrentPanel();

        if (panel) {
            return panel.isAnoSelecionavel;
        }

        return false;
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de evolução anual.
     * @param {*} ano Ano da categoria.
     */
    function onDataSelectedEvoAnual(ano) {
        this.ReceitasService.store({
            anoExercicio: ano
        });

        this.$location.path('/receitas/por-orgao');
        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de receita por categoria.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedReceitaCategoria(categoria) {
        this.$location.path('/receitas/consulta-dinamica').search({
            exercicio: this.anoSelecionado,
            listaCodigoCategoriaEconomica: categoria,
            colunas: ['nomeCategoriaEconomica', 'nomeFonte', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
        });

        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de receita corrente.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedReceitaCorrente(categoria) {
        this.$location.path('/receitas/consulta-dinamica').search({
            exercicio: this.anoSelecionado,
            nomeFonte: categoria,
            colunas: ['nomeFonte', 'nomeSubfonte', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
        });

        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento no gráfico de receita de impostos.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedReceitaImpostos(categoria) {
        var ano = this.anoSelecionado;

        var list = ano <= 2018 ? getAlinea(categoria.dataLabel) : getAlineaMaior2019(categoria.dataLabel);

        this.$location.path('/receitas/consulta-dinamica').search({
            exercicio: ano,
            listaCodigoAlinea: list,
            teste: true,
            colunas: ['nomeAlinea', 'nomeSubalinea', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
        });

        this.$scope.$apply();
    }

    /**
     * Responde ao evento de seleção de uma categoria para detalhamento nos gráficos de receita tributária.
     * @param {*} categoria Categoria selecionada.
     */
    function onDataSelectedReceitaTributaria(categoria) {
        this.$location.path('/receitas/consulta-dinamica').search({
            exercicio: this.anoSelecionado,
            listaCodigoSubfonte: categoria,
            colunas: ['nomeRubrica', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
        });
        this.$scope.$apply();
    }

    /**
     * Obtem a data de atualização dos dados.
     * @returns Promise para a data.
     */
    function obterDataDeAtualizacao() {
        return this.DataAtualizacaoService.buscarDataAtualizacao('painel-receitas').then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Obtem os anos em que dados de receita foram contabilizados.
     * @returns Promise para a data.
     */
    function obterAnosReceita() {
        return this.ReceitasService.listarAnos().then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Obtem o painel correspondente a um ID.
     * @param {*} panelId ID.
     * @param {*} panels Paineis.
     * @returns Panel correspondente; undefined, caso o mesmo não seja encontrado.
     */
    function findPanelById(panelId, panels) {
        return panels.filter(function (panel) {
            return panel.id == panelId;
        })[0];
    }

    /**
     * Obtem o corrente painel em exibição.
     */
    function getCurrentPanel() {
        if (this.panels && this.panels.length > 0) {
            return this.panels.filter(function (panel) {
                return panel.current == true;
            })[0];
        }

        return undefined;
    }

    var PANELS = [
        {
            id: 'panelEvoAnual',
            chartType: 'evolution-chart',
            isAnoSelecionavel: false,
            current: true,
            initial: true,
            title: 'Evolução Anual da Receita',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function () {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function (serviceData) {
                var chartColors = ['#1ED6D6', '#0e7eca'];
                var panel = this;

                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartEvoAnual',
                    chartHeight: 300,
                    minScaleValue: 0,
                    fnTickSequenceBy: function () { return 5; },
                    fnFormatData: function (v) { return 'R$ ' + parseInt(v) + ' bilhões'; },
                    fnFormatTooltip: function (v) { return 'R$ ' + v.toFixed(1) + ' bilhões'; },
                    fnChartBuild: function (chart) { this.chart = chart; },
                    fnDataClickListener: function (v, d) { panel.onDataSelected(v, d); },
                    dimentions: [
                        {
                            type: 'area',
                            label: 'previsto',
                            color: chartColors[0 % chartColors.length],
                            data: data.categoria.map(function (ano, index) {
                                return [ano, data.previsto[index + 1] / 1000000000];
                            })
                        }, {
                            type: 'area',
                            label: 'realizado',
                            color: chartColors[1 % chartColors.length],
                            data: data.categoria.map(function (ano, index) {
                                return [ano, data.realizado[index + 1] / 1000000000];
                            })
                        }
                    ]
                };
            }
        }, {
            id: 'panelReceitaCategoria',
            chartType: 'evolution-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: 'Receita por Categoria',
            panelTitle: 'Receita por Categoria',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function () {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function (serviceData) {
                var chartColors = ['#1ED6D6', '#0e7eca'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;
                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartReceitaCategoria',
                    chartHeight: 300,
                    fnTickSequenceBy: function () { return 5; },
                    fnFormatData: function (v) { return 'R$ ' + parseInt(v) + ' bilhões'; },
                    fnFormatTooltip: function (v) { return 'R$ ' + v.toFixed(1) + ' bilhões'; },
                    fnChartBuild: function (chart) { this.chart = chart; },
                    fnDataClickListener: function (v, d) { panel.onDataSelected(v, d); },
                    dimentions: [
                        {
                            label: 'previsto',
                            color: chartColors[0 % chartColors.length],
                            data: data.categoria.map(function (ano, index) {
                                return [ano, data.previsto[index + 1] / 1000000000];
                            })
                        }, {
                            label: 'realizado',
                            color: chartColors[1 % chartColors.length],
                            data: data.categoria.map(function (ano, index) {
                                return [ano, data.realizado[index + 1] / 1000000000];
                            })
                        }
                    ]
                };
            }
        }, {
            id: 'panelReceitaCorrente',
            chartType: 'area-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: 'Receita Correntes',
            panelTitle: 'Receitas Correntes',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            loadHideContent: true,
            destroy: function () {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function (serviceData) {
                var chartColors = ['#1ED6D6', '#1F7DC0', '#65A0CE', '#229396', '#50597B', '#FFD200', '#D14C39', '#E64C65'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;
                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartReceitaCorrente',
                    chartHeight: 340,
                    fnFormatData: function (ratio) { return (ratio * 100).toFixed(1).toString().replace('.', ','); },
                    fnChartBuild: function (chart) { this.chart = chart; },
                    fnChartShow: function () { panel.onShow(); },
                    fnDataClickListener: function (v) { panel.onDataSelected(v); },
                    dimentions: data.map(function (d, index) {
                        return {
                            dataLabel: d[0].toLowerCase(),
                            data: d[1],
                            color: chartColors[index % chartColors.length]
                        };
                    })
                };
            }
        }, {
            id: 'panelReceitaImpostos',
            chartType: 'bar-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: 'Receitas de impostos',
            panelTitle: 'Receitas de impostos',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function () {
                if (this.chartModel) {
                    if (this.chartModel.chart) {
                        this.chartModel.chart.destroy();
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
            },
            buildModel: function (serviceData) {
                var chartColors = ['#1ED6D6', '#0e7eca'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;
                var data = serviceData.data;

                this.chartModel = {
                    chartId: 'chartReceitaImpostos',
                    chartHeight: 300,
                    fnFormatData: formatData,
                    useColorPattern: true,
                    fnChartBuild: function (chart) { this.chart = chart; },
                    fnDataClickListener: function (v) { panel.onDataSelected(v); },
                    dimentions: data.categoria.map(function (imposto, index) {
                        return {
                            dataLabel: imposto,
                            color: chartColors[index % chartColors.length],
                            data: [
                                {
                                    division: 'previsto',
                                    value: data.previsto[index + 1]
                                }, {
                                    division: 'realizado',
                                    value: data.realizado[index + 1]
                                }
                            ]
                        };
                    })
                };
            }
        }, {
            id: 'panelReceitaTributaria',
            chartType: 'multi-gauge-chart',
            isAnoSelecionavel: true,
            current: false,
            initial: false,
            title: 'Receita Tributária',
            panelTitle: 'Receita Tributária',
            chartDataPromise: undefined,
            onDataSelected: undefined,
            destroy: function () {
                if (this.chartModel) {
                    if (this.chartModel.charts) {
                        this.chartModel.charts.forEach(function (c) {
                            c.chart.destroy();
                        });
                    }

                    this.chartModel = undefined;
                }
            },
            onShow: function () {
                if (this.chartModel && this.chartModel.charts) {
                    this.chartModel.charts.forEach(function (c) {
                        c.chart.flush();
                    });
                }
            },
            buildModel: function (serviceData) {
                var chartColors = ['#1ED6D6'];
                var panel = this;

                panel.title = panel.panelTitle + ' - ' + serviceData.anoSelecionado;

                this.chartModel = {
                    charts: [{
                        chartId: 'chartReceitaTributariaImpostos',
                        legend: 'Impostos',
                        dataLabel: 'Impostos',
                        data: serviceData.data[0],
                        categoria: 111
                    }, {
                        chartId: 'chartReceitaTributariaTaxas',
                        legend: 'Taxas',
                        dataLabel: 'Taxas',
                        data: serviceData.data[1],
                        categoria: 112
                    }].map(function (props) {
                        return {
                            chartId: props.chartId,
                            chartHeight: 170,
                            chartWidth: 250,
                            legend: props.legend,
                            fnChartBuild: function (chart) { this.chart = chart; },
                            fnDataClickListener: function (v) { panel.onDataSelected(props.categoria); },
                            dimentions: [{
                                dataLabel: props.dataLabel,
                                color: chartColors[0],
                                data: props.data
                            }]
                        };
                    })
                };
            }
        }
    ];

    /**
     * Formata um valor a ser exibido no gráfico de um painel.
     * @param {*} v Valor.
     * @param {*} containerWidth Largura do container de conteúdo do painel.
     * @returns String referente ao valor a ser exibido.
     */
    function formatData(v, containerWidth) {
        if (v == 0) {
            return '0';
        }

        var mask = 'coinSimbol value desc';

        if (containerWidth) {
            if (containerWidth <= 500) {
                mask = 'value descShort';
            } else if (containerWidth <= 600) {
                mask = 'coinSimbol value descShort';
            }
        }

        var numberDesc = [
            {
                desc: 'bilhões',
                descSingle: 'bilhão',
                descShort: 'bi',
                value: 1000000000,
                divisor: 1000000000
            }, {
                desc: 'milhões',
                descSingle: 'milhão',
                descShort: 'mi',
                value: 1,
                divisor: 1000000
            }
        ];

        var desc = numberDesc.filter(function (desc) {
            return v >= desc.value;
        })[0];
        v = v / desc.divisor;

        var coinSimbol = 'R$';
        var value = String(v % parseInt(v) == 0 ? v : v.toFixed(1));
        var numberDescrition = v >= 2 ? desc.desc : desc.descSingle;
        var numberDescritionShort = desc.descShort;

        return mask.replace('coinSimbol', coinSimbol)
            .replace('value', value)
            .replace('descShort', numberDescritionShort)
            .replace('desc', numberDescrition);
    }

    function getAlinea(siglaImposto) {
        switch (siglaImposto) {
            case "ITBI":
                return "111208";
            case "ICMS":
                return "111302";
            case "IPVA":
                return "111205";
            case "IR":
                return "111204";
            case "ITCMD":
                return "111207";
            case "IS":
                return "111306";
            case "IPTU":
                return "111202";
            case "ISS":
                return "111305";
            default:
                return null;
        }
    }

    function getAlineaMaior2019(sigla) {
        switch (sigla) {
            case "ITBI":
                return "11180141";
            case "ICMS":
                return "11180211, 11180221";
            case "IPVA":
                return "11180121";
            case "IR":
                return "11130111, 11130211, 11130311";
            case "ITCMD":
                return "11180131";
            case "IPTU":
                return "11180111";
            case "ISS":
                return "11180231";
            default:
                return null;
        }
    }

})();

/**
 * Created by Basis Tecnologia on 27/01/2016.
 */
(function () {
  'use strict';

  angular.module('portal.receita').controller('ReceitaController', ReceitaController);

  /** @ngInject */
  function ReceitaController($scope, $aside, $location, RelatorioService,
                             anos, unidadesGestoras, categoria,
                             fontes, subfontes, alineas, subalineas, rubricas, ReceitasService, dataAtualizacao) {

    var vm = this;

    vm.anos = anos.data.map(function(a) { return String(a); });
    vm.unidadesGestoras = unidadesGestoras.data;
    vm.fontes = fontes.data;
    vm.subfontes = subfontes.data;
    vm.alineas = alineas.data;
    vm.subalineas = subalineas.data;
    vm.rubricas = rubricas.data;
    vm.categoria = categoria.data;
    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      unidadeGestora: {nome: "Unidade Gestora", visible: true, disabled: true , termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos."},
      ano: {nome: "Exercício", visible: true , termo:"Ano relativo às informações.", center: true },
      categoria: {nome: "Categoria", visible: false , termo:"Classificação das receitas e despesas para uma avaliação do efeito econômico."},
      fonte: {nome: "Origem", visible: false , termo:"Subdivisão da categoria que indica a procedência dos recursos."},
      subfonte: {nome: "Espécie", visible: false , termo:"Subdivisão da origem que permite qualificar com maior detalhe o fato gerador das receitas."},
      rubrica: {nome: "Rubrica", visible: false , termo:"Detalha a espécie por meio da especificação dos recursos financeiros que lhe são correlatos."},
      alinea: {nome: "Alínea", visible: false , termo:'"Nome” da receita que receberá o registro pela entrada de recursos financeiros.'},
      subalinea: {nome: "Subalínea", visible: false , termo:"Detalhamento da alínea com maior especificidade."},
      valorPrevistoOrgao: {nome: "Receita Prevista", visible: true, currency: true , termo:"Valor que o governo espera receber em um determinado período."},
      valorRealizadoOrgao: {nome: "Receita Realizada", visible: true, currency: true , disabled: true,  termo:"Valor que foi efetivamente recebido pelo governo."},
      percentualRealizado: {nome: "% Realizado", visible: true, currency: true , termo:"Proporção da receita arrecadada em relação à previsão."}
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Receita',
      plural: 'Receitas'
    };

    vm.item = {
      ano: vm.anos[0].toString(),
      busy: false,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    /**
     * Executado na inicialização
     */
    vm.init = function() {
      vm.assignInitParams($location.search());
      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function(params) {
      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignSelect(vm.unidadesGestoras, vm.item, 'listaCodigoUnidadeGestora', params['orgao'], 'nome', 'codigo', true);
      assignSelect(vm.anos, vm.item, 'ano', params['exercicio'], undefined, undefined, false);
    };

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/receitas/receita-por-orgao-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/receitas/receita-por-orgao-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.item = {
        busy: false,
        editing: true
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFormFiltro();
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.linha = linha;
        showFormDetalhamento();
      }
    };

    vm.search = function () {
      var stored=ReceitasService.getStored();
      if(stored){
        vm.item.ano=stored.anoExercicio;
      }
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    var showFormFiltro = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
    };

    $scope.hideForm = function () {
      formDetalhamentoTpl.hide();
      formFiltroTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/receita/relatorio/por-orgao', vm.item);
      }
    };

    $scope.fecharModalColunas = function () {
      vm.search();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal.receita').service('ReceitasService', Service);

  function Service($http, api) {

    var dataStored;
    var service = {};
    var serviceConfig = {cache: true};

    service.store = function (data) {
      dataStored = data;
    }

    service.getStored = function () {
      var data = dataStored;
      dataStored = null;
      return data;
    }
    service.listasMultasTransito = function (obj) {
      return $http({
        url: api.url + '/receita/multas',
        method: 'GET',
        params: obj
      });
    };

    service.totalMultasTransito = function (ano) {
      return $http({
        url: api.url + '/receita/multas/total',
        method: 'GET',
        params: {ano: ano}
      });
    };

    service.listarPorOrgao = function (obj) {
      return $http({
        url: api.url + '/receita/por-orgao',
        method: 'GET',
        params: obj
      });
    };

    service.listarAnosMultasTransito = function () {
      return $http.get(api.url + '/receita/multas/anos', serviceConfig);
    };

    service.listarAnos = function () {
      return $http.get(api.url + '/receita/anos', serviceConfig);
    };

    service.listarGestao = function () {
      return $http.get(api.url + '/receita/gestao', serviceConfig);
    };

    service.listarCategoria = function () {
      return $http.get(api.url + '/receita/categoria', serviceConfig);
    };

    service.listarUnidadeGestora = function () {
      return $http.get(api.url + '/receita/unidade-gestora', serviceConfig);
    };

    service.listarFonte = function () {
      return $http.get(api.url + '/receita/fonte', serviceConfig);
    };

    service.listarSubFonte = function () {
      return $http.get(api.url + '/receita/sub-fonte', serviceConfig);
    };

    service.listarRubrica = function () {
      return $http.get(api.url + '/receita/rubrica', serviceConfig);
    };

    service.listarAlinea = function () {
      return $http.get(api.url + '/receita/alinea', serviceConfig);
    };

    service.listarSubAlinea = function () {
      return $http.get(api.url + '/receita/sub-alinea', serviceConfig);
    };

    service.graficoEvolucaoReceita = function () {
      return $http.get(api.url + '/receita/grafico/evolucao', serviceConfig);
    };

    service.graficoImpostos = function (exercicio) {
      return $http({
        url: api.url + '/receita/grafico/impostos',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.graficoReceitasCorrentes = function (exercicio) {
      return $http({
        url: api.url + '/receita/grafico/receitas-correntes',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.graficoReceitaCategoria = function (exercicio) {
      return $http({
        url: api.url + '/receita/grafico/receita-categoria',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.graficoPercentualImpostos = function (exercicio) {
      return $http({
        url: api.url + '/receita/grafico/percentual/impostos',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.graficoPercentualTaxas = function (exercicio) {
      return $http({
        url: api.url + '/receita/grafico/percentual/taxas',
        method: 'GET',
        params: {
          exercicio: exercicio
        },
        cache: true
      });
    };

    service.graficoEvolucaoImposto = function (imposto) {
      return $http({
        url: api.url + '/receita/grafico/evolucao-imposto',
        method: 'GET',
        params: {
          imposto: imposto
        },
        cache: true
      });
    };

     service.listarReceitaAuxilioUniaoExercicio = function(){
          return $http.get(api.url + '/receita/fonte-recurso/exercicio', serviceConfig);
    }
    service.listarFonteRecurso = function (){
      return $http.get(api.url + '/receita/fonte-recurso/filtro-recurso', serviceConfig);
    }

     service.listarPorUniao = function (obj) {
        return $http({
          url: api.url + '/receita-uniao/transferencia',
          method: 'GET',
          params: obj
        });
      };

      service.listarAnos = function () {
        return $http.get(api.url + '/receita-uniao/anos', serviceConfig);
      };

      service.listarUnidadeGestora = function () {
        return $http.get(api.url + '/receita-uniao/unidade-gestora', serviceConfig);
      };

      service.listarRubrica = function () {
        return $http.get(api.url + '/receita-uniao/rubrica', serviceConfig);
      };

      service.listarAlinea = function () {
        return $http.get(api.url + '/receita-uniao/alinea', serviceConfig);
      };

      service.listarSubAlinea = function () {
        return $http.get(api.url + '/receita-uniao/sub-alinea', serviceConfig);
      };

      service.listarCategoria = function () {
        return $http.get(api.url + '/receita-uniao/categoria', serviceConfig);
      };

      service.listarOrigem = function () {
       return $http.get(api.url + '/receita-uniao/origem', serviceConfig);
      };


    return service;

  }

})();

(function () {
    'use strict';

    angular.module('portal').controller('CadastroExpulsoesController', CadastroExpulsoesController);

    /** @ngInject */
    function CadastroExpulsoesController($scope, $location, RelatorioService, listaAno,
        $aside, orgaos, punicoes, cargos, dataAtualizacao) {

        var vm = this;
        vm.orgaos = orgaos.data;
        vm.punicoes = punicoes.data;
        vm.cargos = cargos.data;
        vm.data = [];
        vm.contador = 0;
        vm.listaAno = listaAno;
        vm.dataAtualizacao = dataAtualizacao;

        var colunas = {
            nomeServidor: { nome: "Nome", visible: true, termo: "Nome completo do servidor" },
            numeroMatricula: { nome: "Matrícula", visible: true, termo: "Nº de registro do servidor no órgão" },
            nomeCargo: { nome: "Cargo", visible: true, termo: "Posição que o servidor ocupa no órgão de forma permanente" },
            nomeOrgao: { nome: "Órgão", visible: true, termo: "Órgão vinculado ao servidor" },
            punicao: { nome: "Punição", visible: true, termo: "Tipo de sanção aplicada ao servidor" },
            dataPublicacao: { nome: "Data", visible: true, termo: "Data da publicação da punição no Diário Oficial do DF" },
            motivoPunicao: { nome: "Motivo", visible: false, termo: "Causa da punição" },
            fundamentoLegal: { nome: "Fundamento Legal", visible: false, termo: "Legislação pertinente ao assunto" },
            numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à punição" },
            ano: { nome: "Ano", visible: false, termo: "Ano de referência", center: true },
            dataFinalPublicacao: { nome: "Data Final", visible: false, date: true, termo: "Data de término da punição" }
        };

        $scope.colunas = colunas;

        // settings
        vm.settings = {
            singular: 'Servidor',
            plural: 'Servidores'
        };

        vm.item = {
            busy: false,
            editing: true,
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        vm.init = function () {

            vm.assignInitParams($location.search());

            $scope.filter = angular.copy(vm.item);
        };

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         */
        vm.assignInitParams = function (params) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return elem[compareProp] == param; })[0];

                    if (element != null) {
                        modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
                    }
                }
            };

            assignProps([{ from: 'nome', to: 'nomeServidor', type: String }], params, vm.item);
            assignProps([{ from: 'exercicio', to: 'ano', type: Number }], params, vm.item);
            assignSelect(vm.orgaos, vm.item, 'nomeOrgao', params['orgao'], 'nome', 'nome', false);
        };

        // defining template
        var formDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/servidores/cadastro-expulsoes-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formFiltro = $aside({
            scope: $scope,
            template: 'app/components/servidores/cadastro-expulsoes-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.item = {
                busy: false,
                editing: true
            };
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = colunas;
                vm.item.tipo = $scope.dados.form.tipo;
                RelatorioService.exportar('/expulsao/relatorio/', vm.item);
            }
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                showFormDetalhamento();
            }
        };

        vm.exibirFormPesquisa = function () {
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showFormFiltro();
        };

        vm.search = function () {
            $scope.filter = angular.copy(vm.item);
        };

        var showFormDetalhamento = function () {
            angular.element('.tooltip').remove();
            formDetalhamento.show();
        };

        var showFormFiltro = function () {
            angular.element('.tooltip').remove();
            formFiltro.show();
        };

        $scope.hideForm = function () {
            formDetalhamento.hide();
            formFiltro.hide();
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

    }

})();

(function(){
  'use strict';

  angular.module('portal').service('CadastroExpulsaoService', CadastroExpulsaoService);

  /** @ngInject */
  function CadastroExpulsaoService($q, $http, api) {

    var service = {};
    var serviceConfig = { cache: true };

    service.pesquisar = function(servidor) {
      var deferred = $q.defer();

      $http({
        url: api.url + '/expulsao/' + servidor.exercicio,
        method: 'GET',
        params: {
          nomeServidor: servidor.nome,
          orgaos: servidor.orgao,
          punicoes: servidor.punicao,
          page: servidor.page
        }
      }).success(function(data) {
        deferred.resolve(data);
      }).error(function(err, status) {
        deferred.reject(err, status);
      });

      return deferred.promise;
    };

    service.listarOrgao = function() {
      return $http.get(api.url + '/expulsao/orgao', serviceConfig);
    };

    service.listarPunicao = function() {
      return $http.get(api.url + '/expulsao/punicao', serviceConfig);
    };

    service.listarCargo = function() {
      return $http.get(api.url + '/expulsao/cargo', serviceConfig);
    };

    return service;

  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('CargoComissionadoController', CargoComissionadoController);

  function CargoComissionadoController($location, $scope, $controller, dataAtualizacao, simbolos, ultimoExercicio, funcao, ServidoresService) {

    var vm = this;

    var dataReferencia = [];

    vm.dataAtualizacao = dataAtualizacao;
    vm.dataReferencia = ultimoExercicio.data;
    vm.ultimoExercicio = ultimoExercicio.data[0];
    vm.simbolos = simbolos.data;
    vm.funcao = funcao.data;
    //vm.orgaos = orgaos.data;
    vm.titulo = "Cargos Comissionados";
    vm.tipo = "cargo-comissionado";
    vm.texto = "Veja aqui o quantitativo de cargos comissionados ocupados e vagos em cada órgão ou entidade do Governo do Distrito Federal. Fonte: SIGRH (SEEC)";
    vm.url = "/servidor/cargo-comissionado";

    var colunas = {
      descricaoEmpresa: { nome: "Órgão", visible: true, destacado: true, termo: "Nome do órgãos/entidades da estrutura administrativa do Poder Executivo Distrital" },
      descricaoFuncao: { nome: "Função", visible: true, termo: "Nome das funções de confiança/cargos comissionados (livre provimento)" },
      dataReferencia: { nome: "Referência", visible: true, termo: "Mês de referência da consulta", center: true },
      vagos: { nome: "Cargos Vagos", visible: true, termo: "Existentes e não ocupados (livre provimento)", center: true },
      ocupados: { nome: "Cargos Ocupados", visible: true, termo: "Ocupados mediante nomeação (livre provimento)", center: true },
      total: { nome: "Total de Cargos", visible: true, termo: "Quantidade prevista em legislação específica", center: true }
    };

    $scope.colunas = colunas;

    $controller('CargoController', {
      $scope: $scope,
      instance: vm
    });

    vm.init = function () {
      var params = $location.search();

      if (params['orgao']) {
        ServidoresService.listarOrgaosCargosComissionados(vm.ultimoExercicio)
          .then(function (response) {
            vm.orgaos = response.data;
            vm.assignInitParams(params, vm.item);
            vm.search();
          });
      } else {
        vm.assignInitParams(params, vm.item);
        vm.search();
      }

    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function (params, modelObject) {
      var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function (elem) { return elem[compareProp] == param; })[0];

          if (element != null) {
            modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
          }
        }
      };

      assignSelect(vm.orgaos, modelObject, 'descricaoEmpresa', params['orgao'], 'nome', 'nome', false);

      if (params['ano'] && params['mes']) {
        var mes = Number(params['mes']);
        mes = mes > 9 ? String(mes) : '0' + String(mes);

        vm.item.dataReferencia = mes + '/' + params['ano'];
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('portal').controller('CargoEfetivoController', CargoEfetivoController);

  function CargoEfetivoController($scope, $controller, dataAtualizacao, ultimoExercicio, carreira, cargo) {

      var vm = this;

      var dataReferencia = [];

      vm.dataAtualizacao = dataAtualizacao;
      vm.dataReferencia = ultimoExercicio.data;
      vm.ultimoExercicio = ultimoExercicio.data[0];
      vm.carreira = carreira.data;
      vm.cargo = cargo.data;
      vm.titulo = "Cargos Efetivos";
      vm.tipo = "cargo-efetivo";
      vm.url = "/servidor/cargo-efetivo";
      vm.texto = "Veja aqui o quantitativo, por carreira, dos cargos de provimento efetivo do Governo do Distrito Federal, ocupados e vagos, em relação ao limite máximo previsto em legislação. Fonte: SIGRH (SEEC)";

    	var colunas = {
        descricaoCarreira:{ nome: "Carreira", destacado: true, visible:true, termo:"Nome das carreiras integrantes da estrutura administrativa do Poder Executivo Distrital"  },
        descricaoCargo:{ nome:"Cargo", visible:true, termo:"Nome dos cargos de provimento efetivo (por concurso público)"  },
        dataReferencia:{nome:"Referência", visible:true, termo:"Mês de referência da consulta", center: true },
        vagos:{nome:"Cargos Vagos", visible:true, termo:"Previstos e não ocupados mediante concurso público", center: true },
        ocupados:{nome:"Cargos Ocupados",visible:true, termo:"Ocupados mediante concurso público", center: true },
        total:{nome:"Total de Cargos",visible:true, termo:"Limite máximo de cargos previsto em legislação", center: true }
      };

      $scope.colunas = colunas;

      $controller('CargoController', {
        $scope: $scope,
        instance: vm
      });
  }
})();

(function () {
  'use strict';

  angular.module('portal').controller('CargoController', CargoController);

  function CargoController($scope, $log, $aside, ServidoresService, RelatorioService, instance) {

    var vm = instance;

    vm.settings = {
      singular: vm.titulo,
      plural: '',
      busy: true,
      cmd: 'Pesquisar'//,
    };

    vm.item = {
      page: 0,
      dataReferencia: vm.ultimoExercicio,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/servidor/' + vm.tipo,
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/servidores/cargo.pesquisa-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = {
        editing: true,
        page: 0
      };

      vm.item = {
        page: 0
      };
    };

    vm.exibirFormPesquisa = function () {
      carregarFiltros(vm.item.dataReferencia);
      vm.data.form.icon = 'md-search';
      vm.data.form.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.carregarFiltros = carregarFiltros;

    function carregarFiltros(dataReferencia) {
      if (vm.tipo == 'cargo-comissionado') {
        ServidoresService.listarOrgaosCargosComissionados(dataReferencia)
          .then(function (response) {
            vm.orgaos = response.data;
          });
      }
    }

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    $scope.exportar = function () {
      if (vm.item)
        vm.item.colunas = vm.settings.colunas;
      vm.item.tipo = $scope.dados.form.tipo;
      RelatorioService.exportar('/servidor/relatorio/', vm.item);

    };
    vm.init = function () {
      vm.item.dataReferencia = vm.ultimoExercicio;

      ServidoresService.pesquisarCargo(vm.tipo).then(function (obj) {

        vm.data.form = obj.data;
        search();
      });
    };
    var search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.ano;
      $scope.filter = angular.copy(vm.item);
      formTpl.hide();
    };

    vm.search = search;

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function () {
      formTpl.hide();
    };

    $scope.$on('$destroy', function () {
      hideForm();
    });
  }
})();
(function(){
  'use strict';

  angular.module('portal').controller('ServidorQuadroController', ServidoresController);

  /** @ngInject */
  function ServidoresController($scope, $log, $aside, ServidoresService, formTemplate, categoria,datasReferencias, dataAtualizacao, anosQuadro, ArquivoUrlService) {

    var vm = this;
    vm.contador = 0;
    vm.anosQuadro = anosQuadro.data;
    $scope.vm = vm;
    vm.datasReferencias = datasReferencias.data;
    vm.dataAtualizacao = dataAtualizacao;
    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;
    var colunas = {
      nome:{ nome: "Nome", destacado: true, visible:true, termo:"Descrição do arquivo" },
      ano:{ nome:"Exercício", visible:true, termo:"Ano de referência", center: true },
      dataReferencia:{ nome:"Referência", visible:true,date:true, termo:"Mês de referência"  },
      descricao:{nome:"Observação", visible:true, termo:"Data de publicação no Diário Oficial do DF"},
      fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela informação"}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Relatório',
      plural: 'Relatórios',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      editing: true,
      page: 0,
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/servidor/quadro',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: formTemplate,
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    //vm.visualizarItem = function(linha){
    //  if(linha){
    //    vm.item.editing = false;
    //    vm.linha = linha;
    //    vm.settings.cmd = 'Visualizar';
    //    showForm();
    //  }
    //};

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.search();
    };

    $scope.init = vm.init;

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };


    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      formTpl.hide();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('ServidoresRemuneracaoSaibaMaisController', ServidoresRemuneracaoSaibaMaisController);

  /** @ngInject */
  function ServidoresRemuneracaoSaibaMaisController($scope, $window, dataAtualizacao, ArquivoUrlService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao.data;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    var colunas = {
      nome:{ nome: "Nome", visible:true },
      ano:{ nome:"Exercício", visible:true },
      dataReferencia:{ nome:"Data referência", visible:false, date:true }
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Remuneração dos Servidores - Saiba Mais​',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
      page: 0,
      busy: false
    };

    var data = {
      url: '/remuneracao/servidores/saiba-mais',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    vm.init = function () {
      vm.search();
    }

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.voltar = function(){
      $window.location.href = '#/servidores/remuneracao';
    };
  }
})();

(function () {
  'use strict';

  angular.module('portal').controller('RemuneracaoController', RemuneracaoController);

  /** @ngInject */
  function RemuneracaoController($scope, $rootScope, $modal, $alert, ultimoExercicio,
    $aside, $location, RemuneracaoService, ServidoresService, PagingService, RelatorioService,
    dataAtualizacao, ScopeService) {

    var JANEIRO = 1;
    var DEZEMBRO = 12;
    var ANOS_REMUNERACAO = [2026,2025, 2024, 2023, 2022, 2021,2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013];

    var vm = this;

    var currentModal, backModal;

    vm.titulo = "Remuneração dos Servidores";
    vm.dataAtualizacao = dataAtualizacao;

    // Form Models
    vm.orgaos = [];
    vm.funcoes = [];
    vm.situacoes = [];
    vm.cargos = [];
    vm.anos = [];

    // Funções
    // Modificar DOM
    vm.exibirFormPesquisa = exibirFormPesquisa;

    // Requisições FORM
    vm.carregarFiltros = carregarFiltros;

    var colunas = {
      nomeServidor: { nome: "Nome", visible: true, disabled: true, destacado: true, termo: "Nome completo do servidor" },
      cpfServidor: { nome: "CPF", visible: true, disabled: true, termo: "Nº do cadastro de pessoa física mascarado" },
      nomeOrgao: { nome: "Órgão", visible: true, termo: "Órgão vinculado ao servidor" },
      cargo: { nome: "Cargo", visible: true, termo: "Posição que o servidor ocupa no órgão de forma permanente" },
      funcao: { nome: "Função", visible: true, termo: "Designação temporária para desempenho de determinadas atribuições (Cargo Comissionado)" },
      situacaoFuncional: { nome: "Situação", visible: false, termo: "Condição do servidor em relação ao exercício de suas atividades" },
      mesReferencia: { nome: "Mês", visible: false, termo: "Mês de referência", center: true },
      anoExercicio: { nome: "Ano", visible: false, termo: "Ano de referência", center: true },
      valorRemuneracaoBasica: { nome: "Remuneração Básica", direita: true, visible: false, termo: "Remuneração básica" },
      valorBeneficios: { nome: "Benefícios", direita: true, visible: false, termo: "Valor dos benefícios" },
      valorFuncoes: { nome: "Valor da Função", direita: true, visible: false, termo: "Valor das funções" },
      valorComissaoConselheiro: { nome: "Comissão Conselheiro", direita: true, visible: false, termo: "Comissão Conselheiro" },
      valorHoraExtra: { nome: "Hora Extra", direita: true, visible: false, termo: "Total de Hora Extra" },
      valorVerbasEventuais: { nome: "Verbas Eventuais", direita: true, visible: false, termo: "Valor das verbas eventuais" },
      valorVerbasJudiciais: { nome: "Verbas Judiciais", direita: true, visible: false, termo: "Valor das verbas judiciais" },
      valorReposicaoDescontosMaior: { nome: "Descontos a maior", direita: true, visible: false, termo: "Reposição de descontos a maior" },
      valorLicencaPremio: { nome: "Licência prêmio", direita: true, visible: false, termo: "Licência prêmio" },
      valorImpostoRenda: { nome: "IRRF", direita: true, visible: false, termo: "Imposto de renda retido na fonte" },
      valorSeguridadeSocial: { nome: "Seg. Social", direita: true, visible: false, termo: "Valor da seguridade social" },
      valorRedutorTeto: { nome: "Teto redutor", direita: true, visible: false, termo: "Valor do teto redutor" },
      valorReceitasMesesAnteriores: { nome: "Outros recebimentos", direita: true, visible: false, termo: "Valor de outros recebimentos" },
      valorDescontosMesesAnteriores: { nome: "Outros descontos obrigatórios", direita: true, visible: false, termo: "Valor de outros descontos obrigatórios" },
      valorReposicaoPagamentoMaior: { nome: "Pagamentos a maior", direita: true, visible: false, termo: "Reposição de pagamentos a maior" },
      valorBruto: { nome: "Bruto", currency: true, visible: true, disabled: false, termo: "Valor bruto da remuneração" },
      valorLiquido: { nome: "Líquido", currency: true, visible: true, disabled: true, termo: "Valor líquido após descontos obrigatórios" }
    };

    $scope.colunas = colunas;

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };
    // settings
    vm.settings = {
      singular: 'Servidor',
      plural: 'Servidores',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      anoExercicio: vm.anos[0],
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/remuneracao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/servidores/remuneracao-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formFiltro = $aside({
      scope: $scope,
      template: 'app/components/servidores/remuneracao-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/servidores/remuneracao-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    function exibirFormPesquisa() {
      carregarFiltros(vm.item.anoExercicio, vm.item.mesReferencia);

      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    function carregarFiltros(exercicio, mesReferencia) {

      vm.filtersLoaded = false;
      Promise.all([
        RemuneracaoService.listarOrgao(exercicio, mesReferencia),
        RemuneracaoService.listarFuncao(exercicio, mesReferencia),
        RemuneracaoService.listarSituacao(exercicio, mesReferencia),
        RemuneracaoService.listarCargo(exercicio, mesReferencia)
      ]).then(function (response) {
        vm.orgaos = response[0].data;
        vm.funcoes = response[1].data;
        vm.situacoes = response[2].data;
        vm.cargos = response[3].data;

        vm.filtersLoaded = true;
      });

      //   ServidoresService.listarAnoRemuneracao()
      //     .then(function(response) {
      //       vm.anos = response.data;
      //     });
      vm.anos = ANOS_REMUNERACAO;
    }

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';

        showFromDetalhamento();
      }
    };

    vm.init = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;

      vm.filtroAnoRemuneracao($rootScope.anoRemuneracao);

      var fromScope = ScopeService.getStored();
      var params = fromScope && fromScope.params ? fromScope.params : $location.search();

      if (params['orgao']) {
        RemuneracaoService.listarOrgao()
          .then(function (response) {
            vm.orgaos = response.data;
            vm.assignInitParams(params, vm.item);
            vm.search();
          });
      } else if (params['funcao']) {
        RemuneracaoService.listarFuncao()
          .then(function (response) {
            vm.funcoes = response.data;
            vm.assignInitParams(params, vm.item);
            vm.search();
          });
      } else {
        vm.assignInitParams(params, vm.item);
        vm.search();
      }
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function (params) {
      var assignProps = function (propsArray, fromObj, toObj) {
        propsArray.forEach(function (prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function (elem) {
            return elem[compareProp].trim() == param;
          })[0];
          if (element != null) {
            modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
          }
        }
      };

      assignProps([
        { from: 'ano', to: 'anoExercicio', type: String },
        { from: 'mes', to: 'mesReferencia', type: String },
        { from: 'cpf', to: 'cm', type: String },
        { from: 'nome', to: 'nomeServidor', type: String }], params, vm.item);
      assignSelect(vm.orgaos, vm.item, 'nomesOrgaos', params['orgao'], 'nome', 'nome', true);
      assignSelect(vm.funcoes, vm.item, 'funcoes', params['funcao'], 'nome', 'nome', true);

      if (vm.item.cm) {
        vm.item.cm = btoa(vm.item.cm);
      } else if (params['cm']) {
        vm.item.cm = params['cm'];
      }
    };

    vm.filtroAnoRemuneracao = function (anoRemuneracao) {
      if (anoRemuneracao) {
        vm.item.anoExercicio = anoRemuneracao;
        vm.item.mesReferencia = ultimoExercicio.data.toString().substr(4, 5);
        $rootScope.anoRemuneracao = "";
      } else {
        vm.item.anoExercicio = ultimoExercicio.data.toString().substr(0, 4);
        vm.item.mesReferencia = ultimoExercicio.data.toString().substr(4, 5);
      }
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;

      vm.pesquisaPorOrgao(vm.item, false);

      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();

      vm.pesquisaPorOrgao(vm.item, true);
    };

    vm.pesquisaPorOrgao = function (item, recuperarLabel) {
      //implementado devido ao erro na consulta por órgão, alguns estavam com vírgula no texto!
      if (item.nomesOrgaos) {
        if (item.nomesOrgaos.length == 1) {
          for (var i = 0; i < item.nomesOrgaos.length; i++) {
            if (!recuperarLabel) {
              item.nomesOrgaos[i] = item.nomesOrgaos[i].replace(/,/g, "#");
            } else {
              item.nomesOrgaos[i] = item.nomesOrgaos[i].replace(/#/g, ",");
            }
          }
        }
      }
    }

    var showForm = function () {
      angular.element('.tooltip').remove();
      //formTpl.show();
      formFiltro.show();
    };

    var showFromDetalhamento = function () {
      $scope.descontos = {
        valores: [
          {
            label: 'IRRF',
            value: vm.linha.valorImpostoRenda
          }, {
            label: 'seguridade social',
            value: vm.linha.valorSeguridadeSocial
          }, {
            label: 'teto redutor',
            value: vm.linha.valorRedutorTeto
          }, {
            label: 'outros descontos obrigatórios',
            value: vm.linha.valorDescontosMesesAnteriores
          }, {
            label: 'reposição pagamento a maior',
            value: vm.linha.valorReposicaoPagamentoMaior
          }
        ],
        totalLabel: 'total de descontos',
        calcTotal: function () {
          return this.valores.map(function (v) { return v.value; }).reduce(function (prev, curr) { return prev + curr; });
        }
      };
      $scope.recebimentos = {
        valores: [
          {
            label: 'remuneração básica',
            value: vm.linha.valorRemuneracaoBasica
          }, {
            label: 'benefícios',
            value: vm.linha.valorBeneficios
          }, {
            label: 'funções',
            value: vm.linha.valorFuncoes
          }, {
            label: 'comissão conselheiros',
            value: vm.linha.valorComissaoConselheiro
          }, {
            label: 'horas extras',
            value: vm.linha.valorHoraExtra
          }, {
            label: 'verbas extras',
            value: vm.linha.valorVerbasEventuais
          }, {
            label: 'verbas judiciais',
            value: vm.linha.valorVerbasJudiciais
          }, {
            label: 'outros recebimentos',
            value: vm.linha.valorReceitasMesesAnteriores
          }, {
            label: 'reposição desconto a maior',
            value: vm.linha.valorReposicaoDescontosMaior
          }, {
            label: 'licença prêmio',
            value: vm.linha.valorLicencaPremio
          }
        ],
        totalLabel: 'total bruto',
        calcTotal: function () {
          return this.valores.map(function (v) { return v.value; }).reduce(function (prev, curr) { return prev + curr; });
        }
      };
      formDetalhamento.show();
      currentModal = formDetalhamento;
    };

    $scope.hideForm = function () {
      formFiltro.hide();
    };

    $scope.exportar = function () {
      if (vm.item)
        vm.item.colunas = vm.settings.colunas;
      vm.item.tipo = $scope.dados.form.tipo;
      RelatorioService.exportar('/remuneracao/relatorio/', vm.item);
    };

    vm.exportarDetalhamento = function (item) {
      if (item.codigoIdentificacao)
        item.tipo = 'pdf';
      RelatorioService.exportar('/remuneracao/relatorio/detalhamento/' + item.codigoIdentificacao, item);
    };

    vm.exportarExtrato = function (item) {
      if (item.codigoMatricula && item.anoExercicio)
        item.tipo = 'pdf';
      RelatorioService.exportar(
        '/remuneracao/relatorio/extrato/' + item.codigoMatricula + '/' + item.anoExercicio, item);
    }


    var myModal = $aside({
      scope: $scope,
      template: 'app/components/servidores/extrato-anual-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });


    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };
    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    };


    vm.showModal = function (item) {
      RemuneracaoService.listarExtratoAnual(item).then(
        function (response) {
          vm.extratoAnual = response.data;
          hideCurrentModal();
          myModal.show();
        })
        .catch(function (erro) {
          $alert({
            title: 'Erro',
            content: 'Erro ao recuperar dados para o extrato',
            placement: 'top-right',
            type: 'erro',
            container: '.alert-container-top-right',
            animation: 'mat-grow-top-right',
            duration: 5
          });
        });
    };

    var myModalRubrica = $aside({
      scope: $scope,
      template: 'app/components/servidores/rubrica-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.showModalRubrica = function (item) {
      RemuneracaoService.listarRubrica(item).then(
        function (response) {
          vm.rubrica = response.data.content;
          vm.totalRubrica = response.data.totalizador;
          vm.totalAposDescontos = (vm.totalRubrica.totalRecebimento - vm.totalRubrica.totalDesconto).toFixed(2);
          hideCurrentModal();
          myModalRubrica.show();
        })
        .catch(function (error) {
          $alert({
            content: 'Esse servidor ainda não possui detalhamento das rúbricas',
            type: 'warning'
          });
        });
    };

    vm.exportarDetalhamentoRubrica = function (item) {
      if (item.codigoIdentificacao)
        item.tipo = 'pdf';
      RelatorioService.exportar('/remuneracao/relatorio/rubrica/' + item.codigoIdentificacao + '/' + item.anoExercicio + '/' + item.codigoOrgaoArtificial, item);
    }

    vm.selecionarTodasColunas = function (selecionar) {
      //$scope.colunas.nomeServidor.visible = selecionar;
      //$scope.colunas.cpfServidor.visible = selecionar;
      $scope.colunas.valorSeguridadeSocial.visible = selecionar;
      $scope.colunas.valorRedutorTeto.visible = selecionar;
      $scope.colunas.nomeOrgao.visible = selecionar;
      $scope.colunas.cargo.visible = selecionar;
      $scope.colunas.funcao.visible = selecionar;
      $scope.colunas.situacaoFuncional.visible = selecionar;
      $scope.colunas.mesReferencia.visible = selecionar;
      $scope.colunas.anoExercicio.visible = selecionar;
      $scope.colunas.valorRemuneracaoBasica.visible = selecionar;
      $scope.colunas.valorBeneficios.visible = selecionar;
      $scope.colunas.valorFuncoes.visible = selecionar;
      $scope.colunas.valorComissaoConselheiro.visible = selecionar;
      $scope.colunas.valorHoraExtra.visible = selecionar;
      $scope.colunas.valorVerbasEventuais.visible = selecionar;
      $scope.colunas.valorVerbasJudiciais.visible = selecionar;
      $scope.colunas.valorReposicaoDescontosMaior.visible = selecionar;
      $scope.colunas.valorLicencaPremio.visible = selecionar;
      $scope.colunas.valorImpostoRenda.visible = selecionar;
      $scope.colunas.valorReceitasMesesAnteriores.visible = selecionar;
      $scope.colunas.valorDescontosMesesAnteriores.visible = selecionar;
      $scope.colunas.valorReposicaoPagamentoMaior.visible = selecionar;
      //$scope.colunas.valorLiquido.visible = selecionar;

    }

    vm.hideModal = function () {
      myModal.hide();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

  }

})();

(function(){
  'use strict';

  angular.module('portal').service('RemuneracaoService', RemuneracaoService);

  function RemuneracaoService($q, $http, api) {
    var service = {};
    var serviceConfig = { cache: true };

    service.pesquisar = function(servidor) {
      var deferred = $q.defer();

      $http({
        url: api.url + '/remuneracao/' + servidor.exercicio + '/' + servidor.mes,
        method: 'GET',
        params: {
          nomeServidor: servidor.nome,
          orgaos: servidor.orgao,
          cargos: servidor.cargo,
          funcoes: servidor.funcao,
          situacoesFuncionais: servidor.situacao,
          page: servidor.page
        }
      }).success(function(data) {
        deferred.resolve(data);
      }).error(function(err, status) {
        deferred.reject(err, status);
      });

      return deferred.promise;
    };

    service.listarOrgao = function(exercicio, mesReferencia) {
      return $http({
        url: api.url + '/remuneracao/orgao',
        method: 'GET',
        params: {
            exercicio: exercicio,
            mesReferencia: mesReferencia
        },
        cache: true
      });
    };

    service.listarCargo = function(exercicio, mesReferencia) {
      return $http({
        url: api.url + '/remuneracao/cargo',
        method: 'GET',
        params: {
            exercicio: exercicio,
            mesReferencia: mesReferencia
        },
        cache: true
      });
    };

    service.listarFuncao = function(exercicio, mesReferencia) {
      return $http({
        url: api.url + '/remuneracao/funcao',
        method: 'GET',
        params: {
            exercicio: exercicio,
            mesReferencia: mesReferencia
        },
        cache: true
      });
    };

    service.listarSituacao = function(exercicio, mesReferencia) {
      return $http({
        url: api.url + '/remuneracao/situacao',
        method: 'GET',
        params: {
            exercicio: exercicio,
            mesReferencia: mesReferencia
        },
        cache: true
      });
    };

    service.listarExtratoAnual = function(item) {
      return $http({
        url: api.url + '/remuneracao/extrato/' + item.codigoMatricula + '/' + item.anoExercicio + '/' + item.codigoOrgaoArtificial,
        method: 'GET',
        cache: true
      });
    };

    service.graficoEvolucaoRemuneracao = function() {
      return $http.get(api.url + '/remuneracao/grafico/evolucao', serviceConfig);
    };

    service.listarRubrica = function(item) {      
      //return $http.get(api.url + '/remuneracao/rubrica/' + item.codigoMatricula, serviceConfig);
       return $http({
         url: api.url + '/remuneracao/rubrica',
         method: 'GET',
         cache: true,
         params: item
      });
    };

    return service;
  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('ServidoresPerfilController', ServidoresPerfilController);

  /** @ngInject */
  function ServidoresPerfilController(ServidoresService, ultimoExercicio, dataAtualizacao) {
    var vm = this;

    vm.dataAtualizacao = dataAtualizacao.data;
    
    vm.anoExercicio = ultimoExercicio.data.toString().substr(0,4);
    vm.mesReferencia = ultimoExercicio.data.toString().substr(4,5);

    vm.panels = [
      ['panelPorEscolaridade', ServidoresService, 'listarDadosGraficoEscolaridade'],
      ['panelPorFaixaEtaria', ServidoresService, 'listarDadosGraficoIdade'],
      ['panelPorSexo', ServidoresService, 'listarDadosGraficoSexo']
    ].map(function(panelIdAndData) {
      var panel = findPanelById(panelIdAndData[0], PANELS);

      panel.chartDataPromise = function() {
        return panelIdAndData[1][panelIdAndData[2]]();
      };

      return panel;
    });
  }

  /**
   * Obtem o painel correspondente a um ID.
   * @param {*} panelId ID.
   * @param {*} panels Paineis.
   * @returns Panel correspondente; undefined, caso o mesmo não seja encontrado.
   */
  function findPanelById(panelId, panels) {
    return panels.filter(function(panel) {
      return panel.id == panelId;
    })[0];
  }

  var PANELS = [{
      id: 'panelPorEscolaridade',
      chartType: 'bar-chart',
      current: true,
      initial: true,
      title: 'Escolaridade dos Servidores',
      chartDataPromise: undefined,
      onShow: function() {
          if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
      },
      buildModel: function(data) {
          var chartColors = ['#1ED6D6', '#0e7eca'];

          this.chartModel = {
              chartId: 'chartPorEscolaridade',
              chartHeight: 300,
              useColorPattern: true,
              fnChartBuild: function(chart) { this.chart = chart; },
              dimentions: data.dados.map(function(escolaridade, index) {
                  return {
                      dataLabel: escolaridade.x,
                      color: chartColors[index % chartColors.length],
                      data: [
                          {
                              division: 'masculino',
                              value: escolaridade.masculino
                          },{
                              division: 'feminino',
                              value: escolaridade.feminino
                          }
                      ]
                  };
              })
          };
      }
    },{
      id: 'panelPorFaixaEtaria',
      chartType: 'bar-chart',
      current: false,
      initial: false,
      title: 'Faixa etaria dos Servidores',
      chartDataPromise: undefined,
      onShow: function() {
          if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
      },
      buildModel: function(data) {
          var chartColors = ['#1ED6D6', '#0e7eca'];

          this.chartModel = {
              chartId: 'chartPorFaixaEtaria',
              chartHeight: 300,
              useColorPattern: true,
              fnChartBuild: function(chart) { this.chart = chart; },
              dimentions: data.dados.map(function(escolaridade, index) {
                  return {
                      dataLabel: escolaridade.x,
                      color: chartColors[index % chartColors.length],
                      data: [
                          {
                              division: 'masculino',
                              value: escolaridade.masculino
                          },{
                              division: 'feminino',
                              value: escolaridade.feminino
                          }
                      ]
                  };
              })
          };
      }
    },{
      id: 'panelPorSexo',
      chartType: 'area-chart',
      current: false,
      initial: false,
      title: 'Percentual de Servidores por Sexo',
      chartDataPromise: undefined,
      onShow: function() {
        if (this.chartModel && this.chartModel.chart) {
          var self = this;
          this.chartModel.chart.flush();
          setTimeout(function() { self.chartModel.chart.flush(); }, 300);
        }
      },
      buildModel: function(data) {
        var chartColors = ['#1ED6D6', '#0e7eca'];
        var panel = this;
  
        this.chartModel = {
          chartId: 'grafico-por-sexo',
          insideTitle: 'Sexo',
          chartHeight: 340,
          fnFormatData: function(ratio) { return (ratio * 100).toFixed(1).toString().replace('.', ','); },
          fnChartBuild: function(chart) { this.chart = chart; },
          fnChartShow: function() { panel.onShow(); },
          dimentions: data.map(function(d, index) {
            return {
              dataLabel: d[0].toLowerCase(),
              data: d[1],
              color: chartColors[index % chartColors.length]
            };
          })
        };
      }
    }
  ];

})();


(function(){
  'use strict';

  angular.module('portal').directive('graficoRegimeServidor', GraficoRegimeServidor);

  /** @ngInject */
  function GraficoRegimeServidor() {
    return {
      restrict: 'E',
      replace: true,
      scope:{},
      templateUrl: 'app/components/servidores/graficos/regime-servidor.html',
      controller: function($scope, $location, ServidoresService) {

        $scope.onClick = function(valor) {
          var data = {
            regime: valor.name
          };
          ServidoresService.store(data);
          $location.path('/servidores/orgao');
        };

        ServidoresService.listarDadosGraficoRegime().then(
          function(response) {
            $scope.dados = [];
            $scope.dados.push(response.data.pontos);
            $scope.colunas = response.data.colunas;
          }
        );
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('graficoStatusServidor', GraficoStatusServidor);

  /** @ngInject */
  function GraficoStatusServidor() {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      templateUrl: 'app/components/servidores/graficos/status-servidor.html',
      controller: function($scope, $location, ServidoresService) {

        $scope.onClick = function(valor) {
          var cod;

          if(valor.name == 'Incluido no mês') cod = '01';
          if(valor.name == 'Normal') cod = '02';
          if(valor.name == 'Afastado') cod = '03';
          if(valor.name == 'Desligado no mês') cod = '04';
          if(valor.name == 'Desligado') cod = '05';
          if(valor.name == 'Requisitado') cod = '07';
          if(valor.name == 'Cedido') cod = '08';
          if(valor.name == 'Aposentado ou Pensionista') cod = '09';
          if(valor.name == 'Posse') cod = '10';

          var data = {
            codigoStatus: cod
          }
          ServidoresService.store(data);
          $location.path('/servidores/orgao');
        }

        ServidoresService.listarDadosGraficoStatus()
          .then(
          function(response) {
            $scope.dados = [];
            $scope.dados.push(response.data.pontos);
            $scope.colunas = response.data.colunas;
          }
        );
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('portal').controller('ServidoresController', ServidoresController);

    /** @ngInject */
    function ServidoresController($scope, $rootScope, $alert,
        $aside, $location, ServidoresService, PagingService, RelatorioService,
        dataAtualizacao, ultimoExercicio, ScopeService) {

        var vm = this;

        vm.carregarFiltros = carregarFiltros;

        vm.carreiras = [];
        vm.regimes = [];
        vm.cargos = [];
        vm.situacoes = [];
        vm.funcoes = [];
        vm.orgaos = [];
        vm.status = [];
        vm.situacoesFuncionais = [];
        vm.anos = [];
        vm.dataAtualizacao = dataAtualizacao;

        var colunas = {
            nome: { nome: "Nome", destacado: true, visible: true, exportar: true, termo: "Nome completo do servidor" },
            codigoMatricula: { nome: "Matrícula", visible: false, exportar: true, termo: "Nº de registro do servidor no órgão" },
            nomeOrgao: { nome: "Órgão", visible: true, exportar: true, termo: "Órgão vinculado ao servidor" },
            nomeCargo: { nome: "Cargo", visible: true, exportar: true, termo: "Posição que o servidor ocupa no órgão de forma permanente" },
            nomeFuncao: { nome: "Função", visible: true, exportar: true, termo: "Designação temporária para desempenho de determinadas atribuições (Função de confiança ou Cargo Comissionado)" },
            codigoFuncao: { nome: "Cod. Função", visible: true, exportar: true, termo: "Símbolo da função de confiança ou cargo comissionado" },
            situacao: { nome: "Situação", visible: true, exportar: true, termo: "Condição do servidor em relação ao exercício de suas atividades" },
            nomeCarreira: { nome: "Carreira", visible: false, exportar: true, termo: "Conjunto de cargos com estruturas semelhantes dos quais o servidor faz parte." },
            lotacao: { nome: "Lotação", visible: false, exportar: true, termo: "Setor do órgão onde o servidor está atuando." },
            dataAdmissaoFormatada: { nome: "Data de Admissão", visible: false, center: true, exportar: true, termo: "Início do exercício das atividades no cargo efetivo ou na função sem vínculo." },
            nomeStatus: { nome: "Status", visible: false, exportar: true, termo: "Situação do servidor em relação ao órgão." },
            regime: { nome: "Regime", visible: false, exportar: true, termo: "Vínculo jurídico do servidor com a Administração Pública" },
            mesReferencia: { nome: "Mês", visible: false, exportar: true, termo: "Mês de referência", center: true },
            situacaoFuncional: { nome: "Sit. Funcional", visible: true, exportar: true, termo: "Situação do servidor para fins previdenciários." },
            cargaHoraria: { nome: "Carga Horária", visible: false, center: true, exportar: true, termo: "Carga horária semanal do servidor." },
            dataAposentadoriaFormatada: { nome: "Data da Aposentadoria", visible: false, center: true, exportar: true, termo: "Data em que o servidor se aposentou." },
            dataDesligamentoFormatada: { nome: "Data do Desligamento", visible: false, center: true, exportar: true, termo: "Data em que o servidor se desligou do órgão." }
        };

        $scope.colunas = colunas;

        // settings
        vm.settings = {
            singular: 'Servidor',
            plural: 'Servidores',
            busy: true,
            cmd: '',
            colunas: colunas
        };

        vm.item = {
            page: 0,
            tipo: 'csv',
            exercicio: vm.anos[0],
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        // adding demo data
        var data = {
            url: '/servidor',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        // defining template
        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/servidores/servidores-por-orgao-form.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/servidores/servidores-por-orgao-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formFiltro = $aside({
            scope: $scope,
            template: 'app/components/servidores/servidores-por-orgao-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.init = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.item.exercicio = ultimoExercicio.data.toString().substr(0, 4);
            vm.item.mesReferencia = ultimoExercicio.data.toString().substr(4, 5);
            vm.data.form = vm.item;

            var fromScope = ScopeService.getStored();
            var params = fromScope && fromScope.params ? fromScope.params : $location.search();

            vm.statusServidor($rootScope.statusServidor);
            vm.regimeServidor($rootScope.regimeServidor);
            vm.carreiraServidor($rootScope.carreiraServidor);
            vm.situacaoFuncionalServidor($rootScope.situacaoFuncionalServidor);

            if (params['orgao']) {
                ServidoresService.listarOrgao()
                    .then(function (response) {
                        vm.orgaos = response.data;
                        vm.assignInitParams(params, vm.item);
                        vm.search();
                    });
            } else if (params['funcao']) {
                ServidoresService.listarFuncao()
                    .then(function (response) {
                        vm.funcoes = response.data;
                        vm.assignInitParams(params, vm.item);
                        vm.search();
                    });
            } else {
                vm.assignInitParams(params, vm.item);
                vm.search();
            }

        };

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         */
        vm.assignInitParams = function (params) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return elem[compareProp].trim() == param; })[0];

                    if (element != null) {
                        modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
                    }
                }
            };

            assignProps([
                { from: 'ano', to: 'exercicio', type: String },
                { from: 'mes', to: 'mesReferencia', type: String },
                { from: 'cpf', to: 'cm', type: String },
                { from: 'nome', to: 'nome', type: String }], params, vm.item);
            assignSelect(vm.orgaos, vm.item, 'orgaos', params['orgao'], 'nome', 'codigo', true);
            assignSelect(vm.funcoes, vm.item, 'nomeFuncao', params['funcao'], 'nome', 'nome', false);

            if (vm.item.cm) {
                vm.item.cm = btoa(vm.item.cm);
            } else if (params['cm']) {
                vm.item.cm = params['cm'];
            }
        };

        vm.statusServidor = function (status) {
            if (status != "") {
                vm.item.nomeStatus = status;
                $rootScope.statusServidor = "";
            }
        };

        vm.regimeServidor = function (regime) {
            if (regime != "") {
                vm.item.regime = regime;
                $rootScope.regimeServidor = "";
            }
        };

        vm.carreiraServidor = function (carreira) {
            if (carreira != "") {
                vm.item.nomeCarreira = carreira;
                $rootScope.carreiraServidor = "";
            }
        };

        vm.situacaoFuncionalServidor = function (situacaoFuncional) {
            if (situacaoFuncional != "") {
                vm.item.situacao = situacaoFuncional;
                $rootScope.situacaoFuncionalServidor = "";
            }
        };

        vm.cancelar = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                // $scope.showForm();
                formDetalhamento.show();
            }
        };

        vm.exibirFormPesquisa = function () {
            vm.carregarFiltros();

            vm.item.icon = 'md-search';
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showFormFiltro();
        };

        var search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
            $scope.hideForm();
        };

        var showFormFiltro = function () {
            angular.element('.tooltip').remove();
            //formTpl.show();
            formFiltro.show();
        };

        function carregarFiltros() {
            vm.filtersLoaded = false;
            Promise.all([
                ServidoresService.listarRegimes(vm.item.exercicio, vm.item.mesReferencia),
                ServidoresService.listarCargos(vm.item.exercicio, vm.item.mesReferencia),
                ServidoresService.listarCarreira(vm.item.exercicio, vm.item.mesReferencia),
                ServidoresService.listarSituacao(vm.item.exercicio, vm.item.mesReferencia),
                ServidoresService.listarFuncao(vm.item.exercicio, vm.item.mesReferencia),
                ServidoresService.listarOrgao(),
                ServidoresService.listarStatus(),
                ServidoresService.listarSituacaoFuncional(),
                ServidoresService.listarAno()
            ]).then(function (response) {
                vm.regimes = response[0].data;
                vm.cargos = response[1].data;
                vm.carreiras = response[2].data;
                vm.situacoes = response[3].data;
                vm.funcoes = response[4].data;
                vm.orgaos = response[5].data;
                vm.status = response[6].data;
                vm.situacoesFuncionais = response[7].data;
                vm.anos = response[8].data;

                vm.filtersLoaded = true;
            });

        }

        vm.search = search;

        $scope.exportar = function () {

            var backupColunas = angular.copy(vm.settings.colunas);

            angular.forEach(vm.settings.colunas, function (coluna) {


                coluna.visible = !!coluna.exportar;
            });

            vm.item.colunas = angular.toJson(vm.settings.colunas);

            vm.item.tipo = $scope.dados.form.tipo;

            RelatorioService.exportar('/servidor/relatorio/', vm.item);

            vm.settings.colunas = backupColunas;
        };

        $scope.showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.hideForm = function () {
            formFiltro.hide();
        };

        $scope.$on('$destroy', function () {
            formFiltro.hide();
            formDetalhamento.hide();
        });

    }

})();

(function(){
  'use strict';

  angular.module('portal').controller('ServidoresDashboardController', ServidoresDashboardController);

  /** @ngInject */
  function ServidoresDashboardController(anos, ultimoExercicio, $scope, $rootScope, $location, dataAtualizacao, RemuneracaoService, ServidoresService) {
    var vm = this;
    vm.anoSelecionado = anos.data[0];
    vm.dataAtualizacao =  dataAtualizacao.data;
    vm.mesReferencia = ultimoExercicio.data.toString().substr(4,5);

    function detailCharData(panel, dataValue) {
      $rootScope[panel.detailProperty] = dataValue;
      $location.path(panel.detailPath);
      $scope.$apply();
    }

    vm.panels = [
      ['panelRemuneracaoBasica', RemuneracaoService, 'graficoEvolucaoRemuneracao'],
    //   ['panelSituacao', ServidoresService, 'listarDadosGraficoSituacaoFuncional'],
    //   ['panelCarreiras', ServidoresService, 'listarDadosGraficoCarreira'],
    //   ['panelRegime', ServidoresService, 'listarDadosGraficoRegime'],
    //   ['panelStatus', ServidoresService, 'listarDadosGraficoStatus']
    ].map(function(panelIdAndData) {
      var panel = findPanelById(panelIdAndData[0], PANELS);

      panel.chartDataPromise = function() {
        return panelIdAndData[1][panelIdAndData[2]]();
      };
      panel.onDataSelected = function(dataValue) {
        detailCharData(panel, dataValue);
      };

      return panel;
    });
  }

  /**
   * Obtem o painel correspondente a um ID.
   * @param {*} panelId ID.
   * @param {*} panels Paineis.
   * @returns Panel correspondente; undefined, caso o mesmo não seja encontrado.
   */
  function findPanelById(panelId, panels) {
    return panels.filter(function(panel) {
      return panel.id == panelId;
    })[0];
  }

  /**
   * Modelos correspondentes aos paineis.
   */
  var PANELS = [
    {
      id: 'panelRemuneracaoBasica',
      chartType: 'evolution-chart',
      current: true,
      initial: true,
      title: 'Evolução da remuneração básica',
      detailPath: '/servidores/remuneracao',
      detailProperty: 'anoRemuneracao',
      chartDataPromise: undefined,
      onShow: function() {
        if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
      },
      buildModel: function(data) {
        var panel = this;
        this.chartModel = {
          chartId: 'grafico-evolucao-remuneracao',
          chartHeight: 310,
          minScaleValue: 0,
          fnFormatData: function(v) { return 'R$ ' + parseInt(v) + ' bilhões'; },
          fnFormatTooltip: function(v) { return 'R$ ' + v.toFixed(3) + ' bilhões'; },
          fnChartBuild: function(chart) { this.chart = chart; },
          fnDataClickListener: function(v) { panel.onDataSelected(v); },
          dimentions: [
            {
              label: 'remuneração',
              color: '#1EC8C9',
              data: data.colunas.slice(1).map(function(val, index) {
                return [data.categoria[index], val / 1000000000]; 
              })
            }
          ]
        };
      }
    }/*,{
      id: 'panelSituacao',
      chartType: 'horizontal-bar-chart',
      current: false,
      initial: false,
      title: 'Situação dos servidores',
      detailPath: '/servidores/orgao',
      detailProperty: 'situacaoFuncionalServidor',
      chartDataPromise: undefined,
      onShow: function() {
        if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
      },
      buildModel: function(data) {
        var panel = this;
        var chartColors = ['#1ED6D6', '#0E7ECA', '#65A0CE', '#229396'];

        function parseLabel(dataLabel) {
          var translatedLabels = new Map();
          translatedLabels.set('ATIVO', 'aponsentado');
          translatedLabels.set('ATIVO', 'ativo');
          translatedLabels.set('OUTROS', 'outros');
          translatedLabels.set('CONTRATO TEMPORARIO', 'contrato temporário');
          translatedLabels.set('PENSAO', 'pensão');
          return translatedLabels.has(dataLabel) ? translatedLabels.get(dataLabel) : dataLabel.toLowerCase();
        }

        this.chartModel = {
          chartId: 'grafico-situacao-funcional',
          chartHeight: 310,
          chartBarWidthRatio: 0.6,
          chartBarSpaceRatio: 0.3,
          fnChartBuild: function(chart) { this.chart = chart; },
          fnTickSequenceBy: function() {
            var width = this.chart ? this.chart.element.offsetWidth : window.innerWidth;
  
            if (width >= 1000) {
              return 10000;
            } else if (width >= 800) {
              return 15000;
            } else if (width >= 500) {
              return 20000;
            } else {
              return 30000;
            }
          },
          fnDataClickListener: function(v) { panel.onDataSelected(v); },
          dimentions: data.map(function(d, index) {
            return {
              label: parseLabel(d[0]),
              color: chartColors[index % chartColors.length],
              dataLabel: d[0],
              data: d[1]
            };
          })
        };
      }
  },{
    id: 'panelCarreiras',
    chartType: 'horizontal-bar-chart',
    current: false,
    initial: false,
    title: '5 maiores carreiras',
    detailPath: '/servidores/orgao',
    detailProperty: 'carreiraServidor',
    chartDataPromise: undefined,
    onShow: function() {
      if (this.chartModel && this.chartModel.chart) { this.chartModel.chart.flush(); }
    },
    buildModel: function(data) {
      var panel = this;
      var chartColors = ['#1ED6D6', '#0E7ECA', '#65A0CE', '#229396', '#50597B'];

      function parseLabel(dataLabel) {
        var translatedLabels = new Map();
        translatedLabels.set('MAGISTERIO PUBLICO DO DF', 'magistério público do DF');
        translatedLabels.set('ASSISTENCIA PUBLICA A SAUDE', 'asistência pública a saúde');
        translatedLabels.set('ASSISTENCIA A EDUCACAO', 'asistência a educação');
        translatedLabels.set('CONTRATO TEMPORARIO', 'contrato temporário');
        translatedLabels.set('POLITICAS PUBLICAS E GESTAO GOVERNAMENTAL DO DF', 'políticas públicas e gestão governamental');
        return translatedLabels.has(dataLabel) ? translatedLabels.get(dataLabel) : dataLabel.toLowerCase();
      }

      this.chartModel = {
        chartId: 'grafico-carreiras',
        chartHeight: 290,
        chartBarWidthRatio: 0.8,
        chartBarSpaceRatio: 0.3,
        fnChartBuild: function(chart) { this.chart = chart; },
        fnTickSequenceBy: function() {
          var width = this.chart ? this.chart.element.offsetWidth : window.innerWidth;

          if (width >= 1000) {
            return 5000;
          } else if (width >= 800) {
            return 7500;
          } else if (width >= 500) {
            return 10000;
          } else {
            return 15000;
          }
        },
        fnDataClickListener: function(v) { panel.onDataSelected(v); },
        dimentions: data.map(function(d, index) {
          return {
            label: parseLabel(d[0]),
            color: chartColors[index % chartColors.length],
            dataLabel: d[0],
            data: d[1]
          };
        })
      };
    }
  },{
      id: 'panelRegime',
      chartType: 'area-chart',
      current: false,
      initial: false,
      title: 'Regime dos servidores',
      detailPath: '/servidores/orgao',
      detailProperty: 'regimeServidor',
      chartDataPromise: undefined,
      onShow: function() {
        if (this.chartModel && this.chartModel.chart) {
          var self = this;
          this.chartModel.chart.flush();
          setTimeout(function() { self.chartModel.chart.flush(); }, 300);
        }
      },
      buildModel: function(data) {
        var chartColors = ['#1ED6D6', '#1F7DC0', '#65A0CE', '#229396', '#50597B', '#FFD200', '#D14C39', '#E64C65'];
        var panel = this;

        this.chartModel = {
          chartId: 'grafico-regime',
          chartHeight: 340,
          fnFormatData: function(ratio) { return (ratio * 100).toFixed(1).toString().replace('.', ','); },
          fnChartBuild: function(chart) { this.chart = chart; },
          fnChartShow: function() { panel.onShow(); },
          fnDataClickListener: function(v) { panel.onDataSelected(v); },
          dimentions: data.map(function(d, index) {
            return {
              dataLabel: d[0].toLowerCase(),
              data: d[1],
              color: chartColors[index % chartColors.length]
            };
          })
        };
      }
  },{
    id: 'panelStatus',
    chartType: 'area-chart',
    current: false,
    initial: false,
    title: 'Status dos servidores',
    detailPath: '/servidores/orgao',
    detailProperty: 'statusServidor',
    chartDataPromise: undefined,
    onShow: function() {
      if (this.chartModel && this.chartModel.chart) {
        var self = this;
        this.chartModel.chart.flush();
        setTimeout(function() { self.chartModel.chart.flush(); }, 300);
      }
    },
    buildModel: function(data) {
      var chartColors = ['#1ED6D6', '#1F7DC0', '#65A0CE', '#229396', '#50597B', '#FFD200', '#D14C39', '#E64C65'];
      var panel = this;

      this.chartModel = {
        chartId: 'grafico-status',
        chartHeight: 340,
        fnFormatData: function(ratio) { return (ratio * 100).toFixed(1).toString().replace('.', ','); },
        fnChartBuild: function(chart) { this.chart = chart; },
        fnChartShow: function() { panel.onShow(); },
        fnDataClickListener: function(v) { panel.onDataSelected(v); },
        dimentions: data.map(function(d, index) {
          return {
            dataLabel: d[0].toLowerCase(),
            data: d[1],
            color: chartColors[index % chartColors.length]
          };
        })
      };
    }
  }*/];

})();

(function () {
  'use strict';

  angular.module('portal').factory('Expulsao', ExpulsaoFactory);

  /** @ngInject */
  function ExpulsaoFactory($resource, api) {
    return {
      listaAno: function () {
        return $resource(api.url + '/expulsao/anos', null, { 'get': { cache: true, isArray: true } });
      }
    }
  };

})();

(function () {
  'use strict';

  angular.module('portal').service('ServidoresService', ServidoresService);

  /** @ngInject */
  function ServidoresService($http, api) {
    var dataStored;
    var service = {};
    var serviceConfig = { cache: true };

    service.pesquisarQuadro = function (rel) {
      return $http({
        url: api.url + '/servidor/quadro',
        method: 'GET',
        params: {
          nome: rel.nome,
          ano: rel.ano,
          mes: rel.mes,
          codigoCategoria: rel.categoria
        }
      });
    };

    service.store = function (data) {
      dataStored = data;
    };

    service.getStored = function () {
      var data = dataStored;
      dataStored = null;
      return data;
    };

    service.listarDataReferenciaPorGdf = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorGdf',
        method: 'GET',
        cache: true
      });
    };
    service.listarDataReferenciaPorPatrimonio = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorPatrimonio',
        method: 'GET'
      });
    };

    service.listarDataReferenciaPorConvenio = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorConvenio',
        method: 'GET'
      });
    };

    service.listarAnosQuadro = function () {
      return $http({
        url: api.url + '/servidor/listarAnosQuadro',
        method: 'GET'
      });
    };

    service.listarAnosTabela = function () {
      return $http({
        url: api.url + '/servidor/listarAnosTabelasRemuneracao',
        method: 'GET'
      });
    };

    service.listarDataReferenciaPorPrestacaoContas = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorPrestacaoContas',
        method: 'GET'
      });
    };

    service.listarDataReferenciaPorGerenciais = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorGerenciais',
        method: 'GET'
      });
    };

    service.listarDataReferenciaPorGerenciais = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorGerenciais',
        method: 'GET'
      });
    };

    service.listarDataReferenciaPorTipo = function (tipo) {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorTipo',
        method: 'GET',
        params: {
          tipo: tipo
        }
      });
    };
    service.listarDataReferenciaPorRemuneracao = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorRemuneracao',
        method: 'GET'
      });
    };


    service.listarDataReferenciaPorOutrosOrcamento = function () {
      return $http({
        url: api.url + '/servidor/listarDataReferenciaPorOutrosOrcamento',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosGraficoSituacaoFuncional = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/situacao',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarTotalDeRespostasDaPesquisaDeSatisfacao = function () {
      return $http({
        url: api.url + '/pesquisa/grafico/total-respostas',
        method: 'GET',
        cache: true
      });
    }

    service.listarDadosPesquisaOcupacao = function () {
      return $http({
        url: api.url + '/pesquisa/grafico/ocupacao',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosPesquisaFaixaEtaria = function () {
      return $http({
        url: api.url + '/pesquisa/grafico/faixa-etaria',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosPesquisaNivelSatisfacao = function () {
      return $http({
        url: api.url + '/pesquisa/grafico/nivel-satisfacao',
        method: 'GET',
        cache: true
      });
    };

    service.pesquisarCargo = function (tipo) {
      return $http({
        url: api.url + '/servidor/' + tipo,
        method: 'GET'
      });
    };

    service.paginasPopulares = function () {
      return $http({
        url: api.url + '/analytics/paginas-populares',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosServidoresAtivos = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/ativo',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosServidoresAposentados = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/aposentado',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosServidoresPensao = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/pensao',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosServidoresOutros = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/outros',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.recuperarTotalServidores = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/total',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosGraficoCarreira = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/carreira',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosGraficoRegime = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/regime',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosGraficoStatus = function (ano) {
      return $http({
        url: api.url + '/servidor/grafico/status',
        method: 'GET',
        params: {
          ano: ano
        },
        cache: true
      });
    };

    service.listarDadosGraficoSexo = function () {
      return $http({
        url: api.url + '/servidor/grafico/sexo',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosGraficoEscolaridade = function () {
      return $http({
        url: api.url + '/servidor/grafico/escolaridade',
        method: 'GET',
        cache: true
      });
    };

    service.listarDadosGraficoIdade = function () {
      return $http({
        url: api.url + '/servidor/grafico/idade',
        method: 'GET',
        cache: true
      });
    };

    service.listarOrgao = function () {
      return $http.get(api.url + '/servidor/orgao', serviceConfig)
    };

    service.listarOrgaosCargosComissionados = function (dataReferencia) {
      dataReferencia = dataReferencia.replace('/', '');
      return $http.get(api.url + '/servidor/cargo-comissionado/orgaos?dataReferencia=' + dataReferencia, serviceConfig);
    }

    service.listarCarreira = function (ano, mes) {
      return $http.get(api.url + '/servidor/carreira', {
        params: {
          ano: ano, mes: mes
        }
      }, serviceConfig);
    };
    service.listarCarreiraCargoEfetivo = function () {
      return $http.get(api.url + '/servidor/carreira-cargo-efetivo', serviceConfig);
    };

    service.listarDescricaoCargoEfetivo = function () {
      return $http.get(api.url + '/servidor/cargo-efetivo-descricao', serviceConfig);
    };

    service.listarFuncao = function (ano, mes) {
      return $http.get(api.url + '/servidor/funcao', {
        params: {
          ano: ano, mes: mes
        }
      }, serviceConfig);
    };

    service.listarFuncoes = function () {
      return $http.get(api.url + '/servidor/funcoes', serviceConfig);
    };

    service.listarSimbolos = function () {
      return $http.get(api.url + '/servidor/simbolos', serviceConfig);
    };

    service.listarStatus = function () {
      return $http.get(api.url + '/servidor/status', serviceConfig);
    };

    service.listarCategoriaRelatorio = function () {
      return $http.get(api.url + '/servidor/quadro/categoria', serviceConfig);
    };

    service.listarRegimes = function (ano, mes) {
      return $http.get(api.url + '/servidor/regime', {
        params: {
          ano: ano, mes: mes
        }
      }, serviceConfig);
    };

    service.listarSituacao = function (ano, mes) {
      return $http.get(api.url + '/servidor/situacao', {
        params: {
          ano: ano, mes: mes
        }
      }, serviceConfig);
    };

    service.listarSituacaoFuncional = function () {
      return $http.get(api.url + '/servidor/situacaoFuncional', serviceConfig);
    };

    service.listarAnoRemuneracao = function () {
      return $http.get(api.url + '/remuneracao/anos', serviceConfig);
    };

    service.recuperarUltimoExercicio = function () {
      return $http.get(api.url + '/remuneracao/ultimo-exercicio', serviceConfig);
    };

    service.recuperarUltimoExercicioCargosComissionado = function () {
      return $http.get(api.url + '/servidor/ultimo-exercicio-cargo-comissionado', serviceConfig);
    };

    service.recuperarUltimoExercicioCargosEfetivo = function () {
      return $http.get(api.url + '/servidor/ultimo-exercicio-cargo-efetivo', serviceConfig);
    };

    service.recuperarUltimoExercicioServidoresOrgao = function () {
      return $http.get(api.url + '/remuneracao/ultimo-exercicio-orgao', serviceConfig);
    };

    service.listarCargos = function (ano, mes) {
      return $http.get(api.url + '/servidor/cargo', {
        params: {
          ano: ano, mes: mes
        }
      }, serviceConfig);
    };

    service.listarAno = function () {
      return $http.get(api.url + '/servidor/anos', serviceConfig);
    };

    service.listarAnoMilitaresCedidos = function () {
      return $http.get(api.url + '/servidor/militares-cedidos/ano', serviceConfig);
    }
    service.listarMesMilitaresCedidos = function (exercicio){
      return $http.get(api.url + '/servidor/militares-cedidos/mes?exercicio='+exercicio, serviceConfig);
    }
    service.listarReferenciaMilitaresCedidos = function(){
      var referencias = {};
      var self = this;
      return this.listarAnoMilitaresCedidos()
        .then(function(exercicios) {
          console.log(exercicios);
          referencias.exercicios = exercicios.data;
          return self.listarMesMilitaresCedidos(referencias.exercicios[0])
            .then(function(meses){
              referencias.meses = meses.data;
              return referencias;
            })
        })

    }
    service.listarNomeCedenteMilitaresCedidos = function () {
      return $http.get(api.url + '/servidor/militares-cedidos/nome-cedente', serviceConfig);
    }

    return service;

  }

})();

(function(){
  'use strict';

  angular.module('portal').controller('ServidoresTabelaController', ServidoresTabelaController);

    function ServidoresTabelaController($scope, formTemplate, categoria, $aside, datasReferencias, dataAtualizacao, anosTabela) {
    
    var vm = this;
    vm.anosTabela = anosTabela.data;
    vm.datasReferencias = datasReferencias.data;
      vm.dataAtualizacao = dataAtualizacao;
    var colunas = {
      nome:{ nome: "Nome", visible:true, termo:"Nome da carreira / cargo" },
      ano:{ nome:"Exercício", visible:true, termo:"Ano de referência" },
      dataReferencia:{ nome:"Data referência", visible:true ,date:true, termo:"Mês de referência" },
      descricao:{nome:"Observação", visible:true, termo:"Nome do documento"},
      fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela informação"}
    };

    $scope.colunas = colunas;

    $scope.settings = {
      singular: 'Relatório',
      plural: 'Relatórios',
      busy: true,
      cmd: 'Pesquisar',
      colunas: colunas
    };

    vm.item = {
      editing: true,
      page: 0,
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var formTpl = $aside({
      scope: $scope,
      template: formTemplate,
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var data = {
      url: '/servidor/tabela-remuneracao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    $scope.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      $scope.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.search();
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      formTpl.hide();
    };
 }

})();

(function(){
  'use strict';

  angular.module('portal').controller('StatusServidoresController', ServidoresController);

  /** @ngInject */
  function ServidoresController($scope, $aside, orgaos, cargos,
                                ServidoresService, PagingService, RelatorioService) {

    var vm = this;
    vm.orgaos = orgaos.data;
    vm.cargos = cargos.data;

    var colunas = {
      nome:{ nome: "Nome", visible:true },
      nomeOrgao:{ nome: "Órgão", visible:true },
      nomeCarreira:{ nome:"Carreira", visible: false},
      nomeCargo:{ nome: "Cargo", visible:true },
      regime:{ nome:"Regime", visible:false },
      codigoMatricula:{ nome:"Matrícula", visible:false },
      dataAdmissao:{ nome:"Data de Admissão", visible:false, date:true },
      nomeFuncao:{ nome: "Função", visible:true },
      codigoFuncao:{ nome: "Cod. Função", visible:true },
      situacaoFuncional:{ nome:"Sit. Funcional", visible:false }
    };

    // settings
    vm.settings = {
      singular: 'Servidor',
      plural: 'Servidores',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo:'pdf'
    };

    // adding demo data
    var data = {
      url: '/servidor',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/servidores/servidores-por-status-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function() {
      var stored = ServidoresService.getStored();
      if(stored) {
        vm.item.nomeCarreira = stored.nomeCarreira;
        vm.item.sexo = stored.sexo;
        vm.item.regime = stored.regime;
        vm.item.codigoStatus = stored.codigoStatus;
        search();
      }
    }

    vm.cancelar = function() {
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    var search = function() {
      vm.data.content = [];
      vm.item.page = -1;
      pesquisa();
    };

    vm.search = search;

    var pesquisa = function() {
      PagingService.pesquisar(vm.data).then(
        function(response) {
          if(response.totalElements > 0 && vm.item.editing) hideForm();
        },
        function(error) {
          hideForm;
        }
      );
    };

    vm.exportar = function(item) {
      if(item)
        item.colunas = vm.settings.colunas;
        RelatorioService.exportar('/servidor/relatorio/', item);
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      hideForm();
    });

  }

})();

(function () {
    'use strict';

    angular.module('portal').controller('SuperBuscaController', Controller);

    /**
     * Modelo de uma direção.
     */
    var Direction = (function () {
        var DirectionClass = function (config, paramsRouteType) {
            this.route = config.route;
            this.params = config.params;
            this.paramsRouteType = paramsRouteType;
        };

        /**
         * Aciona o redirecionamento para a direção.
         * @param {*} result Resultado.
         * @param {*} $location Angular location service.
         * @param {*} ScopeService Serviço de escopo.
         */
        DirectionClass.prototype.takeResultDirection = function (result, $location, ScopeService) {
            var params = this.buildParamsObj(result);

            if (this.paramsRouteType == 'BY_URL') {
                $location.path(this.route).search(params);
            } else if (this.paramsRouteType == 'BY_SCOPE') {
                ScopeService.store({ params: params });
                $location.path(this.route).search({});
            }
        };

        /**
         * Obtem o path correspondente a direção de um resultado.
         * @param {*} result Resultado
         * @returns String contendo o path.
         */
        DirectionClass.prototype.getDirectionPath = function (result) {
            var params = this.buildParamsObj(result);

            var keys = Object.keys(params);

            if (keys.length > 0) {
                var queryString = keys.map(function (key) {
                    return key + '=' + params[key];
                }).reduce(function (prev, curr) {
                    return prev + '&' + curr;
                });

                return retirarSinalDeMais(this.route + '?' + queryString);
            }

            function retirarSinalDeMais(string) {
                return string.replaceAll("+", "%2B");
            }

            return this.route;
        };

        /**
         * Constroi o mapa de parâmetros correspondente a um resultado.
         * @param {*} result Resultado
         * @returns Mapa de parâmetro e valor.
         */
        DirectionClass.prototype.buildParamsObj = function (result) {
            var self = this, params = {};
            Object.keys(this.params.campos).forEach(function (campo) {
                if (result.campo == campo) {

                    // tratamento de campo codificado
                    if (self.params.campos[campo] == 'cm') {
                        params[self.params.campos[campo]] = btoa(result.value);
                    } else {
                        params[self.params.campos[campo]] = result.value;
                    }
                }
            });
            if (result.exercicio && this.params.ano) {
                if (result.mes && this.params.mes) {
                    params[this.params.mes] = result.mes;
                }
                params[this.params.ano] = result.exercicio;
            }
            if (result.notaEmpenho) {
                params['numeroNotaEmpenho'] = result.notaEmpenho;
            }
            if (result.codigoUnidadeGestora) {
                params['codigoUnidadeGestora'] = result.codigoUnidadeGestora;
            }
            if (result.codigoGestao) {
                params['codigoGestao'] = result.codigoGestao;
            }

            return params;
        };

        return DirectionClass;
    })();


    // Mapa de categorias e suas respectivas informações
    var CATEGORIES_MAP = {
        0: {
            descricao: 'remuneração dos servidores',
            icons: { icon: 'fa-street-view' },
            info: 'Resultado de uma busca por nome, CPF ou Órgão, encaminha para a consulta da remuneração de um servidor, ou dos servidores lotados em um Órgão.',
            infoResumo: 'Encaminha para a consulta da remuneração de um servidor, ou dos servidores lotados em um Órgão.',
            fields: ['órgão', 'cpf', 'nome', 'função']
        },
        1: {
            descricao: 'servidores por órgão',
            icons: { icon: 'fa-university' },
            info: 'Resultado de uma busca por nome, CPF ou Órgão, encaminha para a consulta que relaciona o servidor com o Órgão no qual o mesmo se encontra lotado, ou os servidores lotados em um Órgão.',
            infoResumo: 'Encaminha para a consulta que relaciona o servidor com o Órgão no qual o mesmo se encontra lotado, ou os servidores lotados em um Órgão.',
            fields: ['órgão', 'cpf', 'nome', 'função']
        },
        2: {
            descricao: 'despesas por credor',
            icons: { icon: 'fa-dollar' },
            info: 'Resultado de uma busca por nome, CPF ou CNPJ, encaminha para a consulta no qual a pessoa física ou jurídica consta como credora em uma despesa.',
            infoResumo: 'Encaminha para a consulta no qual a pessoa física ou jurídica consta como credora em uma despesa.',
            fields: ['cnpj', 'cpf', 'nome']
        },
        3: {
            descricao: 'beneficiários',
            icons: { icon: 'fa-universal-access' },
            info: 'Resultado de uma busca por nome, encaminha para a consulta no qual a pessoa consta como beneficiária de programas sociais.',
            infoResumo: 'Encaminha para a consulta no qual a pessoa consta como beneficiária de programas sociais.',
            fields: ['nome']
        },
        4: {
            descricao: 'diárias e passagens',
            icons: { icon: 'fa-dollar', sup: 'fa-plus-circle' },
            info: 'Resultado de uma busca por nome, CPF, CNPJ ou Órgão, encaminha para a consulta no qual uma pessoa física ou jurídica consta como credora em despesas por viagem, ou no qual um Órgão consta como demandante de tais despesas.',
            infoResumo: 'Encaminha para a consulta no qual uma pessoa física ou jurídica consta como credora em despesas por viagem, ou no qual um Órgão consta como demandante de tais despesas.',
            fields: ['órgão', 'cnpj', 'cpf', 'nome']
        },
        5: {
            descricao: 'receitas por órgão',
            icons: { icon: 'fa-dollar', sup: 'fa-minus-circle' },
            info: 'Resultado de uma busca por Órgão, encaminha para a consulta que lista as receitas obtidas pelo Órgão.',
            infoResumo: 'Encaminha para a consulta que lista as receitas obtidas pelo Órgão.',
            fields: ['órgão']
        },
        6: {
            descricao: 'despesas por órgão',
            icons: { icon: 'fa-dollar', sup: 'fa-minus-circle' },
            info: 'Resultado de uma busca por Órgão, encaminha para a consulta que lista as despesas do Órgão.',
            infoResumo: 'Encaminha para a consulta que lista as despesas do Órgão.',
            fields: ['órgão']
        },
        7: {
            descricao: 'despesas por ação',
            icons: { icon: 'fa-money' },
            info: 'Resultado de uma busca por uma ação ou Órgão, encaminha para a consulta que lista as despesas associadas a uma ação, ou as despesas por ação de um Órgão.',
            infoResumo: 'Encaminha para a consulta que lista as despesas associadas a uma ação, ou as despesas por ação de um Órgão.',
            fields: ['órgão', 'ação']
        },
        8: {
            descricao: 'pagamentos por credor',
            icons: { icon: 'fa-list-alt' },
            info: 'Resultado de uma busca por nome ou Órgão, encaminha para a consulta que lista os pagamentos recebidos por um credor, ou realizados por um Órgão.',
            infoResumo: 'Encaminha para a consulta que lista os pagamentos recebidos por um credor, ou realizados por um Órgão.',
            fields: ['órgão', 'nome']
        },
        9: {
            descricao: 'detalhamentos',
            icons: { icon: 'fa-money' },
            info: 'Resultado de uma busca por Órgão, encaminha para a consulta que lista os detalhamentos de despesas do Órgão.',
            infoResumo: 'Encaminha para a consulta que lista os detalhamentos de despesas do Órgão.',
            fields: ['órgão']
        },
        10: {
            descricao: 'emendas parlamentares',
            icons: { icon: 'fa-pencil-square-o' },
            info: 'Resultado de uma busca por programa, autor ou Órgão, encaminha para a consulta que lista as emendas parlamentares relacionadas.',
            infoResumo: 'Encaminha para a consulta que lista as emendas parlamentares relacionadas ao programa, autor ou Órgão.',
            fields: ['órgão', 'programa', 'ação']
        },
        11: {
            descricao: 'cadastro de expulsões',
            icons: { icon: 'fa-street-view' },
            info: 'Resultado de uma busca por nome ou Órgão, encaminha para a consulta que relaciona o servidor a um cadastro de expulsão, ou os cadastros associados a um Órgão.',
            infoResumo: 'Encaminha para a consulta que relaciona o servidor a um cadastro de expulsão, ou dos cadastros associados a um Órgão.',
            fields: ['órgão', 'nome']
        },
        12: {
            descricao: 'cargos comissionados',
            icons: { icon: 'fa-street-view' },
            info: 'Resultado de uma busca por Órgão, encaminha para a consulta que lista os cargos comissionados do mesmo.',
            infoResumo: 'Encaminha para a consulta que lista os cargos comissionados do Órgão.',
            fields: ['órgão']
        },
        13: {
            descricao: 'contratos',
            icons: { icon: 'fa-gavel' },
            info: 'Resultado de uma busca por objeto, credor ou Órgão, encaminha para a consulta que lista as contratos relacionados.',
            infoResumo: 'Encaminha para a consulta que lista as contratos ao objeto, credor ou Órgão.',
            fields: ['órgão', 'credor', 'objeto']
        },
        14: {
            descricao: 'conselhos',
            icons: { icon: 'fa-users' },
            info: 'Resultado de uma busca por nome do conselho ou Órgão, encaminha para a consulta que lista um conselho ou os conselhos associados a um Órgão.',
            infoResumo: 'Encaminha para a consulta que lista um conselho ou os conselhos associados a um Órgão.',
            fields: ['órgão', 'conselho']
        },
        15: {
            descricao: 'conselheiros',
            icons: { icon: 'fa-user' },
            info: 'Resultado de uma busca por nome do conselheiro, conselho ou representação, encaminha para a consulta que lista componentes de conselhos.',
            infoResumo: 'Encaminha para a consulta que lista componentes de conselhos.',
            fields: ['representação', 'conselho', 'nome']
        },
        16: {
            descricao: 'entidades beneficiadas',
            icons: { icon: 'fa-handshake-o' },
            info: 'Resultado de uma busca por credor, CNPJ ou Órgão, encaminha para a consulta que lista entidades beneficiadas associadas.',
            infoResumo: 'Encaminha para a consulta que lista entidades beneficiadas associadas a um nome credor, CNPJ ou Órgão transferidor.',
            fields: ['órgão', 'CNPJ', 'credor']
        },
        17: {
            descricao: 'convênios de receita',
            icons: { icon: 'fa-handshake-o' },
            info: 'Resultado de uma busca por convenente, concedente ou justificativa do convênio, encaminha para a consulta que lista os convênios de receita associados.',
            infoResumo: 'Encaminha para a consulta que lista os convênios de receita associados um convenente, concedente ou justificativa.',
            fields: ['justificativa', 'concedente', 'convenente']
        },
        18: {
            descricao: 'convênios de despesa',
            icons: { icon: 'fa-handshake-o' },
            info: 'Resultado de uma busca por convenente, concedente ou justificativa do convênio, encaminha para a consulta que lista os convênios de despesa associados.',
            infoResumo: 'Encaminha para a consulta que lista os convênios de despesa associados um convenente, concedente ou justificativa.',
            fields: ['justificativa', 'concedente', 'convenente']
        },
        19: {
            descricao: 'bens móveis',
            icons: { icon: 'fa-cogs' },
            info: 'Resultado de uma busca pela descrição do bem móvel, encaminha para a consulta que lista bens móveis da Administração Pública.',
            infoResumo: 'Encaminha para a consulta que lista bens móveis da Administração Pública dada sua descrição.',
            fields: ['descrição']
        },
        20: {
            descricao: 'localização de bens móveis',
            icons: { icon: 'fa-cogs' },
            info: 'Resultado de uma busca pela descrição do bem móvel ou Órgão, encaminha para a consulta que lista bens móveis da Administração Pública e sua localização.',
            infoResumo: 'Encaminha para a consulta que lista bens móveis da Administração Pública e sua localização dada sua descrição ou Órgão.',
            fields: ['órgão', 'descrição']
        },
        21: {
            descricao: 'itens licitados',
            icons: { icon: 'fa-cogs' },
            info: 'Resultado de uma busca pelo nome ou descrição do item, nome do órgão ou fornecedor das licitações, encaminha para a consulta que lista os itens licitados e os seus valores unitários.',
            infoResumo: 'Encaminha para a consulta que lista os itens licitados e os seus valores unitários.',
            fields: ['nome', 'descrição', 'órgão', 'fornecedor']
        },
        23: {
            descricao: 'consulta dinâmica despesas',
            icons: { icon: 'fa-cogs' },
            info: 'Consulta dinâmica de Despesas.',
            infoResumo: 'Encaminha para a consulta dinâmica de Despesas.',
            fields: ['nota empenho', 'nota lancamento', 'ordem bancária', 'número do processo']
        },
        24: {
            descricao: 'detalhamento notas de empenho',
            icons: { icon: 'fa-cogs' },
            info: 'Detalhamento das Notas de Empenho.',
            infoResumo: 'Encaminha para a consulta da nota de empenho.',
            fields: ['descrição']
        }
    };


    // Mapa de direções respectivas a cada categoria de resultado
    var DIRECTIONS_MAP = {
        0: new Direction({
            route: '/servidores/remuneracao',
            params: {
                campos: { 'NOME': 'nome', 'DC_EMPRESA': 'orgao', 'NR_CPF': 'cm', 'DS_FUNCAO': 'funcao' },
                ano: 'ano',
                mes: 'mes'
            }
        }, 'BY_SCOPE'),
        1: new Direction({
            route: '/servidores/orgao',
            params: {
                campos: { 'NOME': 'nome', 'DC-ORGAO': 'orgao', 'NR-CPF': 'cm', 'DS_FUNCAO': 'funcao' },
                ano: 'ano',
                mes: 'mes'
            }
        }, 'BY_SCOPE'),
        2: new Direction({
            route: '/despesas/credor',
            params: {
                campos: { 'NM_CREDOR': 'nome', 'CD_CREDOR': 'codigoCredor', 'NM_UG': 'orgao' },
                ano: 'ano',
                mes: 'mes'
            }
        }, 'BY_URL'),
        3: new Direction({
            route: '/prestando-contas/beneficiario/programas-sociais',
            params: {
                campos: { 'DS_NOME_BENEFICIARIO': 'nome' },
                ano: 'ano',
                mes: 'mes'
            }
        }, 'BY_URL'),
        4: new Direction({
            route: '/despesas/diarias-passagens-locomocao',
            params: {
                campos: { 'NM_UG': 'orgao', 'NM_CREDOR': 'nome', 'CD_CREDOR': 'codigoCredor', 'NM_ELEM': 'elemento', 'NM_SUBELEM': 'subelemento' },
                ano: 'ano'
            }
        }, 'BY_URL'),


        5: new Direction({
            route: '/receitas/por-orgao',
            params: {
                campos: { 'NM_UG': 'orgao' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        6: new Direction({
            route: '/despesas/orgao',
            params: {
                campos: { 'NM_UG': 'orgao' },
                ano: 'ano'
            }
        }, 'BY_URL'),
        7: new Direction({
            route: '/despesas/acao',
            params: {
                campos: { 'NM_UG': 'orgao', 'NM_ACAO': 'acao' },
                ano: 'ano'
            }
        }, 'BY_URL'),
        8: new Direction({
            route: '/despesas/pagamentos-por-credor',
            params: {
                campos: { 'NM_UG': 'orgao', 'NM_CREDOR': 'credor' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        9: new Direction({
            route: '/despesas/detalhamento',
            params: {
                campos: { 'NM_UG': 'orgao' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        10: new Direction({
            route: '/despesas/emendas-parlamentares',
            params: {
                campos: { 'NM_UG': 'orgao', 'NM_PROGRAMA': 'programa', 'NM_AUTOR': 'autor' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        11: new Direction({
            route: '/servidores/expulsoes',
            params: {
                campos: { 'DC-ORGAO': 'orgao', 'NOME': 'nome' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        12: new Direction({
            route: '/servidores/cargo-comissionado',
            params: {
                campos: { 'DC-ORGAO': 'orgao' },
                ano: 'ano',
                mes: 'mes'
            }
        }, 'BY_URL'),
        13: new Direction({
            route: '/licitacoes-contratos/contratos',
            params: {
                campos: { 'NM_UG': 'orgao', 'NM_CREDOR': 'credor', 'NM_OBJETO': 'objeto' },
                ano: 'ano'
            }
        }, 'BY_URL'),
        14: new Direction({
            route: '/prestando-contas/conselhos',
            params: {
                campos: { 'NM_ORGAO_VINCULADO': 'orgao', 'NM_CONSELHO': 'nome' }
            }
        }, 'BY_URL'),
        15: new Direction({
            route: '/prestando-contas/conselheiros',
            params: {
                campos: { 'NM_CONSELHEIRO': 'nome', 'NM_REP': 'representacao', 'NM_CONSELHO': 'conselho' }
            }
        }, 'BY_URL'),
        16: new Direction({
            route: '/convenio/entidades-beneficiadas',
            params: {
                campos: { 'NM_ORGAO_TRANSFERIDOR': 'orgao', 'CD_ENTIDADE': 'codCredor', 'NM_ENTIDADE': 'nomeCredor' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        17: new Direction({
            route: '/convenio/receita',
            params: {
                campos: { 'NM_CONVENENTE': 'convenente', 'NM_JUST': 'justificativa', 'NM_CONCEDENTE': 'concedente' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        18: new Direction({
            route: '/convenio/despesa',
            params: {
                campos: { 'NM_CONVENENTE': 'convenente', 'NM_JUST': 'justificativa', 'NM_CONCEDENTE': 'concedente' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        19: new Direction({
            route: '/patrimonio/bens-moveis',
            params: {
                campos: { 'NM_ITEM': 'item' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        20: new Direction({
            route: '/patrimonio/localizacao',
            params: {
                campos: { 'NM_ORGAO_LOCALIZACAO': 'orgao', 'NM_DESC': 'descricao' }
            }
        }, 'BY_URL'),
        21: new Direction({
            route: '/licitacoes-contratos/itens-licitados',
            params: {
                campos: { 'NM_ITEM': 'nomeItem', 'DS_ITEM': 'descricaoItem', 'DC-ORGAO': 'nomeOrgao', 'NM_FORNECEDOR': 'nomeFornecedor' },
                ano: 'exercicio'
            }
        }, 'BY_URL'),
        23: new Direction({
            route: '/despesas/consulta-dinamica',
            params: {
                campos: { 'NR_NE': 'notaEmpenho', 'NR_NL': 'notaLancamento', 'NR_OB': 'ordemBancaria', 'NR_PROCESSO': 'numeroProcesso' }
            }
        }, 'BY_URL'),
        24: new Direction({
            route: '/despesas/nota-empenho',
            params: {
                campos: {},
                numeroNotaEmpenho: 'notaEmpenho',
                codigoUnidadeGestora: 'codigoUnidadeGestora',
                codigoGestao: 'codigoGestao',
                ano: 'exercicio'
            }
        }, 'BY_URL')
    };


    /**
     * Controlador da página da super busca.
     * @param {*} $scope Escopo injetado.
     */
    /** @ngInject */
    function Controller($scope, $aside, SuperBuscaService, ScopeService, $location) {
        var vm = this;
        vm.$scope = $scope;
        vm.$aside = $aside;
        vm.$location = $location;
        vm.ScopeService = ScopeService;
        vm.SuperBuscaService = SuperBuscaService;
        vm._buscarValor = _buscarValor;
        vm._addDados = _addDados;
        vm._reset = _reset;
        vm.categories = Object.keys(CATEGORIES_MAP);

        vm._lastValorPesquisado = undefined;
        vm.pageValue = 1;
        vm.loadingInProcess = false;
        vm.noMoreResults = false;
        vm.total = 0;

        vm.init = init;
        vm.onSearch = onSearch;
        vm.icon = icon;
        vm.descricaoCategoria = descricaoCategoria;
        vm.descricaoCampo = descricaoCampo;
        vm.pathResultado = pathResultado;
        vm.loadMore = loadMore;
        vm.onResultSelecionado = onResultSelecionado;
        vm.showInfoPage = showInfoPage;
        vm.infoCategoria = infoCategoria;
        vm.infoCategoriaResumo = infoCategoriaResumo;
        vm.searchFields = searchFields;
        vm.emitSearchInputEvent = emitSearchInputEvent;
        vm.openSuperBuscaLink = openSuperBuscaLink;

        $scope.vm = vm;

        var pesquisaScope = $scope.$new(true);
        pesquisaScope.vm = vm;
        vm.formPesquisa = $aside({
            scope: pesquisaScope,
            template: 'app/components/super-busca/pesquisa.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        $scope.$on('super_busca_search', function (event, value) {
            vm.onSearch(value);
        });
    }

    /**
     * Realiza procedimentos na inicialização do controlador.
     */
    function init() {
        var params = this.$location.search();

        if (params.q) {
            this._buscarValor(params.q);
        }
    }

    /**
     * Redefine os parâmetros para uma nova consulta.
     */
    function _reset() {
        this.noMoreResults = false;
        this.pageValue = 1;
        this.dados = undefined;
    }

    /**
     * Corresponde a ação acionada pela barra de busca.
     * @param {*} searchValue Valor informado.
     */
    function onSearch(searchValue) {
        if (this._lastValorPesquisado != undefined && this._lastValorPesquisado == searchValue) {
            return;
        }

        this._buscarValor(searchValue);

        this.$location.search({ q: searchValue });
    }

    /**
     * Emite evento correspondente a entrada de um valor no campo de busca.
     * @param {*} searchValue 
     */
    function emitSearchInputEvent(searchValue) {
        this.$scope.$emit('super_busca_input', searchValue);
    }

    /**
     * Corresponde a ação de seleção de um resultado.
     * @param {*} result Resultado.
     */
    function onResultSelecionado(result, evt) {
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }

        var direction = DIRECTIONS_MAP[result.categoria.getCategoriaId()];

        direction.takeResultDirection(result, this.$location, this.ScopeService);
    }

    /**
     * Responde ao evento de busca.
     */
    function _buscarValor(searchValue) {
        if (searchValue) {
            var self = this;

            if (this._lastValorPesquisado == undefined || this._lastValorPesquisado != searchValue) {
                this._reset();
            }

            this._lastValorPesquisado = searchValue;
            this.loadingInProcess = true;

            this.SuperBuscaService.buscar(searchValue, this.pageValue).then(function (data) {
                self._addDados(data);
            }).catch(function (error) {
                self.error = true;
            }).finally(function () {
                self.loadingInProcess = false;
            });

            if (this.searchValue != searchValue) {
                this.searchValue = searchValue;
            }
        }
    }

    /**
     * Adiciona dados ao resultado.
     * @param {*} data Dados.
     */
    function _addDados(data) {
        if (this.dados == undefined) {
            this.dados = data.results;
            this.total = data.count;

            if (data.count == this.dados.length || this.dados.length > data.count) {
                this.noMoreResults = true;
            }
        } else {
            this.dados = this.dados.concat(data.results);

            if (data.results.length == 0 || this.total == this.dados.length || this.dados.length > this.total) {
                this.noMoreResults = true;
            }
        }
    }

    /**
     * Aciona o carregamento de mais uma página.
     */
    function loadMore() {
        this.pageValue++;
        this._buscarValor(this._lastValorPesquisado);
    }

    /**
     * Obtem o ícone adequado a um resultado.
     * @param {*} result Resultado.
     */
    function icon(result) {
        return CATEGORIES_MAP[isNaN(result) ? result.categoria.getCategoriaId() : result].icons;
    }

    /**
     * Obtem a descrição da categoria ao qual o resultado pertence.
     * @param {*} result Resultado.
     */
    function descricaoCategoria(result) {
        return CATEGORIES_MAP[isNaN(result) ? result.categoria.getCategoriaId() : result].descricao;
    }

    /**
     * Obtem a descrição informativa de uma categoria.
     * @param {*} result Resultado ou ID da categoria.
     */
    function infoCategoria(result) {
        return CATEGORIES_MAP[isNaN(result) ? result.categoria.getCategoriaId() : result].info;
    }

    function descricaoCampo(result) {
        return ['servidor',
            'órgão',
            'servidor',
            'credor',
            'credor',
            'unidade gestora',
            'servidor',
            'órgão',
            'servidor',
            'objeto',
            'conselho',
            'órgão vinculado',
            'conselheiro',
            'representação',
            'entidade',
            'entidade',
            'órgão transferidor',
            'concedente',
            'convenente',
            'justificativa',
            'item',
            'órgão/localização',
            'descrição do bem',
            'função',
            'descrição do item',
            'fornecedor',
            'beneficiário',
            'nota empenho',
            'nota lançamento',
            'ordem bancária',
            'número do processo',
            'descrição da nota de empenho'][result.categoria.getCampoId()];
    }

    /**
     * Obtem a descrição informativa de uma categoria.
     * @param {*} result Resultado ou ID da categoria.
     */
    function infoCategoriaResumo(result) {
        return CATEGORIES_MAP[isNaN(result) ? result.categoria.getCategoriaId() : result].infoResumo;
    }

    /**
     * Obtem o conjunto de campos que a busca por uma categoria faz.
     * @param {*} result Resultado ou ID da categoria.
     */
    function searchFields(result) {
        return CATEGORIES_MAP[isNaN(result) ? result.categoria.getCategoriaId() : result].fields;
    }

    /**
     * Obtem o path correspondente a um resultado.
     * @param {*} result Resultado.
     * @returns Path que identifica a rota necessário para acessar os detalhes do resultado.
     */
    function pathResultado(result) {
        var direction = DIRECTIONS_MAP[result.categoria.getCategoriaId()];

        return direction.getDirectionPath(result);
    }

    /**
     * Apresenta a tela informativa.
     */
    function showInfoPage() {
        var self = this;

        if (this.infoPage == undefined) {
            this.infoPage = this.$aside({
                scope: this.$scope,
                template: 'app/components/super-busca/info-page.html',
                placement: 'left',
                show: false,
                backdrop: true,
                animation: 'am-slide-left',
                prefixEvent: 'info'
            });

            this.$scope.$on('info.show', function (event) {
                $('body, nav').addClass('without_scroll');
            });

            this.$scope.$on('info.hide', function (event) {
                $('body, nav').removeClass('without_scroll');
            });
        }

        this.infoPage.$promise.then(function () { self.infoPage.show(); });
    }

    function openSuperBuscaLink(link) {
        if (link.includes('gerenciador')) {
            return '/' + link;
        }

        return '#/' + link;
    }

})();

(function () {
    'use strict';

    angular.module('portal').service('SuperBuscaService', Service);

    /**
     * Fornece serviços para a funcionalidade de super busca.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} apisuperbusca Endpoint utilizado no serviço de busca.
     * @param {*} Util Serviço de funções utilitárias.
     */
    function Service($http, $q, apisuperbusca, Util) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = apisuperbusca;
        _scope.Util = Util;
        _scope.store = function (data) { dataStored = data; }
        _scope.buscar = buscar;
        _scope.ResultPesquisa = ResultPesquisa;
        _scope.SuperBusca = SuperBusca;

        return _scope;
    }

    /**
     * Busca um valor.
     * @param {*} valor Valor.
     * @param {*} pagina Página do resultado; inicía com a página 1.
     */
    function buscar(valor, pagina) {
        var servicos = ['/indice'];

        valor = valor.trim();

        if (this.Util.hasOnlyDigits(valor) || this.Util.hasCpfFormat(valor) || this.Util.hasCnpjFormat(valor)) {
            if (this.Util.validarCPF(valor)) {
                valor = this.Util.extractDigits(valor);
                servicos = ['/indice-cpf', '/indice-cod-credor'];
            } else if (this.Util.validarCNPJ(valor)) {
                valor = this.Util.extractDigits(valor);
                servicos = ['/indice-cod-credor'];
            }
        }

        var self = this;

        function appendTransform(defaults, transform) {
            defaults = angular.isArray(defaults) ? defaults : [defaults];
            return defaults.concat(transform);
        }

        function encodeSlash(text) {
            return text.replace("/", "%252F");
        }

        var promiseArray = servicos.map(function (servico) {
            var valorEncoded = encodeSlash(valor);
            return self.$http({
                url: self.api.url + servico + '/' + (pagina ? pagina : 1) + '/' + valorEncoded,
                method: 'GET',
                cache: false,
                transformResponse: appendTransform(self.$http.defaults.transformResponse, function (result) {
                    return result == null ? null : result.map(function (r) {
                        return new self.ResultPesquisa(r);
                    });
                })
            });
        });

        return this.$q.all(promiseArray).then(function (responseArray) {
            var count = responseArray.map(function (resp) {
                return Number(resp.headers('x-count'));
            }).reduce(function (prev, curr) {
                return prev + curr;
            });

            var results = responseArray.map(function (resp) {
                return resp.data;
            }).reduce(function (acc, cur) {
                return acc.concat(cur);
            });

            return new self.SuperBusca(results, count);
        });
    }


    /**
     * Modelo referente ao tipo de categoria de um resultado da busca.
     */
    var ResultCategoria = (function () {
        function ResultCategoriaClass(dataset, coluna) {
            this.dataset = dataset;
            this.coluna = coluna;
        }

        /**
         * Obtem o ID da categoria do resultado.
         * @returns Inteiro positivo.
         */
        ResultCategoriaClass.prototype.getCategoriaId = function () {
            switch (this.dataset) {
                case 'REMUNERACAO': return 0;
                case 'SERVIDOR-ORGAO': return 1;
                case 'DESPESA-CREDOR': return 2;
                case 'BENEFICIARIOS-SOCIAIS': return 3;
                case 'DIARIAS-PASSAGENS': return 4;
                case 'RECEITA-ORGAO': return 5;
                case 'DESPESA-ORGAO': return 6;
                case 'DESPESA-ACAO': return 7;
                case 'PAGAMENTO-CREDOR': return 8;
                case 'DETALHAMENTO': return 9;
                case 'EMENDAS': return 10;
                case 'EXPULSOES': return 11;
                case 'CARGOS-COMISSIONADOS': return 12;
                case 'CONTRATOS': return 13;
                case 'CONSELHOS': return 14;
                case 'CONSELHEIROS': return 15;
                case 'ENTIDADES-BENEFICIADAS': return 16;
                case 'CONVENIOS-RECEITA': return 17;
                case 'CONVENIOS-DESPESA': return 18;
                case 'BENS-MOVEIS': return 19;
                case 'LOCALIZACAO-BENS-MOVEIS': return 20;
                case 'ITENS-LICITADOS': return 21;
                case 'CUSTOM-PALAVRA-CHAVE': return 22;
                case 'DESPESAS-CONSULTA-DINAMICA': return 23;
                case 'DESPESAS-NE-DESCRITIVOS': return 24;
                default: return null;
            }
        };

        /**
         * Obtem a categoria de forma descritiva.
         * @returns String representando a categoria.
         */
        ResultCategoriaClass.prototype.getCategoria = function () {
            return ['REMUNERACAO',
                'SERVIDOR-ORGAO',
                'DESPESA-CREDOR',
                'BENEFICIARIOS-SOCIAIS',
                'DIARIAS-PASSAGENS',
                'RECEITA-ORGAO',
                'DESPESA-ORGAO',
                'DESPESA-ACAO',
                'PAGAMENTO-CREDOR',
                'DETALHAMENTO',
                'EMENDAS',
                'EXPULSOES',
                'CARGOS-COMISSIONADOS',
                'CONTRATOS',
                'CONSELHOS',
                'CONSELHEIROS',
                'ENTIDADES-BENEFICIADAS',
                'CONVENIOS-RECEITA',
                'CONVENIOS-DESPESA',
                'BENS-MOVEIS',
                'LOCALIZACAO-BENS-MOVEIS',
                'ITENS-LICITADOS',
                'CUSTOM-PALAVRA-CHAVE',
                'DESPESAS-CONSULTA-DINAMICA',
                'DESPESAS-NE-DESCRITIVOS'][this.getCategoriaId()];
        };

        /**
         * Obtem o ID correspondente ao campo do resultado.
         * @returns Inteiro positivo.
         */
        ResultCategoriaClass.prototype.getCampoId = function () {
            switch (this.coluna) {
                case 'NOME': return 0;
                case 'DC_EMPRESA': return 1;
                case 'NR_CPF': return 2;
                case 'CD_CREDOR': return 3;
                case 'NM_CREDOR': return 4;
                case 'NM_UG': return 5;
                case 'DS_NOME': return 6;
                case 'DC-ORGAO': return 7;
                case 'NR-CPF': return 8;
                case 'NM_OBJETO': return 9;
                case 'NM_CONSELHO': return 10;
                case 'NM_ORGAO_VINCULADO': return 11;
                case 'NM_CONSELHEIRO': return 12;
                case 'NM_REP': return 13;
                case 'CD_ENTIDADE': return 14;
                case 'NM_ENTIDADE': return 15;
                case 'NM_ORGAO_TRANSFERIDOR': return 16;
                case 'NM_CONCEDENTE': return 17;
                case 'NM_CONVENENTE': return 18;
                case 'NM_JUST': return 19;
                case 'NM_ITEM': return 20;
                case 'NM_ORGAO_LOCALIZACAO': return 21;
                case 'NM_DESC': return 22;
                case 'DS_FUNCAO': return 23;
                case 'DS_ITEM': return 24;
                case 'NM_FORNECEDOR': return 25;
                case 'DS_NOME_BENEFICIARIO': return 26;
                case 'NR_NE': return 27;
                case 'NR_NL': return 28;
                case 'NR_OB': return 29;
                case 'NR_PROCESSO': return 30;
                case 'TX_ESPECIFICACAO': return 31;
                default: return null;
            }
        };

        return ResultCategoriaClass;
    })();

    /**
     * Modelo referente a um resultado da busca.
     */
    var ResultPesquisa = (function () {
        function ResultPesquisaClass(result) {
            if (result.descritivo != undefined) {
                this.descritivo = result.descritivo;
                this.value = result.descritivo;
            } else if (result.nomeServidor) {
                this.descritivo = result.nomeServidor;
                this.value = result.cpfServidor;
            } else if (result.nomeCredor) {
                this.descritivo = result.nomeCredor;
                this.value = result.codCredor;
            }

            this.descritivo = this.descritivo ? this.descritivo.trim() : undefined;
            this.value = this.value ? this.value.trim() : undefined;
            this.mes = result.mesReferencia;
            this.exercicio = result.exercicio;
            this.campo = result.coluna;
            this.descricao = result.descricao;
            this.urlConsulta = result.urlConsulta;
            this.notaEmpenho = result.notaEmpenho;
            this.codigoUnidadeGestora = result.codigoUnidadeGestora;
            this.codigoGestao = result.codigoGestao;
            this.categoria = new ResultCategoria(result.dataset, result.coluna);

            if (result.anoMes && result.anoMes.length == 6) {
                this.exercicio = Number(result.anoMes.substr(0, 4));
                this.mes = Number(result.anoMes.substr(4, 2));
            }
        }

        /**
         * Obtem a data descritiva do resultado.
         * @returns String referente a data no formado MM/yyyy.
         */
        ResultPesquisaClass.prototype.getDataDescritiva = function () {
            if (this.exercicio) {
                if (this.mes) {
                    return this.mes + "/" + this.exercicio;
                }

                return String(this.exercicio);
            }

            return '';
        };

        return ResultPesquisaClass;
    })();

    /**
     * Modelo referente ao resultado de uma busca.
     */
    var SuperBusca = (function () {
        var SuperBuscaClass = function (results, count) {
            this.count = count;
            this.results = results;
        };

        return SuperBuscaClass;
    })();

})();

(function () {
  'use strict';

  angular.module('portal').controller('ArquivoUrlController', ArquivoUrlController);

  /** @ngInject */
  function ArquivoUrlController(TopnavService, $location, $window, ArquivoUrlService) {

    var vm = this;
    vm.errorFlag = false;
    vm.successFlag = false;


    var URL_ARQUIVOS_PORTAL = ArquivoUrlService.ARQUIVOS;

    var COD_CATEGORIA_ACOES_CONTROLE = 54;
    var COD_CATEGORIA_TOMADAS_CONTA_ESPECIAL = 52;
    var COD_CATEGORIA_PROCESSOS_CORRECIONAIS_SAUDE = 51;
    var COD_CATEGORIA_PLANO_ESTRATEGICO = 53;
    var COD_CATEGORIA_CGDF_PAD_PENDENTES = 57;
    var COD_CATEGORIA_CGDF_PAD_PAF = 58;
    var COD_CATEGORIA_CGDF_PIP = 59;
    var COD_CATEGORIA_CEDIDOS_POLICIA_MILITAR = 61;
    var COD_CATEGORIA_CEDIDOS_BOMBEIROS = 62;

    var CONSULTA_ACOES_CONTROLE = 'andamento-acoes-controle';
    var CONSULTA_TOMADA_CONTAS_ESPECIAL = 'andamento-tomadas-conta-especial';
    var CONSULTA_CGDF_PAD_PENDENTES = 'cgdf-pads-pendentes';
    var CONSULTA_CGDF_PAD_PAF = 'cgdf-pad-paf';
    var CONSULTA_CGDF_PIP = 'cgdf-pip';
    var CONSULTA_PROCESSOS_CORRECIONAIS_SAUDE = 'processos-correcionais-saude';
    var CONSULTA_PLANO_ESTRATEGICO = 'plano-estrategico';
    var CONSULTA_CEDIDOS_POLICIA_MILITAR = 'cedidos-policia-militar-df';
    var CONSULTA_CEDIDOS_BOMBEIROS = 'cedidos-bombeiros-df';


    var main = function () {
      var consulta = $location.search()['query'];
      var exercicio = $location.search()['exercicio'];

      if(exercicio){

        switch (consulta){
          case CONSULTA_CEDIDOS_POLICIA_MILITAR:
           abrirArquivoPorCodCategoriaExercicio(COD_CATEGORIA_CEDIDOS_POLICIA_MILITAR, exercicio);
           break;
          case CONSULTA_CEDIDOS_BOMBEIROS:
           abrirArquivoPorCodCategoriaExercicio(COD_CATEGORIA_CEDIDOS_BOMBEIROS, exercicio);
           break;
          default:
            $window.location = '/';
        }

      }else{
        switch (consulta) {
          case CONSULTA_ACOES_CONTROLE:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_ACOES_CONTROLE);
            break;
          case CONSULTA_TOMADA_CONTAS_ESPECIAL:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_TOMADAS_CONTA_ESPECIAL);
            break;
          case CONSULTA_CGDF_PAD_PENDENTES:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_CGDF_PAD_PENDENTES);
            break;
          case CONSULTA_CGDF_PAD_PAF:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_CGDF_PAD_PAF);
            break;
          case CONSULTA_CGDF_PIP:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_CGDF_PIP);
            break;
          case CONSULTA_PROCESSOS_CORRECIONAIS_SAUDE:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_PROCESSOS_CORRECIONAIS_SAUDE);
            break;
          case CONSULTA_PLANO_ESTRATEGICO:
            abrirArquivoPorCodCategoria(COD_CATEGORIA_PLANO_ESTRATEGICO);
            break;
          default:
            $window.location = '/';
        }
      }
    }

    function abrirArquivoPorCodCategoria(codigoCategoria) {
      TopnavService.abrirArquivoPorCodCategoria(codigoCategoria)
        .then(function (response) {
          if (response.data.urlArquivo == null) {
            vm.errorFlag = true;
          } else {
            var urlArquivo = URL_ARQUIVOS_PORTAL + response.data.urlArquivo;
            $window.location = urlArquivo;
            vm.successFlag = true;
          }
        })
        .catch(function (error) {
          vm.errorFlag = true;
        });
    }

    function abrirArquivoPorCodCategoriaExercicio(codigoCategoria, exercicio) {
      TopnavService.abrirArquivoPorCodCategoriaExercicio(codigoCategoria, exercicio)
        .then(function (response) {
          if (response.data.urlArquivo == null) {
            vm.errorFlag = true;
          } else {
            var urlArquivo = URL_ARQUIVOS_PORTAL + response.data.urlArquivo;
            $window.location = urlArquivo;
            vm.successFlag = true;
          }
        })
        .catch(function (error) {
          vm.errorFlag = true;
        });
    }

    main();

  }

})();

(function(){
  'use strict';

  angular.module('portal').service('ArquivoUrlService', ArquivoUrlService);

  function ArquivoUrlService(caminhoImagens, caminhoArquivos, caminhoDadosAbertos) {
        this.IMAGENS = caminhoImagens.url;
        this.ARQUIVOS = caminhoArquivos.url;
        this.DADOS_ABERTOS = caminhoDadosAbertos.url;

  }

})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "Antes de Cristo",
        "Ano do Senhor"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "Janeiro",
        "Fevereiro",
        "Mar\u00e7o",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/yy HH:mm",
      "shortDate": "dd/MM/yy",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

/*eslint-disable */
/**
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

/**
 * This is based, in part, on [fkadeveloper](https://github.com/fkadeveloper)'s
 * [lorem.js](https://github.com/fkadeveloper/loremjs).
 */
angular.module( 'ngPlaceholders', [] )

  .factory( 'PlaceholderTextService', function () {

    var words = ["lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing",
      "elit", "ut", "aliquam,", "purus", "sit", "amet", "luctus", "venenatis,",
      "lectus", "magna", "fringilla", "urna,", "porttitor", "rhoncus", "dolor",
      "purus", "non", "enim", "praesent", "elementum", "facilisis", "leo,", "vel",
      "fringilla", "est", "ullamcorper", "eget", "nulla", "facilisi", "etiam",
      "dignissim", "diam", "quis", "enim", "lobortis", "scelerisque", "fermentum",
      "dui", "faucibus", "in", "ornare", "quam", "viverra", "orci", "sagittis", "eu",
      "volutpat", "odio", "facilisis", "mauris", "sit", "amet", "massa", "vitae",
      "tortor", "condimentum", "lacinia", "quis", "vel", "eros", "donec", "ac",
      "odio", "tempor", "orci", "dapibus", "ultrices", "in", "iaculis", "nunc",
      "sed", "augue", "lacus,", "viverra", "vitae", "congue", "eu,", "consequat",
      "ac", "felis", "donec", "et", "odio", "pellentesque", "diam", "volutpat",
      "commodo", "sed", "egestas", "egestas", "fringilla", "phasellus", "faucibus",
      "scelerisque", "eleifend", "donec", "pretium", "vulputate", "sapien", "nec",
      "sagittis", "aliquam", "malesuada", "bibendum", "arcu", "vitae", "elementum",
      "curabitur", "vitae", "nunc", "sed", "velit", "dignissim", "sodales", "ut",
      "eu", "sem", "integer", "vitae", "justo", "eget", "magna", "fermentum",
      "iaculis", "eu", "non", "diam", "phasellus", "vestibulum", "lorem", "sed",
      "risus", "ultricies", "tristique", "nulla", "aliquet", "enim", "tortor,", "at",
      "auctor", "urna", "nunc", "id", "cursus", "metus", "aliquam", "eleifend", "mi",
      "in", "nulla", "posuere", "sollicitudin", "aliquam", "ultrices", "sagittis",
      "orci,", "a", "scelerisque", "purus", "semper", "eget", "duis", "at", "tellus",
      "at", "urna", "condimentum", "mattis", "pellentesque", "id", "nibh", "tortor,",
      "id", "aliquet", "lectus", "proin", "nibh", "nisl,", "condimentum", "id",
      "venenatis", "a,", "condimentum", "vitae", "sapien", "pellentesque",
      "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada",
      "fames", "ac", "turpis", "egestas", "sed", "tempus,", "urna", "et", "pharetra",
      "pharetra,", "massa", "massa", "ultricies", "mi,", "quis", "hendrerit",
      "dolor", "magna", "eget", "est", "lorem", "ipsum", "dolor", "sit", "amet,",
      "consectetur", "adipiscing", "elit", "pellentesque", "habitant", "morbi",
      "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac",
      "turpis", "egestas", "integer", "eget", "aliquet", "nibh", "praesent",
      "tristique", "magna", "sit", "amet", "purus", "gravida", "quis", "blandit",
      "turpis", "cursus", "in", "hac", "habitasse", "platea", "dictumst", "quisque",
      "sagittis,", "purus", "sit", "amet", "volutpat", "consequat,", "mauris",
      "nunc", "congue", "nisi,", "vitae", "suscipit", "tellus", "mauris", "a",
      "diam", "maecenas", "sed", "enim", "ut", "sem", "viverra", "aliquet", "eget",
      "sit", "amet", "tellus", "cras", "adipiscing", "enim", "eu", "turpis",
      "egestas", "pretium", "aenean", "pharetra,", "magna", "ac", "placerat",
      "vestibulum,", "lectus", "mauris", "ultrices", "eros,", "in", "cursus",
      "turpis", "massa", "tincidunt", "dui", "ut", "ornare", "lectus", "sit", "amet",
      "est", "placerat", "in", "egestas", "erat", "imperdiet", "sed", "euismod",
      "nisi", "porta", "lorem", "mollis", "aliquam", "ut", "porttitor", "leo", "a",
      "diam", "sollicitudin", "tempor", "id", "eu", "nisl", "nunc", "mi", "ipsum,",
      "faucibus", "vitae", "aliquet", "nec,", "ullamcorper", "sit", "amet", "risus",
      "nullam", "eget", "felis", "eget", "nunc", "lobortis", "mattis", "aliquam",
      "faucibus", "purus", "in", "massa", "tempor", "nec", "feugiat", "nisl",
      "pretium", "fusce", "id", "velit", "ut", "tortor", "pretium", "viverra",
      "suspendisse", "potenti", "nullam", "ac", "tortor", "vitae", "purus",
      "faucibus", "ornare", "suspendisse", "sed", "nisi", "lacus,", "sed", "viverra",
      "tellus", "in", "hac", "habitasse", "platea", "dictumst", "vestibulum",
      "rhoncus", "est", "pellentesque", "elit", "ullamcorper", "dignissim", "cras",
      "tincidunt", "lobortis", "feugiat", "vivamus", "at", "augue", "eget", "arcu",
      "dictum", "varius", "duis", "at", "consectetur", "lorem", "donec", "massa",
      "sapien,", "faucibus", "et", "molestie", "ac,", "feugiat", "sed", "lectus",
      "vestibulum", "mattis", "ullamcorper", "velit", "sed", "ullamcorper", "morbi",
      "tincidunt", "ornare", "massa,", "eget", "egestas", "purus", "viverra",
      "accumsan", "in", "nisl", "nisi,", "scelerisque", "eu", "ultrices", "vitae,",
      "auctor", "eu", "augue", "ut", "lectus", "arcu,", "bibendum", "at", "varius",
      "vel,", "pharetra", "vel", "turpis", "nunc", "eget", "lorem", "dolor,", "sed",
      "viverra", "ipsum", "nunc", "aliquet", "bibendum", "enim,", "facilisis",
      "gravida", "neque", "convallis", "a", "cras", "semper", "auctor", "neque,",
      "vitae", "tempus", "quam", "pellentesque", "nec", "nam", "aliquam", "sem",
      "et", "tortor", "consequat", "id", "porta", "nibh", "venenatis", "cras", "sed",
      "felis", "eget", "velit", "aliquet", "sagittis", "id", "consectetur", "purus",
      "ut", "faucibus", "pulvinar", "elementum", "integer", "enim", "neque,",
      "volutpat", "ac", "tincidunt", "vitae,", "semper", "quis", "lectus", "nulla",
      "at", "volutpat", "diam", "ut", "venenatis", "tellus", "in", "metus",
      "vulputate", "eu", "scelerisque", "felis", "imperdiet", "proin", "fermentum",
      "leo", "vel", "orci", "porta", "non", "pulvinar", "neque", "laoreet",
      "suspendisse", "interdum", "consectetur", "libero,", "id", "faucibus", "nisl",
      "tincidunt", "eget", "nullam", "non", "nisi", "est,", "sit", "amet",
      "facilisis", "magna", "etiam", "tempor,", "orci", "eu", "lobortis",
      "elementum,", "nibh", "tellus", "molestie", "nunc,", "non", "blandit", "massa",
      "enim", "nec", "dui", "nunc", "mattis", "enim", "ut", "tellus", "elementum",
      "sagittis", "vitae", "et", "leo", "duis", "ut", "diam", "quam", "nulla",
      "porttitor", "massa", "id", "neque", "aliquam", "vestibulum", "morbi",
      "blandit", "cursus", "risus,", "at", "ultrices", "mi", "tempus", "imperdiet",
      "nulla", "malesuada", "pellentesque", "elit", "eget", "gravida", "cum",
      "sociis", "natoque", "penatibus", "et", "magnis", "dis", "parturient",
      "montes,", "nascetur", "ridiculus", "mus", "mauris", "vitae", "ultricies",
      "leo", "integer", "malesuada", "nunc", "vel", "risus", "commodo", "viverra",
      "maecenas", "accumsan,", "lacus", "vel", "facilisis", "volutpat,", "est",
      "velit", "egestas", "dui,", "id", "ornare", "arcu", "odio", "ut", "sem",
      "nulla", "pharetra", "diam", "sit", "amet", "nisl", "suscipit", "adipiscing",
      "bibendum", "est", "ultricies", "integer", "quis", "auctor", "elit", "sed",
      "vulputate", "mi", "sit", "amet", "mauris", "commodo", "quis", "imperdiet",
      "massa", "tincidunt", "nunc", "pulvinar", "sapien", "et", "ligula",
      "ullamcorper", "malesuada", "proin", "libero", "nunc,", "consequat",
      "interdum", "varius", "sit", "amet,", "mattis", "vulputate", "enim", "nulla",
      "aliquet", "porttitor", "lacus,", "luctus", "accumsan", "tortor", "posuere",
      "ac", "ut", "consequat", "semper", "viverra", "nam", "libero", "justo,",
      "laoreet", "sit", "amet", "cursus", "sit", "amet,", "dictum", "sit", "amet",
      "justo", "donec", "enim", "diam,", "vulputate", "ut", "pharetra", "sit",
      "amet,", "aliquam", "id", "diam", "maecenas", "ultricies", "mi", "eget",
      "mauris", "pharetra", "et", "ultrices", "neque", "ornare", "aenean", "euismod",
      "elementum", "nisi,", "quis", "eleifend", "quam", "adipiscing", "vitae",
      "proin", "sagittis,", "nisl", "rhoncus", "mattis", "rhoncus,", "urna", "neque",
      "viverra", "justo,", "nec", "ultrices", "dui", "sapien", "eget", "mi", "proin",
      "sed", "libero", "enim,", "sed", "faucibus", "turpis", "in", "eu", "mi",
      "bibendum", "neque", "egestas", "congue", "quisque", "egestas", "diam", "in",
      "arcu", "cursus", "euismod", "quis", "viverra", "nibh", "cras", "pulvinar",
      "mattis", "nunc,", "sed", "blandit", "libero", "volutpat", "sed", "cras",
      "ornare", "arcu", "dui", "vivamus", "arcu", "felis,", "bibendum", "ut",
      "tristique", "et,", "egestas", "quis", "ipsum", "suspendisse", "ultrices",
      "fusce", "ut", "placerat", "orci", "nulla", "pellentesque",
      "dignissim", "enim,", "sit", "amet", "venenatis", "urna", "cursus", "eget",
      "nunc", "scelerisque", "viverra", "mauris,", "in", "aliquam", "sem",
      "fringilla", "ut", "morbi", "tincidunt", "augue", "interdum", "velit",
      "euismod", "in", "pellentesque", "massa", "placerat", "duis", "ultricies",
      "lacus", "sed", "turpis", "tincidunt", "id", "aliquet", "risus", "feugiat",
      "in", "ante", "metus,", "dictum", "at", "tempor", "commodo,", "ullamcorper",
      "a", "lacus", "vestibulum", "sed", "arcu", "non", "odio", "euismod", "lacinia",
      "at", "quis", "risus", "sed", "vulputate", "odio", "ut", "enim", "blandit",
      "volutpat", "maecenas", "volutpat", "blandit", "aliquam", "etiam", "erat",
      "velit,", "scelerisque", "in", "dictum", "non,", "consectetur", "a", "erat",
      "nam", "at", "lectus", "urna", "duis", "convallis", "convallis", "tellus,",
      "id", "interdum", "velit", "laoreet", "id", "donec", "ultrices", "tincidunt",
      "arcu,", "non", "sodales", "neque", "sodales", "ut", "etiam", "sit", "amet",
      "nisl", "purus,", "in", "mollis", "nunc", "sed", "id", "semper", "risus", "in",
      "hendrerit", "gravida", "rutrum", "quisque", "non", "tellus", "orci,", "ac",
      "auctor", "augue", "mauris", "augue", "neque,", "gravida", "in", "fermentum",
      "et,", "sollicitudin", "ac", "orci", "phasellus", "egestas", "tellus",
      "rutrum", "tellus", "pellentesque", "eu", "tincidunt", "tortor", "aliquam",
      "nulla", "facilisi", "cras", "fermentum,", "odio", "eu", "feugiat", "pretium,",
      "nibh", "ipsum", "consequat", "nisl,", "vel", "pretium", "lectus", "quam",
      "id", "leo", "in", "vitae", "turpis", "massa", "sed", "elementum", "tempus",
      "egestas", "sed", "sed", "risus", "pretium", "quam", "vulputate", "dignissim",
      "suspendisse", "in", "est", "ante", "in", "nibh", "mauris,", "cursus",
      "mattis", "molestie", "a,", "iaculis", "at", "erat", "pellentesque",
      "adipiscing", "commodo", "elit,", "at", "imperdiet", "dui", "accumsan", "sit",
      "amet", "nulla", "facilisi", "morbi", "tempus", "iaculis", "urna,", "id",
      "volutpat", "lacus", "laoreet", "non", "curabitur", "gravida", "arcu", "ac",
      "tortor", "dignissim", "convallis", "aenean", "et", "tortor", "at", "risus",
      "viverra", "adipiscing", "at", "in", "tellus", "integer", "feugiat",
      "scelerisque", "varius", "morbi", "enim", "nunc,", "faucibus", "a",
      "pellentesque", "sit", "amet,", "porttitor", "eget", "dolor", "morbi", "non",
      "arcu", "risus,", "quis", "varius", "quam", "quisque", "id", "diam", "vel",
      "quam", "elementum", "pulvinar", "etiam", "non", "quam", "lacus",
      "suspendisse", "faucibus", "interdum", "posuere", "lorem", "ipsum", "dolor",
      "sit", "amet,", "consectetur", "adipiscing", "elit", "duis", "tristique",
      "sollicitudin", "nibh", "sit", "amet", "commodo", "nulla", "facilisi",
      "nullam", "vehicula", "ipsum", "a", "arcu", "cursus", "vitae", "congue",
      "mauris", "rhoncus", "aenean", "vel", "elit", "scelerisque", "mauris",
      "pellentesque", "pulvinar", "pellentesque", "habitant", "morbi", "tristique",
      "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis",
      "egestas", "maecenas", "pharetra", "convallis", "posuere", "morbi", "leo",
      "urna,", "molestie", "at", "elementum", "eu,", "facilisis", "sed", "odio",
      "morbi", "quis", "commodo", "odio", "aenean", "sed", "adipiscing", "diam",
      "donec", "adipiscing", "tristique", "risus", "nec", "feugiat", "in",
      "fermentum", "posuere", "urna", "nec", "tincidunt", "praesent", "semper",
      "feugiat", "nibh", "sed", "pulvinar", "proin", "gravida", "hendrerit",
      "lectus", "a", "molestie", "gravida", "dictum"
    ];


    var name = {
      "first_name": ["Aaliyah","Aaron","Abagail","Abbey","Abbie","Abbigail","Abby","Abdiel","Abdul","Abdullah","Abe","Abel","Abelardo","Abigail","Abigale","Abigayle","Abner","Abraham","Ada","Adah","Adalberto","Adaline","Adam","Adan","Addie","Addison","Adela","Adelbert","Adele","Adelia","Adeline","Adell","Adella","Adelle","Aditya","Adolf","Adolfo","Adolph","Adolphus","Adonis","Adrain","Adrian","Adriana","Adrianna","Adriel","Adrien","Adrienne","Afton","Aglae","Agnes","Agustin","Agustina","Ahmad","Ahmed","Aida","Aidan","Aiden","Aileen","Aimee","Aisha","Aiyana","Akeem","Al","Alaina","Alan","Alana","Alanis","Alanna","Alayna","Alba","Albert","Alberta","Albertha","Alberto","Albin","Albina","Alda","Alden","Alec","Aleen","Alejandra","Alejandrin","Alek","Alena","Alene","Alessandra","Alessandro","Alessia","Aletha","Alex","Alexa","Alexander","Alexandra","Alexandre","Alexandrea","Alexandria","Alexandrine","Alexandro","Alexane","Alexanne","Alexie","Alexis","Alexys","Alexzander","Alf","Alfonso","Alfonzo","Alford","Alfred","Alfreda","Alfredo","Ali","Alia","Alice","Alicia","Alisa","Alisha","Alison","Alivia","Aliya","Aliyah","Aliza","Alize","Allan","Allen","Allene","Allie","Allison","Ally","Alphonso","Alta","Althea","Alva","Alvah","Alvena","Alvera","Alverta","Alvina","Alvis","Alyce","Alycia","Alysa","Alysha","Alyson","Alysson","Amalia","Amanda","Amani","Amara","Amari","Amaya","Amber","Ambrose","Amelia","Amelie","Amely","America","Americo","Amie","Amina","Amir","Amira","Amiya","Amos","Amparo","Amy","Amya","Ana","Anabel","Anabelle","Anahi","Anais","Anastacio","Anastasia","Anderson","Andre","Andreane","Andreanne","Andres","Andrew","Andy","Angel","Angela","Angelica","Angelina","Angeline","Angelita","Angelo","Angie","Angus","Anibal","Anika","Anissa","Anita","Aniya","Aniyah","Anjali","Anna","Annabel","Annabell","Annabelle","Annalise","Annamae","Annamarie","Anne","Annetta","Annette","Annie","Ansel","Ansley","Anthony","Antoinette","Antone","Antonetta","Antonette","Antonia","Antonietta","Antonina","Antonio","Antwan","Antwon","Anya","April","Ara","Araceli","Aracely","Arch","Archibald","Ardella","Arden","Ardith","Arely","Ari","Ariane","Arianna","Aric","Ariel","Arielle","Arjun","Arlene","Arlie","Arlo","Armand","Armando","Armani","Arnaldo","Arne","Arno","Arnold","Arnoldo","Arnulfo","Aron","Art","Arthur","Arturo","Arvel","Arvid","Arvilla","Aryanna","Asa","Asha","Ashlee","Ashleigh","Ashley","Ashly","Ashlynn","Ashton","Ashtyn","Asia","Assunta","Astrid","Athena","Aubree","Aubrey","Audie","Audra","Audreanne","Audrey","August","Augusta","Augustine","Augustus","Aurelia","Aurelie","Aurelio","Aurore","Austen","Austin","Austyn","Autumn","Ava","Avery","Avis","Axel","Ayana","Ayden","Ayla","Aylin","Baby","Bailee","Bailey","Barbara","Barney","Baron","Barrett","Barry","Bart","Bartholome","Barton","Baylee","Beatrice","Beau","Beaulah","Bell","Bella","Belle","Ben","Benedict","Benjamin","Bennett","Bennie","Benny","Benton","Berenice","Bernadette","Bernadine","Bernard","Bernardo","Berneice","Bernhard","Bernice","Bernie","Berniece","Bernita","Berry","Bert","Berta","Bertha","Bertram","Bertrand","Beryl","Bessie","Beth","Bethany","Bethel","Betsy","Bette","Bettie","Betty","Bettye","Beulah","Beverly","Bianka","Bill","Billie","Billy","Birdie","Blair","Blaise","Blake","Blanca","Blanche","Blaze","Bo","Bobbie","Bobby","Bonita","Bonnie","Boris","Boyd","Brad","Braden","Bradford","Bradley","Bradly","Brady","Braeden","Brain","Brandi","Brando","Brandon","Brandt","Brandy","Brandyn","Brannon","Branson","Brant","Braulio","Braxton","Brayan","Breana","Breanna","Breanne","Brenda","Brendan","Brenden","Brendon","Brenna","Brennan","Brennon","Brent","Bret","Brett","Bria","Brian","Briana","Brianne","Brice","Bridget","Bridgette","Bridie","Brielle","Brigitte","Brionna","Brisa","Britney","Brittany","Brock","Broderick","Brody","Brook","Brooke","Brooklyn","Brooks","Brown","Bruce","Bryana","Bryce","Brycen","Bryon","Buck","Bud","Buddy","Buford","Bulah","Burdette","Burley","Burnice","Buster","Cade","Caden","Caesar","Caitlyn","Cale","Caleb","Caleigh","Cali","Calista","Callie","Camden","Cameron","Camila","Camilla","Camille","Camren","Camron","Camryn","Camylle","Candace","Candelario","Candice","Candida","Candido","Cara","Carey","Carissa","Carlee","Carleton","Carley","Carli","Carlie","Carlo","Carlos","Carlotta","Carmel","Carmela","Carmella","Carmelo","Carmen","Carmine","Carol","Carolanne","Carole","Carolina","Caroline","Carolyn","Carolyne","Carrie","Carroll","Carson","Carter","Cary","Casandra","Casey","Casimer","Casimir","Casper","Cassandra","Cassandre","Cassidy","Cassie","Catalina","Caterina","Catharine","Catherine","Cathrine","Cathryn","Cathy","Cayla","Ceasar","Cecelia","Cecil","Cecile","Cecilia","Cedrick","Celestine","Celestino","Celia","Celine","Cesar","Chad","Chadd","Chadrick","Chaim","Chance","Chandler","Chanel","Chanelle","Charity","Charlene","Charles","Charley","Charlie","Charlotte","Chase","Chasity","Chauncey","Chaya","Chaz","Chelsea","Chelsey","Chelsie","Chesley","Chester","Chet","Cheyanne","Cheyenne","Chloe","Chris","Christ","Christa","Christelle","Christian","Christiana","Christina","Christine","Christop","Christophe","Christopher","Christy","Chyna","Ciara","Cicero","Cielo","Cierra","Cindy","Citlalli","Clair","Claire","Clara","Clarabelle","Clare","Clarissa","Clark","Claud","Claude","Claudia","Claudie","Claudine","Clay","Clemens","Clement","Clementina","Clementine","Clemmie","Cleo","Cleora","Cleta","Cletus","Cleve","Cleveland","Clifford","Clifton","Clint","Clinton","Clotilde","Clovis","Cloyd","Clyde","Coby","Cody","Colby","Cole","Coleman","Colin","Colleen","Collin","Colt","Colten","Colton","Columbus","Concepcion","Conner","Connie","Connor","Conor","Conrad","Constance","Constantin","Consuelo","Cooper","Cora","Coralie","Corbin","Cordelia","Cordell","Cordia","Cordie","Corene","Corine","Cornelius","Cornell","Corrine","Cortez","Cortney","Cory","Coty","Courtney","Coy","Craig","Crawford","Creola","Cristal","Cristian","Cristina","Cristobal","Cristopher","Cruz","Crystal","Crystel","Cullen","Curt","Curtis","Cydney","Cynthia","Cyril","Cyrus","Dagmar","Dahlia","Daija","Daisha","Daisy","Dakota","Dale","Dallas","Dallin","Dalton","Damaris","Dameon","Damian","Damien","Damion","Damon","Dan","Dana","Dandre","Dane","D'angelo","Dangelo","Danial","Daniela","Daniella","Danielle","Danika","Dannie","Danny","Dante","Danyka","Daphne","Daphnee","Daphney","Darby","Daren","Darian","Dariana","Darien","Dario","Darion","Darius","Darlene","Daron","Darrel","Darrell","Darren","Darrick","Darrin","Darrion","Darron","Darryl","Darwin","Daryl","Dashawn","Dasia","Dave","David","Davin","Davion","Davon","Davonte","Dawn","Dawson","Dax","Dayana","Dayna","Dayne","Dayton","Dean","Deangelo","Deanna","Deborah","Declan","Dedric","Dedrick","Dee","Deion","Deja","Dejah","Dejon","Dejuan","Delaney","Delbert","Delfina","Delia","Delilah","Dell","Della","Delmer","Delores","Delpha","Delphia","Delphine","Delta","Demarco","Demarcus","Demario","Demetris","Demetrius","Demond","Dena","Denis","Dennis","Deon","Deondre","Deontae","Deonte","Dereck","Derek","Derick","Deron","Derrick","Deshaun","Deshawn","Desiree","Desmond","Dessie","Destany","Destin","Destinee","Destiney","Destini","Destiny","Devan","Devante","Deven","Devin","Devon","Devonte","Devyn","Dewayne","Dewitt","Dexter","Diamond","Diana","Dianna","Diego","Dillan","Dillon","Dimitri","Dina","Dino","Dion","Dixie","Dock","Dolly","Dolores","Domenic","Domenica","Domenick","Domenico","Domingo","Dominic","Dominique","Don","Donald","Donato","Donavon","Donna","Donnell","Donnie","Donny","Dora","Dorcas","Dorian","Doris","Dorothea","Dorothy","Dorris","Dortha","Dorthy","Doug","Douglas","Dovie","Doyle","Drake","Drew","Duane","Dudley","Dulce","Duncan","Durward","Dustin","Dusty","Dwight","Dylan","Earl","Earlene","Earline","Earnest","Earnestine","Easter","Easton","Ebba","Ebony","Ed","Eda","Edd","Eddie","Eden","Edgar","Edgardo","Edison","Edmond","Edmund","Edna","Eduardo","Edward","Edwardo","Edwin","Edwina","Edyth","Edythe","Effie","Efrain","Efren","Eileen","Einar","Eino","Eladio","Elaina","Elbert","Elda","Eldon","Eldora","Eldred","Eldridge","Eleanora","Eleanore","Eleazar","Electa","Elena","Elenor","Elenora","Eleonore","Elfrieda","Eli","Elian","Eliane","Elias","Eliezer","Elijah","Elinor","Elinore","Elisa","Elisabeth","Elise","Eliseo","Elisha","Elissa","Eliza","Elizabeth","Ella","Ellen","Ellie","Elliot","Elliott","Ellis","Ellsworth","Elmer","Elmira","Elmo","Elmore","Elna","Elnora","Elody","Eloisa","Eloise","Elouise","Eloy","Elroy","Elsa","Else","Elsie","Elta","Elton","Elva","Elvera","Elvie","Elvis","Elwin","Elwyn","Elyse","Elyssa","Elza","Emanuel","Emelia","Emelie","Emely","Emerald","Emerson","Emery","Emie","Emil","Emile","Emilia","Emiliano","Emilie","Emilio","Emily","Emma","Emmalee","Emmanuel","Emmanuelle","Emmet","Emmett","Emmie","Emmitt","Emmy","Emory","Ena","Enid","Enoch","Enola","Enos","Enrico","Enrique","Ephraim","Era","Eriberto","Eric","Erica","Erich","Erick","Ericka","Erik","Erika","Erin","Erling","Erna","Ernest","Ernestina","Ernestine","Ernesto","Ernie","Ervin","Erwin","Eryn","Esmeralda","Esperanza","Esta","Esteban","Estefania","Estel","Estell","Estella","Estelle","Estevan","Esther","Estrella","Etha","Ethan","Ethel","Ethelyn","Ethyl","Ettie","Eudora","Eugene","Eugenia","Eula","Eulah","Eulalia","Euna","Eunice","Eusebio","Eva","Evalyn","Evan","Evangeline","Evans","Eve","Eveline","Evelyn","Everardo","Everett","Everette","Evert","Evie","Ewald","Ewell","Ezekiel","Ezequiel","Ezra","Fabian","Fabiola","Fae","Fannie","Fanny","Fatima","Faustino","Fausto","Favian","Fay","Faye","Federico","Felicia","Felicita","Felicity","Felipa","Felipe","Felix","Felton","Fermin","Fern","Fernando","Ferne","Fidel","Filiberto","Filomena","Finn","Fiona","Flavie","Flavio","Fleta","Fletcher","Flo","Florence","Florencio","Florian","Florida","Florine","Flossie","Floy","Floyd","Ford","Forest","Forrest","Foster","Frances","Francesca","Francesco","Francis","Francisca","Francisco","Franco","Frank","Frankie","Franz","Fred","Freda","Freddie","Freddy","Frederic","Frederick","Frederik","Frederique","Fredrick","Fredy","Freeda","Freeman","Freida","Frida","Frieda","Friedrich","Fritz","Furman","Gabe","Gabriel","Gabriella","Gabrielle","Gaetano","Gage","Gail","Gardner","Garett","Garfield","Garland","Garnet","Garnett","Garret","Garrett","Garrick","Garrison","Garry","Garth","Gaston","Gavin","Gay","Gayle","Gaylord","Gene","General","Genesis","Genevieve","Gennaro","Genoveva","Geo","Geoffrey","George","Georgette","Georgiana","Georgianna","Geovanni","Geovanny","Geovany","Gerald","Geraldine","Gerard","Gerardo","Gerda","Gerhard","Germaine","German","Gerry","Gerson","Gertrude","Gia","Gianni","Gideon","Gilbert","Gilberto","Gilda","Giles","Gillian","Gina","Gino","Giovani","Giovanna","Giovanni","Giovanny","Gisselle","Giuseppe","Gladyce","Gladys","Glen","Glenda","Glenna","Glennie","Gloria","Godfrey","Golda","Golden","Gonzalo","Gordon","Grace","Gracie","Graciela","Grady","Graham","Grant","Granville","Grayce","Grayson","Green","Greg","Gregg","Gregoria","Gregorio","Gregory","Greta","Gretchen","Greyson","Griffin","Grover","Guadalupe","Gudrun","Guido","Guillermo","Guiseppe","Gunnar","Gunner","Gus","Gussie","Gust","Gustave","Guy","Gwen","Gwendolyn","Hadley","Hailee","Hailey","Hailie","Hal","Haleigh","Haley","Halie","Halle","Hallie","Hank","Hanna","Hannah","Hans","Hardy","Harley","Harmon","Harmony","Harold","Harrison","Harry","Harvey","Haskell","Hassan","Hassie","Hattie","Haven","Hayden","Haylee","Hayley","Haylie","Hazel","Hazle","Heath","Heather","Heaven","Heber","Hector","Heidi","Helen","Helena","Helene","Helga","Hellen","Helmer","Heloise","Henderson","Henri","Henriette","Henry","Herbert","Herman","Hermann","Hermina","Herminia","Herminio","Hershel","Herta","Hertha","Hester","Hettie","Hilario","Hilbert","Hilda","Hildegard","Hillard","Hillary","Hilma","Hilton","Hipolito","Hiram","Hobart","Holden","Hollie","Hollis","Holly","Hope","Horace","Horacio","Hortense","Hosea","Houston","Howard","Howell","Hoyt","Hubert","Hudson","Hugh","Hulda","Humberto","Hunter","Hyman","Ian","Ibrahim","Icie","Ida","Idell","Idella","Ignacio","Ignatius","Ike","Ila","Ilene","Iliana","Ima","Imani","Imelda","Immanuel","Imogene","Ines","Irma","Irving","Irwin","Isaac","Isabel","Isabell","Isabella","Isabelle","Isac","Isadore","Isai","Isaiah","Isaias","Isidro","Ismael","Isobel","Isom","Israel","Issac","Itzel","Iva","Ivah","Ivory","Ivy","Izabella","Izaiah","Jabari","Jace","Jacey","Jacinthe","Jacinto","Jack","Jackeline","Jackie","Jacklyn","Jackson","Jacky","Jaclyn","Jacquelyn","Jacques","Jacynthe","Jada","Jade","Jaden","Jadon","Jadyn","Jaeden","Jaida","Jaiden","Jailyn","Jaime","Jairo","Jakayla","Jake","Jakob","Jaleel","Jalen","Jalon","Jalyn","Jamaal","Jamal","Jamar","Jamarcus","Jamel","Jameson","Jamey","Jamie","Jamil","Jamir","Jamison","Jammie","Jan","Jana","Janae","Jane","Janelle","Janessa","Janet","Janice","Janick","Janie","Janis","Janiya","Jannie","Jany","Jaquan","Jaquelin","Jaqueline","Jared","Jaren","Jarod","Jaron","Jarred","Jarrell","Jarret","Jarrett","Jarrod","Jarvis","Jasen","Jasmin","Jason","Jasper","Jaunita","Javier","Javon","Javonte","Jay","Jayce","Jaycee","Jayda","Jayde","Jayden","Jaydon","Jaylan","Jaylen","Jaylin","Jaylon","Jayme","Jayne","Jayson","Jazlyn","Jazmin","Jazmyn","Jazmyne","Jean","Jeanette","Jeanie","Jeanne","Jed","Jedediah","Jedidiah","Jeff","Jefferey","Jeffery","Jeffrey","Jeffry","Jena","Jenifer","Jennie","Jennifer","Jennings","Jennyfer","Jensen","Jerad","Jerald","Jeramie","Jeramy","Jerel","Jeremie","Jeremy","Jermain","Jermaine","Jermey","Jerod","Jerome","Jeromy","Jerrell","Jerrod","Jerrold","Jerry","Jess","Jesse","Jessica","Jessie","Jessika","Jessy","Jessyca","Jesus","Jett","Jettie","Jevon","Jewel","Jewell","Jillian","Jimmie","Jimmy","Jo","Joan","Joana","Joanie","Joanne","Joannie","Joanny","Joany","Joaquin","Jocelyn","Jodie","Jody","Joe","Joel","Joelle","Joesph","Joey","Johan","Johann","Johanna","Johathan","John","Johnathan","Johnathon","Johnnie","Johnny","Johnpaul","Johnson","Jolie","Jon","Jonas","Jonatan","Jonathan","Jonathon","Jordan","Jordane","Jordi","Jordon","Jordy","Jordyn","Jorge","Jose","Josefa","Josefina","Joseph","Josephine","Josh","Joshua","Joshuah","Josiah","Josiane","Josianne","Josie","Josue","Jovan","Jovani","Jovanny","Jovany","Joy","Joyce","Juana","Juanita","Judah","Judd","Jude","Judge","Judson","Judy","Jules","Julia","Julian","Juliana","Julianne","Julie","Julien","Juliet","Julio","Julius","June","Junior","Junius","Justen","Justice","Justina","Justine","Juston","Justus","Justyn","Juvenal","Juwan","Kacey","Kaci","Kacie","Kade","Kaden","Kadin","Kaela","Kaelyn","Kaia","Kailee","Kailey","Kailyn","Kaitlin","Kaitlyn","Kale","Kaleb","Kaleigh","Kaley","Kali","Kallie","Kameron","Kamille","Kamren","Kamron","Kamryn","Kane","Kara","Kareem","Karelle","Karen","Kari","Kariane","Karianne","Karina","Karine","Karl","Karlee","Karley","Karli","Karlie","Karolann","Karson","Kasandra","Kasey","Kassandra","Katarina","Katelin","Katelyn","Katelynn","Katharina","Katherine","Katheryn","Kathleen","Kathlyn","Kathryn","Kathryne","Katlyn","Katlynn","Katrina","Katrine","Kattie","Kavon","Kay","Kaya","Kaycee","Kayden","Kayla","Kaylah","Kaylee","Kayleigh","Kayley","Kayli","Kaylie","Kaylin","Keagan","Keanu","Keara","Keaton","Keegan","Keeley","Keely","Keenan","Keira","Keith","Kellen","Kelley","Kelli","Kellie","Kelly","Kelsi","Kelsie","Kelton","Kelvin","Ken","Kendall","Kendra","Kendrick","Kenna","Kennedi","Kennedy","Kenneth","Kennith","Kenny","Kenton","Kenya","Kenyatta","Kenyon","Keon","Keshaun","Keshawn","Keven","Kevin","Kevon","Keyon","Keyshawn","Khalid","Khalil","Kian","Kiana","Kianna","Kiara","Kiarra","Kiel","Kiera","Kieran","Kiley","Kim","Kimberly","King","Kip","Kira","Kirk","Kirsten","Kirstin","Kitty","Kobe","Koby","Kody","Kolby","Kole","Korbin","Korey","Kory","Kraig","Kris","Krista","Kristian","Kristin","Kristina","Kristofer","Kristoffer","Kristopher","Kristy","Krystal","Krystel","Krystina","Kurt","Kurtis","Kyla","Kyle","Kylee","Kyleigh","Kyler","Kylie","Kyra","Lacey","Lacy","Ladarius","Lafayette","Laila","Laisha","Lamar","Lambert","Lamont","Lance","Landen","Lane","Laney","Larissa","Laron","Larry","Larue","Laura","Laurel","Lauren","Laurence","Lauretta","Lauriane","Laurianne","Laurie","Laurine","Laury","Lauryn","Lavada","Lavern","Laverna","Laverne","Lavina","Lavinia","Lavon","Lavonne","Lawrence","Lawson","Layla","Layne","Lazaro","Lea","Leann","Leanna","Leanne","Leatha","Leda","Lee","Leif","Leila","Leilani","Lela","Lelah","Leland","Lelia","Lempi","Lemuel","Lenna","Lennie","Lenny","Lenora","Lenore","Leo","Leola","Leon","Leonard","Leonardo","Leone","Leonel","Leonie","Leonor","Leonora","Leopold","Leopoldo","Leora","Lera","Lesley","Leslie","Lesly","Lessie","Lester","Leta","Letha","Letitia","Levi","Lew","Lewis","Lexi","Lexie","Lexus","Lia","Liam","Liana","Libbie","Libby","Lila","Lilian","Liliana","Liliane","Lilla","Lillian","Lilliana","Lillie","Lilly","Lily","Lilyan","Lina","Lincoln","Linda","Lindsay","Lindsey","Linnea","Linnie","Linwood","Lionel","Lisa","Lisandro","Lisette","Litzy","Liza","Lizeth","Lizzie","Llewellyn","Lloyd","Logan","Lois","Lola","Lolita","Loma","Lon","London","Lonie","Lonnie","Lonny","Lonzo","Lora","Loraine","Loren","Lorena","Lorenz","Lorenza","Lorenzo","Lori","Lorine","Lorna","Lottie","Lou","Louie","Louisa","Lourdes","Louvenia","Lowell","Loy","Loyal","Loyce","Lucas","Luciano","Lucie","Lucienne","Lucile","Lucinda","Lucio","Lucious","Lucius","Lucy","Ludie","Ludwig","Lue","Luella","Luigi","Luis","Luisa","Lukas","Lula","Lulu","Luna","Lupe","Lura","Lurline","Luther","Luz","Lyda","Lydia","Lyla","Lynn","Lyric","Lysanne","Mabel","Mabelle","Mable","Mac","Macey","Maci","Macie","Mack","Mackenzie","Macy","Madaline","Madalyn","Maddison","Madeline","Madelyn","Madelynn","Madge","Madie","Madilyn","Madisen","Madison","Madisyn","Madonna","Madyson","Mae","Maegan","Maeve","Mafalda","Magali","Magdalen","Magdalena","Maggie","Magnolia","Magnus","Maia","Maida","Maiya","Major","Makayla","Makenna","Makenzie","Malachi","Malcolm","Malika","Malinda","Mallie","Mallory","Malvina","Mandy","Manley","Manuel","Manuela","Mara","Marc","Marcel","Marcelina","Marcelino","Marcella","Marcelle","Marcellus","Marcelo","Marcia","Marco","Marcos","Marcus","Margaret","Margarete","Margarett","Margaretta","Margarette","Margarita","Marge","Margie","Margot","Margret","Marguerite","Maria","Mariah","Mariam","Marian","Mariana","Mariane","Marianna","Marianne","Mariano","Maribel","Marie","Mariela","Marielle","Marietta","Marilie","Marilou","Marilyne","Marina","Mario","Marion","Marisa","Marisol","Maritza","Marjolaine","Marjorie","Marjory","Mark","Markus","Marlee","Marlen","Marlene","Marley","Marlin","Marlon","Marques","Marquis","Marquise","Marshall","Marta","Martin","Martina","Martine","Marty","Marvin","Mary","Maryam","Maryjane","Maryse","Mason","Mateo","Mathew","Mathias","Mathilde","Matilda","Matilde","Matt","Matteo","Mattie","Maud","Maude","Maudie","Maureen","Maurice","Mauricio","Maurine","Maverick","Mavis","Max","Maxie","Maxime","Maximilian","Maximillia","Maximillian","Maximo","Maximus","Maxine","Maxwell","May","Maya","Maybell","Maybelle","Maye","Maymie","Maynard","Mayra","Mazie","Mckayla","Mckenna","Mckenzie","Meagan","Meaghan","Meda","Megane","Meggie","Meghan","Mekhi","Melany","Melba","Melisa","Melissa","Mellie","Melody","Melvin","Melvina","Melyna","Melyssa","Mercedes","Meredith","Merl","Merle","Merlin","Merritt","Mertie","Mervin","Meta","Mia","Micaela","Micah","Michael","Michaela","Michale","Micheal","Michel","Michele","Michelle","Miguel","Mikayla","Mike","Mikel","Milan","Miles","Milford","Miller","Millie","Milo","Milton","Mina","Minerva","Minnie","Miracle","Mireille","Mireya","Misael","Missouri","Misty","Mitchel","Mitchell","Mittie","Modesta","Modesto","Mohamed","Mohammad","Mohammed","Moises","Mollie","Molly","Mona","Monica","Monique","Monroe","Monserrat","Monserrate","Montana","Monte","Monty","Morgan","Moriah","Morris","Mortimer","Morton","Mose","Moses","Moshe","Mossie","Mozell","Mozelle","Muhammad","Muriel","Murl","Murphy","Murray","Mustafa","Mya","Myah","Mylene","Myles","Myra","Myriam","Myrl","Myrna","Myron","Myrtice","Myrtie","Myrtis","Myrtle","Nadia","Nakia","Name","Nannie","Naomi","Naomie","Napoleon","Narciso","Nash","Nasir","Nat","Natalia","Natalie","Natasha","Nathan","Nathanael","Nathanial","Nathaniel","Nathen","Nayeli","Neal","Ned","Nedra","Neha","Neil","Nelda","Nella","Nelle","Nellie","Nels","Nelson","Neoma","Nestor","Nettie","Neva","Newell","Newton","Nia","Nicholas","Nicholaus","Nichole","Nick","Nicklaus","Nickolas","Nico","Nicola","Nicolas","Nicole","Nicolette","Nigel","Nikita","Nikki","Nikko","Niko","Nikolas","Nils","Nina","Noah","Noble","Noe","Noel","Noelia","Noemi","Noemie","Noemy","Nola","Nolan","Nona","Nora","Norbert","Norberto","Norene","Norma","Norris","Norval","Norwood","Nova","Novella","Nya","Nyah","Nyasia","Obie","Oceane","Ocie","Octavia","Oda","Odell","Odessa","Odie","Ofelia","Okey","Ola","Olaf","Ole","Olen","Oleta","Olga","Olin","Oliver","Ollie","Oma","Omari","Omer","Ona","Onie","Opal","Ophelia","Ora","Oral","Oran","Oren","Orie","Orin","Orion","Orland","Orlando","Orlo","Orpha","Orrin","Orval","Orville","Osbaldo","Osborne","Oscar","Osvaldo","Oswald","Oswaldo","Otha","Otho","Otilia","Otis","Ottilie","Ottis","Otto","Ova","Owen","Ozella","Pablo","Paige","Palma","Pamela","Pansy","Paolo","Paris","Parker","Pascale","Pasquale","Pat","Patience","Patricia","Patrick","Patsy","Pattie","Paul","Paula","Pauline","Paxton","Payton","Pearl","Pearlie","Pearline","Pedro","Peggie","Penelope","Percival","Percy","Perry","Pete","Peter","Petra","Peyton","Philip","Phoebe","Phyllis","Pierce","Pierre","Pietro","Pink","Pinkie","Piper","Polly","Porter","Precious","Presley","Preston","Price","Prince","Princess","Priscilla","Providenci","Prudence","Queen","Queenie","Quentin","Quincy","Quinn","Quinten","Quinton","Rachael","Rachel","Rachelle","Rae","Raegan","Rafael","Rafaela","Raheem","Rahsaan","Rahul","Raina","Raleigh","Ralph","Ramiro","Ramon","Ramona","Randal","Randall","Randi","Randy","Ransom","Raoul","Raphael","Raphaelle","Raquel","Rashad","Rashawn","Rasheed","Raul","Raven","Ray","Raymond","Raymundo","Reagan","Reanna","Reba","Rebeca","Rebecca","Rebeka","Rebekah","Reece","Reed","Reese","Regan","Reggie","Reginald","Reid","Reilly","Reina","Reinhold","Remington","Rene","Renee","Ressie","Reta","Retha","Retta","Reuben","Reva","Rex","Rey","Reyes","Reymundo","Reyna","Reynold","Rhea","Rhett","Rhianna","Rhiannon","Rhoda","Ricardo","Richard","Richie","Richmond","Rick","Rickey","Rickie","Ricky","Rico","Rigoberto","Riley","Rita","River","Robb","Robbie","Robert","Roberta","Roberto","Robin","Robyn","Rocio","Rocky","Rod","Roderick","Rodger","Rodolfo","Rodrick","Rodrigo","Roel","Rogelio","Roger","Rogers","Rolando","Rollin","Roma","Romaine","Roman","Ron","Ronaldo","Ronny","Roosevelt","Rory","Rosa","Rosalee","Rosalia","Rosalind","Rosalinda","Rosalyn","Rosamond","Rosanna","Rosario","Roscoe","Rose","Rosella","Roselyn","Rosemarie","Rosemary","Rosendo","Rosetta","Rosie","Rosina","Roslyn","Ross","Rossie","Rowan","Rowena","Rowland","Roxane","Roxanne","Roy","Royal","Royce","Rozella","Ruben","Rubie","Ruby","Rubye","Rudolph","Rudy","Rupert","Russ","Russel","Russell","Rusty","Ruth","Ruthe","Ruthie","Ryan","Ryann","Ryder","Rylan","Rylee","Ryleigh","Ryley","Sabina","Sabrina","Sabryna","Sadie","Sadye","Sage","Saige","Sallie","Sally","Salma","Salvador","Salvatore","Sam","Samanta","Samantha","Samara","Samir","Sammie","Sammy","Samson","Sandra","Sandrine","Sandy","Sanford","Santa","Santiago","Santina","Santino","Santos","Sarah","Sarai","Sarina","Sasha","Saul","Savanah","Savanna","Savannah","Savion","Scarlett","Schuyler","Scot","Scottie","Scotty","Seamus","Sean","Sebastian","Sedrick","Selena","Selina","Selmer","Serena","Serenity","Seth","Shad","Shaina","Shakira","Shana","Shane","Shanel","Shanelle","Shania","Shanie","Shaniya","Shanna","Shannon","Shanny","Shanon","Shany","Sharon","Shaun","Shawn","Shawna","Shaylee","Shayna","Shayne","Shea","Sheila","Sheldon","Shemar","Sheridan","Sherman","Sherwood","Shirley","Shyann","Shyanne","Sibyl","Sid","Sidney","Sienna","Sierra","Sigmund","Sigrid","Sigurd","Silas","Sim","Simeon","Simone","Sincere","Sister","Skye","Skyla","Skylar","Sofia","Soledad","Solon","Sonia","Sonny","Sonya","Sophia","Sophie","Spencer","Stacey","Stacy","Stan","Stanford","Stanley","Stanton","Stefan","Stefanie","Stella","Stephan","Stephania","Stephanie","Stephany","Stephen","Stephon","Sterling","Steve","Stevie","Stewart","Stone","Stuart","Summer","Sunny","Susan","Susana","Susanna","Susie","Suzanne","Sven","Syble","Sydnee","Sydney","Sydni","Sydnie","Sylvan","Sylvester","Sylvia","Tabitha","Tad","Talia","Talon","Tamara","Tamia","Tania","Tanner","Tanya","Tara","Taryn","Tate","Tatum","Tatyana","Taurean","Tavares","Taya","Taylor","Teagan","Ted","Telly","Terence","Teresa","Terrance","Terrell","Terrence","Terrill","Terry","Tess","Tessie","Tevin","Thad","Thaddeus","Thalia","Thea","Thelma","Theo","Theodora","Theodore","Theresa","Therese","Theresia","Theron","Thomas","Thora","Thurman","Tia","Tiana","Tianna","Tiara","Tierra","Tiffany","Tillman","Timmothy","Timmy","Timothy","Tina","Tito","Titus","Tobin","Toby","Tod","Tom","Tomas","Tomasa","Tommie","Toney","Toni","Tony","Torey","Torrance","Torrey","Toy","Trace","Tracey","Tracy","Travis","Travon","Tre","Tremaine","Tremayne","Trent","Trenton","Tressa","Tressie","Treva","Trever","Trevion","Trevor","Trey","Trinity","Trisha","Tristian","Tristin","Triston","Troy","Trudie","Trycia","Trystan","Turner","Twila","Tyler","Tyra","Tyree","Tyreek","Tyrel","Tyrell","Tyrese","Tyrique","Tyshawn","Tyson","Ubaldo","Ulices","Ulises","Una","Unique","Urban","Uriah","Uriel","Ursula","Vada","Valentin","Valentina","Valentine","Valerie","Vallie","Van","Vance","Vanessa","Vaughn","Veda","Velda","Vella","Velma","Velva","Vena","Verda","Verdie","Vergie","Verla","Verlie","Vern","Verna","Verner","Vernice","Vernie","Vernon","Verona","Veronica","Vesta","Vicenta","Vicente","Vickie","Vicky","Victor","Victoria","Vida","Vidal","Vilma","Vince","Vincent","Vincenza","Vincenzo","Vinnie","Viola","Violet","Violette","Virgie","Virgil","Virginia","Virginie","Vita","Vito","Viva","Vivian","Viviane","Vivianne","Vivien","Vivienne","Vladimir","Wade","Waino","Waldo","Walker","Wallace","Walter","Walton","Wanda","Ward","Warren","Watson","Wava","Waylon","Wayne","Webster","Weldon","Wellington","Wendell","Wendy","Werner","Westley","Weston","Whitney","Wilber","Wilbert","Wilburn","Wiley","Wilford","Wilfred","Wilfredo","Wilfrid","Wilhelm","Wilhelmine","Will","Willa","Willard","William","Willie","Willis","Willow","Willy","Wilma","Wilmer","Wilson","Wilton","Winfield","Winifred","Winnifred","Winona","Winston","Woodrow","Wyatt","Wyman","Xander","Xavier","Xzavier","Yadira","Yasmeen","Yasmin","Yasmine","Yazmin","Yesenia","Yessenia","Yolanda","Yoshiko","Yvette","Yvonne","Zachariah","Zachary","Zachery","Zack","Zackary","Zackery","Zakary","Zander","Zane","Zaria","Zechariah","Zelda","Zella","Zelma","Zena","Zetta","Zion","Zita","Zoe","Zoey","Zoie","Zoila","Zola","Zora","Zula"],
      "last_name": ["Abbott","Abernathy","Abshire","Adams","Altenwerth","Anderson","Ankunding","Armstrong","Auer","Aufderhar","Bahringer","Bailey","Balistreri","Barrows","Bartell","Bartoletti","Barton","Bashirian","Batz","Bauch","Baumbach","Bayer","Beahan","Beatty","Bechtelar","Becker","Bednar","Beer","Beier","Berge","Bergnaum","Bergstrom","Bernhard","Bernier","Bins","Blanda","Blick","Block","Bode","Boehm","Bogan","Bogisich","Borer","Bosco","Botsford","Boyer","Boyle","Bradtke","Brakus","Braun","Breitenberg","Brekke","Brown","Bruen","Buckridge","Carroll","Carter","Cartwright","Casper","Cassin","Champlin","Christiansen","Cole","Collier","Collins","Conn","Connelly","Conroy","Considine","Corkery","Cormier","Corwin","Cremin","Crist","Crona","Cronin","Crooks","Cruickshank","Cummerata","Cummings","Dach","D'Amore","Daniel","Dare","Daugherty","Davis","Deckow","Denesik","Dibbert","Dickens","Dicki","Dickinson","Dietrich","Donnelly","Dooley","Douglas","Doyle","DuBuque","Durgan","Ebert","Effertz","Eichmann","Emard","Emmerich","Erdman","Ernser","Fadel","Fahey","Farrell","Fay","Feeney","Feest","Feil","Ferry","Fisher","Flatley","Frami","Franecki","Friesen","Fritsch","Funk","Gaylord","Gerhold","Gerlach","Gibson","Gislason","Gleason","Gleichner","Glover","Goldner","Goodwin","Gorczany","Gottlieb","Goyette","Grady","Graham","Grant","Green","Greenfelder","Greenholt","Grimes","Gulgowski","Gusikowski","Gutkowski","Gutmann","Haag","Hackett","Hagenes","Hahn","Haley","Halvorson","Hamill","Hammes","Hand","Hane","Hansen","Harber","Harris","Hartmann","Harvey","Hauck","Hayes","Heaney","Heathcote","Hegmann","Heidenreich","Heller","Herman","Hermann","Hermiston","Herzog","Hessel","Hettinger","Hickle","Hilll","Hills","Hilpert","Hintz","Hirthe","Hodkiewicz","Hoeger","Homenick","Hoppe","Howe","Howell","Hudson","Huel","Huels","Hyatt","Jacobi","Jacobs","Jacobson","Jakubowski","Jaskolski","Jast","Jenkins","Jerde","Johns","Johnson","Johnston","Jones","Kassulke","Kautzer","Keebler","Keeling","Kemmer","Kerluke","Kertzmann","Kessler","Kiehn","Kihn","Kilback","King","Kirlin","Klein","Kling","Klocko","Koch","Koelpin","Koepp","Kohler","Konopelski","Koss","Kovacek","Kozey","Krajcik","Kreiger","Kris","Kshlerin","Kub","Kuhic","Kuhlman","Kuhn","Kulas","Kunde","Kunze","Kuphal","Kutch","Kuvalis","Labadie","Lakin","Lang","Langosh","Langworth","Larkin","Larson","Leannon","Lebsack","Ledner","Leffler","Legros","Lehner","Lemke","Lesch","Leuschke","Lind","Lindgren","Littel","Little","Lockman","Lowe","Lubowitz","Lueilwitz","Luettgen","Lynch","Macejkovic","MacGyver","Maggio","Mann","Mante","Marks","Marquardt","Marvin","Mayer","Mayert","McClure","McCullough","McDermott","McGlynn","McKenzie","McLaughlin","Medhurst","Mertz","Metz","Miller","Mills","Mitchell","Moen","Mohr","Monahan","Moore","Morar","Morissette","Mosciski","Mraz","Mueller","Muller","Murazik","Murphy","Murray","Nader","Nicolas","Nienow","Nikolaus","Nitzsche","Nolan","Oberbrunner","O'Connell","O'Conner","O'Hara","O'Keefe","O'Kon","Okuneva","Olson","Ondricka","O'Reilly","Orn","Ortiz","Osinski","Pacocha","Padberg","Pagac","Parisian","Parker","Paucek","Pfannerstill","Pfeffer","Pollich","Pouros","Powlowski","Predovic","Price","Prohaska","Prosacco","Purdy","Quigley","Quitzon","Rath","Ratke","Rau","Raynor","Reichel","Reichert","Reilly","Reinger","Rempel","Renner","Reynolds","Rice","Rippin","Ritchie","Robel","Roberts","Rodriguez","Rogahn","Rohan","Rolfson","Romaguera","Roob","Rosenbaum","Rowe","Ruecker","Runolfsdottir","Runolfsson","Runte","Russel","Rutherford","Ryan","Sanford","Satterfield","Sauer","Sawayn","Schaden","Schaefer","Schamberger","Schiller","Schimmel","Schinner","Schmeler","Schmidt","Schmitt","Schneider","Schoen","Schowalter","Schroeder","Schulist","Schultz","Schumm","Schuppe","Schuster","Senger","Shanahan","Shields","Simonis","Sipes","Skiles","Smith","Smitham","Spencer","Spinka","Sporer","Stamm","Stanton","Stark","Stehr","Steuber","Stiedemann","Stokes","Stoltenberg","Stracke","Streich","Stroman","Strosin","Swaniawski","Swift","Terry","Thiel","Thompson","Tillman","Torp","Torphy","Towne","Toy","Trantow","Tremblay","Treutel","Tromp","Turcotte","Turner","Ullrich","Upton","Vandervort","Veum","Volkman","Von","VonRueden","Waelchi","Walker","Walsh","Walter","Ward","Waters","Watsica","Weber","Wehner","Weimann","Weissnat","Welch","West","White","Wiegand","Wilderman","Wilkinson","Will","Williamson","Willms","Windler","Wintheiser","Wisoky","Wisozk","Witting","Wiza","Wolf","Wolff","Wuckert","Wunsch","Wyman","Yost","Yundt","Zboncak","Zemlak","Ziemann","Zieme","Zulauf"]
    };

    var icons = [
      "md-menu", "md-arrow-drop-down", "md-flag", "md-home", "md-warning", "md-play-circle-fill",
      "md-forum", "md-content-paste", "md-battery-80", "md-format-textdirection-l-to-r", "md-folder-open",
      "md-desktop-windows", "md-collections", "md-directions-bike", "md-apps", "md-phone-in-talk", "md-people",
      "md-star-half", "md-arrow-drop-down", "md-file-download md-lg", "md-3d-rotation", "md-accessibility",
      "md-account-balance", "md-account-balance-wallet", "md-account-box", "md-account-child", "md-account-circle",
      "md-add-shopping-cart", "md-alarm", "md-alarm-add", "md-alarm-off", "md-alarm-on", "md-android", "md-announcement",
      "md-aspect-ratio", "md-assessment", "md-assignment", "md-assignment-ind", "md-assignment-late", "md-assignment-return",
      "md-assignment-returned", "md-assignment-turned-in", "md-autorenew", "md-backup", "md-book", "md-bookmark",
      "md-bookmark-outline", "md-bug-report", "md-cached", "md-class", "md-credit-card", "md-dashboard", "md-delete",
      "md-description", "md-dns", "md-done", "md-done-all", "md-event", "md-exit-to-app", "md-explore", "md-extension",
      "md-face-unlock", "md-favorite", "md-favorite-outline", "md-find-in-page", "md-find-replace", "md-flip-to-back",
      "md-flip-to-front", "md-get-app", "md-grade", "md-group-work", "md-help", "md-highlight-remove", "md-history",
      "md-home", "md-https", "md-info", "md-info-outline", "md-input", "md-invert-colors", "md-label", "md-label-outline",
      "md-language", "md-launch", "md-list", "md-lock", "md-lock-open", "md-lock-outline", "md-loyalty", "md-markunread-mailbox",
      "md-note-add", "md-open-in-browser", "md-open-in-new", "md-open-with", "md-pageview", "md-payment", "md-perm-camera-mic",
      "md-perm-contact-cal", "md-perm-data-setting", "md-perm-device-info", "md-perm-identity", "md-perm-media", "md-perm-phone-msg",
      "md-perm-scan-wifi", "md-picture-in-picture", "md-polymer", "md-print", "md-query-builder", "md-question-answer", "md-receipt",
      "md-redeem", "md-report-problem", "md-restore", "md-room", "md-schedule", "md-search", "md-settings", "md-settings-applications",
      "md-settings-backup-restore", "md-settings-bluetooth", "md-settings-cell", "md-settings-display", "md-settings-ethernet",
      "md-settings-input-antenna", "md-settings-input-component", "md-settings-input-composite", "md-settings-input-hdmi",
      "md-settings-input-svideo", "md-settings-overscan", "md-settings-phone", "md-settings-power", "md-settings-remote",
      "md-settings-voice", "md-shop", "md-shopping-basket", "md-shopping-cart", "md-shop-two", "md-speaker-notes",
      "md-spellcheck", "md-star-rate", "md-stars", "md-store", "md-subject", "md-swap-horiz", "md-swap-vert",
      "md-swap-vert-circle", "md-system-update-tv", "md-tab", "md-tab-unselected", "md-theaters", "md-thumb-down",
      "md-thumbs-up-down", "md-thumb-up", "md-toc", "md-today", "md-track-changes", "md-translate", "md-trending-down",
      "md-trending-neutral", "md-trending-up", "md-turned-in", "md-turned-in-not", "md-verified-user", "md-view-agenda",
      "md-view-array", "md-view-carousel", "md-view-column", "md-view-day", "md-view-headline", "md-view-list", "md-view-module",
      "md-view-quilt", "md-view-stream", "md-view-week", "md-visibility", "md-visibility-off", "md-wallet-giftcard", "md-wallet-membership",
      "md-wallet-travel", "md-work", "md-error", "md-warning", "md-album", "md-av-timer", "md-closed-caption", "md-equalizer", "md-explicit",
      "md-fast-forward", "md-fast-rewind", "md-games", "md-hearing", "md-high-quality", "md-loop", "md-mic", "md-mic-none",
      "md-mic-off", "md-movie", "md-my-library-add", "md-my-library-books", "md-my-library-music", "md-new-releases", "md-not-interested",
      "md-pause", "md-pause-circle-fill", "md-pause-circle-outline", "md-play-arrow", "md-play-circle-fill",
      "md-play-circle-outline", "md-playlist-add", "md-play-shopping-bag", "md-queue", "md-queue-music", "md-radio",
      "md-recent-actors", "md-repeat", "md-repeat-one", "md-replay", "md-shuffle", "md-skip-next", "md-skip-previous",
      "md-snooze", "md-stop", "md-subtitles", "md-surround-sound", "md-videocam", "md-videocam-off", "md-video-collection",
      "md-volume-down", "md-volume-mute", "md-volume-off", "md-volume-up", "md-web", "md-business", "md-call", "md-call-end",
      "md-call-made", "md-call-merge", "md-call-missed", "md-call-received", "md-call-split", "md-chat", "md-clear-all",
      "md-comment", "md-contacts", "md-dialer-sip", "md-dialpad", "md-dnd-on", "md-email", "md-forum", "md-import-export",
      "md-invert-colors-off", "md-invert-colors-on", "md-live-help", "md-location-off", "md-location-on", "md-message",
      "md-messenger", "md-no-sim", "md-phone", "md-portable-wifi-off", "md-quick-contacts-dialer", "md-quick-contacts-mail",
      "md-ring-volume", "md-stay-current-landscape", "md-stay-current-portrait", "md-stay-primary-landscape",
      "md-stay-primary-portrait", "md-swap-calls", "md-textsms", "md-voicemail", "md-vpn-key", "md-add", "md-add-box",
      "md-add-circle", "md-add-circle-outline", "md-archive", "md-backspace", "md-block", "md-clear", "md-content-copy",
      "md-content-cut", "md-content-paste", "md-create", "md-drafts", "md-filter-list", "md-flag", "md-forward",
      "md-gesture", "md-inbox", "md-link", "md-mail", "md-markunread", "md-redo", "md-remove", "md-remove-circle",
      "md-remove-circle-outline", "md-reply", "md-reply-all", "md-report", "md-save", "md-select-all", "md-send",
      "md-sort", "md-text-format", "md-undo", "md-access-alarm", "md-access-alarms", "md-access-time", "md-add-alarm",
      "md-airplanemode-off", "md-airplanemode-on", "md-battery-20", "md-battery-30", "md-battery-50", "md-battery-60",
      "md-battery-80", "md-battery-90", "md-battery-alert", "md-battery-charging-20", "md-battery-charging-30",
      "md-battery-charging-50", "md-battery-charging-60", "md-battery-charging-80", "md-battery-charging-90",
      "md-battery-charging-full", "md-battery-full", "md-battery-std", "md-battery-unknown", "md-bluetooth",
      "md-bluetooth-connected", "md-bluetooth-disabled", "md-bluetooth-searching", "md-brightness-auto", "md-brightness-high",
      "md-brightness-low", "md-brightness-medium", "md-data-usage", "md-developer-mode", "md-devices", "md-dvr",
      "md-gps-fixed", "md-gps-not-fixed", "md-gps-off", "md-location-disabled", "md-location-searching",
      "md-multitrack-audio", "md-network-cell", "md-network-wifi", "md-nfc", "md-now-wallpaper", "md-now-widgets",
      "md-screen-lock-landscape", "md-screen-lock-portrait", "md-screen-lock-rotation", "md-screen-rotation", "md-sd-storage",
      "md-settings-system-daydream", "md-signal-cellular-0-bar", "md-signal-cellular-1-bar", "md-signal-cellular-2-bar",
      "md-signal-cellular-3-bar", "md-signal-cellular-4-bar", "md-signal-cellular-connected-no-internet-0-bar",
      "md-signal-cellular-connected-no-internet-1-bar", "md-signal-cellular-connected-no-internet-2-bar",
      "md-signal-cellular-connected-no-internet-3-bar", "md-signal-cellular-connected-no-internet-4-bar",
      "md-signal-cellular-no-sim", "md-signal-cellular-null", "md-signal-cellular-off", "md-signal-wifi-0-bar",
      "md-signal-wifi-1-bar", "md-signal-wifi-2-bar", "md-signal-wifi-3-bar", "md-signal-wifi-4-bar", "md-signal-wifi-off",
      "md-storage", "md-usb", "md-wifi-lock", "md-wifi-tethering", "md-attach-file", "md-attach-money", "md-border-all",
      "md-border-bottom", "md-border-clear", "md-border-color", "md-border-horizontal", "md-border-inner", "md-border-left",
      "md-border-outer", "md-border-right", "md-border-style", "md-border-top", "md-border-vertical", "md-format-align-center",
      "md-format-align-justify", "md-format-align-left", "md-format-align-right", "md-format-bold", "md-format-clear",
      "md-format-color-fill", "md-format-color-reset", "md-format-color-text", "md-format-indent-decrease",
      "md-format-indent-increase", "md-format-italic", "md-format-line-spacing", "md-format-list-bulleted",
      "md-format-list-numbered", "md-format-paint", "md-format-quote", "md-format-size", "md-format-strikethrough",
      "md-format-textdirection-l-to-r", "md-format-textdirection-r-to-l", "md-format-underline", "md-functions",
      "md-insert-chart", "md-insert-comment", "md-insert-drive-file", "md-insert-emoticon", "md-insert-invitation",
      "md-insert-link", "md-insert-photo", "md-merge-type", "md-mode-comment", "md-mode-edit", "md-publish",
      "md-vertical-align-bottom", "md-vertical-align-center", "md-vertical-align-top", "md-wrap-text", "md-attachment",
      "md-cloud", "md-cloud-circle", "md-cloud-done", "md-cloud-download", "md-cloud-off", "md-cloud-queue",
      "md-cloud-upload", "md-file-download", "md-file-upload", "md-folder", "md-folder-open", "md-folder-shared",
      "md-cast", "md-cast-connected", "md-computer", "md-desktop-mac", "md-desktop-windows", "md-dock", "md-gamepad",
      "md-headset", "md-headset-mic", "md-keyboard", "md-keyboard-alt", "md-keyboard-arrow-down", "md-keyboard-arrow-left",
      "md-keyboard-arrow-right", "md-keyboard-arrow-up", "md-keyboard-backspace", "md-keyboard-capslock",
      "md-keyboard-control", "md-keyboard-hide", "md-keyboard-return", "md-keyboard-tab", "md-keyboard-voice",
      "md-laptop", "md-laptop-chromebook", "md-laptop-mac", "md-laptop-windows", "md-memory", "md-mouse",
      "md-phone-android", "md-phone-iphone", "md-phonelink", "md-phonelink-off", "md-security", "md-sim-card",
      "md-smartphone", "md-speaker", "md-tablet", "md-tablet-android", "md-tablet-mac", "md-tv", "md-watch",
      "md-add-to-photos", "md-adjust", "md-assistant-photo", "md-audiotrack", "md-blur-circular", "md-blur-linear",
      "md-blur-off", "md-blur-on", "md-brightness-1", "md-brightness-2", "md-brightness-3", "md-brightness-4",
      "md-brightness-5", "md-brightness-6", "md-brightness-7", "md-brush", "md-camera", "md-camera-alt", "md-camera-front",
      "md-camera-rear", "md-camera-roll", "md-center-focus-strong", "md-center-focus-weak", "md-collections", "md-colorize",
      "md-color-lens", "md-compare", "md-control-point", "md-control-point-duplicate", "md-crop", "md-crop-3-2", "md-crop-5-4",
      "md-crop-7-5", "md-crop-16-9", "md-crop-din", "md-crop-free", "md-crop-landscape", "md-crop-original", "md-crop-portrait",
      "md-crop-square", "md-dehaze", "md-details", "md-edit", "md-exposure", "md-exposure-minus-1", "md-exposure-minus-2",
      "md-exposure-zero", "md-exposure-plus-1", "md-exposure-plus-2", "md-filter", "md-filter-1", "md-filter-2", "md-filter-3",
      "md-filter-4", "md-filter-5", "md-filter-6", "md-filter-7", "md-filter-8", "md-filter-9", "md-filter-9-plus", "md-filter-b-and-w",
      "md-filter-center-focus", "md-filter-drama", "md-filter-frames", "md-filter-hdr", "md-filter-none", "md-filter-tilt-shift",
      "md-filter-vintage", "md-flare", "md-flash-auto", "md-flash-off", "md-flash-on", "md-flip", "md-gradient", "md-grain",
      "md-grid-off", "md-grid-on", "md-hdr-off", "md-hdr-on", "md-hdr-strong", "md-hdr-weak", "md-healing", "md-image",
      "md-image-aspect-ratio", "md-iso", "md-landscape", "md-leak-add", "md-leak-remove", "md-lens", "md-looks", "md-looks-1",
      "md-looks-2", "md-looks-3", "md-looks-4", "md-looks-5", "md-looks-6", "md-loupe", "md-movie-creation", "md-nature",
      "md-nature-people", "md-navigate-before", "md-navigate-next", "md-palette", "md-panorama", "md-panorama-fisheye",
      "md-panorama-horizontal", "md-panorama-vertical", "md-panorama-wide-angle", "md-photo", "md-photo-album", "md-photo-camera",
      "md-photo-library", "md-portrait", "md-remove-red-eye", "md-rotate-left", "md-rotate-right", "md-slideshow", "md-straighten",
      "md-style", "md-switch-camera", "md-switch-video", "md-tag-faces", "md-texture", "md-timelapse", "md-timer", "md-timer-3",
      "md-timer-10", "md-timer-auto", "md-timer-off", "md-tonality", "md-transform", "md-tune", "md-wb-auto", "md-wb-cloudy",
      "md-wb-incandescent", "md-wb-irradescent", "md-wb-sunny", "md-beenhere", "md-directions", "md-directions-bike",
      "md-directions-bus", "md-directions-car", "md-directions-ferry", "md-directions-subway", "md-directions-train",
      "md-directions-transit", "md-directions-walk", "md-flight", "md-hotel", "md-layers", "md-layers-clear", "md-local-airport",
      "md-local-atm", "md-local-attraction", "md-local-bar", "md-local-cafe", "md-local-car-wash", "md-local-convenience-store",
      "md-local-drink", "md-local-florist", "md-local-gas-station", "md-local-grocery-store", "md-local-hospital", "md-local-hotel",
      "md-local-laundry-service", "md-local-library", "md-local-mall", "md-local-movies", "md-local-offer", "md-local-parking",
      "md-local-pharmacy", "md-local-phone", "md-local-pizza", "md-local-play", "md-local-post-office", "md-local-print-shop",
      "md-local-restaurant", "md-local-see", "md-local-shipping", "md-local-taxi", "md-location-history", "md-map",
      "md-my-location", "md-navigation", "md-pin-drop", "md-place", "md-rate-review", "md-restaurant-menu", "md-satellite",
      "md-store-mall-directory", "md-terrain", "md-traffic", "md-apps", "md-cancel", "md-arrow-drop-down-circle",
      "md-arrow-drop-down", "md-arrow-drop-up", "md-arrow-back", "md-arrow-forward", "md-check", "md-close", "md-chevron-left",
      "md-chevron-right", "md-expand-less", "md-expand-more", "md-fullscreen", "md-fullscreen-exit", "md-menu", "md-more-horiz",
      "md-more-vert", "md-refresh", "md-unfold-less", "md-unfold-more", "md-adb", "md-bluetooth-audio", "md-disc-full",
      "md-dnd-forwardslash", "md-do-not-disturb", "md-drive-eta", "md-event-available", "md-event-busy", "md-event-note",
      "md-folder-special", "md-mms", "md-more", "md-network-locked", "md-phone-bluetooth-speaker", "md-phone-forwarded",
      "md-phone-in-talk", "md-phone-locked", "md-phone-missed", "md-phone-paused", "md-play-download", "md-play-install",
      "md-sd-card", "md-sim-card-alert", "md-sms", "md-sms-failed", "md-sync", "md-sync-disabled", "md-sync-problem",
      "md-system-update", "md-tap-and-play", "md-time-to-leave", "md-vibration", "md-voice-chat", "md-vpn-lock", "md-cake",
      "md-domain", "md-location-city", "md-mood", "md-notifications-none", "md-notifications", "md-notifications-off",
      "md-notifications-on", "md-notifications-paused", "md-pages", "md-party-mode", "md-group", "md-group-add", "md-people",
      "md-people-outline", "md-person", "md-person-add", "md-person-outline", "md-plus-one", "md-poll", "md-public", "md-school",
      "md-share", "md-whatshot", "md-check-box", "md-check-box-outline-blank", "md-radio-button-off", "md-radio-button-on",
      "md-star", "md-star-half", "md-star-outline", "md-home", "md-warning", "md-play-circle-fill", "md-forum",
      "md-content-paste", "md-battery-80", "md-format-textdirection-l-to-r", "md-folder-open", "md-desktop-windows",
      "md-collections", "md-directions-bike", "md-apps", "md-phone-in-talk", "md-people", "md-star-half"
    ];


    var img = [
      "ad.svg", "button.svg", "converse.svg", "fire extinguisher.svg", "lamp.svg", "passport.svg", "skate.svg",
      "theatre.svg", "turntable.svg", "wacom.svg", "bill.svg", "buzzer.svg","conveyor.svg", "helmet.svg", "luggage.svg",
      "presentation.svg","smart watch.svg", "tie.svg", "umbrella.svg", "workspace.svg", "bowling.svg", "calculator.svg",
      "demoltion.svg", "icecream.svg", "microscope.svg", "server.svg", "switcher.svg", "tower.svg", "vespa.svg", "wrench.svg"
    ];

    var colors = [
      "pink","red","purple","indigo","blue",
      "light-blue","cyan","teal","green","light-green",
      "lime","yellow","amber","orange","deep-orange"
    ];
    var colorVariation = [
      "lighten-2", "lighten-1",
      //"base",
      "darken-1", "darken-2",
      //"accent-1", "accent-2", "accent-3", "accent-4"
    ];



    function randomInt ( min, max ) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    return {

      createFirstname: function(){
        return name.first_name[randomInt(0, name.first_name.length - 1)];
      },

      createLastname: function(){
        return name.last_name[randomInt(0, name.last_name.length - 1)];
      },

      createIcon: function(color){
        color = color || false;

        if(!color){
          return '<i class="md '+icons[randomInt(0, icons.length - 1)]+'"></i>';
        }

        var c = colors[randomInt(0, colors.length-1)];
        var cv = colorVariation[randomInt(0, colorVariation.length-1)];

        return '<i class="md '+icons[randomInt(0, icons.length - 1)]+' '+c+' '+cv+' icon-color"></i>';
      },

      createImg: function(){
        return img[randomInt(0, img.length - 1)];
      },

      createName: function(){
        return this.createFirstname()+' '+this.createLastname();
      },

      createSentence: function ( sentenceLength ) {
        var wordIndex,
          sentence;

        // Determine how long the sentence should be. Do it randomly if one was not
        // provided.
        sentenceLength = sentenceLength || randomInt( 5, 20 );

        // Now we determine were we are going to start in the array randomly. We
        // are just going to take a slice of the array, so we have to ensure
        // whereever we start has enough places left in the array to accommodate
        // the random sentence length from above.
        wordIndex = randomInt(0, words.length - sentenceLength - 1);

        // And pull out the words, join them together, separating words by spaces
        // (duh), and removing any commas that may appear at the end of the
        // sentence. Finally, add a period.
        sentence = words.slice(wordIndex, wordIndex + sentenceLength)
          .join(' ')
          .replace(/\,$/g, '') + '.';

        // Capitalize the first letter - it is a sentence, after all.
        sentence = sentence.charAt(0).toUpperCase() + sentence.slice(1);

        return sentence;
      },
      createSentences: function ( numSentences ) {
        var sentences = [],
          i = 0;

        // Determine how many sentences we should do. Do it randomly if one was not
        // provided.
        numSentences = numSentences || randomInt( 3, 5 );

        // For each paragraph, we should generate between 3 and 5 sentences.
        for ( i = 0; i < numSentences; i++ ) {
          sentences.push( this.createSentence() );
        }

        // And then we just return the array of sentences, concatenated with spaces.
        return sentences.join( ' ' );
      },
      createParagraph: function ( numSentences, html ) {
        var sentences = this.createSentences( numSentences );

        // Make the sentences into a paragraph and return.
        if(html){
          return "<p>" + sentences + "</p>";
        }

        return sentences + "\n";
      },
      createParagraphs: function ( numParagraphs, numSentences, html ) {
        var paragraphs = [],
          i = 0;

        numParagraphs = numParagraphs || randomInt( 3, 7 );

        // Create the number of paragraphs requested.
        for ( i = 0; i < numParagraphs; i++ ) {
          paragraphs.push( this.createParagraph( numSentences, html ) );
        }

        // Return the paragraphs, concatenated with newlines.
        return paragraphs.join( '\n' );
      }
    };
  })

  .directive( 'placeholderText', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ngModel) {

        numParagraphs = attrs.sentences || 1;
        numSentences = attrs.paragraphs || 6;
        html = attrs.html || true;

        element.html(
          PlaceholderTextService.createParagraphs(numParagraphs, numSentences, true)
        );

      }
    };
  }])

  .directive( 'placeholderTitle', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.html(
          PlaceholderTextService.createSentence(5)
        );
      }
    };
  }])

  .directive( 'placeholderName', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ngModel) {
        element.html(
          PlaceholderTextService.createName()
        );
      }
    };
  }])

  .directive( 'placeholderP', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ngModel) {
        element.html(
          PlaceholderTextService.createParagraph(1, 3, false)
        );
      }
    };
  }])

  .directive( 'placeholderImg', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ngModel) {
        element.attr('src', 'assets/img/icons/ballicons/'+PlaceholderTextService.createImg());
      }
    };
  }])

  .directive( 'placeholderIcon', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ngModel) {
        element.html(
          PlaceholderTextService.createIcon(false)
        );
      }
    };
  }])

  .directive( 'placeholderForm', [ 'PlaceholderTextService', function ( PlaceholderTextService ) {
    return {
      restrict: 'C',
      link: function(scope, element, attrs, ngModel) {

        angular.forEach(element.find('input, textarea'), function(el){
          elem = angular.element(el);

          switch (el.type) {
            case 'textarea':
              elem.text(PlaceholderTextService.createParagraphs(1, 4));
              break;
            case 'text':
              elem.attr('value', PlaceholderTextService.createSentence());
              break;
            case 'password':
              elem.attr('value', 'nakama?');
              break;
            case 'checkbox':
              elem.attr('checked','checked');
              break;
          }

          if(elem.val()){
            elem.parent().addClass('filled');
          }
        });

      }
    };
  }])


  .directive( 'placeholderImage', function () {
    return {
      restrict: 'A',
      scope: { dimensions: '@placeholderImage' },
      link: function( scope, element, attr ) {

        // A reference to a canvas that we can reuse
        var canvas;
        var config = {
          text_size: 10,
          fill_color: '#EEEEEE',
          text_color: '#AAAAAA'
        };

        /**
         * When the provided dimensions change, re-pull the width and height and
         * then redraw the image.
         */
        scope.$watch('dimensions', function () {
          if( ! angular.isDefined( scope.dimensions ) ) {
            return;
          }
          var matches = scope.dimensions.match( /^(\d+)x(\d+)$/ ),
            dataUrl;

          if(  ! matches ) {
            console.error("Expected '000x000'. Got " + scope.dimensions);
            return;
          }

          // Grab the provided dimensions.
          scope.size = { w: matches[1], h: matches[2] };

          // FIXME: only add these if not already present
          element.prop( "title", scope.dimensions );
          element.prop( "alt", scope.dimensions );

          // And draw the image, getting the returned data URL.
          dataUrl = drawImage();

          // If this is an `img` tag, set the src as the data URL. Else, we set
          // the CSS `background-image` property to same.
          if ( element.prop( "tagName" ) === "IMG" ) {
            element.prop( 'src', dataUrl );
          } else {
            element.css( 'background-image', 'url("' + dataUrl + '")' );
          }
        });

        /**
         * Calculate the maximum height of the text we can draw, based on the
         * requested dimensions of the image.
         */
        function getTextSize() {
          var dimension_arr = [scope.size.h, scope.size.w].sort(),
            maxFactor = Math.round(dimension_arr[1] / 16);

          return Math.max(config.text_size, maxFactor);
        }

        /**
         * Using the HTML5 canvas API, draw a placeholder image of the requested
         * size with text centered vertically and horizontally that specifies its
         * dimensions. Returns the data URL that can be used as an `img`'s `src`
         * attribute.
         */
        function drawImage() {
          // Create a new canvas if we don't already have one. We reuse the canvas
          // when if gets redrawn so as not to be wasteful.
          canvas = canvas || document.createElement( 'canvas' );

          // Obtain a 2d drawing context on which we can add the placeholder
          // image.
          var context = canvas.getContext( '2d' ),
            text_size,
            text;

          // Set the canvas to the appropriate size.
          canvas.width = scope.size.w;
          canvas.height = scope.size.h;

          // Draw the placeholder image square.
          // TODO: support other shapes
          // TODO: support configurable colors
          context.fillStyle = config.fill_color;
          context.fillRect( 0, 0, scope.size.w, scope.size.h );

          // Add the dimension text.
          // TODO: support configurable font
          // FIXME: ensure text will fit and resize if it doesn't
          text_size = getTextSize();
          text = scope.dimensions;
          context.fillStyle = config.text_color;
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          context.font = 'bold '+text_size+'pt sans-serif';

          // If the text is too long to fit, reduce it until it will.
          if (context.measureText( text ).width / scope.size.w > 1) {
            text_size = config.text_size / (context.measureText( text ).width / scope.size.w);
            context.font = 'bold '+text_size+'pt sans-serif';
          }

          // Finally, draw the text in its calculated position.
          context.fillText( scope.dimensions, scope.size.w / 2, scope.size.h / 2 );

          // Get the data URL and return it.
          return canvas.toDataURL("image/png");
        }
      }
    };
  });

/*eslint-disable */
/* =============================================================
/*
/*	 Angular Smooth Scroll 1.7.1
/*	 Animates scrolling to elements, by David Oliveros.
/*
/*   Callback hooks contributed by Ben Armston
/*   https://github.com/benarmston
/*
/*	 Easing support contributed by Willem Liu.
/*	 https://github.com/willemliu
/*
/*	 Easing functions forked from Gaëtan Renaudeau.
/*	 https://gist.github.com/gre/1650294
/*
/*	 Infinite loop bugs in iOS and Chrome (when zoomed) by Alex Guzman.
/*	 https://github.com/alexguzman
/*
/*	 Influenced by Chris Ferdinandi
/*	 https://github.com/cferdinandi
/*
/*
/*	 Free to use under the MIT License.
/*
/* ============================================================= */

(function () {
	'use strict';

	var module = angular.module('smoothScroll', []);


	// Smooth scrolls the window to the provided element.
	//
	var smoothScroll = function (element, options) {
		options = options || {};

		// Options
		var duration = options.duration || 800,
			offset = options.offset || 0,
			easing = options.easing || 'easeInOutQuart',
			callbackBefore = options.callbackBefore || function() {},
			callbackAfter = options.callbackAfter || function() {};

		var getScrollLocation = function() {
			return window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop;
		};

		setTimeout( function() {
			var startLocation = getScrollLocation(),
				timeLapsed = 0,
				percentage, position;

			// Calculate the easing pattern
			var easingPattern = function (type, time) {
				if ( type == 'easeInQuad' ) return time * time; // accelerating from zero velocity
				if ( type == 'easeOutQuad' ) return time * (2 - time); // decelerating to zero velocity
				if ( type == 'easeInOutQuad' ) return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
				if ( type == 'easeInCubic' ) return time * time * time; // accelerating from zero velocity
				if ( type == 'easeOutCubic' ) return (--time) * time * time + 1; // decelerating to zero velocity
				if ( type == 'easeInOutCubic' ) return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
				if ( type == 'easeInQuart' ) return time * time * time * time; // accelerating from zero velocity
				if ( type == 'easeOutQuart' ) return 1 - (--time) * time * time * time; // decelerating to zero velocity
				if ( type == 'easeInOutQuart' ) return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
				if ( type == 'easeInQuint' ) return time * time * time * time * time; // accelerating from zero velocity
				if ( type == 'easeOutQuint' ) return 1 + (--time) * time * time * time * time; // decelerating to zero velocity
				if ( type == 'easeInOutQuint' ) return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration
				return time; // no easing, no acceleration
			};


			// Calculate how far to scroll
			var getEndLocation = function (element) {
				var location = 0;
				if (element.offsetParent) {
					do {
						location += element.offsetTop;
						element = element.offsetParent;
					} while (element);
				}
				location = Math.max(location - offset, 0);
				return location;
			};

			var endLocation = getEndLocation(element);
			var distance = endLocation - startLocation;


			// Stop the scrolling animation when the anchor is reached (or at the top/bottom of the page)
			var stopAnimation = function () {
				var currentLocation = getScrollLocation();
				if ( position == endLocation || currentLocation == endLocation || ( (window.innerHeight + currentLocation) >= document.body.scrollHeight ) ) {
					clearInterval(runAnimation);
					callbackAfter(element);
				}
			};


			// Scroll the page by an increment, and check if it's time to stop
			var animateScroll = function () {
				timeLapsed += 16;
				percentage = ( timeLapsed / duration );
				percentage = ( percentage > 1 ) ? 1 : percentage;
				position = startLocation + ( distance * easingPattern(easing, percentage) );
				window.scrollTo( 0, position );
				stopAnimation();
			};


			// Init
			callbackBefore(element);
			var runAnimation = setInterval(animateScroll, 16);
		}, 0);
	};


	// Expose the library in a factory
	//
	module.factory('smoothScroll', function() {
		return smoothScroll;
	});


	// Scrolls the window to this element, optionally validating an expression
	//
	module.directive('smoothScroll', ['smoothScroll', function(smoothScroll) {
		return {
			restrict: 'A',
			scope: {
				callbackBefore: '&',
				callbackAfter: '&',
			},
			link: function($scope, $elem, $attrs) {
				if ( typeof $attrs.scrollIf === 'undefined' || $attrs.scrollIf === 'true' ) {
					setTimeout( function() {

						var callbackBefore = function(element) {
							if ( $attrs.callbackBefore ) {
								var exprHandler = $scope.callbackBefore({ element: element });
								if (typeof exprHandler === 'function') {
									exprHandler(element);
								}
							}
						};

						var callbackAfter = function(element) {
							if ( $attrs.callbackAfter ) {
								var exprHandler = $scope.callbackAfter({ element: element });
								if (typeof exprHandler === 'function') {
									exprHandler(element);
								}
							}
						};

						smoothScroll($elem[0], {
							duration: $attrs.duration,
							offset: $attrs.offset,
							easing: $attrs.easing,
							callbackBefore: callbackBefore,
							callbackAfter: callbackAfter
						});
					}, 0);
				}
			}
		};
	}]);


	// Scrolls to a specified element ID when this element is clicked
	//
	module.directive('scrollTo', ['smoothScroll', function(smoothScroll) {
		return {
			restrict: 'A',
			link: function($scope, $elem, $attrs) {
				var targetElement;

				$elem.on('click', function(e) {
					e.preventDefault();

					targetElement = document.getElementById($attrs.scrollTo);
					if ( !targetElement ) return;

					var callbackBefore = function(element) {
						if ( $attrs.callbackBefore ) {
							var exprHandler = $scope.callbackBefore({element: element});
							if (typeof exprHandler === 'function') {
								exprHandler(element);
							}
						}
					};

					var callbackAfter = function(element) {
						if ( $attrs.callbackAfter ) {
							var exprHandler = $scope.callbackAfter({element: element});
							if (typeof exprHandler === 'function') {
								exprHandler(element);
							}
						}
					};

					smoothScroll(targetElement, {
						duration: $attrs.duration,
						offset: $attrs.offset,
						easing: $attrs.easing,
						callbackBefore: callbackBefore,
						callbackAfter: callbackAfter
					});

					return false;
				});
			}
		};
	}]);

}());

(function () {
    'use strict';

    angular.module('fsm').directive('fsmStickyHeader', ['$document', function ($document, $timeout) {
        return {
            restrict: 'EA',
            replace: false,
            scope: {
                scrollBody: '=',
                scrollStop: '=',
                scrollableContainer: '=',
                contentOffset: '='
            },
            link: function (scope, element) {
                var header = $(element, this);
                var clonedHeader = null;
                var content = angular.element(document.querySelector(scope.scrollBody));
                var scrollableContainer = angular.element(document.querySelector(scope.scrollableContainer));
                var contentOffset = scope.contentOffset || 0;

                var lastLeft = 1;

                if (scrollableContainer.length === 0) {
                    scrollableContainer = angular.element(window);
                }

                function setColumnHeaderSizes() {
                    if (clonedHeader.is('tr') || clonedHeader.is('thead')) {
                        var clonedColumns = clonedHeader.find('th');
                        header.find('th').each(function (index, column) {
                            var clonedColumn = $(clonedColumns[index]);
                            clonedColumn.css('width', column.offsetWidth + 'px');
                        });
                    }
                };

                function determineVisibility() {

                    var content = angular.element(document.querySelector(scope.scrollBody));

                    var scrollTop = scrollableContainer.scrollTop() + scope.scrollStop;
                    var contentTop = content.offset().top + contentOffset;
                    var contentBottom = contentTop + content.outerHeight(false);

                    //Variável criada para o header fixo aparecer apenas quando o header original não estiver mais visivel
                    var thead = content.find("thead").innerHeight();

                    if (lastLeft != content.offset().left) {
                        ++scrollTop;
                    }

                    if ((scrollTop > contentTop + (thead ? thead : 0)) && (scrollTop < contentBottom)) {
                        if (!clonedHeader) {
                            createClone();
                            clonedHeader.css({ "visibility": "visible" });
                        }

                        if (scrollTop < contentBottom && scrollTop > contentBottom - clonedHeader.outerHeight(false)) {
                            var top = contentBottom - scrollTop + scope.scrollStop - clonedHeader.outerHeight(false);
                            clonedHeader.css('top', top + 'px');
                        } else {
                            calculateSize();
                        }
                    } else {
                        if (clonedHeader) {
                            /*
                             * remove cloned element (switched places with original on creation)
                             */
                            header.remove();
                            header = clonedHeader;
                            clonedHeader = null;

                            header.removeClass('fsm-sticky-header');
                            header.css({
                                position: 'relative',
                                left: 0,
                                top: 0,
                                width: 'auto',
                                'z-index': 0,
                                visibility: 'visible'
                            });
                        }
                    }
                };

                function calculateSize() {
                    if ($(window).width() < 758) {
                        clonedHeader.css({
                            top: scope.scrollStop,
                            width: header.outerWidth(),
                            left: header.offset().left
                        });
                    } else {
                        clonedHeader.css({
                            top: scope.scrollStop,
                            width: header.outerWidth(),
                            left: -$(window).scrollLeft() + 1
                        });
                    }

                    setColumnHeaderSizes();
                };

                function createClone() {
                    /*
                     * switch place with cloned element, to keep binding intact
                     */
                    clonedHeader = header;
                    header = clonedHeader.clone();
                    clonedHeader.after(header);
                    clonedHeader.addClass('fsm-sticky-header');
                    clonedHeader.css({
                        position: 'fixed',
                        'z-index': 1000,
                        visibility: 'hidden'
                    });

                    calculateSize();
                };

                /**
                 *
                 * Código para rolar o header na horizontal
                 */
                var oldScrollTop = $(".table-responsive").scrollTop();
                var oldScrollLeft = $(".table-responsive").scrollLeft();

                $(".table-responsive").scroll(function () {
                    if (oldScrollTop == $(".table-responsive").scrollTop()) {
                        determineVisibility();
                    }
                    oldScrollTop = $('.table-responsive').scrollTop();
                    oldScrollLeft = $('.table-responsive').scrollLeft();
                });



                scrollableContainer.on('scroll.fsmStickyHeader', determineVisibility).trigger("scroll");
                scrollableContainer.on('resize.fsmStickyHeader', determineVisibility);

                scope.$on('$destroy', function () {
                    scrollableContainer.off('.fsmStickyHeader');
                });
            }
        };
    }]);

})();

(function () {
    'use strict';

    angular.module('fsm').directive('fsmMenuButton', function () {
        return {
            restrict: 'EA',
            replace: false,
            scope: {},
            link: function (scope, element, attributes, control) {
                var menuButton = $(element, this);

                menuButton.addClass('fsm-menu-button');
                menuButton.click(menuOnClick);

                function menuOnClick() {
                    $('body').toggleClass('fsm-menu-toggle');
                    setMenuSpin();
                    setTimeout(setMenuSpin, 50);
                };

                function setMenuSpin() {
                    menuButton.find('.fsm-menu-button-open').toggleClass('fsm-spin-forward');
                    menuButton.find('.fsm-menu-button-closed').toggleClass('fsm-spin-backward');
                };
            }
        }
    });

})();

(function () {
    'use strict';

    angular.module('fsm').directive('fsmBigData', FsmBigData);

    /** @ngInject */
    function FsmBigData($window, $document, $resource, api, $alert, $timeout) {

        return {
            restrict: 'AE',
            scope: true,
            replace: false,
            transclude: true,
            link: function (scope, element, attrs, controller, transclude) {

                var currentPage = 0;
                var scrollContainer = attrs.scrollContainer;
                var pagedDataName = attrs.fsmBigData.split(' of ')[0];
                var rightHandExpression = attrs.fsmBigData.split(' of ')[1];
                var pageSize = parseInt(rightHandExpression.split(' take ')[1]);
                var sourceData = rightHandExpression.split(' take ')[0];
                var Resource = $resource(api.url + attrs.url);
                var filter = scope.filter;

                var rawData = [];
                var sortedData = [];
                var pagedData = [];
                var page = $(window);
                var sortTypes = ['None', 'Ascending', 'Descending'];
                var sortColumns = [];

                scope.sortTypes = sortTypes;

                transclude(scope, function (clone, transcludedScope) {
                    element.append(clone);
                    transcludedScope[pagedDataName] = pagedData;

                    // Adição do indicador de loading
                    $timeout(function () {
                        var headerRows = element.find('thead > tr').length;
                        var columns = element.find('thead > tr:first-child > th').length;
                        var loadBeat = '<div class="internal_table_load lds-beat"><div></div><div></div><div></div><div></div></div>';
                        element.find('tbody').append(angular.element('<tr class="internal_table_load_row"><td class="' + (headerRows == 1 ? 'one_header' : '') + '" colspan="' + columns + '">' + loadBeat + '</td></tr>'));
                    });

                    function nextPage() {
                        if (filter != undefined && !filter.busy) {
                            filter.busy = true;

                            filter.size = pageSize;
                            filter.page = currentPage;
                            filter.sort = sortColumns;

                            element.addClass('loading');

                            Resource.get(filter).$promise.then(function (response) {
                                var dataSlice = response.content;
                                scope.vm.contador = response.totalElements;
                                scope.vm.totalizador = response.totalizador;

                                if (dataSlice.length > 0) {
                                    pagedData.push.apply(pagedData, dataSlice);

                                    if (scope.hideForm)
                                        scope.hideForm();

                                    currentPage++;
                                    filter.busy = response.last;
                                } else if (dataSlice.length == 0) {
                                    $alert({
                                        content: 'Sua pesquisa não retornou nenhum registro',
                                        type: 'info'
                                    });
                                }
                            }).finally(function () {
                                element.removeClass('loading');
                            });
                        }
                    }

                    function addSortColumn(columnName, sortType) {
                        // If this column is currently in the sort stack, remove it.
                        for (var i = 0; i < sortColumns.length; i++) {
                            if (sortColumns[i].indexOf(columnName) > -1) {
                                sortColumns.splice(i, 1);
                            }
                        }


                        // Push this sort on the top of the stack (aka. array)
                        if (sortType > 0) {
                            var direction = 'asc';
                            if (sortTypes[sortType] === 'Descending') {
                                direction = 'desc'
                            }

                            sortColumns.push(columnName + ',' + direction);
                        }

                        filter.busy = false;
                        renderData();
                    }

                    function renderData() {
                        sortedData = rawData;
                        pagedData.length = 0;
                        currentPage = 0;
                        nextPage();
                    }

                    function onPageScroll() {
                        var s = $window.pageYOffset,
                            d = $document.height(),
                            c = $window.innerHeight;
                        var scrollPercent = (s / (d - c));

                        if (scrollPercent > 0.80) {
                            // We use scope.apply here to tell angular about these changes because
                            // they happen outside of angularjs context... we're using jquery here
                            // to figure out when we need to load another page of data.

                            if (!transcludedScope.$$phase) {
                                transcludedScope.$apply(nextPage);
                            }
                        }
                    }

                    function onContainerScroll(e) {
                        var $container = $(e.target);

                        var s = $container.scrollTop();
                        var d = $container.find('table:first-child').height();
                        var c = $container.height();
                        var scrollPercent = (s / (d - c));

                        if (scrollPercent > 0.80) {
                            // We use scope.apply here to tell angular about these changes because
                            // they happen outside of angularjs context... we're using jquery here
                            // to figure out when we need to load another page of data.

                            if (!transcludedScope.$$phase) {
                                transcludedScope.$apply(nextPage);
                            }
                        }
                    }

                    if (scrollContainer) {
                        $(scrollContainer).scroll(onContainerScroll).trigger('scroll');
                    } else {
                        page.scroll(onPageScroll).trigger('scroll');
                    }

                    scope.$parent.$watch('filter', function (newValue) {
                        filter = newValue;
                        renderData();
                    });

                    scope.$parent.$watchCollection(sourceData, function (newData) {
                        if (newData) {
                            rawData = newData;
                            renderData();
                        }
                    });

                    if (attrs.preload) {
                        renderData();
                    }

                    scope.addSortColumn = addSortColumn;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('fsm').directive('fsmSort', function () {
        var sortIconTemplate = '<i class="md md-sort"></i>';

        return {
            restrict: 'A',
            replace: false,
            scope: {},
            link: function (scope, element, attrs) {
                var columnHeader = element;
                var columnName = attrs.fsmSort;
                var sortIcon = angular.element(sortIconTemplate);
                columnHeader.append('&nbsp;')
                columnHeader.append(sortIcon);
                var currentSortType = 0;

                function swapIcons() {
                    sortIcon.removeClass('md-arrow-drop-down md-arrow-drop-up md-sort ');

                    var classToAdd = 'md-sort';

                    if (scope.$parent.sortTypes[currentSortType] === 'Ascending') {
                        classToAdd = 'md-arrow-drop-down';
                    } else if (scope.$parent.sortTypes[currentSortType] === 'Descending') {
                        classToAdd = 'md-arrow-drop-up';
                    }

                    sortIcon.addClass(classToAdd);
                }

                columnHeader.css({ cursor: 'pointer' });
                columnHeader.bind('click', function () {
                    // Find the kind of sort this should now be
                    currentSortType++;
                    if (currentSortType == scope.$parent.sortTypes.length) {
                        currentSortType = 0;
                    }

                    scope.$apply(scope.$parent.addSortColumn(columnName, currentSortType));

                    swapIcons();
                });
            }
        }
    });

})();

/*eslint-disable */
FileAPI = {
  jsPath: 'app/dist/assets/',
  staticPath: 'app/dist/assets/',

  // forceLoad: true,
  // html5: false // to debug flash in HTML5 browsers
  // noContentTimeout: 10000 (see #528)
};

// SVGPathSeg API polyfill
// https://github.com/progers/pathseg
//
// This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
// SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
// changes which were implemented in Firefox 43 and Chrome 46.

(function() { "use strict";
  if (!("SVGPathSeg" in window)) {
    // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
    window.SVGPathSeg = function(type, typeAsLetter, owningPathSegList) {
      this.pathSegType = type;
      this.pathSegTypeAsLetter = typeAsLetter;
      this._owningPathSegList = owningPathSegList;
    }

    SVGPathSeg.prototype.classname = "SVGPathSeg";

    SVGPathSeg.PATHSEG_UNKNOWN = 0;
    SVGPathSeg.PATHSEG_CLOSEPATH = 1;
    SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
    SVGPathSeg.PATHSEG_MOVETO_REL = 3;
    SVGPathSeg.PATHSEG_LINETO_ABS = 4;
    SVGPathSeg.PATHSEG_LINETO_REL = 5;
    SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
    SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
    SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
    SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
    SVGPathSeg.PATHSEG_ARC_ABS = 10;
    SVGPathSeg.PATHSEG_ARC_REL = 11;
    SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
    SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
    SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
    SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
    SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
    SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
    SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
    SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;

    // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
    SVGPathSeg.prototype._segmentChanged = function() {
      if (this._owningPathSegList)
        this._owningPathSegList.segmentChanged(this);
    }

    window.SVGPathSegClosePath = function(owningPathSegList) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
    }
    SVGPathSegClosePath.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegClosePath.prototype.toString = function() { return "[object SVGPathSegClosePath]"; }
    SVGPathSegClosePath.prototype._asPathString = function() { return this.pathSegTypeAsLetter; }
    SVGPathSegClosePath.prototype.clone = function() { return new SVGPathSegClosePath(undefined); }

    window.SVGPathSegMovetoAbs = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegMovetoAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegMovetoAbs.prototype.toString = function() { return "[object SVGPathSegMovetoAbs]"; }
    SVGPathSegMovetoAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegMovetoAbs.prototype.clone = function() { return new SVGPathSegMovetoAbs(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegMovetoAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegMovetoAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegMovetoRel = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegMovetoRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegMovetoRel.prototype.toString = function() { return "[object SVGPathSegMovetoRel]"; }
    SVGPathSegMovetoRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegMovetoRel.prototype.clone = function() { return new SVGPathSegMovetoRel(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegMovetoRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegMovetoRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoAbs = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegLinetoAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoAbs.prototype.toString = function() { return "[object SVGPathSegLinetoAbs]"; }
    SVGPathSegLinetoAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegLinetoAbs.prototype.clone = function() { return new SVGPathSegLinetoAbs(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegLinetoAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegLinetoAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoRel = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegLinetoRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoRel.prototype.toString = function() { return "[object SVGPathSegLinetoRel]"; }
    SVGPathSegLinetoRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegLinetoRel.prototype.clone = function() { return new SVGPathSegLinetoRel(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegLinetoRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegLinetoRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoCubicAbs = function(owningPathSegList, x, y, x1, y1, x2, y2) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x1 = x1;
      this._y1 = y1;
      this._x2 = x2;
      this._y2 = y2;
    }
    SVGPathSegCurvetoCubicAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoCubicAbs.prototype.toString = function() { return "[object SVGPathSegCurvetoCubicAbs]"; }
    SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoCubicAbs.prototype.clone = function() { return new SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2); }
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function() { return this._x1; }, set: function(x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function() { return this._y1; }, set: function(y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function() { return this._x2; }, set: function(x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function() { return this._y2; }, set: function(y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoCubicRel = function(owningPathSegList, x, y, x1, y1, x2, y2) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x1 = x1;
      this._y1 = y1;
      this._x2 = x2;
      this._y2 = y2;
    }
    SVGPathSegCurvetoCubicRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoCubicRel.prototype.toString = function() { return "[object SVGPathSegCurvetoCubicRel]"; }
    SVGPathSegCurvetoCubicRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoCubicRel.prototype.clone = function() { return new SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2); }
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function() { return this._x1; }, set: function(x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function() { return this._y1; }, set: function(y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function() { return this._x2; }, set: function(x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function() { return this._y2; }, set: function(y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoQuadraticAbs = function(owningPathSegList, x, y, x1, y1) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x1 = x1;
      this._y1 = y1;
    }
    SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() { return "[object SVGPathSegCurvetoQuadraticAbs]"; }
    SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() { return new SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1); }
    Object.defineProperty(SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function() { return this._x1; }, set: function(x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function() { return this._y1; }, set: function(y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoQuadraticRel = function(owningPathSegList, x, y, x1, y1) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x1 = x1;
      this._y1 = y1;
    }
    SVGPathSegCurvetoQuadraticRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoQuadraticRel.prototype.toString = function() { return "[object SVGPathSegCurvetoQuadraticRel]"; }
    SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoQuadraticRel.prototype.clone = function() { return new SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1); }
    Object.defineProperty(SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function() { return this._x1; }, set: function(x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function() { return this._y1; }, set: function(y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegArcAbs = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
      this._x = x;
      this._y = y;
      this._r1 = r1;
      this._r2 = r2;
      this._angle = angle;
      this._largeArcFlag = largeArcFlag;
      this._sweepFlag = sweepFlag;
    }
    SVGPathSegArcAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegArcAbs.prototype.toString = function() { return "[object SVGPathSegArcAbs]"; }
    SVGPathSegArcAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y; }
    SVGPathSegArcAbs.prototype.clone = function() { return new SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag); }
    Object.defineProperty(SVGPathSegArcAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "r1", { get: function() { return this._r1; }, set: function(r1) { this._r1 = r1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "r2", { get: function() { return this._r2; }, set: function(r2) { this._r2 = r2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "angle", { get: function() { return this._angle; }, set: function(angle) { this._angle = angle; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function() { return this._largeArcFlag; }, set: function(largeArcFlag) { this._largeArcFlag = largeArcFlag; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcAbs.prototype, "sweepFlag", { get: function() { return this._sweepFlag; }, set: function(sweepFlag) { this._sweepFlag = sweepFlag; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegArcRel = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
      this._x = x;
      this._y = y;
      this._r1 = r1;
      this._r2 = r2;
      this._angle = angle;
      this._largeArcFlag = largeArcFlag;
      this._sweepFlag = sweepFlag;
    }
    SVGPathSegArcRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegArcRel.prototype.toString = function() { return "[object SVGPathSegArcRel]"; }
    SVGPathSegArcRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y; }
    SVGPathSegArcRel.prototype.clone = function() { return new SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag); }
    Object.defineProperty(SVGPathSegArcRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "r1", { get: function() { return this._r1; }, set: function(r1) { this._r1 = r1; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "r2", { get: function() { return this._r2; }, set: function(r2) { this._r2 = r2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "angle", { get: function() { return this._angle; }, set: function(angle) { this._angle = angle; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "largeArcFlag", { get: function() { return this._largeArcFlag; }, set: function(largeArcFlag) { this._largeArcFlag = largeArcFlag; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegArcRel.prototype, "sweepFlag", { get: function() { return this._sweepFlag; }, set: function(sweepFlag) { this._sweepFlag = sweepFlag; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoHorizontalAbs = function(owningPathSegList, x) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
      this._x = x;
    }
    SVGPathSegLinetoHorizontalAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoHorizontalAbs.prototype.toString = function() { return "[object SVGPathSegLinetoHorizontalAbs]"; }
    SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x; }
    SVGPathSegLinetoHorizontalAbs.prototype.clone = function() { return new SVGPathSegLinetoHorizontalAbs(undefined, this._x); }
    Object.defineProperty(SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoHorizontalRel = function(owningPathSegList, x) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
      this._x = x;
    }
    SVGPathSegLinetoHorizontalRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoHorizontalRel.prototype.toString = function() { return "[object SVGPathSegLinetoHorizontalRel]"; }
    SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x; }
    SVGPathSegLinetoHorizontalRel.prototype.clone = function() { return new SVGPathSegLinetoHorizontalRel(undefined, this._x); }
    Object.defineProperty(SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoVerticalAbs = function(owningPathSegList, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
      this._y = y;
    }
    SVGPathSegLinetoVerticalAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoVerticalAbs.prototype.toString = function() { return "[object SVGPathSegLinetoVerticalAbs]"; }
    SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._y; }
    SVGPathSegLinetoVerticalAbs.prototype.clone = function() { return new SVGPathSegLinetoVerticalAbs(undefined, this._y); }
    Object.defineProperty(SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegLinetoVerticalRel = function(owningPathSegList, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
      this._y = y;
    }
    SVGPathSegLinetoVerticalRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegLinetoVerticalRel.prototype.toString = function() { return "[object SVGPathSegLinetoVerticalRel]"; }
    SVGPathSegLinetoVerticalRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._y; }
    SVGPathSegLinetoVerticalRel.prototype.clone = function() { return new SVGPathSegLinetoVerticalRel(undefined, this._y); }
    Object.defineProperty(SVGPathSegLinetoVerticalRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoCubicSmoothAbs = function(owningPathSegList, x, y, x2, y2) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x2 = x2;
      this._y2 = y2;
    }
    SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() { return "[object SVGPathSegCurvetoCubicSmoothAbs]"; }
    SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() { return new SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2); }
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function() { return this._x2; }, set: function(x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function() { return this._y2; }, set: function(y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoCubicSmoothRel = function(owningPathSegList, x, y, x2, y2) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
      this._x = x;
      this._y = y;
      this._x2 = x2;
      this._y2 = y2;
    }
    SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() { return "[object SVGPathSegCurvetoCubicSmoothRel]"; }
    SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() { return new SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2); }
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function() { return this._x2; }, set: function(x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function() { return this._y2; }, set: function(y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoQuadraticSmoothAbs = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() { return "[object SVGPathSegCurvetoQuadraticSmoothAbs]"; }
    SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() { return new SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    window.SVGPathSegCurvetoQuadraticSmoothRel = function(owningPathSegList, x, y) {
      SVGPathSeg.call(this, SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
      this._x = x;
      this._y = y;
    }
    SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(SVGPathSeg.prototype);
    SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() { return "[object SVGPathSegCurvetoQuadraticSmoothRel]"; }
    SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
    SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() { return new SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y); }
    Object.defineProperty(SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function() { return this._x; }, set: function(x) { this._x = x; this._segmentChanged(); }, enumerable: true });
    Object.defineProperty(SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function() { return this._y; }, set: function(y) { this._y = y; this._segmentChanged(); }, enumerable: true });

    // Add createSVGPathSeg* functions to SVGPathElement.
    // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathElement.
    SVGPathElement.prototype.createSVGPathSegClosePath = function() { return new SVGPathSegClosePath(undefined); }
    SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(x, y) { return new SVGPathSegMovetoAbs(undefined, x, y); }
    SVGPathElement.prototype.createSVGPathSegMovetoRel = function(x, y) { return new SVGPathSegMovetoRel(undefined, x, y); }
    SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(x, y) { return new SVGPathSegLinetoAbs(undefined, x, y); }
    SVGPathElement.prototype.createSVGPathSegLinetoRel = function(x, y) { return new SVGPathSegLinetoRel(undefined, x, y); }
    SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(x, y, x1, y1, x2, y2) { return new SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2); }
    SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(x, y, x1, y1, x2, y2) { return new SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2); }
    SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(x, y, x1, y1) { return new SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1); }
    SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(x, y, x1, y1) { return new SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1); }
    SVGPathElement.prototype.createSVGPathSegArcAbs = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) { return new SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag); }
    SVGPathElement.prototype.createSVGPathSegArcRel = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) { return new SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag); }
    SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(x) { return new SVGPathSegLinetoHorizontalAbs(undefined, x); }
    SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(x) { return new SVGPathSegLinetoHorizontalRel(undefined, x); }
    SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(y) { return new SVGPathSegLinetoVerticalAbs(undefined, y); }
    SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(y) { return new SVGPathSegLinetoVerticalRel(undefined, y); }
    SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(x, y, x2, y2) { return new SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2); }
    SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(x, y, x2, y2) { return new SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2); }
    SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(x, y) { return new SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y); }
    SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(x, y) { return new SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y); }
  }

  if (!("SVGPathSegList" in window)) {
    // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
    window.SVGPathSegList = function(pathElement) {
      this._pathElement = pathElement;
      this._list = this._parsePath(this._pathElement.getAttribute("d"));

      // Use a MutationObserver to catch changes to the path's "d" attribute.
      this._mutationObserverConfig = { "attributes": true, "attributeFilter": ["d"] };
      this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
      this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
    }

    SVGPathSegList.prototype.classname = "SVGPathSegList";

    Object.defineProperty(SVGPathSegList.prototype, "numberOfItems", {
      get: function() {
        this._checkPathSynchronizedToList();
        return this._list.length;
      },
      enumerable: true
    });

    // Add the pathSegList accessors to SVGPathElement.
    // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
    Object.defineProperty(SVGPathElement.prototype, "pathSegList", {
      get: function() {
        if (!this._pathSegList)
          this._pathSegList = new SVGPathSegList(this);
        return this._pathSegList;
      },
      enumerable: true
    });
    // FIXME: The following are not implemented and simply return SVGPathElement.pathSegList.
    Object.defineProperty(SVGPathElement.prototype, "normalizedPathSegList", { get: function() { return this.pathSegList; }, enumerable: true });
    Object.defineProperty(SVGPathElement.prototype, "animatedPathSegList", { get: function() { return this.pathSegList; }, enumerable: true });
    Object.defineProperty(SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function() { return this.pathSegList; }, enumerable: true });

    // Process any pending mutations to the path element and update the list as needed.
    // This should be the first call of all public functions and is needed because
    // MutationObservers are not synchronous so we can have pending asynchronous mutations.
    SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
      this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
    }

    SVGPathSegList.prototype._updateListFromPathMutations = function(mutationRecords) {
      if (!this._pathElement)
        return;
      var hasPathMutations = false;
      mutationRecords.forEach(function(record) {
        if (record.attributeName == "d")
          hasPathMutations = true;
      });
      if (hasPathMutations)
        this._list = this._parsePath(this._pathElement.getAttribute("d"));
    }

    // Serialize the list and update the path's 'd' attribute.
    SVGPathSegList.prototype._writeListToPath = function() {
      this._pathElementMutationObserver.disconnect();
      this._pathElement.setAttribute("d", SVGPathSegList._pathSegArrayAsString(this._list));
      this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
    }

    // When a path segment changes the list needs to be synchronized back to the path element.
    SVGPathSegList.prototype.segmentChanged = function(pathSeg) {
      this._writeListToPath();
    }

    SVGPathSegList.prototype.clear = function() {
      this._checkPathSynchronizedToList();

      this._list.forEach(function(pathSeg) {
        pathSeg._owningPathSegList = null;
      });
      this._list = [];
      this._writeListToPath();
    }

    SVGPathSegList.prototype.initialize = function(newItem) {
      this._checkPathSynchronizedToList();

      this._list = [newItem];
      newItem._owningPathSegList = this;
      this._writeListToPath();
      return newItem;
    }

    SVGPathSegList.prototype._checkValidIndex = function(index) {
      if (isNaN(index) || index < 0 || index >= this.numberOfItems)
        throw "INDEX_SIZE_ERR";
    }

    SVGPathSegList.prototype.getItem = function(index) {
      this._checkPathSynchronizedToList();

      this._checkValidIndex(index);
      return this._list[index];
    }

    SVGPathSegList.prototype.insertItemBefore = function(newItem, index) {
      this._checkPathSynchronizedToList();

      // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
      if (index > this.numberOfItems)
        index = this.numberOfItems;
      if (newItem._owningPathSegList) {
        // SVG2 spec says to make a copy.
        newItem = newItem.clone();
      }
      this._list.splice(index, 0, newItem);
      newItem._owningPathSegList = this;
      this._writeListToPath();
      return newItem;
    }

    SVGPathSegList.prototype.replaceItem = function(newItem, index) {
      this._checkPathSynchronizedToList();

      if (newItem._owningPathSegList) {
        // SVG2 spec says to make a copy.
        newItem = newItem.clone();
      }
      this._checkValidIndex(index);
      this._list[index] = newItem;
      newItem._owningPathSegList = this;
      this._writeListToPath();
      return newItem;
    }

    SVGPathSegList.prototype.removeItem = function(index) {
      this._checkPathSynchronizedToList();

      this._checkValidIndex(index);
      var item = this._list[index];
      this._list.splice(index, 1);
      this._writeListToPath();
      return item;
    }

    SVGPathSegList.prototype.appendItem = function(newItem) {
      this._checkPathSynchronizedToList();

      if (newItem._owningPathSegList) {
        // SVG2 spec says to make a copy.
        newItem = newItem.clone();
      }
      this._list.push(newItem);
      newItem._owningPathSegList = this;
      // TODO: Optimize this to just append to the existing attribute.
      this._writeListToPath();
      return newItem;
    }

    SVGPathSegList._pathSegArrayAsString = function(pathSegArray) {
      var string = "";
      var first = true;
      pathSegArray.forEach(function(pathSeg) {
        if (first) {
          first = false;
          string += pathSeg._asPathString();
        } else {
          string += " " + pathSeg._asPathString();
        }
      });
      return string;
    }

    // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
    SVGPathSegList.prototype._parsePath = function(string) {
      if (!string || string.length == 0)
        return [];

      var owningPathSegList = this;

      var Builder = function() {
        this.pathSegList = [];
      }

      Builder.prototype.appendSegment = function(pathSeg) {
        this.pathSegList.push(pathSeg);
      }

      var Source = function(string) {
        this._string = string;
        this._currentIndex = 0;
        this._endIndex = this._string.length;
        this._previousCommand = SVGPathSeg.PATHSEG_UNKNOWN;

        this._skipOptionalSpaces();
      }

      Source.prototype._isCurrentSpace = function() {
        var character = this._string[this._currentIndex];
        return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
      }

      Source.prototype._skipOptionalSpaces = function() {
        while (this._currentIndex < this._endIndex && this._isCurrentSpace())
          this._currentIndex++;
        return this._currentIndex < this._endIndex;
      }

      Source.prototype._skipOptionalSpacesOrDelimiter = function() {
        if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",")
          return false;
        if (this._skipOptionalSpaces()) {
          if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
            this._currentIndex++;
            this._skipOptionalSpaces();
          }
        }
        return this._currentIndex < this._endIndex;
      }

      Source.prototype.hasMoreData = function() {
        return this._currentIndex < this._endIndex;
      }

      Source.prototype.peekSegmentType = function() {
        var lookahead = this._string[this._currentIndex];
        return this._pathSegTypeFromChar(lookahead);
      }

      Source.prototype._pathSegTypeFromChar = function(lookahead) {
        switch (lookahead) {
          case "Z":
          case "z":
            return SVGPathSeg.PATHSEG_CLOSEPATH;
          case "M":
            return SVGPathSeg.PATHSEG_MOVETO_ABS;
          case "m":
            return SVGPathSeg.PATHSEG_MOVETO_REL;
          case "L":
            return SVGPathSeg.PATHSEG_LINETO_ABS;
          case "l":
            return SVGPathSeg.PATHSEG_LINETO_REL;
          case "C":
            return SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
          case "c":
            return SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
          case "Q":
            return SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
          case "q":
            return SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
          case "A":
            return SVGPathSeg.PATHSEG_ARC_ABS;
          case "a":
            return SVGPathSeg.PATHSEG_ARC_REL;
          case "H":
            return SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
          case "h":
            return SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
          case "V":
            return SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
          case "v":
            return SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
          case "S":
            return SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
          case "s":
            return SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
          case "T":
            return SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
          case "t":
            return SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
          default:
            return SVGPathSeg.PATHSEG_UNKNOWN;
        }
      }

      Source.prototype._nextCommandHelper = function(lookahead, previousCommand) {
        // Check for remaining coordinates in the current command.
        if ((lookahead == "+" || lookahead == "-" || lookahead == "." || (lookahead >= "0" && lookahead <= "9")) && previousCommand != SVGPathSeg.PATHSEG_CLOSEPATH) {
          if (previousCommand == SVGPathSeg.PATHSEG_MOVETO_ABS)
            return SVGPathSeg.PATHSEG_LINETO_ABS;
          if (previousCommand == SVGPathSeg.PATHSEG_MOVETO_REL)
            return SVGPathSeg.PATHSEG_LINETO_REL;
          return previousCommand;
        }
        return SVGPathSeg.PATHSEG_UNKNOWN;
      }

      Source.prototype.initialCommandIsMoveTo = function() {
        // If the path is empty it is still valid, so return true.
        if (!this.hasMoreData())
          return true;
        var command = this.peekSegmentType();
        // Path must start with moveTo.
        return command == SVGPathSeg.PATHSEG_MOVETO_ABS || command == SVGPathSeg.PATHSEG_MOVETO_REL;
      }

      // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
      // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
      Source.prototype._parseNumber = function() {
        var exponent = 0;
        var integer = 0;
        var frac = 1;
        var decimal = 0;
        var sign = 1;
        var expsign = 1;

        var startIndex = this._currentIndex;

        this._skipOptionalSpaces();

        // Read the sign.
        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+")
          this._currentIndex++;
        else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
          this._currentIndex++;
          sign = -1;
        }

        if (this._currentIndex == this._endIndex || ((this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != "."))
        // The first character of a number must be one of [0-9+-.].
          return undefined;

        // Read the integer part, build right-to-left.
        var startIntPartIndex = this._currentIndex;
        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9")
          this._currentIndex++; // Advance to first non-digit.

        if (this._currentIndex != startIntPartIndex) {
          var scanIntPartIndex = this._currentIndex - 1;
          var multiplier = 1;
          while (scanIntPartIndex >= startIntPartIndex) {
            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
            multiplier *= 10;
          }
        }

        // Read the decimals.
        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
          this._currentIndex++;

          // There must be a least one digit following the .
          if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return undefined;
          while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9")
            decimal += (this._string.charAt(this._currentIndex++) - "0") * (frac *= 0.1);
        }

        // Read the exponent part.
        if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && (this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m")) {
          this._currentIndex++;

          // Read the sign of the exponent.
          if (this._string.charAt(this._currentIndex) == "+") {
            this._currentIndex++;
          } else if (this._string.charAt(this._currentIndex) == "-") {
            this._currentIndex++;
            expsign = -1;
          }

          // There must be an exponent.
          if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return undefined;

          while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
            exponent *= 10;
            exponent += (this._string.charAt(this._currentIndex) - "0");
            this._currentIndex++;
          }
        }

        var number = integer + decimal;
        number *= sign;

        if (exponent)
          number *= Math.pow(10, expsign * exponent);

        if (startIndex == this._currentIndex)
          return undefined;

        this._skipOptionalSpacesOrDelimiter();

        return number;
      }

      Source.prototype._parseArcFlag = function() {
        if (this._currentIndex >= this._endIndex)
          return undefined;
        var flag = false;
        var flagChar = this._string.charAt(this._currentIndex++);
        if (flagChar == "0")
          flag = false;
        else if (flagChar == "1")
          flag = true;
        else
          return undefined;

        this._skipOptionalSpacesOrDelimiter();
        return flag;
      }

      Source.prototype.parseSegment = function() {
        var lookahead = this._string[this._currentIndex];
        var command = this._pathSegTypeFromChar(lookahead);
        if (command == SVGPathSeg.PATHSEG_UNKNOWN) {
          // Possibly an implicit command. Not allowed if this is the first command.
          if (this._previousCommand == SVGPathSeg.PATHSEG_UNKNOWN)
            return null;
          command = this._nextCommandHelper(lookahead, this._previousCommand);
          if (command == SVGPathSeg.PATHSEG_UNKNOWN)
            return null;
        } else {
          this._currentIndex++;
        }

        this._previousCommand = command;

        switch (command) {
          case SVGPathSeg.PATHSEG_MOVETO_REL:
            return new SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_MOVETO_ABS:
            return new SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_REL:
            return new SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_ABS:
            return new SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
            return new SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
            return new SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
            return new SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
          case SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
            return new SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
          case SVGPathSeg.PATHSEG_CLOSEPATH:
            this._skipOptionalSpaces();
            return new SVGPathSegClosePath(owningPathSegList);
          case SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
          case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
          case SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
            var points = {x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
          case SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
            var points = {x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
          case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
          case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
          case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
            return new SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
            return new SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
          case SVGPathSeg.PATHSEG_ARC_REL:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
          case SVGPathSeg.PATHSEG_ARC_ABS:
            var points = {x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber()};
            return new SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
          default:
            throw "Unknown path seg type."
        }
      }

      var builder = new Builder();
      var source = new Source(string);

      if (!source.initialCommandIsMoveTo())
        return [];
      while (source.hasMoreData()) {
        var pathSeg = source.parseSegment();
        if (!pathSeg)
          return [];
        builder.appendSegment(pathSeg);
      }

      return builder.pathSegList;
    }
  }
}());

/* Copyright 2014+, Federico Zivolo, LICENSE at https://github.com/FezVrasta/bootstrap-material-design/blob/master/LICENSE.md */
/* globals jQuery, navigator */
/*eslint-disable */

(function($, window, document, undefined) {

  "use strict";

  /**
   * Define the name of the plugin
   */
  var ripples = "ripples";


  /**
   * Get an instance of the plugin
   */
  var self = null;


  /**
   * Define the defaults of the plugin
   */
  var defaults = {};


  /**
   * Create the main plugin function
   */
  function Ripples(element, options) {
    self = this;

    this.element = $(element);

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = ripples;

    this.init();
  }


  /**
   * Initialize the plugin
   */
  Ripples.prototype.init = function() {
    var $element  = this.element;

    $element.on("mousedown touchstart", function(event) {
      /**
       * Verify if the user is just touching on a device and return if so
       */
      if(self.isTouch() && event.type === "mousedown") {
        return;
      }


      /**
       * Verify if the current element already has a ripple wrapper element and
       * creates if it doesn't
       */
      if(!($element.find(".ripple-wrapper").length)) {
        $element.append("<div class=\"ripple-wrapper\"></div>");
      }


      /**
       * Find the ripple wrapper
       */
      var $wrapper = $element.children(".ripple-wrapper");


      /**
       * Get relY and relX positions
       */
      var relY = self.getRelY($wrapper, event);
      var relX = self.getRelX($wrapper, event);


      /**
       * If relY and/or relX are false, return the event
       */
      if(!relY && !relX) {
        return;
      }


      /**
       * Get the ripple color
       */
      var rippleColor = self.getRipplesColor($element);


      /**
       * Create the ripple element
       */
      var $ripple = $("<div></div>");

      $ripple
      .addClass("ripple")
      .css({
        "left": relX,
        "top": relY,
        "background-color": rippleColor
      });


      /**
       * Append the ripple to the wrapper
       */
      $wrapper.append($ripple);


      /**
       * Make sure the ripple has the styles applied (ugly hack but it works)
       */
      (function() { return window.getComputedStyle($ripple[0]).opacity; })();


      /**
       * Turn on the ripple animation
       */
      self.rippleOn($element, $ripple);


      /**
       * Call the rippleEnd function when the transition "on" ends
       */
      setTimeout(function() {
        self.rippleEnd($ripple);
      }, 400);


      /**
       * Detect when the user leaves the element
       */
      $element.on("mouseup mouseleave touchend", function() {
        $ripple.data("mousedown", "off");

        if($ripple.data("animating") === "off") {
          self.rippleOut($ripple);
        }
      });

    });
  };


  /**
   * Get the new size based on the element height/width and the ripple width
   */
  Ripples.prototype.getNewSize = function($element, $ripple) {

    return (Math.max($element.outerWidth(), $element.outerHeight()) / $ripple.outerWidth()) * 2.5;
  };


  /**
   * Get the relX
   */
  Ripples.prototype.getRelX = function($wrapper,  event) {
    var wrapperOffset = $wrapper.offset();

    if(!self.isTouch()) {
      /**
       * Get the mouse position relative to the ripple wrapper
       */
      return event.pageX - wrapperOffset.left;
    } else {
      /**
       * Make sure the user is using only one finger and then get the touch
       * position relative to the ripple wrapper
       */
      event = event.originalEvent;

      if(event.touches.length !== 1) {
        return event.touches[0].pageX - wrapperOffset.left;
      }

      return false;
    }
  };


  /**
   * Get the relY
   */
  Ripples.prototype.getRelY = function($wrapper, event) {
    var wrapperOffset = $wrapper.offset();

    if(!self.isTouch()) {
      /**
       * Get the mouse position relative to the ripple wrapper
       */
      return event.pageY - wrapperOffset.top;
    } else {
      /**
       * Make sure the user is using only one finger and then get the touch
       * position relative to the ripple wrapper
       */
      event = event.originalEvent;

      if(event.touches.length !== 1) {
        return event.touches[0].pageY - wrapperOffset.top;
      }

      return false;
    }
  };


  /**
   * Get the ripple color
   */
  Ripples.prototype.getRipplesColor = function($element) {

    var color = $element.data("ripple-color") ? $element.data("ripple-color") : window.getComputedStyle($element[0]).color;

    return color;
  };


  /**
   * Verify if the client browser has transistion support
   */
  Ripples.prototype.hasTransitionSupport = function() {
    var thisBody  = document.body || document.documentElement;
    var thisStyle = thisBody.style;

    var support = (
      thisStyle.transition !== undefined ||
      thisStyle.WebkitTransition !== undefined ||
      thisStyle.MozTransition !== undefined ||
      thisStyle.MsTransition !== undefined ||
      thisStyle.OTransition !== undefined
    );

    return support;
  };


  /**
   * Verify if the client is using a mobile device
   */
  Ripples.prototype.isTouch = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };


  /**
   * End the animation of the ripple
   */
  Ripples.prototype.rippleEnd = function($ripple) {
    $ripple.data("animating", "off");

    if($ripple.data("mousedown") === "off") {
      self.rippleOut($ripple);
    }
  };


  /**
   * Turn off the ripple effect
   */
  Ripples.prototype.rippleOut = function($ripple) {
    $ripple.off();

    if(self.hasTransitionSupport()) {
      $ripple.addClass("ripple-out");
    } else {
      $ripple.animate({"opacity": 0}, 100, function() {
        $ripple.trigger("transitionend");
      });
    }

    $ripple.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {
      $ripple.remove();
    });
  };


  /**
   * Turn on the ripple effect
   */
  Ripples.prototype.rippleOn = function($element, $ripple) {
    var size = self.getNewSize($element, $ripple);

    if(self.hasTransitionSupport()) {
      $ripple
      .css({
        "-ms-transform": "scale(" + size + ")",
        "-moz-transform": "scale(" + size + ")",
        "-webkit-transform": "scale(" + size + ")",
        "transform": "scale(" + size + ")"
      })
      .addClass("ripple-on")
      .data("animating", "on")
      .data("mousedown", "on");
    } else {
      $ripple.animate({
        "width": Math.max($element.outerWidth(), $element.outerHeight()) * 2,
        "height": Math.max($element.outerWidth(), $element.outerHeight()) * 2,
        "margin-left": Math.max($element.outerWidth(), $element.outerHeight()) * (-1),
        "margin-top": Math.max($element.outerWidth(), $element.outerHeight()) * (-1),
        "opacity": 0.2
      }, 400, function() {
        $ripple.trigger("transitionend");
      });
    }
  };


  /**
   * Create the jquery plugin function
   */
  $.fn.ripples = function(options) {
    return this.each(function() {
      if(!$.data(this, "plugin_" + ripples)) {
        $.data(this, "plugin_" + ripples, new Ripples(this, options));
      }
    });
  };

})(jQuery, window, document);

/*eslint-disable */
(function(){
  'use strict';

  var methods = {
    init : function(options) {
      var defaults = {
        menuWidth: 250,
        edge: 'left',
        closeOnClick: false
      };
      options = $.extend(defaults, options);

      $(this).each(function(){
        var $this = $(this);
        var menu_id = $($this.attr('data-activates'));


        // Set to width
        if (options.menuWidth != 250) {
          menu_id.css('width', options.menuWidth);
        }

        // Add Touch Area
        $('body').append($('<div class="drag-target"></div>'));

        if (options.edge == 'left') {
          menu_id.css('left', -1 * (options.menuWidth + 10));
          $('.drag-target').css({'left': 0}); // Add Touch Area
        }
        else {
          menu_id.addClass('right-aligned') // Change text-alignment to right
            .css('right', -1 * (options.menuWidth + 10))
            .css('left', '');
          $('.drag-target').css({'right': 0}); // Add Touch Area
        }

        // If fixed sidenav, bring menu out
        if (menu_id.hasClass('fixed')) {
            if ($(window).width() > 992) {
              menu_id.css('left', 0);
            }
        }

        if (window.innerWidth > 992) {
          menuOut = true;
        }

        // Window resize to reset on large screens fixed
        if (menu_id.hasClass('fixed')) {
          $(window).resize( function() {
            if (window.innerWidth > 992) {
              // Close menu if window is resized bigger than 992 and user has fixed sidenav
              if ($('#sidenav-overlay').css('opacity') !== 0 && menuOut) {
                removeMenu(true);
              }
              else {
                menu_id.removeAttr('style');
                menu_id.css('width', options.menuWidth);
              }
            }
            else if (menuOut === false){
              if (options.edge === 'left')
                menu_id.css('left', -1 * (options.menuWidth + 10));
              else
                menu_id.css('right', -1 * (options.menuWidth + 10));
            }

          });
        }

        // if closeOnClick, then add close event for all a tags in side sideNav
        if (options.closeOnClick === true) {
          menu_id.on("click.itemclick", "a:not(.collapsible-header)", function(){
            if (menuOut === true) {
              removeMenu();
            }
          });
        }

        function removeMenu(restoreNav) {
          panning = false;
          menuOut = false;
          $('body').removeClass('overflow-no');
          $('#sidenav-overlay').velocity({opacity: 0}, {duration: 200, queue: false, easing: 'easeOutQuad',
            complete: function() {
              $(this).remove();
            } });
          if (options.edge === 'left') {
            // Reset phantom div
            $('.drag-target').css({width: '', right: '', left: '0'});
            menu_id.velocity(
              {left: -1 * (options.menuWidth + 10)},
              { duration: 200,
                queue: false,
                easing: 'easeOutCubic',
                complete: function() {
                  if (restoreNav === true) {
                    // Restore Fixed sidenav
                    menu_id.removeAttr('style');
                    menu_id.css('width', options.menuWidth);
                  }
                }

            });
          }
          else {
            // Reset phantom div
            $('.drag-target').css({width: '', right: '0', left: ''});
            menu_id.velocity(
              {right: -1 * (options.menuWidth + 10)},
              { duration: 200,
                queue: false,
                easing: 'easeOutCubic',
                complete: function() {
                  if (restoreNav === true) {
                    // Restore Fixed sidenav
                    menu_id.removeAttr('style');
                    menu_id.css('width', options.menuWidth);
                  }
                }
              });
          }
        }



        // Touch Event
        var panning = false;
        var menuOut = false;

        $('.drag-target').on('click', function(){
          removeMenu();
        });

        $('.drag-target').hammer({
          prevent_default: false
        }).bind('pan', function(e) {

          if (e.gesture.pointerType == "touch") {

            //var direction = e.gesture.direction;
            var x = e.gesture.center.x;
            var y = e.gesture.center.y;
            //var velocityX = e.gesture.velocityX;

            // If overlay does not exist, create one and if it is clicked, close menu
            if ($('#sidenav-overlay').length === 0) {
              var overlay = $('<div id="sidenav-overlay"></div>');
              overlay.css('opacity', 0).click( function(){
                removeMenu();
              });
              $('body').append(overlay);
            }

            // Keep within boundaries
            if (options.edge === 'left') {
              if (x > options.menuWidth) { x = options.menuWidth; }
              else if (x < 0) { x = 0; }
            }

            if (options.edge === 'left') {
              // Left Direction
              if (x < (options.menuWidth / 2)) { menuOut = false; }
              // Right Direction
              else if (x >= (options.menuWidth / 2)) { menuOut = true; }

              menu_id.css('left', (x - options.menuWidth));
            }
            else {
              // Left Direction
              if (x < ($(window).width() - options.menuWidth / 2)) {
                menuOut = true;
              }
              // Right Direction
              else if (x >= ($(window).width() - options.menuWidth / 2)) {
               menuOut = false;
             }
              var rightPos = -1 *(x - options.menuWidth / 2);
              if (rightPos > 0) {
                rightPos = 0;
              }

              menu_id.css('right', rightPos);
            }

            var overlayPerc;

            // Percentage overlay
            if (options.edge === 'left') {
              overlayPerc = x / options.menuWidth;
              $('#sidenav-overlay').velocity({opacity: overlayPerc }, {duration: 50, queue: false, easing: 'easeOutQuad'});
            } else {
              overlayPerc = Math.abs((x - $(window).width()) / options.menuWidth);
              $('#sidenav-overlay').velocity({opacity: overlayPerc }, {duration: 50, queue: false, easing: 'easeOutQuad'});
            }
          }

        }).bind('panend', function(e) {
          if (e.gesture.pointerType == "touch") {
            var velocityX = e.gesture.velocityX;
            panning = false;
            if (options.edge === 'left') {
              // If velocityX <= 0.3 then the user is flinging the menu closed so ignore menuOut
              if ((menuOut && velocityX <= 0.3) || velocityX < -0.5) {
                menu_id.velocity({left: 0}, {duration: 300, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 1 }, {duration: 50, queue: false, easing: 'easeOutQuad'});
                $('.drag-target').css({width: '50%', right: 0, left: ''});
              }
              else if (!menuOut || velocityX > 0.3) {
                menu_id.velocity({left: -1 * (options.menuWidth + 10)}, {duration: 200, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 0 }, {duration: 200, queue: false, easing: 'easeOutQuad',
                  complete: function () {
                    $(this).remove();
                  }});
                $('.drag-target').css({width: '10px', right: '', left: 0});
              }
            }
            else {
              if ((menuOut && velocityX >= -0.3) || velocityX > 0.5) {
                menu_id.velocity({right: 0}, {duration: 300, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 1 }, {duration: 50, queue: false, easing: 'easeOutQuad'});
                $('.drag-target').css({width: '50%', right: '', left: 0});
              }
              else if (!menuOut || velocityX < -0.3) {
                menu_id.velocity({right: -1 * (options.menuWidth + 10)}, {duration: 200, queue: false, easing: 'easeOutQuad'});
                $('#sidenav-overlay').velocity({opacity: 0 }, {duration: 200, queue: false, easing: 'easeOutQuad',
                  complete: function () {
                    $(this).remove();
                  }});
                $('.drag-target').css({width: '10px', right: 0, left: ''});
              }
            }

            $('body').addClass('overflow-no');

          }
        });

          $this.click(function() {
            if (menuOut === true) {
              menuOut = false;
              panning = false;
              removeMenu();
            }
            else {

              $('body').addClass('overflow-no');

              if (options.edge === 'left') {
                $('.drag-target').css({width: '50%', right: 0, left: ''});
                menu_id.velocity({left: 0}, {duration: 300, queue: false, easing: 'easeOutQuad'});
              }
              else {
                $('.drag-target').css({width: '50%', right: '', left: 0});
                menu_id.velocity({right: 0}, {duration: 300, queue: false, easing: 'easeOutQuad'});
                menu_id.css('left','');
              }

              var overlay = $('<div id="sidenav-overlay"></div>');
              overlay.css('opacity', 0)
              .click(function(){
                menuOut = false;
                panning = false;
                removeMenu();
                overlay.velocity({opacity: 0}, {duration: 300, queue: false, easing: 'easeOutQuad',
                  complete: function() {
                    $(this).remove();
                  } });

              });
              $('body').append(overlay);
              overlay.velocity({opacity: 1}, {duration: 300, queue: false, easing: 'easeOutQuad',
                complete: function () {
                  menuOut = true;
                  panning = false;
                }
              });
            }

            return false;
          });
      });


    },
    show : function() {
      this.trigger('click');
    },
    hide : function() {
      $('#sidenav-overlay').trigger('click');
    }
  };


    $.fn.sideNav = function(methodOrOptions) {
      if ( methods[methodOrOptions] ) {
        return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
      } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
        // Default to "init"
        return methods.init.apply( this, arguments );
      } else {
        $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.tooltip' );
      }
    }; // PLugin end
})();

(function(){
    'use strict';
  
    angular.module('portal').controller('TopnavController', TopnavController);
  
    function TopnavController($scope, api, TopnavService) {
               
        $scope.abrirArquivoPorCodCategoria = abrirArquivoPorCodCategoria;        

        function abrirArquivoPorCodCategoria(codCategoria) {          

            TopnavService.abrirArquivoPorCodCategoria(codCategoria)
                .then(function(response) {
                    var url;

                    if(api.url.includes("172")) {
                        url = 'http://homolog-portal-transparencia/gerenciador/arquivos/'
                    } else {
                        url = 'http://www.transparencia.df.gov.br/gerenciador/arquivos/'
                    }
                    
                    url += response.data;

                    window.open(url, '_blank');                    
                })

        }        
    }
  })();
(function(){
    'use strict';
  
    angular.module('portal').service('TopnavService', TopnavService);
  
    /** @ngInject */
    function TopnavService($http, api) {
  
      var service = {};
      var serviceConfig = { cache: true };
  
      service.abrirArquivoPorCodCategoria = function(codCategoria) { 
        return $http({
          url: api.url + '/arquivos/url-ultimo-arquivo-categoria/' + codCategoria,
          method: 'GET'
        })        
      };

      service.abrirArquivoPorCodCategoriaExercicio = function(codCategoria,exercicio) { 
        return $http({
          url: api.url + '/arquivos/url-ultimo-arquivo-categoria-exercicio/' + codCategoria + '/' + exercicio, 
          method: 'GET'
        })        
      };

      return service;
  
    }
  
  })();

/*eslint-disable */
(function () {
    'use strict';
  
    angular.module('portal').controller('ArrecadacaoImpostoController', ArrecadacaoImpostoController);

    /**
     * Controlador referente a seção de arrecadação de impostos da tela inicial
     */
    /** @ngInject */
    function ArrecadacaoImpostoController($scope, ImpostoService, $timeout) {
        this.ImpostoService = ImpostoService;
        this.onIntervaloArrecadacaoImpostoChange = onIntervaloArrecadacaoImpostoChange;
        this.loading = false;
        this.error = false;
        this.$timeout = $timeout;

        this.mesInicial = getMesInicialArrecadacaoImposto();
        this.mesFinal = getMesFinalArrecadacaoImposto();
    }

    /**
     * Responde ao evento que intervalo de meses da tela de arrecadação imposto é alterada.
     * @param {*} startMonth Primeiro mês do intervalo.
     * @param {*} endMonth Último mês do intervalo.
     */
    function onIntervaloArrecadacaoImpostoChange(startMonth, endMonth) {
        var self = this;

        this.loading = true;

        var startTime = new Date().getTime();

        this.ImpostoService.buscarArrecadacao(startMonth, endMonth).then(function(data) {
            var duration = new Date().getTime() - startTime;

            return duration > 250 ? data : self.$timeout(250 - duration).then(function() { return data; });
        }).then(function(data) {
            self.arrecadacaoImpostos = data;

            self.error = false;
        }, function(err) {
            self.error = true;
        }).finally(function() {
            self.loading = false;
        });
    }

    /**
     * Obtem o mês selecionado para o campo do primeiro mês do intervalo da arrecação imposto.
     * @returns String representando o mês no formato MM/yyyy.
     */
    function getMesInicialArrecadacaoImposto() {
        var now = new Date();
        var currentMonth = now.getMonth() + 1;
        var currentYear = now.getFullYear();

        return currentMonth > 1 ? '01/' + currentYear : '01/' + (currentYear - 1);
    }

    /**
     * Obtem o mês selecionado para o campo do último mês do intervalo da arrecação imposto.
     * @returns String representando o mês no formato MM/yyyy.
     */
    function getMesFinalArrecadacaoImposto() {
        var now = new Date();
        var currentMonth = now.getMonth() + 1;
        var currentYear = now.getFullYear();

        return currentMonth > 1 ? ('00' + currentMonth).slice(-2) + '/' + currentYear : '12/' + (currentYear - 1);
    }

})();
/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('ColorsController', ColorsController);

  /** @ngInject */
  function ColorsController() {
    angular.forEach(angular.element(".dynamic-color .col-md-4 div"), function(element){

      var elem = angular.element(element);
      var cls = elem.attr('class');

      var piece = cls.split(' ');

      if(piece[1] === undefined){
        piece[1] = 'base';
      }

      elem.html(piece[0]);
      elem.append('<div class="pull-right">'+piece[1]+'</div>');

      if(piece[1] == "darken-4"){
        elem.after('<br/>');
      }
    });
  }

})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('ColunasController', ColunasController);

    /**
     * Controlador referente a modal de Colunas.
     */
    /** @ngInject */
    function ColunasController($scope, $rootScope) {
        var vm = this;
        var LABEL_CHAR_WIDTH = 9.5;
        vm.initialState = getColumnsState($scope.colunas);

        vm.onColumnChange = function (column) {
            if (!column.visible && !hasAnyColumnVisible($scope.colunas)) {
                column.visible = true;
            }
        };

        $rootScope.$on('aside.hide', function (event, data) {
            event.preventDefault();
            if(data.$element.context.id == 'colunas-modal') {
                var finalState = getColumnsState($scope.colunas);
    
                var hasAnyColumnChange = hasStateChange(vm.initialState, finalState);
    
                if ($scope.fecharModalColunas) {
                    $scope.fecharModalColunas({ hasChange: hasAnyColumnChange });
                }
            }
        })

        vm.trocarVisibilidadeColunas = function (toggleStatus) {
            var arrayColunas = Object.values($scope.colunas);
            for (var i = 0; i < arrayColunas.length; i++) {
                if (!arrayColunas[i].disabled) {
                    arrayColunas[i].visible = toggleStatus;
                }
            }
        };

        var main = function () {
            var longestString = longestStringInArray(Object.values($scope.colunas));
            var labelWidth = getColumnLabelWidth(longestString);

            vm.labelWidth = {
                'width': labelWidth
            }
        }

        var longestStringInArray = function (array) {
            var word = "";
            for (var i = 0; i < array.length; i++) {
                if (word.length < array[i].nome.length) {
                    word = array[i].nome;
                }
            }

            return word;
        }

        var getColumnLabelWidth = function (string) {
            return string.length * LABEL_CHAR_WIDTH;
        }

        main();

    }

    function hasAnyColumnVisible(columns) {
        var visibleOnes = Object.keys(columns).filter(function (columnName) {
            return columns[columnName].visible;
        });

        return visibleOnes.length > 0;
    }

    function getColumnsState(columns) {
        var map = new Map();

        Object.keys(columns).forEach(function (columnName) {
            map.set(columnName, columns[columnName].visible);
        });

        return map;
    }

    function hasStateChange(initialState, finalState) {
        if (initialState.size != finalState.size) {
            return true;
        }

        var hasChange = false;

        Array.from(initialState.entries()).forEach(function (initialEntry) {
            if (finalState.has(initialEntry[0])) {
                var initialEntryValue = initialEntry[1];
                var finalEntryValue = finalState.get(initialEntry[0]);

                if (initialEntryValue != finalEntryValue) {
                    hasChange = true;
                }
            } else {
                hasChange = true;
            }
        });

        return hasChange;
    }

})();
/*eslint-disable */
(function () {
  'use strict';

  angular.module('portal').controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($filter, $scope, $rootScope, $route, $document,$location, ultimoExercicio, admregionais, admregionaisliquidado,
    receitasXDespesas, evolucaoImposto, situacaoAtivo, situacaoTotalServidores, graficoTreemap,
    situacaoAposentado, dadosOcupacao, dadosNivelSatisfacao,
    dadosFaixaEtaria, ReceitasService, ServidoresService, ScopeService, DespesasService) {
    var vm = this;

    var anoExercicio;
    var mesReferencia;
    vm.map = [];
    vm.funcao = '';

    vm.esconderTreemap = false;
    vm.anoExercicio = ultimoExercicio.data.toString().substr(0, 4);
    vm.mesReferencia = ultimoExercicio.data.toString().substr(4, 5);

    vm.dataAtual = new Date().toLocaleDateString('pt-BR');
    var colors = ['#95D1AA', '#6DB0E1', '#2D5181', '#90CEDB', '#76A8D7', '#2F8E43', '#6CAA6C', '#5DA199'];
    var fourColors = ['#98D1AB', '#5DA198', '#719FCA', '#2B5280'];
    var fiveColors = ['#98D1AB', '#5DA198', '#90CEDB', '#719FCA', '#2B5280'];
    var colorsTreemap = ['#5da29a', '#6daba4', '#7db5ae', '#8ebeb8', '#8ebeb8', '#9ec7c2', '#9ec7c2', '#9ec7c2',
      '#aed0cc', '#aed0cc', '#aed0cc', '#bedad7', '#bedad7', '#bedad7', '#cee3e1'];

    var impostoPrimeiroValor = true;
    $scope.imposto = 'IPVA';
    $scope.anoAtual = new Date().getFullYear();

    $scope.recuperarDespesasAtuais = function (ano) {
      DespesasService.recuperarDespesasAtuais(ano).then(
        function (response) {
          graficoTreemap = response;
          $scope.initTreemap();
        });
    }

    $scope.anos = function () {
      DespesasService.listarAno().then(
        function (response) {
          $scope.anos = response.data;
        });
    }

    $scope.pesquisar = function(value) {
      $location.path('/busca').search({q: value});
			$scope.$apply();
    };



    $scope.anos();

    $scope.initTreemapMensagemErro = function () {
      var f1 = graficoTreemap.data[0];
      var v1 = graficoTreemap.data[1];

      var treemapChart = new Highcharts.chart('divtreemap', {
        series: [{
          type: 'treemap',
          layoutAlgorithm: 'squarified',
          data: [
            { name: f1, value: v1, color: '#5da29a' }
          ],

          style: {
            fontFamily: 'Montserrat',
            color: "#FFFFFF"
          }

        }],

        title: {
          text: ''
        },

        exporting: {
          enabled: false
        }
      });
    }

    $scope.initTreemap = function () {
      vm.map = [];
      vm.esconderTreemap = false;
      delete $scope.treemapSubfuncoes;
      var f1 = graficoTreemap.data[0];
      var v1 = graficoTreemap.data[1];
      var f2 = graficoTreemap.data[2];
      var v2 = graficoTreemap.data[3];
      var f3 = graficoTreemap.data[4];
      var v3 = graficoTreemap.data[5];
      var f4 = graficoTreemap.data[6];
      var v4 = graficoTreemap.data[7];
      var f5 = graficoTreemap.data[8];
      var v5 = graficoTreemap.data[9];
      var f6 = graficoTreemap.data[10];
      var v6 = graficoTreemap.data[11];
      var f7 = graficoTreemap.data[12];
      var v7 = graficoTreemap.data[13];
      var f8 = graficoTreemap.data[14];
      var v8 = graficoTreemap.data[15];
      var f9 = graficoTreemap.data[16];
      var v9 = graficoTreemap.data[17];
      var f10 = graficoTreemap.data[18];
      var v10 = graficoTreemap.data[19];
      var f11 = graficoTreemap.data[20];
      var v11 = graficoTreemap.data[21];
      var f12 = graficoTreemap.data[22];
      var v12 = graficoTreemap.data[23];
      var f13 = graficoTreemap.data[24];
      var v13 = graficoTreemap.data[25];
      var f14 = graficoTreemap.data[26];
      var v14 = graficoTreemap.data[27];
      var f15 = graficoTreemap.data[28];
      var v15 = graficoTreemap.data[29];

      var treemapChart = new Highcharts.chart('divtreemap', {
        series: [{
          type: 'treemap',
          cursor: 'pointer',
          layoutAlgorithm: 'squarified',
          data: [
            { name: f1, value: v1, color: '#5da29a' },
            { name: f2, value: v2, color: '#6daba4' },
            { name: f3, value: v3, color: '#7db5ae' },
            { name: f4, value: v4, color: '#8ebeb8' },
            { name: f5, value: v5, color: '#8ebeb8' },
            { name: f6, value: v6, color: '#9ec7c2' },
            { name: f7, value: v7, color: '#9ec7c2' },
            { name: f8, value: v8, color: '#9ec7c2' },
            { name: f9, value: v9, color: '#aed0cc' },
            { name: f10, value: v10, color: '#aed0cc' },
            { name: f11, value: v11, color: '#aed0cc' },
            { name: f12, value: v12, color: '#bedad7' },
            { name: f13, value: v13, color: '#bedad7' },
            { name: f14, value: v14, color: '#bedad7' },
            { name: f15, value: v15, color: '#cee3e1' }
          ],

          events: {
            click: function (e) {
              graficoTreemapSubfuncao(e.point.name);
              vm.funcao = e.point.name        
              var f = vm.funcao.split("-")[0];
              vm.funcao = f.substring(0, f.length - 1);
            }
          },

          style: {
            fontFamily: 'Montserrat',
            color: "#FFFFFF"
          }

        }],

        title: {
          text: 'Funções'
        },

        exporting: {
          enabled: false
        }
      });
    }

    if (graficoTreemap.data[0] == 'NÃO FOI POSSÍVEL CARREGAR O GRÁFICO') {
      $scope.initTreemapMensagemErro();
    } else {
      $scope.initTreemap();
    }

    $scope.initTreemapSubfuncoesMensagemErro = function () {
      var treemapChart = new Highcharts.chart('divtreemapSubfuncoess', {
        series: [{
          type: 'treemap',
          layoutAlgorithm: 'squarified',
          data: [
            { name: "NÃO FOI POSSÍVEL CARREGAR O GRÁFICO", value: '', color: '#5da29a' }
          ],

          style: {
            fontFamily: 'Montserrat',
            color: "#FFFFFF"
          }

        }],

        title: {
          text: ''
        },

        exporting: {
          enabled: false
        }
      });
    }
    var graficoTreemapSubfuncao = function (funcao) {
      funcao = funcao.substring(0, funcao.length - 10);
      DespesasService.graficoTreemapSubfuncao(funcao, $scope.anoTreeMap)
        .then(function (obj) {
          $scope.treemapSubfuncoes = obj.data;
          if ($scope.treemapSubfuncoes.length == 0) {
            $scope.initTreemapSubfuncoesMensagemErro();
          } else {
            vm.esconderTreemap = true;
            $scope.initTreemapSubfuncao();
          }
        })
    }

    $scope.initTreemapSubfuncao = function () {
      var count = 1;
      $($scope.treemapSubfuncoes).each(function (i) {
        if (i > 0 && (i & 1)) {
          vm.map.push({ name: $scope.treemapSubfuncoes[i], value: $scope.treemapSubfuncoes[i + 1], color: colorsTreemap[count] })
          count++;
        }
      })
      var treemapChart = new Highcharts.chart('divtreemapSubfuncoes', {
        series: [{
          type: 'treemap',
          layoutAlgorithm: 'squarified',
          cursor: 'pointer',
          animationLimit: 1000,
          style: {
            fontFamily: 'Montserrat',
            color: "#5da29a"
          },
          data: vm.map,
          events: {
            click: function (e) {
              $location.path('/despesas/consulta-dinamica').search({
                anoExercicio: $scope.anoTreeMap,
                nomeFuncao: vm.funcao,
                nomeSubfuncao: e.point.name.split(' - ')[0],
                colunas: ['nomeUnidadeGestora', 'nomeFuncao', 'nomeSubfuncao', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
              });
              $scope.$apply();
            }
          },
        }],

        title: {
          text: vm.funcao
        },

        exporting: {
          enabled: false
        }
      });
    }

    var graficoReceitasDespesas = c3.generate({
      bindto: '#chart-line-1',
      data: {
        columns: receitasXDespesas.data.colunas,
        type: 'area-spline',
        onclick: function (d, i) {
          if (d.id == 'Receitas') {
            $location.path('/receitas/consulta-dinamica').search({
              exercicio: receitasXDespesas.data.categoria[d.x],
              colunas: ['nomeUnidadeGestora', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
            });
            $scope.$apply();

          } else {
            $location.path('/despesas/consulta-dinamica').search({
              anoExercicio: receitasXDespesas.data.categoria[d.x],
              colunas: ['nomeUnidadeGestora', 'valorNeFinal', 'valorNlBruto', 'valorObFinal']
            });
            $scope.$apply();
          }
        }
      },
      axis: {
        x: {
          type: 'category',
          categories: receitasXDespesas.data.categoria
        },
        y: {
          label: {
            text: 'Bilhões',
            position: 'outer-middle'
          },
          tick: {
            format: function (d) { return $filter('currency')(d / 1000000000); }
          }
        }
      },
      /*size: { height: 220, width: 1000 },*/
      tooltip: { show: true },
      color: { pattern: ['5EA097', '2E5280'] },
      legend: { show: true }
    });

    var graficoImpostos = c3.generate({
      bindto: '#chart-line-2',
      data: {
        columns: evolucaoImposto.data.colunas,
        onclick: function (d, i) {
          $location.path('/receitas/consulta-dinamica')
            .search({
              exercicio: evolucaoImposto.data.categoria[d.x],
              listaCodigoAlinea: getAlinea(d.id),
              colunas: ['nomeAlinea', 'nomeSubalinea', 'valorPrevisto', 'valorRealizado', 'diferenca', 'percentual']
            });
          $scope.$apply();
        },
        type: 'bar'
      },
      axis: {
        x: {
          type: 'category',
          categories: evolucaoImposto.data.categoria
        },
        y: {
          label: {
            text: 'Milhões',
            position: 'outer-middle'
          },
          tick: {
            format: function (d) { return $filter('currency')(d / 1000000); }
          }
        }
      },
      tooltip: { show: true },
      color: { pattern: ['#074E7D'] },
      legend: { show: false }
    });

    var getAlinea = function (siglaImposto) {
      switch (siglaImposto) {
        case "ITBI":
          return "111208";
        case "ICMS":
          return "111302";
        case "IPVA":
          return "111205";
        case "IR":
          return "111204";
        case "ITCMD":
          return "111207";
        case "IS":
          return "111306";
        case "IPTU":
          return "111202";
        case "ISS":
          return "111305";
        default:
          return null;
      }
    };

    var chartBarPesquisaNivelSatisfacao = c3.generate({
      bindto: '#grafico-pesquisa-nivel-satisfacao',
      data: {
        columns: dadosNivelSatisfacao.data,
        type: 'bar'
      },
      tooltip: {
        grouped: false,
        format: {
          name: function (name, ratio, id, index) {
            return name;
          },
          title: function (x) { return '' },
          value: function (value, ratio, id, index) {
            return value;
          }
        }
      },
      axis: {
        y: {
          label: {
            text: 'Nº de Pessoas',
            position: 'outer-middle'
          }
        }
      },
      legend: {
        position: 'bottom'
      },
      /*size: {
        height: 200
      },*/
      color: {
        pattern: fourColors
      }
    });

    var chartBarPesquisaFaixaEtaria = c3.generate({
      bindto: '#grafico-pesquisa-faixa-etaria',
      data: {
        columns: dadosFaixaEtaria.data,
        type: 'bar'
      },
      tooltip: {
        grouped: false,
        format: {
          name: function (name, ratio, id, index) {
            return name;
          },
          title: function (x) { return '' },
          value: function (value, ratio, id, index) {
            return value;
          }
        }
      },
      axis: {
        y: {
          label: {
            text: 'Nº de Pessoas',
            position: 'outer-middle'
          }
        }
      },
      legend: {
        position: 'bottom'
      },
      /*size: {
        height: 200
      },*/
      color: {
        pattern: fiveColors
      }
    });

    var chartBarPesquisaOcupacao = c3.generate({
      bindto: '#grafico-pesquisa-ocupacao',
      data: {
        columns: dadosOcupacao.data,
        type: 'bar'
      },
      tooltip: {
        grouped: false,
        format: {
          name: function (name, ratio, id, index) {
            return name;
          },
          title: function (x) { return '' },
          value: function (value, ratio, id, index) {
            return value;
          }
        }
      },
      axis: {
        y: {
          label: {
            text: 'Nº de Pessoas',
            position: 'outer-middle'
          }
        }
      },
      legend: {
        position: 'bottom'
      },
      /*size: {
        height: 200
      },*/
      color: {
        pattern: colors
      }
    });

    var chartGuageServidoresAtivos = c3.generate({
      bindto: '#grafico-gauge-servidores-ativos',
      data: {
        columns: [
          ['Ativos', (100 * (situacaoAtivo.data / situacaoTotalServidores.data)).toFixed(1)]
        ],
        type: 'gauge',
        onclick: function (d, i) {
          $rootScope.situacaoFuncionalServidor = "ATIVO";
          $location.path('/servidores/orgao');
          $scope.$apply();
        }
      },
      color: { pattern: ['#5DA198'] },
      size: {
        height: 150
      }
    });

    var chartGuageServidoresAposentados = c3.generate({
      bindto: '#grafico-gauge-servidores-aposentados',
      data: {
        columns: [
          ['Aposentados', (100 * (situacaoAposentado.data / situacaoTotalServidores.data)).toFixed(1)]
        ],
        type: 'gauge',
        onclick: function (d, i) {
          $rootScope.situacaoFuncionalServidor = "APOSENTADO";
          $location.path('/servidores/orgao');
          $scope.$apply();
        }
      },
      color: { pattern: ['#5DA198'] },
      size: {
        height: 150
      }
    });

    var alterarImposto = function (newValue, oldValue) {
      var unload = [];
      unload.push(oldValue);

      ReceitasService.graficoEvolucaoImposto(newValue).then(
        function (response) {
          graficoImpostos.load({
            columns: response.data.colunas,
            unload: unload
          });

          angular.element($document).find('.card-reveal').toggleClass('active');
        }
      );
    };

    $scope.$watch('imposto', function (newValue, oldValue) {
      if (!impostoPrimeiroValor) {
        alterarImposto(newValue, oldValue);
      }
      impostoPrimeiroValor = false;
    }, true);

    $scope.$watch('anoTreeMap', function (anoTreeMap) {
      $scope.recuperarDespesasAtuais(anoTreeMap);
      if (anoTreeMap == null) {
        $scope.anoTreeMap = $scope.anoAtual;
      } else {
        $scope.anoTreeMap = anoTreeMap;
      }
    });

    $scope.enviarValoresRadios = function (nivelSatisfacao, faixaEtaria, ocupacao, desagrado, textoDesagrado) {

      if (nivelSatisfacao == "Satisfeito" || nivelSatisfacao == "Muito Satisfeito") {
        desagrado = null;
        textoDesagrado = null;
      }

      var valoresCapturados = ocupacao + ";" + faixaEtaria + ";" + nivelSatisfacao;
      if (!ocupacao || !faixaEtaria || !nivelSatisfacao) {
        $scope.mensagemErro = "Você não respondeu uma ou mais perguntas!";
        setTimeout(function (){
          $scope.mensagemErro = false},3000);
          $scope.mensagemSucesso = null;
      }
      else {
        $.post("http://www.transparencia.df.gov.br/api/pesquisa/registro", {
          valoresCapturados: valoresCapturados,
          desagrado: desagrado,
          textoDesagrado: textoDesagrado
        });
        $scope.mensagemErro = null;
        $scope.mensagemSucesso = "Obrigado pela participação!";
        setTimeout(function (){
          $scope.mensagemSucesso = false},3000);
        vm.limparCamposPesquisa();
        vm.totalDeRespostas();
      }
    }

    vm.limparCamposPesquisa = function(){
      delete $scope.ocupacao;
      delete $scope.faixa;
      delete $scope.satisfacao;
      delete $scope.desagrado;
      delete $scope.detalheDesagrado;
    }


    vm.totalDeRespostas = function(){
      ServidoresService.listarTotalDeRespostasDaPesquisaDeSatisfacao()
      .then(function (obj) {
        $scope.total = obj.data[0][1];
      })
    }

    vm.totalDeRespostas();
  }
})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('DespesasRegionaisController', DespesasRegionaisController);

    /**
     * Controlador referente a seção que apresenta as despesas por região administrativa.
     */
    /** @ngInject */
    function DespesasRegionaisController(RegioesService, $timeout, $q) {
        var self = this;
        this.loading = false;
        this.error = false;
        this.$timeout = $timeout;


        this.loading = true;
        var now = new Date();
        var startTime = now.getTime();
        var currentYear = now.getMonth() == 0 ? now.getFullYear() - 1 : now.getFullYear();


        $q.all([
            RegioesService.consultarDespesas(currentYear),
            RegioesService.consultarRegioesGeoJson(),
            RegioesService.consultarDelimitacoesGeoJson()
        ]).then(function (data) {
            var duration = new Date().getTime() - startTime;

            return duration > 250 ? data : self.$timeout(250 - duration).then(function () { return data; });
        }).then(function (responseArray) {
            self.dataModel = {
                exercicio: currentYear,
                despesas: responseArray[0],
                localizacoes: responseArray[1],
                limites: responseArray[2]
            };
            self.error = false;
        }, function (err) {
            self.error = true;
        }).finally(function () {
            self.loading = false;
        });
    }

})();
(function () {
    'use strict';

    angular.module('portal').controller('DownloadsController', DownloadsController);

   DownloadsController.$inject = ['$scope', '$location', 'ArquivoUrlService'];


    function DownloadsController($scope, $location, ArquivoUrlService) {

        var vm = this;

        var colunas = {
            ano: { nome: "Ano", visible: true },
            nome: { nome: "Nome", visible: true }

        };

        var URL_ARQUIVOS_PORTAL = ArquivoUrlService.DADOS_ABERTOS;
        const anoCorrente = new Date().getFullYear();

        $scope.colunas = colunas;


        vm.sessoes = [
            {
                id: 'rec',
                collapsed: false,
                titulo: 'Receita',
                tabelas: [
                    {
                        titulo: 'Receita - Por Exercício',
                        dicionario :'http://dados.df.gov.br/dataset/c92c427a-9f63-4f53-a0dd-ba5d309f0455/resource/13f7c230-8e8c-419d-8675-6bb8e8c9f46d/download/dicionario-de-dados-abertosreceita.pdf',
                        dados: [
                            {
                                nome: 'Receita - 2009',
                                download: 'Receita_2009.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2009.zip', ano: '2009'
                            },
                            {
                                nome: 'Receita - 2010', download: 'Receita_2010.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2010.zip', ano: '2010'
                            },
                            {
                                nome: 'Receita - 2011', download: 'Receita_2011.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2011.zip', ano: '2011'
                            },
                            {
                                nome: 'Receita - 2012', download: 'Receita_2012.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2012.zip', ano: '2012'
                            },
                            {
                                nome: 'Receita - 2013', download: 'Receita_2013.zip',
                                url: URL_ARQUIVOS_PORTAL + 'Receita_2013.zip', ano: '2013'
                            },
                            {
                                nome: 'Receita - 2014', download: 'Receita_2014.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2014.zip', ano: '2014'
                            },
                            {
                                nome: 'Receita - 2015', download: 'Receita_2015.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2015.zip', ano: '2015'
                            },
                            {
                                nome: 'Receita - 2016', download: 'Receita_2016.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2016.zip', ano: '2016'
                            },
                            {
                                nome: 'Receita - 2017', download: 'Receita_2017.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2017.zip', ano: '2017'
                            },
                            {
                                nome: 'Receita - 2018', download: 'Receita_2018.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2018.zip', ano: '2018'
                            },
                            {
                                nome: 'Receita - 2019', download: 'Receita_2019.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2019.zip', ano: '2019'
                            },
                            {
                                nome: 'Receita - 2020', download: 'Receita_2020.zip',
                                url: URL_ARQUIVOS_PORTAL + 'Receita_2020.zip', ano: '2020'
                            },
                            {
                                nome: 'Receita - 2021', download: 'Receita_2021.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Receita_2021.zip', ano: '2021'
                            },
                            {
                               nome: 'Receita - 2022', download: 'Receita_2022.zip',
                               url:  URL_ARQUIVOS_PORTAL + 'Receita_2022.zip', ano: '2022'
                            },
                            {
                              nome: 'Receita - 2023', download: 'Receita_2023.zip',
                              url:  URL_ARQUIVOS_PORTAL + 'Receita_2023.zip', ano: '2023'
                           },{
                              nome: 'Receita - 2024', download: 'Receita_2024.zip',
                              url:  URL_ARQUIVOS_PORTAL + 'Receita_2024.zip', ano: '2024'
                           },{
                              nome: 'Receita - 2025', download: 'Receita_2025.zip',
                              url:  URL_ARQUIVOS_PORTAL + 'Receita_2025.zip', ano: '2025'
                           },
                          {
                            nome: 'Receita - 2026', download: 'Receita_2026.zip',
                            url:  URL_ARQUIVOS_PORTAL + 'Receita_2026.zip', ano: '2026'

                          }
                        ]
                    }
                ]
            }
            , {
                id: 'des',
                collapsed: false,
                titulo: 'Despesa',
                tabelas: [
                    {
                        titulo: 'Despesa - Por Exercício',
                        dicionario :'http://dados.df.gov.br/dataset/8dce6486-3295-47c3-b463-8a2aaef0ef0b/resource/61a4a81d-73e4-4665-bd85-d6453a98fe47/download/dicionario-de-dados-abertosdespesa.pdf',
                        dados: [
                            {
                                nome: 'Despesa - 2009', download: 'Despesa_2009.zip',
                                url:  URL_ARQUIVOS_PORTAL + 'Despesa_2009.zip', ano: '2009'
                            },
                            {
                                nome: 'Despesa - 2010', download: 'Despesa_2010.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2010.zip', ano: '2010'
                            },
                            {
                                nome: 'Despesa - 2011', download: 'Despesa_2011.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2011.zip', ano: '2011'
                            },
                            {
                                nome: 'Despesa - 2012', download: 'Despesa_2012.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2012.zip', ano: '2012'
                            },
                            {
                                nome: 'Despesa - 2013', download: 'Despesa_2013.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2013.zip', ano: '2013'
                            },
                            {
                                nome: 'Despesa - 2014', download: 'Despesa_2014.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2014.zip', ano: '2014'
                            },
                            {
                                nome: 'Despesa - 2015', download: 'Despesa_2015.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2015.zip', ano: '2015'
                            },
                            {
                                nome: 'Despesa - 2016', download: 'Despesa_2016.zip',
                                url: URL_ARQUIVOS_PORTAL +'Despesa_2016.zip', ano: '2016'
                            },
                            {
                                nome: 'Despesa - 2017', download: 'Despesa_2017.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2017.zip', ano: '2017'
                            },
                            {
                                nome: 'Despesa - 2018', download: 'Despesa_2018.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2018.zip', ano: '2018'
                            },
                            {
                                nome: 'Despesa - 2019', download: 'Despesa_2019.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2019.zip', ano: '2019'
                            },
                            {
                                nome: 'Despesa - 2020', download: 'Despesa_2020.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2020.zip', ano: '2020'
                            },
                            {
                                nome: 'Despesa - 2021', download: 'Despesa_2021.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2021.zip', ano: '2021'
                            },
                            {
                                nome: 'Despesa - 2022', download: 'Despesa_2022.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Despesa_2022.zip', ano: '2022'
                            },
                            {
                              nome: 'Despesa - 2023', download: 'Despesa_2023.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Despesa_2023.zip', ano: '2023'
                            },
                            {
                              nome: 'Despesa - 2024', download: 'Despesa_2024.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Despesa_2024.zip', ano: '2024'
                            },
                            {
                              nome: 'Despesa - 2025', download: 'Despesa_2025.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Despesa_2025.zip', ano: '2025'
                            },
                            {
                              nome: 'Despesa - 2026', download: 'Despesa_2026.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Despesa_2026.zip', ano: '2026'
                            }

                        ]
                    }
                ]
            }
            , {
                id: 'downloadServidores',
                collapsed: false,
                titulo: 'Servidores',
                tabelas: [
                    {
                        titulo: 'Remuneração dos Servidores',
                        dicionario :'http://dados.df.gov.br/dataset/462126f8-8a61-4cec-91a2-38615b7f70f6/resource/0514402e-cd29-440b-83e5-f97787dd1ad3/download/dicdadosremuneracaodosservidores.html',
                        dados: [
                            {
                                nome: 'Remuneração dos Servidores - 2013', download: 'Remuneracao_2013.zip',
                                url: URL_ARQUIVOS_PORTAL + 'Remuneracao_2013.zip', ano: '2013'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2014', download: 'Remuneracao_2014.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2014.zip', ano: '2014'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2015', download: 'Remuneracao_2015.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2015.zip', ano: '2015'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2016', download: 'Remuneracao_2016.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2016.zip', ano: '2016'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2017', download: 'Remuneracao_2017.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2017.zip', ano: '2017'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2018', download: 'Remuneracao_2018.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2018.zip', ano: '2018'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2019', download: 'Remuneracao_2019.zip',
                                url: URL_ARQUIVOS_PORTAL +'Remuneracao_2019.zip', ano: '2019'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2020', download: 'Remuneracao_2020.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2020.zip', ano: '2020'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2021', download: 'Remuneracao_2021.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2021.zip', ano: '2021'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2022', download: 'Remuneracao_2022.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2022.zip', ano: '2022'
                            },
                            {
                                nome: 'Remuneração dos Servidores - 2023', download: 'Remuneracao_2023.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2023.zip', ano: '2023'
                            },
                            {
                              nome: 'Remuneração dos Servidores - 2024', download: 'Remuneracao_2024.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2024.zip', ano: '2024'
                            },
                            {
                              nome: 'Remuneração dos Servidores - 2025', download: 'Remuneracao_2025.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2025.zip', ano: '2025'
                            },
                           {
                             nome: 'Remuneração dos Servidores - 2026', download: 'Remuneracao_2026.zip',
                             url:  URL_ARQUIVOS_PORTAL +'Remuneracao_2026.zip', ano: '2026'
                          },

                        ]
                    }, {
                        titulo: 'Por Órgão',
                        dicionario :'http://dados.df.gov.br/dataset/30a7a2f3-c564-4de2-b969-dcba77eb000d/resource/0f8cd724-2940-4d19-a8db-0867e4de70ff/download/dicdadosservidorespororgao.html',
                        dados: [
                            {
                                nome: 'Servidores por Órgão - 2016', download: 'Servidores_Orgao_2016.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2016.zip', ano: '2016'
                            },
                            {
                                nome: 'Servidores por Órgão - 2017', download: 'Servidores_Orgao_2017.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2017.zip', ano: '2017'
                            },
                            {
                                nome: 'Servidores por Órgão - 2018', download: 'Servidores_Orgao_2018.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2018.zip', ano: '2018'
                            },
                            {
                                nome: 'Servidores por Órgão - 2019', download: 'Servidores_Orgao_2019.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2019.zip', ano: '2019'
                            },
                            {
                                nome: 'Servidores por Órgão - 2020', download: 'Servidores_Orgao_2020.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2020.zip', ano: '2020'
                            },
                            {
                                nome: 'Servidores por Órgão - 2021', download: 'Servidores_Orgao_2021.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2021.zip', ano: '2021'
                            },
                            {
                                nome: 'Servidores por Órgão - 2022', download: 'Servidores_Orgao_2022.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2022.zip', ano: '2022'
                            },
                            {
                              nome: 'Servidores por Órgão - 2023', download: 'Servidores_Orgao_2023.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2023.zip', ano: '2023'
                            },
                            {
                              nome: 'Servidores por Órgão - 2024', download: 'Servidores_Orgao_2024.zip',
                              url:  URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2024.zip', ano: '2024'
                            },
                            {
                              nome: 'Servidores por Órgão - 2025', download: 'Servidores_Orgao_2025.zip',
                              url: URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2025.zip', ano: '2025'
                            },
                            {
                              nome: 'Servidores por Órgão - 2026', download: 'Servidores_Orgao_2026.zip',
                              url: URL_ARQUIVOS_PORTAL +'Servidores_Orgao_2026.zip', ano: '2026'
                            }
                        ]
                    }
                ]
            }, {
                id: 'lic',
                collapsed: false,
                titulo: 'Licitações e Contratos',
                tabelas: [
                    {
                        titulo: 'Licitações',
                        dicionario :'http://dados.df.gov.br/dataset/11fe6055-87ea-4dfb-9c8c-b613589c30d7/resource/957519aa-8b2b-4ad5-bd4e-d8fc62d0edd3/download/dicdadoslicitacoes.html',
                        dados: [
                            {
                                nome: 'Licitações - 2005', download: 'Licitacao_2005.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2005.zip', ano: '2005'
                            },
                            {
                                nome: 'Licitações - 2006', download: 'Licitacao_2006.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2006.zip', ano: '2006'
                            },
                            {
                                nome: 'Licitações - 2007', download: 'Licitacao_2007.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2007.zip', ano: '2007'
                            },
                            {
                                nome: 'Licitações - 2008', download: 'Licitacao_2008.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2008.zip', ano: '2008'
                            },
                            {
                                nome: 'Licitações - 2009', download: 'Licitacao_2009.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2009.zip', ano: '2009'
                            },
                            {
                                nome: 'Licitações - 2010', download: 'Licitacao_2010.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2010.zip', ano: '2010'
                            },
                            {
                                nome: 'Licitações - 2011', download: 'Licitacao_2011.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2011.zip', ano: '2011'
                            },
                            {
                                nome: 'Licitações - 2012', download: 'Licitacao_2012.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2012.zip', ano: '2012'
                            },
                            {
                                nome: 'Licitações - 2013', download: 'Licitacao_2013.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2013.zip', ano: '2013'
                            },
                            {
                                nome: 'Licitações - 2014', download: 'Licitacao_2014.zip',
                                url: URL_ARQUIVOS_PORTAL +'Licitacao_2014.zip', ano: '2014'
                            },
                            {
                                nome: 'Licitações - 2015', download: 'Licitacao_2015.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Licitacao_2015.zip', ano: '2015'
                            }
                        ]
                    }
                ]
            },
            {
                id: 'patr',
                collapsed: false,
                titulo: 'Patrimônio',
                tabelas: [
                    {
                        titulo: 'Bens Móveis',
                        dicionario :'http://dados.df.gov.br/dataset/62512592-f57c-4c99-aca2-acd12476c157/resource/60a513eb-a449-499a-90db-fb73aa1823de/download/dicionario-de-dados-patrimonio-bens-moveis-por-orgao.pdf',
                        dados: [
                            {
                                nome: 'Patrimônio Bens Móveis - Completo', download: 'Patrimonio_Bens_Moveis.zip',
                                url:  URL_ARQUIVOS_PORTAL +'Patrimonio_Bens_Moveis.zip', ano: 'Atual'
                            }
                        ]
                    }
                ]
            },

                {
    id: 'progam',
    collapsed: false,
    titulo: 'PRESTANDO CONTAS',
    tabelas: [
      {
        titulo: 'Beneficiários de programas sociais - Transferência de Renda e Auxílios',
        dicionario: 'https://dados.df.gov.br/dataset/d9c4f69f-4623-4efc-817b-90b1d591d0a6/resource/4ae2a312-d325-4a42-90a2-e3706e4bdd3d/download/dicdadosbeneficiariosdeprograma',
        dados: [
                        {
                          nome: 'Transferência de Renda e Auxílios - 2026',
                          download: 'Transferência_de_Renda_e_Auxílios_2026.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2026.zip',
                          ano: '2026'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2025',
                          download: 'Transferência_de_Renda_e_Auxílios_2025.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2025.zip',
                          ano: '2025'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2024',
                          download: 'Transferência_de_Renda_e_Auxílios_2024.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2024.zip',
                          ano: '2024'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2023',
                          download: 'Transferência_de_Renda_e_Auxílios_2023.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2023.zip',
                          ano: '2023'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2022',
                          download: 'Transferência_de_Renda_e_Auxílios_2022.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2022.zip',
                          ano: '2022'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2021',
                          download: 'Transferência_de_Renda_e_Auxílios_2021.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2021.zip',
                          ano: '2021'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2020',
                          download: 'Transferência_de_Renda_e_Auxílios_2020.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2020.zip',
                          ano: '2020'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2019',
                          download: 'Transferência_de_Renda_e_Auxílios_2019.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2019.zip',
                          ano: '2019'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2018',
                          download: 'Transferência_de_Renda_e_Auxílios_2018.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2018.zip',
                          ano: '2018'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2017',
                          download: 'Transferência_de_Renda_e_Auxílios_2017.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2017.zip',
                          ano: '2017'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2016',
                          download: 'Transferência_de_Renda_e_Auxílios_2016.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2016.zip',
                          ano: '2016'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2015',
                          download: 'Transferência_de_Renda_e_Auxílios_2015.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2015.zip',
                          ano: '2015'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2014',
                          download: 'Transferência_de_Renda_e_Auxílios_2014.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2014.zip',
                          ano: '2014'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2013',
                          download: 'Transferência_de_Renda_e_Auxílios_2013.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2013.zip',
                          ano: '2013'
                        },
                        {
                          nome: 'Transferência de Renda e Auxílios - 2012',
                          download: 'Transferência_de_Renda_e_Auxílios_2012.zip',
                          url: URL_ARQUIVOS_PORTAL + 'Transferência_de_Renda_e_Auxílios_2012.zip',
                          ano: '2012'
                        }
                      ]
            },
         {
                        titulo: 'Beneficiários de programas sociais - Cartão Material Escolar',
                        dicionario: 'https://dados.df.gov.br/dataset/78edd015-d9c6-4cd8-b4a9-502439eae429/resource/0342ed1e-0d28-4be6-be4b-d03dfbca37a4/download/dicdadosbeneficiarios-do-cartao-material-escolar.htm',
                   dados: [
                     {
                       nome: 'Cartão Material Escolar - 2026',
                       download: 'Cartão_Material_Escolar_2026.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2026.zip',
                       ano: '2026'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2025',
                       download: 'Cartão_Material_Escolar_2025.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2025.zip',
                       ano: '2025'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2024',
                       download: 'Cartão_Material_Escolar_2024.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2024.zip',
                       ano: '2024'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2023',
                       download: 'Cartão_Material_Escolar_2023.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2023.zip',
                       ano: '2023'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2022',
                       download: 'Cartão_Material_Escolar_2022.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2022.zip',
                       ano: '2022'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2021',
                       download: 'Cartão_Material_Escolar_2021.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2021.zip',
                       ano: '2021'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2020',
                       download: 'Cartão_Material_Escolar_2020.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2020.zip',
                       ano: '2020'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2019',
                       download: 'Cartão_Material_Escolar_2019.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2019.zip',
                       ano: '2019'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2018',
                       download: 'Cartão_Material_Escolar_2018.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2018.zip',
                       ano: '2018'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2017',
                       download: 'Cartão_Material_Escolar_2017.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2017.zip',
                       ano: '2017'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2016',
                       download: 'Cartão_Material_Escolar_2016.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2016.zip',
                       ano: '2016'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2015',
                       download: 'Cartão_Material_Escolar_2015.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2015.zip',
                       ano: '2015'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2014',
                       download: 'Cartão_Material_Escolar_2014.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2014.zip',
                       ano: '2014'
                     },
                     {
                       nome: 'Cartão Material Escolar - 2013',
                       download: 'Cartão_Material_Escolar_2013.zip',
                       url: URL_ARQUIVOS_PORTAL + 'Cartão_Material_Escolar_2013.zip',
                       ano: '2013'
                     }
                   ]
         },

    ],

}

        ];

        var selected = vm.sessoes.filter(function (sessao) {
            return sessao.id == $location.hash();
        })[0];

        if (selected) {
            vm.sessoes.forEach(function (sessao) {
                sessao.collapsed = sessao != selected;
            });
        }
    }

})();

/*eslint-disable */
(function () {
    'use strict';
  
    angular.module('portal').controller('EstatisticasController', EstatisticasController);

    /**
     * Controlador referente a tela de estatísticas.
     */
    /** @ngInject */
    function EstatisticasController($scope, EstatisticasService, $timeout) {

        var cardSet = {
            cards: [
                {
                    id: 'divNumUsuariosAtivos',
                    label: 'Usuários Ativos',
                    backgroundColor: '#1ED6D6'
                },{
                    id: 'divNumSessoes',
                    label: 'Sessões',
                    backgroundColor: '#0E7ECA'
                },{
                    id: 'divNumVisualizacoes',
                    label: 'Visualizações',
                    backgroundColor: '#65A0CE'
                },{
                    id: 'divTotalSessoesDesktop',
                    label: 'Sessões Desktop',
                    backgroundColor: '#229396'
                },{
                    id: 'divTotalSessoesMobile',
                    label: 'Sessões Mobile',
                    backgroundColor: '#1ED6D6'
                },{
                    id: 'divTotalSessoesNovosVisitantes',
                    label: 'Sessões Novos Visitantes',
                    backgroundColor: '#0E7ECA'
                },{
                    id: 'divTotalSessoesVisitantesRecorrentes',
                    label: 'Sessões Visitantes Recorrentes',
                    backgroundColor: '#65A0CE'
                }
            ],
            getValue: function(id) {
                return this._get(id).value;
            },
            setValue: function(id, value) {
                this._get(id).value = value;
            },
            _get: function(id) {
                return this.cards.filter(function(c) {
                    return c.id == id;
                })[0];
            }
        };
        $scope.cardSet = cardSet;

        var resouces = [
            {
                promise: EstatisticasService.obterVisitas(),
                consumer: function(data) {
                    cardSet.setValue('divTotalSessoesNovosVisitantes', data[1]);
                    cardSet.setValue('divTotalSessoesVisitantesRecorrentes', data[3]);
                }
            },{
                promise: EstatisticasService.obterDispositivos(),
                consumer: function(data) {
                    cardSet.setValue('divTotalSessoesDesktop', data[1]);
                    cardSet.setValue('divTotalSessoesMobile', data[3]);
                }
            },{
                promise: EstatisticasService.obterUsuariosAtivos(),
                consumer: function(data) {
                    cardSet.setValue('divNumUsuariosAtivos', data);
                }
            },{
                promise: EstatisticasService.obterSessoes(),
                consumer: function(data) {
                    cardSet.setValue('divNumSessoes', data);
                }
            },{
                promise: EstatisticasService.obterVisualizacoes(),
                consumer: function(data) {
                    cardSet.setValue('divNumVisualizacoes', data);
                }
            },{
                promise: EstatisticasService.obterPaginasPopulares(),
                consumer: function(data) {
                    $scope.paginas = data;
                }
            }
        ];

        $timeout().then(function() {
            resouces.forEach(function(resource) {
                loadResouce(resource.consumer, resource.promise);
            });
        });
    }

    /**
     * Carrega um recurso;
     * @param {*} consumer Consumer handler.
     * @param {*} promise Promise.
     */
    function loadResouce(consumer, promise) {
        promise.then(function(data) {
            consumer(data);
        });
    }

})();
/*eslint-disable */
(function () {
    'use strict';
  
    angular.module('portal').controller('EvolucaoAnualController', EvolucaoAnualController);

    /**
     * Controlador referente a seção de evolução anual de despesas e receitas da tela inicial.
     */
    /** @ngInject */
    function EvolucaoAnualController(BalancoService) {
        var self = this;

        self.loading = true;
        self.error = false;
        BalancoService.consultarBalanco().then(function(balanco) {
            self.balanco = balanco;
        }, function(err) {
            self.error = true;
        }).finally(function() {
            self.loading = false;
        });
    }

})();
/*eslint-disable */
(function(){
    'use strict';
  
    angular.module('portal').controller('FaleConoscoController', FaleConoscoController);
  
    /**
     * Controlador do modal referente a função FaleConosco.
     * @param {*} $scope Scope.
     */
    /** @ngInject */
    function FaleConoscoController($scope, $timeout, FaleConoscoService) {
        $scope.$timeout = $timeout;
        $scope.FaleConoscoService = FaleConoscoService;
        $scope.showErrorMessage = showErrorMessage;
        $scope.showSuccessMessage = showSuccessMessage;
        $scope.limparCampos = limparCampos;
        $scope.registrarMensagem = registrarMensagem;
        $scope.onClickBtnEnviar = onClickBtnEnviar;
    }

    /**
     * Responde ao evento de click no botão enviar.
     */
    function onClickBtnEnviar() {
        if (!this.nomeContato || !this.emailContato || !this.assuntoContato || !this.mensagemContato) {
            this.showErrorMessage('Você não preencheu um ou mais campos!');
            return;
        }

        this.loading = true;
        var self = this;

        this.registrarMensagem(this.nomeContato, this.emailContato, this.assuntoContato, this.mensagemContato)
            .then(function() {
                return self.$timeout(500);
            }).then(function() {
                self.showSuccessMessage('Agradecemos pelo seu contato!');
                self.limparCampos();
                self.$timeout(function() {
                    self.mensagemSucesso = null;
                }, 4000);
            }, function(err) {
                self.showErrorMessage('Houve um erro ao registrar sua mensagem.');
            }).finally(function() {
                self.loading = false;
            });
    }

    /**
     * Realiza o registro de uma mensagem.
     * @param {*} nome Nome do remetente.
     * @param {*} email E-mail do remetente.
     * @param {*} assunto Assunto.
     * @param {*} mensagem Mensagem.
     * @returns Promise correspondente a operação.
     */
    function registrarMensagem(nome, email, assunto, mensagem) {
        return this.FaleConoscoService.registrarMensagem({
            nome: nome,
            email: email,
            assunto: assunto,
            mensagem: mensagem
        });
    }

    /**
     * Apaga os campos do formulário.
     */
    function limparCampos() {
        delete this.nomeContato;
        delete this.emailContato;
        delete this.assuntoContato;
        delete this.mensagemContato;
    }

    /**
     * Apresenta um mensagem de erro.
     * @param {*} msg Mensagem.
     */
    function showErrorMessage(msg) {
        this.mensagemErro = msg;
        this.mensagemSucesso = null;
    }

    /**
     * Apresenta um mensagem de sucesso.
     * @param {*} msg Mensagem.
     */
    function showSuccessMessage(msg) {
        this.mensagemSucesso = msg;
        this.mensagemErro = null;
    }
  
})();
(function () {
  'use strict';

  angular.module('portal').controller('GlossarioController', GlossarioController);
	
	function GlossarioController($scope) {
		var vm = this;

		vm.alternarTab = function(filtro) {
			var letraInicial = filtro.substr(0,1).toUpperCase();

			vm.alfabeto.forEach(function(letter) {
				if (letter.letra == letraInicial) {
					vm.setActiveTab(letraInicial);
				}
			});
		};

		vm.setActiveTab = function(letter) {
			$scope.actionTab = letter;
		};

		vm.alfabeto = [{
				letra: "A",
				termos: [
				{
					termo: "Abertura de Crédito Adicional",
					significado: "Decreto do Poder Executivo determinando a disponibilidade do crédito orçamentário, com base em autorização legislativa específica."
				}, {
					termo: "Ação Governamental",
					significado: "Conjunto de operações, cujos produtos contribuem para os objetivos do programa governamental. A ação pode ser um projeto, atividade ou operação especial."
				}, {
					termo: "Acordos",
					significado: "Ajustes e Convênios, instrumentos legais para realização, em regime de mútua cooperação, de serviços de interesse recíproco dos órgãos e entidades da administração pública e outros particulares."
				}, {
					termo: "Adjudicação",
					significado: "Procuração dada a uma terceira parte, um agente fiduciário, que passa ter amplos direitos de liquidar seus ativos para satisfazer as reivindicações de credores. No processo licitatório, é a manifestação oficial pela proposta mais vantajosa."
				}, {
					termo: "Administração Direta",
					significado: "É aquela que se encontra integrada e ligada, na estrutura organizacional, diretamente ao chefe do Poder Executivo e legislativo."
				}, {
					termo: "Administração Financeira",
					significado: "É a atividade de administrar os recursos públicos. Abrange a captação de recursos pelo Estado, sua gestão e seu gasto para atender às necessidades da coletividade e do próprio Estado."
				}, {
					termo: "Administração Indireta",
					significado: "Conjunto de entidades públicas dotadas de personalidade jurídica própria,compreendendo: autarquias, empresas públicas, sociedades de economia mista, fundações públicas."
				}, {
					termo: "Administração Pública",
					significado: "Instrumento de Ação do Estado estabelecido com o propósito de possibilitar ocumprimento de suas funções básicas. Conjunto de processos por meio dos quaisos recursos públicos - materiais, humanos, financeiros e institucionais - são utilizados para a implementação das políticas públicas."
				}, {
					termo: "Administrador Público",
					significado: "Pessoa encarregada de gerir negócios públicos."
				}, {
					termo: "Agências Reguladoras",
					significado: "Instituídas como autarquias sob regime especial, são destinadas à execução de serviços públicos, para regulamentação de determinado setor da economia."
				}, {
					termo: "Agente Público",
					significado: "Pessoa física incumbida, definitiva ou transitoriamente, do exercício de alguma função estatal."
				}, {
					termo: "Ajuste Fiscal",
					significado: "Esforço para a redução de despesas e/ou aumento de receitas com a finalidade de se obter determinado patamar de resultado primário e/ou nominal, tendo em vista metas pré-definidas."
				}, {
					termo: "Alienação de Bens",
					significado: "Transferência de domínio de bens a terceiros."
				}, {
					termo: "Alíquota",
					significado: "Relação percentual entre o valor do imposto e o valor tributado; Percentual a ser aplicado sobre um determinado valor líquido tributável (base de cálculo), dando como resultado o valor do imposto a ser pago."
				}, {
					termo: "Alocar",
					significado: "Destinar recursos a um fim específico ou a uma entidade."
				}, {
					termo: "Amortização da Dívida",
					significado: "Despesas com o pagamento do principal e da atualização monetária e cambial referente a operações de crédito internas e externas contratadas."
				}, {
					termo: "Amortização de Empréstimo",
					significado: "Redução gradual de uma dívida por meio de pagamentos periódicos combinados entre o Credor e o devedor. Empréstimos bancários e hipotecas são, em geral, pagos dessa forma."
				}, {
					termo: "Ano Financeiro",
					significado: "Período de 1º de Janeiro a 31 de Dezembro."
				}, {
					termo: "Antecipação de Receita",
					significado: "Processo pelo qual o tesouro público pode contrair uma dívida por \"antecipação da receita prevista\", a qual será liquidada quando efetivada a entrada de numerário."
				}, {
					termo: "Anualidade do Orçamento",
					significado: "Princípio orçamentário que estabelece a periodicidade de um ano para as estimativas da receita e fixação da despesa, podendo coincidir ou não com o ano civil."
				}, {
					termo: "Anulação do Empenho",
					significado: "Cancelamento total ou parcial de importância empenhada."
				}, {
					termo: "Arrecadação",
					significado: "Segundo estágio da receita pública consiste no recebimento da receita pelo agente devidamente autorizado. Quando o Estado recebe dos contribuintes, através das repartições fiscais ou dos bancos autorizados, os valores que lhe são devidos, quer sejam multas, tributos ou qualquer outro crédito."
				}, {
					termo: "Atividade",
					significado: "Conjunto de operações que se realizam de modo contínuo e que concorrem para a manutenção da ação do governo."
				}, {
					termo: "Ativo",
					significado: "Compreende as aplicações de recursos, normalmente em bens e direitos."
				}, {
					termo: "Ativo Circulante",
					significado: "Disponibilidades de numerário, recursos a receber, antecipações de despesa, bem como outros bens e direitos pendentes ou em circulação, realizáveis até o término do exercício seguinte."
				}, {
					termo: "Ativo Compensado",
					significado: "Contas com função precípua de controle, relacionadas aos bens, direitos, obrigações e situações não compreendidas no patrimônio mas que, direta ou indiretamente, possam vir a afetá-lo, inclusive os referentes a atos e fatos administrativos da execução orçamentária."
				}, {
					termo: "Ativo Financeiro",
					significado: "Créditos e valores realizáveis independentemente de autorização orçamentária, bem como os valores numerários."
				}, {
					termo: "Ativo Patrimonial",
					significado: "Conjunto de valores e créditos que pertencem a uma entidade."
				}, {
					termo: "Ativo Permanente",
					significado: "Bens, créditos e valores cuja mobilização ou alienação dependa de autorização legislativa."
				}, {
					termo: "Ativo Realizável a Longo Prazo",
					significado: "Direitos realizáveis após o término do exercício seguinte."
				}, {
					termo: "Atos Administrativos",
					significado: "Medidas postas em prática para que a administração pública alcance seus objetivos."
				}, {
					termo: "Aumento Vegetativo da Receita",
					significado: "A quele que se verifica naturalmente, devido, via de regra, ao crescimento econômico, sem alteração das regras tributárias."
				}, {
					termo: "Autarquia",
					significado: "Entidade administrativa autônoma, descentralizada da Administração pública, criada por lei, com personalidade jurídica de direito público, patrimônio próprio e atribuições específicas para realizar os fins que a lei lhe determinar. No Distrito Federal: Departamento de Estradas de Rodagem, Serviço de Limpeza Urbana e Ajardinamento de Brasília."
				}, {
					termo: "Autarquia de Regime Especial",
					significado: "A quela a que a lei instituidora conferir privilégios específicos e aumentar a sua autonomia comparativamente com as autarquias comuns."
				}, {
					termo: "Autorização",
					significado: "Consentimento dado ao administrador para realizar determinada operação de receita ou de despesa pública."
				}, {
					termo: "Auxílios",
					significado: "Transferência a entidades públicas ou privadas sem fins lucrativos para a realização de despesas de capital, autorizadas na lei orçamentária."
				}, {
					termo: "Avaliação",
					significado: "Expressão de um julgamento ou juízo de valor, em termos qualitativos e/ou quantitativos, do resultado total ou parcial de um projeto, programa ou plano."
				}]
			}, {
				letra: "B",
				termos: [
				{
					termo: "Balancete",
					significado: "É a demonstração parcial dos resultados de órgão ou empresa num determinado período."
				}, {
					termo: "Balanço",
					significado: "Demonstrativo contábil que apresenta, num dado momento, a situação do patrimônio do ponto de vista orçamentário, financeiro ou patrimonial de uma empresa ou de uma entidade pública."
				}, {
					termo: "Balanço Financeiro",
					significado: "Demonstrará as receitas e as despesas orçamentárias bem como os recebimentos e os pagamentos de natureza extra-orçamentária, conjugados com os saldos, em espécie, provenientes do exercício anterior e os que se transferem para o exercício seguinte. Art. 103 da Lei da 4320/64."
				}, {
					termo: "Balanço Orçamentário",
					significado: "Demonstrativo contábil em que se confrontam num dado momento, as receitas e despesas previstas na lei orçamentária com as realizadas."
				}, {
					termo: "Balanço Patrimonial",
					significado: "Demonstrativo contábil em que se evidência, num dado momento, a situação patrimonial da entidade, compreendendo os bens e direitos (que compõem o ativo financeiro e o ativo permanente), as obrigações (que compõem o passivo financeiro e o passivo permanente) e as Contas de Compensação, em que serão registrados os bens, valores, obrigações e situações que, mediata ou imediatamente, possam afetar o patrimônio da entidade."
				}, {
					termo: "Benefícios Fiscais",
					significado: "São dispositivos previstos na legislação que permitem reduzir ou até mesmo suprimir o tributo a pagar. Podem apresentar-se sob diversas espécies, dentre as quais se destacam: imunidade, isenção, redução da base de cálculo, diferimento, crédito presumido, desconto por pagamento antecipado."
				}, {
					termo: "Bens Imóveis",
					significado: "(Jurídico) são os que por natureza ou por destino, não podem ser removidos de um lugar para outro sem perda de sua forma e substância."
				}, {
					termo: "Bens Móveis",
					significado: "(Jurídico) são os que podem ser removidos de um lugar para outro sem perda de sua forma e substância, como esculturas, mobiliário ou equipamentos."
				}, {
					termo: "Bens Semoventes",
					significado: "(Jurídico) são constituídos por animais selvagens, domesticados ou domésticos."
				}, {
					termo: "Bitributação",
					significado: "Ocorrência de dois tributos sobre a mesma base de cálculo."
				}, {
					termo: "Burocracia",
					significado: "Administração da coisa pública por funcionário (de ministério, de secretaria, repartições, etc.) sujeito a hierarquia e a regulamentos rígidos, e a uma rotina inflexível."
				}]
			}, {
				letra: "C",
				termos: [
				{
					termo: "Cadastro de Convênio",
					significado: "Cadastramento de convênios, bem como suas eventuais alterações."
				}, {
					termo: "Cadastro de Fornecedores",
					significado: "Registro detalhado dos prestadores de serviços e/ou fornecedores de material ao serviço público."
				}, {
					termo: "Carga Tributária",
					significado: "Totalidade de tributos que incidem sobre os contribuintes."
				}, {
					termo: "Cargo Público",
					significado: "Lugar criado no órgão para ser provido por agente que exercerá suas funções na forma legal. Conjunto de atribuições e responsabilidades previstas na estrutura organizacional que deve ser exercidas por um servidor."
				}, {
					termo: "Categoria Econômica",
					significado: "Classificação das receitas e despesas em operações correntes ou de capital, objetivando propiciar elementos para uma avaliação do efeito econômico das transações do setor público."
				}, {
					termo: "Caução",
					significado: "É a garantia dada ao cumprimento de obrigações."
				}, {
					termo: "Célula Orçamentária",
					significado: "É uma partição do Quadro de Detalhamento da Despesa, sendo composta por Esfera, Unidade Orçamentária, Programa de Trabalho, Fonte de Recursos e Natureza da Despesa."
				}, {
					termo: "CGDF",
					significado: "Controladoria-Geral do Distrito Federal."
				}, {
					termo: "Ciclo Orçamentário",
					significado: "Período compreendido entre a elaboração da proposta orçamentária e o encerramento do orçamento. Período de tempo necessário para que o orçamento esgote suas quatro fases: elaboração, aprovação, execução e controle."
				}, {
					termo: "Classificação Das Contas Públicas",
					significado: "A grupamento das contas públicas segundo a extensão e compreensão dos respectivos termos. Extensão de um termo é o conjunto dos indivíduos ou objetos designados por ele; compreensão desse mesmo termo é o conjunto das qualidades que ele significa, segundo a lógica formal. Qualquer sistema de classificação, Independiente do seu âmbito de atuação (receita ou despesa) constitui instrumento de planejamento, tomada de decisões, comunicação e controle."
				}, {
					termo: "Classificação Das Receitas Públicas",
					significado: "Agrupamento de contas de receitas públicas previstas na Lei nº 4.320, de 17 de Março de 1964, da forma que melhor as expressem. De acordo com o art. 11 da citada lei, \"A Receita classificar-se-á nas seguintes categorias econômicas: Receita Corrente e Receita de Capital\". A classificação também obedece a outro critério, que é por grupo de fontes."
				}, {
					termo: "Classificação Econômica da Despesa",
					significado: "Agrupamento da Despes apor categorias. Esse agrupamento é utilizado para facilitar e padronizar as informações que se deseja obter. Pela classificação é possível visualizar o Orçament opor Poder, por Funçã ode governo, por subfunção, por programa e por categoria econômica."
				}, {
					termo: "Classificação Funcional",
					significado: "Classificação da despesa segundo estrutura de funções e subfunções, que indicam as áreas de atuação do governo, como saúde, educação, transporte, entre outras. O código da classificação funcional compõe-se de cinco algarismos, sendo os dois primeiros reservados à função e os três últimos à subfunção."
				}, {
					termo: "Classificação Institucional",
					significado: "Evidencia a distribuição dos recursos orçamentários pelos órgãos e unidades orçamentárias responsáveis pela execução. O código da classificação institucional compõe-se de cinco algarismos, sendo os dois primeiros reservados à identificação do órgão e os três últimos à unidade orçamentária."
				}, {
					termo: "Classificação Orçamentária",
					significado: "Organização do orçamento segundo critérios que possibilitam a compreensão geral das funções deste instrumento, propiciando informações para a administração, a gerência e a tomada de decisões. No modelo orçamentário brasileiro são observadas as seguintes classificações Da Despesa: classificação institucional, classificação funcional programática e de natureza da despesa; a Receita: classificação por categorias econômicas e por grupo de fontes."
				}, {
					termo: "CNPJ (Cadastro Nacional de Pessoas Jurídicas)",
					significado: "O cadastro administrado pela Receita Federal do Brasil que registra as informações cadastrais das pessoas jurídicas e de algumas entidades não caracterizadas como tais. É um número que identifica uma pessoa jurídica (uma empresa, por exemplo), perante a Receita Federal. Sem ele a empresa não pode funcionar, abrir contas em bancos, comprar a crédito e etc."
				}, {
					termo: "Cobertura Orçamentária",
					significado: "Dotação orçamentária para atender as despesas provenientes da lei orçamentária ou créditos adicionais."
				}, {
					termo: "Código",
					significado: "Conjunto de dígitos utilizados para individualizar órgãos, instituições, classificações, fontes de recursos e outros."
				}, {
					termo: "Competência Tributária",
					significado: "Capacidade atribuída a uma entidade estatal para instituir, arrecadar e administrar tributos. É disciplinada e limitada pela Constituição, que define tributos de competência privativa ou concorrente da União, dos Estados, do Distrito Federal e dos Municípios."
				}, {
					termo: "Compra",
					significado: "Toda aquisição remunerada de bens e/ou serviços para fornecimento de uma só vez ou parceladamente."
				}, {
					termo: "Concessão de Garantia",
					significado: "Compromisso de adimplência de obrigação financeira ou contratual assumida por ente da Federação ou entidade a ela vinculada."
				}, {
					termo: "Concorrência",
					significado: "Modalidade de licitação entre quaisquer interessados que, na fase de habilitação, comprovem possuir os requisitos mínimos de qualificação exigidos no edital da licitação para a execução de seu objeto."
				}, {
					termo: "Concurso",
					significado: "Modalidade de licitação entre quaisquer interessados, para a escolha de trabalho técnico ou artístico, mediante a instituição de prêmio aos vencedores."
				}, {
					termo: "Conta Corrente Contábil",
					significado: "Representa o menor nível de desdobramento da estrutura de uma conta contábil, permitindo o controle individualizado dos saldos para os quais seja necessário maior detalhamento."
				}, {
					termo: "Conta Única do Distrito Federal",
					significado: "Regulamentada pelo Decreto n.º 17.895, de 10 de dezembro de 1996, e gerida pela Diretoria Geral de Administração Financeira/SUTES/SEF, tem a finalidade de acolher as disponibilidades financeiras do Governo do Distrito Federal, por meio do Sistema Integrado de Administração Financeira e Contábil - SIAC/DF."
				}, {
					termo: "Contabilidade",
					significado: "A ciência que estuda e controla o patrimônio, objetivando representá-lo graficamente, evidenciar suas variações, estabelecer normas para sua interpretação, análise e auditagem e servir como instrumento básico para a tomada de decisões de todos os setores direta ou indiretamente envolvidos com a empresa."
				}, {
					termo: "Contabilidade Pública",
					significado: "Ramo da contabilidade que estuda, controla e demonstra a organização e execução da Fazenda Pública, o patrimônio público e suas variações. Tem por objetivo captar, registrar, acumular, resumir e interpretar os fenômenos que afetam as situações orçamentárias, financeiras e patrimoniais das entidades de Direito Público Interno, por meio de metodologia especialmente concebida e utiliza-se de contas escrituradas nos sistemas Orçamentário, Financeiro, Patrimonial e de Compensação."
				}, {
					termo: "Contas Correntes Bancária",
					significado: "Contas mantidas pelas unidades gestoras junto a agências bancárias, destinadas à movimentação de seus recursos, quando houver necessidade de realização de operações que não possam ser efetuadas através da conta única."
				}, {
					termo: "Contas de Compensação",
					significado: "São contas que registram os valores que, direta ou indiretamente, possam vir a afetar o patrimônio."
				}, {
					termo: "Contenção ou Contingenciamento",
					significado: "Ato do Poder Executivo, limitando a realização da despesa orçamentária, visando assegurar o equilíbrio orçamentário, entre a execução das despesas e a disponibilidade efetiva de recursos."
				}, {
					termo: "Contragarantia",
					significado: "Bem ou direito do devedor, que pode ser assumido pelo garantidor, quando da ocorrência de inadimplência. É prevista contratualmente."
				}, {
					termo: "Contrapartida",
					significado: "Recursos que o devedor (ou convenente) se compromete, contratualmente, a aplicar em um determinado projeto. A cobertura de contrapartida pode efetivar-se por meio de outro empréstimo, receita própria ou dotação orçamentária."
				}, {
					termo: "Contrato",
					significado: "Acordo ou ajuste em que as partes tenham interesses diversos, normalmente opostos, transferindo entre si algum direito ou se sujeitando a alguma obrigação."
				}, {
					termo: "Contribuição de Melhoria",
					significado: "A cobrança de um determinado valor aos proprietários de imóveis beneficiados pela construção de obras públicas. Exemplo: calçamento, asfaltamento, saneamento, iluminação, etc."
				}, {
					termo: "Contribuinte",
					significado: "Aquele que tem obrigação de pagar um tributo porque realizou um ato que a lei definiu como causador do respectivo pagamento."
				}, {
					termo: "Controle da Execução Financeira",
					significado: "Voltado para a utilização dos recursos financeiros destinados a atender a realização dos projetos e/ou atividades atribuídos às unidades orçamentárias."
				}, {
					termo: "Controle da Execução Orçamentária",
					significado: "Compreende o controle da legalidade dos atos de que resultem arrecadação da receita ou realização da despesa e o nascimento ou a extinção de direitos e obrigações; da fidelidade funcional dos agentes da administração responsáveis por bens e valores públicos; e do cumprimento das metas estabelecidas para os programas de trabalho expressos em termos de aquisições, realizações de obras e prestações de serviços."
				}, {
					termo: "Controle Externo",
					significado: "Trata-se de controle, exercido pelo Poder Legislativo, destinando-se a comprovar a probidade dos atos da administração, a regularidade dos gastos públicos e do emprego de bens, valores e dinheiros públicos e a fiel execução da lei orçamentária. No Brasil, o controle externo exercido pelo Poder Legislativo conta com o auxilio do Tribunal de Contas. Fiscalização é exercida sobre os atos e atividades da administração pública, para que tais atos e atividades não se desviem das normas preestabelecidas."
				}, {
					termo: "Controle Interno",
					significado: "O acompanhamento e fiscalização orçamentária, financeira, contábil e patrimonial realizada pela entidade ou por Órgão de Controle Interno, dentro de um mesmo Poder, com o objetivo de assegurar economicidade, eficiência, legalidade, moralidade e publicidade na aplicação do dinheiro público. Por exemplo, qualquer controle efetivado pelo Poder Executivo sobre seus próprios serviços ou agentes é considerado interno."
				}, {
					termo: "Controle Social",
					significado: "É a participação da sociedade no acompanhamento e verificação das ações da gestão pública na execução das políticas públicas, avaliando os objetivos, processos e resultados. O Controle Social das ações dos governantes e funcionários públicos é importante para assegurar que os recursos públicos sejam bem empregados em benefício da coletividade."
				}, {
					termo: "Convênio",
					significado: "Instrumento utilizado para formalização do acordo de vontades entre entidades do setor público e, ocasionalmente, entre entidades do setor público e instituições do setor privado, com vistas à realização de programas de trabalho ou de eventos de interesse recíproco, em regime de mútua cooperação."
				}, {
					termo: "Convite",
					significado: "Modalidade de licitação entre interessados dos ramos pertinentes ao seu objeto, cadastrados ou não, escolhidos e convidados em número mínimo de três pela unidade administrativa, desde que o montante do fornecimento não exceda ao valor fixado em lei. O edital deve ser afixado em local apropriado e a extensão do convite é obrigatória aos interessados que se manifestarem até vinte e quatro horas antes do prazo para apresentação das propostas."
				}, {
					termo: "Correção Monetária",
					significado: "É a atualização de valores econômicos com a finalidade de compensar a desvalorização da moeda."
				}, {
					termo: "Cotação de Preços",
					significado: "A cotação é um procedimento simplificado adotado para compras de pequeno valor, que são dispensadas de licitação."
				}, {
					termo: "Créditos Adicionais",
					significado: "São autorizações de despesas públicas não computadas ou insuficientemente dotadas no orçamento. Classificam-se em três espécies: suplementares, especiais e extraordinários."
				}, {
					termo: "Créditos Especiais",
					significado: "São os destinados a despesas para as quais não haja dotação orçamentária específica, sendo autorizado por lei e aberto, por decreto do Executivo."
				}, {
					termo: "Créditos Extraordinários",
					significado: "São os destinados ao atendimento de despesas urgentes e imprevisíveis, em caso de guerra, subversão interna ou calamidade pública."
				}, {
					termo: "Créditos Orçamentários",
					significado: "São as autorizações decorrentes da lei orçamentária para aplicação de recursos, discriminados conforme as classificações orçamentárias."
				}, {
					termo: "Créditos Suplementares",
					significado: "São os destinados à reforços de dotações já programadas no orçamento. É autorizado por decreto do Executivo se observados os limites fixados na lei orçamentária."
				}, {
					termo: "Credor",
					significado: "Todo aquele que tem um valor a receber da Administração Pública."
				}, {
					termo: "Cronograma de Desembolso",
					significado: "Instrumento pelo qual a unidade orçamentária programa, no tempo, o pagamento das despesas autorizadas na lei orçamentária."
				}]
			}, {
				letra: "D",
				termos: [
				{
					termo: "Decreto",
					significado: "Ato ou resolução emanada de um órgão do poder público competente, com força obrigatória, destinado a assegurar ou promover a boa ordem política, social, jurídica, administrativa, ou a reconhecer, proclamar e atribuir um direito, estabelecido em lei, decreto legislativo, decreto do Congresso, decreto judiciário ou judicial."
				}, {
					termo: "Dedução (Abatimento)",
					significado: "Abater, diminuir, reduzir, extrair."
				}, {
					termo: "Déficit",
					significado: "É um saldo negativo que resultou de mais gastos ou despesas do que ganhos ou receitas."
				}, {
					termo: "Déficit Financeiro",
					significado: "Resultado da maior saída de numerário do caixa de uma entidade, em relação à entrada, em determinado período de tempo."
				}, {
					termo: "Déficit Fiscal",
					significado: "Ocorre quando o total das receitas arrecadadas com impostos é menor do que as despesas do Governo."
				}, {
					termo: "Déficit Orçamentário",
					significado: "Despesa maior do que receita, havendo distinção entre déficit previsto e o déficit da execução orçamentária."
				}, {
					termo: "Déficit Orçamentário Bruto",
					significado: "Diferença entre as receitas e as despesas de um orçamento público, não se considerando, nas receitas de capital, as operações de crédito a serem contratadas para o financiamento do déficit."
				}, {
					termo: "Déficit Patrimonial",
					significado: "Quando a soma do ativo de uma entidade for menor que a soma do seu passivo."
				}, {
					termo: "Déficit Público",
					significado: "É a situação em que o Governo, num determinado período de tempo ou exercício, gasta mais do que arrecada."
				}, {
					termo: "Déficit Rimário",
					significado: "Quando as despesas do Governo, excluindo-se os gastos com juros das dívidas interna e externa, são maiores do que sua arrecadação."
				}, {
					termo: "Depósitos",
					significado: "Representam os montantes dos débitos relativos a recebimentos feitos a título de depósitos, como consignações em folhas, fianças, cauções e outras."
				}, {
					termo: "Depreciação",
					significado: "Conceito de natureza contábil, sendo o custo ou a despesa decorrentes do desgaste ou da obsolescência dos ativos imobilizados (máquinas, veículos, móveis, imóveis e instalações). pelo qual se apropriam no balanço patrimonial as parcelas de redução no valor dos ativos."
				}, {
					termo: "Descentralização de Créditos",
					significado: "Transferência de uma unidade gestora para outra, do poder de utilizar créditos orçamentários que lhe tenham sido dotados."
				}, {
					termo: "Despesa Empenhada",
					significado: "Corresponde à primeira fase da despesa, que é o ato da autoridade competente que cria para o Estado, obrigação de pagamento pendente ou não de implemento de condição."
				}, {
					termo: "Despesa Extra-Orçamentária",
					significado: "É a despesa que não está prevista no orçamento, pois não é uma despesa do governo. Refere-se a pagamentos de valores que estavam sob guarda do Estado, a exemplo de retenções de contrições previdenciárias, de retenções contratuais e outras."
				}, {
					termo: "Despesa Liquidada ou Processada",
					significado: "Corresponde a segunda fase da despesa, momento em que há o reconhecimento pelo poder público da realização da despesa e, por conseqüência, o direito do fornecedor do bem ou serviço, em receber o valor contratado."
				}, {
					termo: "Despesa Não Processada",
					significado: "E aquela cujo empenho foi legalmente emitido e que depende da fase de liquidação, ou seja, do reconhecimento da correspondente despesa."
				}, {
					termo: "Despesa Orçamentária",
					significado: "É o gasto realizado pelo governo depois de aprovado pelo poder Legislativo. Chama-se orçamentária porque a Despesa está prevista no Orçamento do governo."
				}, {
					termo: "Despesa Pública<",
					significado: "Gasto feito pelo governo. Tudo aquilo que o governo se propôs a fazer através de um programa, quando for realizado, será anotado como uma despesa pública. Para ser realizado esse gasto deve ter sido previsto no orçamento que foi autorizado pelo poder legislativo."
				}, {
					termo: "Despesas Correntes",
					significado: "Constitui o Grupo de Despesas da Administração Pública para manutenção e o funcionamento dos serviços públicos, em geral."
				}, {
					termo: "Despesas de Capital",
					significado: "Constituem o grupo de despesas da Administração Pública com intenção de adquirir ou constituir bens de capital que contribuirão para a produção ou geração de novos bens ou serviços e integrarão o patrimônio público, como: ruas, rodovias, prédios, projeções, praças, parques, jardins, etc."
				}, {
					termo: "Despesas de Custeio",
					significado: "Aquela necessária à manutenção da ação governamental e à prestação de serviço público."
				}, {
					termo: "Despesas de Exercícios Anteriores",
					significado: "As relativas a exercícios encerrados, para as quais existia crédito próprio e dotação suficiente nos respectivos orçamentos, mas que não foram processadas na época devida."
				}, {
					termo: "Destaque de Crédito",
					significado: "Transferência, de um órgão para outro, da atribuição de executar o crédito orçamentário que lhe foi consignado pela lei orçamentária anual ou por lei que a altere."
				}, {
					termo: "Dívida",
					significado: "Compromisso financeiro assumido perante terceiro."
				}, {
					termo: "Dívida Ativa",
					significado: "É a inscrição que se faz em conta de devedores, relacionadas a tributos, multas e créditos da Fazenda Pública, lançados mas não cobrados ou não recolhidos no exercício de origem. (art. 39, Lei nº 4.320, de 17 de março de 1964)."
				}, {
					termo: "Dívida Externa Pública",
					significado: "Compromissos assumidos pela União ou por entidade pública com a garantia da União junto a instituições financeiras com sede no exterior que geram a obrigação de pagamento do principal, juros e encargos acessórios em moeda estrangeira."
				}, {
					termo: "Dívida Flutuante",
					significado: "A legalmente contraída pelo Ente público, sem exigência de autorização legislativa específica, para atender às momentâneas necessidades de caixa e que deve ser liquidada em até doze meses. Segundo a Lei nº 4.320/64, compreende os restos a pagar, os serviços da dívida a pagar, os depósitos de terceiros (cauções e garantias) e os débitos de tesouraria."
				}, {
					termo: "Dívida Fundada",
					significado: "Compromissos de exigibilidade superior a doze meses, contraídos para atender a desequilíbrio orçamentário ou a financiamento de obras e serviços públicos. Dívida Interna Pública Compromissos assumidos por entidade pública dentro do país, portanto, em moeda nacional."
				}, {
					termo: "Dívida Interna",
					significado: "São os débitos do Governo adquiridos através de empréstimos e financiamentos com entidades financeiras de seu próprio país."
				}, {
					termo: "Dívida Mobiliária",
					significado: "É um débito que o Governo adquiriu através da colocação de títulos no mercado, com a promessa de pagá-los posteriormente."
				}, {
					termo: "Dívida Pública",
					significado: "Dívida contraída pelo governo com o objetivo de financiar gastos não cobertos com a arrecadação de impostos."
				}, {
					termo: "Documentos Fiscais",
					significado: "São documentos emitidos obrigatoriamente quando do fornecimento de mercadorias e bens ou quando da prestação de serviços."
				}, {
					termo: "Dotação",
					significado: "Limite de crédito consignado na lei do orçamento ou em crédito adicional, para atender determinada despesa."
				}]
			}, {
				letra: "E",
				termos: [
				{
					termo: "Efetividade",
					significado: "Dimensão do desempenho de uma entidade pública ou privada que representa a relação entre os resultados alcançados (impactos observados) e os objetivos (impactos esperados) que motivaram a atuação institucional."
				}, {
					termo: "Eficiência",
					significado: "Termo originado nas Ciências Econômicas que significa a menor relação custo/benefício possível para o atingimento dos objetivos estabelecidos no programa."
				}, {
					termo: "Elaboração Orçamentária",
					significado: "Processo de preparação e aprovação do Orçamento de um ente político (União, Estados e Municípios). Envolve a preparação anual, pelo Poder Executivo, do projeto da lei orçamentária (abrangendo inclusive as propostas orçamentárias dos demais Poderes, centralizadas pelo Poder Executivo em sua função administrativa), seguida de seu envio ao Poder Legislativo para discussão, alteração e aprovação."
				}, {
					termo: "Elemento de Despesa ou Objeto de Gasto",
					significado: "Entende-se por elemento o desdobramento da despesa com pessoal, material, serviços, obras e outros meios de que se serve a administração pública para a consecução dos seus fins."
				}, {
					termo: "Empenho da Despesa",
					significado: "Um dos estágios da despesa. Constitui o ato emanado de autoridade competente, que cria para o estado obrigação de pagamento pendente ou não de implemento de condição (artigo 58 da Lei Federal nº. 4.320, de 17 de março de 1964). Funciona como garantia ao credor do ente público de que existe o crédito necessário para a liquidação de um compromisso assumido."
				}, {
					termo: "Empenho Global",
					significado: "Modalidade de empenho da despesa destinado a atender despesa com finalidade determinada e quantificada, mas cuja liquidação e pagamento deva ocorrer em várias parcelas no decorrer do exercício na medida em que partes ou etapas pré-definidas da obrigação sejam cumpridas. Modalidade excepcional prevista no artigo 60, § 3º, da Lei Federal nº. 4.320, de 17 de março de 1964."
				}, {
					termo: "Empenho Ordinário",
					significado: "Modalidade de empenho relativa aos gastos com finalidade determinada, de valor previamente conhecido e que deva ser liquidado e pago de uma única vez. Modalidade geral do empenho, tal como previsto nos artigos 58 a 60 da Lei Federal nº. 4.320, de 17 de março de 1964."
				}, {
					termo: "Empenho por Estimativa",
					significado: "Modalidade de empenho da despesa destinado a atender despesa, cujo montante não possa ser determinado com antecedência, ocorrendo tipicamente em despesas de caráter repetitivo e de valor variável (ex: tarifas água, energia elétrica e telefonia; despesas com combustíveis e cópias de documentos, cujo valor exato não é passível de ser previsto com antecedência, a despeito da relativa regularidade com que ocorrem). Modalidade excepcional prevista no artigo 60, § 2º, da Lei Federal nº. 4.320, de 17 de março de 1964."
				}, {
					termo: "Empresa Controlada",
					significado: "Sociedade empresarial cuja maioria do capital social com direito a voto pertença, direta ou indiretamente, a ente da Federação, podendo revestir-se de qualquer das formas previstas na legislação societária. Conceito estabelecido pelo art. 2º, inc. II, da Lei de Responsabilidade Fiscal (Lei Complementar Federal nº. 101, de 04 de maio de 2000)."
				}, {
					termo: "Empresa Estatal",
					significado: "Entidade com personalidade jurídica de Direito Privado, com patrimônio público ou misto, para a prestação de serviço público ou para a execução de atividade econômica de natureza privada. O patrimônio dessas empresas é constituído com recursos públicos (na empresa pública) ou públicos e particulares (no caso da sociedade de economia mista)."
				}, {
					termo: "Empresa Estatal Dependente",
					significado: "Empresa controlada que receba do ente controlador recursos financeiros para pagamento de despesas com pessoal ou de custeio em geral ou de capital, excluídos, no último caso, aqueles provenientes de aumento de participação acionária. Conceito estabelecido pelo art. 2º, inc. III, da Lei de Responsabilidade Fiscal (Lei Complementar Federal nº. 101, de 04 de maio de 2000)."
				}, {
					termo: "Empresa Pública",
					significado: "Entidade empresarial, com personalidade jurídica de direito privado e participação única do Poder Público no seu capital e direção, na forma da lei, sendo de propriedade única do Estado. É pessoa jurídica de direito privado, sem privilégios estatais, salvo as prerrogativas que a lei especificar em cada caso particular, para a realização das atividades desejadas pelo Poder Público."
				}, {
					termo: "Encargos da Dívida",
					significado: "Designação genérica atribuída aos juros, taxas, comissões e outros encargos decorrentes de empréstimos e financiamentos internos ou externos, mas sem incluir os gastos com a amortização do principal. Este conceito não deve ser confundido com o de \"Serviço da Dívida\" que inclui também os gastos com a amortização do principal."
				}, {
					termo: "Encargos de Financiamento",
					significado: "Juros, taxas e comissões pagos ou a pagar, decorrentes de financiamentos internos ou externos."
				}, {
					termo: "Encargos Especiais",
					significado: "Modalidade de função que classifica as despesas em relação às quais não se pode associar um bem ou serviço a ser gerado no processo produtivo corrente do setor público, tais como: dívidas, ressarcimentos, indenizações e outras afins, representando uma agregação neutra. Trata-se, portanto, de despesas que não se destinam à prestação de serviços finalísticos pelo ente público."
				}, {
					termo: "Encargos Sociais",
					significado: "Taxas e contribuições pagas pelo empregador para financiamento das políticas públicas que trazem, indiretamente, benefícios ao trabalhador. Ex: FGTS, PIS/PASEP, etc."
				}, {
					termo: "Equilíbrio Orçamentário",
					significado: "Característica dos orçamentos em que contabilmente as receitas igualam-se às despesas."
				}, {
					termo: "Erário",
					significado: "Tesouro ou Fazenda Pública."
				}, {
					termo: "Esfera Orçamentária",
					significado: "Especifica se a dotação orçamentária pertence ao orçamento fiscal, orçamento da seguridade social ou orçamento de investimento."
				}, {
					termo: "Estágios da Despesa Pública",
					significado: "São as etapas ou operações que as entidades responsáveis pela despesa pública devem realizar ou percorrer para que a mesma seja realizada. Os estágios da execução despesa são: empenho, liquidação e pagamento."
				}, {
					termo: "Estágios da Receita Pública",
					significado: "São as etapas ou operações que as entidades responsáveis pela receita pública devem realizar ou percorrer para que a mesma seja materializada. Os estágios da execução da receita são: lançamento, arrecadação e recolhimento."
				}, {
					termo: "Estimativa da Receita",
					significado: "A estimativa da receita é realizada visando determinar antecipadamente o volume de recursos a ser arrecadado num dado exercício financeiro, possibilitando uma programação orçamentária equilibrada. É essencial o acompanhamento da legislação específica de cada receita onde são determinados os elementos indispensáveis à formulação de modelos de projeção, como a base de cálculo, as alíquotas e os prazos de arrecadação."
				}, {
					termo: "Etapa",
					significado: "Cada uma das partes estabelecidas para fornecimentos, obras ou serviços, em relação aos prazos ou cronogramas contratuais."
				}, {
					termo: "Evasão Fiscal",
					significado: "Se dá pelo não pagamento parcial ou total do tributo."
				}, {
					termo: "Evento",
					significado: "É o instrumento utilizado pelas Unidades Gestoras no preenchimento dos documentos de entrada no Sistema de Gestão Governamental do Distrito Federal, para transformar os atos e fatos administrativos em registros contábeis automáticos."
				}, {
					termo: "Excesso de Arrecadação",
					significado: "Saldo positivo das diferenças acumuladas mês a mês, entre a arrecadação prevista e a realizada, considerando-se a tendência do exercício, devendo ser deduzido o montante dos créditos extraordinários abertos no exercício."
				}, {
					termo: "Execução Orçamentária da Despesa",
					significado: "Utilização dos créditos consignados no orçamento do ente público e nos créditos adicionais, visando à realização das missões atribuídas às unidades orçamentárias."
				}, {
					termo: "Execução Orçamentária da Receita",
					significado: "Ato de fazer cumprir o Orçamento observando a previsão orçamentária, a importância efetivamente arrecadada e o excesso ou a insuficiência de arrecadação sobre o previsto."
				}, {
					termo: "Executor",
					significado: "Pessoa física ou órgão público designado para supervisionar, fiscalizar e acompanhar a execução de convênios, contratos ou outros ajustes."
				}, {
					termo: "Exercício Financeiro",
					significado: "Período correspondente à execução orçamentária. No Brasil coincide com o ano civil."
				}, {
					termo: "Exigível a Longo Prazo",
					significado: "Obrigações exigíveis normalmente após o término do exercício seguinte."
				}]
			}, {
				letra: "F",
				termos: [
				{
					termo: "Fato Gerador",
					significado: "Fato, ou o conjunto de fatos, ou o estado de fato, a que o legislador vincula o nascimento de obrigações jurídicas de pagar tributo determinado."
				}, {
					termo: "Fazenda Pública",
					significado: "Conjunto de órgãos da administração pública destinados à arrecadação e à fiscalização de tributos; 2. Erário; 3. Fisco."
				}, {
					termo: "Finanças Públicas",
					significado: "Abrangem a captação de recursos pelo Estado, sua gestão e seu gasto para atender às necessidades da coletividade e do próprio Estado."
				}, {
					termo: "Fonte de Recursos",
					significado: "Classificação da receita segundo a destinação legal dos recursos arrecadados. As fontes de recursos constituem-se de determinados agrupamentos de naturezas de receitas, atendendo a uma determinada regra de destinação legal, e servem para indicar como são financiadas as despesas orçamentárias."
				}, {
					termo: "Função Pública",
					significado: "Conjunto de encargos atribuídos aos órgãos, cargos e agentes públicos. 2. Toda atividade, temporária ou permanente, remunerada ou honorária realizada por uma pessoa física em nome do Estado ou a serviço do Estado ou de suas entidades, em qualquer de seus níveis hierárquicos."
				}, {
					termo: "Fundação Pública",
					significado: "Entidade dotada de personalidade jurídica de direito privado, sem fins lucrativos, criada por lei para o desenvolvimento de atividades que não exijam execução por órgãos ou entidades de direito público, com autonomia administrativa, patrimônio próprio, e funcionamento custeado, basicamente, por recursos do Poder Público, ainda que sob forma de prestação de serviços."
				}, {
					termo: "Fundo",
					significado: "Conjunto de recursos monetários empregados como reserva ou para cobrir despesas extraordinárias. No setor de finanças públicas, o termo refere-se às verbas destinadas ao desenvolvimento de determinados setores."
				}, {
					termo: "Fundo Especial",
					significado: "Constitui fundo especial, o produto de receitas especificadas que, por lei, vinculam se à realização de determinados objetivos ou serviços, facultada a adoção de normas peculiares de aplicação."
				}]
			}, {
				letra: "G",
				termos: [
				{
					termo: "Gestão",
					significado: "Ato de gerir a parcela do patrimônio público, sob a responsabilidade de uma determinada unidade gestora."
				}, {
					termo: "Gestão Tesouro",
					significado: "Gestão dos recursos previstos para os órgãos da administração direta. "
				}, {
					termo: "Gestor",
					significado: "Quem gere ou administra negócios, bens ou serviços."
				}, {
					termo: "Grupo de Natureza da Despesa",
					significado: "Classificação da despesa agregando elementos de despesa com as mesmas características quanto ao objeto de gasto."
				}, {
					termo: "Guia de Recebimento (GR)",
					significado: "Documento destinado ao registro da arrecadação de receitas próprias e ao recolhimento de depósitos de diversas origens."
				}]
			}, {
				letra: "H",
				termos: [
				{
					termo: "Hierarquia",
					significado: "Relação de subordinação existente entre os vários órgãos e agentes, com a distribuição de funções e a gradação da autoridade de cada um."
				}, {
					termo: "Homologação",
					significado: "A provação dada por autoridade judicial ou administrativa a certos atos particulares para que produzam os efeitos jurídicos que lhe são próprios."
				}]
			}, {
				letra: "I",
				termos: [
				{
					termo: "ICMS",
					significado: "Imposto sobre operações relativas à circulação de mercadorias e sobre prestações de serviços de transporte interestadual, intermunicipal e de comunicação é de competência dos Estados e do Distrito Federal."
				}, {
					termo: "Impostos",
					significado: "É a quantia em dinheiro paga obrigatoriamente por pessoas ou organizações, a partir de ocorrência de um fato gerador, calculada mediante aplicação de uma alíquota a uma base de cálculo."
				}, {
					termo: "Impostos Diretos",
					significado: "Tributos que incidem diretamente sobre a riqueza dos contribuintes."
				}, {
					termo: "Impostos Indiretos",
					significado: "Tributos que os contribuintes podem transferir o ônus da contribuição, total ou parcialmente, para terceiros."
				}, {
					termo: "Imunidade",
					significado: "Espécie de desoneração do imposto sempre que feita indicação de não incidência e isenção no texto da Constituição da República."
				}, {
					termo: "Incentivo Fiscal",
					significado: "Subsídio concedido pelo governo, na forma de renúncia de parte de sua receita com impostos, em troca do investimento em operações ou atividades por ele estimuladas."
				}, {
					termo: "Incidência",
					significado: "Campo de abrangência do fato tributário, com a determinação de sobre quem recai o ônus tributário."
				}, {
					termo: "Indicadores Econômicos",
					significado: "Conjunto de dados estatísticos, passíveis de mudança e oscilações, capaz de dar uma idéia do estado de uma economia em determinado período ou data. Índice, relação entre os valores de qualquer medida ou gradação."
				}, {
					termo: "Inexigibilidade de Licitação",
					significado: "Modalidade que a Lei de Licitações desobriga a Administração de realizar o procedimento licitatório, por inviabilidade de competição. Se não há competidores, não é necessária a licitação. As contratações mais comuns são aquelas em que a Administração só encontra um fornecedor ou o representante comercial é exclusivo. A lista prevista na lei é apenas exemplificativa. (art. 25 da Lei nº 8.666/1993)."
				}, {
					termo: "Ingresso Extra-Orçamentário",
					significado: "É o dinheiro que entra nos cofres do governo mas não lhe pertence. Esse dinheiro apenas \"passa\" pelo governo para ser transferido para alguém. O governo não pode contar com esse dinheiro."
				}, {
					termo: "Ingresso Orçamentário",
					significado: "São aqueles pertencentes ao ente público arrecadados para aplicação em programas em ações governamentais."
				}, {
					termo: "Ingressos Públicos ou Entradas",
					significado: "Importâncias em dinheiro, a qualquer título, recebidas pelos cofres públicos. Nem todos os ingressos constituem receitas públicas, uma vez que alguns se caracterizam como simples movimentos de fundos, isto é, não se incorporam ao patrimônio do Estado, uma vez que suas entradas condicionam-se a uma restituição posterior."
				}, {
					termo: "Inscrição Genérica",
					significado: "É um conta corrente/código utilizado para o caso de credores ou devedores que não possuam CGC ou CPF, visando identificar ou individualizar o registro contábil de acordo com a necessidade."
				}, {
					termo: "Inversões Financeiras",
					significado: "Dotações destinadas à aquisição de imóveis, ou bens de capital já em utilização; a títulos financeiros e à constituição ou aumento do capital de entidades ou empresas, inclusive às operações bancárias ou de seguros."
				}, {
					termo: "Investimentos",
					significado: "Despesas de capital destinadas ao planejamento e à execução de obras públicas, à realização de programas especiais de trabalho e à aquisição de instalações, equipamento e material permanente."
				}, {
					termo: "IPTU",
					significado: "Imposto Predial e Territorial Urbano. É um imposto brasileiro instituído pela Constituição Federal cuja incidência se dá sobre a propriedade urbana."
				}, {
					termo: "IPVA",
					significado: "Imposto sobre a Propriedade de Veículos Automotores. É um tributo estadual pago anualmente pelo proprietário de todo e qualquer veículo automotor ao qual seja exigido emplacamento. Do total arrecadado, 50% cabe ao Estado e 50% ao Município onde ocorreu o emplacamento."
				}, {
					termo: "Isenção",
					significado: "Favor fiscal concedido por lei, que consiste em dispensar o contribuinte do pagamento do um tributo devido. Na isenção, a obrigação de pagar o tributo existe, mas foi dispensada. Na imunidade, essa obrigação inexiste."
				}, {
					termo: "ISS (ou ISSQN)",
					significado: "IMPOSTO SOBRE SERVIÇOS DE QUALQUER NATUREZA - Impostos de competência dos Municípios e do Distrito Federal. Tem previsão constitucional (art. 155, III) com regras gerais de alcance nacional na Lei Complementar nº 116/03."
				}, {
					termo: "Item ou Objeto de Gasto",
					significado: "É o detalhamento da despesa. Por exemplo, existe um grupo de despesa que é material de consumo."
				}]
			}, {
				letra: "J",
				termos: [
				{
					termo: "Juros Contratuais",
					significado: "São os juros expressos nas cláusulas do contrato."
				}, {
					termo: "Juros e Encargos da Dívida",
					significado: "Grupo de natureza de despesa no qual são orçados o adimplemento de juros, comissões, dívida pública mobiliária e despesas com operações de crédito internas e externas."
				}, {
					termo: "Juros Nominais",
					significado: "Os juros nominais são aqueles que compreendem toda a remuneração que incide sobre a dívida, incluindo-se a atualização monetária, e podem ser obtidos por dois critérios básicos: caixa e competência."
				}, {
					termo: "Juros Reais",
					significado: "São os valores apropriados ou pagos a título de juros nominais acrescidos do deságio existente na emissão e da atualização monetária do título, porém descontados os efeitos da inflação (atualmente esta é dada pela variação do IGP-M)."
				}, {
					termo: "Juros Sobre a Dívida por Contrato",
					significado: "Despesas com juros referentes a operações de crédito (internas e externas) efetivamente contratadas e parcelamento de dívidas reconhecidas."
				}]
			}, {
				letra: "L",
				termos: [
				{
					termo: "Lançamento",
					significado: "Primeiro estágio na execução da receita. Ato na repartição competente que reconhece o crédito e inscreve o débito, indentificando o valor e devedor."
				}, {
					termo: "Lei de Diretrizes Orçamentárias (LDO)",
					significado: "Lei que compreende as metas e prioridades da Administração Pública, incluindo as despesas de capital para o exercício financeiro subseqüente, orienta a elaboração da Lei Orçamentária Anual, dispõe sobre as alterações na legislação tributária e estabelece a política de aplicação das agências financeiras oficiais de fomento."
				}, {
					termo: "Lei de Licitações",
					significado: "Lei nº 8.666, de 1993, que regulamenta o art. 37, inciso XXI, da Constituição Federal e institui normas para licitações e contratos da Administração Pública e dá outras providências."
				}, {
					termo: "Lei de Responsabilidade Fiscal (LRF)",
					significado: "Define as responsabilidades e deveres do administrador público em relação aos orçamentos da União, dos estados e dos municípios, bem como os limites de gastos com pessoal, proibindo a criação de despesas de duração continuada sem uma fonte segura de receitas. Introduziu restrições orçamentárias na legislação brasileira e criou a disciplina fiscal para os três poderes, Executivo, Legislativo e Judiciário."
				}, {
					termo: "Lei Orçamentária Anual (LOA)",
					significado: "Lei especial que contém a discriminação da receita e da despesa Pública, de forma a evidenciar a política econômica financeira e o programa de trabalho do governo, obedecidos os princípios da unidade, universalidade e anualidade."
				}, {
					termo: "Leilão",
					significado: "Modalidade de licitação entre quaisquer interessados para a venda de bens inservíveis para a administração ou de produtos legalmente apreendidos, a quem oferecer maior lance, igual ou superior ao da avaliação."
				}, {
					termo: "Limite Financeiro",
					significado: "Parcela de recursos que o órgão central de programação financeira, no caso do Distrito Federal, a Secretaria de Fazenda, coloca à disposição da unidade gestora. Tem por objetivo fixar as autorizações máximas para que as unidades executoras possam realizar liquidação e respectivos pagamentos."
				}, {
					termo: "Liquidação da Despesa",
					significado: "Verificação do direito adquirido pelo credor, tendo por base os títulos e documentos comprobatórios do respectivo crédito."
				}, {
					termo: "Liquidez",
					significado: "Grau de agilidade na conversão de um investimento em dinheiro, sem perda significativa de valor. Um investimento tem maior liquidez, quanto mais fácil for a conversão em dinheiro e quanto menor for a perda de valor envolvida nesta transação."
				}]
			}, {
				letra: "M",
				termos: [
				{
					termo: "Material de Consumo",
					significado: "Aquele que, em razão de seu uso corrente e da definição da Lei n° 4.320/64, perde normalmente sua identidade física e/ou tem sua utilização limitada a dois anos."
				}, {
					termo: "Material Permanente",
					significado: "Aquele que, em razão de seu uso corrente, não perde a sua identidade física e/ou tem uma durabilidade superior a dois anos. MEDIÇÃO -V erificação das quantidades das obras ou serviços executados em cada etapa contratual."
				}, {
					termo: "Medida Provisória (MP)",
					significado: "Instrumento legal, previsto na Constituição Federal, de uso exclusivo do Presidente da República e com força de lei. As medidas provisórias podem ser usadas em casos de relevância e urgência, devendo ser submetidas de imediato ao Congresso Nacional, e aprovadas em um prazo máximo de 30 dias. Casos contrários perdem eficácia, a partir da data da sua publicação, se não forem republicadas."
				}, {
					termo: "Meta",
					significado: "Dado que dimensiona a ação, ou seja, é o objetivo quantificado em termos de produto e resultados a alcançar."
				}, {
					termo: "Modalidade de Aplicação",
					significado: "Classificação da natureza da despesa que traduz a forma como os recursos serão aplicados pelos órgãos/entidades, podendo ser diretamente pelos mesmos ou sob a forma de transferências a outras entidades públicas ou privadas que se encarregarão da execução das ações."
				}, {
					termo: "Multa",
					significado: "Pena pecuniária imposta ao contribuinte ou fornecedor de bens e serviços ao governo."
				}]
			}, {
				letra: "N",
				termos: [
				{
					termo: "Natureza da Despesa",
					significado: "Os arts. 12 e 13 da Lei nº 4.320, de 1964, tratam da classificação da despesa por categoria econômica e elementos. No processo de elaboração do orçamento e de sua execução, exceto de liquidação e o de pagamento, o código de classificação da natureza da despesa é constituído por 6 (seis) algarismos."
				}, {
					termo: "Natureza da Receita",
					significado: "Identifica a origem dos recursos de acordo com a legislação pertinente e, em particular, com a Portaria STN n° 248, de 28 de abril de 2003, que consolida as portarias 180, 211 e 300 e divulga o detalhamento das naturezas de receita para 2004."
				}, {
					termo: "Nota de Contrapartida",
					significado: "É o documento utilizado para detalhar convênio. Documento que dá origem a uma ND."
				}, {
					termo: "Nota de Crédito (NC)",
					significado: "É o documento de registro dos fatos vinculados à descentralização de créditos orçamentários, tais como Destaque, Provisão, permanecendo o mesmo Programa de Trabalho."
				}, {
					termo: "Nota de Crédito Adicional",
					significado: "É o documento emitido pelo SIOP (Sistema de Elaboração e Execução do Orçamento). Documento que dá origem a uma Nota de Dotação - ND."
				}, {
					termo: "Nota de Dotação (ND)",
					significado: "Documento originado da elaboração de outros documentos, como Nota de Detalhamento de Fonte, Nota de Remanejamento, Nota de Contingenciamento, Nota de Contrapartida, entre outros."
				}, {
					termo: "Nota de Empenho (NE)",
					significado: "É o documento utilizado para registrar o comprometimento de despesa orçamentária, obedecidos os limites legais, bem como os casos em que se faça necessário o reforço ou a anulação desse compromisso."
				}, {
					termo: "Nota de Lançamento (NL)",
					significado: "Documento utilizado para registro da apropriação/liquidação de receitas e despesas, bem como de outros eventos."
				}, {
					termo: "Nota de Remanejamento",
					significado: "É o documento utilizado para registrar o deslocamento de um recurso de determinada natureza da despesa para outra. Documento que dá origem a uma ND."
				}, {
					termo: "Nota de Sistema (NS)",
					significado: "É o documento utilizado pelo sistema para registros."
				}, {
					termo: "Numerário",
					significado: "Dinheiro; moeda."
				}]
			}, {
				letra: "O",
				termos: [
				{
					termo: "Objeto",
					significado: "O produto do convênio, observados o programa de trabalho e as suas finalidades."
				}, {
					termo: "Objeto de Gasto",
					significado: "Nível mais detalhado de classificação da natureza da despesa. É o mesmo que elemento de despesa (vide Classificação Econômica da Despesa)."
				}, {
					termo: "Obra",
					significado: "Construção, reforma ou ampliação de bens imóveis realizada por execução direta ou indireta."
				}, {
					termo: "Obrigação Acessória",
					significado: "Significa exigência feita pela legislação, no sentido de o sujeito passivo fazer ou deixar de fazer algo (prestações positivas ou negativas), com o propósito de permitir o controle da arrecadação e a fiscalização dos tributos. É obrigação de fazer ou não fazer. Se não cumprida, transforma-se em obrigação principal no tocante a penalidade (multa)."
				}, {
					termo: "Obrigação Principal",
					significado: "Consiste no pagamento do tributo, penalidade e acréscimo. Surge com o fato gerador e extingue-se ao mesmo tempo em que é extinto o crédito tributário. É obrigação de dar (no caso, em dinheiro)."
				}, {
					termo: "Obrigação Tributária",
					significado: "Pode ser conceituada como o poder jurídico, por força do qual o Estado pode exigir de uma pessoa física ou jurídica uma prestação pecuniária nas condições previstas em lei."
				}, {
					termo: "Obrigações",
					significado: "1. Dívidas, 2. Dever, encargo, compromisso."
				}, {
					termo: "Obrigações Patronais",
					significado: "Despesas com encargos que a administração é levada a atender pela sua condição de empregadora, resultante de pagamento de pessoal, tais como as contribuições previdenciárias."
				}, {
					termo: "Operação de Crédito",
					significado: "Obtenção de empréstimo pelas entidades da administração pública, com o objetivo de financiar seus projetos e/ou atividades, podendo ser interna ou externa."
				}, {
					termo: "Orçamento da Seguridade Social",
					significado: "Integra a Lei Orçamentária Anual, e abrange todas as entidades, fundos e fundações de administração direta e indireta, instituídos e mantidos pelo Poder público, vinculados à Seguridade Social."
				}, {
					termo: "Orçamento de Investimento",
					significado: "Integra a Lei Orçamentária Anual e refere-se ao orçamento de investimento das empresas em que o GDF, direta ou indiretamente, detenha a maioria do capital social com direito a voto."
				}, {
					termo: "Orçamento Fiscal",
					significado: "Integra a Lei Orçamentária Anual e refere-se ao orçamento dos Poderes da União, seus fundos, órgãos e entidades da administração direta e indireta, inclusive fundações instituídas e mantidas pelo Poder Público."
				}, {
					termo: "Orçamento Público",
					significado: "Lei de iniciativa do Poder Executivo que estima a receita e fixa a despesa da administração pública. É elaborada em um exercício para, depois de aprovada pelo Poder Legislativo, vigorar no exercício seguinte."
				}, {
					termo: "Ordem Bancária (OB)",
					significado: "É o documento utilizado para pagamento de credores, que deve ter como favorecido o credor do empenho, exceto as retenções."
				}, {
					termo: "Ordem Bancária Cancelada (OC)",
					significado: "É o documento resultante do cancelamento da OB."
				}, {
					termo: "Ordem Bancária Conta Única",
					significado: "É o documento utilizado para pagamento de credores, que deve ter como favorecido o credor do empenho, exceto as retenções. É um documento restrito a movimentação da Conta Única do GDF."
				}, {
					termo: "Ordenador de Despesa",
					significado: "Toda e qualquer autoridade de cujos atos resultem emissão de empenho e/ou autorização de pagamento."
				}, {
					termo: "Ordenador de Despesa por Delegação de Competência",
					significado: "Qualquer servidor designado por meio de ato específico para desempenhar atos que resultem emissão de empenho e/ou autorização de pagamento."
				}, {
					termo: "Organismo Multilateral de Crédito",
					significado: "O rganização, formada por mais de um país, que possui como um de seus objetivos a concessão de crédito a entidades nacionais e sub-nacionais. Os mais conhecidos são o Fundo Monetário Internacional, Banco Mundial, Banco Interamericano de Desenvolvimento - BID e FIDA - Fundo Internacional e Desenvolvimento Agrícola."
				}, {
					termo: "Outras Despesas Correntes",
					significado: "Despesas com a manutenção e funcionamento da máquina administrativa do governo, tais como: pagamento de pessoal, aquisição de material de consumo, pagamento de serviços prestados por pessoa física sem vínculo empregatício ou pessoa jurídica independente da forma contratual, e outras não classificadas nos demais grupos de despesas correntes."
				}, {
					termo: "Outros Encargos Sobre a Dívida por Contrato",
					significado: "Despesas com outros encargos da dívida pública contratada (interna e externa), tais como: correção monetária, taxas, comissões bancárias, prêmios, imposto de renda, comissões por apólices resgatadas e por cupons de juros pagos, registros de títulos nas bolsas de valores, impressão e autenticação de apólices, despesas de remessas e outros encargos da dívida."
				}]
			}, {
				letra: "P",
				termos: [
				{
					termo: "Pagamento",
					significado: "Último estágio da despesa pública. Caracteriza-se pela emissão de ordem bancária em favor do credor."
				}, {
					termo: "Passivo",
					significado: "Contas relativas às obrigações, que uma pessoa física ou jurídica deve satisfazer. Evidencia as origens dos recursos aplicados no ativo, dividindo-se em passivo circulante, exigível de curto e longo prazo, resultados de exercícios futuros, patrimônio líquido e passivo compensado."
				}, {
					termo: "Passivo Circulante",
					significado: "Depósitos, restos a pagar, antecipações de receita, bem como outras obrigações pendentes ou em circulação, exigíveis até o término do exercício seguinte."
				}, {
					termo: "Passivo Compensado",
					significado: "Contas com função precípua de controle, relacionadas aos bens, direitos, obrigações e situações não compreendidas no patrimônio mas que, direta ou indiretamente, possam vir a afetá-lo, inclusive as referentes a atos e fatos relacionados com a execução orçamentária e financeira."
				}, {
					termo: "Passivo Contingente",
					significado: "Os passivos contingentes do governo são definidos como dívidas cuja existência depende de fatores imprevisíveis"
				}, {
					termo: "Patrimônio",
					significado: "Conjunto de bens, direitos e obrigações de uma entidade."
				}, {
					termo: "Patrimônio Líquido",
					significado: "Capital autorizado, as reservas de capital e outras que forem definidas, bem como o resultado acumulado e não destinado."
				}, {
					termo: "Patrimônio Público",
					significado: "Conjunto de bens à disposição da Administração Pública ara atendimento das necessidades da coletividade."
				}, {
					termo: "Pensões",
					significado: "Despesas com pensionistas civis e militares e com pensões especiais despendidas pelo Poder Público, na forma da lei."
				}, {
					termo: "Pessoa Física",
					significado: "É a pessoa natural, isto é, todo indivíduo (homem ou mulher), desde o nascimento até a morte. A personalidade civil da pessoa começa do nascimento com vida."
				}, {
					termo: "Pessoa Jurídica",
					significado: "É a entidade abstrata com existência e responsabilidade jurídicas como, por exemplo, uma associação, empresa, companhia, legalmente instituídas e autorizadas. Podem ser de direito público (União, Unidades Federativas, Autarquias etc.), ou de direito privado (empresas, sociedades simples, associações etc.)."
				}, {
					termo: "Pessoal e Encargos Sociais",
					significado: "Grupo de natureza da despesa que inclui a despesa com o pagamento pelo efetivo serviço exercido de cargo/emprego ou função no setor público quer civil ou militar, ativo ou inativo, bem como as obrigações de responsabilidade do empregador. Ver \"Grupo de Natureza da Despesa\"."
				}, {
					termo: "Planejamento",
					significado: "Metodologia de administração que consiste, basicamente, em determinar os objetivos a alcançar, as ações a serem realizadas, compatibilizando-as com os meios disponíveis para sua execução. Essa concepção da ação planejada é também conhecida como planejamento normativo."
				}, {
					termo: "Plano de Contas",
					significado: "Estruturação ordenada e sistematizada das contas utilizáveis numa entidade. O plano contém diretrizes técnicas gerais e específicas que orientam a feitura dos registros dos atos praticados e dos fatos ocorridos na entidade."
				}, {
					termo: "Plano Interno",
					significado: "Instrumento de planejamento e de acompanhamento da ação planejada, usado como forma de detalhamento do projeto/atividade, de uso exclusivo de cada /órgão."
				}, {
					termo: "Plano Plurianual",
					significado: "Estabelece de forma regionalizada as diretrizes, objetivos e metas da administração pública para as despesas de capital e outras delas decorrentes e para as relativas aos programas de duração continuada. Vigora por quatro anos, sendo elaborado no primeiro ano do mandato do governador, abrangendo até o primeiro ano do mandato seguinte. Está previsto no art. 165 da Constituição Federal."
				}, {
					termo: "Poder",
					significado: "Disponibilidade de recursos coercitivos, utilitários ou simbólicos, que um ator utiliza no sentido de fazer valer a sua vontade."
				}, {
					termo: "Política",
					significado: "1. Parâmetro ou orientação para a tomada de decisão. 2. Definição dos níveis de delegação, faixas de valores e/ou quantidades limites e de abrangência das ações para consecução dos desafios e objetivos."
				}, {
					termo: "Política Fiscal",
					significado: "Coordenação da tributação, dívida pública e despesas governamentais, com o objetivo de promover o desenvolvimento e a estabilização da economia. Opera, basicamente, através de três esquemas: via tributo sobre a renda e produção, via incentivos e abatimentos fiscais."
				}, {
					termo: "Política Monetária",
					significado: "Controle do sistema bancário e monetário exercido pelo governo, com a finalidade de propiciar estabilidade para o valor da moeda, equilíbrio no balanço de pagamentos, pleno emprego e outros objetivos correlatos."
				}, {
					termo: "Portal da Transparência",
					significado: "É um canal pelo qual o cidadão pode acompanhar a execução financeira dos programas de governo. Estão disponíveis informações sobre os recursos públicos bem como dados sobre os gastos realizados pelo Estado em compras ou contratação de obras e serviços."
				}, {
					termo: "Pregão Eletrônico",
					significado: "O pregão, na forma eletrônica, como modalidade de licitação do tipo menor preço, realizar-se-á quando a disputa pelo fornecimento de bens ou serviços comuns for feita a distância em sessão pública, por meio de sistema que promova a comunicação pela internet."
				}, {
					termo: "Prestação de Contas",
					significado: "Demonstrativo organizado pelo próprio agente, entidade ou pessoa designada, acompanhado ou não de documentos comprobatórios das operações de receita e despesa, os quais, se aprovados pelo Ordenador de Despesa, integrarão a sua tomada de contas; é também o levantamento organizado pelo Serviço de Contabilidade das entidades da Administração Indireta, inclusive das Fundações instituídas pelo Poder Público."
				}, {
					termo: "Previsão da Receita",
					significado: "Cálculo provável do comportamento da receita, mediante a utilização de métodos estatísticos, observações diretas e outros instrumentos."
				}, {
					termo: "Previsão de Pagamento (PP)",
					significado: "É o documento utilizado pelo liquidante, para autorização da emissão da Ordem Bancária (OB)."
				}, {
					termo: "Previsão Orçamentária",
					significado: "A previsão orçamentária é, além de ato de planejamento das atividades financeiras do Estado, ato de caráter jurídico, \"criador de direitos e de obrigações\"."
				}, {
					termo: "Princípio da Universalidade do Orçamento",
					significado: "Princípio segundo o qual a lei orçamentária deve compreender todas as receitas e todas as despesas pelos seus totais."
				}, {
					termo: "Princípio da Uuidade do Orçamento",
					significado: "Princípio segundo o qual os orçamentos de todos os órgãos que constituem o setor público devem fundamentar-se segundo uma única política orçamentária, estruturarem-se uniformemente e ajustarem-se a um método único."
				}, {
					termo: "Princípios Orçamentários",
					significado: "Regras que cercam a instituição orçamentária, visando a dar-lhe consistência, principalmente no que se refere ao controle pelo Poder Legislativo. Os principais são: universalidade, unidade, exclusividade, especificação, periodicidade, autorização prévia, exatidão, clareza, publicidade, equilíbrio e programação."
				}, {
					termo: "Processo Orçamentário",
					significado: "Compreende as fases de elaboração e execução das leis orçamentárias - PPA, LDO e LOA. Cada uma dessas leis tem ritos próprios de elaboração, aprovação e implementação pelos Poderes Legislativo e Executivo."
				}, {
					termo: "Produto Interno Bruto (PIB)",
					significado: "De forma simplificada pode-se dizer que representa a quantificação de toda a riqueza produzida dentro dasfronteiras do país, em um ano."
				}, {
					termo: "Programa",
					significado: "Desdobramento da classificação funcional programática, através do qual se faz a ligação entre os planos de longo e médio prazo aos orçamentos plurianuais e anuais, representando os meios e instrumentos de ação, organicamente articulados para o cumprimento das funções. Os programas, geralmente, representam os produtos finais da ação governamental."
				}, {
					termo: "Programa de Governo",
					significado: "Principal instrumento que os governos utilizam para promover a integração entre os entes e os setores para otimizar seus recursos, sejam eles financeiros, humanos, logísticos ou materiais."
				}, {
					termo: "Programa de Trabalho",
					significado: "É o conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo."
				}, {
					termo: "Programação Financeira",
					significado: "Atividades relativas ao orçamento de caixa, compreendendo a previsão do comportamento da receita, a consolidação dos cronogramas de desembolso e o estabelecimento do fluxo de caixa."
				}, {
					termo: "Programação Orçamentária",
					significado: "É um instrumento que o Estado possui para organizar a utilização dos recursos que serão aplicados em suas ações de Governo."
				}, {
					termo: "Projeto",
					significado: "Tipo de ação destinada a alcançar o objetivo de um programa, envolvendo um conjunto de operações, limitadas no tempo, das quais resulta um produto que concorre para a expansão ou aperfeiçoamento da atuação governamental."
				}, {
					termo: "Proposta Orçamentária",
					significado: "Previsão da receita e despesa para um exercício financeiro, com os respectivos quadros e justificativas. No caso do Estado materializa no Projeto de Lei Orçamentário encaminhado pelo Poder Executivo ao poder Legislativo."
				}]
			}, {
				letra: "Q",
				termos: [
				{
					termo: "Quadro de Detalhamento da Despesa (QDD)",
					significado: "Instrumento que detalha, operacionalmente, os subprojetos e subatividades constantes da Lei Orçamentária Anual, especificando os elementos de despesa e respectivos desdobramentos. É o ponto de partida para a execução orçamentária."
				}]
			}, {
				letra: "R",
				termos: [
				{
					termo: "Receita",
					significado: "Recursos auferidos na gestão, a serem computados na apuração do resultado do exercício, desdobrados nas categorias econômicas de correntes e de capital."
				}, {
					termo: "Receita Corrente",
					significado: "No sentido amplo, consiste na soma de valores recebidos durante um determinado período de tempo. No setor público, é a soma de ingressos, impostos, taxas, contribuições e outras fontes de recursos, arrecadados para atender às despesas públicas."
				}, {
					termo: "Receita Corrente Líquida (RCL)",
					significado: "É o somatório das receitas tributárias de um Governo, referentes a contribuições, patrimoniais, industriais, agropecuárias e de serviços, deduzidos os valores das transferências constitucionais."
				}, {
					termo: "Receita de Capital",
					significado: "São os ingressos de recursos financeiros oriundos de atividades operacionais ou não operacionais para aplicação em despesas operacionais, correntes ou de capital, visando ao atingimento dos objetivos traçados nos programas e ações de governo. São denominados receita de capital porque são derivados da obtenção de recursos mediante a constituição de dívidas, amortização de empréstimos e financiamentos e/ou alienação de componentes do ativo permanente."
				}, {
					termo: "Receita de Serviços",
					significado: "Fonte de receita que corresponde às atividades caracterizadas pela prestação de serviços tais como de transporte, saúde, comunicação, portuários, armazenagem, de inspeção e fiscalização, judiciários, de processamento de dados, entre outros."
				}, {
					termo: "Receita de Transferências Correntes",
					significado: "São os recursos financeiros recebidos de pessoas jurídicas ou físicas e que serão aplicados no atendimento de Despesas Correntes."
				}, {
					termo: "Receita Extra-Orçamentária",
					significado: "Valores provenientes de toda e qualquer arrecadação que não figure no orçamento e, conseqüentemente, toda arrecadação que não constitui renda do Estado."
				}, {
					termo: "Receita Industrial",
					significado: "Fonte de receita que corresponde às atividades industriais, entre as quais estão a extrativa mineral, de transformação, editorial, gráfica, produção de energia elétrica e serviços de saneamento."
				}, {
					termo: "Receita Orçamentária",
					significado: "Receita constante da Lei Orçamentária Anual. Conjunto de ingressos de Recursos Financeiros, com fonte e fatos geradores próprios e permanentes, oriundos de ação e de tributos inerentes à instituição."
				}, {
					termo: "Receita Originária",
					significado: "Rendimentos que os governos auferem, este agindo na mesma posição de direitos com o particular, utilizando os seus próprios recursos patrimoniais industriais e outros, não entendidos como tributos. As receitas originárias correspondem às rendas, como os foros, laudêmios, aluguéis, dividendos, participações (se patrimoniais) e em tarifas (quando se tratar de rendas industriais)."
				}, {
					termo: "Receita Patrimonial",
					significado: "Corresponde ao resultado financeiro decorrente da fruição de bens mobiliários, imobiliários ou de participações societárias. Incluem-se, aqui, os aluguéis, arrendamentos, juros e correção monetária de títulos de renda e investimentos financeiros, dividendos e outras receitas resultantes da participação no capital de empresas, bem como ágios na colocação de títulos."
				}, {
					termo: "Receita Própria",
					significado: "As arrecadações pelas entidades públicas em razão de sua atuação econômica no mercado. Estas receitas são aplicadas pelas próprias unidades geradoras."
				}, {
					termo: "Receita Pública",
					significado: "1. A entrada que, integrando-se ao patrimônio público sem quaisquer reservas, condições ou correspondência no passivo, vem acrescer o seu vulto como elemento novo e positivo; 2 - Toda arrecadação de rendas autorizadas pela Constituição Federal, Leis e Títulos Creditórios à Fazenda Pública; 3 - Conjunto de meios financeiros que o Estado e as outras pessoas de direito público auferem, e, livremente, e sem reflexo no seu passivo, podem dispor para custear a produção de seus serviços e executar as tarefas políticas dominantes em cada comunidade."
				}, {
					termo: "Receita Tributária",
					significado: "É o valor do ingresso nos cofres públicos, decorrente da cobrança de tributos: impostos, taxas e contribuição de melhoria."
				}, {
					termo: "Receita Vinculada",
					significado: "Receita arrecadada com destinação específica estabelecida na legislação vigente."
				}, {
					termo: "Recolhimento",
					significado: "Um dos estágios da receita. É o ato pelo qual os agentes arrecadadores entregam, diariamente, ao Tesouro público o produto da arrecadação."
				}, {
					termo: "Recursos Disponíveis",
					significado: "Recursos sobre os quais o Poder Executivo mantém autonomia no sentido de prover sua alocação em programas prioritários, em face das decisões de política econômica global."
				}, {
					termo: "Refinanciamento da Dívida Mobiliária",
					significado: "Emissão de títulos para pagamento do principal acrescido da atualização monetária. O refinanciamento do principal da dívida mobiliária não excederá, ao término de cada exercício financeiro, o montante do final do exercício anterior, somado ao das operações de crédito autorizadas no orçamento para este efeito e efetivamente realizadas, acrescido de atualização monetária."
				}, {
					termo: "Regime Contábil",
					significado: "É um procedimento ou técnica adotado para a realização dos registros dos fatos aplicados à ciência contábil, estabelecendo as diretrizes para classificação das variações ou alterações patrimoniais."
				}, {
					termo: "Regime de Caixa",
					significado: "Modalidade contábil que considera para a apuração do resultado do exercício apenas os pagamentos e recebimentos ocorridos efetivamente no exercício."
				}, {
					termo: "Regime de Competência",
					significado: "Modalidade contábil que considera os fatos contábeis ocorridos durante o exercício para fins de apuração dos resultados do mesmo."
				}, {
					termo: "Regime Misto",
					significado: "Modalidade conceitual estabelecida pela Lei nº 4.320/64, art. 35, Título IV - Do Exercício Financeiro, que determina para a execução orçamentária, a combinação do Regime de Caixa para as receitas, ou seja, a realização dessas após o efetivo impacto nas disponibilidades financeiras e o Regime de Competência para a despesa, reconhecendo-a em momentos diferentes."
				}, {
					termo: "Registro",
					significado: "Conjunto de dados relacionados entre si, organizados e mantidos por qualquer meio de armazenamento."
				}, {
					termo: "Rentabilidade",
					significado: "Relação percentual entre o lucro de determinado período ou negócio e o volume de capital aplicado."
				}, {
					termo: "Reserva de Capital",
					significado: "Receitas que alteram o patrimônio duradouro do estado, como, por exemplo, aquelas provenientes da observância de um período ou do produto de um empréstimo contraído pelo estado a longo prazo. Compreendem, assim, a constituição de dívidas, a conversão em espécie de bens e direitos, reservas, bem como as transferências de capital."
				}, {
					termo: "Reserva de Contingência",
					significado: "Dotação global não especificamente destinada a determinado órgão, unidade orçamentária, programa ou categoria econômica, cujos recursos serão utilizados para abertura de créditos adicionais."
				}, {
					termo: "Restituição",
					significado: "Direito do contribuinte que pagou tributo indevidamente, a reaver o valor pago."
				}, {
					termo: "Restos a Pagar",
					significado: "Despesas empenhadas, mas não pagas, até 31 de dezembro, distinguindo-se os processados dos não processados. É condição para o surgimento de restos a pagar que os valores tenham sido anteriormente empenhados e liquidados ou até mesmo apenas empenhados."
				}, {
					termo: "Restos a Pagar Não Processados",
					significado: "Saldo de despesas empenhadas e não liquidadas. Correspondem aos valores das despesas que estando empenhadas não atingiram o estágio da liquidação até 31 de dezembro. Neste caso, encontram-se pendentes ou a prestação do serviço, ou o fornecimento do material ou a execução da obra, não tendo, portanto, o credor direito líquido e certo a receber."
				}, {
					termo: "Restos a Pagar Processados",
					significado: "Saldo de despesas liquidadas e não pagas. Correspondem àqueles valores que, ao final do exercício, estavam prontos para pagamento, uma vez que o credor já cumpriu com suas obrigações, seja com a entrega do material, prestação dos serviços ou execução de obra, dentro do exercício, tendo, portanto, direito líquido e certo a receber."
				}, {
					termo: "Resultado de Exercícios Futuros",
					significado: "Contas representativas de receitas de exercícios futuros, bem como as despesas a elas correspondentes."
				}, {
					termo: "Resultado do Exercício",
					significado: "Constituído pelo resultado orçamentário e o resultado extra-orçamentário."
				}, {
					termo: "Resultado Extra-Orçamentário",
					significado: "Decréscimos, interferências ativas e mutações patrimoniais passivas independentes da execução orçamentária."
				}, {
					termo: "Resultado Nominal",
					significado: "Obtém-se pela diferença entre todas as receitas arrecadadas e todas as despesas empenhadas, inclusive aquelas relacionadas com a dívida do setor público. Esse resultado indica em quanto a dívida aumentou ou reduziu no exercício ou num período determinado de tempo."
				}, {
					termo: "Resultado Orçamentário",
					significado: "Despesas, interferências ativas e mutações patrimoniais passivas resultantes de execução orçamentária."
				}, {
					termo: "Resultado Primário",
					significado: "Diferença entre as receitas e despesas do setor público, não computadas as despesas com \"rolagem da dívida\" e operações de crédito ativas e passivas. Reflete o esforço fiscal do governo."
				}, {
					termo: "Retenção na Fonte",
					significado: "Desconto de imposto sobre a renda efetuado pelo pagador sobre rendimentos do trabalho assalariado, de capital, ou pela prestação de serviços podendo ou não vir a ser compensado na declaração anual de rendimentos."
				}]
			}, {
				letra: "S",
				termos: [
				{
					termo: "Salário-Família",
					significado: "Despesas com o pagamento desta vantagem ao servidor público estatutário, civil ou militar, ativo ou inativo, pela manutenção de dependentes, na forma da lei."
				}, {
					termo: "SEDESTMIDH",
					significado: "Secretaria de Estado do Trabalho Desenvolvimento Social e Políticas para as Mulheres, Igualdade Racial e Direitos Humanos."
				}, {
					termo: "SEF",
					significado: "Secretaria de Estado de Fazenda do Distrito Federal."
				}, {
					termo: "SIGGO - Sistema Integrado de Gestão Governamental",
					significado: "Sistema de Gestão Governamental que concentra todas as movimentações orçamentárias, financeiras e contábeis do Governo do Distrito Federal."
				}, {
					termo: "Segregação de Funções",
					significado: "Princípio básico do sistema de controle interno que consiste na separação de funções, nomeadamente de autorização, aprovação, execução, controle e contabilização das operações."
				}, {
					termo: "SIGRH – Sistema Integrado de Gestão de Recursos Humanos",
					significado: "Sistema de controle dos recursos humanos no âmbito do Distrito Federal, responsável pela folha de pagamentos."
				}, {
					termo: "Seguridade Social",
					significado: "Conjunto integrado de ações de iniciativa dos poderes públicos e da sociedade destinadas a assegurar os direitos relativos à saúde, à previdência e à assistência social."
				}, {
					termo: "SELIC",
					significado: "Sistema Especial de Liquidação e de Custódia, criado em 1979 e administrado pelo Banco Central do Brasil, destinado a registrar títulos públicos e depósitos interfinanceiros por meio de equipamento eletrônico de teleprocessamento."
				}, {
					termo: "SEFP",
					significado: "Secretaria de Fazenda, Planejamento, Orçamento e Gestão."
				}, {
					termo: "Serviço da Dívida Interna",
					significado: "Compreende o pagamento de juros, encargos adicionais e de resgate dos títulos da dívida interna consolidada e flutuante."
				}, {
					termo: "Serviços Públicos",
					significado: "São os que a administração pública presta diretamente à comunidade, por reconhecer sua essencialidade e necessidade para a sobrevivência do grupo social e do próprio Estado. São considerados privativos do Poder Público, sendo exemplos os serviços de defesa nacional, polícia, preservação de saúde pública. Podem, também, ser denominados serviços pró-comunidade."
				}, {
					termo: "SISGEPAT",
					significado: "Sistema Geral de patrimônio Sistema integrado de processamento de dados, destinado à execução das atividades de administração e controle dos bens patrimoniais móveis e semoventes de propriedade do Distrito Federal."
				}, {
					termo: "Simples Nacional",
					significado: "É o Estatuto da Microempresa previsto na Lei Complementar n° 123/06. SISTEMA INTEGRADO DE GESTÃO DE MATERIAL (SIGMA) - Sistema informatizado de controle de material do Distrito Federal, que registra os lançamentos de entrada e saída dos materiais de consumo e permanente."
				}, {
					termo: "Sistema",
					significado: "Conjunto de entidades ou atividades, significativamente conectadas e satisfatoriamente ligadas, as quais interagem para um propósito ou propósitos comuns."
				}, {
					termo: "Sistema de Contas",
					significado: "Conjunto de contas que registra ocorrências de características comuns a determinados atos administrativos. O sistema de contas na administração pública compreende o sistema orçamentário, financeiro, patrimonial e de compensação."
				}, {
					termo: "Sistema Integrado de Gerenciamento de Recursos Humanos (SIGRE)",
					significado: "Sistema de controle dos recursos humanos no âmbito do Distrito Federal, responsável pela folha de pagamentos."
				}, {
					termo: "Sistema Integrado de Tributação e Administração Fiscal/SITAF",
					significado: "Tem por objetivo controlar o cadastro de contribuintes e a arrecadação tributária do Distrito Federal."
				}, {
					termo: "Sociedade de Economia Mista",
					significado: "Entidade dotada de personalidade jurídica de direito privado, criada por lei para o exercício de atividade econômica, sob a forma de sociedade anônima, cujas ações com direito a voto pertençam em sua maioria ao Poder Público."
				}, {
					termo: "STN",
					significado: "Secretaria do Tesouro Nacional, representante da União e responsável pela emissão dos Títulos a serem ofertados no Tesouro Direto. SONEGAÇÃO FISCAL - São atos praticados com a finalidade de enganar a Fazenda Pública, mediante a utilização de meios ilícitos para evitar, reduzir ou retardar o pagamento ou recolhimento do tributo devido."
				}, {
					termo: "Subsídio",
					significado: "Concessão de dinheiro feita pelo governo às empresas para lhes aumentar a renda ou abaixar os preços ou para estimular as exportações do país. Podem também ser concedidas diretamente ao consumidor. Em termos orçamentários, caracteriza uma subvenção econômica."
				}, {
					termo: "Substituição Tributária",
					significado: "É a eleição legal de um terceiro como responsável pelo imposto devido."
				}, {
					termo: "Subvenção Econômica",
					significado: "Alocação destinada à cobertura dos déficits de manutenção das empresas públicas de natureza autárquica ou não, assim como as dotações destinadas a cobrir a diferença entre os preços de mercado e os preços de revenda."
				}, {
					termo: "Subvenção Social",
					significado: "Suplementação dos recursos de origem privada aplicados na prestação de serviços de assistência social ou cultural sem finalidade lucrativa."
				}, {
					termo: "Superávit Financeiro",
					significado: "Diferença positiva entre o ativo financeiro e o passivo financeiro, conjugando-se, ainda, os saldos dos créditos adicionais e as operações de créditos a eles vinculados."
				}, {
					termo: "Superávit Orçamentário",
					significado: "Quando a soma das receitas estimadas é maior que às das despesas orçamentárias previstas."
				}, {
					termo: "Suplementação",
					significado: "Aumento de recursos por crédito adicional, para reforçar as dotações que já constam na lei orçamentária."
				}, {
					termo: "Suprido",
					significado: "Servidor indicado para aplicar Suprimento de Fundos."
				}, {
					termo: "Suprimento de Fundos",
					significado: "Instrumento de execução ao qual pode recorrer o ordenador de despesas para, através de servidor subordinado, realizar despesas que, a critério da administração e consideradas as limitações previstas em lei, não possam ou não devam ser realizadas por via bancária."
				}]
			}, {
				letra: "T",
				termos: [
				{
					termo: "Tabela de Eventos",
					significado: "Relação ordenada e codificada dos principais fatos contábeis rotineiros de um órgão público, agrupados de acordo com características comuns."
				}, {
					termo: "Taxa",
					significado: "Espécie de tributo que os indivíduos pagam ao Estado, em razão do exercício do Poder de Polícia ou pela utilização, efetiva ou potencial, de serviços públicos específicos e divisíveis, prestados ao contribuinte ou postos à sua disposição."
				}, {
					termo: "Termo Aditivo",
					significado: "Instrumento elaborado com a finalidade de alterar itens de contratos, convênios ou acordos firmados pela administração pública."
				}, {
					termo: "Termo de Cooperação",
					significado: "Um instrumento político e ou diplomático com o qual as Autoridades Públicas ou Privadas indicam a disposição de realizar mútua cooperação técnico-científica entre os signatários."
				}, {
					termo: "Títulos",
					significado: "Títulos representativos da dívida pública federal emitidos pelo Tesouro Nacional e ofertados por meio do Tesouro Direto."
				}, {
					termo: "Títulos da Dívida Pública",
					significado: "Títulos financeiros com variadas taxas de juros, métodos de atualização monetária e prazo de vencimento, utilizados como instrumentos de política monetária de financiamento do déficit público."
				}, {
					termo: "Tomada de Contas",
					significado: "Levantamento organizado por serviço de contabilidade analítica, baseado na escrituração dos atos e fatos praticados na movimentação de créditos, recursos financeiros e outros bens públicos, por um ou mais responsáveis pela gestão financeira e patrimonial, a cargo de uma unidade administrativa e seus agentes, em determinado exercício ou período de gestão."
				}, {
					termo: "Tomada de Contas Especial",
					significado: "Instrumento de que dispõe a Administração Pública para ressarcir-se de eventuais prejuízos que lhe forem causados, sendo o processo revestido de rito próprio e somente instaurado depois de esgotadas as medidas administrativas para reparação do dano."
				}, {
					termo: "Tomada de Preços",
					significado: "Modalidade de licitação realizada entre interessados previamente cadastrados, observada a necessária qualificação."
				}, {
					termo: "Transação",
					significado: "Unidade de operação do sistema de administração financeira e contábil que corresponde a atividades de entrada e consulta de dados. Equivale a um comando para executar uma tarefa, dirigido ao sistema."
				}, {
					termo: "Transferências Constitucionais",
					significado: "São transferências, previstas na Constituição Federal, de parcelas das receitas federais arrecadadas pela União e que devem ser repassadas aos Estados, ao Distrito Federal e aos Municípios. O objetivo do repasse é amenizar as desigualdades regionais e promover o equilíbrio socioeconômico entre Estados e Municípios."
				}, {
					termo: "Transferências Correntes",
					significado: "Dotações destinados a terceiros sem a correspondente prestação de serviços incluindo as subvenções sociais, os juros da dívida a contribuição de previdência social, etc."
				}, {
					termo: "Transferências de Capital",
					significado: "Dotações para investimentos ou inversões financeiras que outras pessoas de direito público ou privado devam realizar, independente de contraprestação direta em bens ou serviços, constituindo essas transferências auxílios ou contribuições, segundo derivem da lei de orçamento ou de lei especial anterior, bem como as dotações para amortização da dívida pública."
				}, {
					termo: "Transferências Fundo a Fundo",
					significado: "Caracterizam-se pelo repasse, por meio da descentralização, de recursos diretamente de fundos da esfera estadual para fundos da esfera, municipal, dispensando a celebração de convênios. As transferências fundo a fundo são utilizadas nas áreas de assistência social e de saúde."
				}, {
					termo: "Transferências Inter-Governamentais",
					significado: "Transferências feitas entre a União, Estados, Distrito Federal e Municípios."
				}, {
					termo: "Transferências Voluntárias",
					significado: "São os recursos financeiros repassados pela União aos Estados, Distrito Federal e Municípios em decorrência da celebração de convênios, acordos, ajustes ou outros instrumentos similares, cuja finalidade é a realização de obras e/ou serviços de interesse comum."
				}, {
					termo: "Tributo",
					significado: "Receita instituída pela União, pelos Estados, Distrito Federal e Municípios, compreendendo os impostos, as taxas e contribuições de melhoria, nos termos da Constituição e das leis vigentes em matéria financeira"
				}]
			}, {
				letra: "U",
				termos: [
				{
					termo: "Unidade Gestora",
					significado: "Unidade administrativa investida do poder de gerir recursos orçamentários e financeiros, próprios ou sob descentralização."
				}, {
					termo: "Unidade Orçamentária",
					significado: "O segmento da administração direta a que o orçamento consigna dotações especificas para a realização de seus programas de seus programas de trabalho e sobre os quais exerce o poder de disposição."
				}]
			}
		];
	}
	

})();
/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('HomeController', HomeController);

    /**
     * Controlador referente a tela inicial.
     */
    /** @ngInject */
    function HomeController($scope, SlideShowService, $interval, $location, ArquivoUrlService) {
        var self = this;
        self.URL_IMAGENS_PORTAL = ArquivoUrlService.IMAGENS;

        this.linkAreasList = LINK_AREAS;

        this.setSlideshowModelCallback = function (model) { self.ssModel = model; };
        this.onClickSlideShowIndicator = onClickSlideShowIndicator;
        this.onSlideShowSwipeListener = onSlideShowSwipeListener;
        this.hideSlideShow = hideSlideShow;
        this.loadingIndicators = LOADING_INDICATORS;
        this.slideTo = slideTo;
        this.$scope = $scope;
        this.slideshowTimer = {
            interval: 10,
            delayBeforeStart: 5
        };

        // Indicativo de carregamento
        this.loadingIndicators.startLoading($interval);

        // Carregamendo das imagens do slideshow
        SlideShowService.buscarImagens().then(function (response) {
            var imagens = [];
            for (var i = 0; i < response.data.length; i++) {
                var imagem = {
                    id: 'img' + i,
                    src: response.data[i]
                };
                if (i == 0) {
                    imagem.current = true;
                } else {
                    imagem.current = false;
                }

                imagens[i] = imagem;
            }

            self.slideShowImages = imagens;

            if (imagens.length > 0) {
                self.ssModel.createTimer(self.slideshowTimer.interval, self.slideshowTimer.delayBeforeStart);
            }
        }).finally(function () {
            self.loadingIndicators.stopLoading($interval);
        });

        $scope.onSearch = function (value) {
            $location.path('/busca').search({ q: value });
        };
    }

    /**
     * Responde ao click um indicator do slideshow.
     * @param {*} image Image correspondente.
     */
    function onClickSlideShowIndicator(image) {
        if (!image.current) {
            this.ssModel.show(this.slideShowImages.indexOf(image));
        }
    }

    /**
     * Responde ao evento de swipe sobre o slideshow.
     * @param {*} d Direção.
     */
    function onSlideShowSwipeListener(d) {
        this.$scope.$apply();
    }

    /**
     * Realiza o slide para a localização de um elemento.
     * @param {*} elementId ID do elemento.
     * @param {*} event Evento.
     */
   function slideTo(area, event) {

    if (area.href && area.href.startsWith('#/')) {
        return;
    }

    if (area.isExternalLink) {
        if (event) event.preventDefault();
        window.open(area.href, '_blank');
        return;
    }

    if (area.href && area.href.startsWith('#')) {
        if (event) event.preventDefault();

        var target = document.getElementById(area.href.replace('#', ''));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }
}

    /**
     * Verifica se o slideshow deve ser ocultado.
     * @returns True, slideshow deve ser ocultado; false, caso contrário.
     */
    function hideSlideShow() {
        return isMobileMediaMatched();
    }

    /**
     * Verifica se a janela está adequada para a mobile media.
     */
    function isMobileMediaMatched() {
        return window.matchMedia(MOBILE_MEDIA).matches;
    }

    var MOBILE_MEDIA = '(max-width: 750px)';

    var LOADING_INDICATORS = {
        interval: undefined,
        enable: false,
        current: 0,
        indicators: [{ current: true }, { current: false }, { current: false }],
        next: function () {
            this.indicators[this.current].current = false;
            this.current = this.current == this.indicators.length - 1 ? 0 : this.current + 1;
            this.indicators[this.current].current = true;
        },
        startLoading: function ($interval) {
            var self = this;
            this.enable = true;
            this.interval = $interval(function () { self.next(); }, 300);
        },
        stopLoading: function ($interval) {
            this.enable = false;
            $interval.cancel(this.interval);
            this.interval = undefined;
        }
    };

    var LINK_AREAS = [
        {
          icon: {
              type: 'img',
              name: 'assets/img/areas-home/participaDF_home.png'
          },
          title: '',
          label: 'ParticipaDF',
          href: 'https://www.participa.df.gov.br',
          isExternalLink: true,
          newTab: true
        },
        {
            icon: {
                type: 'img',
                name: 'assets/img/areas-home/logo_como_funciona.png'
            },
            title: 'Veja as instruções de utilização',
            label: 'Como funciona',
            href: '#secaoAprendaNavegar',
            isExternalLink: false
        }, {
            icon: {
                type: 'img',
                name: 'assets/img/areas-home/logo_execucao_despesas.png'
            },
            title: 'Veja o andamento da execução de despesas',
            label: 'Execução das Despesas',
            href: '#secaoExecDespesa',
            isExternalLink: false
        }, {
            icon: {
                type: 'img',
                name: 'assets/img/areas-home/logo_impostometro.png'
            },
            title: 'Veja a contabilização de impostos',
            label: 'Impostômetro',
            href: '#secaoArrecImposto',
            isExternalLink: false
        },
        {
            icon: {
                type: 'img',
                name: 'assets/img/areas-home/logo_acesso_informacao.png'
            },
            title: '',
            label: 'Acesso à informação',
            href: '#/acesso-informacao',
            isExternalLink: true
        },
        {
          icon: {
              type: 'img',
              name: 'assets/img/areas-home/logo_portal-dados-abertos.png'
          },
          title: '',
          label: 'Portal de Dados Abertos',
          href: 'http://www.dados.df.gov.br',
          isExternalLink: true,
          newTab: true
      },
      {
    icon: {
        type: 'img',
        name: 'assets/img/icons/41_logo_protecao_dados_branca.png',
        isSmallIcon: true
    },
    title: '',
    label: 'Proteção Dados Pessoais',
    href: '#aviso-protecao-dados',
    isExternalLink: false
},
        {
            icon: {
            type: 'img',
            name: '/assets/img/areas-home/102_radar_transparencia_logo.png',
            isSmallIcon: true
            },
            title: '',
            label: 'Da transparência Pública',
            href: 'https://radardatransparencia.atricon.org.br',
            isExternalLink: true,
            newTab: true
        }
    ];

  

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('ListsController',  ListsController);

  /** @ngInject */
  function ListsController() {
    $('#range').on('slide set', function(a,b){
      if(!$(this).find('.noUi-handle div').length){
        $(this).find('.noUi-handle').append('<div>'+b+'</div>');
      }
      $(this).find('.noUi-handle div').html(b);
    });
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, localStorageService, APP, crumble, $location, $element,$window ) {
    $scope.crumble = crumble;
    $scope.location = $location;

    $scope.version = APP.version;
    $scope.scrollTop = 140;
    // redirecionamento para o APP

    /* $scope.redirecionaParaMobile = redirecionaParaMobile(); */

     $scope.abreModal = abreModal();

    $scope.theme_colors = [
      "pink",
      "red",
      "purple",
      "indigo",
      "blue",
      "light-blue",
      "cyan",
      "teal",
      "green",
      "light-green",
      "lime",
      "yellow",
      "amber",
      "orange",
      "deep-orange",
    ];

    var theme = {
      color: "theme-light-blue",
      template: "theme-template-light",
    };

    localStorageService.set("theme", theme);
    localStorageService.bind($scope, "theme");

    // Setting moment locale to PT-BR
    moment.locale("pt-br");

    $scope.onSearchBar = function (value) {
      $location.path("/busca").search({ q: value });
      $scope.$broadcast("super_busca_search", value);
    };

    $scope.$on("super_busca_input", function (event, value) {
      $scope.searchBarValue = value;
    });

    $scope.topBar = $element.find("#topBarPortal");

    // Altera layout da barra superior para páginas que não a inicial
    $scope.$on("$routeChangeSuccess", function (event, current, previous) {
      if (current.originalPath != "" && current.originalPath != "/") {
        if (!$scope.topBar.hasClass("other_pages")) {
          $scope.topBar.addClass("other_pages");
          $scope.topBar.addClass("collapsed");
        }
      } else {
        if ($scope.topBar.hasClass("other_pages")) {
          $scope.topBar.removeClass("other_pages");
          $scope.topBar.removeClass("collapsed");
        }
      }
    });

    //Redirecionamento direto para o APP - a ser ativado futuramente

    /*  function redirecionaParaMobile() {
      var param1 = $location.search().redirect;
      if(param1){
        sessionStorage.setItem('redirect', 'true')
      }
      var verificaSession = sessionStorage.getItem('redirect');
      console.log(param1);
      console.log(verificaSession)
      if (verificaSession !== 'true' && screen.width <= 1023) {
        window.location.replace("https://app.transparencia.df.gov.br/home");
      }

    } */

    function abreModal() {
      var param1 = window.location.href;
      var param2 = $location.search().redirect;

      if(param1.includes('/busca')){
          sessionStorage.setItem("modal", "false");
      }

      if(param2){
          sessionStorage.setItem('redirect', 'true')
      }

      var verificaRedirect = sessionStorage.getItem('redirect');
      var verificaModal = sessionStorage.getItem("modal");

      $window.onload = function() {
        if (screen.width < 1023 && verificaModal === null && verificaRedirect === null) {
          $("#modalMobile").modal("show");
          sessionStorage.setItem("modal", "false");
        } else if (screen.width < 1023 && verificaModal === "false" || verificaRedirect === "true") {
          $("#modalMobile").modal("hide");
          sessionStorage.setItem("modal", "false");
        }
      }

    }

    $scope.$on('$routeChangeSuccess', function(event, current, previous) {
      // Enviar evento para o Google Analytics
      gtag('event', 'page_view', {
        'page_location': $location.url(),
        'page_title': current.$$route.title
      });
    });

  }



})();





/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('PesquisaSatisfacaoController', PesquisaSatisfacaoController);

    /** @ngInject */
    function PesquisaSatisfacaoController($scope, $alert, PesquisaSatisfacaoService, $modal, $aside, $timeout) {
        var valoresFormulario = {};

        $scope.submitForm = submitForm;

        function submitForm(isValid) {
            if (!isValid) {
                return;
            }

            valoresFormulario = construirPesquisa();

            $scope.formLoading = true;
            
            PesquisaSatisfacaoService.salvar(valoresFormulario)
                .then(function (response) {
                    cleanScope();
                    $scope.formSubmited = true;

                    if ($scope.$parent.onPesquisaEnviada) {
                        $scope.$parent.onPesquisaEnviada();
                    }
                    $scope.loadResultados();
                }, function(error) {
                    if (error.status === 400) {
                        $alert({
                            title: 'Erro',
                            content: error.data.erros[0],
                            type: 'warning'
                        });
                    } else {
                        $alert({
                            title: 'Erro',
                            content: 'tente novamente mais tarde.',
                            type: 'warning'
                        });
                    }
                }).finally(function() {
                    $scope.formLoading = false;
                });
        }

        function cleanScope() {
            delete $scope.form.ocupacao;
            delete $scope.form.faixaEtaria;
            delete $scope.form.satisfacao;
            delete $scope.form.detalheDesagrado;
            delete $scope.form.desagrado;
        }

        function construirPesquisa() {
            var pesquisa = {};
            pesquisa.ocupacao = $scope.form.ocupacao;
            pesquisa.faixaEtaria = $scope.form.faixaEtaria;
            pesquisa.satisfacao = $scope.form.satisfacao;
            pesquisa.textoDesagrado = $scope.form.detalheDesagrado;
            pesquisa.desagrado = $scope.form.desagrado;
            return pesquisa;
        }
        
        $scope.loadResultados = function() {
            $aside({
                template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-resultado.html',
                show: true,
                placement: 'left',
                backdrop: true,
                animation: 'am-slide-left'
            });
        };
    }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('ResultadoPesquisaController', ResultadoPesquisaController);

  /** @ngInject */
  function ResultadoPesquisaController($scope, ServidoresService, $q) {
    var colors = ['#1ED6D6', '#1F7DC0', '#65A0CE', '#229396', '#50597B', '#FFD200'];
    var dadosNivelSatisfacao = ServidoresService.listarDadosPesquisaNivelSatisfacao();
    var dadosFaixaEtaria = ServidoresService.listarDadosPesquisaFaixaEtaria();
    var dadosOcupacao = ServidoresService.listarDadosPesquisaOcupacao();
    var dadosTotalPesquisa = ServidoresService.listarTotalDeRespostasDaPesquisaDeSatisfacao();

    $q.all([dadosNivelSatisfacao, dadosFaixaEtaria, dadosOcupacao, dadosTotalPesquisa]).then(function(respArray) {

      $scope.satisfacaoChartModel = buildAreaChart('grafico-pesquisa-nivel-satisfacao', 'NÍVEL DE SATISFAÇÃO', respArray[0].data, colors);
      $scope.faixaEtariaChartModel = buildAreaChart('grafico-pesquisa-faixa-etaria', 'FAIXA ETÁRIA', respArray[1].data, colors);
      $scope.ocupacaoChartModel = buildAreaChart('grafico-pesquisa-ocupacao', 'OCUPAÇÃO', respArray[2].data, colors);

      $scope.total = respArray[3].data[0][1];
    });
  }

  function buildAreaChart(chartId, title, data, colors) {

    var total = data.map(function(d) {
      return d[1];
    }).reduce(function(prev, next) {
      return prev + next;
    }, 0);

    return {
      chartId: chartId,
      chartHeight: 280,
      outsideLegendOffset: 50,
      legendPosition: 'bottom',
      insideTitle: title,
      insideText: total + ' respondentes',
      fnFormatData: function(ratio, value) { return value; },
      fnChartBuild: function(chart) { this.chart = chart; },
      dimentions: data.map(function(d, index) {
          return {
              dataLabel: d[0].toLowerCase(),
              data: d[1],
              color: colors[index % colors.length]
          };
      })
    };
  }

})();

/*eslint-disable */
(function(){
    'use strict';
  
    angular.module('portal').controller('SetorDesejadoController',  SetorDesejadoController);
  
    /** @ngInject */
    function SetorDesejadoController($scope, SetorDesejadoService) {
        var self = this;
    
        this.loading = true;
        SetorDesejadoService.buscarSetores().then(function(data) {
            self.slides = data.temas;
            self.anoAtual = data.anos[0];

            self.error = false;
        }, function(err) {
            self.error = true;
        }).finally(function() {
            self.loading = false;
        });
    }

})();
  
/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('ShareController', ShareController);

  /** @ngInject */
  function ShareController($scope, $location) {
    $scope.url = $location.absUrl();
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').controller('UploadController', UploadController);

  /** @ngInject */
  function UploadController($scope, Upload, $timeout) {
    $scope.fileReaderSupported = window.FileReader !== undefined && (window.FileAPI === undefined || FileAPI.html5 !== false);

    $scope.$watch('files', function () {
      $scope.upload($scope.files);
    });

    progressHandler = function(evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      console.log('progress: ' + progressPercentage + '% ' + evt.config.file.name);
    };

    successHandler = function(data, status, headers, config) {
      console.log('file ' + config.file.name + 'uploaded. Response: ' + JSON.stringify(data));
    };

    thumbHandler = function(file) {
      generateThumb(file);
    };

    generateThumb = function(file) {
      if (file !== undefined) {
        if ($scope.fileReaderSupported && file.type.indexOf('image') > -1) {
          $timeout(function() {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function(e) {
              $timeout(function() {
                file.dataUrl = e.target.result;
              });
            };
          });
        }
      }
    };

    $scope.upload = function (files) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          Upload.upload({
              url: '#',
              file: file
            })
            .progress(progressHandler)
            .success(successHandler);
        }
      }
    };

    $scope.$watch('files', function(files) {
      $scope.formUpload = false;
      if (files !== undefined && files !== null) {
        for (var i = 0; i < files.length; i++) {
          $scope.errorMsg = undefined;
          (thumbHandler)(files[i]);
        }
      }
    });
  }

})();


(function() {
  'use strict';

  angular.module('portal').directive('autofocus', AutoFocus);

  /** @ngInject */
  function AutoFocus($timeout) {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        $timeout(function () {
          $element[0].focus();
        });
      }
    };
  }

})();


(function () {
  'use strict';

  angular.module('portal').directive('cabecalhoPagina', CabecalhoPagina);

  /** @ngInject */
  function CabecalhoPagina(ServidoresService) {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        fnInit: '&?',
        atualizacao: '@',
        urlSaibaMais: '@?',
        textoAdicional: '@?'
      },
      templateUrl: 'app/template/directives/cabecalho-pagina.html',
      controller: function ($scope, $location, $sce, $filter) {

        $scope.exibirResultados = false;
        $scope.mostrarDataDeAtualizacao = true;
        var colors = ['#95D1AA', '#6DB0E1', '#2D5181', '#90CEDB', '#76A8D7', '#2F8E43', '#6CAA6C', '#5DA199'];
        var fourColors = ['#98D1AB', '#5DA198', '#719FCA', '#2B5280'];
        var fiveColors = ['#98D1AB', '#5DA198', '#90CEDB', '#719FCA', '#2B5280'];

        $scope.init = function () {
          if ($location.path() == '/prestando-contas/empresa-punida') {

            $scope.mostrarDataDeAtualizacao = false;
          }
          if (angular.isDefined($scope.fnInit)) {
            $scope.fnInit()();

          }
        };

        $scope.chamarResultados = function () {
          $scope.listarDadosPesquisaNivelSatisfacao();
          $scope.listarDadosPesquisaFaixaEtaria();
          $scope.listarDadosPesquisaOcupacao();
          $scope.showResultados();
          $scope.totalDeRespostas();
        }

        $scope.redirect = function () {
          if ($scope.urlSaibaMais) {
            $location.path($scope.urlSaibaMais)
          }
        };
        $scope.atualizacaoFormatada = $filter('date')(new Date($scope.atualizacao.replace(/"/g, '')), 'dd/MM/yyyy');

        $scope.message = $sce.trustAsHtml($scope.textoAdicional);

        $scope.showResultados = function () {
          $scope.exibirResultados = true;
        }

        $scope.listarDadosPesquisaNivelSatisfacao = function () {
          ServidoresService.listarDadosPesquisaNivelSatisfacao()
            .then(function (obj) {
              $scope.dadosNivelSatisfacao = obj;
              var chartBarPesquisaNivelSatisfacao = c3.generate({
                bindto: '#grafico-pesquisa-nivel-satisfacao',
                data: {
                  columns: $scope.dadosNivelSatisfacao.data,
                  type: 'bar'
                },
                tooltip: {
                  grouped: false,
                  format: {
                    name: function (name, ratio, id, index) {
                      return name;
                    },
                    title: function (x) { return '' },
                    value: function (value, ratio, id, index) {
                      return value;
                    }
                  }
                },
                axis: {
                  y: {
                    label: {
                      text: 'Nº de Pessoas',
                      position: 'outer-middle'
                    }
                  }
                },
                legend: {
                  position: 'bottom'
                },
                size: {
                  height: 150,
                  width: 800
                },
                color: {
                  pattern: fourColors
                }
              });
            })
        }

        $scope.listarDadosPesquisaFaixaEtaria = function () {
          ServidoresService.listarDadosPesquisaFaixaEtaria()
            .then(function (obj) {
              $scope.dadosFaixaEtaria = obj;

              var chartBarPesquisaFaixaEtaria = c3.generate({
                bindto: '#grafico-pesquisa-faixa-etaria',
                data: {
                  columns: $scope.dadosFaixaEtaria.data,
                  type: 'bar'
                },
                tooltip: {
                  grouped: false,
                  format: {
                    name: function (name, ratio, id, index) {
                      return name;
                    },
                    title: function (x) { return '' },
                    value: function (value, ratio, id, index) {
                      return value;
                    }
                  }
                },
                axis: {
                  y: {
                    label: {
                      text: 'Nº de Pessoas',
                      position: 'outer-middle'
                    }
                  }
                },
                legend: {
                  position: 'bottom'
                },
                size: {
                  height: 150,
                  width: 800
                },
                color: {
                  pattern: fiveColors
                }
              });
            })
        }

        $scope.listarDadosPesquisaOcupacao = function () {
          ServidoresService.listarDadosPesquisaOcupacao()
            .then(function (obj) {
              $scope.dadosOcupacao = obj;

              var chartBarPesquisaOcupacao = c3.generate({
                bindto: '#grafico-pesquisa-ocupacao',
                data: {
                  columns: $scope.dadosOcupacao.data,
                  type: 'bar'
                },
                tooltip: {
                  grouped: false,
                  format: {
                    name: function (name, ratio, id, index) {
                      return name;
                    },
                    title: function (x) { return '' },
                    value: function (value, ratio, id, index) {
                      return value;
                    }
                  }
                },
                axis: {
                  y: {
                    label: {
                      text: 'Nº de Pessoas',
                      position: 'outer-middle'
                    }
                  }
                },
                legend: {
                  position: 'bottom'
                },
                size: {
                  height: 150,
                  width: 800
                },
                color: {
                  pattern: colors
                }
              });
            })
        }

        $scope.totalDeRespostas = function () {
          ServidoresService.listarTotalDeRespostasDaPesquisaDeSatisfacao()
            .then(function (obj) {
              $scope.total = obj.data[0][1];
            })
        }

        $scope.exibirPesquisa = function () {
          $scope.exibirResultados = false;
          $scope.mensagemSucesso = null;
          $scope.mensagemErro = null;
        }

        $scope.enviarValoresRadios = function (nivelSatisfacao, faixaEtaria, ocupacao, desagrado, textoDesagrado) {

          if (nivelSatisfacao == "Satisfeito" || nivelSatisfacao == "Muito Satisfeito") {
            desagrado = null;
            textoDesagrado = null;
          }

          var valoresCapturados = ocupacao + ";" + faixaEtaria + ";" + nivelSatisfacao;
          if (!ocupacao || !faixaEtaria || !nivelSatisfacao) {
            $scope.mensagemErro = "Você não respondeu uma ou mais perguntas!";
            $scope.mensagemSucesso = null;
          }
          else {
            $.post("http://www.transparencia.df.gov.br/api/pesquisa/registro", {
              valoresCapturados: valoresCapturados,
              desagrado: desagrado,
              textoDesagrado: textoDesagrado
            });
            $scope.mensagemErro = null;
            $scope.mensagemSucesso = "Obrigado pela participação!";
            $scope.totalDeRespostas();
            $scope.chamarResultados();
          }
        }



        $scope.enviarMensagem = function (nome, email, assunto, mensagem) {
          var valoresFormulario = nome + ";" + email + ";" + assunto + ";" + mensagem;
          if (!nome || !email || !assunto || !mensagem) {
            $scope.mensagemErro = "Você não preencheu um ou mais campos!";
            $scope.mensagemSucesso = null;
          } else {
            $.post('http://172.16.1.216:8080/contato/registro', { valoresFormulario: valoresFormulario });
            $scope.mensagemSucesso = "Agradecemos pelo seu contato!";
            $scope.mensagemErro = null;
            limparCamposFaleConosco();
          }
        }

        var limparCamposFaleConosco = function () {
          delete $scope.nomeContato;
          delete $scope.emailContato;
          delete $scope.assuntoContato;
          delete $scope.mensagemContato;
        }

      }

    }
  };


})();

(function () {
    'use strict';
  
    angular.module('portal').directive('cabecalhoTabela', Directive);
  
    /** @ngInject */
    function Directive() {
      return {
        restrict: 'AE',
        replace: true,
        scope: true,
        transclude: true,
        templateUrl: 'app/template/directives/cabecalho-tabela.html',
        link: function(scope, element, attrs) {
          scope.visualizar = attrs.visualizar;
        }
      }
    };
  
  })();
  
(function(){
  'use strict';

  angular.module('portal').directive('cardFlip', CardFlip);

  /** @ngInject */
  function CardFlip() {
    return {
      restrict: 'C',
      link: function(scope, element) {
        element.find('.btn-flip, .card-image').on('click', function(){
          element.find('.card-reveal').toggleClass('active');
        });
      }
    };
  }

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('contadorTabela', ContadorTabelaDirective);

    /**
     * Diretiva para inclusão do contador da tabela de consulta.
     */
    function ContadorTabelaDirective() {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a); },
            scope: {
                contador: '='
            },
            templateUrl: 'app/template/directives/contador-tabela/contador-tabela.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        element.addClass('internal_page_padding');
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('dashboardPanels', Directive);
    
    /**
     * Diretiva responsável por gerenciar paineis de dashboard.
     */
    function Directive($timeout) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $timeout); },
            scope: {
                panels: '=',
                currentPointer: '=?'
            },
            templateUrl: 'app/template/directives/dashboard-panels/dashboard-panels.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $timeout) {
        scope.$timeout = $timeout;
        scope.currentPanel = currentPanel;
        scope.next = next;
        scope.previous = previous;
        scope.showLoading = showLoading;
        scope.hideLoading = hideLoading;
        scope.showError = showError;
        scope.element = element;
        scope.enableSwipe = enableSwipe;
        scope.loadPanel = loadPanel;
        scope.slide = slide;
        scope.showPanel = showPanel;
        scope.onPanelShow = onPanelShow;
        scope._setCurrentPointer = _setCurrentPointer;
        scope.setCurrentPointer = function(p) { scope._setCurrentPointer(p) };

        scope.$watch('panels', function(panels) {
            if (panels != undefined) {
                $timeout(function() {
                    panels.forEach(function(p) { p.current = p.initial == true; });

                    var curr = scope.currentPanel();
                    if (curr) {
                        scope.currentPointer = curr.panel;
                    }

                    element.find('.dashboard_panels_chart_container').each(function() { scope.enableSwipe(this); });

                    panels.forEach(function(panel) {
                        panel.showLoading = function() { scope.showLoading(panel); };
                        panel.hideLoading = function() { scope.hideLoading(panel); };
                        panel.showError = function() { scope.showError(panel); };
                        panel.reload = function() {
                            scope.loadPanel(this);
                        };
                        panel.invalidadeLoad = function() {
                            this.destroy();
                            this._isLoadUnnecessary = false;
                        };

                        if (panel.current) {
                            scope.onPanelShow(panel);
                        }
                    });
                });
            }
        });

        scope.$watch('currentPointer', function(panel) {
            if (panel && !panel.current) {
                scope.showPanel(scope.panels.indexOf(panel));
            }
        });
    }

    /**
     * Responde ao evento em que um painel é exibido.
     */
    function onPanelShow(panel) {
        if (!panel._isLoadUnnecessary) {
            this.loadPanel(panel);
        }

        panel.onShow();
    }

    /**
     * Carrega um painel.
     * @param {*} panel Painel
     */
    function loadPanel(panel) {
        panel._isLoadUnnecessary = true;

        var promise = typeof panel.chartDataPromise == 'function' ? panel.chartDataPromise() : panel.chartDataPromise;

        if (promise) {
            panel.showLoading();
            promise.then(function(resp) {
                panel.buildModel(resp.data);
                panel._isLoadNeeded = false;
            }, function(err) {
                panel.showError();
                panel._isLoadUnnecessary = false;
            }).finally(function() {

                if (panel.loadHideContent) {
                    setTimeout(function() {
                        panel.hideLoading();
                    }, 400);
                } else {
                    panel.hideLoading();
                }
            });
        } else {
            panel._isLoadUnnecessary = false;
        }
    }

    /**
     * Aciona o indicativo de carregamento para um painel.
     * @param {*} panel Painel.
     */
    function showLoading(panel) {
        this.element.find('#' + panel.id).find('.dashboard_panel_load').fadeIn();
        this.element.find('#' + panel.id).find('.dashboard_panel_error').fadeOut();
    }

    /**
     * Esconde o indicativo de carregamento de um painel.
     * @param {*} panel Painel
     */
    function hideLoading(panel) {
        this.element.find('#' + panel.id).find('.dashboard_panel_load').fadeOut();
    }

    /**
     * Aciona o indicativo de error de um painel.
     * @param {*} panel Painel
     */
    function showError(panel) {
        this.element.find('#' + panel.id).find('.dashboard_panel_error').fadeIn();
    }

    /**
     * Ativa o reconhecimento do gesto swipe sobre um elemento.
     * @param {*} element Elemento.
     */
    function enableSwipe(element) {
        var self = this;
        detectswipe(element, function(el, d) {
            self.$timeout(function() {
                if (d == 'r') {
                    self.previous();
                } else if (d == 'l') {
                    self.next();
                }
            });
        });
    }

    /**
     * Obtem o painel atualmente sendo exibido.
     * @returns Objeto contendo o painel corrente e seu índice.
     */
    function currentPanel() {
        return this.panels.map(function(panel, i) {
            return {panel: panel, index: i};
        }).filter(function(obj) { return obj.panel.current; })[0];
    }

    /**
     * Exibe o painel anterior.
     */
    function previous() {
        if (this.panels.length > 1) {
            var current = this.currentPanel();

            if (current) {
                var currentIndex = current.index;
                var nextIndex = this.panels.length - 1;

                if (currentIndex > 0) {
                    nextIndex = currentIndex - 1;
                }

                var currentPanel = current.panel;
                var nextPanel = this.panels[nextIndex];

                this.slide(currentPanel, nextPanel, 'left-to-right');
            }
        }
    }

    /**
     * Exibe o próximo painel.
     */
    function next() {
        if (this.panels.length > 1) {
            var current = this.currentPanel();

            if (current) {
                var currentIndex = current.index;
                var nextIndex = 0;

                if (currentIndex < this.panels.length - 1) {
                    nextIndex = currentIndex + 1;
                }

                var currentPanel = current.panel;
                var nextPanel = this.panels[nextIndex];

                this.slide(currentPanel, nextPanel, 'right-to-left');
            }
        }
    }

    /**
     * Exibe o painel respectivo a um índice.
     * @param {*} index Índice no qual o painel se encontra. Inicia em 0.
     */
    function showPanel(index) {
        if (this.panels.length > 1) {       
            var next = this.panels[index];
            var current = this.currentPanel();

            if (next && current && current.index != index) {
                if (index == 0 && current.index == this.panels.length - 1 && this.panels.length > 2) {
                    this.slide(current.panel, next, 'right-to-left');
                } else if (current.index == 0 && index == this.panels.length - 1 && this.panels.length > 2) {
                    this.slide(current.panel, next, 'left-to-right');
                } else if (index < current.index) {
                    this.slide(current.panel, next, 'left-to-right');
                } else if (index > current.index) {
                    this.slide(current.panel, next, 'right-to-left');
                }
            }
        }
    }

    /**
     * Realiza o slide de um painel para outro.
     * @param {*} currentPanel Painel atual.
     * @param {*} nextPanel Próximo painel a ser exibido.
     * @param {*} slideType Direção da animação de slide.
     */
    function slide(currentPanel, nextPanel, slideType) {
        if (slideType == 'right-to-left') {
            $('#' + currentPanel.id).toggle('slide', {direction: 'left'}, 'slow');
            $('#' + nextPanel.id).toggle('slide', {direction: 'right'}, 'slow');
        } else {
            $('#' + currentPanel.id).toggle('slide', {direction: 'right'}, 'slow');
            $('#' + nextPanel.id).toggle('slide', {direction: 'left'}, 'slow');
        }

        currentPanel.current = false;
        nextPanel.current = true;

        if (this.currentPointer != nextPanel) {
            this.setCurrentPointer(nextPanel);
        }

        this.onPanelShow(nextPanel);
    }

    /**
     * Configura o indicador do painel atualmente em apresentação.
     * @param {*} panel Painel.
     */
    function _setCurrentPointer(panel) {
        this.currentPointer = panel;
    }

    /**
     * Realiza a detecção do movimento e swipe sobre um elemento.
     * @param {*} el Elemento.
     * @param {*} func Função callback que receberá o evento.
     */
    function detectswipe(el, func) {
        var swipe_det = new Object();
        swipe_det.sX = 0;
        swipe_det.sY = 0;
        swipe_det.eX = 0;
        swipe_det.eY = 0;
        var min_x = 20;  //min x swipe for horizontal swipe
        var max_x = 40;  //max x difference for vertical swipe
        var min_y = 40;  //min y swipe for vertical swipe
        var max_y = 50;  //max y difference for horizontal swipe
        var direc = "";

        var ele = el;
        ele.addEventListener('touchstart',function(e) {
            var t = e.touches[0];
            swipe_det.sX = t.screenX; 
            swipe_det.sY = t.screenY;
        });

        ele.addEventListener('touchmove',function(e) {
            var t = e.touches[0];
            swipe_det.eX = t.screenX; 
            swipe_det.eY = t.screenY;    
        });

        ele.addEventListener('touchend',function(e) {
            //horizontal detection
            if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y)))) {
                if(swipe_det.eX > swipe_det.sX) direc = "r";
                else direc = "l";
            }

            //vertical detection
            if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) && ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x)))) {
                if(swipe_det.eY > swipe_det.sY) direc = "d";
                else direc = "u";
            }

            if (direc != "") {
                if(typeof func == 'function') func(el,direc);
            }
            direc = "";
        });  
    }

})();
(function(){
  'use strict';

  angular.module('portal').directive('dropdownMultiselect', DropDownMultiselect);

  function DropDownMultiselect() {
    return {
      restrict: 'E',
      template: "<div class='btn-group' data-ng-class='{open: open}'>"+
      "<button class='btn btn-small'>Selecione</button>"+
      "<button class='btn btn-small dropdown-toggle' data-ng-click='open=!open;openDropdown()'><span class='caret'></span></button>"+
      "<ul class='dropdown-menu scrollable-menu' aria-labelledby='dropdownMenu'>" +
      "<li><a data-ng-click='selectAll()'>Selecionar Todos</a></li>" +
      "<li><a data-ng-click='deselectAll();'>Remover Seleção</a></li>" +
      "<li class='divider'></li>" +
      "<li data-ng-repeat='option in options'> " +
      " <a data-ng-click='setSelectedItem()' style='cursor: pointer;'>{{option.descricao}}<span data-ng-class='isChecked(option.codigo)'></span></a></li>" +
      "</ul>" +
      "</div>" ,
      controller: function($scope, $log, _){

        $scope.openDropdown = function(){
          $scope.selected_items = [];
          //for(var i = 0; i < $scope.pre_selected.length; i++){
          //  $scope.selected_items.push($scope.pre_selected[i].codigo);
          //}
        };

        $scope.selectAll = function () {
          $scope.model = _.pluck($scope.options, 'codigo');
          $log.debug($scope.model);
        };

        $scope.deselectAll = function() {
          $scope.model=[];
          $log.debug($scope.model);
        };

        $scope.setSelectedItem = function(){
          var codigo = this.option.codigo;
          if (_.contains($scope.model, codigo)) {
            $scope.model = _.without($scope.model, codigo);
          } else {
            $scope.model.push(codigo);
          }
          $log.debug('item selecionado' + $scope.model);
          return false;
        };

        $scope.isChecked = function (codigo) {
          if (_.contains($scope.model, codigo)) {
            return 'md md-check pull-right';
          }
          return false;
        };
      }
    }
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('enqueteWidget', EnqueteWidget);

  /** @ngInject */
  function EnqueteWidget(enqueteService) {
    return {
      restrict: 'EA',
      templateUrl: 'app/template/directives/enquete-widget.html',
      replace: true,
      link: function($scope) {
        $scope.enqueteService = new enqueteService($scope);
      }
    };
  }

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('formFiltro', FormFiltroDirective);

    /**
     * Diretiva para inclusão do formulário de filtro.
     */
    function FormFiltroDirective($q) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $q); },
            scope: {
                fields: '=',
                buttons: '=',
                model: '='
            },
            templateUrl: 'app/template/directives/form-filtro/form-filtro.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $q) {
        scope.$q = $q;
        scope.checkForLoad = checkForLoad;
        scope.onFormSumbit = function() { onFormSumbit.call(scope); };
        scope.onFormBtnClick = function(e, b) { onFormBtnClick.call(scope, e, b); };
        scope.onFieldChange = function(e, f) { onFieldChange.call(scope, e, f); };

        scope.checkForLoad();
    }

    /**
     * Carrega campos descarregados.
     */
    function checkForLoad() {
        var self = this;
        var unloaded = this.fields.filter(function(field) {
            return field.fnLoad != undefined && !field._loaded;
        });

        if (unloaded.length) {
            this.loading = true;

            this.$q.all(unloaded.map(function(field) {
                return field.fnLoad(self.fields);
            })).then(function(responses) {
                for (var i = 0; i < responses.length; i++) {
                    unloaded[i].options = responses[i];
                    unloaded[i]._loaded = true;
                }
            }).finally(function() {
                self.loading = false;
            });
        }
    }

    /**
     * Responde ao evento de mudança de um campo.
     * @param {*} event Evento disparado.
     * @param {*} field Objeto modelo do campo.
     */
    function onFieldChange(event, field) {
        if (field.onChange) {
            field.onChange(event, this.fields);
        }
        this.checkForLoad();
    }

    /**
     * Responde ao submit event sobre o formulário.
     * @param {*} evt Evento disparado.
     */
    function onFormSumbit(evt) {
        _filterOptions('submit', function(btn) {
            btn.callBack(evt);
        }, this.buttons);
    }

    /**
     * Responde ao evento de click sobre um botão.
     * @param {*} evt Evento disparado.
     * @param {*} btn Objecto modelo do botão.
     */
    function onFormBtnClick(evt, btn) {
        evt.preventDefault();
        btn.callBack(evt);
    }

    /**
     * Filtra as opções de um determinado tipo.
     * @param {*} type Tipo.
     * @param {*} callBack Callback para as opções.
     */
    function _filterOptions(type, callBack, options) {
        if (options) {
            options.filter(function(op) {
                return op.type == type;
            }).forEach(function(op) {
                callBack(op);
            });
        }
    }

})();
(function(){
  'use strict';

  angular.module('portal.acessibilidade').directive('fontResize', FontResize);

  /** @ngInject */
  function FontResize($rootScope, $document, $window, resizableElements) {
    return {
      restrict: 'E',
      scope: {
        decreaseMaxHits: '@',
        increaseMaxHits: '@',
        step: '@',
        controlElement: '@',
      },
      templateUrl: 'app/template/directives/fontResize.html',
      link: function(scope) {

        scope.rootScope = $rootScope;
        scope.decreaseFontSize = decreaseFontSize;
        scope.increaseFontSize = increaseFontSize;

        checkHitsCounter();

        // Registering listener to reset fontResize object when a new view is loaded
        $rootScope.$on('$viewContentLoaded', function(){
          delete $rootScope.fontResize;
        });

        function decreaseFontSize() {
          checkHitsCounter();
          var wasDecreased = false;
          getTargetElements().each(function(index, element){
            var elementsToChange = element.querySelectorAll(resizableElements);
            if($rootScope.fontResize.decreaseHits >= 0 
                && (($rootScope.fontResize.decreaseHits < scope.decreaseMaxHits) 
                    || !scope.decreaseMaxHits)){
              for (var i = 0; i < elementsToChange.length; i++) {
                decreaseElementFontSize(elementsToChange[i]);
              }
              wasDecreased = true;
            }
          });
          if(wasDecreased){
            handleDecreaseHits();
          }
        }

        function increaseFontSize() {
          checkHitsCounter();
          var wasIncreased = false;
          getTargetElements().each(function(index, element){
            var elementsToChange = element.querySelectorAll(resizableElements);
            if($rootScope.fontResize.increaseHits >= 0 
                && (($rootScope.fontResize.increaseHits < scope.increaseMaxHits) 
                  || !scope.decreaseMaxHits)){
              for (var i = 0; i < elementsToChange.length; i++) {
                increaseElementFontSize(elementsToChange[i]);
              }
              wasIncreased = true;
            }
          });
          if(wasIncreased){
            handleIncreaseHits();
          }
        }

        function checkHitsCounter(){
          if(!$rootScope.hasOwnProperty('fontResize')){
            $rootScope.fontResize = {
              increaseHits: 0,
              decreaseHits: 0
            };
          }
        }

        function getTargetElements(){
          var targets = scope.controlElement 
              ? angular.element($document.find(scope.controlElement))
              : angular.element(document);
          return targets;
        }

        function getElementFontSize(el){
          return $window.getComputedStyle(el, null).getPropertyValue('font-size').replace('px', '');
        }

        function setElementFontSize(el, fontSize, important){
          important = important ? 'important' : '';
          el.style.setProperty('font-size', fontSize + "px", important);
        }

        function decreaseElementFontSize(el) {
          var currentSize = getElementFontSize(el);
          var newSize = parseInt(currentSize) - parseInt(scope.step);
          setElementFontSize(el, newSize, true);
        }

        function increaseElementFontSize(el) {
          var currentSize = getElementFontSize(el);
          var newSize = parseInt(currentSize) + parseInt(scope.step);
          setElementFontSize(el, newSize, true);
        }

        function handleDecreaseHits() {
          if(scope.decreaseMaxHits){
            if($rootScope.fontResize.increaseHits === 0){
              $rootScope.fontResize.decreaseHits++;
            }else{
              $rootScope.fontResize.increaseHits--;
            }
          }
        }

        function handleIncreaseHits() {
          if(scope.increaseMaxHits){
            if($rootScope.fontResize.decreaseHits === 0){
              $rootScope.fontResize.increaseHits++;
            }else{
              $rootScope.fontResize.decreaseHits--;
            }
          }
        }
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('portal').directive('infinitableButtons', InfinitableButtons);

  function InfinitableButtons() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        scroll: '=',
        fnExibirForm: '&',
        hidefilterbtn: '='
      },
      templateUrl: 'app/template/directives/infinitable-buttons.html',
      controller: function($scope) {
        $scope.isScrollLessThen100 = function() {
          return $scope.scroll == undefined || $scope.scroll < 100;
        };

        $scope.exibirForm = function() {
          $scope.fnExibirForm()();
        };

        $scope.scrollTop = function() {
          $("body").animate({scrollTop: 0}, "slow");
          window.scrollTo(0, 0);
        }
      }
    }
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('format', Format);

  /** @ngInject */
  function Format($filter) {
    return {
      require: '?ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;


        ctrl.$formatters.unshift(function (a) {
          return $filter(attrs.format)(ctrl.$modelValue)
        });


        ctrl.$parsers.unshift(function (viewValue) {

          elem.priceFormat({
            prefix: '',
            centsSeparator: ',',
            thousandsSeparator: '.'
          });

          return elem[0].value;
        });
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('formControl', FormControl);

  /** @ngInject */
  function FormControl() {
    return {
      restrict: 'C',
      link: function(scope, element) {

        // Add class filled to form-control's that have a value
        if(element.val()){
          element.parent().addClass('filled');
        }

        element.bind('blur', function (e) {
          var input = angular.element(e.currentTarget);
          if(input.val()){
            input.parent().addClass('filled');
          } else {
            input.parent().removeClass('filled');
          }
          input.parent().removeClass('active');
        }).bind('focus', function (e) {
          var input = angular.element(e.currentTarget);
          input.parent().addClass('active');
        });

      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal.acessibilidade').directive('highContrast', HighContrast);

  /** @ngInject */
  function HighContrast($rootScope, $css) {
    var cssPath = 'styles/highContrast.css';

    return {
      restrict: 'E',
      scope: {
        hcOnLabel: "@",
        hcOffLabel: "@"
      },
      templateUrl: 'app/template/directives/highContrast.html',
      link: function(scope, elem) {
        scope.changeContrast = changeContrast;
        
        if($rootScope.hasOwnProperty('highContrast')){
          scope.hcActive = $rootScope.highContrast.active;
        }else{
          $rootScope.highContrast = {active: false};
        }

        scope.$watch('hcActive', function(isActive){
          isActive = !isActive ? false : true;
          $rootScope.highContrast.active = isActive;
        });

        function changeContrast(){
          if(scope.hcActive){
            enableContrast();
          }else{
            disableContrast();
          }
        }

        function enableContrast(){
          $css.add(cssPath);
          angular.element('body').addClass('high_contrast');
        }

        function disableContrast(){
          $css.remove(cssPath);
          angular.element('body').removeClass('high_contrast');
        }
      }
    };
  }
})();


(function(){
  'use strict';

  angular.module('portal').directive('infinitable', Infinitable);

  /** @ngInject */
  function Infinitable($compile){

    function insereCabecalho(scope, element) {
      var linhaCabecalho = element.find('thead tr');
      _.each(scope.colunas, function (value, key) {
        var th = '<th  ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')">' + value.nome + '</th>';
        linhaCabecalho.append($compile(th)(scope));
      });
      if (scope.fnVisualizar || scope.fnDownload) {
        linhaCabecalho.append('<th class="text-right"></th>');
      }
    }

    function insereTotalizador(scope, element) {
      if(!scope.totalizar) return;

      var cabecalho = element.find('thead');
      var linhaTotalizadora = '';
      var numeroColunas = 0;

      _.each(scope.colunas, function (value, key) {
        if(value.currency) {
          linhaTotalizadora += '<th ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')">{{ dados.totalizador[\'' + key + '\'] | currency:\'\' }}</th>';
        } else {
          linhaTotalizadora += '<th ng-show="showColumn(\'' + key + '\')">' + ((numeroColunas == 0) ? 'Total':'') + '</th>';
        }

        numeroColunas++;
      });

      if (scope.fnVisualizar || scope.fnDownload) {
        linhaTotalizadora += '<th></th>';
      }

      cabecalho.append($compile('<tr>' + linhaTotalizadora + '</tr>')(scope));
    }

    function insereLinhas(scope, element) {
      var linha = '<tr ng-repeat="(key, value) in dados.content" ng-click="value.selected=!value.selected" ng-dblclick="visualizar(value)">'
        + insereColunas(scope) + '</tr>';
      var tbody = element.find('tbody');
      tbody.append($compile(linha)(scope));
    }

    function insereColunas(scope) {
      var colunas = '';

      _.each(scope.colunas, function (value, key) {
        if(value.link1 && scope.link1) {
          colunas += '<td ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')"><a ng-click="link1(value)">{{ value.' + key + (defineFiltro(value)) + '}}</a></td>';

        } else if(value.link2 && scope.link2) {
          colunas += '<td ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')"><a ng-click="link2(value)">{{ value.' + key + (defineFiltro(value)) + '}}</a></td>';

        } else if(value.link3 && scope.link3) {
          colunas += '<td ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')"><a ng-click="link3(value)">{{ value.' + key + (defineFiltro(value)) + '}}</a></td>';

        } else {
          colunas += '<td ng-class="{\'text-right\':' + value.currency + '}" ng-show="showColumn(\'' + key + '\')">{{ value.' + key + (defineFiltro(value)) + '}}</td>';
        }
      });

      if (scope.fnVisualizar) {
        colunas += '<td class="text-right" ng-click="$event.stopPropagation()">'
              +'<button type="button" class="btn btn-link btn-round" data-title="Detalhar Informações" ng-click="visualizar(value)">'
              +'<i class="md md-add"></i></button></td>';
      }

      if(scope.fnDownload) {
        colunas += '<td class="text-right" ng-click="$event.stopPropagation()">'
          +'<button type="button" class="btn btn-link btn-round" data-title="Detalhar Informações" ng-click="download(value)">'
          +'<i class="md md-get-app"></i></button></td>';
      }

      return colunas;
    }

    function defineFiltro(value) {
      if(value.currency) { //TODO: depreciado, refatorar as listas
        return ' | currency:\'\'';

      } else if(value.date) { //TODO: depreciado, refatorar as listas
        return ' | date:\'dd/MM/yyyy\'';

      } else if(value.filter) {
        return ' | ' + value.filter.name;

      } else {
        return '';
      }
    }

    return {
      restrict: 'EA',
      replace: true,
      transclude: true,
      scope: {
        dados: '=',
        colunas: '=',
        onCloseColunas:'&?',
        totalizar: '@?',
        fnVisualizar: '&?',
        fnDownload: '&?',
        fnExportar: '&?',
        fnVoltar: '&?',
        fnLink1: '&?',
        fnLink2: '&?',
        fnLink3: '&?'
      },
      templateUrl: 'app/template/directives/infinitable.html',
      controller: function($scope, $aside, PagingService) {

        $scope.showColumn = function(nome) {
          return $scope.colunas[nome].visible;
        };

        $scope.fecharModalColunas = function() {
          return $scope.onCloseColunas()();
        };

        $scope.visualizar = function(linha) {
          $scope.fnVisualizar()(linha);
        };

        $scope.download = function(linha) {
          $scope.fnDownload()(linha);
        };

        $scope.link1 = function(linha) {
          $scope.fnLink1()(linha);
        };

        $scope.link2 = function(linha) {
          $scope.fnLink2()(linha);
        };

        $scope.link3 = function(linha) {
          $scope.fnLink3()(linha);
        };

        $scope.voltar = function() {
          $scope.fnVoltar()();
        };

        $scope.exportar = function() {
          var form = $scope.dados.form;
          form.colunas = $scope.colunas;
          $scope.fnExportar()(form);
        }

        $scope.proximaPagina = function() {
          if ($scope.dados.settings.busy || $scope.dados.last) return;
          $scope.dados.settings.busy = true;
          $scope.dados.form.page += 1;
          pesquisa();
        };

        $scope.ordenar = function (nomeColuna) {
          $scope.dados.form.sort.push(nomeColuna + ',asc');
          $scope.dados.content = [];
          pesquisa();
        };

        var pesquisa = function() {
          PagingService.pesquisar($scope.dados).then(
            function (response) {
              //if(response.totalElements > 0 && $scope.dados.form.editing) hideForm();
            },
            function () {
              //hideForm();
            }
          );
        };
      },
      link: function($scope, $element) {
        insereCabecalho($scope, $element);
        insereTotalizador($scope, $element);
        insereLinhas($scope, $element);
      }
    };
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('initRipples', InitRipples);

  /** @ngInject */
  function InitRipples() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var withRipples = [
          '.btn:not(.withoutripple)',
          '.card-image',
          '.navbar a:not(.withoutripple)',
          '.dropdown-menu a',
          '.nav-tabs a:not(.withoutripple)',
          '.withripple'
        ].join(',');

        $(element).find(withRipples).ripples();
      }
    };
  }

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('internalHeader', Directive);

    /**
     * Diretiva para inclusão de componente correspondente ao cabeçario de uma página interna.
     */
    function Directive($sce, $filter) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $sce, $filter); },
            scope: {
                fnInit: '&?',
                pageTitle: '@',
                pageDescription: '@?',
                updateDate: '@?'
            },
            templateUrl: 'app/template/directives/internal-header/internal-header.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $sce, $filter) {
        scope.$sce = $sce;
        scope.$filter = $filter;
        scope.setTitle = setTitle;
        scope.setDescription = setDescription;
        scope.setUpdateDate = setUpdateDate;

        scope.$watch('pageTitle', function(newVal) {
            scope.setTitle(newVal);
        });

        scope.$watch('pageDescription', function(newVal) {
            scope.setDescription(newVal);
        });

        scope.$watch('updateDate', function(newVal) {
            scope.setUpdateDate(newVal);
        });

        if (angular.isDefined(scope.fnInit)) {
            scope.fnInit()();
        }
    }

    /**
     * Configura a propriedade título.
     * @param {*} title Valor a ser atribuído.
     */
    function setTitle(title) {
        if (title != undefined) {
            this.pageTitleHtml = this.$sce.trustAsHtml(title);
        }
    }

    /**
     * Configura a propriedade descrição.
     * @param {*} title Valor a ser atribuído.
     */
    function setDescription(desc) {
        if (desc != undefined) {
            this.pageDescriptionHtml = this.$sce.trustAsHtml(desc);
        }
    }

    /**
     * Configura a propriedade correspodente a data de atualização.
     * @param {*} title Valor a ser atribuído.
     */
    function setUpdateDate(dateValue) {
        if (dateValue) {
            var date;

            function isNumber(o) {
                return ! isNaN (o-0) && o !== null && o !== "" && o !== false;
            }

            var date = isNumber(dateValue) ? new Date(Number(dateValue)) : new Date(dateValue.replace(/"/g, ''));

            this.updateDateStr = this.$filter('date')(date, 'dd/MM/yyyy');

            if (this.updateDateStr == 'Invalid Date') {
                this.updateDateStr = undefined;
            }
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('mediaPanel', MediaPanel);

    /**
     * Diretiva para inclusão do painel de compartilhamento.
     */
    function MediaPanel() {
        return {
            restrict: 'E',
            link: link,
            scope: {},
            templateUrl: 'app/template/directives/mediapanel/media-panel.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onClickShareBtn = onClickShareBtn;
        scope.medias = MEDIAS_LIST;
    }

    /**
     * Responde ao evento de click sobre o botão share
     */
    function onClickShareBtn() {
        $('.media_panel_link_redes').toggle();

        var $btn = $('.media_panel_link_share');

        if ($btn.hasClass('opened')) {
            $btn.removeClass('opened');
        } else {
            $btn.addClass('opened');
        }
    }

    var MEDIAS_LIST = [
        {
            icon: 'fa-facebook-square',
            title: 'Facebook',
            href: 'https://www.facebook.com/govdf?ref=ts&fref=ts',
            newtab: 'true'
        },{
            icon: 'fa-instagram',
            title: 'Instagram',
            href: 'https://instagram.com/gov_df/',
            newtab: 'true'
        },{
            icon: 'fa-twitter',
            title: 'Twitter',
            href: 'https://twitter.com/gov_df',
            newtab: 'true'
        },{
            icon: 'fa-youtube-play',
            title: 'Youtube',
            href: 'https://www.youtube.com/user/govdf',
            newtab: 'true'
        }
    ];

})();
/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('menuLink', MenuLink);

  /** @ngInject */
  function MenuLink() {
    return {
      restrict: 'A',
      transclude: true,
      replace: true,
      scope: {
        href: '@',
        icon: '@',
        name: '@'
      },
      templateUrl: 'app/template/directives/menu-link.html',
      controller: ['$element', '$location', '$rootScope', function($element, $location, $rootScope) {
        this.getName = function(name) {
          if ( name !== undefined ) {
            return name;
          } else {
            return $element.find('a').text().trim();
          }
        };

        this.setBreadcrumb = function(name) {
          $rootScope.pageTitle = this.getName(name);
        };

        this.isSelected = function(href) {
          if (href == undefined) {
            return false;
          }
          return $location.path() == href.slice(1, href.length);
        };
      }],
      link: function(scope, element, attrs, linkCtrl) {
        var icon = attrs.icon;
        if ( icon ) {
          element.children().first().prepend('<i class="' + icon + '"></i>&nbsp;');
        }

        if ( linkCtrl.isSelected(attrs.href) ) {
          linkCtrl.setBreadcrumb(attrs.name);
        }

        element.click(function(){
          linkCtrl.setBreadcrumb(attrs.name);
        });

        element.find('a').ripples();

        scope.isSelected = function() {
          return linkCtrl.isSelected(attrs.href);
        };
      }
    };
  }

})();

(function() {

  angular.module('portal').directive('menuToggle', MenuToggle);

  /** @ngInject */
  function MenuToggle($location) {
    return {
      restrict: 'A',
      transclude: true,
      replace: true,
      scope: {
        name: '@',
        icon: '@'
      },
      templateUrl: 'app/template/directives/menu-toggle.html',
      link: function(scope, element, attrs) {
        var icon = attrs.icon;
        if ( icon ) {
          element.children().first().prepend('<i class="' + icon + '"></i>&nbsp;');
        }

        element.children().first().on('click', function(e) {
          e.preventDefault();
          var link = angular.element(e.currentTarget);

          if( link.hasClass('active') ) {
            link.removeClass('active');
          } else {
            link.addClass('active');
          }
        });

        element.find('a').ripples();

        scope.isOpen = function() {
          var folder = '/' + $location.path().split('/')[1];
          return folder == attrs.path;
        };
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('navbarScroll', NavbarScroll);

  /** @ngInject */
  function NavbarScroll($window) {
    return {
      restrict: 'A',
      link: function() {
        var navbar = angular.element('.main-container .navbar');
        angular.element($window).bind('scroll', function() {
          if (this.pageYOffset > 0) {
            navbar.addClass('scroll');
          } else {
            navbar.removeClass('scroll');
          }
        });
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('navbarSearch', NavbarSearch);

  /** @ngInject */
  function NavbarSearch() {
    return {
      restrict: 'A',
      templateUrl: 'app/template/directives/navbar-search.html',
      link: function(scope) {
        scope.showNavbarSearch = false;

        scope.toggleSearch = function(){
          scope.showNavbarSearch = !scope.showNavbarSearch;
        };

        scope.submitNavbarSearch = function(){
          scope.showNavbarSearch = false;
        };
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('navbarToggle', NavbarToggle);

  /** @ngInject */
  function NavbarToggle() {
    return {
      restrict: 'C',
      link: function(scope, element) {
        element.sideNav({ menuWidth: 260, closeOnClick: true });
      }
    };
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('nouiSlider', NouiSlider);

  /** @ngInject */
  function NouiSlider() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {

        var start, startPoint, range, step, v2, v;

        var bind = angular.element(attrs.bind);
        var bindRange = angular.element(attrs.bindRange);
        var indicator = angular.element(attrs.indicator);

        if ( bind.length ) start = bind.val();

        // setting range or start
        start = ( attrs.start ? attrs.start : 0 );
        range = ( attrs.range ? attrs.range : 0 );

        if(range){
          startPoint = [start, range];
          element.addClass('noUi-range');
        } else {
          startPoint = [start];
        }

        // settings
        step = ( attrs.step ? parseInt(attrs.step) : 0 );
        min = ( attrs.min ? parseInt(attrs.min) : 0 );
        max = ( attrs.max ? parseInt(attrs.max) : 10 );

        $(element).noUiSlider({
          start: startPoint,
          step: step,
          range: {
            'min': [ min ],
            'max': [ max ]
          }
        });

        if ( indicator.selector === 'true' ) {
          $(element).on('slide set change', function(a,b){
            if( !$(this).find('.noUi-handle div').length ){
              $(this).find('.noUi-handle').append('<div>'+b+'</div>');
            }
            $(this).find('.noUi-handle div').html(b);
          });
        }

        $(element).on('slide', function(a,b){

          if ( bindRange.length ) {
            v = parseInt(b[0]);
            v2 = parseInt(b[1]);
          } else {
            v = parseInt(b);
          }

          if ( bind.length ) {
            if (bind[0].value !== undefined) {
              bind.val(v);
            } else {
              bind.html(v);
            }
          }

          if ( bindRange.length ) {
            if (bindRange[0].value !== undefined) {
              bindRange.val(v2);
            } else {
              bindRange.html(v2);
            }
          }
        });
      }
    };
  }

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('painelTabela', PainelTabelaDirective);

    /**
     * Diretiva para inclusão do painel de opções da tabela de consulta.
     */
    function PainelTabelaDirective($uibModal, $modal) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $uibModal, $modal); },
            scope: {
                options: '='
            },
            templateUrl: 'app/template/directives/painel-tabela/painel-tabela.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $uibModal, $modal) {
        element.addClass('internal_page_padding');
        scope.$uibModal = $uibModal;
        scope.$modal = $modal;
        scope._filterOptions = _filterOptions;
        scope.onClickBtnModalTemplate = function(e) { onClickBtnModalTemplate.call(scope, e); };
        scope.fecharModalColunas = function(e) { onColunasModalClose.call(scope, e); };

        scope._filterOptions('colunas', function(op) {
            scope.colunas = op.config.colunas;
        });

        scope._filterOptions('bs-modal', function(op) {
            if (op.config.scope) {
                Object.keys(op.config.scope).forEach(function(key) {
                    scope[key] = op.config.scope[key];
                });
            }
        });

        scope.backButton = scope.options.filter(function(op) {
            return op.type == 'back-button';
        })[0];
    }

    /**
     * Responde ao evento de click no botão de avaliação.
     * @param {*} event Evento disparado.
     */
    function onClickBtnModalTemplate(evt) {
        var template = evt.currentTarget.getAttribute('modal-template');
        var ctrl = evt.currentTarget.getAttribute('modal-ctrl');

        if (ctrl) {
            this.$uibModal.open({
                templateUrl: template,
                controller: ctrl
            });
        } else {
            this.$modal({
                template: template
            });
        }
    }

    /**
     * Responde ao evento de fechamento do modal de colunas.
     * @param {*} event Evento disparado.
     */
    function onColunasModalClose(event) {
        this._filterOptions('colunas', function(op) {
            op.config.onClose();
        });
    }

    /**
     * Filtra as opções de um determinado tipo.
     * @param {*} type Tipo.
     * @param {*} callBack Callback para as opções.
     */
    function _filterOptions(type, callBack) {
        if (this.options) {
            this.options.filter(function(op) {
                return op.type == type;
            }).forEach(function(op) {
                callBack(op);
            });
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('printSection', PrintSection);
    angular.module('portal').directive('printBtn', PrintButton);
    angular.module('portal').directive('printTable', PrintTable);
    angular.module('portal').directive('printIf', PrintIf);

    /**
     * Diretiva utilizada para demarcação de conteúdo para impressão.
     */
    function PrintSection() {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                element[0].classList.add('printSection');
            }
        };
    }

    /**
     * Diretiva utilizada para acionar a impressão a partir de um click sobre um elemento.
     */
    function PrintButton($window, $timeout, $css) {
        return {
            restrict: 'A', 
            link: function(scope, element, attr) {
                element.on('click', function() {
                    $css.add('styles/print.css');

                    $window.onafterprint = function() {
                        $css.remove('styles/print.css');
                    };

                    $timeout(function() {
                        $window.print();
                    }, 0);
                });
            }
        };
    }

    /**
     * Diretiva utilizada para demarcação de uma tabela para impressão.
     */
    function PrintTable($window, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {

                scope.$watch(attr.printTable, function makeTable(value) {
                    setTimeout(function() {
                        if(value == null) return;
                        var elem = element[0];
                        elem.classList.add('printSection');
                        elem.id = 'print-table';
                        var tds = elem.getElementsByTagName('td');
                        for(var i = 0, content, div; i < tds.length; i++){
                            content = tds[i].innerHTML;
                            tds[i].innerHTML = '';
                            div = document.createElement('div');
                            div.className = 'avoidPageBreak';
                            div.innerHTML = content;
                            tds[i].appendChild(div);
                        }
                        element[0] = elem;
                    }, 1000);
                });

            }
        };
    }

    /**
     * Diretiva utilizada para condicionalmente determinar se uma elemento irá para impressão ou não.
     */
    function PrintIf() {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                scope.$watch(attr.printIf, function applyPrint(value){
                    if ('printOnly' in attr) {
                        $animate[toBoolean(value) ? 'removeClass' : 'addClass'](element, 'printRemove');
                    } else {
                        $animate[toBoolean(value) ? 'addClass' : 'removeClass'](element, 'printSection');
                    }
                });
            }
        };
    }

    /**
     * Realiza o parse de um dado para um valor boleano.
     * @param {*} value Dado.
     * @returns boolean.
     */
    function toBoolean(value) {
        if (typeof value === 'function') {
          value = true;
        } else if (value && value.length !== 0) {
          var v = lowercase('' + value);
          value = !(v == 'f' || v == '0' || v == 'false' || v == 'no' || v == 'n' || v == '[]');
        } else {
          value = false;
        }
        return value;
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('quadroEntidades', QuadroEntidades);

    /**
     * Diretiva para inclusão de um quadro temático.
     */
    function QuadroEntidades($window) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $window); },
            scope: {
                promise: '=entidades'
            },
            templateUrl: 'app/template/directives/quadro-entidades/quadro-entidades.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $window) {
        scope.$element = element;
        scope.$window = $window;

        scope.onClickGrupo = onClickGrupo;
        scope.onClickEntidade = onClickEntidade;
        scope.onSeachValueChange = onSeachValueChange;
        scope.updateListModel = updateListModel;
        scope.loadEntidades = loadEntidades;
        scope.isSearchEnabled = false;
        scope.searchDisabled = true;
        scope.textFilter = new TextFilterModel();
        scope.grupoFilter = new GroupFilterModel();

        scope.$watch('promise', function(newVal) {
            if (newVal) {
                scope.loadEntidades(newVal);
            }
        });
    }

    /**
     * Carrega o quadro de entidades.
     * @param {*} promise Promise para os dados.
     */
    function loadEntidades(promise) {
        var self = this;

        this.searchDisabled = true;
        this.listModel = new ListModel(Array.apply(null, {length: 9}).map(function() { return { loading: true }; }));

        promise.then(function(entidades) {
            self.listModel = new ListModel(entidades.data);
            self.grupos = mapToGrupos(entidades.data);

            self.searchDisabled = false;
        }, function(err) {
            self.listModel = new ListModel(Array.apply(null, {length: 9}).map(function() { return { loading: true, error: true }; }));
        }, function() {

        });
    }

    /**
     * Responde ao evento de click em um grupo.
     * @param {*} grupo Grupo
     */
    function onClickGrupo(grupo) {
        grupo.selected ? this.grupoFilter.removeValue(grupo.value) : this.grupoFilter.addValue(grupo.value);
        grupo.selected = !grupo.selected;
        
        this.updateListModel();
    }

    /**
     * Responde ao evento de click em uma entidade.
     * @param {*} entidade Entidade.
     */
    function onClickEntidade(entidade) {
        this.$window.open(entidade.urlDestino, '_blank');
    }

    /**
     * Responde ao evento de mudança do valor da barra de busca
     * @param {*} value Valor.
     */
    function onSeachValueChange(value) {
        this.isSearchEnabled = value.length > 0;

        this.textFilter.setFilterValue(value);
        
        this.updateListModel();
    }

    /**
     * Atualiza a lista de entidades de acordo com os filtros correntes.
     */
    function updateListModel() {
        var textFilter = this.textFilter;
        var grupoFilter = this.grupoFilter;

        this.listModel.filter(function(entidade) {
            return (textFilter.match(entidade.sigla)
                    || textFilter.match(entidade.nome))
                    && grupoFilter.match(entidade.tipo);
        });
    }

    /**
     * Identifica os gupos de um conjunto de entidades.
     * @param {*} entidades Entidades.
     */
    function mapToGrupos(entidades) {
        var tipos = entidades.map(function(entidate) {
            return entidate.tipo;
        });

        return tipos.filter(function(item, pos) {
            return tipos.indexOf(item) == pos;
        }).map(function(tipo) {
            return {
                name: tipo,
                value: tipo,
                selected: false
            };
        }).sort(function(g1, g2) {
            var priorityOnes = ['DIRETA', 'REGIONAL', 'INDIRETA'];

            var index1 = priorityOnes.indexOf(g1.value);
            var index2 = priorityOnes.indexOf(g2.value);

            if (index1 == -1 && index2 == -1) {
                return 0;
            } else if (index1 != -1 && index2 != -1) {
                return index1 - index2;
            } else if (index1 != -1) {
                return -1;
            } else {
                return 1;
            }
        });
    }

    /**
     * Model da lista.
     */
    var ListModel = (function() {
        function ListModelClass(entities) {
            this.entitiesSource = entities;
            this.entities = entities.slice();
        }
        ListModelClass.prototype.filter = function(filterFunction) {
            this.entities = this.entitiesSource.filter(filterFunction);
        };
        ListModelClass.prototype.isEmpty = function() {
            return this.entities.length == 0;
        };

        return ListModelClass;
    })();

    /**
     * Model do filtro textual.
     */
    var TextFilterModel = (function() {
        function FilterModelClass() {
            this.filterValue = '';
            this.caseSensitive = false;
        }
        FilterModelClass.prototype.setFilterValue = function(value) {
            this.filterValue = value;
        };
        FilterModelClass.prototype.match = function(value) {
            var filterValue = this.filterValue;

            if (!filterValue) {
                return true;
            }

            if (!value) {
                return false;
            }

            if (!this.caseSensitive) {
                value = value.toUpperCase();
                filterValue = filterValue.toUpperCase();
            }

            if (value.indexOf(filterValue) == -1) {
                return false;
            }

            return true;
        };

        return FilterModelClass;
    })();

    /**
     * Model do filtro para grupos.
     */
    var GroupFilterModel = (function() {
        function FilterModelClass() {
            this.values = [];
        }
        FilterModelClass.prototype.addValue = function(value) {
            var index = this.values.indexOf(value);

            if (index == -1) {
                this.values.push(value);
            }
        };
        FilterModelClass.prototype.removeValue = function(value) {
            var index = this.values.indexOf(value);

            if (index != -1) {
                this.values.splice(index, 1);
            }
        };
        FilterModelClass.prototype.setFilterValue = function(values) {
            this.values = values;
        };
        FilterModelClass.prototype.match = function(value) {
            if (this.values.length == 0) {
                return true;
            }
            return this.values.indexOf(value) != -1;
        };

        return FilterModelClass;
    })();

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('quadroTematico', QuadroTematico);

    /**
     * Diretiva para inclusão de um quadro temático.
     */
    function QuadroTematico($timeout) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $timeout) ;},
            scope: {
                headTitle: '@',
                icon: '@',
                promise: '=',
                page: '='
            },
            templateUrl: 'app/template/directives/quadro-tematico/quadro-tematico.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $timeout) {
        scope.$element = element;
        scope.$timeout = $timeout;
        scope.loadData = loadData;
        scope.reload = reload;
        scope.nextPage = nextPage;
        scope.previousPage = previousPage;
        scope.setData = setData;
        scope.isAnyPreviousPages = isAnyPreviousPages;
        scope.isAnyNextPages = isAnyNextPages;
        scope.onSwipeListener = onSwipeListener;
        scope.projetos = [{}, {}, {}, {}];

        scope.$watch('promise', function(promise) {
            if (promise) {
                scope.loadData(promise, scope.page);
            }
        });
    }

    /**
     * Recarrega os dados do quadro.
     */
    function reload() {
        if (this.promise) {
            this.loadData(this.promise, this.page);
        }
    }

    /**
     * Carrega os dados a partir de uma promise.
     * @param {*} promise Promise.
     */
    function loadData(promise, page) {
        var self = this;

        this.$element.addClass('loading');
        self.error = false;

        promise(page).then(function(data) {
            self.setData(data);
        }, function(err) {
            self.error = true;
        }).finally(function() {
            self.$element.removeClass('loading');
        });
    }

    /**
     * Configura os dados do quadro.
     * @param {*} data Dados.
     */
    function setData(data) {
        if (this.projetos && this.projetos.length) {
            var currentArray = this.projetos;
            var newArray = data.projetos;

            newArray.forEach(function(proj, i) {
                if (currentArray.length > i) {
                    Object.keys(proj).forEach(function(key) {
                        currentArray[i][key] = proj[key];
                    });
                }
            });

            if (currentArray.length > newArray.length) {
                currentArray.splice(newArray.length, currentArray.length - newArray.length);
            } else if (currentArray.length < newArray.length) {
                newArray.slice(currentArray.length).forEach(function(proj) {
                    currentArray.push(proj);
                });
            }
        } else {
            this.projetos = data.projetos;
        }

        this.total = data.total;
    }

    /**
     * Avança a página do quadro.
     */
    function nextPage() {
        if (this.isAnyNextPages()) {
            this.page += 1;

            this.reload();
        }
    }

    /**
     * Retrocede a página do quadro.
     */
    function previousPage() {
        if (this.isAnyPreviousPages()) {
            this.page -= 1;

            this.reload();
        }
    }
    
    /**
     * Verifica se existe páginas anteriores disponíveis.
     * @returns true, há mais páginas; false, caso contrário.
     */
    function isAnyPreviousPages() {
        return this.page > 1;
    }

    /**
     * Verifica se existe páginas a frente.
     * @returns true, há mais páginas; false, caso contrário
     */
    function isAnyNextPages() {
        return true;
    }

        /**
     * Responde ao evento de swipe sobre o painel de quadros.
     * @param {*} direction Constante que identifica a direção do gesto.
     */
    function onSwipeListener(direction) {
        if (direction == 'd') {
            this.previousPage();
        } else if (direction == 'u') {
            this.nextPage();
        }
    }

})();
(function(){
  'use strict';

  angular.module('portal').directive('readOnlyRow', ReadOnlyRowDirective);

  /** @ngInject */
  function ReadOnlyRowDirective() {
    return {
      restrict: 'A',
      transclude: true,
      replace: true,
      scope: {
        value: '='
      },
      templateUrl: 'app/template/directives/read-only-row.html',
    };
  };

})();

(function(){
  'use strict';

  angular.module('portal').directive('readOnly', ReadOnlyDirective);

  /** @ngInject */
  function ReadOnlyDirective() {
    return {
      restrict: 'A',
      transclude: true,
      replace: true,
      scope: {
        value: '='
      },
      templateUrl: 'app/template/directives/read-only.html',
    };
  };

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('scrollSpy', ScrollSpy);

  /** @ngInject */
  function ScrollSpy($window) {
    return {
      link: function(scope, element, attrs) {
        angular.element($window).bind('scroll', function() {
          scope.scroll = this.pageYOffset;
          if(!scope.$$phase) {
            scope.$apply();
          }
        });
      }
    };
  }

})();

(function(){
  'use strict';

  angular.module('portal').directive('scrolltop', ScrollTop);

  function ScrollTop() {
    return {
      restrict: 'E',
      replace: true,
      template: '<div class="btn btn-default btn-round btn-lg m-r-10 btn-footer" scroll-to="top" ng-hide="scroll<100" data-title="Rolar para cima" bs-tooltip><i class="md md-arrow-drop-up"></i></div>'
    }
  }

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('searchBar', SearchBar);

    /**
     * Diretiva para inclusão da barra de super busca.
     */
    function SearchBar() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                inputValue: '=value',
                onSearchListener: '=onsearch',
                loadingFlag: '=loadingflag',
                minLength: '=minlength',
                placeholder: '@?'
            },
            templateUrl: 'app/template/directives/searchbar/searchbar.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        var _scope = {};

        _scope.scope = scope;
        _scope.$input = element.find('input.sb_input');
        _scope.$iconRight = element.find('.sb_search_icon_right');
        _scope.$iconRightSearch = element.find('.sb_search_icon_right.fa-search');
        _scope.$iconLoading = element.find('.sb_search_icon_loading');
        _scope.$button = element.find('.sb_search_button_link');
        _scope.transitionTime = 200;
        _scope.barState = 'blur';

        _scope.onInputFocus = onInputFocus;
        _scope.onInputBlur = onInputBlur;
        _scope.onInvalidInputLengthTry = onInvalidInputLengthTry;
        _scope.enableLoading = enableLoading;
        _scope.isEmptyInput = isEmptyInput;
        _scope.search = search;
        _scope.getValue = getValue;
        _scope.onBtnSearchClick = onBtnSearchClick;
        _scope.onInputKeyPress = onInputKeyPress;

        _scope.$input.bind('focus', function() {
            _scope.onInputFocus();
        });

        _scope.$input.bind('blur', function() {
            _scope.onInputBlur();
        });

        _scope.scope.onClickSearchBtn = function(e) {
            _scope.onBtnSearchClick(e);
        };

        _scope.scope.onInputKeyPress = function(e) {
            _scope.onInputKeyPress(e);
        };

        scope.$watch('inputValue', function(newVal, oldVal) {
            if (newVal) {
                _scope.$input.focus();
            }
        });

        scope.$watch('loadingFlag', function(newVal, oldVal) {
            _scope.enableLoading(newVal);
        });
    }

        /**
     * Responde ao evento de key press no campo de entrada.
     * @param {*} $event Evento.
     */
    function onInputKeyPress($event) {
        if ($event.keyCode == 13) {
            this.onBtnSearchClick();
        }
    }

    /**, 
     * Controla a habilitação do loading.
     * @param {*} enable True, habilita a indicação de loading; false, desabilita.
     */
    function enableLoading(enable) {
        var self = this;

        if (enable) {
            this.$iconRightSearch.hide('fast', function() {
                self.$iconLoading.show();
            });
        } else {
            this.$iconLoading.hide('fast', function() {
                self.$iconRightSearch.show();
            });
        }
    }

    /**
     * Responde ao evento de click no botão de busca.
     */
    function onBtnSearchClick(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.search(this.getValue());
    }

    /**
     * Executa a ação de busca de um valor.
     * @param {*} value Valor.
     */
    function search(value) {
        var minLength = Number(this.scope.minLength);
        minLength = minLength ? minLength : 0;

        if (minLength > 0) {
            if (value.trim().length >= minLength) {
                this.scope.onSearchListener(value);
            } else {
                this.onInvalidInputLengthTry();
            }
        } else {
            this.scope.onSearchListener(value);
        }
    }

    /**
     * Verifica o a entrada está vazia.
     */
    function isEmptyInput() {
        return this.getValue().trim().length == 0;
    }

    /**
     * Obtem o corrente valor presente na barra de busca.
     */
    function getValue() {
        return this.$input.val();
    }

    /**
     * Responde ao evento de fucus no input da busca.
     */
    function onInputFocus() {
        if (this.barState == 'blur') {
            this.barState = 'focus';

            /*this.$iconRight.animate({ right: "+=40" }, this.transitionTime);*/
        }
    }

    /**
     * Responde ao evento de blur no input da busca.
     */
    function onInputBlur() {
        if (this.isEmptyInput()) {
            this.barState = 'blur';
            
            /*this.$iconRight.animate({ right: "-=40" }, self.transitionTime);*/
        }
    }

    /**
     * Responde ao evento de entrada de um valor de tamanho inválido.
     */
    function onInvalidInputLengthTry() {
        var self = this;

        this.$input.css('box-shadow', 'inset 0 -2px 0 #e53935');

        setTimeout(function() {
            self.$input.css('box-shadow', '');
        }, 500);
    }

})();
(function(){
  'use strict';

  angular.module('portal').directive('selectMultiplo', SelectMultiplo);

  /** @ngInject */
  function SelectMultiplo() {
    return {
      restrict: 'E',
      replace: true,
      require: 'ngModel',
      scope: {
        title: '@',
        data: '=',
        keyName: '@?',
        valueName: '@?'
      },
      templateUrl: 'app/template/directives/select-multiplo.html',
      controller: function($scope) {
        $scope.keyName = angular.isDefined($scope.keyName) ? $scope.keyName : 'codigo';
        $scope.valueName = angular.isDefined($scope.valueName) ? $scope.valueName : 'nome';
      }
    }
  }

})();

(function() {
  'use strict';

  angular.module('portal').directive('share', Share);

  /** @ngInject */
  function Share( $modal ) {
    return {
      restrict: 'E',
      templateUrl: 'app/template/directives/share.html',
      link: function(scope, element, attrs){
        scope.url = element[0].baseURI;
        element.bind('click', function(){
          $modal({
              template: 'app/template/directives/share-modal.html',
              controller: 'ShareController',
              scope: scope
          });
        });
      }
    };
  }

})();


(function() {
    'use strict';
    
    angular.module('portal').directive('simpleSearchbar', SimpleSearchbar);

    /**
     * Diretiva para inclusão de uma barra de busca.
     */
    function SimpleSearchbar($timeout) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $timeout); },
            scope: {
                placeholder: '@?',
                onChange: '&?onvaluechange',
                onEnter: '&?onenter',
                disabled: '='
            },
            templateUrl: 'app/template/directives/simple-searchbar/simple-searchbar.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $timeout) {
        scope.$element = element;
        scope.onInputKeyPress = onInputKeyPress;
        scope.onInputChange = onInputChange;
        scope.onClickCloseButton = onClickCloseButton;
        scope.inputValue = null;
    }

    /**
     * Responde ao evento de key press no campo de entrada.
     * @param {*} $event Evento.
     */
    function onInputKeyPress($event) {
        if ($event.keyCode == 13 && this.onEnter) {
            this.onEnter({value: $event.target.value});
        }
    }

    /**
     * Responde ao evento change sobre o campo de entrada.
     */
    function onInputChange() {
        if (this.onChange) {
            this.onChange({value: this.inputValue});
        }
    }

    /**
     * Responde ao evento de click no ícone close.
     */
    function onClickCloseButton() {
        this.inputValue = '';
        this.onInputChange();
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('slideShow', SlideShow);

    /**
     * Diretiva para inclusão do slideshow da tela inicial.
     */
    function SlideShow($interval) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $interval); },
            scope: {
                modelReceiverCallback: '=model',
                swipeListener: '&',
                images: '='
            },
            templateUrl: 'app/template/directives/slideshow/slideshow.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $interval) {
        scope.next = next;
        scope.prev = prev;
        scope.show = show;
        scope.hasImages = hasImages;
        scope.currentImg = currentImg;
        scope._slide = _slide;
        scope.element = element;
        scope.$interval = $interval;
        scope.onUserInteraction = onUserInteraction;
        scope.createTimer = createTimer;
        scope.$on('$destroy', function() {
            if (scope.timer) {
                scope.timer.stop();
                scope.timer = undefined;
            }
        });

        var model = {
            next: function() { scope.onUserInteraction(); scope.next(); },
            prev: function() { scope.onUserInteraction(); scope.prev(); },
            show: function(i) { scope.onUserInteraction(); scope.show(i); },
            createTimer: function(time, restartDelay) { scope.createTimer(time, restartDelay); },
            hasImages: function() { return scope.hasImages(); }
        };

        if (scope.modelReceiverCallback) {
            scope.modelReceiverCallback(model);
        }

        detectswipe(element[0], function(el, d) {
            if (d == 'r') {
                scope.prev();
            } else if (d == 'l') {
                scope.next();
            }

            if (scope.swipeListener) {
                scope.swipeListener({direction: d});
            }
        });
    }

    /**
     * Cria o timer de avanço.
     * @param {*} time Segundos de intervalo.
     * @param {*} restartDelay Segundos de delay após interação.
     */
    function createTimer(time, restartDelay) {
        var self = this;
        if (this.timer) {
            this.timer.stop();
        }
        this.timer = new Timer(time * 1000, restartDelay * 1000, function() { self.next(); }, this.$interval);
        this.timer.start();
    }

    /**
     * Responde ao evento de interação com os controles do modelo.
     */
    function onUserInteraction() {
        this.timer.restart();
    }

    /**
     * Obtem a corrente imagem em seleção.
     */
    function currentImg() {
        return this.images.map(function(img, i) {
            return {img: img, index: i};
        }).filter(function(obj) { return obj.img.current; })[0];
    }

    /**
     * Verifica se existem imagens.
     * @returns true, existe pelo menos uma imagem; false, caso contrário.
     */
    function hasImages() {
        return this.images != undefined && this.images != null && this.images.length > 0;
    }

    /**
     * Avança o slideshow.
     */
    function next() {
        if (this.images.length > 1) {
            var current = this.currentImg();

            if (current) {
                var currentIndex = current.index;
                var nextIndex = 0;

                if (currentIndex < this.images.length - 1) {
                    nextIndex = currentIndex + 1;
                }

                var currentImg = current.img;
                var nextImg = this.images[nextIndex];

                this._slide(currentImg, nextImg, 'right-to-left');
            }
        }
    }

    /**
     * Retrocede o slideshow.
     */
    function prev() {
        if (this.images.length > 1) {
            var current = this.currentImg();

            if (current) {
                var currentIndex = current.index;
                var nextIndex = this.images.length - 1;

                if (currentIndex > 0) {
                    nextIndex = currentIndex - 1;
                }

                var currentImg = current.img;
                var nextImg = this.images[nextIndex];

                this._slide(currentImg, nextImg, 'left-to-right');
            }
        }
    }

    /**
     * Exibe a imagem respectiva a um índice.
     * @param {*} index Índice no qual a imagem se encontra. Inicia em 0.
     */
    function show(index) {
        if (this.images.length > 1) {       
            var nextImage = this.images[index];
            var current = this.currentImg();

            if (nextImage && current && current.index != index) {
                if (index == 0 && current.index == this.images.length - 1 && this.images.length > 2) {
                    this._slide(current.img, nextImage, 'right-to-left');
                } else if (current.index == 0 && index == this.images.length - 1 && this.images.length > 2) {
                    this._slide(current.img, nextImage, 'left-to-right');
                } else if (index < current.index) {
                    this._slide(current.img, nextImage, 'left-to-right');
                } else if (index > current.index) {
                    this._slide(current.img, nextImage, 'right-to-left');
                }
            }
        }
    }

    /**
     * Realiza o slide da imagem em corrente apresentação para outra.
     * @param {*} currentImg Imagem corrente.
     * @param {*} nextImg Próxima imagem.
     */
    function _slide(currentImg, nextImg, slideType) {        
        if (slideType == 'right-to-left') {
            $('#' + currentImg.id).toggle('slide', {direction: 'left'}, 'slow');
            $('#' + nextImg.id).toggle('slide', {direction: 'right'}, 'slow');
        } else {
            $('#' + currentImg.id).toggle('slide', {direction: 'right'}, 'slow');
            $('#' + nextImg.id).toggle('slide', {direction: 'left'}, 'slow');
        }

        currentImg.current = false;
        nextImg.current = true;
        
        if (this.changeListener) {
            this.changeListener(nextImg);
        }
    }

    /**
     * Realiza a detecção do movimento e swipe sobre um elemento.
     * @param {*} el Elemento.
     * @param {*} func Função callback que receberá o evento.
     */
    function detectswipe(el, func) {
        var swipe_det = new Object();
        swipe_det.sX = 0;
        swipe_det.sY = 0;
        swipe_det.eX = 0;
        swipe_det.eY = 0;
        var min_x = 20;  //min x swipe for horizontal swipe
        var max_x = 40;  //max x difference for vertical swipe
        var min_y = 40;  //min y swipe for vertical swipe
        var max_y = 50;  //max y difference for horizontal swipe
        var direc = "";

        var ele = el;
        ele.addEventListener('touchstart',function(e) {
            var t = e.touches[0];
            swipe_det.sX = t.screenX; 
            swipe_det.sY = t.screenY;
        });

        ele.addEventListener('touchmove',function(e) {
            var t = e.touches[0];
            swipe_det.eX = t.screenX; 
            swipe_det.eY = t.screenY;    
        });

        ele.addEventListener('touchend',function(e) {
            //horizontal detection
            if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y)))) {
                if(swipe_det.eX > swipe_det.sX) direc = "r";
                else direc = "l";
            }

            //vertical detection
            if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) && ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x)))) {
                if(swipe_det.eY > swipe_det.sY) direc = "d";
                else direc = "u";
            }

            if (direc != "") {
                if(typeof func == 'function') func(el,direc);
            }
            direc = "";
        });  
    }


    /**
     * Timer de avanço
     */
    var Timer = (function() {
        var TimerClass = function(timeInSeconds, delayBeforeRestartInSeconds, callback, $interval) {
            this.delayBeforeRestartInSeconds = delayBeforeRestartInSeconds;
            this.timeInSeconds = timeInSeconds;
            this.callback = callback;
            this.$interval = $interval;
        };
        // Inicia o timer
        TimerClass.prototype.start = function() {
            var self = this;
            this._currentTimer = this.$interval(function() {
                self.callback();
            }, this.timeInSeconds);
        };
        // Interrompe o timer
        TimerClass.prototype.stop = function() {
            this._clearTimers();
        };
        // Reinicia o timer
        TimerClass.prototype.restart = function() {
            var self = this;
            this.stop();

            this._restartTimer = setTimeout(function() {
                self.start();
            }, this.delayBeforeRestartInSeconds);
        };
        TimerClass.prototype._clearTimers = function() {
            if (this._restartTimer) {
                clearTimeout(this._restartTimer);
                this._restartTimer = undefined;
            }
            if (this._currentTimer) {
                this.$interval.cancel(this._currentTimer);
                this._currentTimer = undefined;
            }
        };

        return TimerClass;
    })();

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('superBuscaBar', SuperBuscaBar);

    /**
     * Diretiva para inclusão da barra de super busca.
     */
    function SuperBuscaBar() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                inputValue: '=value',
                onSearchListener: '&onsearch',
                loadingFlag: '=loadingflag',
                minLength: '=minlength',
                placeHolder: '@?'
            },
            templateUrl: 'app/template/directives/super-busca-bar/super-busca-bar.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        var _scope = {};

        _scope._animationPromise = angular.element.when();

        _scope.scope = scope;
        _scope.$input = element.find('input.sb_input');
        _scope.$iconLeft = element.find('.sb_search_icon_left');
        _scope.$iconRight = element.find('.sb_search_icon_right');
        _scope.$iconRightSearch = element.find('.sb_search_icon_right.fa-search');
        _scope.$iconEdit = element.find('.sb_search_icon_edit');
        _scope.$iconLoading = element.find('.sb_search_icon_loading');
        _scope.$button = element.find('.sb_search_button_link');
        _scope.transitionTime = 200;
        _scope.barState = 'blur';

        _scope.onInputFocus = onInputFocus;
        _scope.onInputBlur = onInputBlur;
        _scope.enableLoading = enableLoading;
        _scope.isEmptyInput = isEmptyInput;
        _scope.search = search;
        _scope.getValue = getValue;
        _scope.onBtnSearchClick = onBtnSearchClick;
        _scope.onInputKeyPress = onInputKeyPress;

        _scope.$input.bind('focus', function() {
            _scope.onInputFocus();
        });

        _scope.$input.bind('blur', function() {
            _scope.onInputBlur();
        });

        _scope.scope.onClickSearchBtn = function(e) {
            _scope.onBtnSearchClick(e);
        };

        _scope.scope.onInputKeyPress = function(e) {
            _scope.onInputKeyPress(e);
        };

        scope.$watch('inputValue', function(newVal, oldVal) {
            if (newVal) {
                _scope.$input.focus();
            }
        });

        scope.$watch('loadingFlag', function(newVal, oldVal) {
            _scope.enableLoading(newVal);
        });

        scope.$on('search_bar_enter', function(event, value) {
            _scope.search(value ? value : _scope.getValue());
        });
    }

    /**
     * Responde ao evento de key press no campo de entrada.
     * @param {*} $event Evento.
     */
    function onInputKeyPress($event) {
        if ($event.keyCode == 13) {
            this.onBtnSearchClick();
        }
    }

    /**
     * Controla a habilitação do loading.
     * @param {*} enable True, habilita a indicação de loading; false, desabilita.
     */
    function enableLoading(enable) {
        var self = this;

        if (enable) {
            self._currPromise = self.$iconRightSearch.hide('fast').promise();

            self._currPromise.done(function() {
                self._currPromise = self.$iconLoading.show().promise();
            });
        } else {
            angular.element.when(self._currPromise).done(function() {
                self._currPromise = self.$iconLoading.hide('fast').promise();

                self._currPromise.done(function() {
                    self._currPromise = self.$iconRightSearch.show().promise();
                });
            });
        }
    }

    /**
     * Responde ao evento de click no botão de busca.
     */
    function onBtnSearchClick(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.search(this.getValue());
    }

    /**
     * Executa a ação de busca de um valor.
     * @param {*} value Valor.
     */
    function search(value) {
        var self = this;

        var minLength = Number(this.scope.minLength);
        minLength = minLength ? minLength : 0;

        if (minLength > 0) {
            if (value.trim().length >= minLength) {
                this.scope.onSearchListener({ value: value });
            } else {
                this.$input.css('box-shadow', 'inset 0 -2px 0 #e53935');

                setTimeout(function() {
                    self.$input.css('box-shadow', '');
                }, 500);
            }
        } else {
            this.scope.onSearchListener({ value: value });
        }
    }

    /**
     * Verifica o a entrada está vazia.
     */
    function isEmptyInput() {
        return this.getValue().trim().length == 0;
    }

    /**
     * Obtem o corrente valor presente na barra de busca.
     */
    function getValue() {
        return this.$input.val();
    }

    /**
     * Responde ao evento de fucus no input da busca.
     */
    function onInputFocus() {
        if (this.barState == 'blur') {
            this.barState = 'focus';

            var self = this;

            this.$iconLeft.animate({ left: "-=35" }, this.transitionTime);
            this.$iconRight.animate({ right: "+=35" }, this.transitionTime, function() {
                if (self.barState == 'focus') {
                    self.$iconEdit.fadeIn(150);
                }
            });
        }
    }

    /**
     * Responde ao evento de blur no input da busca.
     */
    function onInputBlur() {
        if (this.isEmptyInput()) {
            this.barState = 'blur';
            
            var self = this;

            this.$iconEdit.fadeOut(150, function() {
                self.$iconLeft.animate({ left: "+=35" }, self.transitionTime);
                self.$iconRight.animate({ right: "-=35" }, self.transitionTime);        
            });
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('swipeGesture', SwipeGesture);

    /**
     * Diretiva para detecção do gesto de swipe sobre um elemento.
     */
    function SwipeGesture() {
        return {
            restrict: 'A',
            scope: {
                swipeGesture: '&'
            },
            link: function(scope, element, attr) {
                detectswipe(element[0], function(el, d) {
                    scope.swipeGesture({direction: d});
                });
            }
        };
    }

    /**
     * Realiza a detecção do movimento e swipe sobre um elemento.
     * @param {*} el Elemento.
     * @param {*} func Função callback que receberá o evento.
     */
    function detectswipe(el, func) {
        var swipe_det = new Object();
        swipe_det.sX = 0;
        swipe_det.sY = 0;
        swipe_det.eX = 0;
        swipe_det.eY = 0;
        var min_x = 20;  //min x swipe for horizontal swipe
        var max_x = 40;  //max x difference for vertical swipe
        var min_y = 40;  //min y swipe for vertical swipe
        var max_y = 50;  //max y difference for horizontal swipe
        var direc = "";

        var ele = el;
        ele.addEventListener('touchstart',function(e) {
            var t = e.touches[0];
            swipe_det.sX = t.screenX; 
            swipe_det.sY = t.screenY;
        });

        ele.addEventListener('touchmove',function(e) {
            var t = e.touches[0];
            swipe_det.eX = t.screenX; 
            swipe_det.eY = t.screenY;    
        });

        ele.addEventListener('touchend',function(e) {
            //horizontal detection
            if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y)))) {
                if(swipe_det.eX > swipe_det.sX) direc = "r";
                else direc = "l";
            }

            //vertical detection
            if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) && ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x)))) {
                if(swipe_det.eY > swipe_det.sY) direc = "d";
                else direc = "u";
            }

            if (direc != "") {
                if(typeof func == 'function') func(el,direc);
            }
            direc = "";
        });  
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('tabelaConsulta', TabelaConsultaDirective);

    /**
     * Diretiva para inclusão da tabela de consulta.
     */
    function TabelaConsultaDirective($resource, api, $compile, $q) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $resource, api, $compile, $q); },
            scope: {
                url: '@',
                pageSize: '@',
                filter: '=',
                contador: '=',
                rowSelection: '&?selection',
                hasTotalizador: '=?totalizador',
                dataParser: '&?parser'
            },
            templateUrl: 'app/template/directives/tabela-consulta/tabela-consulta.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $resource, api, $compile, $q) {
        var _scope = {};
        _scope.fetch = fetch;
        _scope.onContainerScroll = onContainerScroll;
        _scope.onFilterChange = onFilterChange;
        _scope.nextPage = nextPage;
        _scope.setColumnSort = setColumnSort;
        _scope.updateLinhas = updateLinhas;
        _scope.resetLinhas = resetLinhas;
        _scope.createRenders = createRenders;
        _scope.renderTable = renderTable;
        _scope.scope = scope;
        _scope.$q = $q;
        _scope.element = element;
        _scope.$compile = $compile;
        _scope.Resource = $resource(scope.url.indexOf('http://') == 0 ? scope.url : (api.url + scope.url));
        _scope.sortSet = {};
        _scope.sortedColumns = [];
        _scope.loading = false;
        _scope.linhas = [];
        _scope.colunas = undefined;
        _scope.currentFetch = undefined;
        _scope.totalizador = {};
        _scope.hasTableSelection = scope.rowSelection != undefined && scope.rowSelection != null;

        _scope.contador = scope.contador = {
            loaded: false,
            totalElements: undefined,
            totalPages: undefined
        };

        _scope.pageSize = scope.pageSize;
        _scope.currentPageIndex = -1;

        _scope.renders = _scope.createRenders(element);

        scope.$watch('filter', function(newVal) {
            _scope.onFilterChange(newVal);
        });

        element.addClass('table-responsive well no-padding white no-margin tabela_consulta_container internal_scrollbar');
        element.scroll(function(e) {
            _scope.onContainerScroll(e);
        });
    }

    /**
     * Responde ao evento de alteração do objeto filter.
     */
    function onFilterChange(newValue) {
        if (newValue != undefined && newValue != null) {
            var filter = angular.copy(newValue);

            delete(filter.dataAtualizacao);
            delete(filter.editing);
            delete(filter.busy);
            delete(filter.colunas);

            this.params = filter;
            this.colunas = newValue.colunas;

            this.renderTable();
            this.resetLinhas({ type: 'filter' });
        }
    }

    /**
     * Redefine as linhas da tabela.
     */
    function resetLinhas(fetchProps, callback) {
        this.currentPageIndex = 0;
        this.linhas.splice(0);
        this.updateLinhas(fetchProps, callback);
    }

    /**
     * Atualiza as linhas da tabela.
     */
    function updateLinhas(fetchProps, callback) {
        var self = this;
        var colunasToFetch = {};

        Object.keys(this.colunas).forEach(function(key) {
            colunasToFetch[key] = { visible: self.colunas[key].visible };
        });

        this.fetch(colunasToFetch, this.params, this.currentPageIndex, this.pageSize, this.sortedColumns, fetchProps, function(resp) {
            resp.content.forEach(function(e) {
                self.linhas.push(e);
            });

            if (resp.totalizador) {
                Object.keys(resp.totalizador).forEach(function(key) {
                    self.totalizador[key] = resp.totalizador[key];
                });
            } else if (self.totalizador) {
                Object.keys(self.totalizador).forEach(function(key) {
                    if (self.totalizador[key] != null) {
                        self.totalizador[key] = 0;
                    }
                });
            }

            self.contador.loaded = true;
            self.contador.totalElements = resp.totalElements;
            self.contador.totalPages = resp.totalPages;

            if (callback) {
                callback(resp);
            }
        });
    }

    /**
     * Realiza a busca da próxima página.
     */
    function nextPage() {
        if (!this.loading) {
            var nextPage = this.currentPageIndex + 1;

            if (this.contador.totalPages == undefined || this.contador.totalPages > nextPage) {
                this.currentPageIndex = nextPage;
                this.updateLinhas({ cancelCurrent: false });
            }
        }
    }

    /**
     * Configura a ordenação de uma coluna.
     * @param {*} columnName Nome da coluna.
     * @param {*} sortType Tipo de ordenação.
     */
    function setColumnSort(columnName, sortType, fetchCallback) {
        for (var i = 0; i < this.sortedColumns.length; i++) {
            if (this.sortedColumns[i].indexOf(columnName) > -1) {
                this.sortedColumns.splice(i, 1);
            }
        }

        if (sortType != 'None') {
            var direction = sortType == 'Descending' ? 'desc' : 'asc';

            this.sortedColumns.push(columnName + ',' + direction);
        }

        this.resetLinhas({ cancelCurrent: true }, fetchCallback);
    }
    
    /**
     * Responde ao evento scroll sobre o container da tabela.
     * @param {*} event Evento.
     */
    function onContainerScroll(event) {
        var $container = $(event.target);

        var s = $container.scrollTop();
        var d = $container.find('table:first-child').height();
        var c = $container.height();
        var scrollPercent = (s / (d - c));

        if (scrollPercent > 0.80) {
            this.nextPage();
        }
    }

    /**
     * Obtem os dados da tabela a partir do serviço.
     */
    function fetch(colunasObj, params, pageIndex, pageSize, sortedColumns, fetchProps, resultCallback) {
        var self = this;
        self.loading = true;
        var filter = {
            size: pageSize,
            page: pageIndex,
            colunas: colunasObj,
            sort: sortedColumns
        };

        Object.keys(params).forEach(function(param) {
            filter[param] = params[param];
        });

        var $table = this.element.find('table');

        var beforeFetch = function() {
            $table.addClass('loading');
            self.loading = true;
        };

        var afterFetch = function() {
            $table.removeClass('loading');
            self.loading = false;
        };

        if (this.currentFetch != undefined && !this.currentFetch.hasCompleted) {
            if (fetchProps == undefined || !fetchProps.cancelCurrent) {
                return;
            }

            this.currentFetch.cancel();
        }

        this.currentFetch = {
            _Resource: this.Resource,
            _defer: this.$q.defer(),
            _params: filter,
            _beforeFetch: beforeFetch,
            _afterFetch: afterFetch,
            type: fetchProps == undefined ? null : fetchProps.type,
            hasCompleted: false,
            then: function(callback) {
                var _self = this;
                this._beforeFetch();

                this._Resource.get(this._params).$promise.then(function(resp) {
                    _self._defer.resolve(resp);
                }, function(err) {
                    _self._defer.reject(err);
                });

                this._defer.promise.finally(function() {
                    _self._afterFetch();
                    _self.hasCompleted = true;
                });

                this._defer.promise.then(callback);
            },
            cancel: function() {
                this._defer.reject();
            }
        };

        setTimeout(function() {
            self.currentFetch.then(function(resp) {
                if (self.scope.dataParser) {
                    self.scope.dataParser({
                        data: resp,
                        callback: function(data) {
                            resultCallback(data);
                        }
                    });
                } else {
                    resultCallback(resp);
                }
            });
        }, 50);
    }

    /**
     * Desenha a tabela.
     */
    function renderTable() {
        var self = this;
        var r = this.renders.medias.filter(function(media) {
            return media.query != 'default';
        }).filter(function(media) {
            return window.matchMedia(media.query).matches;
        })[0];

        if (r == undefined) {
            r = this.renders.default;
        }

        var headScope = this.scope.$new(true);
        headScope.totalizador = this.totalizador;
        headScope.hasTotalizador = this.scope.hasTotalizador;
        headScope.colunas = this.colunas;
        headScope.hasSelection = this.hasTableSelection;
        headScope.typeOf = typeOf;
        headScope.sortSet = this.sortSet;
        headScope.setColumnSort = function(col, nextSortType) {
            self.setColumnSort(col, nextSortType);
        };

        var bodyScope = this.scope.$new(true);
        bodyScope.colunas = this.colunas;
        bodyScope.data = this.linhas;
        bodyScope.hasTotalizador = this.scope.hasTotalizador;
        bodyScope.selectionCallback = this.scope.rowSelection;
        bodyScope.typeOf = typeOf;
        
        r.render.render(headScope, bodyScope, this.$compile);
    }

    /**
     * Obtem o tipo de representação para uma coluna.
     * @param {*} coluna Coluna.
     */
    function typeOf(coluna) {
        var types = [
            { type: coluna.onClick, desc: 'clickable' },
            { type: coluna.link, desc: 'linked' },
            { type: coluna.collapsed, desc: 'collapsable' },
            { type: true, desc: 'none'} ];

        return types.filter(function(t) { return t.type != undefined && t.type != null; })[0].desc;
    }

    /**
     * Cria o conjunto table renders.
     * @param {*} $table Elemento correspondente a tabela.
     */
    function createRenders($table) {
        var self = this;
        var $thead = $table.find('thead');
        var $tbody = $table.find('tbody');
        var renders = {
            medias: [{
                query: '(max-width: 750px)',
                render: new TableRender('head-mobile', 'body-mobile', $thead, $tbody)
            }],
            default: {
                query: 'default',
                render: new TableRender('head-desktop', 'body-desktop', $thead, $tbody)
            }
        };

        renders.medias.forEach(function(md) {
            var media = window.matchMedia(md.query);
            media.addListener(function() {
                self.renderTable();
            });
        });

        return renders;
    }

    var TableRender = (function() {
        function Class(headRenderAttr, bodyRenderAttr, $thead, $tbody) {
            this.headRenderAttr = headRenderAttr;
            this.bodyRenderAttr = bodyRenderAttr;
            this.$thead = $thead;
            this.$tbody = $tbody;
        }
        Class.prototype.render = function(headScope, bodyScope, $compile) {
            this.renderAttribute(this.$thead, this.headRenderAttr, headScope, $compile);
            this.renderAttribute(this.$tbody, this.bodyRenderAttr, bodyScope, $compile);
        };
        Class.prototype.renderAttribute = function($element, attrName, scope, $compile) {
            $element.html('');
            Array.from($element[0].attributes).forEach(function(attr) {
                $element.removeAttr(attr.name);
            });
            $element.attr(attrName, '');
    
            $compile($element)(scope);
        };

        return Class;
    })();

})();


(function() {
    'use strict';
    
    angular.module('portal').directive('headDesktop', HeadDesktopDirective);

    /**
     * Diretiva para inclusão do cabeçario da tabela com layout desktop.
     */
    function HeadDesktopDirective() {
        return {
            restrict: 'A',
            link: function(s, e, a) { link(s, e, a); },
            /*scope: {
                totalizador: '=',
                colunas: '=',
                setColumnSort: '&',
                hasTotalizador: '=',
                hasSelection: '=',
                sortSet: '='
            },*/
            templateUrl: 'app/template/directives/tabela-consulta/desktop/thead.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onClickColumn = function(e, c) { _onClickColumn.call(scope, e, c); };
    }

    /**
     * Responde ao evento de click sobre uma coluna.
     * @param {*} event Evento disparado.
     * @param {*} coluna Nome da coluna.
     */
    function _onClickColumn(event, coluna) {
        var TYPES = [ 'None', 'Ascending', 'Descending' ];
        var nextType = null;

        if (this.sortSet[coluna] == undefined) {
            nextType = TYPES[1];
        } else {
            if (TYPES.indexOf(this.sortSet[coluna]) == TYPES.length - 1) {
                nextType = TYPES[0];
            } else {
                nextType = TYPES[TYPES.indexOf(this.sortSet[coluna]) + 1];
            }
        }

        this.sortSet[coluna] = nextType;
        changeIcon(event, nextType);
        this.setColumnSort(coluna, nextType);
    }

    /**
     * Alterna o ícone de uma coluna de acordo com um tipo de ordenação.
     * @param {*} evt Evento disparado.
     * @param {*} type Tipo de ordenação.
     */
    function changeIcon(evt, type) {
        var $icon = angular.element(evt.currentTarget).find('i');

        $icon.removeClass('md-arrow-drop-down md-arrow-drop-up md-sort ');
  
        var classToAdd = 'md-sort';

        if (type === 'Ascending') {
            classToAdd = 'md-arrow-drop-down';
        } else if (type === 'Descending') {
            classToAdd = 'md-arrow-drop-up';
        }

        $icon.addClass(classToAdd);
    }

})();


(function() {
    'use strict';
    
    angular.module('portal').directive('bodyDesktop', BodyDesktopDirective);

    /**
     * Diretiva para inclusão do corpo da tabela com layout desktop.
     */
    function BodyDesktopDirective() {
        return {
            restrict: 'A',
            link: function(s, e, a) { link(s, e, a); },
            /*scope: {
                colunas: '=',
                data: '=',
                hasTotalizador: '=',
                selectionCallback: '='
            },*/
            templateUrl: 'app/template/directives/tabela-consulta/desktop/tbody.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.toggleCollapsed = toggleCollapsed;
        scope.qtdColunas = Object.keys(scope.colunas).length;
        scope.hasSelection = scope.selectionCallback != undefined && scope.selectionCallback != null;
        scope.onRowSelected = function(i, evt) {
            
            if (scope.selectionCallback) {
                scope.selectionCallback({event: { item: i, event: evt }});
            }
        };
    }

    /**
     * Responde a ação de recolher/expandir de uma célula recolhivel.
     * @param {*} event Evento disparado.
     */
    function toggleCollapsed(event) {
        angular.element(event.currentTarget).siblings().toggleClass('cell_collapsed');
    }

})();


(function() {
    'use strict';
    
    angular.module('portal').directive('headMobile', HeadMobileDirective);

    /**
     * Diretiva para inclusão do cabeçario da tabela com layout mobile.
     */
    function HeadMobileDirective() {
        return {
            restrict: 'A',
            link: function(s, e, a) { link(s, e, a); },
            /*scope: {
                totalizador: '=',
                colunas: '=',
                onClickSort: '&',
                hasTotalizador: '=',
                hasSelection: '='
            },*/
            templateUrl: 'app/template/directives/tabela-consulta/mobile/thead.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onClickRecolherResultados = onClickRecolherResultados;
        scope.onClickExpandirResultados = onClickExpandirResultados;
    }

    /**
     * Responde ao evento de click sobre a opções de expanção dos resultados.
     * @param {*} event Evento disparado.
     */
    function onClickExpandirResultados(event) {
        angular.element(event.target)
            .closest('tabela-consulta')
            .find('tbody > tr > .cell_container > .collapsed')
            .removeClass('collapsed');
    }

    /**
     * Responde ao evento de click sobre a opções de recolhimento dos resultados.
     * @param {*} event Evento disparado.
     */
    function onClickRecolherResultados(event) {
        angular.element(event.target)
            .closest('tabela-consulta')
            .find('tbody > tr > .cell_container > .content')
            .addClass('collapsed');
    }

})();


(function() {
    'use strict';
    
    angular.module('portal').directive('bodyMobile', BodyMobileDirective);

    /**
     * Diretiva para inclusão do corpo da tabela com layout mobile.
     */
    function BodyMobileDirective() {
        return {
            restrict: 'A',
            link: function(s, e, a) { link(s, e, a); },
            /*scope: {
                colunas: '=',
                data: '=',
                hasTotalizador: '=',
                selectionCallback: '='
            },*/
            templateUrl: 'app/template/directives/tabela-consulta/mobile/tbody.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.toggleCollapsed = toggleCollapsed;
        scope.onClickRowContainer = onClickRowContainer;
        scope.hasSelection = scope.selectionCallback != undefined && scope.selectionCallback != null;
        scope.onRowSelected = function(i, evt) {
            evt.stopPropagation();
            if (scope.selectionCallback) {
                scope.selectionCallback({event: { item: i, event: evt }});
            }
        };
    }

    /**
     * Responde a ação de recolher/expandir de uma célula recolhivel.
     * @param {*} event Evento disparado.
     */
    function toggleCollapsed(event) {
        angular.element(event.currentTarget).siblings().toggleClass('cell_collapsed');
    }

    /**
     * Responde ao evento de click sobre o container de uma linha.
     * @param {*} event Evento disparado.
     */
    function onClickRowContainer(event) {
        if (event.target.tagName == 'A') {
            return;
        }
        
        if (!window.getSelection().toString().length) {
            angular.element(event.target).closest('div.content').toggleClass('collapsed');
        }
    }

})();
(function () {
  'use strict';

  angular.module('portal').directive('tableBody', TableBodyDirective);

  /** @ngInject */
  function TableBodyDirective() {
    return {
      restrict: 'AE',
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/template/directives/table-body.html',
      link: function(scope, element, attrs) {
        scope.visualizar = attrs.visualizar;
      }
    }
  };

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('tableData', Directive);

    /**
     * Diretiva para inclusão da tabela de apresentação de dados.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                url: '@',
                columnsModel: '=',
                paramsModel: '=',
                actionsModel: '=?',
                onRowDoubleClick: '&?',
                pageSize: '@',
                totalCount: '=',
                totalRow: '=?',
                scrollContainer: '@?',
                enableColumnFunc: '&?'
            },
            templateUrl: 'app/template/directives/table-data/table-data.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onRowDoubleClickListener = onRowDoubleClickListener;
        scope.isLastVisibleColumn = isLastVisibleColumn;
        scope.isLastVisibleAction = isLastVisibleAction;
        scope.canColumnBeRendered = canColumnBeRendered;

        scope.vm = scope;

        scope.$watch('paramsModel', function(newVal) {
            scope.filter = newVal;
        });

        scope.$watch('contador', function(newVal) {
            scope.totalCount = newVal;
        });

        scope.$watch('totalizador', function(newVal) {
            scope.totalColumns = newVal;
        });
    }

    /**
     * Responde ao evento de click duplo em uma linha da tabela.
     * @param {*} item Item referente a linha.
     */
    function onRowDoubleClickListener(item) {
        if (this.onRowDoubleClick != undefined) {
            this.onRowDoubleClick({item: item});
        }
    }

    /**
     * Verifica se uma coluna pode ser rederizada.
     * @param {*} name Name da coluna.
     * @param {*} column Objeto valor da coluna.
     */
    function canColumnBeRendered(name, column) {
        if (this.enableColumnFunc != undefined) {
            return this.enableColumnFunc({name: name, column: column});
        }

        return true;
    }

    /**
     * Diz se uma coluna é a última visível na linha.
     * @param {*} column Column value.
     * @returns True, última visível; false, caso contrário.
     */
    function isLastVisibleColumn(column) {
        if (this.actionsModel == undefined || this.actionsModel.length == 0) {
            if (this.columnsModel != undefined) {
                var visibleColumns = Object.values(this.columnsModel).filter(function(c) { return c.visible; });

                if (visibleColumns.length > 0) {
                    return visibleColumns[visibleColumns.length - 1] == column
                }
            }
        }

        return false;
    }

    /**
     * Diz se uma coluna referente a uma action corresponde a últma visível na linha.
     * @param {*} action Action.
     * @returns True, última visível; false, caso contrário.
     */
    function isLastVisibleAction(action) {
        if (this.actionsModel != undefined) {
            var visibleActions = Object.values(this.actionsModel).filter(function(a) { return a.isVisible(); });

            if (visibleActions.length > 0) {
                return visibleActions[visibleActions.length - 1] == action
            }
        }

        return false;
    }

    /*

        <div class="table-responsive well no-padding white no-margin internal_table_container internal_scrollbar">
            <table-data url="/remuneracao" columns-model="colunas" params-model="serviceParams" actions-model="acoes"
                total-count="contador" page-size="{{ serviceParams.size }}" scroll-container=".internal_table_container"
                on-row-double-click="console.log('strhtrhrthrt')"></table-data>
        </div>

        var actionsModel = [
            {
                type: 'button',
                title: 'Adicionar',
                iconClassname: 'md md-add',
                columnName: '',
                onClick: function(item) {
                    console.log(item);
                },
                isVisible: function() {
                    return true;
                }
            },{
                type: 'link',
                title: 'Adicionar',
                label: 'Adicionar',
                columnName: '',
                onClick: function(item) {
                    console.log(item);
                },
                isVisible: function() {
                    return true;
                }
            }
        ];

        var serviceParams = {
            tipo: 'csv',
            page: 0,
            size: 30,
            anoExercicio: 2019,
            busy: false
        };
    
    */

})();
(function () {
  'use strict';

  angular.module('portal').directive('tableHeader', TableHeaderDirective);

  /** @ngInject */
  function TableHeaderDirective() {
    return {
      restrict: 'AE',
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/template/directives/table-header.html',
      link: function(scope, element, attrs) {
        scope.visualizar = attrs.visualizar;
      }
    }
  };

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('tableOptionsPanel', Directive);

    /**
     * Diretiva para inclusão de componente correspondente ao painel de opções da tabela de resultados de uma página interna.
     */
    function Directive($uibModal, $modal) {
        return {
            restrict: 'E',
            transclude: true,
            link: function(s, e, a) { link(s, e, a, $uibModal, $modal); },
            scope: {
                fnFiltro: '&?'
            },
            templateUrl: 'app/template/directives/table-options-panel/table-options-panel.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $uibModal, $modal) {
        element.find('.option_button[href]').on('click', function(e) {
            window.location = e.currentTarget.getAttribute('href');
        });

        element.find('.option_button[modal-template]').on('click', function(e) {
            var template = e.currentTarget.getAttribute('modal-template');
            var ctrl = e.currentTarget.getAttribute('modal-ctrl');

            if (ctrl) {
                $uibModal.open({
                    templateUrl: template,
                    controller: ctrl
                });
            } else {
                $modal({
                    template: template
                });
            }
        });

        /*scope.buttons = [
            {
                icon: 'fa-filter',
                title: 'Abrir filtros',
                label: 'Filtro',
                onClick: function() { scope.fnFiltro(); }
            },{
                icon: 'fa-plus',
                title: 'Escolher colunas disponíveis',
                label: 'Mais itens',
                onClick: function() { console.log(this.icon); }
            },{
                icon: 'fa-download',
                title: 'Downloads',
                label: 'Downloads',
                onClick: function() { console.log(this.icon); }
            },{
                icon: 'fa-share-alt',
                title: 'Compartilhar em redes sociais',
                label: 'Compartilhar',
                onClick: function() { console.log(this.icon); }
            },{
                icon: 'fa-envelope-o',
                title: 'Fale conosco',
                label: 'Fale conosco',
                onClick: function() { console.log(this.icon); }
            }
        ];*/
    }

})();
/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('todoWidget', TodoWidget);

  /** @ngInject */
  function TodoWidget(todoService) {
    return {
      restrict: 'EA',
      templateUrl: 'app/template/directives/todo-widget.html',
      replace: true,
      link: function($scope, $element) {
        $scope.todoService = new todoService($scope);
      }
    };
  }

})();

/*eslint-disable */
(function(){
  'use strict';

  angular.module('portal').directive('vectormap', Vectormap);

  /** @ngInject */
  function Vectormap(colorService) {
    return {
      restrict: 'E',
      'markers': '=markers',
      link: function(scope, element, attrs) {
        var chart = null;
        var markers = scope.markers;

        scope.$watch('datamap', function(n,o){
          if (!chart){
            $(element).width('auto');
            $(element).height('100%');

            options = {
              backgroundColor: 'transparent',
              series: {
                regions: [{
                  values: scope.datamap,
                  scale: [colorService.theme('darken-2'), colorService.theme('lighten-2')],
                  attribute:'fill'
                }],
              },
              regionStyle: {
                initial: {
                  fill: colorService.theme()
                }
              },
              markerStyle: {
                initial: {
                  stroke: colorService.theme_secondary('lighten-1'),
                  fill: colorService.theme_secondary('darken-1')
                },
                hover: {
                  stroke: colorService.theme_secondary('lighten-3')
                }
              }
            };

            if (markers !== null) {
              options.markers = markers;
            }

            chart = $(element).vectorMap(options);
          } else {
            chart.vectorMap('get', 'mapObject').series.regions[0].setValues(scope.datamap);
            chart.vectorMap('get', 'mapObject').series.regions[0].setNormalizeFunction('polynomial');
            chart.vectorMap('get', 'mapObject').series.regions[0].setScale([colorService.theme('darken-2'), colorService.theme('lighten-2')]);
          }
        });
      }
    };
  }

})();

/**
 * Description:
 *     removes white space from text. useful for html values that cannot have spaces
 * Usage:
 *   {{some_text | nospace}}
 */
(function(){
  'use strict';

  angular.module('portal').filter('nospace', NoSpace);

  function NoSpace() {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

})();

(function() {
    'use strict';
  
    angular.module('portal').filter('classeNumericaDesc', ClasseNumericDesc);

    /**
     * Filtro que descreve a classe numérica de um valor.
     */
    function ClasseNumericDesc() {
        var CLASSES = [
            {
                desc: 'mil',
                descs: 'mil'
            },{
                desc: 'milhão',
                descs: 'milhões'
            },{
                desc: 'bilhão',
                descs: 'bilhões'
            },{
                desc: 'trilhão',
                descs: 'trilhões'
            },{
                desc: 'quatrilhão',
                descs: 'quatrilhões'
            },{
                desc: 'quintilhão',
                descs: 'quintilhões'
            },{
                desc: 'sextilhão',
                descs: 'sextilhões'
            },{
                desc: 'septilhão',
                descs: 'septilhões'
            },{
                desc: 'octilhão',
                descs: 'octilhões'
            },{
                desc: 'nonilhão',
                descs: 'nonilhões'
            },{
                desc: 'decilhão',
                descs: 'decilhões'
            }
        ];

        return function(value) {
            var minorClasses = CLASSES.filter(function(classe, i) {
                return value >= Math.pow(10, (i + 1) * 3);
            });

            if (minorClasses.length > 0) {
                var classe = minorClasses[minorClasses.length - 1];
                var power = (CLASSES.indexOf(classe) + 1) * 3;

                var scaleNumber = Math.pow(10, power);

                return parseInt(value / scaleNumber) > 1 ? classe.descs : classe.desc;
            }
        };
    }

})();

(function(){
  'use strict';

  angular.module('portal').filter('mesAno', MesAno);

  function MesAno() {

    var meses = [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ];

    return function(valor) {
      return meses[parseInt(valor.toString().substr(4,2)) - 1] + '/' + valor.toString().substr(0,4);
    }
  }

})();

(function(){
  'use strict';

  angular.module('portal').filter('mes', NomeMes);

  function NomeMes() {

    var meses = [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ];

    return function(numero) {
      return meses[numero - 1];
    }
  }

})();

(function() {
    'use strict';
  
    angular.module('portal').filter('onEmpty', onEmpty);

    /**
     * Filtro que retorna uma string caso o valor passado resulte em false.
     */
    function onEmpty() {
        return function(value, str) {
            if (!value) {
                return str;
            }
            
            return value;
        };
    }

})();
(function () {
    'use strict';

    angular.module('portal').service('ArquivosService', Service);

    /**
     * Fornece serviços para retornar os arquivos do portal.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     */
    function Service($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;

        _scope.listarArquivosPorCodigoCategoria = listarArquivosPorCodigoCategoria;

        return _scope;
    }

    /**
     * Lista os arquivos pelo código da categoria.
     * @param {*} codCategoria Código da categoria para filtrar os arquivos.
     */
    function listarArquivosPorCodigoCategoria(codCategoria) {
        return this.$http({
            url: this.api.url + '/arquivos?codCategoria=' + codCategoria,
            method: 'GET'
        });
    }

})();

(function () {
    'use strict';
  
    angular.module('portal').service('BalancoService', Service);

    /**
     * Fornece serviços de consulta ao balanço anual de receitas e despesas.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, api, $q, $timeout) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.$timeout = $timeout;
        _scope.api = api;
        _scope.consultarBalanco = consultarBalanco;

        return _scope;
    }

    /**
     * Busca a arrecadação de impostos dos meses presentes em um intervalo.
     * @param {*} mesInicial Mês inicial do intervalo.
     * @param {*} mesFinal Mês final do intervalo.
     */
    function consultarBalanco() {
        var self = this;

        var servicos = ['/receita/receita-anual', '/despesa/despesa-anual'];
        
        var promiseArray = servicos.map(function(servico) {
            return self.$http({
                url: self.api.url + servico,
                method: 'GET',
                cache: false
            });
        });

        return this.$q.all(promiseArray).then(function(responseArray) {
            var receitas = responseArray[0].data;
            var despesas = responseArray[1].data;

            var anos = Object.keys(receitas).concat(Object.keys(despesas)).filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });

            var min = Math.min.apply(null, anos);
            var max = Math.max.apply(null, anos);

            return Array.apply(null, {length: max - min + 1}).map(function(e, i) {
                return new BalancoClass(i + min, receitas[i + min], despesas[i + min]);
            });
        });
    }

    /**
     * Modelo para o balanço de receitas e despesas de um ano.
     */
    var BalancoClass = (function() {
        var Class = function(ano, receita, despesa) {
            this.ano = ano;
            this.receita = receita;
            this.despesa = despesa;
        };
        Class.prototype.calcPercentual = function() {
            return (this.isBalancoPositivo() ? 
                    this.despesa / this.receita : 
                    this.receita / this.despesa) * 100;
        };
        Class.prototype.isBalancoPositivo = function() {
            return this.receita > this.despesa;
        };
        Class.prototype.isBalancoNegativo = function() {
            return this.receita < this.despesa;
        };
        Class.prototype.isAnoCorrente = function() {
            return this.ano == new Date().getFullYear();
        };

        return Class;
    })();

})();
  
/*eslint-disable */
(function(){

  angular.module('portal').factory('colorService', ColorService);

  function ColorService() {

    function brand_primary(variation) {
      return get_color(get_color_name('brand-primary'), variation);
    }

    function brand_success(variation) {
      return get_color(get_color_name('brand-success'), variation);
    }

    function brand_info(variation) {
      return get_color(get_color_name('brand-info'), variation);
    }

    function brand_warning(variation) {
      return get_color(get_color_name('brand-warning'), variation);
    }

    function brand_danger(variation) {
      return get_color(get_color_name('brand-danger'), variation);
    }

    function theme(variation) {
      variation = ( variation ? variation : 'base' );
      return get_color(get_color_name('theme'), variation);
    }

    function theme_secondary(variation) {
      variation = ( variation ? variation : 'base' );
      return get_color(get_color_name('theme-secondary'));
    }

    function get_color_name(name) {
      if(theme_colors[name] !== undefined){
        return theme_colors[name];
      }

      return global_colors[name];
    }

    function get_color(color, variation) {
      variation = ( variation ? variation : 'base' );

      return global_colors[color][variation];
    }

    function get_colors(){

    }

    return {
      brand_primary: brand_primary,
      brand_success: brand_success,
      brand_info: brand_info,
      brand_warning: brand_warning,
      brand_danger: brand_danger,
      theme: theme,
      theme_secondary: theme_secondary,
      get_color: get_color,
      cores_graficos: []
    };
  }

})();

/*eslint-disable */
(function() {

  angular.module('portal').factory('enqueteService', EnqueteService);

  /** @ngInject */
  function EnqueteService(localStorageService, $filter) {

    function Enquete ($scope) {
      var enquete = {
        voto: '',
        done: false
      };

      this.votar = function () {
        enquete.done = true;
        localStorageService.set('enquete', enquete);
      };

      $scope.enquete = enquete;

      var grafico = c3.generate({
        bindto:'#resultado-enquete',
        data: {
          columns: [
            ['Ótimo', 4],
            ['Bom', 3],
            ['Regular', 1],
            ['Ruim', 2]
          ],
          type: 'bar'
        },
        axis: {
          x: {
            type: 'category',
            categories: ['Votos']
          },
          rotated: true
        },
        size: { height: 100 },
        color:{
          pattern: ['#B0EBF3', '#6897CD', '#a366ff', '#85e0e0']
        }
      });
    }

    Enquete.prototype.votar = function() {
      this.votar();
    };

    return Enquete;
  }

})();

(function () {
    'use strict';
  
    angular.module('portal').service('EstatisticasService', Service);

    /**
     * Fornece serviços para a funcionalidade que exibe estatísticas gerais de uso da aplicação.
     * @param {*} $http Serviço de requisição HTTP.
     */
    function Service($http, api) {
        return {
            $http: $http,
            api: api,
            obterVisitas: obterVisitas,
            obterDispositivos: obterDispositivos,
            obterUsuariosAtivos: obterUsuariosAtivos,
            obterSessoes: obterSessoes,
            obterVisualizacoes: obterVisualizacoes,
            obterPaginasPopulares: obterPaginasPopulares
        };
    }

    /**
     * Obtem a estatística de visitas.
     */
    function obterVisitas() {
        return this.$http({
            url: this.api.url + '/analytics/visitas',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a estatística de uso por dispositivo.
     */
    function obterDispositivos() {
        return this.$http({
            url: this.api.url + '/analytics/categoria-dispositivos',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a estatística de usuários ativos.
     */
    function obterUsuariosAtivos() {
        return this.$http({
            url: this.api.url + '/analytics/usuarios-ativos',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a estatística de sessões.
     */
    function obterSessoes() {
        return this.$http({
            url: this.api.url + '/analytics/total-sessoes',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a estatística de visualizações.
     */
    function obterVisualizacoes() {
        return this.$http({
            url: this.api.url + '/analytics/total-visualizacoes',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a estatística das páginas mais acessadas.
     */
    function obterPaginasPopulares() {
        return this.$http({
            url: this.api.url + '/analytics/paginas-populares',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

})();
  

(function () {
    'use strict';
  
    angular.module('portal').service('FaleConoscoService', Service);

    /**
     * Fornece serviços para a funcionalidade FaleConosco.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} apisuperbusca Endpoint utilizado no serviço de busca.
     */
    function Service($http, $q, $httpParamSerializer, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.registrarMensagem = registrarMensagem;
        _scope.$httpParamSerializer = $httpParamSerializer;
        _scope.api = api;
  
        return _scope;
    }

    /**
     * Busca as imagens do slideshow.
     * @returns Promise para a operação.
     */
    
    function registrarMensagem(mensagem) {
        var self = this;

        var endPoint = '/contato/registro';
        var param = mensagem.nome + ";" + mensagem.email + ";" + mensagem.assunto + ";" + mensagem.mensagem;

        return this.$q(function(resolve, reject) {
            self.$http.post(self.api.url + endPoint, self.$httpParamSerializer({
                valoresFormulario: param
            }),{
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
                transformResponse: function(data) {
                    return data;
                }
            }).then(function(resp) {
                if (resp.status == 200) {
                    resolve();
                } else {
                    reject('sem sucesso ao realizar registro');
                }
            }, function(err) {
                reject(err);
            });
        });
    } 

})();
  
(function(){
  'use strict';

  angular.module('portal').service('gestaoService', GestaoService);

  /** @ngInject */
  function GestaoService($q, $http, api) {

    var service = {};

    service.listar = function() {
      var deferred = $q.defer();

      $http.get(api.url + '/gestao').success(function(data) {
        deferred.resolve(data);
      }).error(function(err, status) {
        deferred.reject(err, status);
      });

      return deferred.promise;
    };

    return service;

  }

})();

(function () {
    'use strict';
  
    angular.module('portal').service('ImpostoService', Service);

    /**
     * Fornece serviços de consulta a arrecadação de impostos
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, api, $q, $timeout) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;
        _scope.buscarArrecadacao = buscarArrecadacao;
        _scope.$timeout = $timeout;
        _scope.count = 0;

        return _scope;
    }

    /**
     * Busca a arrecadação de impostos dos meses presentes em um intervalo.
     * @param {*} mesInicial Mês inicial do intervalo.
     * @param {*} mesFinal Mês final do intervalo.
     */
    function buscarArrecadacao(mesInicial, mesFinal) {

        /*return this.$q(function(resolve) {
            setTimeout(function() {
                resolve(generateRandomData());
            }, 1000);
        });*/


        var self = this;
        return self.$http({
            url: self.api.url + '/receita/grafico/arrecadacao-imposto',
            method: 'GET',
            cache: false,
            params: {
                mesInicio: mesInicial.split('/')[0],
                anoInicio: mesInicial.split('/')[1],
                mesFim: mesFinal.split('/')[0],
                anoFim: mesFinal.split('/')[1]
            }
        }).then(function(resp) {
            return resp.data;
        });
    }

    function generateRandomData() {
        var obj = {};

        obj.totalReceitas = Math.floor(Math.random() * 11935735354) + 1;
        obj.totalImpostos = Math.floor(Math.random() * (obj.totalReceitas / 2 + (obj.totalReceitas / 2 / 2))  ) + 1;

        obj.impostos = TEST_DATA.impostos;
        obj.impostos.forEach(function(i) {
            i.arrecadacao = Math.floor(Math.random() * obj.totalImpostos) + 1;
        });

        return obj;
    }

    var TEST_DATA = {
        impostos: [
            {
                nome: "ICMS",
                arrecadacao: 3838587512.53
            },{
                nome: "IPTU",
                arrecadacao: 393526153.11
            },{
                nome: "IPVA",
                arrecadacao: 856069157.63
            },{
                nome: "IR",
                arrecadacao: 1450603757.02
            },{
                nome: "IS",
                arrecadacao: 189076031.81
            },{
                nome: "ISS",
                arrecadacao: 747321960.86
            },{
                nome: "ITBI",
                arrecadacao: 188515997.25
            },{
                nome: "ITCMD",
                arrecadacao: 50612186.74
            }
        ],
        totalImpostos: 7714312756.95,
        totalReceitas: 11935735354.05
    };

})();
  
(function () {
  'use strict';

  angular.module('portal').factory('PagingService', PagingService);

  /** @ngInject */
  function PagingService($q, $http, $log, api, $alert) {
    return {
      pesquisar: pesquisar
    };

    function pesquisar(data) {
      var deferred = $q.defer();

      $http.get(api.url + data.url, data.form).then(successHandler, errorHandler);

      return deferred.promise;

      function successHandler(response) {

        if (response.totalElements == 0) {
          $alert({
            content: 'Sua pesquisa não retornou nenhum registro',
            type: 'info'
          });
        }

        data.form.page = response.number;
        data.first = response.first;
        data.last = response.last;
        data.totalElements = response.totalElements;
        data.totalizador = response.totalizador;

        for (var i = 0; i < response.content.length; i++) {
          // TODO: refatorar para manter na lista somente o dados em exibição
          data.content.push(response.content[i]);
        }

        data.settings.busy = false;
        deferred.resolve(response);
      }

      function errorHandler(error, status) {
        $alert({
          title: 'Erro',
          content: 'Houve um erro ao recuperar os dados',
          type: 'danger'
        });

        data.settings.busy = false;
        $log.error(error);
        deferred.reject(error, status);
      }
    }
  }

})();



(function(){
    'use strict';

    angular.module('portal').service('PesquisaSatisfacaoService', PesquisaSatisfacaoService);

    function PesquisaSatisfacaoService($http, api) {
        var service = {};
        var serviceConfig = { cache: true };

        service.salvar = function(valoresFormulario) {
            return $http({
                url: api.url + '/v2/pesquisa-satisfacao/',
                method: 'POST',
                data: valoresFormulario,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        };

        return service;
    }
})();
(function () {
    'use strict';

    angular.module('portal').service('RegioesService', Service);

    /**
     * Fornece serviços para consulta de dados de regiões administrativas.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;
        _scope.store = function (data) { dataStored = data; }
        _scope.consultarDespesas = consultarDespesas;
        _scope.consultarDelimitacoesGeoJson = consultarDelimitacoesGeoJson;
        _scope.consultarRegioesGeoJson = consultarRegioesGeoJson;

        return _scope;
    }

    /**
     * Consulta as despesas de todas as regiões.
     * @returns Promise para conjunto de totais de pesas por região.
     */
    function consultarDespesas(ano) {
        var self = this;

        return this.$http({
            url: self.api.url + '/v2/despesas-ras?exercicio=' + ano,
            method: 'GET',
            cache: false
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Consulta a delimitação das regiões administrativas em formato GeoJSON.
     * @returns Promise para uma feature collection.
     */
    function consultarDelimitacoesGeoJson() {
        return this.$http({
            url: '/assets/delimitacao_ras.json',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta a localização das regiões administrativas em formato GeoJSON.
     * @returns Promise para uma feature collection.
     */
    function consultarRegioesGeoJson() {
        return this.$http({
            url: '/assets/localizacoes_ras.json',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

})();

(function(){
  'use strict';

  angular.module('portal').factory('RelatorioService', RelatorioService);

  /** @ngInject */
  function RelatorioService($http, $alert, $window, api, FileSaver) {
    return {
      exportar: function(url, obj) {
        $alert({
          content: 'Estamos gerando o relatório. Aguarde',
          placement: 'top-right',
          type: 'info',
          container: '.alert-container-top-right',
          animation: 'mat-grow-top-right',
          duration: 5
        });

        return $http({
          url: api.url + url,
          method: 'GET',
          responseType: 'arraybuffer',
          params: obj
        }).then(
          function(response) {

            var type = obj.tipo == 'pdf' ? 'application/pdf' : 'text/csv;charset=utf-8';
            var file = new Blob([response.data], {type: type});
            if(obj.tipo == 'pdf') {
              var fileURL = $window.URL.createObjectURL(file);
              $window.open(fileURL);
            } else {
              FileSaver.saveAs(file, 'relatorio.csv');
            }
          }, function (erro) {
            console.log(erro);
          }
        );
      }
    };
  }

})();



(function () {
  'use strict';

  angular.module('portal').service('ScopeService', Service);

  function Service() {

    var service = {};
    var dataStored;

    service.store = function(data) {
      dataStored = data;
    };

    service.getStored = function() {
      var data = dataStored;
      dataStored = null;
      return data;
    };

    return service;
  }

})();

(function () {
    'use strict';
  
    angular.module('portal').service('SlideShowService', Service);

    /**
     * Fornece serviços para a funcionalidade de slideshow da tela inicial.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} apisuperbusca Endpoint utilizado no serviço de busca.
     */
    function Service($http, $q, apisuperbusca, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.api = apisuperbusca;
        _scope.$q = $q;
        _scope.buscarImagens = buscarImagens;
        _scope.api = api;
  
        return _scope;
    }

    /**
     * Busca as imagens do slideshow.
     */
    function buscarImagens() {
        return this.$http({
            url: this.api.url + '/v2/imagens/imagens-slideshow',
            method: 'GET'
        });
    }

})();
  

(function(){
    'use strict';
  
    angular.module('portal').service('TextoConsultaService', TextoConsultaService);
  
    /** @ngInject */
    function TextoConsultaService($q, $http, api) {
        
        var service = {};

        service.buscarTextoConsulta = function(categoria, subCategoria) {
            return $http({
                url: api.url + '/textos-consultas',
                method: 'GET',
                params: {categoria: categoria, subCategoria: subCategoria}
            });
        };
        return service;
    }  
  })();
  
/*eslint-disable */
(function() {

  angular.module('portal').factory('todoService', TodoService);

  /** @ngInject */
  function TodoService(localStorageService, $rootScope, $filter) {
    function Todo ($scope) {
      this.$scope = $scope;
      this.todoFilter = {};
      this.activeFilter = 0;

      this.input = angular.element('#todo-title');

      this.filters = [
        {
          'title': 'All',
          'method': 'all'
        },
        {
          'title': 'Active',
          'method': 'active'
        },
        {
          'title': 'Completed',
          'method': 'completed'
        }
      ];

      this.newTodo = {
        title: '',
        done: false,
        editing: false
      };

      this.restore();

      if ( !localStorageService.get('todos') ) {
        todos = [];
        todos[0] = { title: 'Grow my mailing list', done: true };
        todos[1] = { title: 'Create a killer SAAS business', done: false };
        todos[2] = { title: 'Write autoresponder sequence', done: false };

        localStorageService.set('todos', todos);
      }
      localStorageService.bind(this.$scope, 'todos');

      this.completedTodos = function() {
        return $filter('filter')(this.$scope.todos, { done: !true });
      };

      this.addTodo = function() {
        if (this.todo.title !== '' && this.todo.title !== undefined) {
          this.$scope.todos.push(this.todo);
          $rootScope.$broadcast('todos:count', this.count());
          this.restore();
        }
      };

      this.updateTodo = function() {
        this.restore();
      };
    }

    Todo.prototype.saveTodo = function(todo) {
      if ( this.todo.editing ) {
        this.updateTodo();
      } else {
        this.addTodo();
      }
    };

    Todo.prototype.editTodo = function(todo) {
      this.todo = todo;
      this.todo.editing = true;
      this.input.focus();
    };

    Todo.prototype.toggleDone = function(todo) {
      $rootScope.$broadcast('todos:count', this.count());
    };

    Todo.prototype.clearCompleted = function() {
      this.$scope.todos = this.completedTodos();
      this.restore();
    };

    Todo.prototype.count = function() {
      c = this.completedTodos();
      return c.length;
    };

    Todo.prototype.restore = function(focus) {
      focus = typeof focus !== 'undefined' ? focus : true;

      this.todo = angular.copy(this.newTodo);
      this.input.val('');

      if ( focus === true )
        this.input.focus();
    };

    Todo.prototype.filter = function(filter) {
      if ( filter === 'active' ) {
        this.activeFilter = 1;
        this.todoFilter = { done: false };
      } else if ( filter === 'completed' ) {
        this.activeFilter = 2;
        this.todoFilter = { done: true };
      } else {
        this.activeFilter = 0;
        this.todoFilter = {};
      }
    };

    return Todo;
  }

})();

(function() {
    'use strict';

    angular.module('portal').factory('UiDateService', UiDateService);

    function UiDateService () {
        return {
            validateAttrs: validateAttrs,
            validateCustomFilter: validateCustomFilter,
            resetDate: resetDate,
            validateDate: validateDate
        };

        function validateAttrs(attrs, scope){
            if(attrs.dateLabel){
                scope.label = attrs.dateLabel;
            }

            if(!attrs.datePairId){
                console.error('Attribute date-pair-id not informed for uiStartDate directive.');
            }
        }

        function validateCustomFilter(filterFn){

            var customFilter = function($dates){};
            if(filterFn){
                customFilter = datesFilterDecorator(filterFn());
            }
            return customFilter;

            function datesFilterDecorator(fn) {
                return function($dates){
                    $dates.filter(function (date) {
                        return fn(date.localDateValue());
                    }).forEach(function (date) {
                        date.selectable = false;
                    });
                }
            }
        }

        function validateDate(date, pairDateValidation, userCustomFilter, modelController){
            // Check if the given date is a valid date
            var isDate = angular.isDate(date);
            if(isDate){
                modelController.$setValidity('date', true);

                // Check if the given date makes sense with its respective pair (start and end dates)
                var okWithPairDate = pairDateValidation(date);
                modelController.$setValidity('invalidRangeOfDates', okWithPairDate);

                // Check if the given date is accordingly to user custom validation rule
                var passUserCustomFilter = ! userCustomFilter(date);
                modelController.$setValidity('invalidDateDueToUserCustomFilter', passUserCustomFilter);
            }else{
                modelController.$setValidity('date', false);
            }
        }

        function resetDate(scope, element){
            return function(){
                // Setting all validity rules to true when resetting the date
                var modelController = element.find('input').controller('ngModel');
                modelController.$setValidity('date', true);
                modelController.$setValidity('invalidDateDueToUserCustomFilter', true);
                modelController.$setValidity('invalidRangeOfDates', true);
                scope.dateModel = null;
            }
        }
    }
})();

(function(){
  'use strict';

  angular.module('portal').service('unidadeGestoraService', UnidadeGestoraService);

  /** @ngInject */
  function UnidadeGestoraService($q, $http, api) {

    var service = {};

    service.listar = function() {
      var deferred = $q.defer();

      $http.get(api.url + '/unidadeGestora').success(function(data) {
        deferred.resolve(data);
      }).error(function(err, status) {
        deferred.reject(err, status);
      });

      return deferred.promise;
    };

    return service;

  }

})();

(function () {
  'use strict';

  angular.module('portal').factory('Util', UtilFactory);

  /**
   * Exporta funções utilitárias.
   */
  /** @ngInject */
  function UtilFactory() {
    return {
      extend: extend,
      validarCNPJ: validarCNPJ,
      validarCPF: validarCPF,
      extractDigits: extractDigits,
      hasOnlyDigits: hasOnlyDigits,
      hasCpfFormat: hasCpfFormat,
      hasCnpjFormat: hasCnpjFormat
    }
  };

  /**
   * Realiza a cópia das propriedades de um objeto para outro.
   * @param {*} obj Objeto que receberá os valores.
   * @param {*} src Objeto com as propriedades a serem copiadas.
   */
  function extend(obj, src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) obj[key] = src[key];
    }

    return obj;
  }

  /**
   * Verifica se uma string se encontra no formato do CPF.
   * @param {*} str String.
   * @returns True, string no formato; false, caso contrário.
   */
  function hasCpfFormat(str) {
    return str.match(/^([0-9]){3}\.([0-9]){3}\.([0-9]){3}-([0-9]){2}$/g) != null;
  }

  /**
   * Verifica se uma string se encontra no formato do CNPJ.
   * @param {*} str String.
   * @returns True, string no formato; false, caso contrário.
   */
  function hasCnpjFormat(str) {
    return str.match(/[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}/g) != null;
  }

  /**
   * Verifica se uma string contém somente caracteres numéricos.
   * @param {*} str String.
   * @returns True, possuí somente números; false, caso contrário.
   */
  function hasOnlyDigits(str) {
    return str.length > 0 && str == extractDigits(str);
  }

  /**
   * Obtem os dígitos de uma string.
   * @param {*} str String.
   * @returns String contendo somente os caracteres numéricos.
   */
  function extractDigits(str) {
    return str.replace(/[^\d]+/g,'');
  }

  /**
   * Realiza a validação de um CNPJ.
   * @param {*} cnpj CNPJ em string.
   * @returns True se o CNPJ é válido; false, caso contrário.
   */
  function validarCNPJ(cnpj) {
    cnpj = extractDigits(cnpj);
 
    if(cnpj == '') return false;
     
    if (cnpj.length != 14)
        return false;
 
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" || 
        cnpj == "11111111111111" || 
        cnpj == "22222222222222" || 
        cnpj == "33333333333333" || 
        cnpj == "44444444444444" || 
        cnpj == "55555555555555" || 
        cnpj == "66666666666666" || 
        cnpj == "77777777777777" || 
        cnpj == "88888888888888" || 
        cnpj == "99999999999999")
        return false;
         
    // Valida DVs
    var tamanho = cnpj.length - 2
    var numeros = cnpj.substring(0,tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
         
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;
           
    return true;
  }

  /**
   * Verifica se um CPF é válido.
   * @param {*} cpf String contendo o CPF.
   * @returns True, CPF válido; false, caso contrário.
   */
  function validarCPF(cpf) {	
    cpf = extractDigits(cpf);

    if(cpf == '') return false;	
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 || 
      cpf == "00000000000" || 
      cpf == "11111111111" || 
      cpf == "22222222222" || 
      cpf == "33333333333" || 
      cpf == "44444444444" || 
      cpf == "55555555555" || 
      cpf == "66666666666" || 
      cpf == "77777777777" || 
      cpf == "88888888888" || 
      cpf == "99999999999")
        return false;
    // Valida 1o digito	
    var rev, add = 0;	
    for (var i=0; i < 9; i ++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }
    rev = 11 - (add % 11);	
    if (rev == 10 || rev == 11)	{
      rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9)))	{
      return false;
    }
    // Valida 2o digito	
    add = 0;	
    for (var i = 0; i < 10; i ++)	{
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);	
    if (rev == 10 || rev == 11)	{
      rev = 0;
    }

    return rev != parseInt(cpf.charAt(10)) ? false : true;   
  }

})();
(function () {
  'use strict';

  angular.module('portal.despesa').controller('DespesaConsultaDinamicaController', Controller);

  /** @ngInject */
  function Controller($scope, $aside, $alert, $location, ano, ScopeService, DespesasService,
    RelatorioService, Util, $rootScope, dataAtualizacao, $filter) {

    var vm = this;

    vm.exibirGrid = false;
    vm.data = [];
    vm.contador = 0;
    vm.periodo;
    vm.dataAtualizacao = dataAtualizacao.data;

    var colunas = {
      nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      nomeGestao: { nome: "Gestão", visible: true, termo: "Unidade responsável pela administração dos recursos públicos" },
      nomeCredor: { nome: "Credor", visible: false, termo: "Nome de quem tem um valor a receber da Administração Pública" },

      codigoCredorMascarado: { nome: "CPF/CNPJ do Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },

      numeroProcesso: { nome: "Número do Processo", visible: false, termo: "Nº do processo referente à despesa" },
      anoExercicio: { nome: "Exercício", visible: false, termo: "Ano relativo às informações.", center: true },
      nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
      nomeTipoLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
      nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
      nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
      nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação " },
      nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
      nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
      nomeSubtitulo: { nome: "Subtitulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
      nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
      nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
      nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
      nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
      nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
      valorNeFinal: { nome: "Empenhado", visible: true, currency: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
      valorNlBruto: { nome: "Liquidado", visible: true, currency: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
      valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
      valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
      valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
      valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
      valorObFinal: { nome: "Total Pago", visible: true, currency: true, termo: "Valor pago pelo produto entregue ou serviço realizado" }
    };

    //Objetos dos filtros
    vm.anos = ano.data;
    vm.unidadeGestora = [];
    vm.gestao = [];
    vm.esfera = [];
    vm.funcao = [];
    vm.subfuncao = [];
    vm.programa = [];
    vm.modalidadeLicitacao = [];
    vm.categoriaEconomica = [];
    vm.grupoNatureza = [];
    vm.modalidadeAplicacao = [];
    vm.elemento = [];
    vm.fonte = [];

    vm.carregarFiltros = carregarFiltros;

    function carregarFiltros(exercicio) {
      DespesasService.listarFiltros(exercicio)
        .then(function (response) {
          vm.unidadeGestora = response.data.unidadesGestoras;
          vm.gestao = response.data.gestoes;
          vm.esfera = response.data.esfera;
          vm.funcao = response.data.funcoes;
          vm.subfuncao = response.data.subfuncoes;
          vm.programa = response.data.programa;
          vm.modalidadeLicitacao = response.data.modalidadeLicitacao;
          vm.categoriaEconomica = response.data.categoriaEconomica;
          vm.grupoNatureza = response.data.grupoNatureza;
          vm.modalidadeAplicacao = response.data.modalidadeAplicacao;
          vm.elemento = response.data.elemento;
          vm.fonte = response.data.fonte;
        });
    }


    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Execução de Emendas',
      plural: ''
    };

    vm.item = {
      busy: true,
      editing: true,
      colunas: colunas,
      dataAtualizacao: vm.dataAtualizacao,
      buildDateText: function () {
        if (this.dataInicio) {
          return $filter('date')(this.dataInicio, 'dd/MM/yyyy') + ' - ' + $filter('date')(this.dataFim, 'dd/MM/yyyy');
        }
      }
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // defining template
    var formTpl = $aside({
      scope: $scope,
      //template: 'app/components/despesas/execucao-emendas-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.item = {
        busy: false,
        editing: true
      };
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        linha.anoExercicio = vm.data.form.anoExercicio;
        DespesasService.listarExecucaoEmendasPorSubtitulo(linha).then(
          function (response) {
            $scope.dadosDetalhamento = response.data;
            vm.exibirTabelaAgrupadora = false;
          }
        );
      }
    };

    var detalharAgrupador = function (url, linha, tipoValorPago) {
      var obj = {};
      obj.url = '/despesas/consulta-dinamica';
      obj.colunas = [];
      obj.filtroOrigem = vm.item;

      // insere no array somente os nomes lÃ³gicos das colunas visÃ­veis
      for (var coluna in $scope.colunas) {
        if ($scope.colunas.hasOwnProperty(coluna)) {
          if ($scope.colunas[coluna].visible) obj.colunas.push(coluna);
        }
      }

      vm.item.colunas = {};
      linha = Util.extend(linha, vm.item);

      delete obj.filtroOrigem.buildDateText;
      ScopeService.store(obj);
      //linha.ano = linha.anoExercicio;
      //linha.anoNotaEmpenho = linha.anoExercicio;
      linha.tipoValorPago = tipoValorPago;

      var codCredor = linha.codigoCredor || linha.codigoCredorMascarado;

      if (codCredor) {
        // Campo a ser utilizado como parâmetro de consulta pela view de detalhamento
        linha.codigoCredorCodificado = btoa(codCredor);

        // Campo retornado pelo serviço
        delete linha.codigoCredor;

        // Campo informado pelo usuário
        delete linha.codigoCredorMascarado;
      }

      delete linha.buildDateText;
      $location.path(url).search(linha);
    };

    vm.detalharValorEmpenhado = function (linha) {
      linha.ano = linha.anoExercicio;
      linha.anoNotaEmpenho = linha.anoExercicio;
      detalharAgrupador('/despesas/nota-empenho', linha);
    };

    vm.detalharValorLiquidado = function (linha) {
      linha.ano = linha.anoExercicio;
      linha.anoNotaLancamento = linha.anoExercicio;
      detalharAgrupador('/despesas/nota-lancamento', linha);
    };

    vm.detalharValorPago = function (linha, tipoValorPago) {
      linha.ano = linha.anoExercicio;
      detalharAgrupador('/despesas/ordem-bancaria', linha, tipoValorPago);
    };

    vm.exibirFormPesquisa = function () {
      vm.exibirGrid = false;
    };

    vm.handlerValorFiltroInserido = function () {
      var numeroNe = vm.item.numeroNotaEmpenho;
      var numeroNl = vm.item.notaLancamento;
      var numeroOb = vm.item.ordemBancaria;
      if (numeroNe != null || numeroNl != null || numeroOb != null) {
        colunas.nomeUnidadeGestora.visible = true;
        colunas.nomeGestao.visible = true;
      }
    };


    vm.exibePeriodoPesquisa = true;

    vm.search = function () {

      var colunasVisiveis = _.filter($scope.colunas, function (value, key) {
        return value.visible == true;
      });

      if (colunasVisiveis.length == 0) {
        $alert({
          content: 'Selecione ao menos uma colunas para exibir no resultado',
          type: 'info'
        });
        return;
      }
      if (vm.item.dataInicioFormatar == null) {
        vm.exibePeriodoPesquisa = false;
      } else {
        vm.exibePeriodoPesquisa = true;
        vm.item.dataInicio = formataParaDate(vm.item.dataInicioFormatar);
        vm.item.dataFim = formataParaDate(vm.item.dataFimFormatar);
      }
      vm.exibirGrid = true;
      vm.item.busy = false;
      vm.item.colunas = $scope.colunas;
      $scope.filter = angular.copy(vm.item);
    };

    var formataParaDate = function (date) {
      var dateSplited = date.split('/');

      var day = dateSplited[0];
      var month = dateSplited[1];
      var year = dateSplited[2];

      var dateToFormat = month + "-" + day + "-" + year;

      return new Date(dateToFormat);
    }

    vm.verificarDateMaior = function (firstDate, secondDate) {
      var dateLength = 10;
      if ((firstDate && firstDate.length == dateLength) && (secondDate && secondDate.length == dateLength)) {
        var firstDateFormated = formataParaDate(firstDate);
        var secondDateFormated = formataParaDate(secondDate);

        return firstDateFormated > secondDateFormated;
      }

      return false;
    }


    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/consulta-dinamica', vm.item);
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function () {
      //formTpl.hide();
    };

    vm.init = function () {
      var params = $location.search();

      if (params['unidadeGestora'] != undefined) {
        vm.exibirGrid = true;
        DespesasService.listarUnidadeGestora()
          .then(function (response) {
            vm.unidadeGestora = response.data;
            executarConsulta(params);
          });
      } else {
        executarConsulta(params);
      }
    };

    function executarConsulta(params) {
      vm.assignInitParams(params, vm.item);

      if ($rootScope.filter != null) {
        vm.item = $rootScope.filter;
      }

      carregarFiltros(vm.anos[0]);

      if (!(_.isEmpty(params))) {
        vm.exibirGrid = true;
        if (params.anoExercicio) {
          vm.item.anoExercicio = String(params.anoExercicio);
        }
        vm.applyFilters(params);

        if (params.colunas) {
          _.each($scope.colunas, function (coluna) {
            coluna.visible = false;
          });

          _.each(params.colunas, function (value) {
            $scope.colunas[value].visible = true;
          });
        }
        vm.search();
      }
    }

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function (params, modelObject) {

      var assignProps = function (propsArray, fromObj, toObj) {
        propsArray.forEach(function (prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      assignProps([
        { from: 'notaEmpenho', to: 'numeroNotaEmpenho', type: String },
        { from: 'notaLancamento', to: 'notaLancamento', type: String },
        { from: 'ordemBancaria', to: 'ordemBancaria', type: String },
        { from: 'numeroProcesso', to: 'numeroProcesso', type: String }], params, vm.item);

      if (params['anoExercicio'] != undefined) {
        modelObject.anoExercicio = String(params['anoExercicio']);
      }

      if (params['unidadeGestora'] != undefined) {
        var unidade = vm.unidadeGestora.filter(function (u) {
          return u.nome == params['unidadeGestora'];
        })[0];

        colunas.anoExercicio.visible = true;

        if (unidade != null) {
          modelObject.listaCodigoUnidadeGestora = [unidade.codigo];
        }
      }
    };


    vm.applyFilters = function (obj) {

      var fn = function (item, dados) {
        if (item) {
          var codigo;
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      };

      vm.item.listaCodigoCategoriaEconomica = fn(obj.listaCodigoCategoriaEconomica, vm.categoriaEconomica);
      vm.item.listaCodigoFuncao = fn(obj.nomeFuncao, vm.funcao);
      vm.item.listaCodigoSubfuncao = fn(obj.nomeSubfuncao, vm.subfuncao);

      if (obj.listaCodigoFuncao) {
        vm.item.listaCodigoFuncao = obj.listaCodigoFuncao;
      }

      if (obj.listaCodigoSubfuncao) {
        vm.item.listaCodigoSubfuncao = obj.listaCodigoSubfuncao;
      }

      vm.item.listaCodigoGrupoNatureza = fn(obj.nomeGrupoNatureza, vm.grupoNatureza);

      if (obj.listaCodigoGrupoNatureza) {
        vm.item.listaCodigoGrupoNatureza = obj.listaCodigoGrupoNatureza;
      }

      vm.item.listaCodigoModalideLicitacao = fn(obj.nomeTipoLicitacao, vm.modalidadeLicitacao);

      if (obj.listaCodigoModalideLicitacao) {
        vm.item.listaCodigoModalideLicitacao = obj.listaCodigoModalideLicitacao;
      }
    };

    vm.checarDataInvalida = function (data) {
      // Datas abaixo de 2009 e acima da data atual são inválidas
      var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
      var dataFutura = data >= moment().valueOf();
      return anteriorA2009 || dataFutura;
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    $scope.fecharModalColunas = function () {
      vm.search();
    };

    vm.selecionarTodasAsColunas = function (selecionar) {
      var arrayColunas = Object.values($scope.colunas);
      for (var i = 0; i < arrayColunas.length; i++) {
        if (!arrayColunas[i].disabled) {
          arrayColunas[i].visible = selecionar;
        }
      }
    }

  }

})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('DespesasCovid19PorItemController', DespesasCovid19PorItemController);

    /**
     * Controlador da consulta de despesas com COVID-19 por item.
     */
    /** @ngInject */
    function DespesasCovid19PorItemController($scope, $aside, $location, ScopeService, dataAtualizacao, anos, unidadesGestoras, RelatorioService) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.ScopeService = ScopeService;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.RelatorioService = RelatorioService;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
            nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
            numeroNotaEmpenho: { nome: "Nota de empenho", visible: true, termo: "Número da nota de empenho associada", center: true },
            numeroNotaEmpenhoOriginal: { nome: "Empenho Original", visible: true, termo: "Número da nota de empenho original", center: true },
            numeroItem: { nome: "Nº Item", visible: true, termo: "Número do item da despesa", center: true },
            descricaoItem: { nome: "Descrição Item", visible: true, termo: "Descrição da despesa", collapsed: true },
            valorUnitarioItem: { nome: "VL Unitário", visible: true, currency: true, termo: "Valor unitário da despesa" },
            quantidadeItem: { nome: "Quantidade", visible: true, center: true, termo: "Quantidade de items da despesa" },
            valorTotalItems: { nome: "VL Total Item", visible: true, currency: true, termo: "Valor total do item" },
            nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
            nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
            nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
            nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
            nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
            nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
            nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
            nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
            nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
            nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
            nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
            nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
            nomeFonteRecurso: { nome: "Fonte de Recursos", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
            numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
            codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
        };

        _scope.filterModel = {
            anoExercicio: String(0),
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'select',
                label: 'Exercício',
                title: 'Ano de referência',
                required: true,
                modelField: 'anoExercicio',
                showAllYears: true,
                options: anos
            }, {
                type: 'multiple-select',
                label: 'Unidade Gestora',
                title: 'Órgão ou entidade gestora associada a despesa',
                required: false,
                modelField: 'listaCodigoUnidadeGestora',
                options: unidadesGestoras.data,
                valueProp: 'codigo',
                displayProp: 'nome'
            }, {
                type: 'text',
                label: 'Credor',
                title: 'Nome da entidade credora',
                required: false,
                modelField: 'nomeCredor'
            }, {
                type: 'text',
                label: 'Nota Empenho/Empenho Original',
                title: 'Nota de empenho associada',
                required: false,
                modelField: 'numeroNotaEmpenho'
            }, {
                type: 'text',
                label: 'Item',
                title: 'Descrição do item da despesa',
                required: false,
                modelField: 'descricaoItem'
            }
        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        if (this.filterModel.mes) {
            obj.mes = _parseMonthDate(this.filterModel.mes);
        }

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Navega para a página de detalhamento de nota de empenho para uma despesa.
     * @param {*} despesa Despesa.
     */
    function detalharNotaEmpenho(despesa) {
        var obj = {
            url: '/despesas/despesas-covid19-por-item',
            filtroOrigem: this.filterModel,
            colunas: this.filterModel.colunas
        };

        

        this.$location.path('/despesas/nota-empenho').search({
            exercicio: this.filterModel.anoExercicio,
            nomeCredor: !despesa.nomeCredor ? this.filterModel.nomeCredor : despesa.nomeCredor,
            codigoUnidadeGestora: this.filterModel.listaCodigoUnidadeGestora ? this.filterModel.listaCodigoUnidadeGestora[0] : undefined
        });

        this.ScopeService.store(obj);
    }

    /**
     * Navega para a página de detalhamento de ordem bancária para uma despesa.
     * @param {*} despesa Despesa.
     */
    function detalharOrdemBancaria(despesa) {
        var obj = {
            url: '/despesas/despesas-covid19-por-item',
            filtroOrigem: this.filterModel,
            colunas: this.filterModel.colunas
        };

        this.$location.path('/despesas/ordem-bancaria').search({
            ano: this.filterModel.anoExercicio,
            codigoUnidadeGestora: this.filterModel.listaCodigoUnidadeGestora ? this.filterModel.listaCodigoUnidadeGestora[0] : undefined,
            tipoValorPago: 'pago-final'
        });

        this.ScopeService.store(obj);
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/despesa/relatorio/covid-por-itens', this.filterModel);
        }
    }

    /**
     * Realiza o parse de um objeto Date para o formato MM/yyyy.
     */
    function _parseMonthDate(date) {
        var s = '00' + (date.getMonth() + 1);
        var month = s.substr(s.length - 2);

        return month + '/' + date.getFullYear();
    }

})();

(function () {
    'use strict';

    angular.module('portal').controller('DespesasDetalhamentosSaibaMaisController', DespesasDetalhamentosSaibaMaisController);

    /** @ngInject */
    function DespesasDetalhamentosSaibaMaisController($scope, $window, dataAtualizacao, ArquivosService) {

        var CODIGO_CATEGORIA_SAIBA_MAIS_DESPESAS = 60;

        var vm = this;

        vm.dataAtualizacao = dataAtualizacao.data;

        var colunas = {
            nome: { nome: "Nome", visible: true },
            exercicio: { nome: "Exercício", visible: true }
        };

        $scope.colunas = colunas;

        vm.data = [];

        vm.init = function () {
            vm.search();
        }

        vm.search = function () {
            ArquivosService.listarArquivosPorCodigoCategoria(CODIGO_CATEGORIA_SAIBA_MAIS_DESPESAS)
                .then(function (res) {
                    vm.data = res.data;
                });
        };

        vm.voltar = function () {
            var urlPreviousPage = localStorage.getItem('URL_PREVIOUS_PAGE');
            $window.location.href = '#' + urlPreviousPage;
        };
    }
})();
(function () {
    'use strict';

    angular.module('portal.despesa').controller('NotaEmpenhoController', NoteEmpenhoController);

    /** @ngInject */
    function NoteEmpenhoController($scope, $modal, $aside, $location, $alert, unidadesGestoras, $filter,
        DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao, _) {

        var vm = this;

        var currentModal, backModal;

        vm.data = [];
        vm.contador = 0;
        vm.dataAtualizacao = dataAtualizacao;

        var storedObj;
        var filtroOrigem;

        var colunas = {
            numeroNotaEmpenho: { nome: "Nota Empenho", visible: true, destacado: 'true', disabled: true, termo: "Nº do documento utilizado para formalizar o comprometimento da despesa" },
            dataEmissao: { nome: "Emissão", visible: true, date: true, termo: "Data em que o comprometimento da despesa foi registrado" },
            nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
            nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
            processo: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
            nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
            nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
            nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
            nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
            nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de atuação governamental, formado por um conjunto de ações" },
            nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa" },
            nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
            nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
            nomeNaturezaDespesa: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
            nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Forma de aplicação dos recursos: diretamente ou por transferência a outras entidades" },
            nomeElementoDespesa: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
            nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
            observacaoRegistro: { nome: "Observação", visible:false, termo: "Observação" },

            codigoCredorMascarado: { nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },

            nomeCredor: { nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública" },
            codigoNatureza: { nome: "Natureza Despesa", visible: false, termo: "" },
            unidadeOrcamentaria: { nome: "Unidade Orçamentaria", visible: false, termo: "" },
            dataLancamento: { nome: "Data de Lançamento", visible: false, termo: "" },
            codigoProgramaTrabalho: { nome: "Código Programa de Trabalho", visible: false, termo: "" },
            tipoLicitacao: { nome: "Código Modalidade Licitação", visible: false, termo: "" },
            referencia: { nome: "Referencia", visible: false, termo: "" },
            nomeModalidadeEmpenho: { nome: "Modalidade Empenho", visible: false, termo: "" },
            localEntrega: { nome: "Local De Entrega", visible: false, termo: "" },
            prazoEntrega: { nome: "Prazo de Entrega", visible: false, termo: "" },
            valorNeFinal: { nome: "Valor Final", visible: true, currency: true, termo: "Valor reservado para pagamento pela prestação ou entrega do serviço após os reforços e anulações" },

            // ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //




        };


        $scope.colunas = colunas;

        // settings
        vm.settings = {
            singular: 'Nota de Empenho',
            plural: 'Notas de Empenho'
        };

        vm.item = {
            busy: true,
            editing: true,
            colunas: $scope.colunas,
            dataAtualizacao: new Date(vm.dataAtualizacao.data),
            buildTextoData: function () {
                if (this.dataInicio) {
                    return $filter('date')(this.dataInicio, 'MM/yyyy') + ' - ' + $filter('date')(this.dataFim, 'MM/yyyy');
                }
                return String(this.anoNotaEmpenho);
            }
        };

        vm.unidadesGestoras = unidadesGestoras.data;

        $scope.dados = {
            form: {
                tipo: 'pdf'
            }
        };

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var extratoNeTemplate = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-modal.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var subitemNeTemplate = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/subitem-ne-modal.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var execucaoNeTemplate = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/execucao-ne-modal.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var descricaoNeTemplate = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/descricao-ne-modal.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var notaFiscalNeTemplate = $aside({
          scope: $scope,
          template: 'app/components/despesas/despesas-por-agrupador/nota-fiscal-ne-modal.html',
          show: false,
          placement: 'left',
          backdrop: true,
          animation: 'am-slide-left'

      });

        var modalTemplate = function (titulo, template) {
            return $modal({
                scope: $scope,
                title: titulo,
                template: template,
                show: false
            });
        };

        vm.cancelar = function () {
            vm.item = storedObj;
            vm.item.editing = true;
            vm.item.busy = false;
        };

        vm.exibirFormPesquisa = function () {
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showForm();
        };

        vm.visualizarItem = function (linha) {
            DespesasService.recuperarNotaEmpenho(linha).then(
                function (response) {
                    vm.item.editing = false;
                    vm.settings.cmd = 'Visualizar';
                    vm.linha = response.data;
                    showFormDetalhamento();
                }
            );
        };

        var hideCurrentModal = function () {
            if (currentModal) {
                currentModal.hide();
                backModal = currentModal;
            }
        };

        vm.backCurrentModal = function () {
            if (backModal) {
                backModal.show();
                backModal = undefined;
            }
        };

        vm.exibirModalExtratoNotaEmpenho = function (item) {

            var reqObj = {
                anoNotaEmpenho: item.anoNotaEmpenho,
                codigoUnidadeGestora: item.codigoUnidadeGestora,
                codigoGestao: item.codigoGestao,
                numeroNotaEmpenho: item.numeroNotaEmpenho
            };

            DespesasService.listarExtratoNotaEmpenho(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não há notas de empenho vinculadas',
                            type: 'info'
                        });
                        return;
                    }

                    vm.extratoAnual = response.data;
                    vm.extratoTotal = _.reduce(vm.extratoAnual, function (memo, obj) {
                        return memo + obj.valorNe
                    }, 0);

                    hideCurrentModal();
                    extratoNeTemplate.show();
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar dados para o extrato',
                        type: 'info'
                    });
                }
            );
        };

        vm.exibirModalSubitemNotaEmpenho = function (item) {

            var reqObj = {
                anoNotaEmpenho: item.anoNotaEmpenho,
                codigoUnidadeGestora: item.codigoUnidadeGestora,
                codigoGestao: item.codigoGestao,
                numeroNotaEmpenho: item.numeroNotaEmpenho
            };

            DespesasService.listarSubitemDespesa(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não há subitens para essa nota de empenho',
                            type: 'info'
                        });
                        return;
                    }

                    vm.subitemsDespesa = response.data;
                    vm.subitemsDespesaTotal = _.reduce(vm.subitemsDespesa, function (memo, obj) {
                        return memo + obj.valor
                    }, 0);

                    hideCurrentModal();
                    subitemNeTemplate.show();
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar subitens',
                        type: 'info'
                    });
                }
            );
        };

        vm.exibirModalExecucaoNotaEmpenho = function (item) {

            var reqObj = {
                anoNotaEmpenho: item.anoNotaEmpenho,
                codigoUnidadeGestora: item.codigoUnidadeGestora,
                codigoGestao: item.codigoGestao,
                numeroNotaEmpenho: item.numeroNotaEmpenho,
                observacaoRegistro:item.observacaoRegistro
            };

            DespesasService.listarNotasLancamentoPorNeOriginal(reqObj).then(
                function (response) {
                    vm.notasLancamento = response.data;
                    vm.notasLancamentoTotal = _.reduce(vm.notasLancamento, function (memo, obj) {
                        return memo + obj.valorFinal
                    }, 0);

                    hideCurrentModal();
                    execucaoNeTemplate.show();
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar as notas de lançamento na execução da nota de empenho',
                        type: 'info'
                    });
                }
            );

            DespesasService.listarOrdemBancariaPorNeOriginal(reqObj).then(
                function (response) {
                    vm.ordensBancarias = response.data;
                    vm.ordensBancariasTotal = _.reduce(vm.ordensBancarias, function (memo, obj) {
                        return memo + obj.valorFinal
                    }, 0);
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar aa ordens bancárias na execução da nota de empenho',
                        type: 'info'
                    });
                }
            );



        };

        vm.exibirModalDescricaoNotaEmpenho = function (item) {
            var reqObj = {
                numeroNotaEmpenho: item.numeroNotaEmpenho,
                codigoUnidadeGestora: item.codigoUnidadeGestora,
                anoNotaEmpenho: item.anoNotaEmpenho,
                codigoGestao: item.codigoGestao
            };

            DespesasService.listarDescricaoNotaEmpenho(reqObj).then(
                function (response) {
                    if (response.data.length == 0) {
                        $alert({
                            content: 'Não há descrições vinculadas',
                            type: 'info'
                        });
                        return;
                    }

                    vm.listaDescricao = response.data;
                    vm.listaDescricaoTotal = _.reduce(vm.listaDescricao, function (memo, obj) {
                        return memo + obj.valorTotal
                    }, 0);

                    hideCurrentModal();
                    descricaoNeTemplate.show();
                },
                function () {
                    $alert({
                        content: 'Erro ao recuperar as descrições da nota de empenho',
                        type: 'info'
                    });
                }
            );

        };

        vm.isNotaFiscalRoute = function() {

          var currentPath = $location.path().trim();

          var acessouSuprimento = sessionStorage.getItem('acessouSuprimento') === 'true';

          if (currentPath === '/despesas/nota-empenho' && acessouSuprimento) {
              return true;
          } else {
              return false;
          }
      };

      $rootScope.$on('$routeChangeStart', function(event, next, current) {

          if ($location.path() === '/despesas/suprimento') {
              sessionStorage.setItem('acessouSuprimento', 'true');
          }else if($location.path() !== '/despesas/nota-empenho'){
            sessionStorage.setItem('acessouSuprimento', 'false');
          }

      });

      $scope.$on('$routeChangeSuccess', function() {
          $scope.$applyAsync(function() {
              vm.isNotaFiscalRoute();
          });
      });


      vm.exibirModalNotaFiscalNotaEmpenho = function (item) {
          var reqObj = {
              anoNotaEmpenho: item.anoNotaEmpenho,
              codigoGestao: item.codigoGestao,
              codigoUnidadeGestora: item.codigoUnidadeGestora,
              numeroNotaEmpenho: item.numeroNotaEmpenho
          };

          DespesasService.listarNotaFiscalNotaEmpenho(reqObj).then(
            function (response) {
              if (response.data.length == 0) {
                $alert({
                  content: 'Não há notas fiscais vinculadas aqui',
                  type: 'info'
                });
                return;
              }

              vm.listaNotaFiscal = response.data;
              vm.listaNotaFiscalTotal = _.reduce(vm.listaNotaFiscal, function (memo, obj) {
                return memo + obj.valorTotal
              }, 0);

              hideCurrentModal();
              notaFiscalNeTemplate.show();
            },
            function (error) {
              $alert({
                content: 'Erro ao recuperar as notas fiscais da nota de empenho',
                type: 'info'
              });
            }
          );

       };

        vm.init = function () {
            storedObj = ScopeService.getStored();
            var obj = $location.search();
            if (obj.exercicio) {
                obj.anoNotaEmpenho = obj.exercicio;
            }

            if (obj.anoNotaEmpenho) {
                vm.item = extend(vm.item, obj);
                vm.item.busy = false;
                if (storedObj) {
                    filtroOrigem = storedObj.filtroOrigem;
                    filtroOrigem.colunas = storedObj.colunas;
                    filtroOrigem.url = storedObj.url;
                } else {
                    filtroOrigem = {};
                }

                vm.applyFilters();
                vm.search();
            }
        };

        vm.applyFilters = function () {
            var fn = function (item, dados) {
                if (item) {
                    var codigo = '';
                    if (Array.isArray(dados)) {
                        dados.forEach(function (dado) {
                            if (dado.nome == item || dado.codigo == item) {
                                codigo = [dado.codigo];
                            }
                        });
                    } else {
                        codigo = [item];
                    }
                    return codigo;
                }
            }
            vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
        };

        var extend = function (obj, src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) obj[key] = src[key];
            }
            return obj;
        };

        vm.voltar = function () {
            $rootScope.filter = filtroOrigem;

            $location.path(filtroOrigem.url).search(filtroOrigem);
        };

        var hasOriginFilter = function () {
            return !(_.isEmpty(filtroOrigem));
        }

        vm.hasOriginFilter = hasOriginFilter;

        vm.search = function () {
            $scope.filter = angular.copy(vm.item);
        };

        var showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
            currentModal = formTpl;
        };

        var showFormDetalhamento = function () {
            angular.element('.tooltip').remove();
            formDetalhamento.show();
            currentModal = formDetalhamento;
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = $scope.colunas;
                vm.item.tipo = $scope.dados.form.tipo;
                RelatorioService.exportar('/despesa/relatorio/nota-empenho', vm.item);
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

    }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('NotaLancamentoController', NotaLancamentoController);

  /** @ngInject */
  function NotaLancamentoController($scope, $modal, $aside, $alert, $location, $window, PagingService, $filter,
    unidadesGestoras, prioridades, DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;
    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    vm.prioridades = prioridades.data;

    var currentModal, backModal;

    var storedObj;
    var filtroOrigem;

    var colunas = {
      notaLancamento: { nome: "Nota Lançamento", visible: true, disabled: true, termo: "Nº do documento que registra a conferência da entrega do produto ou da prestação do serviço" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, disabled: true, termo: "Data em que a conferência da entrega do produto ou prestação do serviço foi registrada" },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
      codigoCredorMascarado: { nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },

      nomeCredor: { nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública" },


      //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------//

      numeroContrato: { nome: "Numero Contrato", visible: false, termo: "" },
      numeroTransferencia: { nome: "Numero transferência", visible: false, termo: "" },
      especie: { nome: "Espécie", visible: false, termo: "" },
      numeroFatura: { nome: "Numero Fatura", visible: false, termo: "" },
      observacao: { nome: "Observação", visible: false, termo: "" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, disabled: true, termo: "Valor que deve ser pago pela entrega de produto ou prestação de serviço" }


    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Lançamento',
      plural: 'Notas de Lançamento'
    };

    vm.item = {
      busy: true,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data),
      buildTextoData: function () {
        if (this.dataInicio) {
          return $filter('date')(this.dataInicio, 'dd/MM/yyyy') + ' - ' + $filter('date')(this.dataFim, 'dd/MM/yyyy');
        }
        return String(this.ano);
      }
    };

    vm.unidadesGestoras = unidadesGestoras.data;

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var notaEmpenhoTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-aside.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var eventoTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.busy = false;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.visualizarItem = function (linha) {
      DespesasService.recuperarNotaLancamento(linha).then(
        function (response) {
          vm.item.editing = false;
          vm.settings.cmd = 'Visualizar';
          vm.linha = response.data;
          showFormDetalhamento();
        }
      );
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    vm.init = function () {
      storedObj = ScopeService.getStored();
      var obj = $location.search();

      if (localStorage.getItem('URL_PREVIOUS_PAGE')) {
        localStorage.removeItem('URL_PREVIOUS_PAGE');
      }

      if (obj.ano) {
        vm.item = extend(vm.item, obj);
        vm.item.busy = false;
        if (storedObj) {
          filtroOrigem = storedObj.filtroOrigem;
          filtroOrigem.anoExercicio = obj.ano;
          filtroOrigem.colunas = storedObj.colunas;
          filtroOrigem.url = storedObj ? storedObj.url : '';
        }
        vm.applyFilters();
        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      $scope.filter = angular.copy(vm.item);
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
      currentModal = formTpl;
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamento.show();
      currentModal = formDetalhamento;
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/nota-lancamento', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    }

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = 'Valor liquidado';
      DespesasService.listarNotasEmpenhoPorNotaLancamentoDetalheNL(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }
          vm.listaNotasEmpenho = response.data;
          vm.totalNotasEmpenho = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          notaEmpenhoTemplate.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          eventoTemplate.show();

        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

  }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('OrdemBancariaController', OrdemBancariaController);

  /** @ngInject */
  function OrdemBancariaController($scope, $modal, $aside, $location, $alert, $window, PagingService,
    unidadesGestoras, gestaoNl, prioridades, DespesasService,
    RelatorioService, ScopeService,
    ConvenioService, $rootScope, dataAtualizacao) {

    var vm = this;

    vm.prioridades = prioridades.data;

    var currentModal, backModal;

    var storedObj;
    var filtroOrigem;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      ordemBancaria: { nome: "Pagamentos", visible: true, disabled: true, termo: "Nº do documento relativo ao valor pago pelo produto entregue ou serviço prestado" },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, termo: "Data de registro do pagamento pelo produto entregue ou serviço prestado" },
      hora: { nome: "Hora", visible: true, termo: "Hora do registro de Pagamento", center: true },
      numeroNotaLancamentoReferencia: { nome: "NL Referência", visible: true, termo: "Número da Nota de Referência", center: true },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      unidadeGestoraLiquidante: { nome: "Unidade Liquidante", visible: true, termo: "Unidade responsável pela liquidação da despesa" },
      nomeGestao: { nome: "Gestão Liquidante", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      nomeGestaoNl: { nome: "Gestão Nl", visible: false, termo: "Gestão Nl" },
      codigoCredorMascarado: { nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
      codigoDomicilioBancario: { nome: "Código Domicílio Bancário", visible: false, termo: "" },
      numeroFatura: { nome: "Numero Fatura", visible: false, termo: "" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, termo: "Valor pago pelo produto entregue ou serviço realizado" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Empenho',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'pdf',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data),
      buildTextoData: function () {
        if (this.dataInicio) {
          return $filter('date')(this.dataInicio, 'dd/MM/yyyy') + ' - ' + $filter('date')(this.dataFim, 'dd/MM/yyyy');
        }
        return String(this.ano);
      }
    };

    var data = {
      url: '/despesa/ordem-bancaria',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.checarDataInvalida = function (data) {
      // Datas abaixo de 2009 e acima da data atual são inválidas
      var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
      var dataFutura = data >= moment().valueOf();
      return anteriorA2009 || dataFutura;
    };


    vm.unidadesGestoras = unidadesGestoras.data;
    vm.gestaoNl = gestaoNl.data;
    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var notaLancamentoFormTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var notasEmpenhoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-aside.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var eventosTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var cancelamentoTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ordem-cancelamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.page = 0;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.visualizarItem = function (linha) {
      if (linha.ordemBancaria.indexOf('NL') > -1) {
        linha.notaLancamento = linha.ordemBancaria;
        DespesasService.recuperarNotaLancamentoOB(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormNL();
          }
        );
      } else if (linha.ordemBancaria.indexOf('OB') > -1) {
        DespesasService.recuperarOrdemBancaria(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormDetalhamento();
          }
        );
      }
    };

    vm.exibirModalNELiquidacao = function (item) {
      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasEmpenhoLiquidacao = response.data;
            vm.notasEmpenhoLiquidacaoTotalPago = _.reduce(vm.listaNotasEmpenhoLiquidacao, function (memo, obj) {
              return memo + obj.valorNeFinal
            }, 0);
            var modal = modalTemplate('Notas de Empenho', 'app/components/despesas/despesas-por-agrupador/empenho-liquidacao-modal.html');
            modal.$promise.then(modal.show);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de empenho', type: 'info' }); }
      );
      DespesasService.listarNotasLancamentoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasLancamentoLiquidacao = response.data;
            vm.notasLancamentoLiquidacaoTotalPago = _.reduce(vm.listaNotasLancamentoLiquidacao, function (memo, obj) {
              return memo + obj.valorFinal
            }, 0);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de lancamento', type: 'info' }); }
      );
    };

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    };

    vm.exibirModalNEporOB = function (item) {

      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = "Valor Pago";

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          var somaValores = 0;
          for (var i = 0; i < vm.listaNotasEmpenho.length; i++) {
            somaValores += vm.listaNotasEmpenho[i].valorNeFinal;
          }
          vm.totalNotasEmpenho = somaValores;
          /*var modal = modalTemplate(
          'Notas de Empenho',
          'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-modal.html');
        modal.$promise.then(modal.show);*/

          hideCurrentModal();
          notasEmpenhoTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    vm.init = function () {
      vm.data.content = [];

      storedObj = ScopeService.getStored();

      if (localStorage.getItem('URL_PREVIOUS_PAGE')) {
        localStorage.removeItem('URL_PREVIOUS_PAGE');
      }

      if (storedObj && storedObj.filtroOrigem) {
        vm.item.ano = storedObj.filtroOrigem.anoExercicio;
      }

      var obj = $location.search();
      if (obj.ano) {
        vm.item = obj;
        if (storedObj) {
          filtroOrigem = storedObj.filtroOrigem;
          filtroOrigem.colunas = storedObj.colunas;
          filtroOrigem.url = storedObj.url;
        } else {
          filtroOrigem = {};
        }
        filtroOrigem.anoExercicio = obj.ano;

        vm.titulo = "Pagamentos";
        var tipoValorPago = vm.item.tipoValorPago;
        switch (tipoValorPago) {
          case 'pago-exercicio':
            vm.titulo = vm.titulo + " no exercício";
            break;
          case 'pago-rpp':
            vm.titulo = vm.titulo + " de restos a pagar processados (RPP)";
            break;
          case 'pago-rpnp':
            vm.titulo = vm.titulo + " de restos a pagar não processados (RPNP)";
            break;
          case 'pago-ret':
            vm.titulo = vm.titulo + " das retenções (RET) ";
            break;
        }

        vm.applyFilters();

        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
      currentModal = formTpl;
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamento.show();
      currentModal = formDetalhamento;
    };

    var showFormNL = function () {
      angular.element('.tooltip').remove();
      notaLancamentoFormTpl.show();
      currentModal = notaLancamentoFormTpl;
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/ordem-bancaria', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = "Valor Ajuste Pagamento";

      DespesasService.listarNotasEmpenhoPorNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          vm.totalNotasEmpenho = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          notasEmpenhoTpl.show();

        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          eventosTemplate.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

    vm.exibirOrdensDeCancelamento = function (item) {
      var reqObj = {
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroOrdemBancaria: item.ordemBancaria
      };

      DespesasService.listarOrdemCancelamentoPorOB(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há ordens de cancelamento vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaOrdensCancelamento = response.data;


          /*
          vm.listaEventosTotal = _.reduce( vm.listaEventos, function(memo, obj) {
            return memo + obj.valorLancamento
          }, 0 );*/

          //   var modal = modalTemplate(
          //     'Ordens de Cancelamento',
          //     'app/components/despesas/despesas-por-agrupador/extrato-ordem-cancelamento.html');
          //   modal.$promise.then(modal.show);
          hideCurrentModal();
          cancelamentoTemplate.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar ordens de cancelamento',
            type: 'danger'
          });
        }
      );
    }

  }

})();

(function(){
  'use strict';

  angular.module('portal.despesa').controller('DespesaPorAcaoController', DespesaPorAcaoController);

  /** @ngInject */
  function DespesaPorAcaoController($scope, $aside, PagingService, RelatorioService, ScopeService) {

    var vm = this;

    var colunas = {
      nomeProjeto: {nome: "Ação Orçamentária", visible: true, disabled:true},
      valorNeFinal: {nome: "Empenhado", visible: true, currency: true },
      valorNlBruto: {nome: "Liquidado", visible: true, currency: true},
      valorObFinal: {nome: "Pago", visible: true, currency: true}
    };

    // settings
    vm.settings = {
      singular: 'Nota de Empenho',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'pdf',
      page: 0,
    };

    var data = {
      url: '/despesa/acao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/agrupador-valores-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.init = function() {
      vm.data.content = [];

      var storedObj = ScopeService.getStored();
      if(storedObj) {
        vm.item = {
          anoNotaEmpenho: storedObj['detalhamento'].anoExercicio,
          codigoProjeto: storedObj['detalhamento'].codigoProjeto,
          codigoCredor: storedObj['detalhamento'].codigoCredor,
          codigoUnidadeGestora: storedObj['detalhamento'].codigoUnidadeGestora,
        };
      }

      vm.item.page = 0;
      vm.item.padrao = true;
      vm.data.form = vm.item;
      pesquisa();
    }

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      pesquisa();
    };

    var pesquisa = function() {
      PagingService.pesquisar(vm.data).then(
        function(response) {
          if(response.totalElements > 0 && vm.item.editing) hideForm();
        },
        function(error) {
          hideForm;
        });
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var hideForm = function(){
      formTpl.hide();
    };

    vm.exportar = function(item) {
      if(item) item.colunas = vm.settings.colunas;
      RelatorioService.exportar('/despesa/relatorio/acao', item);
    };

    $scope.$on('$destroy', function() {
      hideForm();
    });

  }

})();

(function () {
    'use strict';

    angular.module('portal.despesa').controller('DespesasPorAgrupadorController', Controller);

    /** @ngInject */
    function Controller($scope, $rootScope, $aside, $location, tipo, initialParams, ScopeService, RelatorioService,
        dataAtualizacao, $routeParams, crumble, DespesasService) {

        var vm = this, anos = initialParams.anos;
        //covid auxílio união
        var CODIGOS_FONTE_RECURSO_COVID = ["138018816", "138019886", "138020688", "158018949", "158018950", "158018951", "188000000", "189000000", "191000000", "738018816", "739018816", "338018816", "338019886", "338020655", "338020688", "358018949", "358018950", "358018951", "388000000", "389000000", "389010327", "389014725", "389018949", "389018950",
      "389018951", "391000000", "738018816", "839018816"];

        vm.data = [];
        vm.contador = 0;
        vm.dataAtualizacao = dataAtualizacao;
        vm.consultaObrasInstalacoes = true;

        vm.tipo = tipo;

        vm.hiddenFilters = [];

        vm.filterOptions = {
            listaCodigoFonteRecurso: {
                disabled: 'false'
            }
        };

        var configuracao = {
            acao: {
                titulo: 'Despesas por Ação',
                texto: 'Aqui está disponível, de forma anual, informações das despesas realizadas pela Administração Pública, discriminadas por ações orçamentárias. A consulta tem como referência o empenho. Então, o resultado apresenta os empenhos registrados no período pesquisado e todas as liquidações e pagamentos relacionados a esses empenhos, independente da data em que ocorreram. Fonte: SIGGO (SEEC)' ,
                saibaMaisLink: '#/despesas/saiba-mais',
                colunas: {
                    nomeProjeto: { nome: "Ação", visible: true, disabled: true, destacado: true, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    anoExercicio: { nome: "Exercício", visible: false, termo: "Ano de emissão da Nota de Empenho" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF do Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    nomeCredor: { nome: "Credor", visible: false, termo: "Nome de quem tem um valor a receber da Administração Pública" },
                    numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: false, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade De aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
                    nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                }
            },

            credor: {
                titulo: 'Despesas por Credor',
                texto: 'Veja aqui todas as despesas realizadas com pessoas ou empresas que prestaram serviço ou venderam bem à Administração Pública. A consulta tem como referência o empenho. Então, o resultado apresenta os empenhos registrados no período pesquisado e todas as liquidações e pagamentos relacionados a esses empenhos, independente da data em que ocorreram. Fonte: SIGGO (SEEC)',
                saibaMaisLink: '#/despesas/saiba-mais',
                colunas: {
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: true, disabled: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    nomeCredor: { nome: "Credor", visible: true, disabled: true, termo: "Quem tem um valor a receber da Administração Pública" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: false, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação " },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
                    nomeFonteRecurso: { nome: "Fonte de Recursos", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                }
            },

            orgao: {
                titulo: 'Despesas por Órgão',
                texto: 'Aqui estão as despesas anuais da Administração Pública, discriminadas por unidade gestora. A consulta tem como referência o empenho. Então, o resultado apresenta os empenhos registrados no período pesquisado e todas as liquidações e pagamentos relacionados a esses empenhos, independente da data em que ocorreram. Fonte: SIGGO (SEEC) ',
                saibaMaisLinkObras: '#/despesas/saiba-mais-obras',
                colunas: {
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
                    nomeFonteRecurso: { nome: "Fonte de Recursos", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    nomeCredor: { nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                }
            },

            covidorgao: {
                titulo: 'Despesas COVID-19',
                texto: 'Veja aqui as despesas relacionadas ao enfrentamento da Covid-19, cujo tipo de licitação foi assinalado com os códigos 19 (com contrato) ou 22 (sem contrato) ou, ainda, cuja fonte de recursos foram os auxílios da União. Fonte: SIGGO (SEEC)',
                colunas: {
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
                    nomeFonteRecurso: { nome: "Fonte de Recursos", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    numeroProcesso: { nome: "Nº do Processo", visible: true, termo: "Nº do processo referente à despesa" },
                    numeroContrato: { nome: "Nº do Contrato", visible: true, center: true, termo: "Nº do contrato referente à despesa" },
                    nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
                    referenciaLicitacao: { nome: "Referência da Licitação", visible: false, termo: "Referência da Licitação" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                }
            },

            suprimento: {
                titulo: 'Suprimento de Fundos',
                texto: ' Veja aqui as despesas de caráter excepcional, de pronto pagamento (tipo de Despesa - Suprimento de Fundos). Fonte: SIGGO (SEEC).',
                colunas: {
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeGestao: { nome: "Gestão", visible: true, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, disabled: true, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: true, termo: "Indica os objetos de gastos" },
                    nomeFonteRecurso: { nome: "Fonte de Recursos", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                },
                onInit: function (initialParams, model) {
                    this.setModalidadeLicitacaoParam(initialParams.modalidadesLicitacaoUltimoAno, model);
                },
                onFiltrosLoad: function (data, model) {
                    this.setModalidadeLicitacaoParam(data.modalidadeLicitacao, model);
                },
                setModalidadeLicitacaoParam: function (modalidades, model) {
                    modalidades.filter(function (mod) {
                        return mod.nome == 'SUPRIMENTO DE FUNDOS';
                    }).forEach(function (mod) {
                        if (model.listaCodigoModalideLicitacao == undefined) {
                            model.listaCodigoModalideLicitacao = [mod.codigo];
                        }
                    });
                }
            },

            covidAuxilioUniao: {
                titulo: 'Despesas Transferência União',
                texto: 'Aqui foram destacadas as despesas realizadas com os AUXÍLIOS FINANCEIROS DA UNIÃO, recebidos pelo GDF, para o enfrentamento da Covid-19. Essas despesas estão incluídas na consulta Despesas COVID-19, cujo valor é maior pois engloba, além desses auxílios, outras fontes de recursos do Distrito Federal. Fonte: SIGGO (SEEC)',
                colunas: {
                    nomeFonteRecurso: { nome: "Fonte de Recurso", visible: true, disabled: true, termo: "Indica a origem dos recursos para realizar as despesas" },
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    anoExercicio: { nome: "Exercício", visible: false, center: true, termo: "Ano da despesa" },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Esfera da despesa" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    nomeElemento: { nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos" },
                    numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, disabled: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                },
                onInit: function(initialParams, model) {
                    this.setPredefinedParams(model);
                },
                onReset: function(model) {
                    this.setPredefinedParams(model);
                    this.setPredefinedFilters(model);
                },
                setPredefinedParams: function(model) {
                    model.listaCodigoFonteRecurso = CODIGOS_FONTE_RECURSO_COVID;
                },
                setPredefinedFilters: function(model) {
                    if (this._fonte != undefined) {
                        model.listaFonteRecurso = this._fonte.map(function(fonte) {
                            return fonte.nome;
                        });
                    }
                },
                onFiltrosLoad: function(resp, model) {
                    if (this._fonte == undefined) {
                        this._fonte = this._filterFontesByCodigo(resp.fonte, CODIGOS_FONTE_RECURSO_COVID);

                        this.setPredefinedFilters(model);
                    }

                    vm.fonte = this._fonte;
                },
                onFilterSubmit: function(model) {
                    if (!model.listaCodigoFonteRecurso || model.listaCodigoFonteRecurso.length == 0) {
                        this.setPredefinedParams(model);
                    }

                    if (!model.listaFonteRecurso || model.listaFonteRecurso.length == 0) {
                        this.setPredefinedFilters(model);
                    }
                },
                _filterFontesByCodigo: function(fontes, codigos) {
                    return fontes.filter(function(fonte) {
                        return codigos.filter(function(cd) {
                            return fonte.codigo.indexOf(cd) == 0;
                        }).length > 0;
                    });
                }
            },
              exerciciosAnteriores: {
                titulo: 'DEA - Despesas de exercícios anteriores',
                texto: 'Veja aqui as despesas realizadas pelo Governo do Distrito Federal referentes a exercícios anteriores. A consulta tem como referência o empenho. Então, o resultado apresenta os empenhos registrados no período pesquisado e todas as liquidações e pagamentos relacionados a esses empenhos, independente da data em que ocorreram. Fonte: SIGGO (SEEC)',
                saibaMaisLink: '#/despesas/saiba-mais',
                colunas: {
                    nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                    nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                    codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                    nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
                    nomeEsfera: { nome: "Esfera", visible: false, termo: "Esfera da despesa" },
                    nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                    nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                    nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                    nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                    nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                    nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                    nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                    nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                    nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                    nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                    nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                    numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                    valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                    valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                    valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                    valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                    valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                    valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                    valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, disabled: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
                },
                onInit: function(initialParams, model) {
                    vm.hiddenFilters.push('elementoDespesa');
                },
                onReset: function(model) {
                    this.setPredefinedParams(model);
                },
                setPredefinedParams: function(model) {
                    model.consultaExerciciosAnteriores = true;
                },
                onFilterSubmit: function(model) {
                    if (!model.consultaExerciciosAnteriores) {
                        this.setPredefinedParams(model);
                    }
                },
                onNotaEmpenhoDetalhada: function(row, notaEmpenhoParams) {
                    notaEmpenhoParams.consultaExerciciosAnteriores = true;
                },
                onNotaLancamentoDetalhada: function(row, notaLancamentoParams) {
                    notaLancamentoParams.consultaExerciciosAnteriores = true;
                },
                onOrdemBancariaDetalhada: function(row, ordemBancariaParams) {
                    ordemBancariaParams.consultaExerciciosAnteriores = true;
                }
            },
              obrasInstalacoes: {
              titulo: 'Obras e Instalações',
              texto: 'Veja aqui as despesas realizadas pelo Governo do Distrito Federal referentes à Obras e Instalações. A consulta tem como referência o empenho. Então, o resultado apresenta os empenhos registrados no período pesquisado e todas as liquidações e pagamentos relacionados a esses empenhos, independente da data em que ocorreram. Fonte: SIGGO (SEEC). <br></br>Consulte outras informações e documentos públicos relacionados às obras na <a href="https://sei.df.gov.br/sei/modulos/pesquisa/md_pesq_processo_pesquisar.php?acao_externa=protocolo_pesquisar&acao_origem_externa=protocolo_pesquisar&id_orgao_acesso_externo=0" target="_blank">Pesquisa Pública do SEI-GDF</a>.',
              saibaMaisLinkObras: '#/despesas/saiba-mais-obras',
              colunas: {
                  nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
                  nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
                  codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
                  nomeCredor: { nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública" },
                  nomeEsfera: { nome: "Esfera", visible: false, termo: "Esfera da despesa" },
                  nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
                  nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
                  nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
                  nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
                  nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
                  nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
                  nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
                  nomeSubtitulo: { nome: "Subtítulo", visible: true, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
                  nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
                  nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
                  nomeModalidadeAplicacao: { nome: "Modalidade de Aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
                  numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
                  valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
                  valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
                  valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
                  valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
                  valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
                  valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
                  valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, disabled: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
              },
              onInit: function(initialParams, model) {
                  vm.hiddenFilters.push('elementoDespesa');
              },
              onReset: function(model) {
                  this.setPredefinedParams(model);
              },
              setPredefinedParams: function(model) {
                  model.consultaObrasInstalacoes = true;
              },
              onFilterSubmit: function(model) {
                  if (!model.consultaObrasInstalacoes) {
                      this.setPredefinedParams(model);
                  }
              },
              onNotaEmpenhoDetalhada: function(row, notaEmpenhoParams) {
                  notaEmpenhoParams.consultaObrasInstalacoes = true;
              },
              onNotaLancamentoDetalhada: function(row, notaLancamentoParams) {
                  notaLancamentoParams.consultaObrasInstalacoes = true;
              },
              onOrdemBancariaDetalhada: function(row, ordemBancariaParams) {
                  ordemBancariaParams.consultaObrasInstalacoes = true;
              }
            }
        };

        vm.carregarFiltros = carregarFiltros;

        //Objetos do filtro
        vm.anos = anos;
        vm.unidadesGestoras = [];
        vm.gestoes = [];
        vm.esfera = [];
        vm.funcoes = [];
        vm.subfuncoes = [];
        vm.programa = [];
        vm.modalidadeLicitacao = [];
        vm.categoriaEconomica = [];
        vm.grupoNatureza = [];
        vm.modalidadeAplicacao = [];
        vm.elemento = [];
        vm.fonte = [];

        function carregarFiltros(exercicio) {
            if(exercicio == 0) {
                exercicio = null;
            }
            vm.loadingFilter = true;
            if(tipo == 'covidorgao'){
              DespesasService.listarFiltrosCovid(exercicio)
              .then(function (response) {
                  vm.unidadesGestoras = response.data.unidadesGestoras;
                  vm.gestoes = response.data.gestoes;
                  vm.esfera = response.data.esfera;
                  vm.funcoes = response.data.funcoes;
                  vm.subfuncoes = response.data.subfuncoes;
                  vm.programa = response.data.programa;
                  vm.modalidadeLicitacao = response.data.modalidadeLicitacao;
                  vm.categoriaEconomica = response.data.categoriaEconomica;
                  vm.grupoNatureza = response.data.grupoNatureza;
                  vm.modalidadeAplicacao = response.data.modalidadeAplicacao;
                  vm.elemento = response.data.elemento;
                  vm.fonte = response.data.fonte;

                  vm.loadingFilter = false;
              });
            } else if(tipo == 'covidAuxilioUniao'){
              DespesasService.listarFiltrosCovidAuxUni(exercicio)
              .then(function (response) {
                  vm.unidadesGestoras = response.data.unidadesGestoras;
                  vm.gestoes = response.data.gestoes;
                  vm.esfera = response.data.esfera;
                  vm.funcoes = response.data.funcoes;
                  vm.subfuncoes = response.data.subfuncoes;
                  vm.programa = response.data.programa;
                  vm.modalidadeLicitacao = response.data.modalidadeLicitacao;
                  vm.categoriaEconomica = response.data.categoriaEconomica;
                  vm.grupoNatureza = response.data.grupoNatureza;
                  vm.modalidadeAplicacao = response.data.modalidadeAplicacao;
                  vm.elemento = response.data.elemento;
                  vm.fonte = response.data.fonte;

                  vm.loadingFilter = false;
              });
            } else{
              DespesasService.listarFiltros(exercicio)
              .then(function (response) {
                  vm.unidadesGestoras = response.data.unidadesGestoras;
                  vm.gestoes = response.data.gestoes;
                  vm.esfera = response.data.esfera;
                  vm.funcoes = response.data.funcoes;
                  vm.subfuncoes = response.data.subfuncoes;
                  vm.programa = response.data.programa;
                  vm.modalidadeLicitacao = response.data.modalidadeLicitacao;
                  vm.categoriaEconomica = response.data.categoriaEconomica;
                  vm.grupoNatureza = response.data.grupoNatureza;
                  vm.modalidadeAplicacao = response.data.modalidadeAplicacao;
                  vm.elemento = response.data.elemento;
                  vm.fonte = response.data.fonte;

                  /*
                  if (configuracao[tipo].onFiltrosLoad != undefined) {
                      configuracao[tipo].onFiltrosLoad(response.data, vm.item);
                  }*/

                  vm.loadingFilter = false;
              });
            }
        }

        vm.current = configuracao[tipo];
        vm.titulo = configuracao[tipo].titulo;
        vm.texto = configuracao[tipo].texto;

        vm.exibirTabelaAgrupadora = true;
        vm.exibirBtnPesquisa = true;
        vm.exibirCampo = false;

        vm.lista = '';


        $scope.colunas = configuracao[tipo].colunas;

        /*$scope.isColumnEnabled = function(name, column) {
          return !column.currency;
        };

        var acoesTabela = [
          {
            type: 'link-click',
            title: 'Detalhar',
            align: 'right',
            buildLabel: function(item) {
              return item.valorNeFinal;
            },
            onClick: function(item) {
              vm.visualizarEmpenhado(item);
            },
            isVisible: function() {
              return $scope.colunas.valorNeFinal != undefined && $scope.colunas.valorNeFinal.visible;
            }
          },{
            type: 'link-click',
            title: 'Detalhar',
            align: 'right',
            buildLabel: function(item) {
              return item.valorNlBruto;
            },
            onClick: function(item) {
              vm.visualizarLiquidado(item);
            },
            isVisible: function() {
              return $scope.colunas.valorNlBruto != undefined && $scope.colunas.valorNlBruto.visible;
            }
          },{
            type: 'link-click',
            title: 'Detalhar',
            align: 'right',
            buildLabel: function(item) {
              return item.valorObFinal;
            },
            onClick: function(item) {
              vm.visualizarPago(item,'pago-final');
            },
            isVisible: function() {
              return $scope.colunas.valorObFinal != undefined && $scope.colunas.valorObFinal.visible;
            }
          }
        ];
        $scope.acoesTabela = acoesTabela;*/


        // settings
        vm.settings = {
            singular: 'Despesa',
            plural: 'Despesas'
        };

        vm.item = {
            anoExercicio: vm.anos[0],
            busy: false,
            editing: true,
            colunas: $scope.colunas,
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        var tipoCrumble = vm.titulo;
        crumble.update({ tipo: tipoCrumble });
        crumble.context = { tipo: tipoCrumble };
        crumble.update();

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/despesas/despesas-por-agrupador/agrupador-valores-form.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.item = {
                busy: false,
                editing: true,
                colunas: vm.item.colunas = $scope.colunas,
                anoExercicio: anos[0]
            };
            if (tipo == 'covidorgao') {
                vm.item.consultaCovid = true;
            }

            if (tipo == 'covidAuxilioUniao') {
             vm.item.consultaCovidAuxUni = true;
          }

            if (configuracao[tipo].onReset != undefined) {
                configuracao[tipo].onReset(vm.item, vm.filterOptions);
            }
        };

        vm.visualizarEmpenhado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/despesas/' + tipo;

            ScopeService.store(obj);

            var params = {
                anoNotaEmpenho: row.anoExercicio ? row.anoExercicio : vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                tipoLicitacao: (!vm.item.listaCodigoModalideLicitacao || vm.item.listaCodigoModalideLicitacao.length > 1) ? null : vm.item.listaCodigoModalideLicitacao[0],
                listaTipoLicitacao: vm.item.listaCodigoModalideLicitacao && vm.item.listaCodigoModalideLicitacao.length > 1 ? vm.item.listaCodigoModalideLicitacao : null,
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                listaFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso,
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                nomeElemento: !vm.item.nomeElemento ? row.nomeElemento : vm.item.nomeElemento,
                nomeFonteRecurso: !vm.item.nomeFonteRecurso ? row.nomeFonteRecurso : vm.item.nomeFonteRecurso,
                nomeGrupoNatureza: !vm.item.nomeGrupoNatureza ? row.nomeGrupoNatureza : vm.item.nomeGrupoNatureza,
                nomeModalidadeLicitacao: !vm.item.nomeModalidadeLicitacao ? row.nomeModalidadeLicitacao : vm.item.nomeModalidadeLicitacao,
                nomeSubfuncao: !vm.item.nomeSubfuncao ? row.nomeSubfuncao : vm.item.nomeSubfuncao,
                nomeFuncao: !vm.item.nomeFuncao ? row.nomeFuncao : vm.item.nomeFuncao,
                nomeGestao: !vm.item.nomeGestao ? row.nomeGestao : vm.item.nomeGestao,
                codigoFonteRecurso: !vm.item.codigoFonteRecurso ? row.codigoFonteRecurso : vm.item.codigoFonteRecurso,
                consultaCovid: !vm.item.consultaCovid ? row.consultaCovid : vm.item.consultaCovid,
                consultaCovidAuxUni: !vm.item.consultaCovidAuxUni ? row.consultaCovidAuxUni : vm.item.consultaCovidAuxUni
            };

            if (configuracao[tipo].onNotaEmpenhoDetalhada != undefined) {
                configuracao[tipo].onNotaEmpenhoDetalhada(row, params);
            }

            $location.path('/despesas/nota-empenho').search(params);
        };

        vm.visualizarLiquidado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/despesas/' + tipo;

            ScopeService.store(obj);

            var params = {
                ano: row.anoExercicio ? row.anoExercicio : vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                listaFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso,
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                nomeElemento: !vm.item.nomeElemento ? row.nomeElemento : vm.item.nomeElemento,
                nomeFonteRecurso: !vm.item.nomeFonteRecurso ? row.nomeFonteRecurso : vm.item.nomeFonteRecurso,
                nomeGrupoNatureza: !vm.item.nomeGrupoNatureza ? row.nomeGrupoNatureza : vm.item.nomeGrupoNatureza,
                nomeTipoLicitacao: !vm.item.nomeModalidadeLicitacao ? row.nomeModalidadeLicitacao : vm.item.nomeModalidadeLicitacao,
                nomeSubfuncao: !vm.item.nomeSubfuncao ? row.nomeSubfuncao : vm.item.nomeSubfuncao,
                nomeFuncao: !vm.item.nomeFuncao ? row.nomeFuncao : vm.item.nomeFuncao,
                nomeGestao: !vm.item.nomeGestao ? row.nomeGestao : vm.item.nomeGestao,
                codigoFonteRecurso: !vm.item.codigoFonteRecurso ? row.codigoFonteRecurso : vm.item.codigoFonteRecurso,
                consultaCovid: !vm.item.consultaCovid ? row.consultaCovid : vm.item.consultaCovid,
                consultaCovidAuxUni: !vm.item.consultaCovidAuxUni ? row.consultaCovidAuxUni : vm.item.consultaCovidAuxUni
            };

            if (configuracao[tipo].onNotaLancamentoDetalhada != undefined) {
                configuracao[tipo].onNotaLancamentoDetalhada(row, params);
            }

            $location.path('/despesas/nota-lancamento').search(params);
        };

        vm.visualizarPago = function (row, tipoValorPago) {
            vm.item.colunas = $scope.colunas;

            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };

            obj.url = '/despesas/' + tipo;

            ScopeService.store(obj);

            var params = {
                ano: row.anoExercicio ? row.anoExercicio : vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: !row.nomeCredor ? vm.item.nomeCredor : row.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                listaFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso,
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                tipoValorPago: tipoValorPago,
                nomeElemento: !vm.item.nomeElemento ? row.nomeElemento : vm.item.nomeElemento,
                nomeFonteRecurso: !vm.item.nomeFonteRecurso ? row.nomeFonteRecurso : vm.item.nomeFonteRecurso,
                nomeGrupoNatureza: !vm.item.nomeGrupoNatureza ? row.nomeGrupoNatureza : vm.item.nomeGrupoNatureza,
                nomeTipoLicitacao: !vm.item.nomeModalidadeLicitacao ? row.nomeModalidadeLicitacao : vm.item.nomeModalidadeLicitacao,
                nomeSubfuncao: !vm.item.nomeSubfuncao ? row.nomeSubfuncao : vm.item.nomeSubfuncao,
                nomeFuncao: !vm.item.nomeFuncao ? row.nomeFuncao : vm.item.nomeFuncao,
                nomeGestao: !vm.item.nomeGestao ? row.nomeGestao : vm.item.nomeGestao,
                codigoFonteRecurso: !vm.item.codigoFonteRecurso ? row.codigoFonteRecurso : vm.item.codigoFonteRecurso,
                consultaCovid: !vm.item.consultaCovid ? row.consultaCovid : vm.item.consultaCovid,
                consultaCovidAuxUni: !vm.item.consultaCovidAuxUni ? row.consultaCovidAuxUni : vm.item.consultaCovidAuxUni
            };

            if (configuracao[tipo].onOrdemBancariaDetalhada != undefined) {
                configuracao[tipo].onOrdemBancariaDetalhada(row, params);
            }

            $location.path('/despesas/ordem-bancaria').search(params);
        };

        vm.exibirFormPesquisa = function () {
            carregarFiltros(vm.item.anoExercicio);
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showFormPesquisa();
        };

        vm.search = function () {
            if (configuracao[tipo].onFilterSubmit != undefined) {
                configuracao[tipo].onFilterSubmit(vm.item);
            }

            $scope.filter = copyFilterModel(vm.item);
        };

        var showFormPesquisa = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
            if (vm.titulo == 'Despesas por Órgão' || vm.titulo == 'credor') {
                vm.exibirCampo = true;
            }
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = $scope.colunas;
                vm.item.tipo = $scope.dados.form.tipo;
                RelatorioService.exportar('/despesa/relatorio/' + tipo, vm.item);
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

        $scope.fecharModalColunas = function (columnsChangeEvent) {
            if(columnsChangeEvent.hasChange == true) {
                vm.search();
            }
        };

        vm.init = function () {
            // Leitura de parâmetros em url
            var params = $location.search();

            if (params.colunas != null) {
                $scope.colunas = params.colunas;
            }

            if (params.anoExercicio || params.ano) {
                vm.item = extend(vm.item, params);
            } else {
                vm.item.anoExercicio = anos[0];
            }
            if(tipo == 'covidAuxilioUniao'){
                vm.item.anoExercicio = null;
                vm.item.consultaCovidAuxUni = true;
            }

            if (tipo == 'covidorgao') {
                vm.item.consultaCovid = true;
                vm.hiddenFilters.push('tipoDespesa');
                vm.item.anoExercicio = null;
            }

            if (params.unidadeGestora) {
                $scope.colunas.nomeUnidadeGestora.visible = true;
            }

            if (params['orgao'] || params['codigoUnidadeGestora']) {
                DespesasService.listarUnidadeGestora(vm.item.anoExercicio)
                    .then(function (response) {
                        vm.unidadesGestoras = response.data;
                        vm.assignInitParams(params, vm.item);
                        vm.search();
                    });
            } else {
                vm.assignInitParams(params, vm.item);
                vm.search();
            }
        };

        vm.shouldHideFilter = function(filter) {
            return !vm.hiddenFilters.includes(filter);
        }

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         * @param {*} modelObject Objeto modelo.
         */
        vm.assignInitParams = function (params, modelObject) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

                    if (element != null) {
                        if (valueProp != undefined) {
                            element = element[valueProp];
                        }

                        modelObj[modelProp] = isMultiple ? [element] : element;
                    }
                }
            };

            assignProps([
                { from: 'ano', to: 'anoExercicio', type: String },
                { from: 'nome', to: 'nomeCredor', type: String },
                { from: 'acao', to: 'nomeProjeto', type: String },
                { from: 'unidadeGestora', to: 'nomeUnidadeGestora', type: String },
                { from: 'codigoCredor', to: 'codigoCredor', type: String }], params, vm.item);

            assignSelect(vm.unidadesGestoras, vm.item, 'listaCodigoUnidadeGestora', params['orgao'], 'nome', 'codigo', true);
            assignSelect(vm.unidadesGestoras, vm.item, 'listaCodigoUnidadeGestora', params['codigoUnidadeGestora'], 'codigo', 'codigo', true);
        };

        vm.checarDataInvalida = function (data) {
            // Datas abaixo de 2009 e acima da data atual são inválidas
            var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
            var dataFutura = data >= moment().valueOf();
            return anteriorA2009 || dataFutura;
        };


        var extend = function (obj, src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) obj[key] = src[key];
            }
            return obj;
        }


        if (configuracao[tipo].onInit != undefined) {
            configuracao[tipo].onInit(initialParams, vm.item, vm.filterOptions);
        }
    }

    /**
     * Copia um objeto modelo de filtro.
     * @param {*} filterModel Modelo do filtro.
     */
    function copyFilterModel(filterModel) {
        var copy = angular.copy(filterModel);

        copy.colunas = buildColunasParamsMap(copy.colunas);

        return copy;
    }

    /**
     * Constrói o map de parametros correspondentes às colunas.
     * @param {*} colunas Objeto modelo das colunas.
     */
    function buildColunasParamsMap(colunas) {
        var map = {};

        Object.keys(colunas)
            .forEach(function (key) {
                map[key] = {
                    visible: colunas[key].visible
                };
            });

        return map;
    }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('NotaEmpenhoDiariasPassagensController', NotaEmpenhoDiariasPassagensController);

  /** @ngInject */
  function NotaEmpenhoDiariasPassagensController($scope, $modal, $aside, $location, $alert, unidadesGestoras,
                                 DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;

    var currentModal, backModal;

    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    var storedObj;
    var filtroOrigem;

    var colunas = {
      numeroNotaEmpenho: {nome: "Nota Empenho", visible: true, disabled: true, termo: "Nº do documento utilizado para formalizar o comprometimento da despesa"},
      dataEmissao: {nome: "Emissão", visible: true, date: true, termo: "Data em que o comprometimento da despesa foi registrado"},
      nomeUnidadeGestora: {nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos"},
      nomeGestao: {nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos"},
      nomeEsfera: {nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais"},
      processo: {nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa"},
      nomeModalidadeLicitacao: {nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa"},
      nomeProgramaTrabalho: {nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo"},
      nomeFuncao: {nome: "Função", visible: false, termo: "Área de atuação da Administração Pública"},
      nomeSubfuncao: {nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação "},
      nomePrograma: {nome: "Programa", visible: false, termo: "Instrumento de atuação governamental, formado por um conjunto de ações "},
      nomeProjeto: {nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa"},
      nomeSubtitulo: {nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária"},
      nomeCategoriaEconomica: {nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico"},
      nomeNaturezaDespesa: {nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto"},
      nomeModalidadeAplicacao: {nome: "Modalidade de Aplicação", visible: false, termo: "Forma de aplicação dos recursos: diretamente ou por transferência a outras entidades "},
      nomeElementoDespesa: {nome: "Elemento de Despesa", visible: false, termo: "Indica os objetos de gastos"},
      nomeFonteRecurso: {nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas"},
      codigoCredorMascarado: {nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública"},
      nomeCredor: {nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública"},
      valorNeFinal: {nome: "Valor Final", visible: true, currency: true, termo: "Valor reservado para pagamento pela prestação ou entrega do serviço após os reforços e anulações"}
    };


    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Empenho',
      plural: 'Notas de Empenho'
    };

    vm.item = {
      busy: true,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    vm.unidadesGestoras = unidadesGestoras.data;

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-empenho-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoNeTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var subitemNeTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/subitem-ne-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var execucaoNeTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/execucao-ne-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var descricaoNeTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/descricao-ne-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.busy = false;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFormFiltro();
    };

    vm.visualizarItem = function (linha) {
      DespesasService.recuperarNotaEmpenho(linha).then(
        function (response) {
          vm.item.editing = false;
          vm.settings.cmd = 'Visualizar';
          vm.linha = response.data;
          showFormDetalhamento();
        }
      );
    };

    var hideCurrentModal = function() {
        if (currentModal) {
            currentModal.hide();
            backModal = currentModal;
        }
    };

    vm.backCurrentModal = function() {
        if (backModal) {
            backModal.show();
            backModal = undefined;
        }
    };

    vm.exibirModalExtratoNotaEmpenho = function (item) {

      var reqObj = {
        anoNotaEmpenho: item.anoNotaEmpenho,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroNotaEmpenho: item.numeroNotaEmpenho
      };

      DespesasService.listarExtratoNotaEmpenho(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.extratoAnual = response.data;
          vm.extratoTotal = _.reduce(vm.extratoAnual, function (memo, obj) {
            return memo + obj.valorNe
          }, 0);

          hideCurrentModal();
          extratoNeTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalSubitemNotaEmpenho = function (item) {

      var reqObj = {
        anoNotaEmpenho: item.anoNotaEmpenho,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroNotaEmpenho: item.numeroNotaEmpenho
      };

      DespesasService.listarSubitemDespesa(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há subitens para essa nota de empenho',
              type: 'info'
            });
            return;
          }

          vm.subitemsDespesa = response.data;
          vm.subitemsDespesaTotal = _.reduce(vm.subitemsDespesa, function (memo, obj) {
            return memo + obj.valor
          }, 0);

          hideCurrentModal();
          subitemNeTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar subitens',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalExecucaoNotaEmpenho = function (item) {

      var reqObj = {
        anoNotaEmpenho: item.anoNotaEmpenho,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroNotaEmpenho: item.numeroNotaEmpenho
      };

      DespesasService.listarNotasLancamentoPorNeOriginal(reqObj).then(
        function (response) {
          vm.notasLancamento = response.data;
          vm.notasLancamentoTotal = _.reduce(vm.notasLancamento, function (memo, obj) {
            return memo + obj.valorFinal
          }, 0);

          hideCurrentModal();
          execucaoNeTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar as notas de lançamento na execução da nota de empenho',
            type: 'info'
          });
        }
      );

      DespesasService.listarOrdemBancariaPorNeOriginal(reqObj).then(
        function (response) {
          vm.ordensBancarias = response.data;
          vm.ordensBancariasTotal = _.reduce(vm.ordensBancarias, function (memo, obj) {
            return memo + obj.valorFinal
          }, 0);
        },
        function () {
          $alert({
            content: 'Erro ao recuperar aa ordens bancárias na execução da nota de empenho',
            type: 'info'
          });
        }
      );

    };

    vm.exibirModalDescricaoNotaEmpenho = function (item) {
      var reqObj = {
        numeroNotaEmpenho: item.numeroNotaEmpenho,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        anoNotaEmpenho: item.anoNotaEmpenho,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarDescricaoNotaEmpenho(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há descrições vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaDescricao = response.data;
          vm.listaDescricaoTotal = _.reduce(vm.listaDescricao, function (memo, obj) {
            return memo + obj.valorTotal
          }, 0);

          hideCurrentModal();
          descricaoNeTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar as descrições da nota de empenho',
            type: 'info'
          });
        }
      );
    };

    vm.init = function () {
      storedObj = ScopeService.getStored();
      var obj = $location.search();
      if (obj.anoNotaEmpenho) {
        vm.item = extend(vm.item, obj);
        vm.item.busy = false;
        filtroOrigem = storedObj.filtroOrigem;
        filtroOrigem.anoExercicio = obj.anoNotaEmpenho;
        filtroOrigem.colunas = storedObj.colunas;
        filtroOrigem.url = storedObj ? storedObj.url : '';
        vm.applyFilters();
        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      $scope.filter = angular.copy(vm.item);
    };

    var showFormFiltro = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
      currentModal = formTpl;
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
      currentModal = formDetalhamentoTpl;
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/nota-empenho', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('NotaLancamentoDiariasPassagensController', NotaLancamentoDiariasPassagensController);

  /** @ngInject */
  function NotaLancamentoDiariasPassagensController($scope, $modal, $aside, $alert, $location, $window, PagingService,
    unidadesGestoras, prioridades, DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;

    var currentModal, backModal;

    vm.prioridades = prioridades.data;

    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    var storedObj;
    var filtroOrigem;

    var colunas = {
      notaLancamento: { nome: "Nota Lançamento", visible: true, disabled: true, termo: "Nº do documento que registra a conferência da entrega do produto ou da prestação do serviço" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, disabled: true, termo: "Data em que a conferência da entrega do produto ou prestação do serviço foi registrada" },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais" },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      codigoCredorMascarado: { nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      nomeCredor: { nome: "Credor", visible: false, termo: "Quem tem um valor a receber da Administração Pública" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, disabled: true, termo: "Valor que deve ser pago pela entrega de produto ou prestação de serviço" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Lançamento',
      plural: 'Notas de Lançamento'
    };

    vm.item = {
      busy: true,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    vm.unidadesGestoras = unidadesGestoras.data;

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoNePorObTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-aside.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoEventosTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.busy = false;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFiltroForm();
    };

    vm.visualizarItem = function (linha) {
      DespesasService.recuperarNotaLancamento(linha).then(
        function (response) {
          vm.item.editing = false;
          vm.settings.cmd = 'Visualizar';
          vm.linha = response.data;
          showDetalhamentoForm();
        }
      );
    };

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    vm.init = function () {
      storedObj = ScopeService.getStored();
      var obj = $location.search();

      if (localStorage.getItem('URL_PREVIOUS_PAGE')) {
        localStorage.removeItem('URL_PREVIOUS_PAGE');
      }

      if (obj.ano) {
        vm.item = extend(vm.item, obj);
        vm.item.busy = false;
        filtroOrigem = storedObj.filtroOrigem;
        filtroOrigem.anoExercicio = obj.ano;
        filtroOrigem.colunas = storedObj.colunas;
        filtroOrigem.url = storedObj ? storedObj.url : '';
        vm.applyFilters();
        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      $scope.filter = angular.copy(vm.item);
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showFiltroForm = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
      currentModal = formFiltroTpl;
    };

    var showDetalhamentoForm = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
      currentModal = formDetalhamentoTpl;
    };

    $scope.hideForm = function () {
      formFiltroTpl.hide();
      formDetalhamentoTpl.hide();
      extratoNePorObTpl.hide();
      extratoEventosTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/nota-lancamento', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = 'Valor liquidado';
      DespesasService.listarNotasEmpenhoPorNotaLancamentoDetalheNL(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }
          vm.listaNotasEmpenho = response.data;
          vm.totalNotasEmpenho = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          extratoNePorObTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          extratoEventosTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

  }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('OrdemBancariaDiariasPassagensController', OrdemBancariaDiariasPassagensController);

  /** @ngInject */
  function OrdemBancariaDiariasPassagensController($scope, $modal, $aside, $location, $alert, $window, PagingService,
    unidadesGestoras, gestaoNl, prioridades, DespesasService, RelatorioService, ScopeService, $rootScope, dataAtualizacao) {

    var vm = this;

    var currentModal, backModal;

    vm.prioridades = prioridades.data;

    var storedObj;
    var filtroOrigem;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      ordemBancaria: { nome: "Pagamentos", visible: true, disabled: true, termo: "Nº do documento relativo ao valor pago pelo produto entregue ou serviço prestado" },
      numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
      dataEmissao: { nome: "Emissão", visible: true, date: true, termo: "Data de registro do pagamento pelo produto entregue ou serviço prestado" },
      hora: { nome: "Hora", visible: true, termo: "Hora do registro de Pagamento" },
      numeroNotaLancamentoReferencia: { nome: "NL Referência", visible: true, termo: "Número da Nota de Referência" },
      nomeGestaoNl: { nome: "Gestão NL", visible: false, termo: "Gestão NL" },
      prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
      unidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      unidadeGestoraLiquidante: { nome: "Unidade Liquidante", visible: true, termo: "Unidade responsável pela liquidação da despesa" },
      nomeGestao: { nome: "Gestão Liquidante", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
      codigoCredorMascarado: { nome: "CNPJ/CPF", visible: false, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      nomeCredor: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
      valorFinal: { nome: "Valor Final", visible: true, currency: true, termo: "Valor pago pelo produto entregue ou serviço realizado" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Nota de Empenho',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'pdf',
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/despesa/ordem-bancaria',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.checarDataInvalida = function (data) {
      // Datas abaixo de 2009 e acima da data atual são inválidas
      var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
      var dataFutura = data >= moment().valueOf();
      return anteriorA2009 || dataFutura;
    };


    vm.unidadesGestoras = unidadesGestoras.data;
    vm.gestaoNl = gestaoNl.data;
    vm.data = data;

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/ordem-bancaria-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var notaLancamentoFormTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/nota-lancamento-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var extratoNePorObTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ne-por-ob-aside.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var eventosTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-eventos.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var cancelamentoTemplate = $aside({
      scope: $scope,
      template: 'app/components/despesas/despesas-por-agrupador/extrato-ordem-cancelamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    vm.cancelar = function () {
      vm.item = storedObj;
      vm.item.editing = true;
      vm.item.page = 0;
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFiltroForm();
    };

    vm.visualizarItem = function (linha) {
      if (linha.ordemBancaria.indexOf('NL') > -1) {
        linha.notaLancamento = linha.ordemBancaria;
        DespesasService.recuperarNotaLancamentoOB(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showFormNL();
          }
        );
      } else if (linha.ordemBancaria.indexOf('OB') > -1) {
        DespesasService.recuperarOrdemBancaria(linha).then(
          function (response) {
            vm.item.editing = false;
            vm.settings.cmd = 'Visualizar';
            vm.linha = response.data;
            showDetalhamentoForm();
          }
        );
      }
    };

    vm.exibirModalNELiquidacao = function (item) {
      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasEmpenhoLiquidacao = response.data;
            vm.notasEmpenhoLiquidacaoTotalPago = _.reduce(vm.listaNotasEmpenhoLiquidacao, function (memo, obj) {
              return memo + obj.valorNeFinal
            }, 0);
            var modal = modalTemplate('Notas de Empenho', 'app/components/despesas/despesas-por-agrupador/empenho-liquidacao-modal.html');
            modal.$promise.then(modal.show);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de empenho', type: 'info' }); }
      );
      DespesasService.listarNotasLancamentoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length > 0) {
            vm.listaNotasLancamentoLiquidacao = response.data;
            vm.notasLancamentoLiquidacaoTotalPago = _.reduce(vm.listaNotasLancamentoLiquidacao, function (memo, obj) {
              return memo + obj.valorFinal
            }, 0);
          } else {
            $alert({ content: 'Não há notas de empenho vinculadas', type: 'info' });
          }
        },
        function () { $alert({ content: 'Erro ao recuperar dados das notas de lancamento', type: 'info' }); }
      );
    };

    vm.exibirModalNEporOB = function (item) {

      var reqObj = {
        ordemBancaria: item.ordemBancaria,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = "Valor Pago";

      DespesasService.listarNotasEmpenhoPorOrdemBancaria(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          var somaValores = 0;
          for (var i = 0; i < vm.listaNotasEmpenho.length; i++) {
            somaValores += vm.listaNotasEmpenho[i].valorNeFinal;
          }
          vm.totalNotasEmpenho = somaValores;

          hideCurrentModal();
          extratoNePorObTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.abrirSaibaMais = function () {
      var urlPreviousPage = $location.url();
      localStorage.setItem('URL_PREVIOUS_PAGE', urlPreviousPage);
      ScopeService.store(storedObj);
      $window.location.href = '#/despesas/detalhamentos/saiba-mais';
    };

    vm.init = function () {
      vm.data.content = [];

      storedObj = ScopeService.getStored();

      if (localStorage.getItem('URL_PREVIOUS_PAGE')) {
        localStorage.removeItem('URL_PREVIOUS_PAGE');
      }

      vm.item.ano = storedObj.filtroOrigem.anoExercicio;
      var obj = $location.search();
      if (storedObj && obj.ano) {
        vm.item = obj;
        vm.item.dataFim = null;
        vm.item.dataInicio = null;
        filtroOrigem = storedObj.filtroOrigem;
        filtroOrigem.colunas = storedObj.colunas;
        filtroOrigem.anoExercicio = obj.ano;
        filtroOrigem.url = storedObj.url;

        vm.titulo = "Pagamentos";
        var tipoValorPago = vm.item.tipoValorPago;
        switch (tipoValorPago) {
          case 'pago-exercicio':
            vm.titulo = vm.titulo + " no exercício";
            break;
          case 'pago-rpp':
            vm.titulo = vm.titulo + " de restos a pagar processados (RPP)";
            break;
          case 'pago-rpnp':
            vm.titulo = vm.titulo + " de restos a pagar não processados (RPNP)";
            break;
          case 'pago-ret':
            vm.titulo = vm.titulo + " das retenções (RET) ";
            break;
        }

        vm.applyFilters();

        vm.search();
      }
    };

    vm.applyFilters = function () {
      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      }
      vm.item.listaCodigoUnidadeGestora = fn(vm.item.codigoUnidadeGestora, vm.unidadesGestoras);
    };

    vm.voltar = function () {
      $rootScope.filter = filtroOrigem;
      $location.path(filtroOrigem.url).search(filtroOrigem);
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
      if (vm.item.ano < 2020) {
        $scope.colunas.prioridade.visible = false;
        $scope.colunas.prioridade.disabled = true;
      }
    };

    var showFiltroForm = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
      currentModal = formFiltroTpl
    };

    var showDetalhamentoForm = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
      currentModal = formDetalhamentoTpl;
    };

    var showFormNL = function () {
      angular.element('.tooltip').remove();
      notaLancamentoFormTpl.show();
      currentModal = notaLancamentoFormTpl;
    };

    $scope.hideForm = function () {
      formDetalhamentoTpl.hide();
      formFiltroTpl.hide();
      notaLancamentoFormTpl.hide();
    };

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = $scope.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/despesa/relatorio/ordem-bancaria', vm.item);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    vm.exibirModalNEporNL = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      $scope.tipoValor = "Valor Ajuste Pagamento";

      DespesasService.listarNotasEmpenhoPorNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaNotasEmpenho = response.data;
          vm.totalNotasEmpenho = _.reduce(vm.listaNotasEmpenho, function (memo, obj) {
            return memo + obj.valorNeFinal
          }, 0);

          hideCurrentModal();
          extratoNePorObTpl.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.exibirModalEventos = function (item) {
      var reqObj = {
        notaLancamento: item.notaLancamento,
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        ano: item.ano,
        codigoGestao: item.codigoGestao
      };

      DespesasService.listarEventosNotaLancamento(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há eventos vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaEventos = response.data;
          vm.listaEventosTotal = _.reduce(vm.listaEventos, function (memo, obj) {
            return memo + obj.valorLancamento
          }, 0);

          hideCurrentModal();
          eventosTemplate.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar os eventos da Nota de Lançamento',
            type: 'info'
          });
        }
      );
    };

    vm.exibirOrdensDeCancelamento = function (item) {
      var reqObj = {
        codigoUnidadeGestora: item.codigoUnidadeGestora,
        codigoGestao: item.codigoGestao,
        numeroOrdemBancaria: item.ordemBancaria
      };

      DespesasService.listarOrdemCancelamentoPorOB(reqObj).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há ordens de cancelamento vinculadas',
              type: 'info'
            });
            return;
          }

          vm.listaOrdensCancelamento = response.data;

          hideCurrentModal();
          cancelamentoTemplate.show();
        },
        function () {
          $alert({
            content: 'Erro ao recuperar ordens de cancelamento',
            type: 'danger'
          });
        }
      );
    }

    var hideCurrentModal = function () {
      if (currentModal) {
        currentModal.hide();
        backModal = currentModal;
      }
    };

    vm.backCurrentModal = function () {
      if (backModal) {
        backModal.show();
        backModal = undefined;
      }
    };


  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('DiariasPassagensSaibaMaisController', DiariasPassagensSaibaMaisController);

  /** @ngInject */
  function DiariasPassagensSaibaMaisController($scope, $window, dataAtualizacao, ArquivoUrlService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao.data;
    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    var colunas = {
      nome:{ nome: "Nome", visible:true },
      ano:{ nome:"Exercício", visible:true },
      dataReferencia:{ nome:"Data referência", visible:false, date:true }
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Diárias e Passagens - Saiba Mais​',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
      page: 0,
      busy: false
    };

    var data = {
      url: '/despesa/diarias-passagens/saiba-mais',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    vm.init = function () {
      vm.search();
    }

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.voltar = function(){
      $window.location.href = '#/despesas/diarias-passagens-locomocao';
    };
  }
})();

(function () {
    'use strict';

    angular.module('portal.despesa').controller('DiariasPassagensController', Controller);

    /** @ngInject */
    function Controller($scope, $aside, anos, dataAtualizacao, PagingService, ScopeService, $location, RelatorioService,
        DespesasService) {

        var vm = this;

        vm.anos = anos.data;
        vm.dataAtualizacao = dataAtualizacao;

        // vm.unidadeGestora.forEach(function(uni) {
        //   uni.nome = uni.nome ? uni.nome.trim() : uni.nome;
        // });

        var colunas = {
            unidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
            anoExercicio: { nome: "Exercício", visible: false, termo: "Ano de emissão da Nota de Empenho" },
            codigoCredorMascarado: { nome: "CNPJ/CPF Credor", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
            favorecido: { nome: "Credor", visible: true, termo: "Quem tem um valor a receber da Administração Pública" },
            nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            numeroProcesso: { nome: "Nº Processo", visible: false, termo: "Nº do processo referente à despesa" },
            nomeEsfera: { nome: "Esfera", visible: false, termo: "Indica a qual orçamento a despesa faz parte: fiscal, seguridade social ou investimento das empresas estatais" },
            nomeModalidadeLicitacao: { nome: "Tipo de Despesa", visible: false, termo: "Indica o procedimento utilizado para realização da despesa" },
            nomeProgramaTrabalho: { nome: "Programa de Trabalho", visible: false, termo: "Conjunto organizado das ações que serão executadas de acordo com as possibilidades financeiras do governo" },
            nomeFuncao: { nome: "Função", visible: false, termo: "Área de atuação da Administração Pública" },
            nomeSubfuncao: { nome: "Subfunção", visible: false, termo: "Identifica a natureza básica das ações de uma determinada área de atuação" },
            nomePrograma: { nome: "Programa", visible: false, termo: "Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
            nomeProjeto: { nome: "Ação", visible: false, termo: "Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
            nomeSubtitulo: { nome: "Subtítulo", visible: false, termo: "Identifica a localização física ou geográfica da ação orçamentária" },
            nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico" },
            nomeGrupoNatureza: { nome: "Grupo de Natureza da Despesa", visible: false, termo: "Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
            nomeModalidadeAplicacao: { nome: "Modalidade De aplicação", visible: false, termo: "Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
            elemento: { nome: "Elemento", visible: true, termo: "Indica os objetos de gastos" },
            subItem: { nome: "Subelemento", visible: true, termo: "Maior detalhamento do elemento da despesa" },
            nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
            valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
            valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
            valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
            valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
            valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
            valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
            valorObFinal: { nome: "Total Pago", visible: true, currency: true, termo: "Valor pago para o favorecido" }
        };

        $scope.colunas = colunas;

        //Objetos do Filtro
        vm.unidadeGestora = [];
        vm.elemento = [];
        vm.subitem = [];
        vm.gestao = [];
        vm.esfera = [];
        vm.modalidadeLicitacao = [];
        vm.funcoes = [];
        vm.subfuncoes = [];
        vm.programa = [];
        vm.categoriaEconomica = [];
        vm.grupoNatureza = [];
        vm.modalidadeAplicacao = [];
        vm.fonte = [];

        vm.carregarFiltros = carregarFiltros;

        function carregarFiltros(exercicio) {
            vm.filtersLoaded = false;
            Promise.all([
                DespesasService.listarUnidadesGestorasDiariasPassagens(exercicio),
                DespesasService.listarElementosDiariasPassagens(exercicio),
                DespesasService.listarSubElementosDiariasPassagens(exercicio),
                DespesasService.listarGestoesDiariasPassagens(exercicio),
                DespesasService.listarEsferasDiariasPassagens(exercicio),
                DespesasService.listarTiposDespesaDiariasPassagens(exercicio),
                DespesasService.listarFuncoesDiariasPassagens(exercicio),
                DespesasService.listarSubFuncoesDiariasPassagens(exercicio),
                DespesasService.listarProgramasDiariasPassagens(exercicio),
                DespesasService.listarCategoriasEconomicasDiariasPassagens(exercicio),
                DespesasService.listarGruposDespesaDiariasPassagens(exercicio),
                DespesasService.listarModalidadesAplicacoesDiariasPassagens(exercicio),
                DespesasService.listarFontesRecursoDiariasPassagens(exercicio)
            ]).then(function (response) {
                vm.unidadeGestora = response[0].data;
                vm.elemento = response[1].data;
                vm.subitem = response[2].data;
                vm.gestao = response[3].data;
                vm.esfera = response[4].data;
                vm.modalidadeLicitacao = response[5].data;
                vm.funcoes = response[6].data;
                vm.subfuncoes = response[7].data;
                vm.programa = response[8].data;
                vm.categoriaEconomica = response[9].data;
                vm.grupoNatureza = response[10].data;
                vm.modalidadeAplicacao = response[11].data;
                vm.fonte = response[12].data;

                vm.filtersLoaded = true;
            });

        }

        // settings
        vm.settings = {
            singular: 'Diárias, Passagens e Locomoção',
            plural: '',
            busy: true,
            cmd: '',
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            busy: false,
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        var data = {
            url: '/despesas/diarias-passagens',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/despesas/diarias-passagens/diarias-passagens-form.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
        };

        vm.exibirFormPesquisa = function () {
            carregarFiltros(vm.item.anoExercicio);
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showForm();
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.linha = linha;
                vm.settings.cmd = 'Visualizar';
                showForm();
            }
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = vm.settings.colunas;
                vm.item.tipo = $scope.dados.form.tipo;
                RelatorioService.exportar('/despesa/relatorio/diarias-passagens', vm.item);
            }
        };

        vm.init = function () {
            var params = $location.search();
            if (params.colunas != null) {
                $scope.colunas = params.colunas;
            }
            if (params.anoExercicio) {
                vm.item = extend(vm.item, params);
            } else {
                vm.item.anoExercicio = vm.anos[0];
            }
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;

            vm.assignInitParams(params, vm.item);

            $scope.filter = angular.copy(vm.item);
        };

        /**
         * Atribui os parâmetros para o objeto modelo.
         * @param {*} params Mapa de parâmetros.
         * @param {*} modelObject Objeto modelo.
         */
        vm.assignInitParams = function (params, modelObject) {
            var assignProps = function (propsArray, fromObj, toObj) {
                propsArray.forEach(function (prop) {
                    if (fromObj[prop.from] != undefined) {
                        if (prop.type == Number) {
                            toObj[prop.to] = Number(fromObj[prop.from]);
                        } else if (prop.type == String) {
                            toObj[prop.to] = String(fromObj[prop.from]);
                        }
                    }
                });
            };

            var assignSelect = function (selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
                if (param) {
                    var element = selectOptions.filter(function (elem) { return elem[compareProp] == param; })[0];

                    if (element != null) {
                        modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
                    }
                }
            };

            assignProps([
                { from: 'ano', to: 'anoExercicio', type: String },
                { from: 'nome', to: 'favorecido', type: String },
                { from: 'codigoCredor', to: 'codigoCredor', type: String }], params, vm.item);
            assignSelect(vm.unidadeGestora, modelObject, 'listaCodigoUnidadeGestora', params['orgao'], 'nome', 'codigo', true);
            assignSelect(vm.elemento, modelObject, 'listaCodigoElementoDespesa', params['elemento'], 'nome', 'codigo', true);
            assignSelect(vm.subitem, modelObject, 'listaCodigoSubItem', params['subelemento'], 'nome', 'nome', true);
        };


        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;

            $scope.filter = angular.copy(vm.item);
            $scope.hideForm();
        };


        var showForm = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };


        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

        /*
        $scope.$watch('vm.item.listaCodigoElementoDespesa', function () {
          $scope.atualizarListaDeSubitemDespesa();
        });

        */

        vm.visualizarEmpenhado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/despesas/diarias-passagens-locomocao';
            ScopeService.store(obj);
            $location.path('/despesa/diarias-passagens/nota-empenho').search({
                anoNotaEmpenho: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                tipoLicitacao: !vm.item.listaCodigoModalideLicitacao ? null : vm.item.listaCodigoModalideLicitacao[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0]
            });
        };

        vm.visualizarLiquidado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/despesas/diarias-passagens-locomocao';

            ScopeService.store(obj);
            $location.path('/despesa/diarias-passagens/nota-lancamento').search({
                ano: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0]

            });
        };

        vm.visualizarPago = function (row, tipoValorPago) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };

            obj.url = '/despesas/diarias-passagens-locomocao';

            ScopeService.store(obj);
            $location.path('/despesa/diarias-passagens/ordem-bancaria').search({
                ano: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: row.codigoCredor ? btoa(row.codigoCredor) : undefined,
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                tipoValorPago: tipoValorPago
            });
        };

        /*
        $scope.atualizarListaDeSubitemDespesa = function () {
          if (vm.item.listaCodigoElementoDespesa) {
            vm.item.listaCodigoSubItem = [];
            subitemDespesaPorElemento(vm.item.listaCodigoElementoDespesa).success(function (response) {
              vm.subitem = response;
            });
          } else {
            vm.subitem = [];
          }
        };
        */
        var extend = function (obj, src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) obj[key] = src[key];
            }
            return obj;
        }


    }

})();

(function () {
  'use strict';

  angular.module('portal.despesa').controller('EmendasParlamentaresFederaisController', Controller);

  /** @ngInject */
  function Controller($scope, $aside, PagingService, RelatorioService,
    anos, dataAtualizacao, $location, DespesasService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      tipoTransferencia: { nome: 'Tipo de Transferência', exportar: true, visible: true, termo: 'Modalidade utilizada para transferir os recursos públicos federais.' },
      idPlanoAcao: { nome: 'ID do Plano de Ação', exportar: true, visible: false, termo: 'Identificador único do Plano de Ação cadastrado pelo órgão responsável.' },
      anoEmenda: { nome: 'Ano', exportar: true, visible: true, termo: 'Ano de referência da Emenda Parlamentar ou do Plano de Ação.' },
      origemRecursos: { nome: 'Origem dos Recursos', exportar: true, visible: false, termo: 'Fonte de origem dos recursos financeiros destinados ao objeto.' },
      numeroEmendaParlamentar: { nome: 'Número', exportar: true, visible: true, termo: 'Número identificador da Emenda Parlamentar que originou os recursos.' },
      tipoEmenda: { nome: 'Tipo da Emenda', exportar: true, visible: true, termo: 'Categoria da Emenda Parlamentar conforme sua natureza de destinação.' },
      beneficiario: { nome: 'Beneficiário / Proponente', exportar: true, visible: true, termo: 'Órgão, entidade ou instituição responsável por receber ou propor a execução dos recursos.' },
      classificacaoEmenda: { nome: 'Classificação da Emenda', exportar: true, visible: false, termo: 'Classificação da Emenda Parlamentar de acordo com as regras orçamentárias vigentes.' },
      parlamentar: { nome: 'Parlamentar', exportar: true, visible: true, termo: 'Autor da Emenda Parlamentar responsável pela destinação dos recursos.' },
      modalidade: { nome: 'Modalidade', exportar: true, visible: true, termo: 'Forma de execução ou operacionalização da transferência dos recursos públicos.' },
      orgaoExecutor: { nome: 'Órgão Executor', exportar: true, visible: false, termo: 'Órgão ou entidade responsável pela execução do objeto financiado.' },
      codigoPlanoAcao: { nome: 'Código do Plano de Ação', exportar: true, visible: false, termo: 'Código de identificação do Plano de Ação vinculado à transferência.' },
      categoriaDespesa: { nome: 'Categoria de Despesa', exportar: true, visible: true, termo: 'Classificação do gasto público conforme sua finalidade e natureza da despesa.' },
      situacaoPlanoTrabalho: { nome: 'Situação do Plano de Trabalho', exportar: true, visible: false, termo: 'Situação atual do plano de trabalho' },
      objeto: { nome: 'Objeto', exportar: true, visible: false, verMais: true, termo: 'Status atual do Plano de Trabalho durante sua execução e acompanhamento.' },
      areasPoliticasPublicas: { nome: 'Áreas de Políticas Públicas', exportar: true, visible: false, termo: 'Área governamental ou política pública beneficiada pelos recursos destinados.' },
      dataInicioExecucao: { nome: 'Data Início da Execução', exportar: true, visible: true, date: true, termo: 'Data prevista ou efetiva de início da execução do objeto financiado.' },
      dataFimExecucao: { nome: 'Data Fim da Execução', exportar: true, visible: true, date: true, termo: 'Data prevista ou efetiva de conclusão da execução do objeto financiado.' },
      valorTotal: { nome: 'Valor Total', exportar: true, visible: true, currency: true, termo: 'Montante total de recursos previstos para execução do objeto.' },
      valorPago: { nome: 'Valor Pago', exportar: true, visible: true, currency: true, termo: 'Valor efetivamente transferido ou pago ao beneficiário até o momento.' }
    };

    $scope.colunas = colunas;
    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // Modelos do Filtro
    vm.anos = anos.data;

    vm.tiposTransferencia = [
      'DISCRICIONÁRIA/LEGAL',
      'ESPECIAL',
      'FUNDO A FUNDO'
    ];

    vm.orgaosExecutores = [];
    vm.parlamentares = [];

    DespesasService.listarOrgaosExecutoresFederais().then(function (response) {
      var content = response.data.content || [];
      content.forEach(function (item) {
        vm.orgaosExecutores.push(item.valor || item);
      });
    });

    DespesasService.listarParlamentaresFederais().then(function (response) {
      var content = response.data.content || [];
      content.forEach(function (item) {
        vm.parlamentares.push(item.valor || item);
      });
    });

    // settings
    vm.settings = {
      singular: 'Emendas Parlamentares Federais',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      busy: false,
      anoEmenda: vm.anos && vm.anos.length ? vm.anos[0] : null,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/despesa/emenda-parlamentar-federal',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/emendas-parlamentares-federais/emendas-parlamentares-federais-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/emendas-parlamentares-federais/emendas-parlamentares-federais-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0,
        anoEmenda: vm.anos && vm.anos.length ? vm.anos[0] : null,
        tipo: 'csv',
        busy: false,
        dataAtualizacao: new Date(vm.dataAtualizacao.data)
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFormFiltro();
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.linha = linha;
        showFormDetalhamento();
      }
    };

    vm.init = function () {
      var params = $location.search();

      if (params.anoEmenda) {
        vm.item.anoEmenda = params.anoEmenda;
      } else if (vm.anos && vm.anos.length) {
        vm.item.anoEmenda = vm.anos[0];
      }

      vm.search();
    };


    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
      formFiltroTpl.hide();
    };

    var showFormFiltro = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
    };

    $scope.exportar = function () {
      if (vm.item) {
        var colunasParaExportar = {};
        angular.forEach(vm.settings.colunas, function(coluna, key) {
          if (coluna.exportar) {
            colunasParaExportar[key] = coluna;
          }
        });

        var payload = angular.copy(vm.item);
        payload.anoEmenda = null;
        payload.colunas = colunasParaExportar;
        payload.tipo = $scope.dados.form.tipo;

        RelatorioService.exportar('/despesa/relatorio/emendas-parlamentares-federais', payload);
      }
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var extend = function (obj, src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
      }
      return obj;
    };

  }

})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('PagamentosPorCredorDetalhamentoCtrl', PagamentosPorCredorDetalhamentoController);


    /**
     * Controlador da consulta de detalhamento de pagamentos por credor.
     */
    /** @ngInject */
    function PagamentosPorCredorDetalhamentoController($scope, $location, dataAtualizacao, ScopeService, $rootScope) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.$rootScope = $rootScope;
        _scope.storedObj = ScopeService.getStored();
        _scope.search = search;
        _scope.init = init;
        _scope.dataParser = dataParser;
        _scope.voltar = voltar;

        var colunas = {
            numeroOb: { nome: "Ordem Bancária", visible: true, disabled: false, termo: "Nº do documento relativo ao valor pago pelo produto entregue ou serviço prestado" },
            dataEmissao: { nome: "Emissão", visible: true, disabled: true, termo: "Data de registro do pagamento pelo produto entregue ou serviço prestado" },
            hora: { nome: "Hora", visible: true, termo: "Hora do registro de Pagamento", center: true },
            numeroNotaLancamentoReferencia: { nome: "Nl Referência", visible: true, termo: "Nl Referência", center: true },
            nomeGestaoNl: { nome: "Gestão NL", visible: false, termo: "Gestão NL" },
            gestaoLiquidante: { nome: "Gestão Liquidante", visible: false, termo: "Gestão Liquidante" },
            prioridade: { nome: "Prioridade", visible: true, termo: "Código de prioridade conforme o Decreto 40.372/2019, que se encontra no Saiba mais", center: true },
            nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, disabled: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
            nomeUnidadeGestoraLiquidante: { nome: "Unidade Liquidante", visible: true, disabled: true, termo: "Unidade responsável pela liquidação da despesa" },
            nomeCredor: { nome: "Credor", visible: true, termo: "Nome de quem tem um valor a receber da Administração Pública" },
            valorFinal: { nome: "Valor Pago", visible: true, currency: true, disabled: true, termo: "Valor pago pelo produto entregue ou serviço realizado" }
        };

        _scope.filterModel = {
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;
        $scope.dataParser = dataParser;

        $scope.filterModel = _scope.filterModel;
        $scope.tableOptions = [
            {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];

        if (_scope.storedObj && _scope.storedObj.url) {
            $scope.tableOptions.push({
                type: 'back-button',
                config: {
                    label: 'Voltar',
                    title: 'Voltar a página anterior',
                    icon: 'fa fa-long-arrow-left',
                    onClick: function() { _scope.voltar(); }
                }
            });
        }
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        var self = this;
        var searchParams = this.$location.search();

        if (this.storedObj && this.storedObj.filtroOrigem) {
            this.filterModel.ano = this.storedObj.filtroOrigem.anoExercicio;
        }

        Object.keys(searchParams).forEach(function(key) {
            self.filterModel[key] = searchParams[key];
        });

        if (this.filterModel.ano) {
            this.search();
        }
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        this.$scope.filter = obj;

        if (this.filterModel.ano < 2020) {
            this.filterModel.colunas.prioridade.visible = false;
            this.filterModel.colunas.prioridade.disabled = true;
        }
    }

    /**
     * Realiza o parse do retorno do serviço.
     */
    function dataParser(data, callback) {
        data.totalizador = data.totalizador.valorFinal;
        callback(data);
    }

    /**
     * Volta a página previamente exibida.
     */
    function voltar() {
        var filtroOrigem = this.storedObj.filtroOrigem;
        this.$rootScope.filter = filtroOrigem;
        var searchParams = angular.copy(filtroOrigem);
        delete(searchParams.colunas);
        this.$location.path(this.storedObj.url).search(searchParams);
    }

})();
/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('PagamentosPorCredorCtrl', PagamentosPorCredorController);


    /**
     * Controlador da consulta de pagamentos por credor.
     */
    /** @ngInject */
    function PagamentosPorCredorController($scope, $aside, $location, DespesasService, dataAtualizacao, ScopeService, anos) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.ScopeService = ScopeService;
        _scope.DespesasService = DespesasService;
        _scope.search = search;
        _scope.init = init;
        _scope.onClickValorFinal = onClickValorFinal;
        _scope.dataParser = dataParser;
        _scope.assignInitParams = assignInitParams;
        _scope.carregarFiltroUnidadeLiquidante = carregarFiltroUnidadeLiquidante;
        _scope.verificarDateMaior = verificarDateMaior;
        _scope.informaErroData = informaErroData;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nomeUnidadeGestora: {nome: "Unidade Gestora", visible: true, disabled: true, termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos"},
            nomeUnidadeGestoraLiquidante: {nome: "Unidade Liquidante", visible: true, disabled: true, termo:"Unidade responsável pela liquidação da despesa"},
            nomeCredor: {nome: "Credor", visible: true, termo:"Nome de quem tem um valor a receber da Administração Pública"},
            ano: {nome: "Exercício", visible: false, termo:"Ano de emissão da Ordem Bancária", center: true },
	        valorFinal: {nome: "Valor Final", visible: true, currency: true, disabled: true, termo:"Valor pago pelo produto entregue ou serviço realizado", onClick: function(i, e) { _scope.onClickValorFinal(i, e); }}
        };

        anos = anos.data;
        var defaultAno = String(anos[0]);
        _scope.filterModel = {
            ano: defaultAno,
            colunas: colunas,
            title:defaultAno
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;
        $scope.dataParser = dataParser;

        _scope.unidadesGestoras = [];

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'range',
                required: false,
                options: anos,

                modelField: 'ano',
                titleYear:"EXERCÍCIO",

                modelFieldIniDate:'iniDate',
                titleInitialDate:"DATA INICIAL PAGAMENTO",
                descriptionInitialDate:"Pesquisa de pagamentos realizados a partir desta data",

                modelFieldFinDate:'finDate',
                titleFinalDate:"DATA FINAL PAGAMENTO",
                descriptionFinalDate:"Pesquisa de pagamentos realizados até esta data",

                onChange: function() {
                    informaErroData(_scope.filterModel.iniDate,_scope.filterModel.finDate);
                    _scope.carregarFiltroUnidadeLiquidante(_scope.filterModel.ano);
                }
            }, {
                type: 'text',
                label: 'Credor',
                title: 'Nome da entidade credora',
                required: false,
                modelField: 'nomeCredor'
            }, {
                type: 'single-select',
                label: 'Unidade Liquidante',
                title: 'Unidade responsável pela liquidação da despesa',
                required: false,
                modelField: 'codigoUnidadeGestoraLiquidante',
                options: _scope.unidadesGestoras,
                valueProp: 'codigo',
                displayProp: 'nome'
            }
        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                    _scope.filterModel.ano = defaultAno;
                    _scope.filterModel.iniDate = "";
                    _scope.filterModel.finDate = "";
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];

        _scope.carregarFiltroUnidadeLiquidante(_scope.filterModel.ano);
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.assignInitParams(this.$location.search(), this.filterModel);

        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);
        this.filterModel.title = obj.ano;
        if(obj.finDate && obj.iniDate){
            this.filterModel.title = obj.iniDate + " - " + obj.finDate ;
            obj.iniDate = formatDateBack(obj.iniDate);
            obj.finDate = formatDateBack(obj.finDate);
        }
        if(obj.finDate == "" && obj.iniDate ==""){
            obj.iniDate = null;
            obj.finDate = null;
        }

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Responde ao evento de clique no valor final de um item.
     */
    function onClickValorFinal(item, event) {

        var obj = {
            filtroOrigem: this.filterModel
        };
        obj.url = '/despesas/pagamentos-por-credor';
       
        if(obj.filtroOrigem.finDate && obj.filtroOrigem.iniDate){
          obj.filtroOrigem.iniDate = formatDate(obj.filtroOrigem.iniDate);
          obj.filtroOrigem.finDate = formatDate(obj.filtroOrigem.finDate);

        }
        if(obj.filtroOrigem.finDate == "" && obj.filtroOrigem.iniDate ==""){
          obj.filtroOrigem.iniDate = null;
          obj.filtroOrigem.finDate = null;
        }

        this.ScopeService.store(obj);
        this.$location.path('/despesas/pagamentos-por-credor-detalhamento').search({
            ano: item.ano,
            nomeCredor: this.filterModel.nomeCredor,
            codigoCredor: item.codigoCredor,
            codigoUg: item.codigoUg,
            codigoG: item.codigoGestao,
            codigoUgLiq: item.codigoUnidadeGestoraLiquidante,
            codigoGLiq: item.codigoGestaoLiquidante,
            iniDate: obj.filtroOrigem.iniDate,
            finDate: obj.filtroOrigem.finDate
        });

    }

    /**
     * Realiza o parse do retorno do serviço.
     */
    function dataParser(data, callback) {
        callback(data);
    }

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    function assignInitParams(params, modelObject) {
        var assignProps = function(propsArray, fromObj, toObj) {
            propsArray.forEach(function(prop) {
                if (fromObj[prop.from] != undefined) {
                    if (prop.type == Number) {
                        toObj[prop.to] = Number(fromObj[prop.from]);
                    } else if (prop.type == String) {
                        toObj[prop.to] = String(fromObj[prop.from]);
                    }
                }
            });
        };

        var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
            if (param) {
                var element = selectOptions.filter(function(elem) { return elem[compareProp] == param; })[0];

                if (element != null) {
                    modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
                }
            }
        };

        assignProps([{from:'nomeCredor', to:'nomeCredor', type:String}, {from:'credor', to:'nomeCredor', type:String}], params, modelObject);
        assignProps([{from:'ano', to:'ano', type:String}, {from:'exercicio', to:'ano', type:String}], params, modelObject);
        assignSelect(this.unidadesGestoras, modelObject, 'codigoUnidadeGestoraLiquidante', params['orgao'], 'nome', 'codigo', false);
    }

    /**
     * Carrega os dados do filtro unidade liquidante para um dado exercício.
     * @param {*} exercicio Ano.
     */
    function carregarFiltroUnidadeLiquidante(exercicio) {
        var self = this;
        this.DespesasService.listarUnidadeGestora(exercicio)
            .then(function(response) {
                self.unidadesGestoras.splice(0, self.unidadesGestoras.length);
                response.data.forEach(function(unidade) {
                    self.unidadesGestoras.push(unidade);
                });
            });
    }

    function checarDataInvalida(data) {
        return data > moment().valueOf();
      };

    function verificarDateMaior(firstDate, secondDate) {
        var dateLength = 10;
        if ((firstDate && firstDate.length == dateLength) && (secondDate && secondDate.length == dateLength)) {
          var firstDateFormated = formataParaDate(firstDate);
          var secondDateFormated = formataParaDate(secondDate);

          return firstDateFormated > secondDateFormated;
        }
        return false;
    }

    function verificaDataMaiorAtual(firstDate){
        var dateLength = 10;
        if ((firstDate && firstDate.length == dateLength)) {
          var firstDateFormated = formataParaDate(firstDate);
          return checarDataInvalida(firstDateFormated);
        }
        return false;
    }

    function informaErroData(firstDate,secondDate){
        //verifica se a data final e maior que a inicial
        if(verificarDateMaior(firstDate,secondDate)){
            document.querySelector(".periodo_error").classList.add("periodo_error_ativo");
        }
        else{
            document.querySelector(".periodo_error").classList.remove("periodo_error_ativo")
        }

        //verfica se a data inicial e maior que a data atual
        if(verificaDataMaiorAtual(firstDate)){
            document.querySelector(".ini_maior_atual_erro").classList.add("ini_maior_atual_erro_ativo");
        }
        else{
            document.querySelector(".ini_maior_atual_erro").classList.remove("ini_maior_atual_erro_ativo")
        }

        //verifica se a data final e maior que a data atual
        if(verificaDataMaiorAtual(secondDate)){
            document.querySelector(".fin_maior_atual_erro").classList.add("fin_maior_atual_erro_ativo");
        }
        else{
            document.querySelector(".fin_maior_atual_erro").classList.remove("fin_maior_atual_erro_ativo")
        }
    }

    var formataParaDate = function (date) {
        var dateSplited = date.split('/');
        var day = dateSplited[0];
        var month = dateSplited[1];
        var year = dateSplited[2];

        var dateToFormat = month + "-" + day + "-" + year;

        return new Date(dateToFormat);
    }

    var formatDateBack = function (date) {
        var dateSplited = date.split('/');
        var day = dateSplited[0];
        var month = dateSplited[1];
        var year = dateSplited[2];

        var dateToFormat = year + "/" + month + "/" + day;

        return dateToFormat;
    }

    var formatDate = function (date) {

      var dateSplited = date.split('/');
      var day = dateSplited[0];
      var month = dateSplited[1];
      var year = dateSplited[2];

      var dateToFormat = year +  month +  day;

      return dateToFormat;
  }

})();

(function(){
  'use strict';

  angular.module('portal.despesa').controller('RestosAPagarController', Controller);

  /** @ngInject */
  function Controller($scope, unidadeGestora, gestao, ano,fonte,
                      $aside, PagingService, RelatorioService,
                      DespesasService, dataAtualizacao) {

    var vm = this;
    vm.unidadeGestora = unidadeGestora.data;
    vm.gestao = gestao.data;
    vm.ano = ano.data;
    vm.fonte = fonte.data;
    vm.exibirTabelaAgrupadora = true;
    vm.dataAtualizacao = dataAtualizacao;

    vm.tipos = [
      {codigo:1, nome:'Processado'},
      {codigo:2, nome:'Não Processado'}
    ];

    var colunas = {
      nomeCredor:{ nome: "Credor", visible:true, termo:"Quem tem um valor a receber da Administração Pública" },
      codigoCredor:{ nome: "CNPJ/CPF", visible:false, termo:"Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
      tipoResto:{ nome: "Tipo", visible:false, termo:"Indica o procedimento utilizado para realização da despesa" },
      nomeUnidadeGestora:{ nome: "Unidade Gestora", visible:false, termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos" },
      numeroProcesso:{ nome: "Nº Processo", visible:false, termo:"Nº do processo referente à despesa" },
      programaTrabalho:{ nome: "Programa de Trabalho", visible:false, termo:"Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
      funcao:{ nome: "Função", visible:false, termo:"Área de atuação da Administração Pública" },
      subfuncao:{ nome: "Subfunção", visible:false, termo:"Identifica a natureza básica das ações de uma determinada área de atuação " },
      programa:{ nome: "Programa", visible:false, termo:"Instrumento de organização da atuação governamental, formado por um conjunto de ações que buscam atingir objetivos preestabelecidos." },
      projeto:{ nome: "Ação", visible:false, termo:"Atividade que visa a obtenção de bens ou serviços para alcançar o objetivo de um programa." },
      subtitulo:{ nome: "Subtítulo", visible:false, termo:"Identifica a localização física ou geográfica da ação orçamentária" },
      categoriaEconomica:{ nome: "Categoria Econômica", visible:false, termo:"Classificação das receitas e despesas para uma avaliação do efeito econômico" },
      grupoDespesa:{ nome: "Grupo de Despesa", visible:false, termo:"Agrega elementos de despesa com as mesmas características quanto ao objeto do gasto" },
      modalidadeAplicacao:{ nome: "Modalidade de Aplicação", visible:false, termo:"Indica se os recursos serão aplicados diretamente pelo órgão ou sob a forma de transferência a outras entidades públicas ou privadas" },
      elemento:{ nome: "Elemento de Despesa", visible:false, termo:"Indica os objetos de gastos" },
      fonte:{ nome: "Fonte", visible:false, termo:"Indica a origem dos recursos para realizar as despesas" },
      valorInscrito:{ nome: "Valor Inscrito", visible:true, currency:true, termo:"Valor inscrito como restos a pagar" },
      valorCancelado:{ nome: "Cancelado", visible:true, currency:true, termo:"Valor relativo à diferença entre o valor real e o valor inscrito como restos a pagar" },
      valorPago:{ nome: "Pago", visible:true, currency:true, termo:"Valor pago" },
      valorAPagar:{ nome: "A Pagar", visible:true, currency:true, termo:"Valor a ser pago da despesa inscrita em restos a pagar" },
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Restos a Pagar',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo:'csv',
      exercicio: vm.ano[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/despesa/restos-a-pagar',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/despesas/restosAPagar/restos-a-pagar-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = true;
      vm.item.exercicio = vm.ano[0];
      vm.data.form = vm.item;
      vm.data.exercicio = vm.ano[0];
      $scope.filter = angular.copy(vm.item);
    };

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){

      var reqObj = {
        anoNotaEmpenho: linha.anoNotaEmpenho,
        codigoGestao: linha.codigoGestao,
        codigoUnidadeGestora: linha.codigoUnidadeGestora,
        numeroNotaEmpenho: linha.numeroNotaEmpenho
      };

      DespesasService.recuperarNotaEmpenho(reqObj).then(
        function(response) {
          vm.linha = response.data;
          vm.item.editing = false;
          showForm();
        }
      );
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    var search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.search = search;

    $scope.exportar = function() {
      if(vm.item)
        vm.item.colunas = vm.settings.colunas;
      vm.item.tipo = $scope.dados.form.tipo;
      RelatorioService.exportar('/despesa/restos-a-pagar/relatorio', vm.item);
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

  }

})();

(function () {
    'use strict';

    angular.module('portal').controller('DespesasSaibaMaisController', Controller);

    /** @ngInject */
    function Controller($scope, $window, ArquivoUrlService) {
        var vm = this;

        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        var colunas = {
            nome:{ nome: "Nome", visible:true },
            ano:{ nome:"Exercício", visible:true },
            dataReferencia:{ nome:"Data referência", visible:false, date:true }
        };

        var urlCurrent = window.location.href;
        urlCurrent = urlCurrent.split("/").pop()

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Despesas - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };

        vm.item = {
            page: 0,
            busy: false
        };

        var data = {
          url: "",
          form: vm.item,
          settings: vm.settings,
          content: [],
          totalElements: 0,
          last: true,
        };

        switch(urlCurrent){
          case "saiba-mais-obras":
            data.url = "/despesa/saiba-mais-obras";
            break;
          default:
            data.url = "/despesa/saiba-mais";
        }

        vm.data = data;

        vm.init = function() {
            vm.search();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };
    }
})();

(function(){
  'use strict';

  angular.module('portal.licitacao-contrato').controller('ContratosController', Controller);

  /** @ngInject */
  function Controller($location, $scope, $aside, $modal, $alert, anos,
                      funcao, gestao, tipoLicitacao, unidadeGestora,
                      PagingService, RelatorioService, LicitacoesContratosService, dataAtualizacao) {


    var vm = this, currentModal;
   
    vm.anos = anos.data;
    // vm.fonteRecurso = fonteRecurso.data;
    vm.funcao = funcao.data;
    vm.gestao = gestao.data;
    vm.tipoLicitacao = tipoLicitacao.data;
    vm.unidadeGestora = unidadeGestora.data;
    vm.dataAtualizacao = dataAtualizacao;

    vm.ultimoAno = vm.anos[0];

    var colunas = {
      numeroContrato:{ nome: "Nº SIGGO", visible:true, disabled:true, termo:"Nº de identificação do contrato no SIGGO"  },
      numeroOriginal:{ nome: "Nº Original", visible:true, disabled:true, termo:"Nº de identificação do contrato no órgão"},
      unidadeGestora:{ nome: "Orgão", visible:true, termo:"Órgão contratante"  },
      credor:{ nome: "Credor", visible:true, termo:"Pessoa física ou jurídica contratada"  },
      codigoCredorMascarado:{ nome:"CPF/CNPJ", visible:false, termo:"Nº do cadastro de pessoa física ou jurídica" },
      gestao:{ nome:"Gestão", visible:false, termo:"Unidade responsável pela gestão dos recursos" },
      especie:{ nome:"Espécie", visible:true, termo:"Tipo de contratação" },
      numeroProcesso:{ nome:"Processo", visible:false, termo:"Nº do processo relativo ao contrato" },
      objeto:{ nome:"Objeto", visible:true, termo:"Bem adquirido ou serviço contratado" },
      dataInicio:{ nome:"Início", visible:true, termo:"Data início do contrato" },
      dataFim:{nome:"Término", visible:true, termo:"Data final do contrato"},
      aditivos:{ nome: "Aditivos", visible:true, termo:"Nº de alterações do contrato", center: true },
      finalidade:{ nome: "Finalidade", visible:false, termo: "Finalidade do contrato"},
      valorContrato:{ nome: "Valor", visible:true, currency:true, disabled:true, termo:"Valor do contrato sem aditivos"  }
      
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Contratos',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var data = {
      url: '/licitacoes-contratos/contrato',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/licitacoes-contratos/contratos/contratos-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formTplDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/licitacoes-contratos/contratos/contratos-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var modalTemplate = function (titulo, template) {
      return $modal({
        scope: $scope,
        title: titulo,
        template: template,
        show: false
      });
    };

    var modalAditivos = $aside({
      scope: $scope,
      template: 'app/components/licitacoes-contratos/contratos/aditivos-modal.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showFormDetalhamento();
      }
    };

    $scope.exportar = function() {
      if(vm.item){
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/licitacoes-contratos/relatorio/contrato', vm.item);
      }
    };

    vm.init = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;

      var stored = LicitacoesContratosService.getStored();
      if(stored){
        vm.item.anoInicio = stored.ano;
        vm.applyFilters(stored);
      }else{
        vm.item.anoInicio = vm.anos[0];
      }
      
      vm.assignInitParams($location.search());

      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function(params) {
      var assignProps = function(propsArray, fromObj, toObj) {
        propsArray.forEach(function(prop) {
          if (fromObj[prop.from] != undefined) {
            if (prop.type == Number) {
              toObj[prop.to] = Number(fromObj[prop.from]);
            } else if (prop.type == String) {
              toObj[prop.to] = String(fromObj[prop.from]);
            }
          }
        });
      };

      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return elem[compareProp].trim() == param; })[0];

          if (element != null) {
            modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];
          }
        }
      };

      assignProps([{from:'credor', to:'credor', type:String}], params, vm.item);
      assignProps([{from:'objeto', to:'objeto', type:String}], params, vm.item);
      assignProps([{from:'ano', to:'anoInicio', type:String}], params, vm.item);
      assignSelect(vm.unidadeGestora, vm.item, 'listaCodigoUnidadeGestora', params['orgao'], 'nome', 'codigo', true);

      if (params['objeto']) {
        colunas.objeto.visible = true;
      }
    };

    vm.applyFilters = function (stored) {

      var fn = function (item,dados) {
        if(item){
          var codigo = '';
          if(Array.isArray(dados)){
            dados.forEach(function(dado){
              if(dado.nome == item || dado.codigo == item){
                codigo = [dado.codigo];
              }
            });
          }else{
            codigo = [item];
          }
          return codigo;
        }
      };

      vm.item.listaCodigoSituacao = fn(stored.situacao,vm.situacoes);
      vm.item.listaCodigoUnidadeGestora = fn(stored.unidadeGestora, vm.unidadeGestora);
      vm.item.especie = stored.especie;
    };

    vm.exibirModalExtratoNotaEmpenho = function (item) {
      LicitacoesContratosService.listarExtratoNotaEmpenho(item.numeroContrato).then(
        function (response) {
          if (response.data.length == 0) {
            $alert({
              content: 'Não há notas de empenho vinculadas',
              type: 'info'
            });
            return;
          }
          vm.notas = response.data;
          vm.totalNe = _.reduce(vm.notas, function (memo, obj) {
            return memo + obj.valorNe
          }, 0);
          vm.totalNl = _.reduce(vm.notas, function (memo, obj) {
            return memo + obj.valorNl
          }, 0);
          vm.totalPago = _.reduce(vm.notas, function (memo, obj) {
            return memo + obj.valorPago
          }, 0);

          if (currentModal) {
            currentModal.hide();
          }

          $aside({
            scope: $scope,
            template: 'app/components/licitacoes-contratos/contratos/nota-empenho-modal.html',
            show: true,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
          });


        },
        function () {
          $alert({
            content: 'Erro ao recuperar dados para o extrato',
            type: 'info'
          });
        }
      );
    };

    vm.search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.anoInicio;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    vm.voltar = function() {
      if (currentModal) {
        currentModal.show();
      }
    };

    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    var showFormDetalhamento = function() {
      angular.element('.tooltip').remove();
      formTplDetalhamento.show();

      currentModal = formTplDetalhamento;
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    vm.exibirModalAditivos = function(item) {

      var reqObj = {
        numeroContrato: item.numeroContrato,
      };

      LicitacoesContratosService.listarContratoAditivos(reqObj).then(
        function(response) {
          if(response.data.length == 0) {
            $alert({
              content:'Não há aditivos registrados no SIGGO para este contrato',
              type:'info'
            });
            return;
          }

          vm.aditivos = response.data;

          if (currentModal) {
            currentModal.hide();
          }

          modalAditivos.show();
        },
        function() {
          $alert({
            content: 'Erro ao recuperar os aditivos do contrato',
            type: 'info'
          });
        }
      );
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal.licitacao-contrato').controller('ItensLicitadosController', ItensLicitadosController);

  /** @ngInject */
  function ItensLicitadosController($scope, $aside, $window, $location, anos,
                    RelatorioService, LicitacoesContratosService, dataAtualizacao) {

    var vm = this;
    vm.anos = anos.data;
    var anoPadrao = selecionarAnoVigente(vm.anos);
    
    vm.dataAtualizacao = dataAtualizacao;

    vm.orgaos = [];
    vm.ufs = [];
    vm.modalidades = [];

    var colunas = {
      idPregaoEletronico: {nome: "N° Licitação", visible: true, termo:"Nº de identificação do processo licitatório", center: true},
      codigoItem : {nome: "N° Item", visible: true, termo: "Código do item", center: true},
      modalidadeLicitacao: { nome: "Modalidade", visible: false, termo: "Tipo de procedimento que vai reger a licitação" },
      nomeItem: {nome: "Item", visible: true, termo:"Nome do objeto licitado", disabled: true},
      descricaoItem: {nome: "Descrição", visible: true, termo:"Detalhamento do objeto licitado", disabled: true},      
      nomeOrgao: {nome: "Órgão", visible: true, termo:"Órgão responsável pela aquisição"},
      nomeFornecedor: {nome: "Fornecedor", visible: true, termo:"Empresa que vai fornecer o item"},
      codigoFornecedor: {nome: "CNPJ/CPF", visible: false, termo:"Nº de cadastro de pessoa física ou jurídica do fornecedor"},
      ufFornecedor: {nome: "UF Fornecedor", visible: false, termo:"Unidade da Federação (Estado) do fornecedor", center: true},
      municipioFornecedor: {nome: "Município", visible: false, termo:"Cidade do fornecedor"},
      quantidadeItens: {nome: "Quantidade", visible: true, termo:"Quantidade do item", center: true},
      unidadeMedida : {nome: "Medida", visible: true, termo: "Unidade de medida"},
      valorUnitarioEstimado: {nome: "VL Unit Estimado", visible: false, currency: true, termo:"Valor unitário estimado pelo órgão para o item"},
      valorUnitario: {nome: "Valor Unitário", visible: true, currency: true, termo:"Valor unitário homologado para o item", disabled: true, moreDecimal: true},
      valorTotalItens: {nome: "Total Item", visible: false, currency: true, termo:"Valor total homologado para o item"}
    };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Item Licitado',
      plural: 'Itens Licitados',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      tipo: 'csv',
      page: 0,
      busy: false,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var data = {
      url: '/v2/itens-licitados',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    var formTplFiltro = $aside({
      scope: $scope,
      template: 'app/components/licitacoes-contratos/itens-licitados/itens-licitados-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formTplDetalhamento = $aside({
      scope: $scope,
      template: 'app/components/licitacoes-contratos/itens-licitados/itens-licitados-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      carregarFiltros();
      vm.showFormFiltro();
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.item.editing = false;
        vm.settings.cmd = 'Visualizar';
        
        LicitacoesContratosService.detalharItemLicitado(linha.idItemCompra)
            .then(function(response) {        
                vm.linha = response.data;
                vm.showFormDetalhamento();
            });
      }
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
      }
      RelatorioService.exportar('/v2/itens-licitados/relatorios', vm.item);
    };

    $scope.fecharModalColunas = function () {
        vm.search();
    }

    vm.init = function () {      
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;

      var params = $location.search();

      vm.item.anoLicitacao = params.exercicio ? params.exercicio : anoPadrao;

      if(params['nomeOrgao']) {
          LicitacoesContratosService.listarOrgaos()
            .then(function(response) {
              vm.orgaos = response.data;
              vm.assignInitParams(params);
              vm.search();
            });
      } else {
        vm.assignInitParams(params);
        vm.search();
      }
      
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     */
    vm.assignInitParams = function(params) {
        var assignProps = function(propsArray, fromObj, toObj) {
          propsArray.forEach(function(prop) {
            if (fromObj[prop.from] != undefined) {
              if (prop.type == Number) {
                toObj[prop.to] = Number(fromObj[prop.from]);
              } else if (prop.type == String) {
                toObj[prop.to] = String(fromObj[prop.from]);
              }
            }
          });
        };
  
        var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
          if (param) {
            var element = selectOptions.filter(function(elem) {            
              return elem[compareProp].trim() == param; 
            })[0];
            if (element != null) {
              modelObj[modelProp] = isMultiple ? [element[valueProp]] : element[valueProp];            
            }
          }
        };      
  
        assignProps([
          {from:'nomeItem', to:'nomeItem', type:String},
          {from:'descricaoItem', to:'nomeItem', type:String},
          {from:'nomeFornecedor', to:'nomeFornecedor', type:String},
          {from:'exercicio', to: 'anoLicitacao'}], params, vm.item);
        assignSelect(vm.orgaos, vm.item, 'codigoOrgao', params['nomeOrgao'], 'nome', 'codigo', false);        
  
        if (vm.item.cm) {
          vm.item.cm = btoa(vm.item.cm);
        } else if (params['cm']) {
          vm.item.cm = params['cm'];
        }
    };


    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.anoLicitacao;
      vm.item.colunas = colunas;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    vm.voltar = function() {
      if (currentModal) {
        currentModal.show();
      }
    };

    vm.showFormFiltro = function () {
      angular.element('.tooltip').remove();
      formTplFiltro.show();
    };

    vm.showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formTplDetalhamento.show();
      currentModal = formTplDetalhamento;
    };

    $scope.hideForm = function () {
      formTplFiltro.hide();
      formTplDetalhamento.hide();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    function carregarFiltros() {
        LicitacoesContratosService.listarOrgaos()
            .then(function(response) {
                vm.orgaos = response.data;
            });

        LicitacoesContratosService.listarUfs()
            .then(function(response) {
                vm.ufs = response.data;
            });

        LicitacoesContratosService.listarModalidades()
            .then(function(response) {
                vm.modalidades = response.data;
            });
    }

    function selecionarAnoVigente(anos) {
      var anoVigente = new Date().getFullYear();

      for (var index = 0; index < anos.length; index++) {
        if (Number(anos[index]) === anoVigente) {
          return anoVigente;
        }
      }

      anos.unshift(anoVigente);
      return anoVigente;
    }
  }

})();

(function() {
    'use strict';

    angular.module('portal').controller('LicitacoesController', LicitacoesController);

    /**
     * Controlador da página de licitações.
     */
    /** @ngInject */
    function LicitacoesController($scope, $q, $aside, $location, ScopeService, DataAtualizacaoService, LicitacoesService, anos,
                                  RelatorioService, LicitacoesContratosService) {
        var vm = this;
        vm.pageID = 'licitacoes_page';
        vm.contador = 0;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.LicitacoesService = LicitacoesService;
        vm.LicitacoesContratosService = LicitacoesContratosService;
        vm.loadDataAtualizacao = loadDataAtualizacao;
        vm.visualizarItem = visualizarItem;
        vm.onColumnsPanelClose = onColumnsPanelClose;
        vm.exportar = exportar;
        vm.onFilterFormConfirm = onFilterFormConfirm;
        vm.onFilterFormReset = onFilterFormReset;
        vm.updateData = updateData;
        vm.updateFilter = updateFilter;
        vm.createFilterPanel = createFilterPanel;
        vm.createFormularioFilter = createFormularioFilter;
        vm.buildColunasParamsMap = buildColunasParamsMap;
        vm.navigateTo = navigateTo;
        vm.toggleCollapsed = toggleCollapsed;
        vm.init = init;
        vm.$scope = $scope;
        vm.$aside = $aside;
        vm.$location = $location;
        vm.ScopeService = ScopeService;
        vm.RelatorioService = RelatorioService;

        vm.filterPanel = vm.createFilterPanel();
        vm.formularioFiltro = vm.createFormularioFilter(anos, $q, LicitacoesService, LicitacoesContratosService);
        vm.data = { content: [] };
        vm.ano = 0;
        $scope.colunas = COLUMNS;
        $scope.fecharModalColunas = function(e) { vm.onColumnsPanelClose(e) };

        $scope.exportar = function() {
          vm.exportar();
        };


        vm.init();
    }

    /**
     * Inicializa a página.
     */
    function init() {
        var self = this;
        var filterModel = null;

        this.storagedObject = this.ScopeService.getStored();

        if (this.storagedObject) {
            var storagedParams = this.storagedObject[this.pageID];

            if (storagedParams) {
                this.$scope.colunas = storagedParams.colunas;
                filterModel = storagedParams.filtro;
            }
        }

        this.loadDataAtualizacao();

        this.formularioFiltro.initialDefaultModel(function(model) {
            if (filterModel != null) {
                model = filterModel;
                self.formularioFiltro.setModel(model);
            }
            self.updateFilter(model);
            self.ano = model.anoLicitacao;
        });
    }

    /**
     * Carrega a data de atualização da base de dados.
     */
    function loadDataAtualizacao() {
        var self = this;
        this.DataAtualizacaoService.buscarDataAtualizacao('itens-licitados')
            .then(function(resp) {
                self.dataAtualizacao = resp.data;
            });
    }

    /**
     * Detalha um item.
     * @param {*} item Item.
     */
    function visualizarItem(item) {
        this.navigateTo('/licitacoes-contratos/licitacoes/fornecedores', {
            idPregaoEletronico: item.idPregaoEletronico,
            codigoOrgao: item.codigoOrgao

        });
    }

    /**
     * Navega para uma página.
     * @param {*} url URL.
     * @param {*} searchParams Query params map.
     */
    function navigateTo(url, searchParams) {
        var storeParams = this.storagedObject ? this.storagedObject : {};

        storeParams[this.pageID] = {
            filtro: this.$scope.filter,
            colunas: this.$scope.colunas
        };

        this.ScopeService.store(storeParams);

        this.$location.path(url).search(searchParams);
    }

    /**
     * Alterna a propriedade expanded de uma coluna.
     * @param {*} column Coluna.
     */
    function toggleCollapsed(event) {
        var element = angular.element(event.currentTarget).siblings();
        element.toggleClass('internal_cell_collapsed');
    }
    /**
     * Responde ao evento de fechamento do painel de seleção de colunas.
     */
    function onColumnsPanelClose(event) {
        if (event.hasChange) {
            this.updateData();
        }
    }

    /**
     * Responde ao evento de confirmação do formulário de filtro.
     */
    function onFilterFormConfirm() {
        var model = this.formularioFiltro.buildModel();
        this.updateFilter(model);
        this.filterPanel.hide();
    }

    /**
     * Responde ao evento de redefinição do formulário de filtro.
     */
    function onFilterFormReset() {
        this.updateFilter(this.formularioFiltro.buildDefaultModel('reset'));
        this.filterPanel.hide();
    }

    /**
     * Atualiza a tabela.
     */
    function updateData() {
        var newFilterObj = angular.copy(this.$scope.filter);
        newFilterObj.colunas = this.buildColunasParamsMap(this.$scope.colunas);
        this.$scope.filter = newFilterObj;
    }

    /**
     * Atualiza o filtro de acordo com o seu formulário.
     */
    function updateFilter(model) {
        this.data.content = [];

        model.colunas = this.buildColunasParamsMap(this.$scope.colunas);
        this.$scope.filter = model;
        this.ano = model.anoLicitacao;

    }

    /**
     * Constroi o map de parametros correspondentes às colunas.
     */
    function buildColunasParamsMap() {
        var self = this;
        var map = {};

        Object.keys(this.$scope.colunas)
            .forEach(function(key) {
                map[key] = {
                    visible: self.$scope.colunas[key].visible
                };
            });

        return map;
    }

    /**
    * Faz a exportação da consulta com as colunas selecionadas.
    */
    function exportar() {
        var exportConfig = this.$scope.filter;
        exportConfig.colunas = this.$scope.colunas;

        this.RelatorioService.exportar('/v2/licitacoes/relatorios', exportConfig);
    }

    /**
     * Cria o painel do formulário de filtro.
     */
    function createFilterPanel() {
        return this.$aside({
            scope: this.$scope,
            template: 'app/components/licitacoes-contratos/licitacoes/licitacoes-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });
    }

    /**
     * Cria o modelo do formulário de filtro.
     * @param {*} anos Conjunto de exercícios da base de licitações.
     */
    function createFormularioFilter(anos, $q, LicitacoesService, LicitacoesContratosService) {
        var FormularioFilter = function(exercicios) {
            var self = this;

            this.objetoModel = '';
            this.idPregaoEletronicoModel = '';
            this.periodoFiltroModel = 'exercicio';
            this.periodosFiltro = [
                { codigo: 'exercicio', nome: 'Exercício' },
                { codigo: 'abertura', nome: 'Data de Abertura' }
            ];
            this.anoAberturaModel = null;
            this.mesAberturaModel = null;
            this.mesesAbertura = [
                { codigo: '01', nome: 'Janeiro' },
                { codigo: '02', nome: 'Fevereiro' },
                { codigo: '03', nome: 'Março' },
                { codigo: '04', nome: 'Abril' },
                { codigo: '05', nome: 'Maio' },
                { codigo: '06', nome: 'Junho' },
                { codigo: '07', nome: 'Julho' },
                { codigo: '08', nome: 'Agosto' },
                { codigo: '09', nome: 'Setembro' },
                { codigo: '10', nome: 'Outubro' },
                { codigo: '11', nome: 'Novembro' },
                { codigo: '12', nome: 'Dezembro' }
            ];

            this.tiposResource = new Resource(LicitacoesService.listarTipos());
            this.tiposResource.load();

            this.situacoesResource = new Resource(LicitacoesService.listarSituacoes());
            this.situacoesResource.load();

            this.modalidadesResource = new Resource(LicitacoesContratosService.listarModalidades());
            this.modalidadesResource.load();

            this.orgaosResource = new Resource();

            this.exerciciosResource = new Resource($q(function(resolve) {
                resolve(exercicios);
            }));
            this.exerciciosResource.setChangeListener(function(resource) {
                self.orgaosResource.setPromise(LicitacoesService.listarOrgaos(resource.model))
                self.orgaosResource.load();
            });
        };
        // Carrega o modelo default
        FormularioFilter.prototype.initialDefaultModel = function(callBack) {
            var self = this;
            this.exerciciosResource.load(function(resource) {
                self.ultimoAno = selecionarAnoVigente(resource.data);
                resource.setModel(self.ultimoAno);

                callBack(self.buildDefaultModel('initial'));
            });
        };
        // Responde à escolha do tipo de período usado na consulta
        FormularioFilter.prototype.onPeriodoFiltroChange = function() {
            if (this.periodoFiltroModel == 'abertura') {
                this.anoAberturaModel = this.anoAberturaModel || this.getDefaultAnoAbertura();
                this.mesAberturaModel = this.mesAberturaModel || this.getDefaultMesAbertura();
                this.exerciciosResource.model = null;
                this.exerciciosResource.onChange();
                return;
            }

            this.anoAberturaModel = null;
            this.mesAberturaModel = null;

            if (!this.exerciciosResource.model && this.ultimoAno) {
                this.exerciciosResource.model = this.ultimoAno;
            }

            this.exerciciosResource.onChange();
        };
        // Retorna o ano padrão usado ao habilitar o filtro de abertura
        FormularioFilter.prototype.getDefaultAnoAbertura = function() {
            if (this.ultimoAno) {
                return this.ultimoAno;
            }

            if (this.exerciciosResource.data && this.exerciciosResource.data.length) {
                return this.exerciciosResource.data[0];
            }

            return null;
        };
        // Retorna o mês padrão usado ao habilitar o filtro de abertura
        FormularioFilter.prototype.getDefaultMesAbertura = function() {
            return this.mesesAbertura[0].codigo;
        };
        // Responde à seleção do filtro de exercício
        FormularioFilter.prototype.onExercicioChange = function() {
            if (this.periodoFiltroModel == 'abertura') {
                this.exerciciosResource.model = null;
                this.exerciciosResource.onChange();
                return;
            }

            this.anoAberturaModel = null;
            this.mesAberturaModel = null;

            this.exerciciosResource.onChange();
        };
        // Responde à seleção dos filtros de abertura
        FormularioFilter.prototype.onAberturaChange = function() {
            this.periodoFiltroModel = 'abertura';
            this.orgaosResource.setDefaultModel(this.orgaosResource.model);
            this.exerciciosResource.model = null;
            this.exerciciosResource.onChange();
        };
        // Constroi o modelo padrão correspondente aos filtros
        FormularioFilter.prototype.buildDefaultModel = function(action) {
            var model = {
                tipo: 'csv',
                page: 0,
                busy: false
            };

            this._setModelExercicio(model);
            if(action == 'reset') {
                this.periodoFiltroModel = 'exercicio';
                this.idPregaoEletronicoModel = "";
                this.objetoModel = "";
                this.anoAberturaModel = null;
                this.mesAberturaModel = null;
                this.tiposResource.model = null;
                this.situacoesResource.model = null;
                this.modalidadesResource.model = null;
                this.orgaosResource.model = null;
            }

            if (this.ultimoAno) {
                model.anoLicitacao = this.ultimoAno;
            }

            return model;
        };
        // Configura os campos de acordo com um model
        FormularioFilter.prototype.setModel = function(model) {
            if (model.anoAbertura || model.mesAbertura) {
                this.periodoFiltroModel = 'abertura';
                this.exerciciosResource.setModel(null);
                delete(model.anoLicitacao);
            } else {
                this.periodoFiltroModel = 'exercicio';
                this.exerciciosResource.setModel(model.anoLicitacao);
                delete(model.anoAbertura);
                delete(model.mesAbertura);
            }

            this.orgaosResource.setDefaultModel(model.codigoOrgao);
            this.tiposResource.setDefaultModel(model.codigoTipo);
            this.objetoModel = model.objeto;
            this.idPregaoEletronicoModel = model.idPregaoEletronico;
            this.anoAberturaModel = model.anoAbertura || (this.periodoFiltroModel == 'abertura' ? this.getDefaultAnoAbertura() : null);
            this.mesAberturaModel = model.mesAbertura || (this.periodoFiltroModel == 'abertura' ? this.getDefaultMesAbertura() : null);
        };
        // Constroi o objeto modelo correspondente aos filtros
        FormularioFilter.prototype.buildModel = function() {
            var model = this.buildDefaultModel('confirm');

            this._setModelExercicio(model);
            this._setModelOrgaos(model);
            this._setModelTipo(model);
            this._setModelObjeto(model);
            this._setModelIdPregaoEletronico(model);
            this._setModelAnoAbertura(model);
            this._setModelMesAbertura(model);
            this._aplicarExclusividadePeriodo(model);
            this._setModelModalidades(model);
            this._setModelSituacoes(model);

            return model;
        };
        // Garante que Exercício e filtros de abertura não sejam enviados juntos
        FormularioFilter.prototype._aplicarExclusividadePeriodo = function(model) {
            if (this.periodoFiltroModel == 'abertura' || model.anoAbertura || model.mesAbertura) {
                delete(model.anoLicitacao);
            } else {
                delete(model.anoAbertura);
                delete(model.mesAbertura);
            }
        };
        // Define a propriedade exercício em um objeto modelo
        FormularioFilter.prototype._setModelExercicio = function(model) {
            if (this.periodoFiltroModel != 'exercicio') {
                delete(model.anoLicitacao);
                return;
            }

            this.exerciciosResource.takeModel(function(ano) {
                model.anoLicitacao = ano;
            }, function() {
                delete(model.anoLicitacao);
            });
        };
        // Define a propriedade órgãos em um objeto modelo
        FormularioFilter.prototype._setModelOrgaos = function(model) {
            this.orgaosResource.takeModel(function(data) {
                /*var orgaos = self.orgaosResource.data.filter(function(orgao) {
                    return data.indexOf(orgao.codigo) != -1;
                }).map(function(orgao) {
                    return orgao.nome;
                });

                if (orgaos.length) {
                    model.nomeOrgao = orgaos;
                }*/

                model.codigoOrgao = data;
            }, function() {
                delete(model.codigoOrgao);
            });
        };
        // Define a propriedade tipo em um objeto modelo
        FormularioFilter.prototype._setModelTipo = function(model) {
            this.tiposResource.takeModel(function(tipo) {
                model.codigoTipo = tipo;
            }, function() {
                delete(model.codigoTipo);
            });
        };
        // Define a propriedade objeto em um objeto modelo
        FormularioFilter.prototype._setModelObjeto = function(model) {
            if (this.objetoModel) {
                model.objeto = this.objetoModel;
            } else {
                delete(model.objeto);
            }
        };

        // Define a propriedade objeto em um objeto modelo
        FormularioFilter.prototype._setModelIdPregaoEletronico = function(model) {
            if (this.idPregaoEletronicoModel) {
                model.idPregaoEletronico = this.idPregaoEletronicoModel;
            } else {
                delete(model.idPregaoEletronico);
            }
        };

        // Define a propriedade ano de abertura em um objeto modelo
        FormularioFilter.prototype._setModelAnoAbertura = function(model) {
            if (this.periodoFiltroModel == 'abertura' && this.anoAberturaModel) {
                model.anoAbertura = this.anoAberturaModel;
            } else {
                delete(model.anoAbertura);
            }
        };

        // Define a propriedade mês de abertura em um objeto modelo
        FormularioFilter.prototype._setModelMesAbertura = function(model) {
            if (this.periodoFiltroModel == 'abertura' && this.mesAberturaModel) {
                model.mesAbertura = this.mesAberturaModel;
            } else {
                delete(model.mesAbertura);
            }
        };

        // Define a propriedade objeto em um objeto modelo
        FormularioFilter.prototype._setModelModalidades = function(model) {
            this.modalidadesResource.takeModel(function(modalidade) {
                model.modalidadeLicitacao = modalidade;
            }, function() {
                delete(model.modalidadeLicitacao);
            });
        };

        // Define a propriedade objeto em um objeto modelo
        FormularioFilter.prototype._setModelSituacoes = function(model) {
            this.situacoesResource.takeModel(function(situacao) {
                model.situacao = situacao;
            }, function() {
                delete(model.situacao);
            });
        };

        return new FormularioFilter(anos);
    }

    function selecionarAnoVigente(anos) {
        var anoVigente = new Date().getFullYear();

        for (var index = 0; index < anos.length; index++) {
            if (Number(anos[index]) === anoVigente) {
                return anoVigente;
            }
        }

        anos.unshift(anoVigente);
        return anoVigente;
    }


    // Colunas da tabela
    var COLUMNS = {
        idPregaoEletronico: {nome: "Nº da Licitação", visible: true, termo:"Nº de identificação da licitação"},
        modalidadeLicitacao: {nome: "Modalidade", visible: true, termo:"Procedimento que vai reger a licitação"},
        situacao: {nome: "Situação", visible: true, termo:"Fase em que se encontra a licitação"},
        nomeOrgao: {nome: "Órgão", visible: true, termo:"Unidade gestora associada"},
        codigoComprasNet: {nome: "Código COMPRASNET", visible: false, termo:"Identificador no sistema COMPRASNET"},
        tipo: {nome: "Tipo", visible: true, termo:"Tipo de produto a ser adquirido: serviço ou material"},
        objeto: {nome: "Objeto", visible: true, expanded: false, termo:"Descrição do objeto", collapsed: true},
        dataAbertura: {nome: "Data de Abertura", visible: false, date: true, termo:"Data de Abertura da Sessão Pública"},
        urlEdital: {nome: "Edital", link: true, visible: true, termo:"Link para acesso ao edital"},
        totalEstimado: {nome: "Total Estimado", visible: false, currency: true, termo:"Total Estimado"},
       // totalProposto: {nome: "Total Proposto", visible: true, currency: true, termo:"Total proposto dos itens ou do desconto"},
        totalHomologado: {nome: "Total Homologado", visible: true, currency: true, termo:"Total homologado"} 
            
    };


    // Modelo dos dados de um campo de filtro
    var Resource = (function() {
        var ResourceClass = function(promise) {
            this.loading = false;
            this.setPromise(promise);
        };
        ResourceClass.prototype.load = function(callBack) {
            var self = this;
            this.loading = true;
            this.promise.then(function(data) {
                self.data = data;
                self.model = self.defaultModel != undefined ? self.defaultModel : null;
                self.loaded = true;

                if (callBack) {
                    callBack(self);
                }
            }).finally(function() {
                self.loading = false;
            });
        };
        ResourceClass.prototype.setDefaultModel = function(value) {
            this.defaultModel = value;
        };
        ResourceClass.prototype.setModel = function(value) {
            this.model = value;
            this.onChange();
        };
        ResourceClass.prototype.setChangeListener = function(listenerCallback) {
            this.changeListener = listenerCallback;
        };
        ResourceClass.prototype.onChange = function() {
            if (this.changeListener) {
                this.changeListener(this);
            }
        };
        ResourceClass.prototype.setPromise = function(promise) {
            this.loaded = false;
            this.model = [];
            this.data = [];
            this.promise = promise;
        };
        ResourceClass.prototype.takeModel = function(callbackIfExists, callbackDontExists) {
            if (this.model != null && this.model != undefined) {
                callbackIfExists(this.model);
            } else {
                callbackDontExists();
            }
        };

        return ResourceClass;
    })();

})();

(function () {
    'use strict';
  
    angular.module('portal').service('LicitacoesService', LicitacoesService);

    /**
     * Fornece serviços para a tela de consulta de licitações.
     */
    function LicitacoesService($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.listarExercicios = listarExercicios;
        _scope.listarOrgaos = listarOrgaos;
        _scope.listarTipos = listarTipos;
        _scope.listarFornecedores = listarFornecedores;
        _scope.listarParticipantesItem = listarParticipantesItem;
        _scope.listarItens = listarItens;
        _scope.listarSituacoes = listarSituacoes;
        _scope.api = api;
  
        return _scope;
    }

    /**
     * Obtem o conjunto de exercícios.
     */
    function listarExercicios() {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/anos',
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem o conjunto de órgãos respectivos a um exercício.
     * @param {*} exercicio Exercício.
     */
    function listarOrgaos(exercicio) {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/orgaos',
            method: 'GET',
            params: exercicio ? { exercicio: exercicio } : {}
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem o conjunto de tipos.
     */
    function listarTipos() {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/tipos',
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem os fornecedores de um pregão.
     */
    function listarFornecedores(idPregao, codigoOrgao) {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/fornecedores-por-pregao?idPregaoEletronico=' + idPregao + '&codigoOrgao=' + codigoOrgao,
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem os itens de um fornecedor.
     */
    function listarItens(idPregao, codigoOrgao, codigoFornecedor) {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/itens-por-fornecedor?idPregaoEletronico=' + idPregao + '&codigoOrgao=' + codigoOrgao + '&codigoFornecedor=' + codigoFornecedor,
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem os fornecedores de um item.
     */
    function listarParticipantesItem(idPregao, codigoOrgao, idItemCompra) {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/detalhamento-participantes?idPregaoEletronico=' + idPregao + '&codigoOrgao=' + codigoOrgao + '&idItemCompra=' + idItemCompra,
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Obtem as situações.
     */
    function listarSituacoes() {
        return this.$http({
            url: this.api.url + '/v2/licitacoes/situacoes',
            method: 'GET'
        }).then(function(resp) {
            return resp.data;
        });
    }
    
})();

(function () {
    'use strict';

    angular.module('portal').controller('PatrimonioBensImoveisController', PatrimonioBensImoveisController);

    /**
     * Controlador da página de bens imóveis.
     */
    /** @ngInject */
    function PatrimonioBensImoveisController(dataAtualizacao, $scope, $aside, $alert, BensImoveisService, RelatorioService) {
        var vm = this;
        var modalStack = [];
        vm.pesquisa = {};

        var colunas = {
            tombamento: { nome: "Tombamento", visible: true, termo: "Tombamento", center: true },
            endereco: { nome: "Endereço", visible: true, termo: "Endereço do imóvel" },
            regiaoAdministrativa: { nome: "RA", visible: true, termo: "Região administratriva onde o imóvel se encontra" },
            orgao: { nome: "Órgão", visible: true, termo: "Nome do órgão associado" },
            situacao: { nome: "Situação", visible: true, termo: "Situação do imóvel" },
            // totalTerrenos: { nome: "Total Terrenos", visible: true, termo: "Total Terrenos", currency: true},
            // totalEdificacoes: { nome: "Total Edificações", visible: true, termo: "Total Edificações", currency: true},
            // totalObras: { nome: "Total Obras", visible: true, termo: "Total Obras", currency: true},
        };

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Bem imóvel',
            plural: 'Bens imóveis',
            busy: true,
            cmd: '',
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            busy: false,
            dataAtualizacao: dataAtualizacao.data
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var data = {
            url: '/v2/bens-imoveis',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTplFiltro = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-imoveis/bens-imoveis-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-imoveis/bens-imoveis-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamentoTerreno = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-imoveis/bens-imoveis-terreno.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamentoEdificacao = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-imoveis/bens-imoveis-edificacao.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamentoObras = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-imoveis/bens-imoveis-obras.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.resetFiltros = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
            vm.search();
        };

        $scope.fecharModalColunas = function () {
            vm.search();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.item.colunas = colunas;

            var copy = angular.copy(vm.item);

            if (copy.tombamento) {
                copy.tombamento = copy.tombamento.replace('/', '');
            }

            $scope.filter = copy;
            $scope.hideForm();
        };

        vm.voltar = function () {
            if (modalStack.length > 0) {
                var previous = null;

                if (modalStack.length > 1) {
                    previous = modalStack[modalStack.length - 2];
                }

                modalStack[modalStack.length - 1].hide();
                modalStack.splice(modalStack.length > 1 ? modalStack.length - 2 : modalStack.length - 1, 2);

                if (previous != null) {
                    showForm(previous);
                }
            }
        };

        vm.closeAll = function () {
            if (modalStack.length) {
                modalStack[modalStack.length - 1].hide();
            }

            modalStack.splice(0, modalStack.length);
        };

        function showForm(form) {
            if (modalStack.length > 0) {
                modalStack[modalStack.length - 1].hide();
            }

            angular.element('.tooltip').remove();
            form.show();

            modalStack.push(form);
        }

        vm.showFormDetalhamento = function (data) {
            vm.linha = data;
            showForm(formTplDetalhamento);
        };

        $scope.hideForm = function () {
            formTplFiltro.hide();
            formTplDetalhamento.hide();
        };

        function carregarFiltros() {
            BensImoveisService.consultarConjuntoFiltros().then(function (filtros) {
                vm.pesquisa = filtros;
            });
        }

        vm.exibirFormPesquisa = function () {
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';

            carregarFiltros();
            showForm(formTplFiltro);
        };

        vm.visualizarItem = function (linha) {
            if (linha) {
                vm.item.editing = false;
                vm.settings.cmd = 'Visualizar';
                vm.showFormDetalhamento(linha);
            }
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = vm.settings.colunas;
                vm.item.tipo = $scope.dados.form.tipo;
            }
            RelatorioService.exportar('/v2/bens-imoveis/relatorios', vm.item);
        };

        vm.visualizarTerreno = function (linha) {
            BensImoveisService.consultarTerreno(linha.tombamento)
                .then(function (resp) {
                    vm.terreno = resp.content;

                    if (vm.terreno && vm.terreno.length) {
                        vm.terreno.totalizador = resp.totalizador.valor;
                        showForm(formTplDetalhamentoTerreno);
                    } else {
                        $alert({
                            content: 'Nenhum detalhamento de terreno encontrado',
                            type: 'info'
                        });
                    }
                });
        };

        vm.visualizarEdificacao = function (linha) {
            BensImoveisService.consultarEdificacao(linha.tombamento)
                .then(function (resp) {
                    vm.edificacao = resp.content;

                    if (vm.edificacao && vm.edificacao.length) {
                        vm.edificacao.totalizador = resp.totalizador.valor;
                        showForm(formTplDetalhamentoEdificacao);
                    } else {
                        $alert({
                            content: 'Nenhum detalhamento de edificação encontrado',
                            type: 'info'
                        });
                    }
                });
        };

        vm.visualizarObras = function (linha) {
            BensImoveisService.consultarObras(linha.tombamento)
                .then(function (resp) {
                    vm.obras = resp.content;

                    if (vm.obras && vm.obras.length) {
                        vm.obras.totalizador = resp.totalizador.valor;
                        showForm(formTplDetalhamentoObras);
                    } else {
                        $alert({
                            content: 'Nenhum detalhamento de obra encontrado',
                            type: 'info'
                        });
                    }
                });
        };

        vm.init = function () {
            vm.search();
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });
    }

})();
(function () {
    'use strict';
  
    angular.module('portal').service('BensImoveisService', Service);

    /**
     * Fornece serviços para consulta de dados de bens imóveis.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;
        _scope.store = function (data) { dataStored = data; }
        _scope.consultarRegioesAdministrativas = consultarRegioesAdministrativas;
        _scope.consultarOrgaos = consultarOrgaos;
        _scope.consultarSituacoes = consultarSituacoes;
        _scope.consultarImovel = consultarImovel;
        _scope.consultarEdificacao = consultarEdificacao;
        _scope.consultarObras = consultarObras;
        _scope.consultarTerreno = consultarTerreno;
        _scope.consultarConjuntoFiltros = consultarConjuntoFiltros;
  
        return _scope;
    }

    /**
     * Consulta a delimitação das regiões administrativas em formato GeoJSON.
     * @returns Promise para uma feature collection.
     */
    function consultarRegioesAdministrativas() {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/regioes-administrativas',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de orgões.
     * @returns Promise para a coleção.
     */
    function consultarOrgaos() {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/orgaos',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de situações.
     * @returns Promise para a coleção.
     */
    function consultarSituacoes() {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/situacoes',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de detalhamento.
     * @returns Promise para a coleção.
     */
    function consultarImovel(tombamento) {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/' + parseTombamento(tombamento),
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o detalhamento do terreno.
     * @returns Promise para a coleção.
     */
    function consultarTerreno(tombamento) {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/' + parseTombamento(tombamento) + '/terrenos',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o detalhamento da edificação.
     * @returns Promise para a coleção.
     */
    function consultarEdificacao(tombamento) {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/' + parseTombamento(tombamento) + '/edificacoes',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de detalhamento de obras.
     * @returns Promise para a coleção.
     */
    function consultarObras(tombamento) {
        return this.$http({
            url: this.api.url + '/v2/bens-imoveis/' + parseTombamento(tombamento) + '/obras',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de filtros para bens imóveis.
     * @returns Promise para a coleção.
     */
    function consultarConjuntoFiltros() {
        return this.$q.all([this.consultarOrgaos(), this.consultarRegioesAdministrativas(), this.consultarSituacoes()])
            .then(function(list) {
                return {
                    orgaos: list[0],
                    regioes: list[1],
                    situacoes: list[2]
                };
            });
    }

    function parseTombamento(tombamento) {
        return tombamento ? tombamento.replace('/', '') : tombamento;
    }

})();
  
(function () {
    'use strict';

    angular.module('portal').controller('BensMoveisController', BensMoveisController);

    /**
     * Controlador da página de bens móveis.
     */
    /** @ngInject */
    function BensMoveisController(dataAtualizacao, $scope, $aside, BensMoveisService) {
        var vm = this;
        vm.pesquisa = {};

        var colunas = {
            descricaoTipo: { nome: "Tipo", visible: true, termo: "Caracterização do bem" },
            descricao: { nome: "Bem", visible: true, termo: "Descrição" },
            orgao: { nome: "Órgão", visible: true, termo: "Nome do órgão associado" },
            localizacao: { nome: "Localização", visible: true, termo: "Local onde o bem se encontra" },
            estado: { nome: "Estado", visible: true, termo: "Estado de preservação do bem", center: true },
            quantidade: { nome: "Quantidade", visible: true, termo: "Quantidade", center: true },
            dataIncorporacao: { nome: "Data Incorporação", visible: true, termo: "Data de Incorporação", center: true },
            valorAtual: { nome: "Valor Atual", visible: true, termo: "Valor em que o bem se encontra avalidado", currency: true }
        };

        $scope.colunas = colunas;

        vm.settings = {
            busy: true,
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            busy: false,
            dataAtualizacao: dataAtualizacao.data
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var data = {
            url: '/v2/bens-moveis',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTplFiltro = $aside({
            scope: $scope,
            template: 'app/components/patrimonio/bens-moveis/bens-moveis-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.resetFiltros = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
            vm.search();
        };

        $scope.fecharModalColunas = function () {
            vm.search();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.item.colunas = colunas;

            var copy = angular.copy(vm.item);

            $scope.filter = copy;
            $scope.hideForm();
        };

        $scope.hideForm = function () {
            formTplFiltro.hide();
        };

        vm.showFiltroForm = function () {
            BensMoveisService.consultarConjuntoFiltros().then(function (filtros) {
                vm.pesquisa = filtros;
            });

            formTplFiltro.show();
        };

        vm.init = function () {
            vm.search();
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });
    }

})();
(function () {
    'use strict';

    angular.module('portal').service('BensMoveisService', Service);

    /**
     * Fornece serviços para consulta de dados de bens móveis.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} $q Serviço utilitário de tratamento de recursos assíncronos.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;
        _scope.store = function (data) { dataStored = data; }
        _scope.consultarOrgaos = consultarOrgaos;
        _scope.consultarEstados = consultarEstados;
        _scope.consultarTipos = consultarTipos;
        _scope.consultarConjuntoFiltros = consultarConjuntoFiltros;

        return _scope;
    }

    /**
     * Consulta o conjunto de orgãos compreendidos.
     * @returns Promise para a coleção.
     */
    function consultarOrgaos() {
        return this.$http({
            url: this.api.url + '/v2/patrimonio/bens-moveis/orgaos',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de estados compreendidos.
     * @returns Promise para a coleção.
     */
    function consultarEstados() {
        return this.$http({
            url: this.api.url + '/v2/patrimonio/bens-moveis/estados',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de tipos.
     * @returns Promise para a coleção.
     */
    function consultarTipos() {
        return this.$http({
            url: this.api.url + '/v2/patrimonio/bens-moveis/tipos',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de filtros para bens móveis.
     * @returns Promise para a coleção.
     */
    function consultarConjuntoFiltros() {
        return this.$q.all([this.consultarOrgaos(), this.consultarEstados(), this.consultarTipos()])
            .then(function (list) {
                return {
                    orgaos: list[0],
                    estados: list[1],
                    tipos: list[2]
                };
            });
    }

})();

(function () {
    'use strict';
  
    angular.module('portal').controller('BeneficiariosAcoesEmergenciaisSaibaMaisController', Controller);
  
    /** @ngInject */
    function Controller($scope, $window) {
        var vm = this;
  
        var colunas = {
            nome:{ nome: "Nome", visible:true },
            ano:{ nome:"Exercício", visible:true },
            dataReferencia:{ nome:"Data referência", visible:false, date:true }
        };
  
        $scope.colunas = colunas;
  
        vm.settings = {
            singular: 'Beneficiários Ações Emergenciais - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };
  
        vm.item = {
            page: 0,
            busy: false
        };
  
        var data = {
            url: '/prestando-contas/beneficiario/acoes-emergenciais/saiba-mais',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };
  
        vm.data = data;
  
        vm.init = function() {
            vm.search();
        };
  
        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };
    }
})();
(function () {
    'use strict';

    angular.module('portal').controller('BeneficiariosArtisticoCulturalSaibaMaisController', Controller);

    /** @ngInject */
    function Controller($scope, $window, ArquivoUrlService) {
        var vm = this;
        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        var colunas = {
            nome: { nome: "NOME", visible: true },
            ano: { nome: "EXERCÍCIO", visible: true}
        };

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Beneficiários Artístico Cultural - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };

        vm.item = {
            page: 0,
            busy: false
        };

        var data = {
            url: '/prestando-contas/beneficiario/artistico-cultural/saiba-mais',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        vm.init = function() {
            vm.search();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };
    }
})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('BeneficiarioArtisticoCulturalController', BeneficiarioArtisticoCulturalController);

    /**
     * Controlador da consulta de Beneficiários - Artístico e Cultural.
     */
    /** @ngInject */
    function BeneficiarioArtisticoCulturalController($scope, $aside, dataAtualizacao, RelatorioService,anoReferencia) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.RelatorioService = RelatorioService;
       
        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nome: { nome: "NOME", visible: true, disabled: false, termo: "Nome do beneficiário" },
            cpf: { nome: "CPF", visible: true, termo: "Pessoa Física", center: true },
            anoReferencia: { nome: "EXERCÍCIO", visible: true, termo: "Exercício", center: true },
            valorRecebido: { nome: "VALOR TOTAL BENEFÍCIO", visible: true, termo: "Valor Total Benefício",  currency: true},
          
        };

        _scope.filterModel = {
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'button',
                config: {
                    label: 'Saiba Mais',
                    title: 'Visualizar Saiba Mais',
                    icon: 'fa fa-exclamation-circle',
                    onClick: function () {
                        window.open('#/prestando-contas/beneficiario/artistico-cultural/saiba-mais', '_blank');
                    }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'select',
                label: 'Exercício',
                title: 'Exercício',
                options: anoReferencia.data,
                modelField: 'anoReferenciaFiltro'
            }, {
                type: 'text',
                label: 'Nome',
                title: 'Nome',
                required: false,
                modelField: 'nome'
            },{
                type: 'text',
                label: 'cpf',
                title: 'CPF',
                modelField: 'cpf'
            }                                      
           
        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/prestando-contas/relatorios/beneficiarios-artistico-cultural', this.filterModel);
        }
    }

})();
/*eslint-disable */
(function () {
  'use strict';

  angular.module('portal').controller('BeneficiariosBolsaAlimentacaoController', BeneficiariosBolsaAlimentacaoController);

  /**
   * Beneficiários Bolsa Alimentação Escolar
   */
  /** @ngInject */
  function BeneficiariosBolsaAlimentacaoController($scope, $aside, $location, ScopeService,RelatorioService, PrestandoContasService, dataAtualizacao,referencias, regime, nomeEscola) {
      var _scope = {};
      _scope.$scope = $scope;
      _scope.$location = $location;
      _scope.ScopeService = ScopeService;
      _scope.RelatorioService = RelatorioService;
      _scope.exportar = exportar;
      _scope.search = search;
      _scope.init = init;
      _scope.PrestandoContasService = PrestandoContasService;
      _scope.referencias = referencias;
     // _scope.escola = escola;
      _scope.buscarMesesPorExercicio = buscarMesesPorExercicio;

      _scope.formFiltroTpl = $aside({
          scope: $scope,
          template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
          show: false,
          placement: 'left',
          backdrop: true,
          animation: 'am-slide-left'
      });


      var colunas = {

        nomeResponsavel: { nome: "nome responsável", visible: true, disabled: true, termo: "Nome do Responsável pelo Aluno que tem direito ao benefício."},
        cpfResponsavel: { nome: "cpf responsável", visible: true, disabled: true, termo: "CPF do Responsável pelo Aluno que tem direito ao benefício." },
        nomeEscola: { nome: "Escola", visible: true, disabled: true,  termo: "Escola a qual o Aluno está matriculado no perído a que teve direito ao benefício."},
        tipoRegime: { nome: "Regime", visible: true, disabled: true, center:true, termo: "REGULAR - Aluno estuda em apenas um período (Matutino / Vespertino / Noturno); INTEGRAL - Aluno estuda em dois períodos."},
        mes: { nome:"mês", visible: true, disabled: true, center:true ,termo: "Mês referente ao período em que o Aluno teve direito ao benefício."},
        ano: { nome: "ano", visible: true, disabled: true , center:true , termo: "Ano referente ao período em que o Aluno teve direito ao benefício." },

        valorTotal: { nome:"valor Total", visible: true, disabled: true ,currency: true , termo: "Valor total do benefício por aluno no período de referência."}

      };

      _scope.filterModel = {
          ano: referencias.exercicios[0],
          mes: referencias.meses[0],
          colunas: colunas
      };

      $scope.init = function () {
        _scope.init();
      };
      $scope.dataAtualizacao = dataAtualizacao.data;

      $scope.tableOptions = [
          {
              type: 'button',
              config: {
                  label: 'Filtro',
                  title: 'Abrir filtros',
                  icon: 'fa fa-filter',
                  onClick: function () { _scope.formFiltroTpl.show(); }
              }
          }, {
              type: 'colunas',
              config: {
                  colunas: colunas,
                  onClose: function () { _scope.search(); }
              }
          }, {
              type: 'bs-modal',
              config: {
                  label: 'Exportar',
                  title: 'Exportar os dados no formato CSV',
                  icon: 'fa fa-download',
                  template: 'app/components/compartilhado/report-modal.html',
                  scope: { exportar: function () { _scope.exportar(); } }
              }
          }, {
              type: 'bs-aside',
              config: {
                  label: 'Compartilhar',
                  title: 'Compartilhar',
                  icon: 'fa fa-share-alt',
                  template: 'app/template/directives/share-modal.html'
              }
          }, {
              type: 'modal',
              config: {
                  label: 'Avalie o portal',
                  title: 'Avalie o portal',
                  icon: 'fa fa-comment',
                  template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
              }
          }
      ];
      $scope.filterTitle = 'Pesquisar';
      $scope.filterModel = _scope.filterModel;
      $scope.filterFields = [
        {
           type: 'select',
           label: 'Ano',
           title: 'Ano',
           required:false,
           modelField:'ano',
           options: referencias.exercicios,
           onChange: function(event, field){
             _scope.buscarMesesPorExercicio(event);
           }
        },{
            type: 'select',
            label: 'Mês',
            title: 'Mês',
            required: false,
            modelField:'mes',
            options: referencias.meses,
        },{
            type: 'text',
            label: 'Cpf',
            title: 'CPF Responsável',
            required: false,
            modelField:'cpfResponsavel'
        },{
            type: 'text',
            label: 'nome',
            title: 'Nome Responsável',
            required: false,
            modelField: 'nomeResponsavel'
        },{
            type: 'multiple-select',
            label: 'Escola',
            title: 'Escola',
            options: nomeEscola.data,
            modelField: 'nomeEscolasFiltros',
            valueProp: 'nome',
            displayProp: 'nome'
        },{
            type:'select',
            label: 'Regime',
            title:'Regime',
            required: false,
            options:regime.data,
            modelField:'tipoRegime'
        }

     ];
      $scope.filterBtns = [
          {
              type: 'submit',
              label: 'Pesquisar',
              icon: 'fa fa-search',
              callBack: function () { _scope.search(); }
          }, {
              type: 'reset',
              label: 'Limpar',
              icon: 'fa fa-eraser',
              callBack: function () {
                  $scope.filterFields.forEach(function (field) {
                      delete ($scope.filterModel[field.modelField]);
                  });
              }
          }, {
              type: 'button',
              label: 'Fechar',
              icon: 'fa fa-times',
              callBack: function () { _scope.formFiltroTpl.hide(); }
          }

      ];
      $scope.rowSelection=function(event){
             $scope.linha = event.item;
            _scope.formTplDetalhamento.show();

      }

  }

  /**
   * Inicializa a consulta.
   */
  function init() {
      this.search();
  }

  /**
   * Aciona a consulta do atual conjunto de filtros.
   */
  function search() {
      var obj = angular.copy(this.filterModel);

      this.$scope.filter = obj;
      if(!this.$scope.filter.ano){
        this.$scope.filter.ano = this.referencias.exercicios[0];
      }
      if(!this.$scope.filter.mes){
        this.$scope.filter.mes = this.referencias.meses[0];
      }

      this.formFiltroTpl.hide();
  }


  /**
   * Aciona a exportaÃ§Ã£o do atual estado da consulta.
   */
  function exportar() {
      if (this.filterModel) {
       // console.log(this.filterModel)
          this.RelatorioService.exportar('/prestando-contas/beneficiarios-bolsa-alimentacao/relatorios', this.filterModel);
      }
  }

  /**
   * Realiza o parse de um objeto Date para o formato MM/yyyy.
   */
  function _parseMonthDate(date) {
      var s = '00' + (date.getMonth() + 1);
      var month = s.substr(s.length - 2);

      return month + '/' + date.getFullYear();
  }

  function buscarMesesPorExercicio(exercicio){
    var self = this;
     this.PrestandoContasService.listarMesBeneficiariosBolsaAlimentacao(exercicio)
     .then(function (response){
       self.referencias.meses = response.data;
       self.$scope.filterFields.map(function(filterField) {
         if(filterField.modelField == 'mes') {
           filterField.options = self.referencias.meses;
         }
       })
     })
  }

})();

(function () {
    'use strict';

    angular.module('portal').controller('BeneficiariosMobilidadeCidadaSaibaMaisController', Controller);

    /** @ngInject */
    function Controller($scope, $window, ArquivoUrlService) {
        var vm = this;

        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        var colunas = {
            nome: { nome: "NOME", visible: true },
            ano: { nome: "EXERCÍCIO", visible: true}

        };

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Beneficiários Mobilidade Cidadã - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };

        vm.item = {
            page: 0,
            busy: false
        };

        var data = {
            url: '/prestando-contas/beneficiario/mobilidade-cidada/saiba-mais',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        vm.init = function() {
            vm.search();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };
    }
})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('BeneficiarioMobilidadeCidadaController', BeneficiarioMobilidadeCidadaController);

    /**
     * Controlador da consulta de Beneficiários Mobilidade Cidadã.
     */
    /** @ngInject */
    function BeneficiarioMobilidadeCidadaController($scope, $aside, dataAtualizacao,exercicios, concessoes, RelatorioService) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.RelatorioService = RelatorioService;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nome: { nome: "Nome do beneficiário", visible: true, disabled: true, termo: "Nome do beneficiário" },
            tipoPessoa: { nome: "Tipo de Pessoa", visible: true,  disabled: true, termo: "Tipo de pessoa (física/jurídica)" },
            documento: { nome: "Documento", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica do beneficiário" },
            concessao: { nome: "Concessão", visible: true, termo: "Concessão" },
            ano: { nome: "Ano", visible: true, termo: "Ano", center: true },

            valorTotal: { nome: "Valor Total Benefício", visible: true, termo: "Valor Total", currency: true }
        };

        var defaultExercicio = exercicios.data[0] ? String(exercicios.data[0]) : undefined;

        _scope.filterModel = {
            colunas: colunas,
            exercicio: defaultExercicio
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'button',
                config: {
                    label: 'Saiba Mais',
                    title: 'Visualizar Saiba Mais',
                    icon: 'fa fa-exclamation-circle',
                    onClick: function () {
                        window.open('#/prestando-contas/beneficiarios-mobilidade-cidada/saiba-mais', '_blank');
                    }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'select',
                label: 'Ano',
                title: 'Ano de referência',
                required: false,
                modelField: 'exercicio',
                options: exercicios.data
            }, {
                type: 'text',
                label: 'Nome',
                title: 'Nome do beneficiário',
                required: false,
                modelField: 'nome'
            }, {
                type: 'select',
                label: 'Concessão',
                title: 'Concessão',
                required: false,
                modelField: 'concessao',
                options: concessoes.data
            }, {
                type: 'text',
                label: 'Documento',
                title: 'Documento (CPF/CNPJ)',
                required: false,
                modelField: 'documento'
            },

        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        if (field.modelField == 'exercicio') {
                            $scope.filterModel[field.modelField] = defaultExercicio;
                        } else {
                            delete ($scope.filterModel[field.modelField]);
                        }
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/prestando-contas/relatorios/beneficiarios-mobilidade-cidada', this.filterModel);
        }
    }

})();


(function () {
    'use strict';

    angular.module('portal').controller('PratoCheioSaibaMaisController', PratoCheioSaibaMaisController);

    /** @ngInject */
    function PratoCheioSaibaMaisController($scope, $window,ArquivoUrlService) {

        var vm = this;
        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        var colunas = {
            nome: { nome: "Nome", visible: true },
            ano: { nome: "Exercício", visible: true },
            dataReferencia: { nome: "Data referência", visible: false }
        };

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Beneficiários Prato Cheio - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };

        vm.item = {
            page: 0,
            busy: false
        };

        var data = {
            url: '/prestando-contas/beneficiarios-prato-cheio/saiba-mais',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        vm.init = function () {
            vm.search();
            $scope.data = [
                {
                    nome: 'Portaria 40 de 23 de Maio de 2020',
                    ano: '2020',
                    url: 'Portaria_40_de 23_05_2020.pdf'
                }
            ]

            vm.contador = $scope.data.length;
        }

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };

        vm.voltar = function () {
            $window.location.href = '#prestando-contas/beneficiario/prato-cheio';
        };
    }
})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('BeneficiarioPratoCheioController', BeneficiarioPratoCheioController);

    /**
     * Controlador da consulta de Beneficiários - Prato Cheio.
     */
    /** @ngInject */
    function BeneficiarioPratoCheioController($scope, $aside, $window, dataAtualizacao,anosReferencia, mesesReferencia, RelatorioService) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.RelatorioService = RelatorioService;
        _scope.mesesReferencia = mesesReferencia.data;
        _scope.anosReferencia = anosReferencia.data;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nome: { nome: "Nome do beneficiário", visible: true, disabled: true, termo: "Nome do beneficiário" },
            cpf: { nome: "CPF do beneficiário", visible: true, termo: "CPF do beneficiário", center: true },
            anoReferencia: {nome: "Ano", ano: "Ano", visible: true, termo: "Ano", center: true },
            mesReferencia: { nome: "Mês", visible: true, termo: "Mês de referência", center: true },
            valorRecebido: { nome: "Valor recebido", visible: true, currency: true, termo: "Valor recebido" }
            

       
        };

        _scope.filterModel = {
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'button',
                config: {
                    label: 'Saiba Mais',
                    title: 'Visualizar Saiba Mais',
                    icon: 'fa fa-exclamation-circle',
                    onClick: function () { $window.location.href = '#/prestando-contas/beneficiario/prato-cheio/saiba-mais'; }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {                                    
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'select',
                label: 'Ano',
                title: 'Ano',
                required: false,
                modelField: 'anoReferencia',
                options: anosReferencia.data,
            },
            {
                type: 'select',
                label: 'Mês',
                title: 'Mês de referência',
                required: false,
                modelField: 'mesReferencia',
                options: mesesReferencia.data
            }, {
                type: 'text',
                label: 'Nome',
                title: 'Nome do beneficiário',
                required: false,
                modelField: 'nome'
            }, {
                type: 'text',
                label: 'CPF',
                title: 'CPF do beneficiário',
                required: false,
                modelField: 'cpf'
            }
        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.filterModel.anoReferencia = this.anosReferencia[0];
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        if (this.filterModel.mes) {
            obj.mes = _parseMonthDate(this.filterModel.mes);
        }

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/prestando-contas/relatorios/beneficiarios-prato-cheio', this.filterModel);
        }
    }

    /**
     * Realiza o parse de um objeto Date para o formato MM/yyyy.
     */
    function _parseMonthDate(date) {
        var s = '00' + (date.getMonth() + 1);
        var month = s.substr(s.length - 2);

        return month + '/' + date.getFullYear();
    }

})();

(function () {
  'use strict';

  angular.module('portal').controller('BeneficiarioProSocController', BeneficiarioProSocController);

  /** @ngInject */
  function BeneficiarioProSocController($scope, $aside, $alert, $location, PagingService, RelatorioService, ultimoAnoMes, anos, dataAtualizacao, listarProgramas) {

    var vm = this;

    vm.anos = anos.data;
    vm.ultimoAnoMes = ultimoAnoMes.data;
    vm.dataAtualizacao = dataAtualizacao;
    vm.listaCodigoPrograma = listarProgramas.data;


    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var colunas = {
      nome: {nome: "Nome do Beneficiário", visible: true, destacado: true, termo:"Nome do responsável pela unidade familiar (RF), a quem é disponibilizado o benefício."},
      nrNis: {nome: "NIS", visible: true, termo:"Número de Identificação Social"},
      anoMes: {nome: "Referência", visible: true, filter: {name: 'mesAno'}, date: true , termo:"Período referente ao benefício concedido."},
      nomePrograma: {nome: "Programa Social", visible: true, filter: {name: 'listaCodigoPrograma'}, termo:"Nome do Programa Social"},
      valorTotal: {nome: "Valor", visible: true, currency: true, termo:"Valor do programa disponibilizado para o beneficiário."}
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Beneficiário',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo: 'csv',
      busy: false,
      anoMes: vm.ultimoAnoMes,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/prestando-contas/beneficiario/programa-social',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/beneficiarios-programas-sociais/beneficiarios-programas-sociais-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function () {
      reset();
      vm.data.form.anoMes = ultimoAnoMes.data;
      var primeiroFiltro = new Date(Math.floor(ultimoAnoMes.data / 100), Math.floor(ultimoAnoMes.data % 100) - 1);
      vm.tituloFiltro = monthArray[primeiroFiltro.getMonth()] + "/" + primeiroFiltro.getFullYear();


      var params = $location.search();

      if (params['mes'] != undefined && params['ano'] != undefined) {
        var date = new Date();
        date.setMonth(Number(params['mes']) - 1);
        date.setFullYear(Number(params['ano']));
        vm.item.dataInicio = vm.item.dataFim = date;
        vm.data.form.anoMes = null;
      }

      // Leitura de parâmetros em url
      vm.assignProps([{from:'nome', to:'nome', type:String}], params, vm.item);


      $scope.filter = angular.copy(vm.item);
    }

    vm.cancelar = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    vm.exibirFormPesquisa = function () {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    var search = function () {
      if (invalidInterval()) return;

      reset();

      if (vm.item.dataInicio && vm.item.dataFim) {
        vm.tituloFiltro = monthArray[vm.item.dataInicio.getMonth()] + "/" + vm.item.dataInicio.getFullYear() +
          " - " + monthArray[vm.item.dataFim.getMonth()] + "/" + vm.item.dataFim.getFullYear();
        vm.data.form.anoMes = null;
      }else{
        vm.tituloFiltro = null;
        vm.data.form.anoMes = null;
      }


      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    vm.assignProps = function(propsArray, fromObj, toObj) {
      propsArray.forEach(function(prop) {
        if (fromObj[prop.from] != undefined) {
          if (prop.type == Number) {
            toObj[prop.to] = Number(fromObj[prop.from]);
          } else if (prop.type == String) {
            toObj[prop.to] = String(fromObj[prop.from]);
          }
        }
      });
    };

    vm.search = search;

    var invalidInterval = function () {
      if (vm.item.dataFim < vm.item.dataInicio) {
        $alert({
          content: 'A data final não pode ser antes da data inicial.',
          type: 'info'
        });
        return true;
      } else {
        return false;
      }
    }

    var reset = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/prestando-contas/relatorio/beneficiario/programa-social', vm.item);
      }
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function () {
      formTpl.hide();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

    var monthArray = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('BeneficiarioProSocLegislacaoController', BeneficiarioProSocLegislacaoController);

  /** @ngInject */
  function BeneficiarioProSocLegislacaoController($scope, $window, dataAtualizacao, ArquivoUrlService) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao.data;

    vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

    var colunas = {
      nome:{ nome: "Nome", visible:true, destacado: true },
      ano:{ nome:"Exercício", visible:true },
      dataReferencia:{ nome:"Data referência", visible:false,date:true  }
    };

    var acoesTabela = [
      {
          type: 'link',
          title: 'Baixar arquivo',
          label: '',
          target: '_blank',
          iconClassname: 'md md-get-app',
          columnName: '',
          className: 'margin_right',
          align: 'right',
          buildHref: function(item) {
            return 'https://www.transparencia.df.gov.br' + vm.urlArquivos + item.url;
          },
          isVisible: function() {
              return true;
          }
      }
    ];

    $scope.onRowDoubleClick = function(item) {
      window.open('https://www.transparencia.df.gov.br' + vm.urlArquivos + item.url, '_blank');
    };
    $scope.acoes = acoesTabela;
    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Beneficiários de Programas ​Sociais - Legislação​',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
      page: 0,
      busy: false
    };

    var data = {
      url: '/prestando-contas/beneficiario/programa-social/legislacao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    vm.init = function () {
      vm.search();
    }

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.voltar = function(){
      $window.location.href = '#/prestando-contas/beneficiario/programas-sociais';
    };
  }
})();



(function () {
    'use strict';

    angular.module('portal').controller('RendaEmergencialSaibaMaisController', RendaEmergencialSaibaMaisController);

    /** @ngInject */
    function RendaEmergencialSaibaMaisController($scope, $window, ArquivoUrlService) {

        var vm = this;
        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        var colunas = {
            nome: { nome: "Nome", visible: true },
            ano: { nome: "Exercício", visible: true },
            dataReferencia: { nome: "Data referência", visible: false }
        };

        $scope.colunas = colunas;

        vm.settings = {
            singular: 'Beneficiários Renda Emergencial - Saiba Mais​',
            plural: '',
            busy: true,
            cmd: ''
        };

        vm.item = {
            page: 0,
            busy: false
        };

        var data = {
            url: '/prestando-contas/beneficiarios-auxilio-emergencial/saiba-mais',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        vm.init = function () {
            vm.search();
            $scope.data = [
                {
                    nome: 'Lei 6573 de 08 de Maio de 2020',
                    ano: '2020',
                    url: 'Lei_6573_de_08_05_2020.pdf'
                }
            ]

            vm.contador = $scope.data.length;
        }

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            $scope.filter = angular.copy(vm.item);
        };

        vm.voltar = function () {
            $window.location.href = '#prestando-contas/beneficiario/renda-emergencial';
        };
    }
})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('BeneficiarioRendaEmergController', BeneficiarioRendaEmergController);

    /**
     * Controlador da consulta de Beneficiários - Renda Emergencial.
     */
    /** @ngInject */
    function BeneficiarioRendaEmergController($scope, $aside, $window, dataAtualizacao, mesesReferencia, RelatorioService) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.RelatorioService = RelatorioService;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var colunas = {
            nome: { nome: "Nome do beneficiário", visible: true, disabled: true, termo: "Nome do beneficiário" },
            cpf: { nome: "CPF do beneficiário", visible: true, termo: "CPF do beneficiário", center: true },
            mesReferencia: { nome: "Mês", visible: true, termo: "Mês de referência", center: true },
            valorRecebido: { nome: "Valor recebido", visible: true, currency: true, termo: "Valor recebido" }
        };

        _scope.filterModel = {
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'button',
                config: {
                    label: 'Saiba Mais',
                    title: 'Visualizar Saiba Mais',
                    icon: 'fa fa-exclamation-circle',
                    onClick: function () { $window.location.href = '#/prestando-contas/beneficiario/renda-emergencial/saiba-mais'; }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
                type: 'select',
                label: 'Mês',
                title: 'Mês de referência',
                required: false,
                modelField: 'mesReferencia',
                options: mesesReferencia.data
            }, {
                type: 'text',
                label: 'Nome',
                title: 'Nome do beneficiário',
                required: false,
                modelField: 'nome'
            }, {
                type: 'text',
                label: 'CPF',
                title: 'CPF do beneficiário',
                required: false,
                modelField: 'cpf'
            }
        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }
        ];
    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        if (this.filterModel.mes) {
            obj.mes = _parseMonthDate(this.filterModel.mes);
        }

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/prestando-contas/relatorios/beneficiarios-auxilio-emergencial', this.filterModel);
        }
    }

    /**
     * Realiza o parse de um objeto Date para o formato MM/yyyy.
     */
    function _parseMonthDate(date) {
        var s = '00' + (date.getMonth() + 1);
        var month = s.substr(s.length - 2);

        return month + '/' + date.getFullYear();
    }

})();

(function(){
  'use strict';

  angular.module('portal').controller('BeneficiarioCartaoMatEscController', BeneficiarioCartaoMatEscController);

  /** @ngInject */
  function BeneficiarioCartaoMatEscController($scope, $aside, anos, PagingService, RelatorioService, dataAtualizacao, PrestandoContasService) {

    var vm = this;

    vm.PrestandoContasService = PrestandoContasService;

    vm.anos = anos.data;
    vm.dataAtualizacao = dataAtualizacao;

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    var colunas = {
      nomeResponsavel: { nome: "Nome do Responsável", visible: true, termo: "Nome completo do responsável pelo(s) aluno(s) cadastrado(s) no programa" },
      cpfResponsavel: { nome: "CPF do Responsável", visible: true, termo: "CPF do responsável pelo(s) aluno(s) cadastrado(s) no programa", center: true },
      exercicio: { nome: "Ano", visible: true, termo: "Ano de referência do benefício", center: true },
      nomeEscola: { nome: "Regional", visible: true, termo: "Regional de Ensino Referente à Escola em que o(s) aluno(s) está(ão) matriculado(s)" },
      serie:{ nome: "Lote", termo:"Número do lote em que foi realizado o pagamento do benefício", visible:true, disabled: false},
      valor: { nome: "Valor do Benefício em R$", visible: true, currency: true, termo: "Valor correspondente ao benefício" }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Beneficiário',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo: 'csv',
      busy: false,
      exercicio: vm.anos[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/prestando-contas/beneficiario/cartao',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/cartao-material-escolar/beneficiarios-cartao-material-escolar-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.init = function() {
      vm.search();
      vm.verificaExercicio(vm.item.exercicio);

      if (vm.item.exercicio >= 2024) {
        vm.carregarLotes();
      } else {
        vm.lotes = [];
      }
    };

    vm.carregarLotes = function() {
      vm.PrestandoContasService.listarLoteCartaoMaterialEscolar()
          .then(function(response) {
              vm.lotes = response.data;
          })
          .catch(function(error) {
              console.error('Erro ao buscar os lotes:', error);
          });
    };

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){
      if (linha) {
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    vm.exibirFormPesquisa = function() {
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.search = function() {
      vm.data.content = [];
      vm.data.form.page = 0;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.exercicio;
      vm.verificaExercicio(vm.item.exercicio);
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    vm.verificaExercicio = function(exercicio) {
      if (exercicio >= 2024) {
        colunas.nomeEscola.nome = 'Regional';
        colunas.nomeEscola.termo = 'Regional de Ensino referente à escola que o aluno está matriculado';
      } else {
        colunas.nomeEscola.nome = 'Regional';
        colunas.nomeEscola.termo = 'Regional de Ensino Referente à Escola em que o(s) aluno(s) está(ão) matriculado(s)';
      } if (exercicio >= 2024){
        colunas.serie.visible = true;
      } else {
        colunas.serie.visible =  false;
      } if (exercicio >= 2024){
        colunas.serie.disabled = false;
      } else {
        colunas.serie.disabled = true;
      }
    };

    $scope.exportar = function() {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/prestando-contas/relatorio/beneficiario/cartao', vm.item);
      }
    };

    var showForm = function() {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function() {
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });

  }

})();

(function () {
  'use strict';

  angular.module('portal').controller('BeneficiarioCartaoMatEscSaibaMaisController', BeneficiarioCartaoMatEscSaibaMaisController);

  /** @ngInject */
  function BeneficiarioCartaoMatEscSaibaMaisController($scope, $window, dataAtualizacao) {

    var vm = this;

    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nome: {nome: "Nome", visible: true},
  };

    $scope.colunas = colunas;

    vm.settings = {
      singular: 'Beneficiários do Cartão Material Escolar - Arquivos',
      plural: '',
      busy: true,
      cmd: ''
    };

    vm.item = {
      page: 0,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    var data = {
      url: '/prestando-contas/beneficiario/cartao/saiba-mais',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };

    vm.data = data;

    vm.init = function () {
      vm.search();
    }

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      $scope.filter = angular.copy(vm.item);
    };

    vm.voltar = function(){
      $window.location.href = '/#/prestando-contas/beneficiario/cartao-material-escolar';
    };

  }
})();


/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('EmpresaProgramaIntegridadeController', EmpresaProgramaIntegridadeController);

    /**
     * Empresa programa integridade.
     */
    /** @ngInject */
    function EmpresaProgramaIntegridadeController($scope, $aside, $location, ScopeService,RelatorioService, dataAtualizacao, situacoes, orgaoContratante, anoDataApresentacao, mesDataApresentacao,
        anoDataAvaliacao, mesDataAvaliacao) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.ScopeService = ScopeService;
        _scope.RelatorioService = RelatorioService;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        _scope.formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/prestando-contas/empresas-programa-integridade/empresa-programa-integridade-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
          });

        var colunas = {
            nomeEmpresa: { nome: "Empresa", visible: true, disabled: true, termo: "Nome da Empresa Contratada." },
            nomeFantasia: { nome: "Nome Fantasia", visible: true, termo: "Nome de Fachada, é o nome comercial ou popular da empresa." },
            nomeRazaoSocial: { nome: "Razão Social", visible: false, center: true, termo: "Denominação social, nome empresarial ou firma." },
            numeroCNPJ: { nome: "Cnpj / Vat", visible: true, center: true, termo: "Cadastro Nacional de Pessoa Jurídica (CNPJ) ou Identificador Internacional de Pessoa Jurídica (VAT)."},
            contratoAditivo: { nome: "Contrato / Termo Aditivo", visible: false, center: true, termo: "Exibe o número do contrato / Termo aditivo." },
            dataApresentacao: { nome: "Data de apresentação do programa",visible: false, center: true, date:true,termo: "Data em que a documentação da empresa foi encaminhada a CGDF pelo Órgão Contratante." },
            nomeOrgaoContratante: { nome: "Órgão Contratante", visible: true, termo: "Órgão do GDF que encaminhou o contrato com os documentos do Programa de Integridade da empresa." },
            dataAvaliacao: { nome: "Data da Decisão", visible: false, date:true, center:true, termo: "Data de aprovação do Relatório Circunstanciado" },
            legislacaoAplicada: { nome: "Legislação aplicada", visible: false, center: true, termo: "Norma que regula a análise do programa." },
            portariaAplicada: { nome: "Portaria Aplicada", visible: true, center: true, termo: "Número da portaria aplicada." },
            publicacaoDODF: { nome: "Publicação DODF", visible: true, center: true, termo: "Número do DODF e data da publicação." },
            resultado: { nome: "Resultado", visible: true, center: true, termo: "Se a empresa cumpriu ás exigências referidas na Legislação Aplicada." },
            
        };

        _scope.filterModel = {
           // anoExercicio: String(anos[0]),
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Saiba Mais',
                    title: 'Acesso às legislações correlatas',
                    icon: 'fa fa-exclamation-circle',
                    template: 'app/components/prestando-contas/empresas-programa-integridade/saiba-mais-modal.html'
                    
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [

            {
                type: 'text',
                label: 'Empresa',
                title: 'Empresa',
                required: false,
                modelField: 'nomeEmpresa'
            }, {
                type: 'text',
                label: 'Nome Fantasia',
                title: 'Nome Fantasia',
                modelField: 'nomeFantasia'
            }, {
                type: 'text',
                label: 'Cnpj / Vat',
                title: 'CNPJ / VAT',
                modelField: 'numeroCNPJ'
            },{
                type: 'text',
                label: 'Contrato / Termo Aditivo',
                title: 'Contrato / Termo Aditivo',
                modelField: 'contratoAditivo'
            },
             {
                type: 'multiple-select',
                label: 'Órgão Contratante',
                title: 'Órgão Contratante',
                options:orgaoContratante.data,
                modelField: 'orgaoContratanteFiltros',
                valueProp: 'nome',
                displayProp: 'nome'

            }, {
                type: 'select',
                label: 'resultado',
                title: 'resultado',
                options: situacoes.data,
                modelField: 'resultado'
            },{
                type: 'text',
                label: 'legislação aplicada',
                title: 'Legislação aplicada',
                modelField: 'legislacaoAplicada'
            },{
                type: 'text',
                label: 'portaria aplicada',
                title: 'Portaria aplicada',
                modelField: 'portariaAplicada'
            },{
                type: 'text',
                label: 'publicação dodf',
                title: 'Publicação DODF',
                modelField: 'publicacaoDODF'
            },{
                type: 'select',
                label: 'Ano de Apresentação',
                title: 'Ano de Apresentação',
                options: anoDataApresentacao.data,
                modelField: 'anoApresentacaoFiltro'
            },{
                type: 'select',
                label: 'Mês de Apresentação',
                title: 'Mês de Apresentação',
                options: mesDataApresentacao.data,
                modelField: 'mesApresentacaoFiltro'
            },{
                type: 'select',
                label: 'Ano de Avaliação',
                title: 'Ano de Avaliação',
                options: anoDataAvaliacao.data,
                modelField: 'anoAvaliacaoFiltro'
            },{
                type: 'select',
                label: 'Mês de Avaliação',
                title: 'Mês de Avaliação',
                options: mesDataAvaliacao.data,
                modelField: 'mesAvaliacaoFiltro'
            }

        ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }

        ];
        $scope.rowSelection=function(event){
               $scope.linha = event.item;
              _scope.formTplDetalhamento.show();

        }

    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        if (this.filterModel.mes) {
            obj.mes = _parseMonthDate(this.filterModel.mes);
        }

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }


    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/prestando-contas/empresas-programa-integridade/relatorios', this.filterModel);
        }
    }

    /**
     * Realiza o parse de um objeto Date para o formato MM/yyyy.
     */
    function _parseMonthDate(date) {
        var s = '00' + (date.getMonth() + 1);
        var month = s.substr(s.length - 2);

        return month + '/' + date.getFullYear();
    }

})();

(function(){
    'use strict';

    angular.module('portal').controller("OrganizacoesSociaisSaudeController",Controller);

    function Controller($scope, $aside, listaDatasReferencia, dataAtualizacao, anos, nomes, relatorios, formTemplate, ArquivoUrlService) {

        var vm = this;

        vm.anos = anos.data;
        vm.meses = listaDatasReferencia.data;
        vm.dataAtualizacao = dataAtualizacao;
        vm.nomes = nomes.data;
        vm.relatorios = relatorios.data;

        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;
        //vm.anos = [];
        /*for (var i = new Date().getFullYear(); i >= 2007; i--) {
            vm.anos.push(i);
        }*/

        var colunas = {
            //nomeCategoria:{nome:"Assunto",visible:true},
            nome:{ nome: "Nome", visible:true, termo:"Especificação do relatório correspondente à cada assunto " },
            dsRelatorio:{ nome: "Relatório", visible:true, termo:"Descrição do Relatório" },
            ano:{ nome:"Exercício", visible:true, termo:"Ano de referência do relatório", center: true },
            dataReferencia:{ nome:"Referência", visible:true, termo:"Período de referência do relatório", center: true},
            descricao:{nome:"Observação", visible:true, termo:"Informações adicionais correspondentes à cada assunto "},
            fonte:{nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação"},
            dataCarga:{nome:"Publicação", visible:true, date:true, termo:"Data da publicação do documento no Portal"}
        };

        $scope.colunas = colunas;

        $scope.settings = {
            singular: 'Relatório',
            plural: 'Relatórios',
            busy: true,
            cmd: 'Pesquisar',
            colunas: colunas
        };

        vm.item = {
            editing: true,
            page: 0,
            busy: false,
            ano: vm.anos[0],
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };
        var formTpl = $aside({
            scope: $scope,
            template: formTemplate,
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var data = {
            url: '/prestando-contas/organizacoes-sociais-saude',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        $scope.cancelar = function() {
            vm.data.form = null;
            vm.item = {
            editing: true,
            page: 0
            };
        };

        vm.exibirFormPesquisa = function(){
            vm.item.icon = 'md-search';
            vm.item.editing = true;
            $scope.settings.cmd = 'Pesquisar';
            showForm();
        };

        vm.init = function() {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.anos[0];
            $scope.search();
        };

        var showForm = function(){
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.search = function() {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.tituloFiltro = vm.item.ano;
            $scope.filter = angular.copy(vm.item);
            formTpl.hide();
        };

        $scope.$watch('vm.item.codigoCategoria', function(){
            if (vm.item.codigoCategoria) {
            vm.item.dataReferencia = [];
            listaDatasReferencia(vm.item.codigoCategoria).success(function(response){
                vm.datasReferencias = response;
            });
            }else{
            vm.item.dataReferencia = [];
            }
        });

        var hideForm = function(){
            formTpl.hide();
        };

        $scope.$on('$destroy', function() {
            hideForm();
        });

    }

  })();

(function () {
    'use strict';

    angular.module('portal').controller('PADsController', PADsController);

    /**
     * Controlador da página de consulta a PADs.
     */
    /** @ngInject */
    function PADsController(PADsService, $aside, $scope, dataAtualizacao, RelatorioService) {
        var vm = this;
        var modalStack = [];
        vm.pesquisa = {};
        vm.detalhamento = {
            processo: null,
            acoes: [],
            fases: []
        };

        var colunas = {
            numero: { nome: "Nº do Processo", visible: true, termo: "Número do processo SEI", center: true },
            dataInstauracao: { nome: "Instauração", visible: true, termo: "Data do início do procedimento", center: true },
            tipoProcesso: { nome: "Tipo Processo", visible: true },
            orgao: { nome: "Órgão", visible: true, termo: "Órgão de origem do Processo Administrativo Disciplinar" },
            fase: { nome: "Fase", visible: true, termo: "Fase atual do processo", center: true },
            ultimoAto: { nome: "Último Ato", visible: true, termo: "Último ato registrado no processo", center: true },
            dataAutuacao: { nome: "Data", visible: true, termo: "Data do último ato registrado no processo", center: true }
        };

        $scope.colunas = colunas;

        vm.settings = {
            busy: true,
            colunas: colunas
        };

        vm.item = {
            tipo: 'csv',
            page: 0,
            busy: false,
            dataAtualizacao: dataAtualizacao
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var data = {
            url: '/prestando-contas/processos-administrativos-disciplinares',
            form: vm.item,
            settings: vm.settings,
            content: [],
            totalElements: 0,
            last: true
        };

        vm.data = data;

        var formTplFiltro = $aside({
            scope: $scope,
            template: 'app/components/prestando-contas/pads/pads-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/prestando-contas/pads/pads-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        var formTplDetalhamentoFases = $aside({
            scope: $scope,
            template: 'app/components/prestando-contas/pads/pads-detalhamento-fases.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        $scope.hideForm = function () {
            formTplFiltro.hide();
            formTplDetalhamento.hide();
        };

        vm.search = function () {
            vm.data.content = [];
            vm.item.page = 0;
            vm.item.padrao = false;
            vm.data.form = vm.item;
            vm.item.colunas = colunas;

            var copy = angular.copy(vm.item);

            window['VM'] = vm;

            $scope.filter = copy;
            $scope.hideForm();
        };

        vm.resetFiltros = function () {
            vm.data.form = null;
            vm.item = {
                editing: true,
                page: 0
            };
            vm.search();
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = vm.settings.colunas;
                vm.item.tipo = $scope.dados.form.tipo;
            }
            RelatorioService.exportar(
                '/prestando-contas/processos-administrativos-disciplinares/relatorios',
                vm.item
            );
        };

        function showForm(form) {
            if (modalStack.length > 0) {
                modalStack[modalStack.length - 1].hide();
            }

            angular.element('.tooltip').remove();
            form.show();

            modalStack.push(form);
        }

        vm.voltar = function () {
            if (modalStack.length > 0) {
                var previous = null;

                if (modalStack.length > 1) {
                    previous = modalStack[modalStack.length - 2];
                }

                modalStack[modalStack.length - 1].hide();
                modalStack.splice(modalStack.length > 1 ? modalStack.length - 2 : modalStack.length - 1, 2);

                if (previous != null) {
                    showForm(previous);
                }
            }
        };

        vm.closeAll = function () {
            if (modalStack.length) {
                modalStack[modalStack.length - 1].hide();
            }

            modalStack.splice(0, modalStack.length);
        };

        function carregarFiltros() {
            PADsService.consultarConjuntoFiltros().then(function (filtros) {
                vm.pesquisa = filtros;
            });
        }

        vm.exibirFormPesquisa = function () {
            carregarFiltros();
            showForm(formTplFiltro);
        };

        vm.visualizarItem = function (processo) {
            if (processo) {
                vm.detalhamento.processo = processo;

                PADsService.detalharAcoes(processo).then(function (resp) {
                    vm.detalhamento.acoes = resp;

                    showForm(formTplDetalhamento);
                });
            }
        };

        vm.detalharFases = function (processo) {
            if (processo) {
                vm.detalhamento.processo = processo;
                vm.detalhamento.fases = [];

                PADsService.detalharFases(processo).then(function (resp) {
                    vm.detalhamento.fases = resp;
                    showForm(formTplDetalhamentoFases);
                });
            }
        };

        vm.init = function () {
            vm.search();
        };
    }

})();
(function () {
    'use strict';

    angular.module('portal').service('PADsService', PADsService);

    /**
     * Fornece serviços para a funcionalidade de consulta a processos administrativos disciplinares.
     */
    function PADsService($http, $q, api) {
        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.detalharFases = detalharFases;
        _scope.detalharAcoes = detalharAcoes;
        _scope.buscarDataAtualizacao = buscarDataAtualizacao;
        _scope.consultarConjuntoFiltros = consultarConjuntoFiltros;
        _scope.consultarTipos = consultarTipos;
        _scope.consultarOrgaos = consultarOrgaos;
        _scope.consultarFases = consultarFases;
        _scope.api = api;

        return _scope;
    }

    /**
     * Detalha das ações de um processo.
     */
    function detalharAcoes(processo) {
        return this.$http({
            url: this.api.url + '/prestando-contas/processos-administrativos-disciplinares/' + processo.codigoDocumento + '/acoes',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Detalha as fases de um processo.
     */
    function detalharFases(processo) {
        return this.$http({
            url: this.api.url + '/prestando-contas/processos-administrativos-disciplinares/' + processo.codigoDocumento + '/fases',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Obtem a data de atualização da base de dados.
     */
    function buscarDataAtualizacao() {
        return this.$http({
            url: this.api.url + '/dataAtualizacao/processos-administrativos-disciplinares',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de tipos.
     * @returns Promise para a coleção.
     */
    function consultarTipos() {
        return this.$http({
            url: this.api.url + '/prestando-contas/processos-administrativos-disciplinares/tipos',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de orgões.
     * @returns Promise para a coleção.
     */
    function consultarOrgaos() {
        return this.$http({
            url: this.api.url + '/prestando-contas/processos-administrativos-disciplinares/orgaos',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de fases.
     * @returns Promise para a coleção.
     */
    function consultarFases() {
        return this.$http({
            url: this.api.url + '/prestando-contas/processos-administrativos-disciplinares/fases',
            method: 'GET',
            cache: false
        }).then(function (resp) {
            return resp.data;
        });
    }

    /**
     * Consulta o conjunto de filtros para processos administrativos disciplinares.
     * @returns Promise para a coleção.
     */
    function consultarConjuntoFiltros() {
        return this.$q.all([this.consultarTipos(), this.consultarOrgaos(), this.consultarFases()])
            .then(function (list) {
                return {
                    tipos: list[0],
                    orgaos: list[1],
                    fases: list[2]
                };
            });
    }

})();
/* eslint-disable angular/controller-as */
(function () {
  "use strict";

  angular.module("portal").controller("PIPsController", PIPsController);

  /**
   * Controlador da página de consulta a PIPs.
   */
  /** @ngInject */
  function PIPsController(PIPsService, dataAtualizacao, $aside, $scope, RelatorioService) {
    var vm = this;
    var modalStack = [];
    vm.pesquisa = {};
    vm.detalhamento = {
      processo: null,
      acoes: [],
      fases: [],
    };

    var colunas = {
      numero: { nome: "Nº do Processo", visible: true, termo: "Número do processo SEI", center: true },
      dataDistribuicao: { nome: "Instauração", visible: true, termo: "Data do início do procedimento", center: true },
      tipoProcesso: { nome: "Tipo Processo", visible: true },
      orgao: { nome: "Órgão", visible: true, termo: "Órgão de origem do Processo Administrativo Disciplinar" },
      fase: { nome: "Fase", visible: true, termo: "Fase atual do processo", center: true },
      ultimoAto: { nome: "Último Ato", visible: true, termo: "Último ato registrado no processo", center: true },
      dataAutuacao: { nome: "Data", visible: true, termo: "Data do último ato registrado no processo", center: true },
    };

    $scope.colunas = colunas;

    vm.settings = {
      busy: true,
      colunas: colunas,
    };

    vm.item = {
      tipo: "csv",
      page: 0,
      busy: false,
      dataAtualizacao: dataAtualizacao,
    };

    $scope.dados = {
      form: {
        tipo: "csv",
      },
    };

    var data = {
      url: "/prestando-contas/processos-investigacoes-preliminares",
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true,
    };

    vm.data = data;

    var formTplFiltro = $aside({
      scope: $scope,
      template: "app/components/prestando-contas/pips/pips-filtro.html",
      show: false,
      placement: "left",
      backdrop: true,
      animation: "am-slide-left",
    });

    var formTplDetalhamento = $aside({
      scope: $scope,
      template: "app/components/prestando-contas/pips/pips-detalhamento.html",
      show: false,
      placement: "left",
      backdrop: true,
      animation: "am-slide-left",
    });

    var formTplDetalhamentoFases = $aside({
      scope: $scope,
      template:
        "app/components/prestando-contas/pips/pips-detalhamento-fases.html",
      show: false,
      placement: "left",
      backdrop: true,
      animation: "am-slide-left",
    });

    $scope.hideForm = function () {
      formTplFiltro.hide();
      formTplDetalhamento.hide();
    };

    vm.search = function () {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.item.colunas = colunas;

      var copy = angular.copy(vm.item);

      window["VM"] = vm;

      $scope.filter = copy;
      $scope.hideForm();
    };

    vm.resetFiltros = function () {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0,
      };
      vm.search();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
      }
      RelatorioService.exportar(
        "/prestando-contas/processos-investigacoes-preliminares/relatorios",
        vm.item
      );
    };

    function showForm(form) {
      if (modalStack.length > 0) {
        modalStack[modalStack.length - 1].hide();
      }

      angular.element(".tooltip").remove();
      form.show();

      modalStack.push(form);
    }

    vm.voltar = function () {
      if (modalStack.length > 0) {
        var previous = null;

        if (modalStack.length > 1) {
          previous = modalStack[modalStack.length - 2];
        }

        modalStack[modalStack.length - 1].hide();
        modalStack.splice(
          modalStack.length > 1 ? modalStack.length - 2 : modalStack.length - 1,
          2
        );

        if (previous != null) {
          showForm(previous);
        }
      }
    };

    vm.closeAll = function () {
      if (modalStack.length) {
        modalStack[modalStack.length - 1].hide();
      }

      modalStack.splice(0, modalStack.length);
    };

    function carregarFiltros() {
      PIPsService.consultarConjuntoFiltros().then(function (filtros) {
        vm.pesquisa = filtros;
      });
    }

    vm.exibirFormPesquisa = function () {
      carregarFiltros();
      showForm(formTplFiltro);
    };

    vm.visualizarItem = function (processo) {
      if (processo) {
        vm.detalhamento.processo = processo;

        PIPsService.detalharAcoes(processo).then(function (resp) {
          vm.detalhamento.acoes = resp;

          showForm(formTplDetalhamento);
        });
      }
    };

    vm.detalharFases = function (processo) {
      if (processo) {
        vm.detalhamento.processo = processo;
        vm.detalhamento.fases = [];

        PIPsService.detalharFases(processo).then(function (resp) {
          vm.detalhamento.fases = resp;
          showForm(formTplDetalhamentoFases);
        });
      }
    };

    vm.init = function () {
      vm.search();
    };
  }
})();

(function () {
  'use strict';

  angular.module('portal').service('PIPsService', PIPsService);

  /**
   * Fornece serviços para a funcionalidade de consulta a processos administrativos disciplinares.
   */
  function PIPsService($http, $q, api) {
    var _scope = {};

    _scope.$http = $http;
    _scope.$q = $q;
    _scope.detalharFases = detalharFases;
    _scope.detalharAcoes = detalharAcoes;
    _scope.buscarDataAtualizacao = buscarDataAtualizacao;
    _scope.consultarConjuntoFiltros = consultarConjuntoFiltros;
    _scope.consultarTipos = consultarTipos;
    _scope.consultarOrgaos = consultarOrgaos;
    _scope.consultarFases = consultarFases;
    _scope.api = api;

    return _scope;
  }

  /**
   * Detalha das ações de um processo.
   */
  function detalharAcoes(processo) {
    return this.$http({
      url: this.api.url + '/prestando-contas/processos-investigacoes-preliminares/' + processo.codigoDocumento + '/acoes',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  /**
   * Detalha as fases de um processo.
   */
  function detalharFases(processo) {
    return this.$http({
      url: this.api.url + '/prestando-contas/processos-investigacoes-preliminares/' + processo.codigoDocumento + '/fases',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  // /**
  //  * Obtem a data de atualização da base de dados.
  //  */
  function buscarDataAtualizacao() {
    return this.$http({
      url: this.api.url + '/dataAtualizacao/processos-investigacoes-preliminares',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  /**
   * Consulta o conjunto de tipos.
   * @returns Promise para a coleção.
   */
  function consultarTipos() {
    return this.$http({
      url: this.api.url + '/prestando-contas/processos-investigacoes-preliminares/tipos',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  /**
   * Consulta o conjunto de orgões.
   * @returns Promise para a coleção.
   */
  function consultarOrgaos() {
    return this.$http({
      url: this.api.url + '/prestando-contas/processos-investigacoes-preliminares/orgaos',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  /**
   * Consulta o conjunto de fases.
   * @returns Promise para a coleção.
   */
  function consultarFases() {
    return this.$http({
      url: this.api.url + '/prestando-contas/processos-investigacoes-preliminares/fases',
      method: 'GET',
      cache: false
    }).then(function (resp) {
      return resp.data;
    });
  }

  /**
   * Consulta o conjunto de filtros para processos administrativos disciplinares.
   * @returns Promise para a coleção.
   */
  function consultarConjuntoFiltros() {
    return this.$q.all([this.consultarTipos(), this.consultarOrgaos(), this.consultarFases()])
      .then(function (list) {
        return {
          tipos: list[0],
          orgaos: list[1],
          fases: list[2]
        };
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("portal")
    .controller("ProsperaDfController", ProsperaDfController);

  /** @ngInject */
  function ProsperaDfController($scope, $aside, $location, ScopeService, RelatorioService, dataAtualizacao, exercicio,
    personalidade, regiao, carteira, comite, porte, novoRenovacao, modalidade, subatividade, atividade ) {
    var _scope = {};
    _scope.$scope = $scope;
    _scope.$location = $location;
    _scope.ScopeService = ScopeService;
    _scope.RelatorioService = RelatorioService;
    _scope.exportar = exportar;
    _scope.search = search;
    _scope.init = init;

    _scope.formFiltroTpl = $aside({
      scope: $scope,
      template:
        "app/template/directives/form-filtro/form-filtro-aside-dialog.html",
      show: false,
      placement: "left",
      backdrop: true,
      animation: "am-slide-left"
    });

    _scope.formTplDetalhamento = $aside({
      scope: $scope,
      template:
        "app/components/prestando-contas/prospera-df/prospera-df-detalhamento.html",
      show: false,
      placement: "left",
      backdrop: true,
      animation: "am-slide-left"
    });

    var colunas = {
      contrato: {nome: "Contrato", visible: true, disabled: true, termo:"Exibe o número do contrato registrado nos sistemas de gestão do Programa.", left: true},
      tomador: {nome: "Tomador", visible: true, termo:"Exibe o nome do envolvido recebedor dos recursos concedidos pelo Programa.", left: true},
      exercicio: {nome: "Exercício", visible: false, termo: "Informa o ano em que o contrato foi concedido pelo Programa.", center: true},
      documento: {nome: "Documento", visible: true, center: true, termo:"Informa o número de Cadastro de Pessoa Física ou de Cadastro Nacional de Pessoa Jurídica do negócio beneficiário."},
      personalidade: {nome: "Personalidade", visible: true, date: true, termo:"Informa se é Pessoa Física ou Jurídica o recebedor dos recursos concedidos pelo Programa.", left: true},
      carteira: {nome: "Carteira", visible: false, termo: "Exibe se o contrato beneficia empreendimento Rural ou Urbano.", left: true},
      comite: {nome: "Comitê", visible: false, date: true, termo: "Comitê", left: true},
      novoRenovacao: {nome: "Tipo de Contrato", visible: false, termo:"Informa se o beneficiário está recebendo recursos pela primeira vez, ou seja, novo ou se está regressando a partir da segunda vez para receber o Prospera.", left: true},
      porte: {nome: "Porte", visible: false, termo: "Informa o porte do empreendimento recebedor dos recursos."},
      modalidade: {nome: "Modalidade", visible: false, disabled: false, termo:"Informa as linhas de crédito obtidas pelo beneficiário no contrato concedido."},
      regiaoAdministrativa: {nome: "Região Administrativa", visible: true, termo:"Informa a localidade onde se encontra o empreendimento beneficiário.", left: true},
      atividade: {nome: "Tipo de Atividade", visible: false, termo:"Informa o segmento econômico que a atividade do empreendimento se insere.", left: true},
      subatividade: {nome: "Subatividade", visible: false, termo: "Especifica a atividade na qual o empreendimento atua.", left: true},
      qtdempregoAtual: {nome: "Qtde Empregos Atuais", visible: true, center: true, termo:"Informa o número de pessoas que obtém renda proveniente do trabalho no empreendimento beneficiário do Prospera."},
      qtdempregoGerar: {nome: "Qtde Empregos a Gerar", visible: true, center: true, termo:"Informa a expectativa do responsável pelo empreendimento em ampliar o número de pessoas que obterão renda proveniente do trabalho no empreendimento beneficiário do Prospera."},
      valorCapital: {nome: "Vlr Capital de Giro/Custeio", visible: true, disabled: true, currency: true, termo:"Informa o valor em reais concedido para utilização em capital de giro ou custeio nas atividades produtivas do empreendimento."},
      valorInvestimento: {nome: "Vlr Investimento", visible: true, disabled: true, currency: true, termo:"Informa o valor em reais concedido para utilização em capital de giro ou custeio nas atividades produtivas do empreendimento."},
      valortotal: {nome: "Valor Total", visible: true, disabled: true, currency: true, termo:"Informa o somatório do valor de capital de giro ou custeio e de investimento obtidos pelo beneficiário no contrato Prospera"}
    };

    _scope.filterModel = {
      exercicio: exercicio.data[0],
      colunas: colunas
    };

    $scope.init = function () { _scope.init();};
    $scope.dataAtualizacao = dataAtualizacao.data;

    $scope.tableOptions = [
      {
        type: "button",
        config: {
          label: "Filtro",
          title: "Abrir filtros",
          icon: "fa fa-filter",
          onClick: function () {
            _scope.formFiltroTpl.show();
          }
        }
      },
      {
        type: "colunas",
        config: {
          colunas: colunas,
          onClose: function () {
            _scope.search();
          }
        }
      },
      {
        type: "bs-modal",
        config: {
          label: "Exportar",
          title: "Exportar os dados no formato CSV",
          icon: "fa fa-download",
          template: "app/components/compartilhado/report-modal.html",
          scope: {
            exportar: function () {
              _scope.exportar();
            }
          }
        }
      },
      {
        type: "bs-aside",
        config: {
          label: "Compartilhar",
          title: "Compartilhar",
          icon: "fa fa-share-alt",
          template: "app/template/directives/share-modal.html"
        }
      },
      {
        type: "modal",
        config: {
          label: "Avalie o portal",
          title: "Avalie o portal",
          icon: "fa fa-comment",
          template:
            "app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html"
        }
      }
    ];
    $scope.filterTitle = "Pesquisar";
    $scope.filterModel = _scope.filterModel;
    $scope.filterFields = [
      {
        type: "select",
        label: "exercício",
        title: "exercício",
        options: exercicio.data,
        modelField: "exercicio"
      },
      {
        type: "text",
        label: "Tomador",
        title: "Tomador",
        modelField: "tomador"
      },
      {
        type: "text",
        label: "Contrato",
        title: "Contrato",
        modelField: "contrato"
      },
      {
        type: "select",
        label: "personalidade",
        title: "personalidade",
        options: personalidade.data,
        modelField: "personalidade"
      },
      {
        type: 'multiple-select',
        label: 'Região Administrativa',
        title: 'Região Administrativa',
        options:regiao.data,
        modelField: 'regiaoAdministrativaFiltros',
        valueProp: 'nome',
        displayProp: 'nome'
      },
      {
        type: "select",
        label: "carteira",
        title: "carteira",
        options: carteira.data,
        modelField: "carteira"
      },
      {
        type: "select",
        label: "comite",
        title: "comite",
        options: comite.data,
        modelField: "comite"
      },
      {
        type: "multiple-select",
        label: "Porte",
        title: "Porte",
        options: porte.data,
        modelField: "porteFiltros",
        valueProp: "nome",
        displayProp: "nome"
      },
      {
        type: "multiple-select",
        label: "Tipo Contrato",
        title: "Tipo Contrato",
        options: novoRenovacao.data,
        modelField: "tipoContratoFiltros",
        valueProp: "nome",
        displayProp: "nome"
      },
      {
        type: "multiple-select",
        label: "Modalidade",
        title: "Modalidade",
        options: modalidade.data,
        modelField: "modalidadeFiltros",
        valueProp: "nome",
        displayProp: "nome"
      },
      {
        type: "multiple-select",
        label: "Tipo de Atividade",
        title: "Tipo de Atividade",
        options: atividade.data,
        modelField: "atividadeFiltros",
        valueProp: "nome",
        displayProp: "nome"
      },
      {
        type: "multiple-select",
        label: "Subatividade",
        title: "Subatividade",
        options: subatividade.data,
        modelField: "subatividadeFiltros",
        valueProp: "nome",
        displayProp: "nome"
      }

    ];
    $scope.filterBtns = [
      {
        type: "submit",
        label: "Pesquisar",
        icon: "fa fa-search",
        callBack: function () {
          _scope.search();
        }
      },
      {
        type: "reset",
        label: "Limpar",
        icon: "fa fa-eraser",
        callBack: function () {
          $scope.filterFields.forEach(function (field) {
            delete $scope.filterModel[field.modelField];
          });
        }
      },
      {
        type: "button",
        label: "Fechar",
        icon: "fa fa-times",
        callBack: function () {
          _scope.formFiltroTpl.hide();
        }
      }
    ];
    $scope.rowSelection = function (event) {
      $scope.linha = event.item;
      _scope.formTplDetalhamento.show();
    };
  }

  function init() {
    this.search();
  }

  function search() {
    var obj = angular.copy(this.filterModel);

    if (this.filterModel.mes) {
      obj.mes = _parseMonthDate(this.filterModel.mes);
    }

    this.$scope.filter = obj;
    this.formFiltroTpl.hide();
  }

  function exportar() {
    if (this.filterModel) {
      this.RelatorioService.exportar(
        "/prestando-contas/prospera-df/relatorios",
        this.filterModel
      );
    }
  }

  function _parseMonthDate(date) {
    var s = "00" + (date.getMonth() + 1);
    var month = s.substr(s.length - 2);

    return month + "/" + date.getFullYear();
  }
})();

(function() {
    'use strict';

    angular.module('portal').controller('RelatorioContasController', RelatorioContasController);

    /**
     * Controlador da página de relatório de contas.
     */
    /** @ngInject */
    function RelatorioContasController($scope, $aside, $q, DataAtualizacaoService, anos, ArquivoUrlService) {
        var vm = this;
        vm.anos = anos.data;
        vm.contador = 0;
        vm.init = init
        vm.loadDataAtualizacao = loadDataAtualizacao;
        vm.createFilterPanel = createFilterPanel;
        vm.onFilterFormReset = onFilterFormReset;
        vm.onFilterFormConfirm = onFilterFormConfirm;
        vm.defaultFilter = defaultFilter;
        vm.updateFilter = updateFilter;
        vm.buildColunasParamsMap = buildColunasParamsMap;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.$scope = $scope;
        vm.$aside = $aside;

        vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

        vm.filterPanel = vm.createFilterPanel();
        vm.data = { content: [] };
        $scope.colunas = COLUMNS;
        $scope.filter = vm.defaultFilter();

        vm.exerciciosResource = new Resource($q(function(resolve) { resolve(anos.data); }));

        vm.init();
    }

    /**
     * Inicializa a página.
     */
    function init() {
        this.loadDataAtualizacao();
        this.exerciciosResource.load(function(resource) {
            resource.data = resource.data.filter(function(ano) {
                return ano != null;
            });
        });
    }

    /**
     * Carrega a data de atualização da base de dados.
     */
    function loadDataAtualizacao() {
        var self = this;
        this.DataAtualizacaoService.buscarDataAtualizacao('relatorios-gerenciais')
            .then(function(resp) {
                self.dataAtualizacao = resp.data;
            });
    }

    /**
     * Cria o painel do formulário de filtro.
     */
    function createFilterPanel() {
        return this.$aside({
            scope: this.$scope,
            template: 'app/components/prestando-contas/relatorio-contas/relatorio-contas-filtro.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });
    }

    /**
     * Responde ao evento de confirmação do formulário de filtro.
     */
    function onFilterFormConfirm() {
        var model = this.defaultFilter();

        this.exerciciosResource.takeModel(function(ano) {
            model.ano = ano;
        });

        this.updateFilter(model);
        this.filterPanel.hide();
    }

    /**
     * Responde ao evento de redefinição do formulário de filtro.
     */
    function onFilterFormReset() {
        this.exerciciosResource.model = undefined;
        this.updateFilter(this.defaultFilter());
        this.filterPanel.hide();
    }

    /**
     * Atualiza o filtro de acordo com o seu formulário.
     */
    function updateFilter(model) {
        this.data.content = [];

        model.colunas = this.buildColunasParamsMap(this.$scope.colunas);
        this.$scope.filter = model;
    }

    /**
     * Constroi o map de parametros correspondentes às colunas.
     */
    function buildColunasParamsMap() {
        var self = this;
        var map = {};

        Object.keys(this.$scope.colunas)
            .forEach(function(key) {
                map[key] = {
                    visible: self.$scope.colunas[key].visible
                };
            });

        return map;
    }

    /**
     * Obtem o filtro padrão da consulta.
     */
    function defaultFilter() {
        var self = this;
        return {
            tipo: 'csv',
            page: 0,
            busy: false,
            assunto: 'PRESTAÇÃO DE CONTAS ANUAL',
            ano: self.anos[0]
        };
    }

    // Colunas da tabela
    var COLUMNS = {
        nome: { nome: "Nome", visible:true, termo:"Descrição dos relatórios gerenciais correspondentes aos assuntos" },
        ano: { nome:"Exercício", visible:true, termo:"Ano de referência do relatório", center: true },
        dataReferencia: { nome:"Referência", visible:true, termo:"Período correspondente à cada assunto do relatório gerencial", center: true },
        descricao: { nome:"Observação", visible:true, termo:"Informações adicionais correspondentes aos relatórios gereciais" },
        fonte: { nome:"Fonte",visible:true, termo:"Órgão responsável pela gestão da informação" }
    };


    // Modelo dos dados de um campo de filtro
    var Resource = (function() {
        var ResourceClass = function(promise) {
            this.loading = false;
            this.setPromise(promise);
        };
        ResourceClass.prototype.load = function(callBack) {
            var self = this;
            this.loading = true;
            this.promise.then(function(data) {
                self.data = data;
                self.model = self.defaultModel != undefined ? self.defaultModel : null;
                self.loaded = true;

                if (callBack) {
                    callBack(self);
                }
            }).finally(function() {
                self.loading = false;
            });
        };
        ResourceClass.prototype.setDefaultModel = function(value) {
            this.defaultModel = value;
        };
        ResourceClass.prototype.setModel = function(value) {
            this.model = value;
            this.onChange();
        };
        ResourceClass.prototype.setChangeListener = function(listenerCallback) {
            this.changeListener = listenerCallback;
        };
        ResourceClass.prototype.onChange = function() {
            if (this.changeListener) {
                this.changeListener(this);
            }
        };
        ResourceClass.prototype.setPromise = function(promise) {
            this.loaded = false;
            this.model = [];
            this.data = [];
            this.promise = promise;
        };
        ResourceClass.prototype.takeModel = function(callbackIfExists, callbackDontExists) {
            if (this.model != null && this.model != undefined) {
                callbackIfExists(this.model);
            } else if (callbackDontExists != undefined) {
                callbackDontExists();
            }
        };

        return ResourceClass;
    })();

})();

(function(){
  'use strict';

  angular.module('portal.prestando-contas').controller('ShowsEventosController', BeneficiarioProSocController);

  /** @ngInject */
  function BeneficiarioProSocController($scope, $aside, valorTotal, PagingService, RelatorioService, anos, orgaos, dataAtualizacao) {

    var vm = this;
    vm.anos = anos.data;
    vm.orgaos = orgaos.data;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      dataInicio:{ nome: "Data", visible:true, date:true ,width : '12%', termo:"Data referente à emissão da Nota de Empenho" },
      orgao:{ nome: "Órgão Contratante", visible:true,width : '15%', termo:"Órgão responsável pela contratação do show ou evento" },
      artista:{ nome: "Artista", visible:true ,width : '17%', termo:"Nome do artista/grupo  contratado"},
      empresa:{ nome: "Empresa", visible:true,width : '20%', termo:"Nome da empresa contratada" },
      local:{ nome: "Local", visible:true,width : '20%', termo:"Endereço correspondente à apresentação artística" },
      valor:{ nome: "Valor Pago", visible:true, currency:true,width : '15%', termo:"Quantia paga pelo show ou evento" }
    };

    $scope.colunas = colunas;

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };
    // settings
    vm.settings = {
      singular: 'Shows e Eventos',
      plural: '',
      busy: true,
      cmd: '',
      colunas: colunas
    };

    vm.item = {
      page: 0,
      tipo:'csv',
      ano: vm.anos[0],
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    // adding demo data
    var data = {
      url: '/prestando-contas/shows-eventos',
      form: vm.item,
      settings: vm.settings,
      content: [],
      totalElements: 0,
      last: true
    };
    vm.data = data;
  
    // defining template
    var formTpl = $aside({
      scope: $scope,
      template: 'app/components/prestando-contas/shows-eventos/shows-eventos-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function() {
      vm.data.form = null;
      vm.item = {
        editing: true,
        page: 0
      };
    };

    vm.visualizarItem = function(linha){
      if(linha){
        vm.item.editing = false;
        vm.linha = linha;
        vm.settings.cmd = 'Visualizar';
        showForm();
      }
    };

    vm.exibirFormPesquisa = function(){
      vm.item.icon = 'md-search';
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showForm();
    };

    vm.init = function() {
      vm.item.ano = vm.anos[0];
      search();
    };

    var search = function() {
      vm.data.content = [];
      vm.item.page = 0;
      vm.item.padrao = false;
      vm.data.form = vm.item;
      vm.tituloFiltro = vm.item.ano;
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    vm.search = search;

    $scope.exportar = function() {
      if(vm.item) {
        vm.item.colunas = vm.settings.colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/prestando-contas/relatorio/shows-eventos', vm.item);
      }
    };
    var showForm = function(){
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function(){
      formTpl.hide();
    };

    $scope.$on('$destroy', function() {
      $scope.hideForm();
    });
  

  }

})();

(function () {
  'use strict';
  var app = angular.module('portal.despesa');

  app.controller('ReceitaConsultaDinamicaController', Controller);
  app.filter("asDateMes", function () {
    return function (input) {
      var d = new Date();
      d.setMonth(input - 1);
      return d;
    }
  });
  /** @ngInject */
  function Controller($scope, $aside, ano, $alert, $location, $filter,
    unidadeGestora, gestao, categoria, fonte, subfonte, rubrica,
    alinea, subalinea, RelatorioService, dataAtualizacao) {

    var vm = this;

    vm.anos = ano.data;
    vm.unidadeGestora = unidadeGestora.data;
    vm.gestao = gestao.data;
    vm.categoria = categoria.data;
    vm.fonte = fonte.data;
    vm.subfonte = subfonte.data;
    vm.rubrica = rubrica.data;
    vm.alinea = alinea.data;
    vm.subalinea = subalinea.data;
    vm.exibirGrid = false;
    vm.data = [];
    vm.contador = 0;
    vm.periodo;
    vm.dataAtualizacao = dataAtualizacao.data;
    //vm.texto = texto.data.texto;

    var colunas = {
      nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos." },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos." },
      nomeCategoriaEconomica: { nome: "Categoria Econômica", visible: false, termo: "Classificação das receitas e despesas para uma avaliação do efeito econômico." },
      nomeFonte: { nome: "Origem", visible: false, termo: "Subdivisão da categoria que indica a procedência dos recursos." },
      nomeSubfonte: { nome: "Espécie", visible: false, termo: "Subdivisão da origem que permite qualificar com maior detalhe o fato gerador das receitas." },
      nomeRubrica: { nome: "Rubrica", visible: false, termo: "Detalha a espécie por meio da especificação dos recursos financeiros que lhe são correlatos. " },
      nomeAlinea: { nome: "Alínea", visible: false, termo: '"Nome” da receita que receberá o registro pela entrada de recursos financeiros. ' },
      nomeSubalinea: { nome: "Subalínea", visible: false, termo: "Detalhamento da alínea com maior especificidade." },
      anoExercicio: { nome: "Exercício", visible: false, termo: "Ano relativo às informações.", center: true },
      mes: { nome: "Mês", visible: false, colunaMes: true, termo: "", center: true },
      valorPrevisto: { nome: "Receita Prevista", visible: true, currency: true, termo: "Valor que o governo espera receber em um determinado período." },
      valorRealizado: { nome: "Receita Realizada", visible: true, currency: true, disabled: true, termo: "Valor que foi efetivamente recebido pelo governo" },
      diferenca: { nome: "Diferença", visible: true, currency: true, termo: "Diferença entre o valor previsto e o realizado" },
      percentual: { nome: "% Realizado", visible: true, currency: true, termo: "Proporção da receita arrecadada em relação à previsão." }
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Consulta Dinâmica',
      plural: ''
    };

    vm.item = {
      //exercicio: vm.anos[0],
      busy: true,
      editing: true,
      colunas: colunas,
      dataAtualizacao: vm.dataAtualizacao
    };

    $scope.dados = {
      form: {
        tipo: 'csv'
      }
    };

    // defining template
    var formTpl = $aside({
      scope: $scope,
      //template: 'app/components/despesas/execucao-emendas-form.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.item = {
        busy: false,
        editing: true
      };
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/receita/relatorio/consulta-dinamica', vm.item);
      }
    };

    vm.exibirFormPesquisa = function () {
      vm.exibirGrid = false;
    };

    vm.exibePeridoPesquisa = true;

    vm.search = function () {
      var colunasVisiveis = _.filter(colunas, function (value, key) {
        return value.visible == true;
      });

      if (colunasVisiveis.length == 0) {
        $alert({
          content: 'Selecione ao menos uma colunas para exibir no resultado',
          type: 'info'
        });
        return;
      }

      vm.periodoConsulta = null;

      if (vm.item.dataInicio != null) {
        vm.periodoConsulta = $filter('date')(vm.item.dataInicio, 'MMM/yyyy') + '-' + $filter('date')(vm.item.dataFim, 'MMM/yyyy');
      } else {
        vm.periodoConsulta = vm.item.exercicio;
      }


      vm.exibirGrid = true;
      vm.item.busy = false;
      vm.item.colunas = $scope.colunas;
      $scope.filter = angular.copy(vm.item);
    };

    var showForm = function () {
      angular.element('.tooltip').remove();
      formTpl.show();
    };

    $scope.hideForm = function () {
      //formTpl.hide();
    };

    $scope.$on('$destroy', function () {
      hideForm();
    });

    vm.init = function () {
      var obj = $location.search();
      if (obj.exercicio) {

        vm.item = obj
        //vm.item.exercicio = vm.item.exercicio.toString();
        vm.applyFilters();

        if (obj.colunas) {
          _.each($scope.colunas, function (coluna) {
            coluna.visible = false;
          });

          _.each(obj.colunas, function (coluna) {
            $scope.colunas[coluna].visible = true;
          });
        }

        vm.search();
      }
    };

    vm.applyFilters = function () {

      var fn = function (item, dados) {
        if (item) {
          var codigo = '';
          if (Array.isArray(dados)) {
            dados.forEach(function (dado) {
              if (dado.nome == item || dado.codigo == item) {
                codigo = [dado.codigo];
              }
            });
          } else {
            codigo = [item];
          }
          return codigo;
        }
      };

      vm.item.listaCodigoSubfonte = fn(vm.item.listaCodigoSubfonte, vm.subfonte);
      vm.item.listaCodigoCategoriaEconomica = fn(vm.item.listaCodigoCategoriaEconomica, vm.categoria);
      vm.item.listaCodigoFonte = fn(vm.item.nomeFonte, vm.fonte);
      //vm.item.listaCodigoSubalinea = fn(vm.item.nomeSubalinea,vm.subalinea);

    };

    $scope.fecharModalColunas = function () {
      vm.search();
    };

    vm.selecionarTodasAsColunas = function (selecionar) {
      $scope.colunas.nomeUnidadeGestora.visible = selecionar;
      $scope.colunas.nomeGestao.visible = selecionar;
      $scope.colunas.nomeCategoriaEconomica.visible = selecionar;
      $scope.colunas.nomeFonte.visible = selecionar;
      $scope.colunas.nomeSubfonte.visible = selecionar;
      $scope.colunas.nomeRubrica.visible = selecionar;
      $scope.colunas.nomeAlinea.visible = selecionar;
      $scope.colunas.nomeSubalinea.visible = selecionar;
      $scope.colunas.anoExercicio.visible = selecionar;
      $scope.colunas.mes.visible = selecionar;
      $scope.colunas.diferenca.visible = selecionar;
      $scope.colunas.percentual.visible = selecionar;
      $scope.colunas.valorPrevisto.visible = selecionar;
    }

  }

})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('ReceitaAuxilioUniaoController', ReceitaAuxilioUniaoController);

    /**
     * Controlador da consulta de receita com covid19 - auxílio união.
     */
    /** @ngInject */
    function ReceitaAuxilioUniaoController($scope, $location,dataAtualizacao, RelatorioService, ReceitasService,$aside,exercicioReferencia,FonteRecursoFiltro) {
        var _scope = {};
        _scope.RelatorioService = RelatorioService;
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.ReceitasService = ReceitasService;
        _scope.exercicioReferencia = exercicioReferencia.data;

         _scope.formFiltroTpl = $aside({
              scope: $scope,
              template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
              show: false,
              placement: 'left',
              backdrop: true,
             animation: 'am-slide-left'
         });

      var colunas = {
            codigoRecurso: { nome: "Fonte de recurso", visible: true, disabled: false, termo: "Código da Fonte de Recurso" },
            nomeFonteRecurso: { nome: "Descrição da Fonte de recurso", visible: true, disabled: false, termo: "Especificação a que se refere a Fonte de Recurso" },
            ano: { nome: "Exercicio", visible: true, disabled: false, termo: "Exercício de Referência do ingresso da receita." },
            valorRealizado: { nome: "Receita Realizada", visible: true, disabled: false, termo: "Valor da receita realizada", currency: true }
        };

        _scope.filterModel = {
            colunas: colunas,
            listaCodigoFonteRecurso: [138018816,138019886,138020655,
              138020688,158018949,158018950,158018951,188000000,189000000,191000000,738018816,739018816
            ]
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;
        //$scope.anoDataAtualizacao = new Date($scope.dataAtualizacao).getFullYear();

        $scope.tableOptions = [
            {

              type: 'button',
              config: {
                  label: 'Filtro',
                  title: 'Abrir filtros',
                  icon: 'fa fa-filter',
                  onClick: function () { _scope.formFiltroTpl.show(); }
              }
            },{
               type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
              type:'select',
              label:'Exercício',
              title: 'Exercício',
              required: false,
              options: exercicioReferencia.data,
              modelField:'ano'
            },{
              type: 'multiple-select',
              label: 'Fonte de Recurso',
              title: 'Fonte de Recurso',
              options: FonteRecursoFiltro.data,
              modelField: 'codigoRecurso',
              valueProp: 'codigo',
              displayProp: 'nome'
            }

        ];
        $scope.filterBtns = [
          {
            type: 'submit',
            label: 'Pesquisar',
            icon: 'fa fa-search',
            callBack: function () { _scope.search(); }
        }, {
            type: 'reset',
            label: 'Limpar',
            icon: 'fa fa-eraser',
            callBack: function () {
                $scope.filterFields.forEach(function (field) {
                    delete ($scope.filterModel[field.modelField]);
                });
            }
        }, {
            type: 'button',
            label: 'Fechar',
            icon: 'fa fa-times',
            callBack: function () { _scope.formFiltroTpl.hide(); }
        }
      ];

    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
     * Aciona a consulta do atual conjunto de filtros.
     */
    function search() {
        var obj = angular.copy(this.filterModel);

        this.$scope.filter = obj;
        this.formFiltroTpl.hide();
    }

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {
            this.RelatorioService.exportar('/receita/relatorio/fonte-recurso', this.filterModel);
        }
    }

})();

/**
 * Created by CGDF on 01/06/2023.
 */
(function () {
  'use strict';

  angular.module('portal.receita').controller('ReceitaControllerUniao', ReceitaControllerUniao);

  /** @ngInject */
  function ReceitaControllerUniao($scope, $aside, $location, RelatorioService,
                             anos, unidadesGestoras, categoria, origem,
                             fontes, subfontes, alineas, subalineas, rubricas, ReceitasService, dataAtualizacao) {

    var vm = this;

    vm.anos = anos.data.map(function(a) { return String(a); });
    vm.unidadesGestoras = unidadesGestoras.data;
    vm.fontes = fontes.data;
    vm.origem = origem.data;
    vm.subfontes = subfontes.data;
    vm.alineas = alineas.data;
    vm.subalineas = subalineas.data;
    vm.rubricas = rubricas.data;
    vm.categoria = categoria.data;
    vm.data = [];
    vm.contador = 0;
    vm.dataAtualizacao = dataAtualizacao;

    var colunas = {
      nomeFonte: {nome: "Origem", visible: true , disabled: true ,termo:"Subdivisão da categoria que indica a procedência dos recursos."},
      exercicio: {nome: "Exercício", visible: false , termo:"Ano relativo às informações.", center: true },
      nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos." },
      nomeUnidadeGestora: {nome: "Unidade Gestora", visible: false, disabled: false , termo:"Órgãos e Entidades encarregadas de gerir os recursos públicos."},
      nomeCategoriaEconomica: {nome: "Categoria Econômica", visible: false , termo:"Classificação das receitas e despesas para uma avaliação do efeito econômico."},
      nomeRubrica: {nome: "Rubrica", visible: true , termo:"Detalha a espécie por meio da especificação dos recursos financeiros que lhe são correlatos."},
      nomeAlinea: {nome: "Alínea", visible: false , termo:'"Nome” da receita que receberá o registro pela entrada de recursos financeiros.'},
      nomeSubalinea: {nome: "Subalínea", visible: false , termo:"Detalhamento da alínea com maior especificidade."},
      valorPrevisto: {nome: "Receita Prevista", visible: true, currency: true , termo:"Valor que o governo espera receber em um determinado período."},
      valorRealizado: {nome: "Receita Realizada", visible: true, currency: true , disabled: false,  termo:"Valor que foi efetivamente recebido pelo governo."},
      diferenca: {nome: "Diferença", visible: true, currency: true , disabled: false,  termo:"Diferença entre o valor previsto e o realizado."},
      percentual: {nome: "% Realizado", visible: true, currency: true , termo:"Proporção da receita arrecadada em relação à previsão."}
    };

    $scope.colunas = colunas;

    // settings
    vm.settings = {
      singular: 'Receita',
      plural: 'Receitas'
    };

    vm.item = {
      exercicio: vm.anos[0].toString(),
      busy: false,
      editing: true,
      colunas: $scope.colunas,
      dataAtualizacao: new Date(vm.dataAtualizacao.data)
    };

    $scope.dados = {
      form: {
        tipo: 'pdf'
      }
    };

    /**
     * Executado na inicialização
     */
    vm.init = function() {
      vm.assignInitParams($location.search());
      vm.search();
    };

    /**
     * Atribui os parâmetros para o objeto modelo.
     * @param {*} params Mapa de parâmetros.
     * @param {*} modelObject Objeto modelo.
     */
    vm.assignInitParams = function(params) {
      var assignSelect = function(selectOptions, modelObj, modelProp, param, compareProp, valueProp, isMultiple) {
        if (param) {
          var element = selectOptions.filter(function(elem) { return compareProp ? elem[compareProp] == param : elem == param; })[0];

          if (element != null) {
            if (valueProp != undefined) {
              element = element[valueProp];
            }

            modelObj[modelProp] = isMultiple ? [element] : element;
          }
        }
      };

      assignSelect(vm.fontes, vm.item, 'listaCodigoFonte', params['orgao'], 'nome', 'codigo', true);
      assignSelect(vm.anos, vm.item, 'ano', params['exercicio'], undefined, undefined, false);
    };

    var formFiltroTpl = $aside({
      scope: $scope,
      template: 'app/components/receitas/transferencia-uniao/receita-uniao-filtro.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    var formDetalhamentoTpl = $aside({
      scope: $scope,
      template: 'app/components/receitas/transferencia-uniao/receita-uniao-detalhamento.html',
      show: false,
      placement: 'left',
      backdrop: true,
      animation: 'am-slide-left'
    });

    vm.cancelar = function () {
      vm.item = {
        busy: false,
        editing: true
      };
    };

    vm.exibirFormPesquisa = function () {
      vm.item.editing = true;
      vm.settings.cmd = 'Pesquisar';
      showFormFiltro();
    };

    vm.visualizarItem = function (linha) {
      if (linha) {
        vm.linha = linha;
        showFormDetalhamento();
      }
    };

    vm.search = function () {
      var stored=ReceitasService.getStored();
      if(stored){
        vm.item.ano=stored.anoExercicio;
      }
      $scope.filter = angular.copy(vm.item);
      $scope.hideForm();
    };

    var showFormFiltro = function () {
      angular.element('.tooltip').remove();
      formFiltroTpl.show();
    };

    var showFormDetalhamento = function () {
      angular.element('.tooltip').remove();
      formDetalhamentoTpl.show();
    };

    $scope.hideForm = function () {
      formDetalhamentoTpl.hide();
      formFiltroTpl.hide();
    };

    $scope.exportar = function () {
      if (vm.item) {
        vm.item.colunas = colunas;
        vm.item.tipo = $scope.dados.form.tipo;
        RelatorioService.exportar('/receita/relatorio/uniao', vm.item);
      }
    };

    $scope.fecharModalColunas = function () {
      vm.search();
    };

    $scope.$on('$destroy', function () {
      $scope.hideForm();
    });

  }

})();

/*eslint-disable */
(function () {
    'use strict';

    angular.module('portal').controller('MilitaresCedidosController', MilitaresCedidosController);

    /**
     * Militares Cedidos
     */
    /** @ngInject */
    function MilitaresCedidosController($scope, $aside, $location, ScopeService,RelatorioService, ServidoresService, dataAtualizacao, referencias, nomeCedente) {
        var _scope = {};
        _scope.$scope = $scope;
        _scope.$location = $location;
        _scope.ScopeService = ScopeService;
        _scope.RelatorioService = RelatorioService;
        _scope.exportar = exportar;
        _scope.search = search;
        _scope.init = init;
        _scope.ServidoresService = ServidoresService;
        _scope.referencias = referencias;
        _scope.buscarMesesPorExercicio = buscarMesesPorExercicio;

        _scope.formFiltroTpl = $aside({
            scope: $scope,
            template: 'app/template/directives/form-filtro/form-filtro-aside-dialog.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });


        var colunas = {
            cedente: { nome: "cedente", visible: true, disabled: true, termo: "Força Militar do DF à qual o Militar Cedido tem vínculo de original." },
            requisitante: { nome: "requisitante", visible: true ,disabled: true, termo: "Órgão para o qual o Militar foi cedido."},
            nome: { nome: "nome", visible: true, disabled: true, termo: "Nome do Militar Cedido" },
            matricula: { nome: "matrícula", visible: true, disabled: true, center: true, termo:"Código de Registro do Militar"},
            mes: { nome: "mês",visible: true, disabled: true, termo: "Mês de referência da cessão", center: true },
            ano: { nome: "Ano", visible: true, disabled: true, termo: "Ano de referência da cessão", center:true },

            quadro: { nome: "Quadro", visible: false, disabled: false, termo: "Quadro", center: true},
            graduacao: { nome: "Graduação", visible: false, disabled: false, termo: "Graduação", center: true},
            graduacaoSigla: { nome: "Posto", visible: false, disabled: false, termo: "Posto", center: true},
            remuneracao: { nome: "Remuneração bruta + auxílios", visible: true, disabled: true,  termo: "Remuneração" , currency: true},

        };

        _scope.filterModel = {
           // anoExercicio: String(anos[0]),
            ano: referencias.exercicios[0],
            mes : referencias.meses[0],
            colunas: colunas
        };

        $scope.init = function () { _scope.init(); };
        $scope.dataAtualizacao = dataAtualizacao.data;

        $scope.tableOptions = [
            {
                type: 'button',
                config: {
                    label: 'Filtro',
                    title: 'Abrir filtros',
                    icon: 'fa fa-filter',
                    onClick: function () { _scope.formFiltroTpl.show(); }
                }
            }, {
                type: 'colunas',
                config: {
                    colunas: colunas,
                    onClose: function () { _scope.search(); }
                }
            }, {
                type: 'bs-modal',
                config: {
                    label: 'Exportar',
                    title: 'Exportar os dados no formato CSV',
                    icon: 'fa fa-download',
                    template: 'app/components/compartilhado/report-modal.html',
                    scope: { exportar: function () { _scope.exportar(); } }
                }
            }, {
                type: 'bs-aside',
                config: {
                    label: 'Compartilhar',
                    title: 'Compartilhar',
                    icon: 'fa fa-share-alt',
                    template: 'app/template/directives/share-modal.html'
                }
            }, {
                type: 'modal',
                config: {
                    label: 'Avalie o portal',
                    title: 'Avalie o portal',
                    icon: 'fa fa-comment',
                    template: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao-modal.html'
                }
            }
        ];
        $scope.filterTitle = 'Pesquisar';
        $scope.filterModel = _scope.filterModel;
        $scope.filterFields = [
            {
              type: 'select',
              label: 'Ano',
              title: 'Ano',
              required:false,
              modelField:'ano',
              options: referencias.exercicios,
              onChange: function(event, field){
                _scope.buscarMesesPorExercicio(event);

              }
            },
            {
              type: 'select',
              label: 'Mês',
              title: 'Mês',
              required: false,
              modelField:'mes',
              options:referencias.meses,
            },
            {
              type: 'multiple-select',
              label: 'Cedente',
              title: 'Cedente',
              options: nomeCedente.data,
              modelField: 'cedenteMilitaresFiltros',
              valueProp: 'nome',
              displayProp: 'nome'
            },
            {
              type: 'text',
              label: 'Nome',
              title: 'Nome',
              modelField:'nome'
            }
       ];
        $scope.filterBtns = [
            {
                type: 'submit',
                label: 'Pesquisar',
                icon: 'fa fa-search',
                callBack: function () { _scope.search(); }
            }, {
                type: 'reset',
                label: 'Limpar',
                icon: 'fa fa-eraser',
                callBack: function () {
                    $scope.filterFields.forEach(function (field) {
                        delete ($scope.filterModel[field.modelField]);
                    });
                }
            }, {
                type: 'button',
                label: 'Fechar',
                icon: 'fa fa-times',
                callBack: function () { _scope.formFiltroTpl.hide(); }
            }

        ];
        $scope.rowSelection=function(event){
               $scope.linha = event.item;
              _scope.formTplDetalhamento.show();

        }

    }

    /**
     * Inicializa a consulta.
     */
    function init() {
        this.search();
    }

    /**
   * Aciona a consulta do atual conjunto de filtros.
   */
  function search() {
    var obj = angular.copy(this.filterModel);

    this.$scope.filter = obj;
      if(!this.$scope.filter.ano){
        this.$scope.filter.ano = this.referencias.exercicios[0];

      }
      if(!this.$scope.filter.mes){
        this.$scope.filter.mes = this.referencias.meses[0];

      }

    this.formFiltroTpl.hide();
}

    /**
     * Aciona a exportação do atual estado da consulta.
     */
    function exportar() {
        if (this.filterModel) {

            this.RelatorioService.exportar('/servidor/militares-cedidos/relatorios', this.filterModel);

        }
    }

    /**
     * Realiza o parse de um objeto Date para o formato MM/yyyy.
     */
    function _parseMonthDate(date) {
        var s = '00' + (date.getMonth() + 1);
        var month = s.substr(s.length - 2);

        return month + '/' + date.getFullYear();
    }

    function buscarMesesPorExercicio(exercicio){
      var self = this;
       this.ServidoresService.listarMesMilitaresCedidos(exercicio)
       .then(function (response){
         self.referencias.meses = response.data;
         self.$scope.filterFields.map(function(filterField) {
           if(filterField.modelField == 'mes') {
             filterField.options = self.referencias.meses;
           }
         })
       })
    }

})();

(function () {
    'use strict';

    angular.module('portal').controller('RessarcimentoRequisitadosSaibaMaisController', RessarcimentoRequisitadosSaibaMaisController);

    /** @ngInject */
    function RessarcimentoRequisitadosSaibaMaisController($scope, $window, dataAtualizacao, ArquivoUrlService) {

      var vm = this;

      vm.dataAtualizacao = dataAtualizacao.data;

      vm.urlArquivos = ArquivoUrlService.ARQUIVOS;

      var colunas = {
        nome:{ nome: "Nome", visible:true },
        ano:{ nome:"Exercício", visible:true },
        dataReferencia:{ nome:"Data referência", visible:false, date:true }
      };

      $scope.colunas = colunas;

      vm.settings = {
        singular: 'Ressarcimento Requisitados - Saiba Mais​',
        plural: '',
        busy: true,
        cmd: ''
      };

      vm.item = {
        page: 0,
        busy: false
      };

      var data = {
        url: '/servidores/ressarcimento-requisitado/saiba-mais',
        form: vm.item,
        settings: vm.settings,
        content: [],
        totalElements: 0,
        last: true
      };

      vm.data = data;

      vm.init = function () {
        vm.search();
      }

      vm.search = function () {
        vm.data.content = [];
        vm.item.page = 0;
        vm.item.padrao = false;
        vm.data.form = vm.item;
        $scope.filter = angular.copy(vm.item);
      };

      vm.voltar = function(){
        $window.location.href = '#/servidores/ressarcimento-requisitado';
      };
    }
  })();

(function () {
    'use strict';

    angular.module('portal').controller('RessarcimentoRequisitadoController', Controller);

    /** @ngInject */
    function Controller($scope, $rootScope, $aside, $location, anos,
        unidadesGestoras, gestoes, fonte,
        ScopeService, RelatorioService, dataAtualizacao, $routeParams) {

        var vm = this;

        vm.data = [];
        vm.contador = 0;

        vm.fonte = fonte.data;
        vm.dataAtualizacao = dataAtualizacao;
        vm.unidadesGestoras = unidadesGestoras.data;
        vm.gestoes = gestoes.data;

        var colunas = {
            nomeUnidadeGestora: { nome: "Unidade Gestora", visible: true, termo: "Órgãos e Entidades encarregadas de gerir os recursos públicos" },
            nomeGestao: { nome: "Gestão", visible: false, termo: "Unidade responsável pela administração dos recursos públicos" },
            codigoCredorMascarado: { nome: "CNPJ Credor", visible: true, termo: "Nº do cadastro de pessoa física ou jurídica de quem tem um valor a receber da Administração Pública" },
            nomeCredor: { nome: "Credor", visible: true, termo: "Nome de quem tem um valor a receber da Administração Pública" },
            nomeFonteRecurso: { nome: "Fonte de Recurso", visible: false, termo: "Indica a origem dos recursos para realizar as despesas" },
            numeroProcesso: { nome: "Nº do Processo", visible: false, termo: "Nº do processo referente à despesa" },
            valorPagoExercicio: { nome: "Pago EX", visible: false, currency: true, termo: "Valor pago de despesas do exercício corrente" },
            valorPagoRPP: { nome: "Pago RPP", visible: false, currency: true, termo: "Valor pago de restos a pagar processados (RPP), ou seja, despesas liquidadas e não pagas no exercício anterior" },
            valorPagoRPNP: { nome: "Pago RPNP", visible: false, currency: true, termo: "Valor pago de restos a pagar não processados (RPNP), ou seja, despesas empenhadas e não liquidadas no exercício anterior" },
            valorPagoRET: { nome: "Pago RET", visible: false, currency: true, termo: "Valor das retenções (RET) de pagamento de tributos federais, estaduais ou municipais" },
            valorNeFinal: { nome: "Empenhado", visible: true, currency: true, link1: true, termo: "Valor reservado para pagamento de um produto ou serviço" },
            valorNlBruto: { nome: "Liquidado", visible: true, currency: true, link2: true, termo: "Valor que o órgão deve pagar com base na comprovação do produto entregue ou serviço realizado" },
            valorObFinal: { nome: " Total Pago", visible: true, currency: true, link3: true, termo: "Valor total pago no exercício (desembolsado): despesas do exercício, restos a pagar processados/não processados e retenções" }
        };

        $scope.colunas = colunas;

        vm.titulo = "Ressarcimento Requisitados";
        vm.texto = "Aqui você encontra os dados dos ressarcimentos de despesas de pessoal requisitado realizados por órgão e entidades da administração pública direta, autárquica e fundacional do Distrito Federal, Fonte SIGGO (SEEC)";

        vm.exibirTabelaAgrupadora = true;
        vm.exibirBtnPesquisa = true;
        vm.anos = anos.data;
        vm.exibirCampo = false;

        vm.lista = '';

        // settings
        vm.settings = {
            singular: 'Ressarcimento Requisitado',
            plural: 'Ressarcimento Requisitados'
        };

        vm.item = {
            anoExercicio: vm.anos[0],
            busy: false,
            editing: true,
            colunas: $scope.colunas,
            dataAtualizacao: new Date(vm.dataAtualizacao.data)
        };

        $scope.dados = {
            form: {
                tipo: 'csv'
            }
        };

        var formTpl = $aside({
            scope: $scope,
            template: 'app/components/servidores/ressarcimento-requisitado/ressarcimento-requisitado-form.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        vm.cancelar = function () {
            vm.item = {
                busy: false,
                editing: true,
                colunas: vm.item.colunas = $scope.colunas
            };
        };

        vm.visualizarEmpenhado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/servidores/ressarcimento-requisitado';

            ScopeService.store(obj);

            $location.path('/despesas/nota-empenho').search({
                anoNotaEmpenho: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: btoa(row.codigoCredor),
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                ressarcimento: true

            });
        };

        vm.visualizarLiquidado = function (row) {
            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };
            obj.url = '/servidores/ressarcimento-requisitado';

            ScopeService.store(obj);
            $location.path('/despesas/nota-lancamento').search({
                ano: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: btoa(row.codigoCredor),
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                ressarcimento: true

            });
        };

        vm.visualizarPago = function (row, tipoValorPago) {

            vm.item.colunas = $scope.colunas;
            var obj = {
                filtroOrigem: vm.item,
                colunas: $scope.colunas
            };

            obj.url = '/servidores/ressarcimento-requisitado';

            ScopeService.store(obj);
            $location.path('/despesas/ordem-bancaria').search({
                ano: vm.item.anoExercicio,
                codigoProjeto: row.codigoProjeto,
                codigoCredorCodificado: btoa(row.codigoCredor),
                nomeCredor: $scope.filter.nomeCredor,
                codigoUnidadeGestora: !vm.item.listaCodigoUnidadeGestora ? row.codigoUnidadeGestora : vm.item.listaCodigoUnidadeGestora[0],
                codigoGestao: !vm.item.listaCodigoGestao ? row.listaCodigoGestao : vm.item.listaCodigoGestao[0],
                nomeProgramaTrabalho: !vm.item.nomeProgramaTrabalho ? row.nomeProgramaTrabalho : vm.item.nomeProgramaTrabalho,
                codigoFuncao: !vm.item.listaCodigoFuncao ? row.listaCodigoFuncao : vm.item.listaCodigoFuncao[0],
                codigoSubfuncao: !vm.item.listaCodigoSubfuncao ? row.listaCodigoSubfuncao : vm.item.listaCodigoSubfuncao[0],
                codigoPrograma: !vm.item.codigoPrograma ? row.listaCodigoPrograma : vm.item.codigoPrograma,
                nomeProjeto: !vm.item.nomeProjeto ? row.nomeProjeto : vm.item.nomeProjeto,
                nomeSubtitulo: !vm.item.nomeSubtitulo ? row.nomeSubtitulo : vm.item.nomeSubtitulo,
                categoriaEconomica: !vm.item.listaCodigoCategoriaEconomica ? row.listaCodigoCategoriaEconomica : vm.item.listaCodigoCategoriaEconomica[0],
                codigoNatureza: !vm.item.listaCodigoGrupoNatureza ? row.listaCodigoGrupoNatureza : vm.item.listaCodigoGrupoNatureza[0],
                codigoModalidadeAplicacao: !vm.item.listaCodigoModalidadeAplicacao ? row.listaCodigoModalidadeAplicacao : vm.item.listaCodigoModalidadeAplicacao[0],
                codigoElementoDespesa: !vm.item.listaCodigoElementoDespesa ? row.listaCodigoElementoDespesa : vm.item.listaCodigoElementoDespesa[0],
                codigoFonteRecurso: !vm.item.listaFonteRecurso ? row.listaFonteRecurso : vm.item.listaFonteRecurso[0],
                numeroProcesso: !vm.item.numeroProcesso ? row.numeroProcesso : vm.item.numeroProcesso,
                codigoEsfera: !vm.item.listaCodigoEsfera ? row.listaCodigoEsfera : vm.item.listaCodigoEsfera[0],
                tipoValorPago: tipoValorPago,
                ressarcimento: true
            });
        };

        vm.exibirFormPesquisa = function () {
            vm.item.editing = true;
            vm.settings.cmd = 'Pesquisar';
            showFormPesquisa();
        };

        vm.search = function () {
            if (colunas.valorPagoExercicio.visible) {
                colunas.numeroProcesso.visible = true;
            }
            $scope.filter = angular.copy(vm.item);
        };

        var showFormPesquisa = function () {
            angular.element('.tooltip').remove();
            formTpl.show();
        };

        $scope.hideForm = function () {
            formTpl.hide();
        };

        $scope.exportar = function () {
            if (vm.item) {
                vm.item.colunas = $scope.colunas;
                RelatorioService.exportar('/despesa/relatorio/ressarcimento-requisitado', vm.item);
            }
        };

        $scope.$on('$destroy', function () {
            $scope.hideForm();
        });

        $scope.fecharModalColunas = function () {
            vm.search();
        };

        vm.init = function () {
            var obj = $location.search();
            if (obj.colunas != null) {
                $scope.colunas = obj.colunas;
            }

            if (obj.anoExercicio) {
                vm.item = extend(vm.item, obj);
            } else {
                vm.item.anoExercicio = anos.data[0];
            }
            vm.item.ressarcimento = true;
            vm.search();
        };

        vm.checarDataInvalida = function (data) {
            // Datas abaixo de 2009 e acima da data atual são inválidas
            var anteriorA2009 = data <= moment('31/12/2008', 'DD/MM/YYYY').valueOf();
            var dataFutura = data >= moment().valueOf();
            return anteriorA2009 || dataFutura;
        };


        var extend = function (obj, src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) obj[key] = src[key];
            }
            return obj;
        }

    }

})();

(function () {
    'use strict';

    angular.module('portal').controller('DashboardExecucaoController', DashboardExecucaoController);
    
     /** @ngInject */
    function DashboardExecucaoController($scope, ExecucaoDespesaService, $timeout, DataAtualizacaoService, $q) {
        
        var vm = this;        

        vm.buscarDadosDashboardDespesa = buscarDadosDashboardDespesa;
        vm.onExercicioSelecionado = onExercicioSelecionado;

        $scope.anos = [];
        var curr = new Date();
        var anoAtual = curr.getFullYear();
        $scope.anoAtual = anoAtual;
        $scope.percentualJaExecutado = 0;
        
        DataAtualizacaoService.buscarDataAtualizacao('detalhamento').then(function(data) {
            vm.dataPercentualExecutado = data.data;
        });

        /**
         * Conjunto de estágios.
         */
        vm.estagiosExecucao = {
            estagios: [],
            set: function(id, label, valor, percentual) {
                var est = this.find(id);

                if (est) {
                    est.label = label;
                    est.valor = valor;
                    est.percentual = percentual > 100 ? 100 : percentual.toFixed(2);
                } else {
                    this.estagios.push(this._build(id, label, valor, percentual));
                }
            },
            find: function(id) {
                return this.estagios.filter(function(est) { return est._id == id; })[0];
            },
            _build: function(id, label, valor, percentual) {
                return {
                    _id: id,
                    label: label,
                    valor: valor,
                    percentual: percentual > 100 ? 100 : percentual.toFixed(2)
                };
            }
        };

        vm.estagiosExecucao.set('_despesaAutorizada', 'DESPESA AUTORIZADA', 0, 0);
        vm.estagiosExecucao.set('_valorBloqueado', 'VALOR BLOQUEADO', 0, 0);
        vm.estagiosExecucao.set('_valorEmpenhado', 'VALOR EMPENHADO', 0, 0);
        vm.estagiosExecucao.set('_valorLiquidado', 'VALOR LIQUIDADO', 0, 0);
        vm.estagiosExecucao.set('_valorPago', 'VALOR PAGO', 0, 0);
        
        vm.loadPanel = LOAD_PANEL;

        /**
         * Realiza o fetch de um recurso.
         * @param {*} resouceId Identificação do recurso.
         * @param {*} promise Promise que realiza o carregamento.
         * @param {*} onDataFetched Callback que receberá o recurso.
         * @param {*} delay Delay opcional para o carregamento em milissegundos.
         */
        function fetchData(resouceId, promise, onDataFetched, delay) {
            var startTime = new Date().getTime();

            vm.loadPanel.setLoading(resouceId, true);

            return promise.then(function(data) {
                var duration = new Date().getTime() - startTime;

                return !delay || duration > delay ? data : $timeout(delay - duration).then(function() { return data; });
            }).then(function(resp) {
                onDataFetched(resp.data);
                vm.loadPanel.setError(resouceId, false);
            }, function(err) {
                vm.loadPanel.setError(resouceId, true);
            }).finally(function() {
                vm.loadPanel.setLoading(resouceId, false);
            });
        }

        function onExercicioSelecionado(exercicio) {
            buscarDadosDashboardDespesa($q.resolve(exercicio));
        }
        
        function buscarDadosDashboardDespesa($exercicio) {
            var exercicio = null;

            var $resource = $exercicio.then(function(ex) {
                exercicio = ex;
                return ExecucaoDespesaService.buscarValoresDashBoardExecucaoDespesa(ex);
            });

            fetchData('despesas', $resource, function(data) {
                $scope.anoAtual = exercicio;
                $scope.orcamentoAprovado = data.orcamentoAprovado;
                
                vm.estagiosExecucao.set('_despesaAutorizada', 'DESPESA AUTORIZADA', data.despesaAutorizada, data.percentualDespesaAutorizada);
                vm.estagiosExecucao.set('_valorEmpenhado', 'VALOR EMPENHADO', data.valorEmpenhado, data.percentualValorEmpenhado);
                vm.estagiosExecucao.set('_valorLiquidado', 'VALOR LIQUIDADO', data.valorLiquidado, data.percentualValorLiquidado);
                vm.estagiosExecucao.set('_valorPago', 'VALOR PAGO', data.valorPago, data.percentualValorPago);
                vm.estagiosExecucao.set('_valorBloqueado', 'VALOR BLOQUEADO', data.valorBloqueado, data.percentualValorBloqueado);
                        
                $scope.percentualJaExecutado = data.percentualJaExecutado;
            }, 300);
        }
        
        function buscarAnos() {
            return fetchData('anos', ExecucaoDespesaService.buscarAnos(), function(data) {
                $scope.anos = data;
            }).then(function() {
                return $scope.anos;
            });
        }

        function init() {
            var $ultimoExercicio = buscarAnos().then(function(exercicios) {
                return exercicios[0];
            });

            buscarDadosDashboardDespesa($ultimoExercicio);
        };

        init();
    }

    /**
     * Controla frags relacionadas ao carregamentos dos recursos.
     */
    var LOAD_PANEL = {
        loadMap: {
            'despesas': {
                loading: false,
                error: false
            },
            'anos': {
                loading: false,
                error: false
            }
        },
        isLoading: function(resouce) {
            return resouce == undefined ? this._checkForFlag('loading') : this.loadMap[resouce].loading;
        },
        anyError: function(resouce) {
            return resouce == undefined ? this._checkForFlag('error') : this.loadMap[resouce].error;
        },
        setLoading: function(resource, flag) {
            this.loadMap[resource].loading = flag;
        },
        setError: function(resource, flag) {
            this.loadMap[resource].error = flag;
        },
        _checkForFlag: function(flag) {
            var self = this;
            return Object.keys(this.loadMap).filter(function(key) {
                return self.loadMap[key][flag];
            }).length > 0;
        }
    };
})();
/*eslint-disable */
(function(){
    'use strict';
  
    angular.module('portal').controller('NossosContatosController', NossosContatosController);
  
    /** @ngInject */
    function NossosContatosController($scope, $alert, FaleConoscoService, $timeout) {

        $scope.validarFormulario = validarFormulario;

        function validarFormulario(isValid) {
            if(!isValid) {
                return $alert({
                    title: 'Erro',
                    content: 'É necessário preencher todos os campos',
                    type: 'danger'
                });
            }

            var nome = retirarPontoEVirgula($scope.form.nome);
            var email = retirarPontoEVirgula($scope.form.email);
            var assunto = retirarPontoEVirgula($scope.form.assunto);
            var mensagem = retirarPontoEVirgula($scope.form.mensagem);

            
            $scope.loading = true;

            FaleConoscoService.registrarMensagem({
                nome: nome,
                email: email,
                assunto: assunto,
                mensagem: mensagem
            }).then(function() {
                return $timeout(500);
            }).then(function() {

                hideForm(function() {
                    $alert({
                        title: 'Sucesso!',
                        content: 'Mensagem enviada com sucesso!',
                        type: 'success'
                    });
                    showSuccessMessage();
                    limparCamposForm();
                });
        
            }, function(err) {
                $alert({
                    title: 'Erro!',
                    content: 'Ocorreu um erro ao enviar a mensagem',
                    type: 'danger'
                });
                showErrorMessage();
            }).finally(function() {
                $scope.loading = false;
            });
        }

        function retirarPontoEVirgula(string) {
            return string.replace(";", " ");
        }

        function limparCamposForm() {            
            delete $scope.form;
            $scope.faleConoscoForm.$setPristine();
        }

        function hideForm(onComplete) {
            $('.fale-conosco-form-container').slideUp(function() {
                if (onComplete) {
                    onComplete();
                }
            });
        }

        function showSuccessMessage() {
            $('.fale-conosco-form-msg.alert-success').fadeIn();
        }

        function showErrorMessage() {
            $('.fale-conosco-form-msg.alert-danger').fadeIn();
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('aprendaNavegar', Directive);

    /**
     * Diretiva para inclusão da seção da tela inicial que ensina a navegar.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                videoId: '='
            },
            templateUrl: 'app/template/directives/aprenda-navegar/aprenda-navegar.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.element = element;
        scope.onPlayerRuns = onPlayerRuns;
        scope.onPlayerReady = onPlayerReady;

        angular.element.getScript('https://www.youtube.com/iframe_api', function() {

            window['onYouTubeIframeAPIReady'] = function() {
                scope.player = new YT.Player('ytPlayer', {
                    videoId: scope.videoId,
                    events: {
                        'onReady': function() {
                            scope.onPlayerReady();
                        },
                        'onStateChange': function(event) {
                            if (event.data == YT.PlayerState.BUFFERING || YT.PlayerState.PLAYING) {
                                scope.onPlayerRuns();
                            }
                        }
                    },
                    playerVars: {
                        'origin': 'http://www.transparencia.df.gov.br'
                    }
                });
            };
        });
    }

    /**
     * Responde ao evento em que o player é carregado.
     */
    function onPlayerReady() {
        this.element.find('.aprenda_nav_player').addClass('player_loaded');
    }

    /**
     * Responde ao evento em que o player entra em execução.
     */
    function onPlayerRuns() {
        this.element.find('.aprenda_nav_player').addClass('without_rotate');
        this.element.find('.aprenda_nav_container_content').addClass('playing');
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('arrecadacaoImposto', ArrecadacaoImposto);

    /**
     * Diretiva para inclusão da página que apresenta a arrecadação de impostos.
     */
    function ArrecadacaoImposto() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                arrecadacao: '=',
                mesInicial: '=',
                mesFinal: '=',
                minMesInicial: '=',
                intervaloChangeListener: '&',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/arrecadacao-imposto.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope._setArrecadacao = _setArrecadacao;
        scope._listYears = _listYears;
        scope.onYearSelected = onYearSelected;
        scope._setYears = _setYears;

        var mesInicial = scope.mesInicial;
        
        scope.minDateStart = scope.minMesInicial;
        scope.maxDateStart = 'current';
        scope.minDateEnd = mesInicial;
        scope.maxDateEnd = 'current';

        scope.$watch('year', function(newVal, prevVal) {
            if (prevVal == undefined && newVal != undefined) {
                scope.onYearSelected(newVal);
            }
        });
        
        scope.$watch('arrecadacao', function(newVal) { scope._setArrecadacao(newVal); });

        scope.$watch('minDateStart', function(newVal) {  scope._setYears(); });
        scope.$watch('maxDateEnd', function(newVal) {  
            scope._setYears();
        });

        scope.listaPercentualImpostos = LISTA_DEFAULT;
    }

    /**
     * Configura a lista de anos.
     */
    function _setYears() {
        var years = this._listYears();

        if (this.years && this.years.length == years.length && this.years[0] == years[0]) {
            return;
        }

        this.years = years;
        this.year = this.years.length > 0 ? this.years[this.years.length - 1] : null;
    }

    /**
     * Responde o evento seleção de um ano.
     * @param {year} Valor referente ao ano selecionado
     */
    function onYearSelected(year) {
        var years = this._listYears();
        var firstMonth = undefined, lastMonth = undefined;

        this.year = year;

        if (years.indexOf(year) == 0 && this.minDateStart) {
            firstMonth = this.minDateStart;
        } else {
            firstMonth = '01/' + year;
        }

        if (years.indexOf(year) == years.length - 1 && this.maxDateEnd) {
            var now = new Date();
            lastMonth = this.maxDateEnd == 'current' ? (now.getMonth() + 1) + '/' + now.getFullYear() : this.maxDateEnd;
        } else {
            lastMonth = '12/' + year;
        }

        this.intervaloChangeListener({startMonth: firstMonth, endMonth: lastMonth});
    }

    /**
     * Configura a diretiva de acordo com uma arrecadação.
     * @param {*} arrecadacao Arrecadação de impostos.
     */
    function _setArrecadacao(arrecadacao) {
        if (arrecadacao) {
            var somaImpostos = arrecadacao.totalImpostos;
            var somaReceitas = arrecadacao.totalReceitas;

            this.dataAtualizacao = arrecadacao.dataCarga;
            this.percentual = somaReceitas > 0 ? (somaImpostos * 100 / somaReceitas) : 0;
            this.impostometro = somaImpostos;
            this.listaPercentualImpostos = LISTA_IMPOSTOS.map(function(imposto) {
                
                var arrecImposto = arrecadacao.impostos.filter(function(arr) {
                    return arr.nome == imposto;
                })[0];

                return {
                    label: imposto,
                    percentual: arrecImposto ? arrecImposto.arrecadacao * 100 / somaImpostos : 0,
                    arrecadacao: arrecImposto ? arrecImposto.arrecadacao : 0
                };
            });
        }
    }

    /**
     * Lista os anos de acordo com os valores de mínimo e máximo especificados.
     * @returns Array com a sequência de valores inteiros respectivos aos anos.
     */
    function _listYears() {
        function extractYear(str) {
            if (str == 'current') {
                var currDate = new Date();
                
                return currDate.getFullYear();
            }
            return Number(str.substring(str.length - 4, str.length));
        }

        if (this.minDateStart && this.minDateStart.length >= 4) {
            var minYear = extractYear(this.minDateStart);

            if (this.maxDateEnd && this.maxDateEnd.length >= 4) {
                var maxYear = extractYear(this.maxDateEnd);
            }

            if (minYear && maxYear) {
                return _listValuesBetween(minYear, maxYear);
            }
        }
        
        return [];
    }

    /**
     * Retorna a lista de números inteiros entre dois valores.
     * @param {min} Valor inicial.
     * @param {max} Valor final.
     * @returns Array contendo os valores iniciando de min e terminando em max.
     */
    function _listValuesBetween(min, max) {
        if (min <= max) {
            return Array.apply(null, {length: max + 1 - min}).map(function(_, idx) {
                return idx + min;
            });
        }

        return [];
    }

    var LISTA_IMPOSTOS = ['IPVA', 'ISS', 'ICMS', 'IPTU', 'ITBI', 'ITCD', 'IR'];
    var LISTA_DEFAULT = LISTA_IMPOSTOS.map(function(imposto) { return { label: imposto, percentual: 0, arrecadacao: 0 }; });

})();

(function() {
    'use strict';
    
    angular.module('portal').directive('escala', Directive);

    /**
     * Diretiva para inclusão de componente que apresenta um escala horizontal.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                percentual: '=',
                hideLegenda: '=?'
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/escala.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.setPercentual = setPercentual;
        scope.bar =  element.find('.escala_bar_complete');

        scope.$watch('percentual', function(newVal) {
            scope.setPercentual(newVal);
        });
    }

    /**
     * Configura o percentual de completude da escala.
     * @param {*} val Valor numérico entre 0 e 100.
     */
    function setPercentual(val) {
        val = Number(val);

        if (val != NaN) {
            this.bar.css('transform', 'translateX(-' + (100 - val)  + '%)');
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('listaPercentualImpostos', Directive);

    /**
     * Diretiva para inclusão de painel com a lista impostos e seus respectivos percentuais sobre a receita.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                impostos: '=lista',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/lista-percentual-impostos.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.havingError = false;
        scope.list = undefined;
        scope.enableLoading = enableLoading;
        scope.setErrorFlag = setErrorFlag;
        scope.element = element;

        scope.$watch('loading', function(newVal) {
            scope.enableLoading(newVal);
        });

        scope.$watch('error', function(newVal) {
            scope.setErrorFlag(newVal);
        });

        scope.$watch('impostos', function(newVal) {
            if (newVal) {
                if (scope.list == undefined) {
                    scope.list = newVal;
                } else {
                    if (scope.list.length == newVal.length) {
                        var presentes = scope.list.filter(function(oldObj) {
                            return newVal.filter(function(newObj) {
                                return newObj.label == oldObj.label;
                            })[0] != undefined;
                        });

                        if (presentes.length == newVal.length) {
                            scope.list.forEach(function(imposto) {
                                var novo = newVal.filter(function(newObj) {
                                    return newObj.label == imposto.label;
                                })[0];

                                imposto.arrecadacao = novo.arrecadacao;
                                imposto.percentual = novo.percentual;
                            });
                        } else {
                            scope.list = newVal;
                        }
                    } else {
                        scope.list = newVal;
                    }
                }
            }
        });
    }

    /**
     * Configura o indicador de erro.
     * @param {*} newVal True, houve um erro; false, caso contrário.
     */
    function setErrorFlag(newVal) {
        if (newVal != undefined) {
            this.havingError = newVal;
            
            if (newVal) {
                this.element.find('.lpi_container_label').addClass('having_error');
            } else {
                this.element.find('.lpi_container_label').removeClass('having_error');
            }
        }
    }

    /**
     * Controla o loading.
     * @param {*} enable True, loading  ativo.
     */
    function enableLoading(enable) {
        if (!this._loadingFlag && enable == true) {
            this.element.find('.lpi_container_label').addClass('disable_label');

            if (this.list != undefined) {
                this.list.forEach(function(imposto) {
                    imposto.percentual = 0;
                });
            }

            this._loadingFlag = true;
        } else if (this._loadingFlag && enable == false) {
            this.element.find('.lpi_container_label').removeClass('disable_label');

            this._loadingFlag = false;
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('monthPicker', Directive);

    /**
     * Diretiva para inclusão de componente de entrada de mês.
     */
    function Directive($timeout) {
        return {
            restrict: 'E',
            link: function(s,e,a){link(s, e, a, $timeout);},
            scope: {
                label: '=',
                month: '=',
                minmonth: '=',
                maxmonth: '=',
                dropdownClass: '='
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/month-picker.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $timeout) {
        scope._isDateSelectable = _isDateSelectable;
        scope.startDateBeforeRender = startDateBeforeRender;
        scope._onInputBlur = _onInputBlur;
        scope.setDate = setDate;
        scope.onTimeSet = onTimeSet;
        scope.inputId = 'id_' + Math.random().toString(36).substring(7);
        scope.date = undefined;

        scope.config = {
            dropdownSelector: '#' + scope.inputId,
            startView: 'month',
            minView: 'month',
            renderOn: 'renderEvent' + scope.inputId
        };

        scope.$dropButton = element.find('.mp_dropdown_button');
        scope.$input = element.find('.mp_input');
        scope.$dropDownContainer = element.find('.mp_dropdown');

        scope.$input.on('focus', function() {
            if (!scope.$dropDownContainer.hasClass('open')) {
                setTimeout(function() {
                    scope.$dropButton.click();
                }, 50);
            }
        });

        scope.$watch('maxmonth', function() {
            scope.$broadcast(scope.config.renderOn);
        });
        scope.$watch('minmonth', function() {
            scope.$broadcast(scope.config.renderOn);
        });

        if (scope.month != undefined) {
            scope.setDate(scope.month);
        }

        scope.$watch('month', function(newVal) {
            if (newVal != undefined) {
                scope.setDate(newVal);
            }
        });

        scope.$input.on('blur', function() { $timeout(function() { scope._onInputBlur(); }, 300); });
    }

    /**
     * Responde ao evento de blur no input.
     */
    function _onInputBlur() {
        var month = parseMonth(this.$input.val());

        if (month != null) {
            // Mês presente no input é válido e diferente do selecionado
            if (month.getTime() != this.date.getTime()) {
                this.month = this._isDateSelectable(month) ? toStringMonth(month) : toStringMonth(this.date);
            }
        } else {
            // Mês presente no input é inválido, redefinir
            this.month = toStringMonth(this.date);
        }
    }

    /**
     * Configura um mês como selecionado.
     * @param {*} monthStr String que representa o mês.
     */
    function setDate(monthStr) {
        this.date = parseMonth(monthStr);
    }

    /**
     * Executado quando uma data é definida pelo datetimepicker.
     * @param {*} newDate Nova data.
     * @param {*} oldDate Data anterior
     */
    function onTimeSet(newDate, oldDate) {
        var month = newDate.getMonth() + 1;

        if (month < 10) {
            month = '0' + month;
        }

        var newMonth = month + '/' + newDate.getFullYear();

        if (this.month != newMonth) {
            this.month = newMonth;
        }
    }

    /**
     * Executado antes do datetimepicker ser rederizado.
     * @param {*} $dates Conjunto de datas que a princípio serão exibidas.
     */
    function startDateBeforeRender($dates) {
        var self = this;

        $dates.filter(function(date) {
            return !self._isDateSelectable(date);
        }).forEach(function(date) {
            date.selectable = false;
        });
    }

    /**
     * Verifica se uma data é selecionável.
     * @param {*} date Date.
     * @returns true, data pode ser selecionada; false, caso contrário.
     */
    function _isDateSelectable(date, x) {
        var maxDate = undefined;

        var time = (date instanceof Date) ? date.getTime() : date.localDateValue();

        if (this.maxmonth) {
            var maxDate = this.maxmonth == 'current' ? new Date() : parseMonth(this.maxmonth);

            if (time > maxDate.getTime()) {
                return false;
            }
        }

        if (this.minmonth) {
            var minDate = this.minmonth == 'current' ? new Date() : parseMonth(this.minmonth);

            if (time < minDate.getTime()) {
                return false;
            }
        }

        return true;
    }

    /**
     * Realiza o parse de um mês no formato MM/yyyy.
     * @param {*} monthStr 
     * @returns Objeto Date; null, caso o mês representado se encontra em um formato não esperado.
     */
    function parseMonth(monthStr) {
        var split = monthStr.split('/');

        if (split.length == 2) {
            var mes = Number(split[0]);

            if (mes != NaN && mes >= 1 && mes <= 12) {
                var ano = Number(split[1]);

                if (ano != NaN && ano >= 1 && ano <= 9999) {
                    return new Date(ano, mes - 1, 1, 0, 0, 0, 0);
                }
            }
        }

        return null;
    }

    /**
     * Obtem a representação do mês de um objeto Date.
     * @param {*} date Date.
     * @returns String representando o mês no formato MM/yyyy.
     */
    function toStringMonth(date) {
        return ('00' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('percentualReceitaImpostos', Directive);

    /**
     * Diretiva para inclusão de componente que apresenta o percentual da receita de impostos sobre o total de receitas.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                percentual: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/percentual-receita-impostos.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('percentual', Directive);

    /**
     * Diretiva para inclusão de componente que apresenta um percentual em uma barra de progresso circular.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                percentual: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/arrecadacao-imposto/percentual.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.havingError = false;
        scope.pie = element.find('.pie');
        scope.left = element.find('.left-side');
        scope.right = element.find('.right-side');
        scope.setPercentual = setPercentual;
        scope.enableLoading = enableLoading;
        scope.setErrorFlag = setErrorFlag;

        scope.$loadCircle = element.find('.percentual_load');
        scope.$percentualLabel = element.find('.percentual_label');
        scope.$container = element.find('.percentual_container');
        scope._loadingFlag = false;
        
        scope.$watch('percentual', function(newVal) {
            scope.setPercentual(newVal);
        });

        scope.$watch('loading', function(newVal) {
            scope.enableLoading(newVal);
        });

        scope.$watch('error', function(newVal) {
            scope.setErrorFlag(newVal);
        });
    }

    /**
     * Configura o indicador de erro.
     * @param {*} newVal True, houve um erro; false, caso contrário.
     */
    function setErrorFlag(newVal) {
        if (newVal != undefined) {
            this.havingError = newVal;
            
            if (newVal) {
                this.$container.addClass('having_error');
            } else {
                this.$container.removeClass('having_error');
            }
        }
    }

    /**
     * Controla o loading.
     * @param {*} enable True, loading  ativo.
     */
    function enableLoading(enable) {
        if (!this._loadingFlag && enable == true) {
            this.$container.addClass('loading');
            this.$loadCircle.fadeIn();
            this.$percentualLabel.fadeOut();

            this._loadingFlag = true;
        } else if (this._loadingFlag && enable == false) {
            this.$container.removeClass('loading');
            this.$loadCircle.fadeOut();
            this.$percentualLabel.fadeIn();

            this._loadingFlag = false;
        }
    }

    /**
     * Configura o percentual.
     * @param {*} val Valor numérico entre 0 e 100.
     */
    function setPercentual(val) {
        if (val && !isNaN(val)) {
            if (val <= 50) {
                this.pie.addClass('less_than_fifty');
                this.left.css('transform', 'rotate(' + (val * 180 / 50) + 'deg)');
            } else if (val <= 100) {
                this.pie.removeClass('less_than_fifty');
                this.left.css('transform', 'rotate(' + (val * 360 / 100) + 'deg)');
            }
            
            if (this.percentual != val) {
                this.percentual = val;
            }
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('areaChart', Directive);

    /**
     * Diretiva para inclusão de gráfico de área.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                /***
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',
                 *      fnFormatData: function(v) {
                 *          return '$'+v;
                 *      },
                 *      fnChartBuild: function(chart) { },
                 *      fnDataClickListener: function(categorie) { }
                 *      fnChartShow: function() {},
                 *      dimentions: [{
                 *          dataLabel: 'qwe',
                 *          data: 123,
                 *          color: '#qweqwe'
                 *      }],
                 *      chartHeight: 123,
                 *      outsideLegendOffset: 65,
                 *      legendPosition: 'right', // right or bottom
                 *      insideTitle: 'Status',
                 *      insideText: '%'
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/area-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.generate = generate;
        scope.onRendered = onRendered;
        scope.getChartId = getChartId;
        scope.getDataColumnsArray = getDataColumnsArray;
        scope.onDataClick = onDataClick;
        scope.onClickChartLabel = onClickChartLabel;
        scope.formatData = formatData;
        scope.getColorsArray = getColorsArray;
        scope.getChartHeight = getChartHeight;
        scope.getArcsScale = getArcsScale;
        scope.getOutsideLegendOffset = getOutsideLegendOffset;
        scope.isLegendDisplayed = isLegendDisplayed;
        scope.isBottomLegend = isBottomLegend;
        scope.getInsideTitle = getInsideTitle;
        scope.getInsideText = getInsideText;
        scope.onChartShow = onChartShow;
        scope._focusOn = _focusOn;
        scope._unfocus = _unfocus;
        scope.focusOn = function(l) { scope._focusOn(l); };
        scope.unfocus = function() { scope._unfocus(); };
        scope.legendHideWidth= 700;

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    function generate() {
        var self = this;

        return c3.generate({
            bindto: '#' + this.getChartId(),
            data: {
                columns: this.getDataColumnsArray(),
                type: 'donut',
                onclick: function (d, i) { self.onDataClick(d, i); }
            },
            legend: { position: 'right', show: self.isLegendDisplayed() },
            size: { height: this.getChartHeight() },
            color: { pattern: this.getColorsArray() },
            donut: { 
                title: self.getInsideTitle(), 
                width: 30,
                label: {
                    format: function(value, ratio) { return self.formatData(ratio, value); }
                }
            },
            onrendered: function() { self.onRendered(this); }
        });
    }

    /**
     * Executado quando o gráfico é renderizado.
     */
    function onRendered(internal) {
        var self = this;
        var preSelector = '#' + self.getChartId();
        var d3 = internal.d3;
        var chartContainer = internal.svg[0][0];

        var legendContainer = internal.legend[0][0];
        var transformStr = legendContainer.getAttribute('transform').match(/-?\d+(\.\d+)?/g);
        legendContainer.setAttribute('transform', 'translate(' + (Number(transformStr[0]) + 40) + ', ' + (Number(transformStr[1]) - 20) + ')');

        if (internal.api.element) {
            var className = legendContainer.getAttribute('class');
            if (chartContainer.clientWidth <= self.legendHideWidth && className != 'container_legend_hided') {
                setTimeout(function() {
                    internal.api.legend.hide();
                    legendContainer.setAttributeNS(null, 'class', 'container_legend_hided');
                    legendContainer.setAttributeNS(null, 'style', 'display: none');
                }, 300);
            } else if (chartContainer.clientWidth > self.legendHideWidth && className == 'container_legend_hided') {
                internal.api.legend.show();
                legendContainer.setAttributeNS(null, 'class', '');
                legendContainer.setAttributeNS(null, 'style', '');
            }
        } else {
            setTimeout(function() { self.onChartShow(); }, 100);
        }
     
        d3.selectAll(preSelector + ' .c3-legend-item')[0].reduce(function(acc, elem) {
            var translate = acc + 8;
            elem.setAttributeNS(null, 'style', 'transform: translateY(' + translate + 'px)');
            return translate;
        }, -8);

        d3.selectAll(preSelector + ' .c3-legend-item').each(function() {
            var offSet = 13;

            var line = Array.prototype.slice.call(this.children).filter(function(c) { return c.tagName == 'line'; })[0];
            var x2Position = line.getAttribute('x2');
            line.setAttributeNS(null, 'x2', Number(x2Position) + offSet);

            var text = Array.prototype.slice.call(this.children).filter(function(c) { return c.tagName == 'text'; })[0];
            var xPosition = text.getAttribute('x');
            text.setAttributeNS(null, 'x', Number(xPosition) + offSet);
        });

        d3.selectAll(preSelector + ' .c3-chart .c3-chart-arcs').each(function(v) {
            var transformAttr = this.getAttribute("transform");
            var arsScale = self.getArcsScale(chartContainer.clientWidth);
            this.setAttribute('transform', (transformAttr ? transformAttr + ',' : '') + 'scale('+arsScale[0]+', '+arsScale[1]+')');

            if (internal.percentLabelElement == undefined) {
                var insideText = self.getInsideText();

                if (insideText) {
                    var words = insideText.split(' ');

                    var text = document.createElementNS("http://www.w3.org/2000/svg","text");
                    text.setAttributeNS(null,"class",'inside_percent_label');

                    if (words.length == 1) {
                        text.innerHTML = self.getInsideText();
                    } else {
                        words.reduce(function(prev, curr) {
                            var subText = document.createElementNS("http://www.w3.org/2000/svg","tspan");
                            subText.setAttributeNS(null,'x','0');
                            subText.setAttributeNS(null,'y',prev);
                            subText.innerHTML = curr;
                            text.appendChild(subText);
                            return prev + 23;
                        }, 0);
                    }

                    this.appendChild(text);
                    internal.percentLabelElement = text;
                }
            }

            var circle;
            if (internal.outsideCircleElement == undefined) {
                circle = document.createElementNS("http://www.w3.org/2000/svg","circle");
                circle.setAttributeNS(null,'cx',0);
                circle.setAttributeNS(null,'cy',0);
                circle.setAttributeNS(null,'class','outside_circle');
                this.appendChild(circle);
                internal.outsideCircleElement = circle;
            } else {
                circle = internal.outsideCircleElement;
            }

            circle.setAttributeNS(null,'r', internal.radius + 18);
        });

        d3.selectAll(preSelector + ' .c3-chart-arc text').each(function(v) {
            var label = d3.select(this);
            var pos = label.attr("transform").match(/-?\d+(\.\d+)?/g);

            var pX = Number(pos[0]);
            var pY = Number(pos[1]);

            var offSet = self.getOutsideLegendOffset();

            if (pX < 0) {
                pX -= offSet;
            } else if (pX > 0) {
                pX += offSet;
            }

            if (pY < 0) {
                pY -= offSet;
            } else if (pY > 0) {
                pY += offSet;
            }

            pos[0] = pX;
            pos[1] = pY;

            label.attr("transform", "translate("+ pos[0] +","+ pos[1] +")");
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem a altura que o gráfico deve apresentar.
     */
    function getChartHeight() {
        return this.model.chartHeight;
    }

    /**
     * Obtem o offset da legenda
     */
    function getOutsideLegendOffset() {
        return this.model && this.model.outsideLegendOffset ? this.model.outsideLegendOffset : 65;
    }

    /**
     * Obtem o título interno do gráfico.
     * @returns String referente ao título.
     */
    function getInsideTitle() {
        if (this.model && this.model.insideTitle != undefined) {
            return this.model.insideTitle;
        }

        return '%';
    }

    /**
     * Obtem o texto interno do gráfico.
     * @returns String referente ao título.
     */
    function getInsideText() {        
        return this.model.insideText;
    }

    /**
     * Diz a legenda interna do gráfico deve ser exibida.
     * @returns true, legenda deve ser exibida; false, não deve ser exibida.
     */
    function isLegendDisplayed() {
        return this.model && (this.model.legendPosition == undefined || this.model.legendPosition == 'right');
    }

    /**
     * Diz se a legenda deve ser exibida no fundo.
     * @returns true, legenda deve ser posicionada no fundo; false, caso contrário.
     */
    function isBottomLegend() {
        return this.model && this.model.legendPosition == 'bottom';
    }

    /**
     * Obtem o array de cores do padrão que o gráfico deve apresentar.
     */
    function getColorsArray() {
        return this.model.dimentions.map(function(dim) {
            return dim.color;
        });
    }

    /**
     * Obtem a escala dos arcos do gráfico.
     * @param {*} containerWidth Tamanho do container.
     */
    function getArcsScale(containerWidth) {
        return containerWidth >= 500 ? [0.8, 0.8] : [0.75, 0.75];
    }

    /**
     * Obtem os dados e colunas do gráfico.
     */
    function getDataColumnsArray() {
        return this.model.dimentions.map(function(d) { return [d.dataLabel, d.data]; });
    }

    /**
     * Formata o dado exibido na escala do gráfico.
     * @param {*} data Dado.
     */
    function formatData(ratio, value) {
        return this.model && this.model.fnFormatData != undefined ? this.model.fnFormatData(ratio, value) : ratio
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} i 
     */
    function onDataClick(d, i) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(d.id);
        }
    }

    /**
     * Responde ao evento de click em uma label.
     * @param {*} dataLabel Label.
     */
    function onClickChartLabel(dataLabel) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(dataLabel);
        }
    }

    /**
     * Responde ao evento de apresentação do gráfico.
     */
    function onChartShow() {
        if (this.model.fnChartShow) {
            this.model.fnChartShow();
        }
    }

    /**
     * Responde ao evento de focus sobre uma categoria.
     * @param {*} dimentionLabel Label da categoria.
     */
    function _focusOn(dimentionLabel) {
        if (this.chart) {
            this.chart.focus(dimentionLabel);
        }
    }

    /**
     * Responde eo evento de unfocus sobre as categorias do gráfico.
     */
    function _unfocus() {
        if (this.chart) {
            this.chart.revert();
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('barChart', Directive);

    /**
     * Diretiva para inclusão de gráfico de barras.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a); },
            scope: {
                /***
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',
                 *      fnChartBuild: function(chart) { },
                 *      fnFormatData: function(v) { 
                 *          return '$'+v; 
                 *      },
                 *      fnDataClickListener: function(categorie) { }
                 *      dimentions: [{
                 *          dataLabel: '2018',
                 *          color: '#qweqwe',
                 *          data: 123 
                 *          //Or: data: [{
                 *                          division: 'input',
                 *                          value: 123
                 *                      },{
                 *                          division: 'output',
                 *                          value: 321
                 *                      }]
                 *      }],
                 *      chartHeight: 123,
                 *      chartBarWidthRatio: 0.6,
                 *      chartBarSpaceRatio: 0.3
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/bar-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.$parentElement = element.parent();
        scope.getChartId = getChartId;
        scope.getChartHeight = getChartHeight;
        scope.generate = generate;
        scope.getColorsArray = getColorsArray;
        scope.getDataColumnsArray = getDataColumnsArray;
        scope.getChartBarSpaceRatio = getChartBarSpaceRatio;
        scope.getChartBarWidthRatio = getChartBarWidthRatio;
        scope.formatData = formatData;
        scope.onDataClick = onDataClick;
        scope.getDivisionsArray = getDivisionsArray;
        scope._focusOn = _focusOn;
        scope._unfocus = _unfocus;
        scope.focusOn = function(l) { scope._focusOn(l); };
        scope.unfocus = function() { scope._unfocus(); };

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    /**
     * Gera o gráfico.
     * @returns Gráfico construído.
     */
    function generate() {
        var self = this;

        return c3.generate({
            bindto: '#' + this.getChartId(),
            legend: { show: false },
            grid: { x: { show: true }, y: { show: true } },
            data: {
                x: 'x',
                columns: this.getDataColumnsArray(),
                type: 'bar',
                order: null,
                onclick: function (d, i) { self.onDataClick(d, i); },
                color: (function() {
                    if (!self.model.useColorPattern) {
                        return function(color, d) {
                            return d.index != undefined ? self.getColorsArray()[d.index] : color;
                        };
                    }
                    return undefined;
                })()
            },
            tooltip: {
                grouped: false,
                format: {
                    name: function (name, ratio, id, index) { return name; },
                    title: function (x) { return '' },
                    value: function (value, ratio, id, index) { return self.formatData(value); }
                }
            },
            axis: {
                y: {
                    tick: {
                        format: function(d) { return self.formatData(d); }
                    }
                },
                x: { 
                    type: 'category'/*,
                    tick: {
                        rotate: 60,
                        multiline: false
                    }*/
                }
            },
            size: { height: this.getChartHeight() },
            color: {
                pattern: this.model.useColorPattern ? this.getColorsArray() : undefined
            },
            bar: { 
                space: this.getChartBarSpaceRatio(),
                width: {
                    ratio: this.getChartBarWidthRatio()
                }
            },
            onrendered: function() {
                d3.selectAll('#' + self.getChartId() + ' .c3-axis.c3-axis-x .tick text').on('click', function(value) {
                    self.onDataClick({ index: value }, this);
                });
            }
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem a altura que o gráfico deve apresentar.
     */
    function getChartHeight() {
        return this.model.chartHeight;
    }

    /**
     * Obtem o percentual correspondente ao espaço entre as barras do gráfico.
     */
    function getChartBarSpaceRatio() {
        return this.model.chartBarSpaceRatio != undefined ? this.model.chartBarSpaceRatio : 0.25;
    }

    /**
     * Obtem o percentual correspondente a largura das barras do gráfico.
     */
    function getChartBarWidthRatio() {
        return this.model.chartBarWidthRatio != undefined ? this.model.chartBarWidthRatio : 0.55;
    }

    /**
     * Obtem o array de cores do padrão que o gráfico deve apresentar.
     */
    function getColorsArray() {
        return this.model.dimentions.map(function(dim) {
            return dim.color;
        });
    }

    function getDivisionsArray() {
        if (!this.model) {
            return [];
        }

        if (this._divisions == undefined) {
            var divisions = this.model.dimentions.filter(function(dim) {
                return Array.isArray(dim.data);
            }).map(function(dim) {
                return dim.data.map(function(d) {
                    return d.division;
                });
            }).reduce(function(prev, next) {
                return prev.concat(next);
            }, []).filter(function(value, index, self) { 
                return self.indexOf(value) === index;
            });

            var colors = this.getColorsArray();

            this._divisions = divisions.map(function(div, index) {
                return {
                    label: div,
                    color: colors[index % colors.length]
                };
            });
        }

        return this._divisions;
    }

    /**
     * Obtem os dados e colunas do gráfico.
     */
    function getDataColumnsArray() {
        var dimentions = this.model.dimentions;

        function getDivisionValue(division, dimention) {
            if (Array.isArray(dimention.data)) {

                var value = dimention.data.filter(function(div) {
                    return div.division == division;
                }).map(function(div) {
                    return div.value;
                })[0];

                if (value != undefined) {
                    return value;
                }
            } else if (division == null) {
                return dimention.data;
            }

            return 0;
        }

        var divisions = dimentions.map(function(dim) {
            if (!Array.isArray(dim.data)) {
                return [null];
            }

            return dim.data.map(function(d) {
                return d.division;
            });
        }).reduce(function(prev, next) {
            return prev.concat(next);
        }, []).filter(function(value, index, self) { 
            return self.indexOf(value) === index;
        });

        var divisionsData = divisions.map(function(div) {
            return [div == null ? '' : div].concat(dimentions.map(function(dim) {
                return getDivisionValue(div, dim);
            }));
        });

        var dimentionsLabels = ['x'].concat(dimentions.map(function(dim) { return dim.dataLabel; }));

        return [dimentionsLabels].concat(divisionsData);


        /*return [
            ['x'].concat(this.model.dimentions.map(function(d) { return d.dataLabel; })),
            [''].concat(this.model.dimentions.map(function(d) { return d.data; }))
        ];*/
    }

    /**
     * Formata o dado exibido na escala do gráfico.
     * @param {*} data Dado.
     */
    function formatData(data) {
        return this.model.fnFormatData != undefined ? this.model.fnFormatData(data, this.$parentElement.width()) : data
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} element
     */
    function onDataClick(d, element) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(this.model.dimentions[d.index]);
        }
    }

    /**
     * Responde ao evento de focus sobre uma categoria.
     * @param {*} dimentionLabel Label da categoria.
     */
    function _focusOn(dimentionLabel) {
        if (this.chart) {
            this.chart.focus(dimentionLabel);
        }
    }

    /**
     * Responde eo evento de unfocus sobre as categorias do gráfico.
     */
    function _unfocus() {
        if (this.chart) {
            this.chart.revert();
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('evolutionChart', Directive);

    /**
     * Diretiva para inclusão de gráfico de evolução.
     */
    function Directive($timeout) {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a, $timeout); },
            scope: {
                /**
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',
                 *      fnFormatData: function(v) { 
                 *          return '$'+v; 
                 *      },
                 *      fnFormatTooltip: function(v) { 
                 *          return '$'+v; 
                 *      },
                 *      fnTickSequenceBy: function() {
                 *          return 5;
                 *      },
                 *      fnChartBuild: function(chart) { },
                 *      fnDataClickListener: function(categorie) { },
                 *      useBySideTooltipPosition: true,
                 *      dimentions: [{
                 *          label: 'qwe',
                 *          color: '#gerer'
                 *          data: [['2010', 12], ['2011', 54]],
                 *          type: 'area'
                 *      }],
                 *      chartHeight: 123
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/evolution-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $timeout) {
        scope.$chartElement = element.find('.dashboard_chart');
        scope.generate = generate;
        scope.getChartId = getChartId;
        scope.getValueMarks = getValueMarks;
        scope.getDataColumnsArray = getDataColumnsArray;
        scope.onDataClick = onDataClick;
        scope.formatData = formatData;
        scope.formatTooltip = formatTooltip;
        scope.getColorsArray = getColorsArray;
        scope.getChartHeight = getChartHeight;
        scope.getCategories = getCategories;
        scope.getDimentionsTypesObject = getDimentionsTypesObject;
        scope.getDimentionValues = getDimentionValues;
        scope.chartTickSequenceBy = chartTickSequenceBy;
        scope.getMinScaleValue = getMinScaleValue;
        scope.getTooltipPosition = getTooltipPosition;
        scope._focusOn = _focusOn;
        scope._unfocus = _unfocus;
        scope.focusOn = function(l) { scope._focusOn(l); };
        scope.unfocus = function() { scope._unfocus(); };

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    /**
     * Gera o gráfico.
     * @returns Gráfico construído.
     */
    function generate() {
        var self = this;
        return c3.generate({
            bindto: this.$chartElement[0],
            legend: { show: false },
            grid: { x: { show: true }, y: { show: true } },
            axis: {
                x: { type: 'category' },
                y: {
                    min: this.getMinScaleValue(),
                    tick: {
                        values: this.getValueMarks(),
                        format: function(value) { return self.formatData(value); }
                    }
                }
            },
            data: {
                x: 'x',
                columns: this.getDataColumnsArray(),
                onclick: function (d, i) { self.onDataClick(d, i); },
                types: this.getDimentionsTypesObject()
            },
            size: { height: this.getChartHeight() },
            color: { pattern: this.getColorsArray() },
            tooltip: {
                format: {
                    value: function (value) { return self.formatTooltip(value); }
                },
                position: this.getTooltipPosition()
            }
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem o valor mínimo para a scala do eixo Y.
     * @returns Valor mínimo; undefined, caso não seja definido.
     */
    function getMinScaleValue() {
        return this.model ? this.model.minScaleValue : undefined;
    }

    /**
     * Obtem a altura que o gráfico deve apresentar.
     */
    function getChartHeight() {
        return this.model.chartHeight;
    }

    /**
     * Obtem o array de cores do padrão que o gráfico deve apresentar.
     */
    function getColorsArray() {
        return this.model.dimentions.map(function(dim) {
            return dim.color;
        });
    }

    /**
     * Obtem o conjunto de valores de uma dimention.
     * @param {*} dim Dimention.
     */
    function getDimentionValues(dim) {
        return dim.data.map(function(d) {
            return d[1];
        });
    }

    /**
     * Obtem a função que posiciona o tooltip de uma dimention.
     */
    function getTooltipPosition() {
        if (this.model && this.model.useBySideTooltipPosition) {
            return function(data, width, height, element) {
                var areaWidth = element.parentElement.getBoundingClientRect().width;
                var rectX = parseInt(element.getAttribute('x'));
                
                var offSet = 20;
                var halfWidth = Math.floor(width/2);
                var left = rectX - halfWidth - offSet;
                var right = rectX + halfWidth + offSet;

                if ((rectX + width + offSet) > areaWidth) {
                    return { top: 0, left: left };
                }

                return { top: 0, left: right };
            };
        }

        return undefined;
    }

    /**
     * Obtem o conjunto de categorias do gráfico.
     */
    function getCategories() {
        function getCategoriesOfDimention(dim) {
            return dim.data.map(function(c) { return c[0]; });
        }

        var cats = this.model.dimentions.reduce(function(prevCats, next) {
                return prevCats.concat(getCategoriesOfDimention(next));
        }, []);
        
        var uniqueCats = cats.filter(function(item, pos) {
            return cats.indexOf(item) == pos;
        });

        return uniqueCats;
    }

    /**
     * Obtem os dados e colunas do gráfico.
     */
    function getDataColumnsArray() {
        var self = this;

        return [ ['x'].concat(this.getCategories()) ].concat(this.model.dimentions.map(function(dim) {
            return [dim.label].concat(self.getDimentionValues(dim));
        }));
    }

    /**
     * Obtem o conjunto de data types respectivos as dimenções do gráfico.
     * @returns Objeto mapeanda a label da dimenção com o seu tipo; undefined, caso não exista especificação em nenhuma dimention.
     */
    function getDimentionsTypesObject() {
        var obj = undefined;

        var dimsWithType = this.model.dimentions.filter(function(d) {
            return d.type != undefined;
        });

        if (dimsWithType.length > 0) {
            obj = {};
            dimsWithType.forEach(function(d) {
                obj[d.label] = d.type;
            });
        }

        return obj;
    }

    /**
     * Formata o dado exibido na escala do gráfico.
     * @param {*} data Dado.
     */
    function formatData(data) {
        return this.model && this.model.fnFormatData != undefined ? this.model.fnFormatData(data) : data
    }

    /**
     * Formata o dado exibido no tooltip de uma categora do gráfico.
     * @param {*} data Dado.
     */
    function formatTooltip(data) {
        return this.model.fnFormatTooltip != undefined ? this.model.fnFormatTooltip(data) : data;
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} i 
     */
    function onDataClick(d, i) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(this.getCategories()[d.index], d.id);
        }
    }

    /**
     * Obtem o conjunto de valores correspondentes a escala do gráfico.
     */
    function getValueMarks() {
        var self = this;
        var maxOfDimentions = this.model.dimentions.filter(function(dim) {
            return self.getDimentionValues(dim).length > 0;
        }).map(function(dim) {
            return Math.max.apply(null, self.getDimentionValues(dim));
        });

        return calculateSequenceScale(this.chartTickSequenceBy(), maxOfDimentions);
    }

    /**
     * Obtem o tamanho do intervalo da escala do gráfico.
     */
    function chartTickSequenceBy() {
        if (this.model.fnTickSequenceBy) {
            return this.model.fnTickSequenceBy();
        }

        return 2;
    }

    /**
     * Calcula a sequência de valores para apresentação de uma escala.
     * @param {*} sequenceBy Sequência que os valores devem estar distantes.
     * @param {*} dataArray Conjunto de valores ao qual a sequência deve corresponder.
     */
    function calculateSequenceScale(sequenceBy, dataArray) {
        var max = dataArray.length ? Math.max.apply(null, dataArray) : 0;

        if (max % 5 > 0) {
            max = parseInt(max / sequenceBy) * sequenceBy + sequenceBy;
        }

        if (max == 0) {
            max = 30;
        }

        return Array.apply(null, {length: max / sequenceBy + 1}).map(function(e, i) { return i * sequenceBy; });
    }

    /**
     * Responde ao evento de focus sobre uma categoria.
     * @param {*} dimentionLabel Label da categoria.
     */
    function _focusOn(dimentionLabel) {
        if (this.chart) {
            this.chart.focus(dimentionLabel);
        }
    }

    /**
     * Responde eo evento de unfocus sobre as categorias do gráfico.
     */
    function _unfocus() {
        if (this.chart) {
            this.chart.revert();
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('gaugeChart', Directive);

    /**
     * Diretiva para inclusão de gráfico gauge.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a); },
            scope: {
                /***
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',
                 *      legend: 'description',
                 *      fnChartBuild: function(chart) { },
                 *      fnDataClickListener: function(categorie) { }
                 *      dimentions: [{
                 *      }],
                 *      chartHeight: 123
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/gauge-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.getChartId = getChartId;
        scope.getChartHeight = getChartHeight;
        scope.getChartWidth = getChartWidth;
        scope.getDataColumnsArray = getDataColumnsArray;
        scope.generate = generate;
        scope.onDataClick = onDataClick;
        scope.getColorsArray = getColorsArray;
        scope.onLegendClick = onLegendClick;

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    /**
     * Gera o gráfico.
     * @returns Gráfico construído.
     */
    function generate() {
        var self = this;

        return c3.generate({
            bindto: '#' + this.getChartId(),
            data: {
                columns: this.getDataColumnsArray(),
                type: 'gauge',
                onclick: function (d, i) { self.onDataClick(d, i); }
            },
            color: { pattern: this.getColorsArray() },
            size: {
                height: this.getChartHeight(),
                width: this.getChartWidth()
            }
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem a altura que o gráfico deve apresentar.
     */
    function getChartHeight() {
        return this.model.chartHeight;
    }

    function getChartWidth() {
        return this.model.chartWidth;
    }

    /**
     * Obtem o array de cores do padrão que o gráfico deve apresentar.
     */
    function getColorsArray() {
        return this.model.dimentions.map(function(dim) {
            return dim.color;
        });
    }

    /**
     * Obtem os dados e colunas do gráfico.
     */
    function getDataColumnsArray() {
        return this.model.dimentions.map(function(dim) {
            return [dim.dataLabel, dim.data];
        });
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} element
     */
    function onDataClick(d, element) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(this.model.dimentions[d.index]);
        }
    }

    /**
     * Responde ao evento de click na legenda do gráfico.
     */
    function onLegendClick() {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(this.model.dimentions[0]);
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('horizontalBarChart', Directive);

    /**
     * Diretiva para inclusão de gráfico de barras horizontais.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                /***
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',
                 *      fnTickSequenceBy: function() {
                 *          return width < 500 ? 20 : 10;
                 *      },
                 *      fnChartBuild: function(chart) { },
                 *      fnDataClickListener: function(categorie) { }
                 *      dimentions: [{
                *           label: 'qwé',
                 *          dataLabel: 'qwe',
                 *          color: '#qweqwe',
                 *          data: 123
                 *      }],
                 *      chartHeight: 123,
                 *      chartBarWidthRatio: 0.6,
                 *      chartBarSpaceRatio: 0.3
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/horizontal-bar-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.generate = generate;
        scope.getChartId = getChartId;
        scope.getValueMarks = getValueMarks;
        scope.getDataColumnsArray = getDataColumnsArray;
        scope.onDataClick = onDataClick;
        scope.onClickChartLabel = onClickChartLabel;
        scope.getColorsArray = getColorsArray;
        scope.getChartHeight = getChartHeight;
        scope.chartTickSequenceBy = chartTickSequenceBy;
        scope.getChartBarSpaceRatio = getChartBarSpaceRatio;
        scope.getChartBarWidthRatio = getChartBarWidthRatio;
        scope._focusOn = _focusOn;
        scope._unfocus = _unfocus;
        scope.focusOn = function(l) { scope._focusOn(l); };
        scope.unfocus = function() { scope._unfocus(); };

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    /**
     * Gera o gráfico.
     * @returns Gráfico construído.
     */
    function generate() {
        var self = this;

        return c3.generate({
            bindto: '#' + this.getChartId(),
            legend: { show: false },
            grid: { x: { show: false }, y: { show: true } },
            data: {
                columns: this.getDataColumnsArray(),
                type: 'bar',
                onclick: function (d, i) { self.onDataClick(d, i); }
            },
            tooltip: {
                grouped: false,
                format: {
                    name: function (name, ratio, id, index) { return name; },
                    title: function (x) { return '' },
                    value: function (value, ratio, id, index) { return value; }
                }
            },
            axis: { 
                rotated: true,
                y: {
                    tick: {
                        values: function() { return self.getValueMarks(); }
                    }
                }
            },
            size: { height: this.getChartHeight() },
            color: { pattern: this.getColorsArray() },
            bar: { 
                space: this.getChartBarSpaceRatio(),
                width: {
                    ratio: this.getChartBarWidthRatio()
                }
            }
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem a altura que o gráfico deve apresentar.
     */
    function getChartHeight() {
        return this.model.chartHeight;
    }

    /**
     * Obtem o percentual correspondente ao espaço entre as barras do gráfico.
     */
    function getChartBarSpaceRatio() {
        return this.model.chartBarSpaceRatio != undefined ? this.model.chartBarSpaceRatio : 0.25;
    }

    /**
     * Obtem o percentual correspondente a largura das barras do gráfico.
     */
    function getChartBarWidthRatio() {
        return this.model.chartBarWidthRatio != undefined ? this.model.chartBarWidthRatio : 0.5;
    }

    /**
     * Obtem o array de cores do padrão que o gráfico deve apresentar.
     */
    function getColorsArray() {
        return this.model.dimentions.map(function(dim) {
            return dim.color;
        });
    }

    /**
     * Obtem os dados e colunas do gráfico.
     */
    function getDataColumnsArray() {
        return this.model.dimentions.map(function(d) { return [d.dataLabel, d.data]; });
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} i 
     */
    function onDataClick(d, i) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(d.id);
        }
    }

    /**
     * Responde ao evento de click em uma label.
     * @param {*} dataLabel Label.
     */
    function onClickChartLabel(dataLabel) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(dataLabel);
        }
    }

    /**
     * Responde ao evento de focus sobre uma categoria.
     * @param {*} dimentionLabel Label da categoria.
     */
    function _focusOn(dimentionLabel) {
        if (this.chart) {
            this.chart.focus(dimentionLabel);
        }
    }

    /**
     * Responde eo evento de unfocus sobre as categorias do gráfico.
     */
    function _unfocus() {
        if (this.chart) {
            this.chart.revert();
        }
    }

    /**
     * Obtem o conjunto de valores correspondentes a escala do gráfico.
     */
    function getValueMarks() {
        var maxOfDimentions = this.model.dimentions.map(function(dim) {
            return dim.data;
        });

        return calculateSequenceScale(this.chartTickSequenceBy(), maxOfDimentions);
    }

    /**
     * Obtem o tamanho do intervalo da escala do gráfico.
     */
    function chartTickSequenceBy() {
        if (this.model.fnTickSequenceBy) {
            return this.model.fnTickSequenceBy();
        }

        var width = this.chart ? this.chart.element.offsetWidth : window.innerWidth;
  
        if (width >= 1000) {
            return 10000;
        } else if (width >= 800) {
            return 15000;
        } else if (width >= 500) {
            return 20000;
        } else {
            return 30000;
        }
    }

    /**
     * Calcula a sequência de valores para apresentação de uma escala.
     * @param {*} sequenceBy Sequência que os valores devem estar distantes.
     * @param {*} dataArray Conjunto de valores ao qual a sequência deve corresponder.
     */
    function calculateSequenceScale(sequenceBy, dataArray) {
        var max = dataArray.length ? Math.max.apply(null, dataArray) : 0;

        if (max % 5 > 0) {
            max = parseInt(max / sequenceBy) * sequenceBy + sequenceBy;
        }

        if (max == 0) {
            max = 30;
        }

        return Array.apply(null, {length: max / sequenceBy + 1}).map(function(e, i) { return i * sequenceBy; });
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('multiGaugeChart', Directive);

    /**
     * Diretiva para inclusão de múltiplos gráficos gauge.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a); },
            scope: {
                /***
                 * {
                 *      charts: [
                 *          gaugeModel,
                 *          gaugeModel,
                 *          gaugeModel
                 *      ]
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/multi-gauge-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('treemapChart', Directive);

    /**
     * Diretiva para inclusão de gráfico treemap.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: function(s, e, a) { link(s, e, a); },
            scope: {
                /**
                 * {
                 *      chartId: 'chartId',
                 *      chartClassName: 'some_css_class',,
                 *      chartTitle: 'title',
                 *      fnFormatTooltip: function(v) { 
                 *          return '$'+v; 
                 *      },
                 *      fnChartBuild: function(chart) { },
                 *      fnDataClickListener: function(categorie) { }
                 *      dimentions: [{
                 *          label: 'qwe',
                 *          color: '#gerer'
                 *          data: 34534.23
                 *      }]
                 * }
                 */
                model: '='
            },
            templateUrl: 'app/template/directives/chart/treemap-chart.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.generate = generate;
        scope.getChartId = getChartId;
        scope.onDataClick = onDataClick;
        scope.getDataArray = getDataArray;
        scope.getChartTitle = getChartTitle;
        scope.formatTooltip = formatTooltip;

        scope.$watch('model', function(model) {
            if (model) {
                scope.chart = scope.generate();

                if (model.fnChartBuild) {
                    model.fnChartBuild(scope.chart);
                }
            }
        });
    }

    /**
     * Gera o gráfico.
     * @returns Gráfico construído.
     */
    function generate() {
        var self = this;
        return new Highcharts.chart(this.getChartId(), {
            chart: {
                backgroundColor: '',
                spacing: [0,0,0,0]
            },
            tooltip: {
                formatter: function() {
                    return self.formatTooltip(this.point.options);
                }
            },
            series: [{
                type: 'treemap',
                layoutAlgorithm: 'squarified',
                cursor: 'pointer',
                animationLimit: 1000,
                style: {
                    fontFamily: 'Montserrat',
                    color: "#5da29a"
                },
                data: this.getDataArray(),
                events: {
                    click: function(e) {
                        self.onDataClick(e.point.options);
                    }
                },
            }],
            exporting: {
                enabled: false
            },
            title: {
                text: this.getChartTitle()
            }
        });
    }

    /**
     * Obtem o ID do elemento visual que deve corresponder ao gráfico.
     */
    function getChartId() {
        return this.model.chartId;
    }

    /**
     * Obtem os dados do gráfico.
     */
    function getDataArray() {
        if (this.model.dimentions) {
            return this.model.dimentions.map(function(dimention) {
                return {
                    name: dimention.label,
                    value: dimention.data,
                    color: dimention.color
                };
            });
        }

        return [];
    }

    /**
     * Retorna o título do gráfico.
     * @returns String referente ao título.
     */
    function getChartTitle() {
        return this.model.chartTitle;
    }

    /**
     * Responde ao evento de click em uma categoria do gráfico.
     * @param {*} d 
     * @param {*} i 
     */
    function onDataClick(value) {
        if (this.model.fnDataClickListener) {
            this.model.fnDataClickListener(value);
        }
    }

    /**
     * Formata o dado exibido no tooltip de uma categora do gráfico.
     * @param {*} data Dado.
     */
    function formatTooltip(dimention) {
        if (this.model.fnFormatTooltip) {
            return this.model.fnFormatTooltip(dimention);
        }

        return dimention.name + ': ' + dimention.value;
    }

})();
(function () {
    'use strict';

    angular.module('portal').directive('despesasRas', Directive);

    /**
     * Diretiva para inclusão da seção que exibe as despesas por região administrativa.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                loading: '=loadFlag',
                error: '=errorFlag',
                model: '='
            },
            templateUrl: 'app/template/directives/despesas-ras/despesas-ras.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.element = element;
        scope.onFullScreenSwitch = onFullScreenSwitch;

        scope.$watch('model', function (newVal) {
            if (newVal) {
                scope.anoAtual = newVal.exercicio;
            }
        });
    }

    /**
     * Responde ao evento de fullscreen na tela.
     */
    function onFullScreenSwitch() {
        this.element.find('.desp_ras_container_content').toggleClass('fullscreen');
    }

})();
(function () {
    'use strict';

    angular.module('portal').directive('mapaRas', MapaRas);

    /**
     * Diretiva para inclusão da barra de super busca.
     */
    function MapaRas($compile) {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                link(scope, element, attrs, $compile);
            },
            scope: {
                currentExercicio: '=exercicio',
                onFullScreenSwitch: '&',
                model: '='
            },
            templateUrl: 'app/template/directives/despesas-ras/mapa-ras.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs, $compile) {
        var _scope = {};

        _scope.scope = scope;
        _scope.cores = ['#FFEDA0', '#FED976', '#FEB24C', '#FD8D3C', '#FC4E2A', '#E31A1C', '#BD0026', '#800026', '#420014'];
        _scope.map = undefined;
        _scope.layerRegioes = undefined;
        _scope.layerDelimitacoes = undefined;
        _scope.regioes = [];
        _scope.despesas = [];
        _scope.regiaoSelecionada;
        _scope.$compile = $compile;
        _scope.directiveElement = element;
        _scope.infoControle = undefined;
        _scope._setClassificacaoByCor = _setClassificacaoByCor;
        _scope._generateClassificacaoByCor = _generateClassificacaoByCor;
        _scope._toggleFullScreen = _toggleFullScreen;
        _scope._createRegioesLayer = _createRegioesLayer;
        _scope._createDelimitacoesLayer = _createDelimitacoesLayer;
        _scope._createFullScreenButton = _createFullScreenButton;
        _scope._onClickDelimitacaoFeature = _onClickDelimitacaoFeature;
        _scope._onMouseOutDelimitacaoFeature = _onMouseOutDelimitacaoFeature;
        _scope._onMouseOverDelimitacaoFeature = _onMouseOverDelimitacaoFeature;
        _scope._onMouseOverRegionalFeature = _onMouseOverRegionalFeature;
        _scope._onMouseOutRegionalFeature = _onMouseOutRegionalFeature;
        _scope._onPopupOpen = _onPopupOpen;
        _scope._onPopupClose = _onPopupClose;
        _scope._highlightDelimitacao = _highlightDelimitacao;
        _scope._unhighlightDelimitacao = _unhighlightDelimitacao;
        _scope._createLegendaDespesa = _createLegendaDespesa;
        _scope._updateLegendaInformativa = _updateLegendaInformativa;
        _scope._hideLegendaInformativa = _hideLegendaInformativa;
        _scope._getDespesa = _getDespesa;
        _scope._getMarker = _getMarker;
        _scope._getDelimitacao = _getDelimitacao;
        _scope._centerPopup = _centerPopup;
        _scope._getColorByDespesa = _getColorByDespesa;
        _scope._compilePopupRA = _compilePopupRA;
        _scope._createMarkerRA = _createMarkerRA;
        _scope._createLegendaInfo = _createLegendaInfo;
        _scope._createMap = _createMap;
        _scope.templatePopupRa = element.find('#popupRaContent').html();

        scope.$watch('model', function (newVal) {
            if (newVal != undefined) {
                _scope.despesas = newVal.despesas;

                if (newVal.despesas && newVal.despesas.length) {
                    _scope._setClassificacaoByCor(newVal.despesas);
                }

                _scope.regioesFeatureCollection = newVal.limites;
                _scope.admsRegioesFeatureCollection = newVal.localizacoes;

                _scope._createMap('mapaRas');
            }
        });
    }

    /**
     * Cria o mapa.
     */
    function _createMap(containerId) {
        //var mapLayer = L.tileLayer('http://www.transparencia.df.gov.br/api/tiles/{s}/{z}/{x}/{y}.png');
        var satelliteLayer = L.tileLayer('http://ortofoto.mapa.codeplan.df.gov.br/tms/1.0.0/mosaico_df_2015@GMComp/{z}/{x}/{y}.png', { tms: true });

        this.map = L.map(containerId, {
            center: [-15.794797016134899, -47.9262052592602],
            zoom: 11,
            maxZoom: 18,
            zoomControl: false,
            //layers: [mapLayer]
        });

        this.layerRegioes = this._createRegioesLayer();
        this.layerRegioes.addTo(this.map);
        this.layerDelimitacoes = this._createDelimitacoesLayer();
        this.layerDelimitacoes.addTo(this.map);

        L.control.layers({
            //'Mapa': mapLayer,
            'Satélite': satelliteLayer
        }, {
            'RAs': this.layerRegioes,
            'Delimitações': this.layerDelimitacoes
        }).addTo(this.map);

        this._createLegendaDespesa().addTo(this.map);

        this.infoControle = this._createLegendaInfo();
        this.infoControle.addTo(this.map);

        L.control.locate({
            position: 'topleft',
            strings: {
                popup: 'Sua localização',
                title: 'Minha localização'
            },
            markerStyle: { alt: 'Minha localização' },
            drawCircle: false,
            keepCurrentZoomLevel: true,
            onLocationError: function (err) { }
        }).addTo(this.map);

        this._createFullScreenButton().addTo(this.map);
    }

    /**
     * Cria a layer de regiões.
     * @returns layer.
     */
    function _createRegioesLayer() {
        var self = this;

        var layer = L.geoJson(undefined, {
            onEachFeature: function (f, layer) {
                layer.on({
                    mouseover: function (e) { self._onMouseOverRegionalFeature(e); },
                    mouseout: function (e) { self._onMouseOutRegionalFeature(e); }
                });
            },
            pointToLayer: function (geoJsonObj, latLng) {
                return self._createMarkerRA(self._getDespesa(geoJsonObj.properties.ordem), latLng);
            }
        });

        if (this.admsRegioesFeatureCollection && this.despesas && this.despesas.length) {
            layer.addData(this.admsRegioesFeatureCollection);
        }

        return layer;
    }

    /**
     * Cria a layer de delimitações das regiões.
     * @returns layer.
     */
    function _createDelimitacoesLayer() {
        var self = this;

        var layer = L.geoJson(undefined, {
            onEachFeature: function (f, layer) {
                layer.on({
                    mouseover: function (e) { self._onMouseOverDelimitacaoFeature(e); },
                    mouseout: function (e) { self._onMouseOutDelimitacaoFeature(e); },
                    click: function (e) { self._onClickDelimitacaoFeature(e); }
                });
            },
            style: function (f) {
                return {
                    weight: 2,
                    opacity: 1,
                    color: 'white',
                    dashArray: '3',
                    fillOpacity: 0.7,
                    /*fillColor: '#00000033'*/
                    fillColor: self._getColorByDespesa(self._getDespesa(f.properties.ordem).valorLiquidado)
                };
            }
        });

        if (this.regioesFeatureCollection && this.despesas && this.despesas.length) {
            layer.addData(this.regioesFeatureCollection);
        }

        return layer;
    }

    /**
     * Cria o maker correspondente a uma coordenada.
     * @param {*} coordenada Array contendo longitude e latitude
     * @returns Marker.
     */
    function _createMarkerRA(regiao, coordenada) {
        var self = this;

        var icon = L.AwesomeMarkers.icon({
            prefix: 'fa',
            icon: 'fa-university',
            markerColor: 'blue',
            /*markerColor: 'orange',*/
            iconColor: '#01355f'
            /*iconColor: '#333'*/
        });

        var marker = L.marker(coordenada, {
            icon: icon
        });

        var popupContent = this._compilePopupRA(regiao);

        var popup = marker.bindPopup(popupContent);

        popup.on('popupopen', function (e) { self._onPopupOpen(e); });
        popup.on('popupclose', function (e) { self._onPopupClose(e); });

        return marker;
    }

    /**
     * Cria a legenda de despesa.
     * @returns Controle correspondente a legenda.
     */
    function _createLegendaDespesa() {
        var self = this;
        var legend = L.control({ position: 'bottomright' });

        legend.onAdd = function (map) {
            var div = L.DomUtil.create('div', 'mapa_ras_info mapa_ras_legend'), labels = [];

            function formatValue(value) {
                return (value / 1000000).toFixed(1);
            }

            if (self.classificacaoByCor) {
                self.classificacaoByCor.forEach(function (level, index) {
                    if (index != self.classificacaoByCor.length - 1) {
                        labels.push('<i class="mapa_ras_legend_level" style="background:' + level.color + '"></i> ' + formatValue(level.base) + '&ndash;' + formatValue(level.next));
                    } else {
                        labels.push('<i class="mapa_ras_legend_level" style="background:' + level.color + '"></i> ' + formatValue(level.base) + '+');
                    }
                });
            }

            var recolher = L.DomUtil.create('div', 'mapa_ras_legend_recolher');
            recolher.innerHTML = '<i class="fa fa-sort-desc mapa_ras_legend_recolher_icon" aria-hidden="true"></i>';

            var title = L.DomUtil.create('div', 'mapa_ras_legend_title');
            title.textContent = 'Milhões (R$)';

            div.innerHTML = recolher.outerHTML + title.outerHTML + labels.join('<br>');

            div.addEventListener('click', function (e) {
                if ($(e.target).hasClass('mapa_ras_legend_recolher') || $(e.target).hasClass('mapa_ras_legend_recolher_icon')) {

                    if ($('.mapa_ras_legend_recolher').hasClass('recolhido')) {
                        $('.mapa_ras_legend').animate({ top: 0 }, 'fast', function () {
                            var $icon = $(this).find('.mapa_ras_legend_recolher_icon');
                            $icon.addClass('fa-sort-desc');
                            $icon.removeClass('fa-sort-asc');
                            $('.mapa_ras_legend_recolher').removeClass('recolhido');
                        });
                    } else {
                        $('.mapa_ras_legend').animate({ top: 180 }, 'fast', function () {
                            var $icon = $(this).find('.mapa_ras_legend_recolher_icon');
                            $icon.removeClass('fa-sort-desc');
                            $icon.addClass('fa-sort-asc');
                            $('.mapa_ras_legend_recolher').addClass('recolhido');
                            $(this).addClass('mapa_ras_legend_recolhido');
                            $(this).removeAttr('style');
                        });
                    }
                }
            });

            return div;
        };

        return legend;
    }

    /**
     * Cria a legenda informativa.
     * @returns Controle correspondente.
     */
    function _createLegendaInfo() {
        var info = L.control({ position: 'bottomleft' });

        info.onAdd = function (map) {
            this._div = L.DomUtil.create('div', 'mapa_ras_info');
            this._div.style.pointerEvents = 'none';
            this.update();
            return this._div;
        };

        info.update = function (props) {
            if (props) {
                this._div.style.display = 'block';
                this._div.innerHTML = '<h4>Despesa - Regionais</h4><span class="mapa_ras_info_nome">' + props.nomeRA + '</span><br />R$ ' + (props.valorLiquidado / 1000000).toFixed(2) + ' milhões';
            } else {
                this._div.style.display = 'none';
            }
        };

        return info;
    }

    /**
     * Obtem a despesa de uma regional correspondente a uma ordem.
     * @param {*} ordem Ordem.
     * @returns Objeto contendo nome e despesa da regional.
     */
    function _getDespesa(ordem) {
        return this.despesas[ordem];
    }

    /**
     * Obtem a layer correspondente a delimitação regional de uma ordem
     * @param {*} ordem Ordem.
     * @returns Layer.
     */
    function _getDelimitacao(ordem) {
        return this.layerDelimitacoes.getLayers().filter(function (l) {
            return l.feature.properties.ordem == ordem;
        })[0];
    }

    /**
     * Obtem o marker correspondente a uma ordem.
     * @param {*} ordem Ordem.
     * @returns Marker layer.
     */
    function _getMarker(ordem) {
        return this.layerRegioes.getLayers().filter(function (l) {
            return l.feature.properties.ordem == ordem;
        })[0];
    }

    /**
     * Cria o botão da funcionalidade de tela cheia.
     * @returns Controle referente ao botão.
     */
    function _createFullScreenButton() {
        var self = this;

        return L.easyButton({
            id: 'mapaRasBtnFullScreen',
            states: [
                {
                    stateName: 'expand',
                    icon: 'fa-arrows-alt',
                    title: '',
                    onClick: function (control) {
                        control.state('minimize');
                        self._toggleFullScreen();
                    }
                }, {
                    stateName: 'minimize',
                    icon: 'fa-compress',
                    title: '',
                    onClick: function (control) {
                        control.state('expand');
                        self._toggleFullScreen();
                    }
                }
            ]
        });
    }

    /**
     * Responde ao evento de click em um feature da layer de delimitações.
     * @param {*} event Evento produzido.
     */
    function _onClickDelimitacaoFeature(event) {
        var marker = this._getMarker(event.target.feature.properties.ordem);

        if (marker) {
            marker.openPopup();
        }
    }

    /**
     * Responde ao evento mouseover em um feature da layer de regionais.
     * @param {*} event Evento produzido.
     */
    function _onMouseOverRegionalFeature(event) {
        var layer = event.target;

        if (this.regiaoSelecionada == undefined) {
            this._highlightDelimitacao(this._getDelimitacao(layer.feature.properties.ordem));

            this._updateLegendaInformativa(this._getDespesa(layer.feature.properties.ordem));
        }
    }

    /**
     * Responde ao evento mouseout em um feature da layer de regionais.
     * @param {*} event Evento produzido.
     */
    function _onMouseOutRegionalFeature(event) {
        var layer = event.target;

        if (this.regiaoSelecionada == undefined || this.regiaoSelecionada != layer.feature.properties.ordem) {
            this._unhighlightDelimitacao(this._getDelimitacao(layer.feature.properties.ordem));

            this._hideLegendaInformativa();
        }
    }

    /**
     * Responde ao evento mouseover em um feature da layer de delimitações.
     * @param {*} event Evento produzido.
     */
    function _onMouseOverDelimitacaoFeature(event) {
        if (this.regiaoSelecionada == undefined) {
            this._highlightDelimitacao(event.target);

            this._updateLegendaInformativa(this._getDespesa(event.target.feature.properties.ordem));
        }
    }

    /**
     * Responde ao evento mouseout em um feature da layer de delimitações.
     * @param {*} event Evento produzido.
     */
    function _onMouseOutDelimitacaoFeature(event) {
        var layer = event.target;

        if (this.regiaoSelecionada == undefined || this.regiaoSelecionada != layer.feature.properties.ordem) {
            this._unhighlightDelimitacao(layer);

            this._hideLegendaInformativa();
        }
    }

    /**
     * Responde ao evento em que um popup é aberto.
     * @param {*} event Evento.
     */
    function _onPopupOpen(event) {
        this._centerPopup(event.popup);

        this.regiaoSelecionada = event.sourceTarget.feature.properties.ordem;

        this._highlightDelimitacao(this._getDelimitacao(this.regiaoSelecionada));

        this._hideLegendaInformativa();
    }

    /**
     * Responde ao evento em que um popup é fechado.
     * @param {*} event Evento.
     */
    function _onPopupClose(event) {
        if (this.regiaoSelecionada) {
            this._unhighlightDelimitacao(this._getDelimitacao(this.regiaoSelecionada));
            this.regiaoSelecionada = undefined;
        }
    }

    /**
     * Destaca uma delimitação.
     * @param {*} layer Layer correspondente a delimitação.
     */
    function _highlightDelimitacao(layer) {
        layer.setStyle({
            weight: 5,
            color: '#666',
            dashArray: '',
            fillOpacity: 0.7/*,
            fillColor: '#00000066'*/
        });

        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
            layer.bringToFront();
        }
    }

    /**
     * Desfaz o destacamento de uma delimitação.
     * @param {*} layer Layer correspondente a delimitação.
     */
    function _unhighlightDelimitacao(layer) {
        this.layerDelimitacoes.resetStyle(layer);
    }

    /**
     * Atualiza a legenda informativa com uma despesa.
     * @param {*} despesa Despesa.
     */
    function _updateLegendaInformativa(despesa) {
        this.infoControle.update(despesa);
    }

    /**
     * Oculta a legenda informativa.
     */
    function _hideLegendaInformativa() {
        this.infoControle.update();
    }

    /**
     * Compila o popup para região.
     * @param {*} regiao Região.
     * @returns HTMLElement referente ao Popup compilado.
     */
    function _compilePopupRA(regiao) {
        var scopeRegiao = this.scope.$new();
        scopeRegiao.regiao = regiao;

        regiao.exercicio = this.scope.model.exercicio;

        return this.$compile(this.templatePopupRa)(scopeRegiao)[0];
    }

    /**
     * Centraliza um popup no mapa.
     * @param {*} popup Popup
     */
    function _centerPopup(popup) {
        var px = this.map.project(popup._latlng);
        px.y -= popup._container.clientHeight / 2;
        this.map.panTo(this.map.unproject(px), { animate: true });
    }

    /**
     * Obtem a cor respectiva ao valor de uma despesa.
     * @param {*} despesa Valor da despesa.
     * @returns Valor em hexadecimal da cor.
     */
    function _getColorByDespesa(despesa) {
        var higherPair = this.classificacaoByCor[this.classificacaoByCor.length - 1];

        if (despesa >= higherPair.next) {
            return higherPair.color;
        }

        return this.classificacaoByCor.filter(function (p) {
            return despesa >= p.base && despesa < p.next;
        })[0].color;
    }

    /**
     * Alterna a funcionalidade de tela cheia do mapa.
     */
    function _toggleFullScreen() {
        var self = this;

        this.directiveElement.toggleClass('mapa_fullscreen');

        this.scope.onFullScreenSwitch();

        setTimeout(function () {
            self.map.invalidateSize();
        }, 50);
    }

    /**
     * Configura o conjunto classificador de cores.
     * @param {*} despesas Despesas.
     */
    function _setClassificacaoByCor(despesas) {
        var maxDespesa = Math.max.apply(null, despesas.map(function (d) { return d.valorLiquidado; }));

        this.classificacaoByCor = this._generateClassificacaoByCor(this.cores, maxDespesa);
    }

    /**
     * Produz o conjunto de níveis que classificam um valor por cor.
     * @param {*} colorArray Array de corres que representaram os níveis da classificação.
     * @param {*} maxValue Valor máximo.
     * @returns Array contendo intervalos e respectiva cor.
     */
    function _generateClassificacaoByCor(colorArray, maxValue) {
        var prog = maxValue / (colorArray.length - 1);

        var levelArray = [];
        for (var i = prog; i <= maxValue; i += prog) {
            levelArray.push(i);
        }
        if (levelArray[levelArray.length - 1] != maxValue) {
            levelArray.push(maxValue);
        }

        var pairs = [{
            base: 0,
            next: levelArray[0],
            color: colorArray[0]
        }];

        levelArray.reduce(function (prev, next, currentIndex) {
            pairs.push({
                base: prev,
                next: next,
                color: colorArray[currentIndex]
            });
            return next;
        });

        return pairs;
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('detalheAno', Directive);

    /**
     * Diretiva para inclusão do detalhe de receitas e despesas de um ano.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                balanco: '=',
                loading: '=?loadFlag',
                error: '=?errorFlag'
            },
            templateUrl: 'app/template/directives/evolucao-anual/detalhe-ano.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('evolucaoAnual', Directive);

    /**
     * Diretiva para inclusão da página que apresenta a evolução anual de despesas e receitas.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                balanco: '=',
                loading: '=?loadFlag',
                error: '=?errorFlag'
            },
            templateUrl: 'app/template/directives/evolucao-anual/evolucao-anual.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope._setBalanco = _setBalanco;
        scope.$watch('balanco', function(newVal) {
            if (newVal != undefined) {
                scope._setBalanco(newVal);
            }
        });

    }

    /**
     * Configura os modelos de dados de maneira a representa um conjunto de balanços.
     * @param {*} balancos Lista de balanços de despesas e receitos por ano.
     */
    function _setBalanco(balancos) {
        var balancos = balancos.slice();

        balancos.sort(function(b1, b2) {
            return b1.ano - b2.ano;
        });

        this.chartData = {
            anos: balancos.map(function(b) { return b.ano; }),
            receitas: balancos.map(function(b) { return b.receita; }),
            despesas: balancos.map(function(b) { return b.despesa; })
        };

        balancos = balancos.filter(function(b) { return !b.isAnoCorrente(); });

        this.anos = balancos.length <= 4 ? balancos : balancos.slice(balancos.length - 4);
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('graficoAnual', Directive);

    /**
     * Diretiva para inclusão do componente de apresentação do gráfico de receitas e despesas anuais.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                headerMsg: '=',
                model: '=',
                loading: '=?loadFlag',
                error: '=?errorFlag'
            },
            templateUrl: 'app/template/directives/evolucao-anual/grafico-anual.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.focusOn = focusOn;
        scope.unfocus = unfocus;
        scope._generateChart = _generateChart;
        scope._buildChartModel = _buildChartModel;

        scope.$watch('model', function(newVal) {
            var data = newVal != undefined ? newVal : {
                anos: [], despesas: [], receitas: []
            };

            scope._generateChart('graficoAnualChart', data);
        });
    }

    /**
     * Realiza a geração do gráfico.
     * @param {*} chartContainerId ID do elemento container do gráfico.
     * @param {*} data Dados.
     */
    function _generateChart(chartContainerId, data) {
        var scope = this;

        scope.chartModel = scope._buildChartModel(data);

        scope.chart = c3.generate({
            bindto: '#' + chartContainerId,
            legend: { show: false },
            grid: {
                x: { show: true },
                y: { show: true }
            },
            axis: {
                x: { type: 'category' },
                y: {
                    min: 0,
                    tick: {
                      values: scope.chartModel.getValueMarks(),
                      format: function(d) {
                          return 'R$ ' + parseInt(d) + ' bilhões';
                      }
                    }
                }
            },
            data: {
                x: 'x',
                columns: [ ['x'].concat(scope.chartModel.categories) ].concat(scope.chartModel.dimentions.map(function(dim) {
                    return [dim.label].concat(dim.data);
                }))
            }, color: {
                pattern: scope.chartModel.getDimentionsColors()
            },
            tooltip: {
                format: {
                    value: function (value) { return 'R$ ' + value.toFixed(3) + ' bilhões'; }
                }
            },
            size: { height: 225 }
        });
    }

    /**
     * Controí o modelo de dados para o gráfico.
     * @param {*} data Dados.
     * @returns Objeto modelo.
     */
    function _buildChartModel(data) {
        return {
            categories: data.anos,
            dimentions: [
                {
                    label: 'receitas',
                    color: '#1EC8C9',
                    data: data.receitas.map(function(val) { return val / 1000000000; })
                },{
                    label: 'despesas',
                    color: '#DC3237',
                    data: data.despesas.map(function(val) { return val / 1000000000; })
                }
            ],
            // Obtem o conjunto de cores correspondentes as dimensões do gráfico.
            getDimentionsColors: function() {
                return this.dimentions.map(function(dim) { return dim.color; });
            },
            // Obtem o conjunto de valores que marcam a escala de valores.c3-tooltip-container
            getValueMarks: function() {
                var sequenceBy = 5;

                var maxOfDimentions = this.dimentions.filter(function(dim) {
                    return dim.data.length > 0;
                }).map(function(dim) {
                    return Math.max.apply(null, dim.data);
                });

                var max = maxOfDimentions.length ? Math.max.apply(null, maxOfDimentions) : 0;

                if (max % 5 > 0) {
                    max = parseInt(max / sequenceBy) * sequenceBy + sequenceBy;
                }

                if (max == 0) {
                    max = 30;
                }

                return Array.apply(null, {length: max / sequenceBy + 1}).map(function(e, i) { return i * sequenceBy; });
            }
        };
    }

    /**
     * Aciona o foco sobre uma dimensão do gráfico.
     * @param {*} dimentionLabel Label correspondente a dimensão.
     */
    function focusOn(dimentionLabel) {
        if (this.chart) {
            this.chart.focus(dimentionLabel);
        }
    }

    /**
     * Remove o foco acionado no gráfico.
     */
    function unfocus() {
        if (this.chart) {
            this.chart.revert();
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('listaDetalhe', Directive);

    /**
     * Diretiva para inclusão da lista de detalhes de receitas e despesas anuais.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                balancos: '=',
                loading: '=?loadFlag',
                error: '=?errorFlag'
            },
            templateUrl: 'app/template/directives/evolucao-anual/lista-detalhe.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope._setBalancos = _setBalancos;
        scope.$watch('balancos', function(newVal) {
            scope._setBalancos(newVal);
        });
    }

    /**
     * Configura uma nova lista de balanços.
     * @param {*} balancos Balanços.
     */
    function _setBalancos(balancos) {
        if (balancos == undefined) {
            this.years = lastYears(4).map(function(year) {
                return {
                    ano: year,
                    receita: 0,
                    despesas: 0,
                    calcPercentual: function() { return 0; }
                }
            });
        } else {
            this.years = balancos;
        }
    }

    /**
     * Obtem a lista dos últimos anos.
     * @param {*} yearsAgo Tamanho da lista.
     */
    function lastYears(yearsAgo) {
        var currYear = new Date().getFullYear();

        return Array.apply(null, {length: yearsAgo}).map(function(e, i) {
            return currYear - (i + 1);
        }).sort();
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('cardProgressBars', CardProgressBars);

    /**
     * Diretiva para inclusão da página de Execução da Despesa.
     */
    function CardProgressBars($window, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'app/template/directives/execucao-despesa/card-progress-bars.html',
            scope: {
                estagio: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            link: link
        };
        
    }

    function link(scope, element, attrs) {
        $(".progress-bar").animate({}, 1500);
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('execucaoDespesa', ExecucaoDespesa);

    /**
     * Diretiva para inclusão da página de Execução da Despesa.
     */
    function ExecucaoDespesa($window, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'app/template/directives/execucao-despesa/execucao-despesa.html',
            link: function(scope, element, attrs) {
                scope.gaugeSize = getGaugeSize();

                /* Ajusta tamanho do gauge de acordo com o tamanho da tela */
                window.matchMedia(MOBILE_MEDIA).addListener(function(media) {
                    scope.gaugeSize = getGaugeSize();
                });
            }
        };
    }

    /**
     * Obtem o tamanho do gauge.
     * @param {*} windowMedia Media ao qual o tamanho deve se adequar.
     */
    function getGaugeSize(windowMedia) {
        var condition = windowMedia != undefined ? windowMedia.matches : isMobileMediaMatched();

        return condition ? 280 : 310;
    }

    /**
     * Verifica se a janela está adequada para a mobile media.
     */
    function isMobileMediaMatched() {
        return window.matchMedia(MOBILE_MEDIA).matches;
    }

    var MOBILE_MEDIA = '(max-width: 991px)';

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('gauge', Directive);
    
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                size: '=',
                percent: '='
            },
            templateUrl: 'app/template/directives/execucao-despesa/gauge.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.$containers = element.find('.gauge_container');
        scope.$containersFillBar = element.find('.gauge_fill_bar_container');
        scope.$bars = element.find('.gauge_fill_bar_container > .bar');
        scope.$containerMarks = element.find('.gauge_marks_container');
        scope.$containerMarksLabels = element.find('.gauge_marks_label_container');
        scope.$indicator = element.find('.gauge_indicator');
        scope.$gaugeBox = element.find('.gauge_box');
        scope._getPercentAngle = _getPercentAngle;
        scope._getMarkCoords = _getMarkCoords;
        scope._getMarkRotate = _getMarkRotate;
        scope._getMarkLabelCoords = _getMarkLabelCoords;
        scope.getIndicatorRotation = getIndicatorRotation;
        scope.getPercentLabel = getPercentLabel;
        scope.getLeftFillBarContainerRotate = getLeftFillBarContainerRotate;
        scope.getRightFillBarContainerRotate = getRightFillBarContainerRotate;
        scope.getLeftFillBarRotate = getLeftFillBarRotate;
        scope.getRightFillBarRotate = getRightFillBarRotate;
        scope.getContainerLeftRotation = getContainerLeftRotation;
        scope.getContainerRightRotation = getContainerRightRotation;
        scope._configureSize = _configureSize;
        scope.getMarkCoords = function(m) { return scope._getMarkCoords(m); };
        scope.getMarkLabelCoords = function(m) { return scope._getMarkLabelCoords(m); };
        scope.getMarkRotate = function(m) { return scope._getMarkRotate(m); };
        scope.getBorderWidth = function() { return scope.config.borderWidth(); };
        scope.marks = [ 0,10,20,30,40,50,60,70,80,90,100 ].map(function(p) {
            return {
                label: String(p),
                percent: p,
                first: p == 0,
                last: p == 100
            };
        });

        scope.config = {
            aperture: 120,
            gaugeBoxSize: scope.size,
            leftAperture: function() { return 90 - (this.aperture / 2); },
            rightAperture: function() { this.leftAperture(); },
            totalGaugeAngule: function() { return 360 - this.aperture; },
            startMarkAngule: function() { return 90 + (this.aperture / 2); },
            endMarkAngule: function() { return this.startMarkAngule() + this.totalGaugeAngule(); },
            containerMarksSize: function() { return this.gaugeBoxSize * 92 / 100; },
            containerMarksLabelSize: function() { return this.gaugeBoxSize * 74 / 100; },
            halfPercent: function() { return 180 * 100 / this.totalGaugeAngule(); },
            borderWidth: function() { return this.gaugeBoxSize > 300 ? 25 : 23 }
        };

        scope._configureSize(scope.config.gaugeBoxSize);

        scope.$watch('size', function(newVal) {
            if (newVal != undefined && scope.config.gaugeBoxSize != newVal) {
                scope._configureSize(newVal);
            }
        });
    }

    /**
     * Configura o tamanho do componente.
     * @param {*} size Tamanho.
     */
    function _configureSize(size) {
        this.config.gaugeBoxSize = size;

        this.$gaugeBox.width(this.config.gaugeBoxSize);
        this.$gaugeBox.height(this.config.gaugeBoxSize);
        this.$containerMarks.width(this.config.containerMarksSize());
        this.$containerMarks.height(this.config.containerMarksSize());
        this.$containerMarksLabels.width(this.config.containerMarksLabelSize());
        this.$containerMarksLabels.height(this.config.containerMarksLabelSize());

        this.$containers.css('clip', 'rect(0px, ' + this.config.gaugeBoxSize + 'px, ' + (this.config.gaugeBoxSize / 2) + 'px, 0px)');
        this.$containersFillBar.css('clip', 'rect(0,' + (this.config.gaugeBoxSize / 2) + 'px,' + this.config.gaugeBoxSize + 'px,0px)');

        var $containersFillBarRight = this.$containersFillBar.filter(function(i, e) { return e.className.indexOf('right') >= 0; });
        $containersFillBarRight.css('clip', 'rect(0,' + (this.config.gaugeBoxSize / 2 - 0.6) + 'px,' + this.config.gaugeBoxSize + 'px,0px)');

        this.$bars.css('clip', 'rect(0,' + this.config.gaugeBoxSize + 'px,' + this.config.gaugeBoxSize + 'px,' + (this.config.gaugeBoxSize / 2) + 'px)');
    }

    /**
     * Obtem a rotação do container esquerdo para se adequar a abertura do gauge.
     * @returns Valor numérico em degres.
     */
    function getContainerLeftRotation() {
        return this.getContainerRightRotation() * (-1);
    }

    /**
     * Obtem a rotação do container direito para se adequar a abertura do gauge.
     * @returns Valor numérico em degres.
     */
    function getContainerRightRotation() {
        return 90 - (this.config.aperture / 2);
    }

    /**
     * Obtem a rotação que o container da barra de preenchimento esquerda deve ser configurado.
     * @returns Valor numérico em degres.
     */
    function getLeftFillBarContainerRotate() {
        return this.config.aperture / 2;
    }

    /**
     * Obtem a rotação que o container da barra de preenchimento direita deve ser configurado.
     * @returns Valor numérico em degres.
     */
    function getRightFillBarContainerRotate() {
        return this.config.totalGaugeAngule() / 2;
    }

    /**
     * Obtem a rotação que a barra de preenchimento esquerda deve apresentar.
     * @returns Valor numérico em degres.
     */
    function getLeftFillBarRotate() {
        if (this.percent >= this.config.halfPercent()) {
            return 180;
        }

        return this._getPercentAngle(this.percent) - this.config.startMarkAngule();
    }

    /**
     * Obtem a rotação que a barra de preenchimento direita deve apresentar.
     * @returns Valor numérico em degres.
     */
    function getRightFillBarRotate() {
        if (this.percent <= this.config.halfPercent()) {
            return 0;
        }

        var halfPercent = this.config.halfPercent();

        return this._getPercentAngle(halfPercent) - this._getPercentAngle(100 - halfPercent) + (this._getPercentAngle(this.percent - halfPercent) - this.config.startMarkAngule());
    }

    /**
     * Obtem a coordenada referente ao topo e lado esquerdo para um mark.
     * @param {*} mark Mark.
     */
    function _getMarkCoords(mark) {
        var angle = this._getPercentAngle(mark.percent);
        var containerWidth = this.config.containerMarksSize();
        var containerHeight = this.config.containerMarksSize();

        return _getAngleCoords(angle, containerWidth, containerHeight);
    }

    /**
     * Obtem as coordenadas referente ao topo e lado esquerdo para a label de um mark.
     * @param {*} mark Mark.
     */
    function _getMarkLabelCoords(mark) {
        var angle = this._getPercentAngle(mark.percent);
        var containerWidth = this.config.containerMarksLabelSize();
        var containerHeight = this.config.containerMarksLabelSize();

        return _getAngleCoords(angle, containerWidth, containerHeight);
    }

    /**
     * Obtem a rotação em degres que um marcador deve ter para ficar paralelo ao raio da circunferência.
     * @param {*} mark Marcador.
     * @returns Valor numérico em degres.
     */
    function _getMarkRotate(mark) {
        var angle = this._getPercentAngle(mark.percent);

        return angle + 90;
    }

    /**
     * Obtem a rotação necessária para o indicador apontar para o atual percentual.
     * @returns Valor numérico em degres.
     */
    function getIndicatorRotation() {
        var angle = this._getPercentAngle(this.percent);

        return angle + 90;
    }

    /**
     * Obtem o valor do percentual a ser exibido.
     * @returns Valor.
     */
    function getPercentLabel() {
        return Number(this.percent).toFixed(2);
    }

    /**
     * Obtem o angulo dentro da corbertura do gauge correspondente a um percentual.
     * @param {*} percent Percentual de 0 a 100.
     */
    function _getPercentAngle(percent) {
        return (percent * .01) * this.config.totalGaugeAngule() + this.config.startMarkAngule();
    }

    /**
     * Calcula a coordenada de um ponto na borda de uma circunferência dentro de um retângulo.
     * @param {*} angle Angulo.
     * @param {*} w Largula do retângulo.
     * @param {*} h Altura do retângulo.
     * @returns Array contendo as coordenadas refentes ao topo e ao lado esquerdo.
     */
    function _getAngleCoords(angle, w, h) {
        angle *= Math.PI/180;

        return [
            Math.cos(angle) * w/2 + w/2,
            Math.sin(angle) * h/2 + h/2
        ];
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('orcamentoAprovadoDisplay', Directive);
    
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                valor: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/execucao-despesa/orcamento-aprovado-display.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('yearPicker', Directive);
    
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                value: '=',
                list: '=',
                label: '=?',
                clickListener: '&',
                loading: "=loadFlag",
                error: "=errorFlag"
            },
            templateUrl: 'app/template/directives/execucao-despesa/year-picker.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onClickLeftArrow = onClickLeftArrow;
        scope.onClickRightArrow = onClickRightArrow;
        scope.isCurrentFistValue = isCurrentFistValue;
        scope.isCurrentLastValue = isCurrentLastValue;
        scope.nextValue = nextValue;
        scope.previousValue = previousValue;
        scope.setValue = setValue;
        scope._queueChange = _queueChange;
    }

    /**
     * Responde ao evento de click na left arrow.
     */
    function onClickLeftArrow() {
        this.setValue(this.previousValue());
    }

    /**
     * Responde ao evento de click na right arrow.
     */
    function onClickRightArrow() {
        this.setValue(this.nextValue());
    }

    /**
     * Obtem o valor subsequente ao selecionado.
     * @returns Próximo valor; null, caso o mesmo não exista.
     */
    function nextValue() {
        if (this.list) {
            var self = this;
            var value = Math.min.apply(null, this.list.filter(function(v) {
                return v > self.value;
            }));

            if (value != Infinity && value != -Infinity) {
                return value;
            }
        }
        return null;
    }

    /**
     * Obtem o valor anterior ao selecionado.
     * @returns Valor anterior; null, caso o mesmo não exista.
     */
    function previousValue() {
        if (this.list) {
            var self = this;
            var value = Math.max.apply(null, this.list.filter(function(v) {
                return v < self.value;
            }));

            if (value != Infinity && value != -Infinity) {
                return value;
            }
        }
        return null;
    }

    /**
     * Configura um valor como selecionado.
     * @param {*} value Valor.
     */
    function setValue(value) {
        if (this.list.indexOf(value) != -1) {
            this.value = value;
            this._queueChange(value);
        }
    }

    /**
     * Adiciona uma mudança para a fila de espera.
     * @param {*} value Valor.
     */
    function _queueChange(value) {
        var self = this;

        if (this.currentChange != undefined) {
            clearTimeout(this.currentChange);
        }

        this.currentChange = setTimeout(function() {
            self.clickListener({selected: value});
            self.currentChange = undefined;
        }, 250);
    }

    /**
     * Verifica se o atual valor corresponde ao primeiro da lista de valores.
     * @returns True, valor é o primeiro da lista; false, caso contrário.
     */
    function isCurrentFistValue() {
        return this.previousValue() == null;
    }

    /**
     * Verifica se o atual valor corresponde ao último da lista de valores.
     * @returns True, valor é o último da lista; false, caso contrário.
     */
    function isCurrentLastValue() {
        return this.nextValue() == null;
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('nossosContatos', NossosContatos);

    function NossosContatos() {
        return {
            restrict: 'E',
            templateUrl: 'app/template/directives/nossos-contatos/nossos-contatos.html',
            scope: {
            },
            link: link
        };
        
    }

    function link(scope, element, attrs) {
        
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('numericDisplayGroup', Directive);

    /**
     * Diretiva para inclusão de grupo de dígitos do componente numeric-display.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                label: '=',
                value: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/numeric-display/numeric-display-group.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.havingError = false;
        scope.enableLoading = enableLoading;
        scope.setErrorFlag = setErrorFlag;
        scope.$digitosContainer = element.find('.digitos_container');

        scope.$watch('loading', function(newVal) {
            scope.enableLoading(newVal);
        });

        scope.$watch('error', function(newVal) {
            scope.setErrorFlag(newVal);
        });
    }

    /**
     * Configura o indicador de erro.
     * @param {*} newVal True, houve um erro; false, caso contrário.
     */
    function setErrorFlag(newVal) {
        if (newVal != undefined) {
            this.havingError = newVal;
            
            if (newVal) {
                this.$digitosContainer.addClass('having_error');
            } else {
                this.$digitosContainer.removeClass('having_error');
            }
        }
    }

    /**
     * Controla o loading.
     * @param {*} enable True, loading  ativo.
     */
    function enableLoading(enable) {
        if (!this._loadingFlag && enable == true) {
            this.$digitosContainer.addClass('loading');

            this._loadingFlag = true;
        } else if (this._loadingFlag && enable == false) {
            this.$digitosContainer.removeClass('loading');

            this._loadingFlag = false;
        }
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('numericDisplay', Directive);

    /**
     * Diretiva para inclusão de componente que apresenta um display numérico.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                valor: '=',
                loading: '=loadFlag',
                error: '=errorFlag'
            },
            templateUrl: 'app/template/directives/numeric-display/numeric-display.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope._buildCasasList = _buildCasasList;
    
        scope.$watch('valor', function(newVal) {
            scope.casas = scope._buildCasasList(newVal);
        });
    }

    /**
     * Constroi a lista de casas numéricas para um valor.
     * @param {*} number Valor numérico.
     */
    function _buildCasasList(number) {
        var casas = [];

        if (number > 0) {
            var integerOnly = Math.floor(number);

            var integerHouses = String(integerOnly).replace(/(\d{1,2}?)((\d{3})+)$/, "$1,$2").replace(/(\d{3})(?=\d)/g, "$1,").split(',').reverse();

            for (var i = 0; i < integerHouses.length; i++) {
                casas.push({ label: CASAS_LABEL[i + 1], valor: integerHouses[i] });
            }

            casas.reverse();
            casas.push({
                label: CASAS_LABEL[0],
                valor: (number % 1).toFixed(2).substring(2)
            });
        } else {
            for (var i = 4; i >= 1; i--) {
                casas.push({ label: CASAS_LABEL[i], valor: '000' });
            }
            
            casas.push({ label: CASAS_LABEL[0], valor: '00' });
        }

        return casas;
    }

    var CASAS_LABEL = [
        'centavos',
        'reais',
        'mil',
        'milhões',
        'bilhões',
        'trilhões',
    ];


})();
(function() {
    'use strict';

    angular.module('portal').directive('pesquisaSatisfacao', PesquisaSatisfacao);

    function PesquisaSatisfacao() {
        return {
            restrict: 'E',
            scope: {
                onPesquisaEnviada: '&?'
            },
            templateUrl: 'app/template/directives/pesquisa-satisfacao/pesquisa-satisfacao.html',
            link: function(scope, element, attrs) {
                scope.form = {};
                scope.$containerMotivo =  element.find('.container-motivo-insatisfacao .card-motivo');
                scope.$containerComentario =  element.find('.container-motivo-insatisfacao .card-comentario');
                scope.$containerComentarioAdicional = element.find('.container-motivo-insatisfacao .card-comentario-adicional');

                scope.onClickBtnDeixarComentario = function() {
                    scope.$containerComentarioAdicional.slideDown();
                    scope.comentarioAdicionalExibido = true;
                };

                scope.onOptionSelected = function(option) {
                    if (option.onSelected != undefined) {
                        option.onSelected();
                    }
                };
                scope.onOptionInsatisfacaoMotivoSelected = function(option) {
                    scope.$containerComentario.slideDown();
                }

                function onOptionInsatisfacaoSelected(option) {
                    scope.$containerMotivo.slideDown();
                    scope.$containerComentarioAdicional.slideUp();
                    scope.motivoDesagradoExibido = true;
                    scope.comentarioAdicionalExibido = false;
                }

                function onOptionSatisfacaoSelected(option) {
                    scope.$containerMotivo.slideUp();
                    scope.$containerComentario.slideUp();
                    delete scope.form.desagrado;
                    scope.motivoDesagradoExibido = false;
                }

                scope.optionsOcupacao = [
                    {
                        id: 'radio-servidor',
                        name: 'servidor',
                        value: 'SERVIDOR'
                    },{
                        id: 'radio-jornalista',
                        name: 'jornalista',
                        value: 'JORNALISTA'
                    },{
                        id: 'radio-estudante',
                        name: 'estudante',
                        value: 'ESTUDANTE'
                    },{
                        id: 'radio-advogado',
                        name: 'advogado',
                        value: 'ADVOGADO'
                    },{
                        id: 'radio-empresario',
                        name: 'empresário',
                        value: 'EMPRESARIO'
                    },{
                        id: 'radio-outros',
                        name: 'outros',
                        value: 'OUTROS'
                    }
                ];

                scope.optionsFaixaEtaria = [
                    {
                        id: 'radio-29-anos',
                        name: 'até 29',
                        value: 'ATE_29_ANOS'
                    },{
                        id: 'radio-30-39-anos',
                        name: '30 - 39',
                        value: 'DE_30_A_39_ANOS'
                    },{
                        id: 'radio-40-49-anos',
                        name: '40 - 49',
                        value: 'DE_40_A_49_ANOS'
                    },{
                        id: 'radio-50-59-anos',
                        name: '50 - 59',
                        value: 'DE_50_A_59_ANOS'
                    },{
                        id: 'radio-60-mais',
                        name: '60 ou mais',
                        value: 'DE_60_OU_MAIS'
                    }
                ];

                scope.optionsSatisfacao = [
                    {
                        id: 'radio-muito-satisfeito',
                        name: 'muito satisfeito',
                        value: 'MUITO_SATISFEITO',
                        onSelected: function() { onOptionSatisfacaoSelected(this); }
                    },{
                        id: 'radio-satisfeito',
                        name: 'satisfeito',
                        value: 'SATISFEITO',
                        onSelected: function() { onOptionSatisfacaoSelected(this); }
                    },{
                        id: 'radio-indiferente',
                        name: 'indiferente',
                        value: 'INDIFERENTE',
                        onSelected: function() { onOptionSatisfacaoSelected(this); }
                    },{
                        id: 'radio-insatisfeito',
                        name: 'insatisfeito',
                        value: 'INSATISFEITO',
                        onSelected: function() { onOptionInsatisfacaoSelected(this); }
                    },{
                        id: 'radio-muito-insatisfeito',
                        name: 'muito insatisfeito',
                        value: 'MUITO_INSATISFEITO',
                        onSelected: function() { onOptionInsatisfacaoSelected(this); }
                    }
                ];

                scope.optionsInsatisfacao = [
                    {
                        id: 'radio-nao-encontrei',
                        name: 'Não encontrei o que queria',
                        value: 'Nao_Encontrei'
                    },{
                        id: 'radio-nav-dificil',
                        name: 'Achei a navegação difícil',
                        value: 'Navegacao_Dificil'
                    },{
                        id: 'radio-duas-opcoes',
                        name: 'As duas opções',
                        value: 'As_Duas_Opcoes'
                    },{
                        id: 'radio-outros',
                        name: 'Outros',
                        value: 'Outros'
                    }
                ];
            }
        };
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('rodape', Rodape);

    function Rodape() {
        return {
            restrict: 'E',
            templateUrl: 'app/template/directives/rodape/rodape.html',
            scope: {
            },
            link: link
        };
        
    }

    function link(scope, element, attrs) {
        
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('setorDesejado', SetorDesejado);

    function SetorDesejado($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'app/template/directives/setor-desejado/setor-desejado.html',
            scope: {
                slides: '=',
                loading: '=loadFlag',
                error: '=errorFlag',
                ano: '=ano'
            },
            link: function(s, e, a) { link(s, e, a, $timeout); }
        };
    }

    function link(scope, element, attrs, $timeout) {
        scope.toggleGallery = toggleGallery;
        scope.$carouselGallery = element.find('.carousel-wrap');
        scope.$gridGallery = element.find('.cards-grid');

        scope.$watch('slides', function(newVal) {
            if (newVal != undefined) {
                $timeout(function() {
                    renderCarousel(element.find('.owl-carousel'));
                });
            }
        });

        function onFlagChange() {
            setTimeout(function() {
                if (scope.loading || scope.error) {
                    scope.$carouselGallery.addClass('flaging');
                } else {
                    scope.$carouselGallery.removeClass('flaging');
                }
            }, 100);
        }

        scope.$watch('loading', onFlagChange);
        scope.$watch('error', onFlagChange);
    }

    function toggleGallery() {
        var self = this;
        var outSpeed = 250, inSpeed = 400;

        if (this.$carouselGallery.is(':visible')) {
            this.$carouselGallery.slideUp({
                easing: 'linear',
                duration: outSpeed,
                complete: function() {
                    self.$gridGallery.slideDown({
                        easing: 'swing',
                        duration: inSpeed
                    });
                }
            });
        } else {
            this.$gridGallery.slideUp({
                easing: 'linear',
                duration: outSpeed,
                complete: function() {
                    self.$carouselGallery.slideDown({
                        easing: 'swing',
                        duration: inSpeed
                    });
                }
            });
        }
    }

    function renderCarousel(owl) {
        owl.owlCarousel({
            loop: false,
            lazyLoad: true,
            lazyLoadEager: 4,
            margin: 10,
            nav: true,
            dots: false,
            navText: ["<div class='nav-btn prev-slide'><i class='fa fa-chevron-left' aria-hidden='true'></i></div>", 
                        "<div class='nav-btn next-slide'><i class='fa fa-chevron-right' aria-hidden='true'></i></div>"],
            responsive: {
                0: {
                    items: 1                        
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        });
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('mobileMenuMultiple', Directive);

    /**
     * Diretiva para inclusão de menu mobile de múltiplos links.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {   
                label: "=label",
                links: "=links",
                click: '&',
                onLinkClickListener: '&'
            },
            templateUrl: 'app/template/directives/topbar/mobilemenu-multiple.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.onMenuClick = onMenuClick;
        scope.onSubMenuClick = onSubMenuClick;
        scope.element = element;
    }

    /**
     * Responde ao evento de click em um menu.
     */
    function onMenuClick() {
        this.element.toggleClass('active');
        this.element.find('.submenu_list').slideToggle(200);
    }

    /**
     * Responde ao evneto de click em um submenu.
     */
    function onSubMenuClick($event) {
        var $container = $($event.currentTarget);
        $container.toggleClass('active');
        $container.parent().find('.lastmenu_container > .lastmenu_list').first().slideToggle(200);
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('mobileMenuSingle', Directive);

    /**
     * Diretiva para inclusão de menu mobile de link único.
     */
    function Directive() {
        return {
            restrict: 'E',
            link: link,
            scope: {   
                label: '=label',
                href: '=href'
            },
            templateUrl: 'app/template/directives/topbar/mobilemenu-single.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function () {
  "use strict";

  angular.module("portal").directive("topBar", TopBar);

  /**
   * Diretiva para inclusão da barra superior Desktop.
   * @param {*} $timeout Angular Timeout service.
   * @param {*} $location Serviço de interação com o browser location.
   */
  function TopBar($timeout, $location, $window) {
    return {
      restrict: "E",
      link: function (s, e, a, l, w) {
        link(s, e, a, $timeout, $location, $window);
      },
      scope: {
        onsearch: "=",
        searchValue: "=",
        scrollHeightOpacity: "=",
      },
      templateUrl: "app/template/directives/topbar/topbar.html",
    };
  }

  /**
   * Executado assim que a diretiva foi compilada.
   * @param {*} scope Escopo.
   * @param {*} element Elemento que recebe a diretiva.
   * @param {*} attrs Atributos.
   * @param {*} $timeout Angular Timeout service.
   * @param {*} $location Serviço de interação com o browser location.
   */
  function link(scope, element, attrs, $timeout, $location, $window) {
    scope.linksList = LINKS;
    scope.menusList = MENUS;
    scope._setCurrentMicromenu = _setCurrentMicromenu;
    scope.currentMicromenu = undefined;
    scope.$timeout = $timeout;
    scope.$location = $location;
    scope.$window = $window;
    scope.$topBar = element;
    scope.onClickCollapsedIcon = onClickCollapsedIcon;
    scope.onClickMobileCollapsedIcon = onClickMobileCollapsedIcon;
    scope.onClickRecolherButton = onClickRecolherButton;
    scope.onLinkClick = onLinkClick;
    scope.onClickHomeLogo = onClickHomeLogo;
    scope.followLinkClick = followLinkClick;
    scope.onClickMobileLogo = onClickMobileLogo;
    scope.isMenuActive = isMenuActive;

    scope.microMenuSubMenu = element.find("#micromenuSubmenuContainer");
    scope.opacityBackground = element.find("#topBarOpacityBackground");
    scope.opacityBackgroundMobile = element.find(
      ".topbar_container_mobile_background"
    );
    scope.opacityLogoMobile = element.find(
      ".topbar_container_mobile_logo_portal"
    );
    scope.$mobileMenu = element.find(".topbar_container_mobile");
    scope.bottomLine = element.find("#topBarBottomLine");
    scope._onWindowScroll = _onWindowScroll;

    if (scope.scrollHeightOpacity) {
      $(window).on("scroll", function () {
        scope._onWindowScroll($(this).scrollTop());
      });
    }

    scope.setCurrentMicromenu = function (menu) {
      scope._setCurrentMicromenu(menu);
    };
  }

  /**
   * Verifica se um link corresponde a página atualmente aberta.
   * @param {*} link Link.
   */
  function isMenuActive(link) {
    function recursive(link, currentPath) {
      if (link.type == "multiple") {
        if (link.path && currentPath.startsWith("#" + link.path)) {
          return true;
        }

        return (
          link.links.filter(function (l) {
            return recursive(l, currentPath);
          }).length > 0
        );
      }

      return link.href === currentPath;
    }

    var current = "#" + this.$location.path();
    var menu = findByPath(MENUS, current);

    if (menu != null) {
      if (menu.href == link.href) {
        return true;
      }

      if (menu.useAsCurrent) {
        current = menu.useAsCurrent;
      }
    }

    return this.$location.path() != "/" && recursive(link, current);
  }

  /**
   * Responde ao evento de click em um link.
   * @param {*} event Evento.
   */
  function onLinkClick(event) {
    this.onClickMobileCollapsedIcon();
    this.followLinkClick(event.currentTarget);
  }

  /**
   * Responde ao evento de click no logo da barra de menu mobile.
   * @param {*} event Evento.
   */
  function onClickMobileLogo(event) {
    if (this.$mobileMenu.hasClass("opened")) {
      this.$mobileMenu.removeClass("opened");
    }

    if (this.$topBar.closest("body").hasClass("block_scroll")) {
      this.$topBar.closest("body").removeClass("block_scroll");
    }

    this.followLinkClick(event.currentTarget);
  }

  /**
   * Aciona o link indicado por um elemento anchor.
   * @param {*} link Elemento referente ao click.
   */
  function followLinkClick(link) {
    var path = link.getAttribute("href");
    var target = link.getAttribute("target");

    if (target) {
      this.$window.open(path, target);
    } else {
      if (path.startsWith("/") || path.startsWith("#")) {
        path = path.replace("/#", "").replace("#", "");

        this.$location.path(path);
      } else {
        this.$window.open(path);
      }
    }
  }

  /**
   * Responde ao evento de click no ícone de menu colapsado.
   */
  function onClickCollapsedIcon() {
    this.$topBar.removeClass("collapsed");
  }

  /**
   * Responde ao evento de click no botão referente a funcionalidade de recolhimento da barra de menu.
   */
  function onClickRecolherButton() {
    this.$topBar.addClass("collapsed");
  }

  /**
   * Responde ao evento de click no ícone de menu mobile colapsado.
   */
  function onClickMobileCollapsedIcon() {
    this.$mobileMenu.toggleClass("opened");
    this.$topBar.closest("body").toggleClass("block_scroll");
  }

  /**
   * Responde ao evento de click no logo referente ao home.
   */
  function onClickHomeLogo() {
    if (this.$location.path() == "/") {
      angular.element("html").animate({ scrollTop: 0 }, "fast");
    } else {
      this.$location.path("/");
    }
  }

  /**
   * Responde ao evento de scroll da janela.
   * @param {*} scrollTop Scroll top corrente.
   */
  function _onWindowScroll(scrollTop) {
    var opacity = scrollTop / this.scrollHeightOpacity;

    if (opacity > 1) {
      // Colapsando menu caso o mesmo tenha sido recomposto
      if (!this.$topBar.hasClass("collapsed")) {
        this.$topBar.addClass("collapsed");
      }

      opacity = 1;
    }

    if (opacity == 1 && this.opacityBackground.css("opacity") == 1) {
      return;
    }

    // Configurando opacidade quando antes de colapsar menu
    var opacityBottomLine = 1 - opacity;
    this.opacityBackground.css({ opacity: opacity });
    this.opacityBackgroundMobile.css({ opacity: opacity });
    if (!this.$topBar.hasClass("other_pages")) {
      this.opacityLogoMobile.css({ opacity: opacity });
    }
    this.bottomLine.css({ opacity: opacityBottomLine });

    // Colapsando menu ao atingir determinado scroll height
    if (
      scrollTop >= this.scrollHeightOpacity &&
      !this.$topBar.hasClass("collapsed")
    ) {
      /*this.$topBar.addClass('scrolled');*/
      this.$topBar.addClass("collapsed");
    } else if (
      scrollTop < this.scrollHeightOpacity &&
      this.$topBar.hasClass("collapsed")
    ) {
      if (!this.$topBar.hasClass("other_pages")) {
        /*this.$topBar.removeClass('scrolled');*/
        this.$topBar.removeClass("collapsed");
      }
    }
  }

  /**
   * Configura o corrente micromenu aberto.
   * @param {*} menu Micromenu.
   */
  function _setCurrentMicromenu(menu) {
    var self = this;

    if (this.currentMicromenu != undefined && this.currentMicromenu == menu) {
      this.microMenuSubMenu.slideUp(undefined, function () {
        self.currentMicromenu = undefined;
        self.$apply();
      });
    } else {
      this.currentMicromenu = menu;

      this.$timeout(function () {
        self.microMenuSubMenu.slideDown();
      });
    }
  }

  function findByPath(menus, path) {
    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];

      if (menu.href != undefined && menu.href != null && menu.href == path) {
        return menu;
      } else if (menu.type == "multiple") {
        var finded = findByPath(menu.links, path);

        if (finded != null) {
          return finded;
        }
      }
    }
    //this.bottomLine.css({ opacity: opacityBottomLine });

    return null;
  }

  var MENUS = [
    {
      type: "multiple",
      label: "COVID-19",
      path: "/covid",

      links: [
        {
          label: "Despesas COVID-19",
          href: "#/despesas/covidorgao",
          useAsCurrent: "#/covid/despesas-covid19-por-orgao",
          newtab: false,
        },
        {
          label: "Itens COVID-19",
          href: "#/despesas/despesas-covid19-por-item",
          useAsCurrent: "#/covid/despesas-covid19-por-item",
          newtab: false,
        },
        {
          label: "Despesas COVID-19 - Auxílio União",
          href: "#/despesas/covidAuxilioUniao",
          useAsCurrent: "#/covid/despesas-covid19-auxilio-uniao",
          newtab: false,
        },
        {
          label: "Receita - Auxílio União",
          href: "#/receitas/receita-covid19-auxilio-uniao",
          useAsCurrent: "#/covid/receitas-auxilio-uniao",
          newtab: false,
        },
        {
          label: "Beneficiários Renda Emergencial",
          href: "#/prestando-contas/beneficiario/renda-emergencial",
          useAsCurrent: "#/covid/renda-emergencial",
          newtab: false,
        },
        {
          label: "Beneficiários Prato Cheio",
          href: "#/prestando-contas/beneficiario/prato-cheio",
          useAsCurrent: "#/covid/prato-cheio",
          newtab: false,
        },
        {
          label: "Beneficiários Artístico e Cultural",
          href: "#/prestando-contas/beneficiario/artistico-cultural",
          useAsCurrent: "#/covid/beneficiario-artistico-cultural",
          newtab: false,
        },
        {
          label: "Beneficiários Mobilidade Cidadã",
          href: "#/prestando-contas/beneficiario/mobilidade-cidada",
          useAsCurrent: "#/covid/beneficiario-mobilidade-cidada",
          newtab: false,
        },
        {
          label: "Contratações Emergenciais",
          href: "http://www.coronavirus.df.gov.br/index.php/contratacoes/",
          newtab: true,
        },{
          label: "Portal COVID-19",
          href: "https://www.coronavirus.df.gov.br/",
          newtab: true,
        },
      ],
    },
    {
      type: "multiple",
      label: "Receitas",
      path: "/receitas",
      links: [
        {
          label: "Gráficos",
          href: "#/receitas/dashboard",
          newtab: false,
        },
        {
          label: "Multas de Trânsito",
          href: "#/receitas/multas-transito",
          newtab: false,
        },
        {
          label: "Por Órgão",
          href: "#/receitas/por-orgao",
          newtab: false,
        },
        {
          label: "Impostos",
          href: "#/receitas/impostos",
          newtab: false,
        },
        {
          label: "Consulta Dinâmica",
          href: "#/receitas/consulta-dinamica",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Transferência da União",
          links: [
            {
              label: "Consolidado",
              href: "https://www.transparencia.df.gov.br/#/receita-uniao/transferencia",
              newtab: true,
            },
             {
              label: "Transferências Discricionárias e Legais",
              href: "https://app.powerbi.com/view?r=eyJrIjoiYWRjNTY1Y2EtMTEyNS00ZDA2LTgxNzItZDk1ZDBiYWFhY2EzIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true,
            },
              {
              label: "Transferências Fundo a Fundo",
              href: "https://app.powerbi.com/view?r=eyJrIjoiMjI5MDY0NTktOTE3NC00NzYzLWE3MzMtNWU2MDQxMDBlZmUyIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true,
            },
            {
              label: "Transferências Especiais",
              href: "https://app.powerbi.com/view?r=eyJrIjoiN2IxYmQ1NzktNTdmMS00Mjc1LTk5NzAtZWE2MTMwMGRkZDJmIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true,
            }
          ]
        },
        {
          type: "multiple",
          label: "Renúncias Fiscais - Relatórios",
          links: [
             {
              label: "2025",
              href: "https://www.transparencia.df.gov.br/arquivos/27_ANEXO VI - RELATÓRIOS DA CONTROLAGORIA-GERAL DO DF - VOLUME IV.pdf",
              newtab: true,
            },
            {
              label: "2024",
              href: "https://www.transparencia.df.gov.br/arquivos/ANEXO VI - RELATÓRIOS DA CONTROLAGORIA-GERAL DO DF - VOLUME IV.pdf",
              newtab: true,
            },
            {
              label: "2023",
              href: "https://www.transparencia.df.gov.br/arquivos/Anexo VI - Vol IV - Renuncia de Receitas - 2023.pdf",
              newtab: true,
            },
            {
              label: "2022",
              href: "https://www.transparencia.df.gov.br/arquivos/urp47jxmsr51.pdf",
              newtab: true,
            },
            {
              label: "2021",
              href: "https://www.transparencia.df.gov.br/arquivos/tru4tue9yc6t.pdf",
              newtab: true,
            },
            {
              label: "2020",
              href: "https://www.transparencia.df.gov.br/arquivos/urxy8qnf4s4h.pdf",
              newtab: true,
            },
            {
              label: "2019",
              href: "https://www.transparencia.df.gov.br/arquivos/1hb7pdzla72hy.pdf",
              newtab: true,
            },
            {
              label: "2018",
              href: "https://www.transparencia.df.gov.br/arquivos/1jeta20dxvrqq.pdf",
              newtab: true,
            },
          ],
        },
        {
          label: "Renúncias Fiscais - Dados Abertos",
          href: "http://www.dados.df.gov.br/dataset/renuncias-fiscais-beneficiometro",
          newtab: true,
        },
        {
          label: "Beneficiômetro",
          href: "https://paineis.fazenda.df.gov.br/Beneficiometro",
          newtab: true,
        },
      ],
    },
    {
      type: "multiple",
      label: "Despesas",
      path: "/despesas",
      links: [
        {
          label: "Gráficos",
          href: "#/despesas/dashboard",
          newtab: false,
        },
        {
          label: "Por Ação",
          href: "#/despesas/acao",
          newtab: false,
        },
        {
          label: "Por Credor",
          href: "#/despesas/credor",
          newtab: false,
        },
        {
          label: "Por Órgão",
          href: "#/despesas/orgao",
          newtab: false,
        },
        {
          label: "Por Função",
          href: "#/despesas/por-funcao",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Obras e Instalações",
          href: "#/despesas/obrasInstalacoes",
          links: [
            {
              label: "Infobras",
              href: "https://www.infobras.sinesp.df.gov.br/infobrasLai/index.xhtml",
              newtab: true,
            },
            {
              label: "Execução Orçamentária",
              href: "#/despesas/obrasInstalacoes",
              newtab: false,
            },
            {
              label: "Obras Paralisadas",
              href: "https://app.powerbi.com/view?r=eyJrIjoiNzdjMzBiYzEtMjE1NC00YjBlLThmODctZWVmYWQxMmNlN2IxIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true,
            },
          ],
        },
        {
          label: "DEA - Exercícios Anteriores",
          href: "#/despesas/exerciciosAnteriores",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Pagamentos",
          links: [
            {
              label: "Por Exercício",
              href: "#/despesas/pagamentos-por-credor",
              newtab: false
            },
            {
              label: "Ordem Cronológica",
              href: "https://app.powerbi.com/view?r=eyJrIjoiOTkwMDE0N2ItMDMwZS00YzEzLWFkZDEtYjdjOTEwOTJiMWE4IiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true
            }
          ]
        },
        {
          label: "Suprimento de Fundos",
          href: "#/despesas/suprimento",
          newtab: false,
        },
        {
          label: "Detalhamento (QDD)",
          href: "#/despesas/detalhamento",
          newtab: false,
        },


        {
          type: "multiple",
          label: "Manuais",
          links: [
            {
              label: "Manual de Planejamento e Orçamento - MPO",
              href: "https://www.transparencia.df.gov.br/arquivos/MPO-2016-Versao-Preliminar.pdf",
              newtab: true,
            },
            {
              label: "Manual Técnico de Orçamento - MTO",
              href: "https://www.transparencia.df.gov.br/arquivos/MTO-2025-Manual-Técnico-Orçamento.pdf",
              newtab: true,
            },

          ],
        },

        {
          type: "multiple",
          label: "Empresas Públicas",
          links: [
            {
              label: "BRB - Banco de Brasília",
              href: "https://novo.brb.com.br/servico-de-informacao-ao-cidadao/despesas/",
              newtab: true,
            },
            {
              label: "TERRACAP - Companhia Imobiliária de Brasília",
              href: "http://transparencia.terracap.df.gov.br/QvAJAXZfc/opendoc.htm?document=painel%2FTranspar%C3%AAncia.qvw&host=QVS%40dm13&anonymous=true",
              newtab: true,
            },
            {
              label: "CEB - Companhia Energética de Brasília",
              href: "http://lai.ceb.com.br/site/1/despesas",
              newtab: true,
            },
            {
              label: "CEASA - Centrais de Abastecimento do Distrito Federal",
              href: "http://www.ceasa.df.gov.br/despesas/",
              newtab: true,
            },
            {
              label:
                "CAESB - Companhia de Saneamento Ambiental do Distrito Federal",
              href: "https://www.caesb.df.gov.br/acesso-a-informacao/despesas/",
              newtab: true,
            },
          ],
        },
        {
          type: "multiple",
          label: "Fundo Constitucional",
          links: [
            {
              label:
                "UG 170484 - FCDF - PMDF - DEPARTAMENTO DE GESTÃO DE PESSOAL",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170484",
              newtab: true,
            },
            {
              label: "UG 170393 - FCDF - SSP - POLICIA MILITAR DO DF ",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170393 ",
              newtab: true,
            },
            {
              label: "UG 170394 - FCDF - SSP - CORPO BOMBEIRO MILITAR DO DF",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170394",
              newtab: true,
            },
            {
              label: "UG 170495 - FCDF - CBMDF - ASSISTENCIA MEDICA",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170495",
              newtab: true,
            },
            {
              label: "UG 170395 - FCDF - SSP - POLICIA CIVIL DO DF",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170395",
              newtab: true,
            },
            {
              label: "UG 170399 - FCDF - SECRETARIA DE EDUCAÇÃO",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170399",
              newtab: true,
            },
            {
              label:
                "UG 170485 - FCDF - DEPARTAMENTO DE SAÚDE E ASSIST. DE PESSOAL",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170485",
              newtab: true,
            },
            {
              label: "UG 170397 - FCDF - SECRETARIA DE SAÚDE",
              href: "http://transparencia.gov.br/despesas/consulta?de=01%2F01%2F2021&ate=31%2F12%2F2021&orgaos=UG170397",
              newtab: true,
            },
            {
              label: "FCDF -  EXECUÇÃO ORÇAMENTÁRIA",
              href: "http://www.portaltransparencia.gov.br/orgaos/25915-fundo-constitucional-do-distrito-federal",
              newtab: true,
            },
          ],
        },
        {
          type: "multiple",
          label: "Emendas Parlamentares",
          links: [
            {
              label: "Emendas Parlamentares Distritais",
              href: "#/despesas/emendas-parlamentares",
              newtab: false,
            },
            {
              label: "Emendas Parlamentares Federais",
              href: "#/despesas/emenda-parlamentar-federal",
              newtab: false,
            }
          ]
        },
        {
          label: "Execução OCA",
          href: "#/despesas/execucao-oca",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Diárias, Passagens e Locomoção",
          links: [
            {
              label:
                "Empenhos em Despesas",
              href: "https://www.transparencia.df.gov.br/#/despesas/diarias-passagens-locomocao",
              newtab: true,
            },
            {
              label: "Detalhamento de Diárias",
              href: "https://app.powerbi.com/view?r=eyJrIjoiNDkxNjlkNTgtNTI5YS00ZmRjLTk0YWQtNDAyOTIwOWM1YzFhIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true,
            }
          ]
        },
        {
          label: "Consulta Dinâmica",
          href: "#/despesas/consulta-dinamica",
          newtab: false,
        },
        {
          label: "Aluguel Imóveis",
          href: "https://www.dados.df.gov.br/dataset/locacao-de-imoveis-pelo-poder-executivo-do-distrito-federal",
          newtab: true,
        },
        {
          label: "Consórcio Brasil Central",
          href: "http://www.brasilcentral.gov.br/acesso-a-informacao",
          newtab: true,
        },
      ],
    },
    {
      type: "multiple",
      label: "Servidores",
      path: "/servidores",
      links: [
        {
          label: "Gráficos",
          href: "#/servidores/dashboard",
          newtab: false,
        },
        {
          label: "Remuneração dos Servidores",
          href: "#/servidores/remuneracao",
          newtab: false,
        },
        {
          label: "Ressarcimento Requisitados",
          href: "#/servidores/ressarcimento-requisitado",
          newtab: false,
        },
        {
          label: "Por Órgão",
          href: "#/servidores/orgao",
          newtab: false,
        },
        {
          label: "Perfil Servidores",
          href: "#/servidores/perfil",
          newtab: false,
        },
        {
          label: "Militares Cedidos",
          href: "#/servidores/militares-cedidos",
          useAsCurrent: "#/servidores/militares-cedidos",
          newtab: false,
        },
        {
          label: "Cadastro Expulsões",
          href: "#/servidores/expulsoes",
          newtab: false,
        },
        {
          label: "Quadro Servidores GDF",
          href: "#/servidores/quadro",
          newtab: false,
        },
        {
          label: "Cargos Efetivos",
          href: "#/servidores/cargo-efetivo",
          newtab: false,
        },
        {
          label: "Cargos Comissionados",
          href: "#/servidores/cargo-comissionado",
          newtab: false,
        },
        {
          label: "Carreiras do DF",
          href: "https://www.economia.df.gov.br/carreiras-do-df",
          newtab: true,
        },
        {
          label: "Painel Estatístico Pessoal",
          href: "https://www.economia.df.gov.br/painel_estatistico_pessoal",
          newtab: true,
        },
        {
          label: "Código de Ética do Servidor",
          href: "https://www.sinj.df.gov.br/sinj/Norma/32f5ae1f6e4c4babbb90ede4587c8e79/Decreto_37297_29_04_2016.html",
          newtab: true,
        },
        {
          label: "Concursos",
          href: "https://www.economia.df.gov.br/category/gestao-de-pessoas/concursos ",
          newtab: true,
        },
            {
          label: "Estagiários",
          href: "https://dados.df.gov.br/busca?_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_formDate=1782395519614&q=estagiario",
          newtab: true,
        },
            {
          label: "Terceirizados",
          href: "https://dados.df.gov.br/dataset/funcionarios-terceirizados",
          newtab: true,
        },
        {
          type: "spacer",
        },
        {
          label: "Escala dos Profissionais de Saúde",
          href: "https://info.saude.df.gov.br/sala-de-situacao/painel-infosaude-escalas-de-profissionais/",
          newtab: true,
        },
        {
          label: "Plano de Saúde Servidores",
          href: "https://www.inas.df.gov.br/gdf-saude-em-numeros/",
          newtab: true,
        }
      ],
    },
    {
      type: "multiple",
      label: "Compras",
      path: "/licitacoes-contratos",
      links: [
        {
          label: "Contratos",
          href: "#/licitacoes-contratos/contratos",
          newtab: false,
        },
        {
          label: "Executores de Contratos",
          href: "https://app.powerbi.com/view?r=eyJrIjoiZjQ4MjBlNjQtYjc5NC00ZDI4LTk5YzctOWQ0MTM2NDM0MDk2IiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
          newtab: true,
        },
        {
          label: "Documentos das contratações",
          href: "https://portal.compras.df.gov.br/contratacao/",
          newtab: true,
        },
        {
          label: "Licitações",
          href: "#/licitacoes-contratos/licitacoes",
          newtab: false,
        },
        {
          label: "Itens Licitados",
          href: "#/licitacoes-contratos/itens-licitados",
          newtab: false,
        },
        {
          label: "Plano de Contratações Anual - PCA",
          href: "https://portal.compras.df.gov.br/catalogo/pca",
          newtab: true,
        },
        {
          label: "Cadernos Técnicos",
          href: "https://cadtec.df.gov.br/",
          newtab: true,
        },
        {
          label: "Manuais Técnicos",
          href: "https://www.economia.df.gov.br/manuais-compras-df",
          newtab: true,
        },
        {
          label: "Atas de Registro de Preços",
          href: " https://gestaodeatas.df.gov.br/GeataProject/",
          newtab: true,
        },
        {
          label: "Portal Nacional - PNCP",
          href: "https://www.gov.br/pncp/pt-br",
          newtab: true,
        }
      ],
    },
    {
      type: "multiple",
      label: "Convênios",
      path: "/convenio",
      links: [
        {
          label: "Receita",
          href: "#/convenio/receita",
          newtab: false,
        },
        {
          label: "Despesa",
          href: "#/convenio/despesa",
          newtab: false,
        },
        {
          label: "Entidades Beneficiadas",
          href: "#/convenio/entidades-beneficiadas",
          newtab: false,
        },
      ],
    },
    {
      type: "multiple",
      label: "Prestando Contas",
      path: "/prestando-contas",
      links: [
        {
          label: "Prestação de Contas Anual",
          href: "#/prestando-contas/relatorio-contas",
          newtab: false,
        },
        {
          label: "Apreciação de Contas - TCDF",
          href: "https://www2.tc.df.gov.br/controle-externo/contas-de-governo/",
          newtab: true,
        },
        {
          type: "multiple",
          label: "Andamento Processos Correcionais",
          links: [
            {
              label: "PAD - Processos Administrativos Disciplinares ",
              href: "#/prestando-contas/pads",
              newtab: false,
            },
            {
              label: "PIP - Processos de Investigação Preliminar",
              href: "#/prestando-contas/pips",
              newtab: false,
            },
            {
              label: "TCE - Tomada de Contas Especial",
              href: "https://www.transparencia.df.gov.br/#/url-arquivo?query=andamento-tomadas-conta-especial",
              newtab: true,
            },
          ],
        },
        {
          label: "Andamento Ações de Controle",
          href: "#/url-arquivo?query=andamento-acoes-controle",
          newtab: true,
        },
        {
          label: "Relatórios de Auditoria CGDF",
          href: "http://www.cg.df.gov.br/relatorios-de-auditorias/",
          newtab: true,
        },
        {
          label: "Relatórios de Auditoria TCDF",
          href: "https://www2.tc.df.gov.br/controle-externo/relatorios-de-auditorias-2/",
          newtab: true,
        },
        {
          type: "multiple",
          label: "Beneficiários de Programas Sociais",
          links: [
            {
              label: "Transferência de Renda e Auxílios",
              href: "#/prestando-contas/beneficiario/programas-sociais",
              newtab: false,
            },
            {
              label: "Cartão Material Escolar",
              href: "#/prestando-contas/beneficiario/cartao-material-escolar",
              newtab: false,
            },
          ],
        },
        {
          type: "multiple",
          label: "Conselhos",
          links: [
            {
              label: "Estrutura",
              href: "#/prestando-contas/conselhos",
              newtab: false,
            },
            {
              label: "Conselheiros ",
              href: "#/prestando-contas/conselheiros",
              newtab: false,
            },
          ],
        },
        {
          type: "multiple",
          label: "Cultura",
          links: [
            {
              label: "Shows e Eventos",
              href: "http://www.transparencia.cultura.df.gov.br/public/",
              newtab: true,
            },
            {
              label: "LIC – Lei de Incentivo à Cultura",
              href: "https://sufic.cultura.df.gov.br/transparencia",
              newtab: true,
            },
            {
              label: "Projetos Culturais",
              href: "https://www.cultura.df.gov.br/transparencia/",
              newtab: true,
            },
          ],
        },
        {
          label: "Empresas Programa Integridade",
          href: "#/prestando-contas/empresas-programa-integridade",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Empresas Punidas",
          links: [
            {
              label:
                "CEIS - Cadastro Nacional de Empresas Inidôneas e Suspensas",
              href: "https://portaldatransparencia.gov.br/sancoes/consulta?paginacaoSimples=true&tamanhoPagina=&offset=&direcaoOrdenacao=asc&cadastro=1&orgaoEntidadeSancionadora=DISTRITO+FEDERAL&colunasSelecionadas=linkDetalhamento%2Ccadastro%2CcpfCnpj%2CnomeSancionado%2CufSancionado%2Corgao%2CcategoriaSancao%2CdataPublicacao%2CvalorMulta%2Cquantidade&ordenarPor=orgao&direcao=asc",
              newtab: true,
            },
            {
              label: "CNEP - Cadastro Nacional de Empresas Punidas",
              href: "https://portaldatransparencia.gov.br/sancoes/consulta?paginacaoSimples=true&tamanhoPagina=&offset=&direcaoOrdenacao=asc&cadastro=2&orgaoEntidadeSancionadora=DISTRITO+FEDERAL&colunasSelecionadas=linkDetalhamento%2Ccadastro%2CcpfCnpj%2CnomeSancionado%2CufSancionado%2Corgao%2CcategoriaSancao%2CdataPublicacao%2CvalorMulta%2Cquantidade&ordenarPor=nomeSancionado&direcao=asc",
              newtab: true,
            },
            {
              label:
                "CEPIM - Cadastro de Entidades Privadas sem Fins Lucrativos Impedidas",
              href: "https://portaldatransparencia.gov.br/sancoes/cepim?paginacaoSimples=true&tamanhoPagina=&offset=&direcaoOrdenacao=asc&orgaos=OR91001%2COS91001&colunasSelecionadas=cnpj%2Cnome%2CufSancionado%2Cmotivo%2Corgao%2Cconvenio%2Cquantidade",
              newtab: true,
            },
          ],
        },
        {
          label: "Fundo Distrital de Combate a Corrupção",
          href: "http://www.fdcc.df.gov.br/index.php/2024/02/05/relatorios/",
          newtab: true,
        },
        {
          label: "Gastos com Publicidade",
          href: "#/prestando-contas/gastos-publicidade",
          newtab: false,
        },
        {
          type: "multiple",
          label: "LAI - Informações Classificadas/Desclassificadas",
          links: [
            {
              label: "SSP - Secretaria de Estado de Segurança Pública",
              href: "http://www.ssp.df.gov.br/informacoes-classificadas/",
              newtab: true,
            },
            {
              label: "PCDF - Polícia Civil",
              href: "https://www.pcdf.df.gov.br/transparencia/informacoes-classificadas",
              newtab: true,
            },
            {
              label: "PMDF - Polícia Militar",
              href: "https://portal.pm.df.gov.br/informacoes-classificadas-e-desclassificadas/",
              newtab: true,
            },
            {
              label: "CBMDF - Corpo de Bombeiros Militar",
              href: "https://www.cbm.df.gov.br/lai/informacoes-classificadas/informacoes-classificadas/",
              newtab: true,
            },
            {
              label: "Terracap - Companhia Imobiliária de Brasília",
              href: "https://www.terracap.df.gov.br/index.php/acesso-informacao/informacoes-classificadas",
              newtab: true,
            },

              {
              label: "IPEDF - Instituto de Pesquisa e Estatística",
              href: "https://www.ipe.df.gov.br/informacoes-classificadas-e-desclassificadas",
              newtab: true
            },
             {
              label: "CGDF - Controladoria Geral",
              href: "https://www.cg.df.gov.br/informacoes-classificadas-e-desclassificadas",
              newtab: true
            },
            {
              label: "Lista Consolidada",
              href: "https://app.powerbi.com/view?r=eyJrIjoiN2UwNDNlMjYtYTVjMS00ZTlmLTkxZmEtMmY2NDU5M2M1NDUzIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
              newtab: true
            },


          ],
        },
        {
          label: "Parcerias GDF MROSC",
          href: " https://parcerias.df.gov.br/",
          newtab: true,
        },

        {
          type: "multiple",
          label: "Programas de Crédito",
          links: [
            {
              label: "Prospera DF",
              href: "#/prestando-contas/prospera-df",
              newtab: false,
            },
          ],
        },

        {
          label: "Inscritos na Dívida Ativa",
          href: "https://app.powerbi.com/view?r=eyJrIjoiOTZmYjY5YjctNThkOS00YjY0LWI3M2MtYzJkNmYyZjE3MzNlIiwidCI6IjU3NGNhYTRiLTkxODEtNGI5Yy04ZDhhLTBiMGY3NjkwZDdmNiJ9",
          newtab: true,
        },

        {
          type: "multiple",
          label: "Saúde",
          links: [
            {
              label: "Organizações Sociais",
              href: "#/prestando-contas/organizacoes-sociais-saude",
              newtab: false,
            },
            {
              label: "Transparência e Prestação de Contas",
              href: "https://info.saude.df.gov.br/transparencia-e-prestacao-de-contas/",
              newtab: true,
            },
            {
              label: " InfoSaúde-DF",
              href: "https://info.saude.df.gov.br/",
              newtab: true,
            },
          ],
        },

            {
          type: "multiple",
          label: "Educação",
          links: [
            {
              label: "Creches DF",
              href: "https://www.educacao.df.gov.br/creches-df",
              newtab: true,
            },
  
          ],
        },
        {
          label: "Outros Relatórios",
          href: "#/prestando-contas/outros-relatorios",
          newtab: false,
        },
        {
          type: "multiple",
          label: "Governo Digital",
          links: [
            {
            label:"Política de Governo Digital",
            href: "https://www.sinj.df.gov.br/sinj/Norma/0c7316411ac74db1b2e4333cac59ded5/Decreto_48903_03_07_2026.html",
            newtab:true,
            }

          ]
        }
      ],
    },
    {
      type: "multiple",
      label: "Orçamento",
      path: "/orcamento",
      links: [
        {
          label: "Plano Estratégico do DF",
          href:"https://dados.df.gov.br/documents/d/dados-abertos/book_plano_estrategico_df",
          newtab: true,
        },
        {
          label: "PPA",
          href: "#/orcamento/ppa",
          newtab: false,
        },
        {
          label: "LDO",
          href: "#/orcamento/ldo",
          newtab: false,
        },
        {
          label: "LOA",
          href: "#/orcamento/loa",
          newtab: false,
        },
        {
          label: "Lei de Responsabilidade Fiscal",
          href: "#/orcamento/responsabilidade-fiscal",
          newtab: false,
        },
        {
          label: "Relatórios da Dívida Pública",
          href: "https://www.economia.df.gov.br/divida-publica-relatorios",
          newtab: true,
        },
        {
          label: "Relatórios gerenciais",
          href: "#/orcamento/relatorios-gerenciais",
          newtab: false,
        },
      ],
    },
    {
      type: "multiple",
      label: "Patrimônio",
      path: "/patrimonio",
      links: [
        {
          label: "Bens Móveis",
          href: "#/patrimonio/bens-moveis",
          newtab: false,
        },
        {
          label: "Bens Imóveis",
          href: "#/patrimonio/bens-imoveis",
          newtab: false,
        },
      ],
    },
  ];

  var LINKS = [
    {
      type: "single",
      label: "Início",
      href: "#/",
      newtab: false,
      class: "hide_on_more",
    },
    {
      type: "single",
      label: "Sobre o Portal",
      href: "#/sobre",
      newtab: false,
      class: "hide_on_more",
    },
    {
      type: "single",
      label: "Dados abertos",
      href: "#/downloads",
      newtab: false,
      class: "hide_on_more",
    },
    {
      type: "single",
      label: "Glossário",
      href: "#/glossario",
      newtab: false,
      class: "hide_on_more",
    },
    {
      type: "single",
      label: "Ouvidoria",
      href: "http://www.ouvidoria.df.gov.br/",
      newtab: true,
      class: "hide_on_more",
    },
    {
      type: "single",
      label: "Links Úteis",
      href: "#/linksuteis",
      newtab: false,
      class: "hide_on_more",
    },

    {
      type: "multiple",
      label: "Mais",
      links: [
        {
          label: "Início",
          href: "#/",
          newtab: false,
        },
        {
          label: "Sobre o Portal",
          href: "#/sobre",
          newtab: false,
        },
        {
          label: "Downloads",
          href: "#/downloads",
          newtab: false,
        },
        {
          label: "Glossário",
          href: "#/glossario",
          newtab: false,
        },
        {
          label: "Ouvidoria",
          href: "http://www.ouvidoria.df.gov.br/",
          newtab: true,
        },
        {
          label: "Links Úteis",
          href: "#/linksuteis",
          newtab: false,
        },
      ],
      class: "more_micromenu",
    },
    {
      type: "multiple",
      label: "Institucional",
      links: [
        {
          label: "Estrutura",
          href: "https://www.sinj.df.gov.br/sinj/Norma/d7b71f8fb3864fc0aec117bb1e0ea2ca/Decreto_39610_01_01_2019.html",
          newtab: true,
        },
        {
          label: "Agenda do Governador",
          href: "http://www.df.gov.br/agenda-do-governador/",
          newtab: true,
        },
        {
          label: "Serviços",
          href: "http://www.df.gov.br/category/servicos-2/",
          newtab: true,
        },
        {
          label: "Programas",
          href: "http://www.df.gov.br/category/programas/",
          newtab: true,
        },
        {
          label: "Fale com o Governo",
          href: "http://www.df.gov.br/fale-com-o-governo/",
          newtab: true,
        },
        {
          label: "Diário Oficial do DF",
          href: "http://www.dodf.df.gov.br/",
          newtab: true,
        },
        {
          label: "Notícias",
          href: "https://www.agenciabrasilia.df.gov.br/",
          newtab: true,
        },
        {
          label: "Sobre Brasília",
          href: "http://www.df.gov.br/category/sobre-brasilia/",
          newtab: true,
        },
        {
          label: "Brasília em Números",
          href: "http://brasiliaemnumeros.codeplan.df.gov.br/ ",
          newtab: true,
        },
        {
          label: "Brasília em Mapas",
          href: "http://brasiliaemmapas.codeplan.df.gov.br/",
          newtab: true,
        },
      ],
    },

    {
      type: "multiple",
      label: "Vídeos DF",
      links: [
        {
          label: "ADMINISTRAÇÃO GERAL",
          videoId: "SVCPasM3hrw",
          newtab: true,
        },
        {
          label: "ESPLANADA",
          videoId: "HobReZ2IU8o",
          newtab: true,
        },
        {
          label: "LAGO PARANOÁ",
          videoId: "Dcc2sg6H0sA",
          newtab: true,
        },
        {
          label: "PARQUE DA CIDADE 01",
          videoId: "rBa9WQgqslE",
          newtab: true,
        },
        {
          label: "PARQUE DA CIDADE 02",
          videoId: "eQrF49qFYCs",
          newtab: true,
        },
        {
          label: "PONTE JK 01",
          videoId: "K2Zrw7r5MLo",
          newtab: true,
        },
        {
          label: "PONTE JK 02",
          videoId: "t9PNc_V7Q7A",
          newtab: true,
        },
        {
          label: "TORRE DE TV",
          videoId: "SIBH_Cab7YE",
          newtab: true,
        },
        {
          label: "URBANISMO 01",
          videoId: "AKzQMs8jx7Y",
          newtab: true,
        },
        {
          label: "URBANISMO 02",
          videoId: "OtE1V6p8u74",
          newtab: true,
        },
      ],
    },
    {
      type: "multiple",
      label: "LGPD DF",
      links:[
        {
          label:"Portal LGPD DF",
          href:"https://lgpd.df.gov.br/",
          newtab: true,
        },
        {
          label:"Encarregado Governamental",
          href:"https://lgpd.df.gov.br/contatos/",
          newtab: true,
        },
      ]
    },
{
  type: "single",
  label: "PORTAL DF LEGIS",
  href: "https://dflegis.df.gov.br",
  newtab: true
}
  ];
})();

(function() {
    'use strict';
    
    angular.module('portal').directive('topMenuMultiple', TopMenuMultiple);

    /**
     * Diretiva para inclusão de submenu de para barra superior.
     */
    function TopMenuMultiple() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                menu: '=',
                isCurrent: '&'
            },
            templateUrl: 'app/template/directives/topbar/topmenu-multiple.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
        scope.isCurrentMenu = isCurrentMenu;
    }

    /**
     * Verifica se um link corresponde ao atual contexto aberto.
     * @param {*} link Link.
     */
    function isCurrentMenu(link) {
        return this.isCurrent({ link: link });
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('topMenuSingle', TopMenuSingle);

    /**
     * Diretiva para inclusão de um menu para a barra superior.
     */
    function TopMenuSingle() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                label: '=label',
                href: '=href',
                onLinkClickListener: '&'
            },
            template: '<a href="{{ href }}" class="top_menu_bar_menu_container"><span class="top_menu_bar_menu_label">{{ label }}</span></a>'
            /*template: '<div class="top_menu_bar_menu_container"><a href="{{ href }}" class="top_menu_bar_menu_label">{{ label }}</a></div>'*/
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';
    
    angular.module('portal').directive('topMicromenuMultiple', TopMicromenuMultiple);

    /**
     * Diretiva para inclusão de submenu de links da barra superior.
     */
    function TopMicromenuMultiple() {
        return {
            restrict: 'E',
            link: link,
            scope: {   
                label: "=label",
                links: "=links",
                selected: '=',
                click: '&'
            },
            templateUrl: 'app/template/directives/topbar/topmicromenu-multiple.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();
(function() {
    'use strict';

    angular.module('portal').directive('topMicromenuSingle', TopMicromenuSingle);

    /**
     * Diretiva para inclusão de link da para superior.
     */
    function TopMicromenuSingle() {
        return {
            restrict: 'E',
            link: link,
            scope: {
                link: '=',
                isCurrent: '&'
            },
            templateUrl: 'app/template/directives/topbar/topmicromenu-single.html'
        };
    }

    /**
     * Executado assim que a diretiva foi compilada.
     * @param {*} scope Escopo.
     * @param {*} element Elemento que recebe a diretiva.
     * @param {*} attrs Atributos.
     */
    function link(scope, element, attrs) {
    }

})();

(function() {
    'use strict';

    angular.module('portal').directive('uiEndDate', UiEndDate);

    function UiEndDate ($rootScope, UiDateService) {
        return {
            restrict: 'A',
            scope: {
                dateModel: "=",
                dateRequired: "=",
                dateEditable: "=",
                placeholder: "@",
                dateFormat: "@",
                dateLabelClass: "@",
                dateFilters: "&"
            },
            templateUrl: 'app/template/directives/ui-date/ui-end-date.html',
            link: function (scope, element, attrs) {

                // Directive scope endpoints
                scope.customFilter = UiDateService.validateCustomFilter(scope.dateFilters);
                scope.resetDate = UiDateService.resetDate(scope, element);
                scope.onSetTime = onSetTime;
                scope.endDateBeforeRender = endDateBeforeRender;

                // Validations
                UiDateService.validateAttrs(attrs, scope);

                // Registering event listener to save on directive scope the value of start date
                $rootScope.$on(attrs.datePairId + '-start-date-changed', function(event, args){
                    scope.startDate = args.startDate;
                    validateDate(scope.dateModel);
                });

                // Registering watcher to validate the date model when changed
                scope.$watch('dateModel', function(newDate, oldDate){
                    onSetTime();
                    validateDate(newDate);
                });

                function onSetTime(){
                    // Broadcasting to specific pair of dates that the end date has changed
                    $rootScope.$broadcast(attrs.datePairId + '-end-date-changed', {
                        endDate: scope.dateModel
                    });
                    // General broadcast that the end date has changed
                    $rootScope.$broadcast('end-date-changed');
                }

                function endDateBeforeRender($view, $dates) {
                    if (scope.startDate) {
                        var activeDate = moment(scope.startDate).subtract(1, $view).add(1, 'minute');

                        // Disabling dates under the start date
                        $dates.filter(function (date) {
                            return date.localDateValue() <= activeDate.valueOf();
                        }).forEach(function (date) {
                            date.selectable = false;
                        });
                    }
                }

                function validateDate(date){
                    if(date){
                        var modelController = element.find('input').controller('ngModel');
                        UiDateService.validateDate(date, function(dateToValidate){
                            var greaterThanStartDate = true;
                            if(scope.startDate){
                                greaterThanStartDate = dateToValidate >= scope.startDate;
                            }
                            return greaterThanStartDate;
                        }, scope.dateFilters(), modelController);
                    }
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('portal').directive('uiStartDate', UiStartDate);

    function UiStartDate ($rootScope, UiDateService) {
        return {
            restrict: 'A',
            scope: {
                dateModel: "=",
                dateRequired: "=",
                dateEditable: "=",
                placeholder: "@",
                dateFormat: "@",
                dateLabelClass: "@",
                dateFilters: "&"
            },
            templateUrl: 'app/template/directives/ui-date/ui-start-date.html',
            link: function (scope, element, attrs) {

                // Directive scope endpoints
                scope.customFilter = UiDateService.validateCustomFilter(scope.dateFilters);
                scope.resetDate = UiDateService.resetDate(scope, element);
                scope.onSetTime = onSetTime;
                scope.startDateBeforeRender = startDateBeforeRender;

                // Validations
                UiDateService.validateAttrs(attrs, scope);

                // Registering event listener to save on directive scope the value of end date
                $rootScope.$on(attrs.datePairId + '-end-date-changed', function(event, args){
                    scope.endDate = args.endDate;
                    validateDate(scope.dateModel);
                });

                // Registering watcher to validate the date model when changed
                scope.$watch('dateModel', function(newDate, oldDate){
                    onSetTime();
                    validateDate(newDate);
                });

                function onSetTime() {
                    // Broadcasting to specific pair of dates that the start date has changed
                    $rootScope.$broadcast(attrs.datePairId + '-start-date-changed', {
                        startDate: scope.dateModel
                    });
                    // General broadcast that the end date has changed
                    $rootScope.$broadcast('start-date-changed');
                }

                function startDateBeforeRender($dates) {
                    if (scope.endDate) {
                        var activeDate = moment(scope.endDate);

                        // Disabling dates above the end date
                        $dates.filter(function (date) {
                            return date.localDateValue() >= activeDate.valueOf();
                        }).forEach(function (date) {
                            date.selectable = false;
                        });
                    }
                };

                function validateDate(date){
                    if(date){
                        var modelController = element.find('input').controller('ngModel');
                        UiDateService.validateDate(date, function(dateToValidate){
                            var lessThanEndDate = true;
                            if(scope.endDate){
                                lessThanEndDate = dateToValidate <= scope.endDate;
                            }
                            return lessThanEndDate;
                        }, scope.dateFilters(), modelController);
                    }
                }
            }
        };
    }
})();

(function(){
    'use strict';

    angular.module('portal').service('ExecucaoDespesaService', ExecucaoDespesaService);

    function ExecucaoDespesaService($http, api) {
        var service = {};
        var serviceConfig = { cache: true };

        service.buscarValoresDashBoardExecucaoDespesa = function(exercicio) {
            return $http({
                url: api.url + '/v2/dashboard-execucao-despesa/listar',
                method: 'GET',
                params: {exercicio: exercicio}
            });
        };

        service.buscarAnos = function() {
            return $http({
                url: api.url + '/v2/dashboard-execucao-despesa/listar-anos',
                method: 'GET'
            });
        }

        return service;
    }
})();
(function () {
    'use strict';

    angular.module('portal').service('SetorDesejadoService', Service);

    /**
     * Fornece serviços de consulta sobre setores.
     * @param {*} $http Serviço de requisição HTTP.
     * @param {*} api Endpoint utilizado no serviço.
     */
    function Service($http, api, $q, QuadrosTematicosService, apiGerenciador, ArquivoUrlService) {

        var _scope = {};

        _scope.$http = $http;
        _scope.$q = $q;
        _scope.api = api;
        _scope.QuadrosTematicosService = QuadrosTematicosService;
        _scope.buscarSetores = buscarSetores;
        _scope.apiGerenciador = apiGerenciador;
        _scope.ArquivoUrlService = ArquivoUrlService;
        return _scope;
    }

    /**
     * Busca os setores.
     * @returns Promise para lista de setores
     */
    function buscarSetores() {
        var self = this;

        return this.$http({
            url: this.api.url + '/v2/paineis-despesa/temas-anos',
            method: 'GET',
            cache: false
        }).then(function(resp) {
            return {
                temas: resp.data.temas.map(function(img) {
                    return {
                        imagemUrl: self.ArquivoUrlService.IMAGENS + img.caminhoImagem,
                        descritivo: img.nomeFuncao,
                        href: '#/temas?' + img.codigoFuncao
                    };
                }),
                anos: resp.data.anos
            };
        });
    }

})();

(function() {
    'use strict';

    angular.module('portal').controller('FornecedoresController', FornecedoresController);

    /**
     * Controlador da página de fornecedores.
     */
    /** @ngInject */
    function FornecedoresController($scope, $location, $aside, ScopeService, DataAtualizacaoService, LicitacoesService, 
        LicitacoesContratosService) {

        var vm = this;
        vm.pageID = 'licitacoes_fornecedores_page';
        vm.tituloPagina = 'Fornecedores';
        vm.contador = 0;
        vm.DataAtualizacaoService = DataAtualizacaoService;
        vm.LicitacoesService = LicitacoesService;
        vm.LicitacoesContratosService = LicitacoesContratosService;
        vm.loadDataAtualizacao = loadDataAtualizacao;
        vm.visualizarItem = visualizarItem;
        vm.onColumnsPanelClose = onColumnsPanelClose;
        vm.updateData = updateData;
        vm.updateFilter = updateFilter;
        vm.loadTituloPagina = loadTituloPagina;
        vm.init = init;
        vm.buildColunasParamsMap = buildColunasParamsMap;
        vm.voltar = voltar;
        vm.navigateTo = navigateTo;
        vm.showFormDetalhamento = showFormDetalhamento;
        vm.$scope = $scope;
        vm.$location = $location;
        vm.$aside = $aside;
        vm.ScopeService = ScopeService;

        vm.data = { content: [] };
        vm.settings = { cmd: '' };
        $scope.colunas = COLUMNS;
        $scope.fecharModalColunas = function(e) { vm.onColumnsPanelClose(e) };

        vm.loadDataAtualizacao();
        vm.init();
    }

    /**
     * Configura os parâmetros da página.
     */
    function init(params) {
        var filterModel = null;
        this.storagedObject = this.ScopeService.getStored();

        if (this.storagedObject) {
            var storagedParams = this.storagedObject[this.pageID];

            if (storagedParams) {
                this.$scope.colunas = storagedParams.colunas;
                filterModel = storagedParams.filtro;
            }
        }

        var params = this.$location.search();
        this.initialParams = params;

        if (params.idPregaoEletronico && params.codigoOrgao) {
            filterModel = {
                tipo: 'csv',
                page: 0,
                busy: false,
                idPregaoEletronico: params.idPregaoEletronico,
                codigoOrgao: params.codigoOrgao
            };

            this.loadTituloPagina(params);
        }

        if (filterModel != null) {
            this.updateFilter(filterModel);
        }
    }

    /**
     * Carrega o título da página.
     * @param params Mapa de parâmetros da página.
     */
    function loadTituloPagina(params) {
        var self = this;
        var id = params.idPregaoEletronico.split('/')[0];
        var ano = params.idPregaoEletronico.split('/')[1];

        this.LicitacoesService.listarOrgaos(ano)
            .then(function(orgaos) {
                orgaos = orgaos.filter(function(orgao) {
                    return orgao.codigo == params.codigoOrgao;
                });

                if (orgaos.length) {
                    self.tituloPagina = 'Pregão Nº ' + id + ' / ' + ano + ' - ' + orgaos[0].nome;
                }
            });
    }

    /**
     * Carrega a data de atualização da base de dados.
     */
    function loadDataAtualizacao() {
        var self = this;
        this.DataAtualizacaoService.buscarDataAtualizacao('itens-licitados')
            .then(function(resp) {
                self.dataAtualizacao = resp.data;
            });
    }

    /**
     * Detalha um item.
     * @param {*} item Item.
     */
    function visualizarItem(item) {
        var self = this;

        this.LicitacoesContratosService.detalharItemLicitado(item.idItemCompra)
            .then(function(response) {        
                self.linha = response.data;
                self.showFormDetalhamento(self.$aside, self.$scope);
            });
    }

    /**
     * Navega de volta para a página de licitações.
     */
    function voltar() {
        this.navigateTo('/licitacoes-contratos/licitacoes', {});
    }

    /**
     * Navega para uma página.
     * @param {*} url URL.
     * @param {*} searchParams Query params map.
     */
    function navigateTo(url, searchParams) {
        var storeParams = this.storagedObject ? this.storagedObject : {};

        storeParams[this.pageID] = {
            filtro: this.$scope.filter,
            colunas: this.$scope.colunas
        };

        this.ScopeService.store(storeParams);

        if (searchParams) {
            this.$location.path(url).search(searchParams);
        } else {
            this.$location.path(url);
        }
    }

    /**
     * Responde ao evento de fechamento do painel de seleção de colunas.
     */
    function onColumnsPanelClose(event) {
        if (event.hasChange) {
            this.updateData();
        }
    }

    /**
     * Atualiza a tabela.
     */
    function updateData() {
        var newFilterObj = angular.copy(this.$scope.filter);
        newFilterObj.colunas = this.$scope.colunas;
        this.$scope.filter = newFilterObj;
    }

    /**
     * Atualiza o filtro de acordo com o seu formulário.
     */
    function updateFilter(model) {
        this.data.content = [];

        model.colunas = this.buildColunasParamsMap(this.$scope.colunas);
        this.$scope.filter = model;
    }

    /**
     * Constroi o map de parametros correspondentes às colunas.
     */
    function buildColunasParamsMap() {
        var self = this;
        var map = {};

        Object.keys(this.$scope.colunas)
            .forEach(function(key) {
                map[key] = {
                    visible: self.$scope.colunas[key].visible
                };
            });

        return map;
    }

    /**
     * Mostra a modal de detalhamento do item
     */
    function showFormDetalhamento($aside, $scope) {
        angular.element('.tooltip').remove();
        
        this.settings.cmd = 'Visualizar Item';
        this.$scope = $scope;

        var formTplDetalhamento = $aside({
            scope: $scope,
            template: 'app/components/licitacoes-contratos/itens-licitados/itens-licitados-detalhamento.html',
            show: false,
            placement: 'left',
            backdrop: true,
            animation: 'am-slide-left'
        });

        formTplDetalhamento.$promise.then(function() { formTplDetalhamento.show(); } );
    };

    // Colunas da tabela
    var COLUMNS = {
        numeroItem: {nome: "Nº Item", visible: true, termo:"Número do item"},
        nomeItem: {nome: "Item", visible: true, termo:"Nome do item"},
        quantidadeItens: {nome: "Quantidade", visible: true, termo:"Quantidade de itens"},
        unidadeMedida: {nome: "Medida", visible: true, termo: "Unidade de Medida"},
        nomeFornecedor: {nome: "Fornecedor", visible: true, termo:"Nome do fornecedor"},        
        codigoFornecedor: {nome: "CNPJ/CPF", visible: true, termo:"Identificação do fornecedor"},
        ufFornecedor: {nome: "UF", visible: true, termo:"Unidade federativa do fornecedor"},
        totalProposto: {nome: "Valor Total", visible: true, currency: true, termo:"Valor total proposto"}
    };

})();
(function(){
    'use strict';

    angular.module('portal.pagina-inicial.ptVideoCarousel').directive('ptVideoCarousel', ptVideoCarousel);

    /** @ngInject */
    function ptVideoCarousel($timeout, PtVideoCarousel){
        return {
            restrict: 'E',
            scope: {
                poster: '@',
                playMode: '@'
            },
            templateUrl: 'app/components/pagina-inicial/pt-video-carousel/directives/ptVideoCarousel.directive.html',
            link: link
        };

        function link(scope, element, attrs){
            var videos = PtVideoCarousel.getVideos();
            scope.videosToPlay = angular.copy(videos);
            scope.videosFormat = PtVideoCarousel.getFormat();
            scope.id = attrs.id + '_video';
            scope.sourceId = attrs.id + '_source';
            scope.playedVideos = 0;
            scope.alreadyExecuted = false;
            scope.playNext = playNext;
            
            if(isRamdomMode()){
                PtVideoCarousel.shuffleVideos(scope.videosToPlay);
            }

            // Running inside timeout to wait DOM to be fully loaded
            $timeout(registerListeners);

            function registerListeners(){
                var video = getVideoAndSource().video;
                var videoElement = angular.element(video);

                video.addEventListener('timeupdate', fadeOutCurrentVideo, false);

                video.addEventListener('canplay', fadeInNextVideo, false);

                // Add playNext() as listener of 'onended' event
                video.addEventListener('ended', playNextVideo, false);
                
                function fadeOutCurrentVideo(){
                    if(!scope.alreadyExecuted){
                        var isLastSecond = this.currentTime >= this.duration - 1;
                        if(isLastSecond){
                            videoElement.parent().fadeOut(1000);
                            scope.alreadyExecuted = true;
                        }
                    }
                }

                function fadeInNextVideo(){
                    videoElement.parent().fadeIn(600);
                }

                function playNextVideo(){
                    scope.alreadyExecuted = false;
                    scope.playNext();
                }
            }

            function getVideoAndSource(){
                var video = element[0].querySelector('#' + scope.id);
                var videoSource = element[0].querySelector('#' + scope.sourceId);
                return {
                    video: video,
                    source: videoSource
                };
            }

            function playNext(){
                scope.playedVideos++;
                var allVideosWerePlayed = scope.playedVideos == (scope.videosToPlay.length - 1);
                if(allVideosWerePlayed){
                    scope.playedVideos = 0;
                    if(isRamdomMode()){
                        PtVideoCarousel.shuffleVideos(scope.videosToPlay);
                    }
                }
                changeVideo(scope.playedVideos);
            }

            function changeVideo(index){
                var video = getVideoAndSource();
                video.source.setAttribute('src', scope.videosToPlay[index]);
                video.video.load();
                video.video.play();
            }

            function isRamdomMode(){
                return scope.playMode === 'ramdom';
            }
        }
    }
})();
(function(){
    'use strict';

    angular.module('portal.pagina-inicial.ptVideoCarousel').factory('PtVideoCarousel', PtVideoCarousel);

    /** @ngInject */
    function PtVideoCarousel(){

        var videos = [];
        var videoFormat = 'video/webm';

        var INVALID_VIDEO_URL = 'Invalid video URL. Inform a string.';
        var INVALID_VIDEO_FORMAT = 'Invalid video format. Inform a string.';

        return{
            addVideo: addVideo,
            setVideosFormat: setVideosFormat,
            getVideos: getVideos,
            getFormat: getFormat,
            shuffleVideos: shuffleVideos
        };

        function addVideo(video){
            if(!video || typeof video !== 'string'){
                throw new Error(INVALID_VIDEO_URL);
            }
            videos.push(video);
        }

        function setVideosFormat(format){
            if(!format || typeof format !== 'string'){
                throw new Error(INVALID_VIDEO_FORMAT);
            }
            videoFormat = format;
        }

        function getVideos(){
            return videos;
        }

        function getFormat(){
            return videoFormat;
        }

        function shuffleVideos(videos){
            // Fisher-Yates shuffle method 
            var m = videos.length
            var temp, i;
            while (m) {
                i = Math.floor(Math.random() * m--);
                temp = videos[m];
                videos[m] = videos[i];
                videos[i] = temp;
            }
        }
    }
})();